/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://wx-static.keruyun.com/wx-ui/prod/static/dist-5da4c6ff22f4548b486e/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1144);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(440)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(268)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(43);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _toArray2 = __webpack_require__(175);

var _toArray3 = _interopRequireDefault(_toArray2);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _httpRequestHelper = __webpack_require__(84);

var _httpRequestHelper2 = _interopRequireDefault(_httpRequestHelper);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

var _pageHelper = __webpack_require__(123);

var _pageHelper2 = _interopRequireDefault(_pageHelper);

var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

var _const = __webpack_require__(14);

var _getEmojiReg = __webpack_require__(227);

var _getEmojiReg2 = _interopRequireDefault(_getEmojiReg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var padStart = __webpack_require__(145);
var config = __webpack_require__(13);

var _require = __webpack_require__(14),
    WmPageTpl = _require.WmPageTpl,
    BookOrderStatus = _require.BookOrderStatus,
    TradePayStatus = _require.TradePayStatus,
    BookingStatus = _require.BookingStatus,
    StoreType = _require.StoreType,
    SendStoreType = _require.SendStoreType;

exports.getFetchPostParam = function (params) {
  var requestOptions = (0, _assign2.default)({}, config.requestOptions, {
    method: 'POST',
    body: (0, _stringify2.default)(params)
  });
  return requestOptions;
};

var getUrlParams = exports.getUrlParams = function () {
  var r = window.location.search.replace(/\?/, '');
  if (!r) {
    return null;
  }

  var items = r.split('&');
  if (!items.length) {
    return null;
  }

  var params = {};
  items.forEach(function (item) {
    var paramItem = item.split('=');
    if (paramItem.length < 2) {
      return;
    }

    var _paramItem = (0, _toArray3.default)(paramItem),
        key = _paramItem[0],
        value = _paramItem.slice(1);

    params[key] = value.join('=');
  });

  return params;
};

// 获取url参数
var getUrlParam = exports.getUrlParam = function (param) {
  var params = getUrlParams() || {};

  return params[param] || null;
};

// 将多个url参数组成字符串
exports.formatObjToParamStr = function (paramObj) {
  if (!paramObj) {
    return '';
  }

  return (0, _keys2.default)(paramObj).map(function (key) {
    var value = paramObj[key];
    return value == null ? null : key + '=' + value;
  }).filter(function (item) {
    return item !== null;
  }).join('&');
};

// 设置cookie
exports.setCookie = function (name, value) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';

  var Days = 30;
  var exp = new Date();

  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);

  document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + ';path=' + path;
};

// 获取cookie
var getCookie = exports.getCookie = function (name) {
  var con = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));

  return con != null ? decodeURI(unescape(con[2], 'utf-8')) : null;
};

// 删除cookie
exports.delCookie = function (name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var nameT = getCookie(name);

  if (nameT != null) {
    document.cookie = name + '=' + nameT + ';expires=' + exp.toGMTString() + ';path=/';
  }
};

// 删除指定域下面的指定cookie
exports.delAppointDomainCookie = function (cookieObj) {
  var name = cookieObj.name,
      value = cookieObj.value,
      path = cookieObj.path,
      domain = cookieObj.domain;

  var exp = new Date();
  exp.setTime(exp.getTime() - 1);

  if (name != null) {
    document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + ';path=' + path + ';domain=' + domain;
  }
};

// 校验手机号
exports.phoneNumber = function (phone) {
  /* const rule = /(^1([358][0-9]{9})|^1([7][3678][0-9]{8})|^1([4][57][0-9]{8})|(^09[0-9]{8}))$/; */
  var rule = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[6]([8|6])\d{5}$/; // 大陆 + 港澳
  return rule.test(phone);
};

exports.replaceEmojiWith = function (value, str) {
  if (!value || typeof value !== 'string') {
    return value;
  }

  var rule = new RegExp(_getEmojiReg2.default, 'g');
  return value.replace(rule, str || '');
};

// 校验emoji表情
exports.checkEmojiWith = function (value) {
  if (!value || typeof value !== 'string') {
    return value;
  }
  var rule = new RegExp(_getEmojiReg2.default);
  return !rule.test(value);
};

// 去掉非法字符
exports.replaceInvalidSymbol = function (value, str) {
  if (!value || typeof value !== 'string') {
    return value;
  }
  return value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\ ]/g, str || '');
};

// 校验非法字符只包含中文、英文、数字
exports.checkInvalidSymbol = function (value) {
  if (!value || typeof value !== 'string') {
    return value;
  }
  var rule = /^[a-zA-Z0-9\u4E00-\u9FA5]+$/;
  return rule.test(value);
};

var isWechatMiniProgramBrowser = exports.isWechatMiniProgramBrowser = function () {
  var ua = navigator.userAgent.toLowerCase();
  return (/micromessenger/i.test(ua) && /miniProgram/i.test(ua)
  );
};

var getWeixinVersionInfo = exports.getWeixinVersionInfo = function () {
  var result = {
    weixin: false,
    version: 0
  };
  if (isWechatMiniProgramBrowser()) {
    return result;
  }
  var match = /micromessenger\/([\d.]+)/i.exec(navigator.userAgent);
  if (match) {
    result.weixin = true;
    result.version = match[1];
  }
  return result;
};

exports.getOSVersionInfo = function () {
  var result = {
    os: '',
    version: 0,
    versionString: ''
  };

  var userAgent = navigator.userAgent;
  var items = [{ descript: 'android', reg: /(android) (\d+(?:\.\d+)*)/i }, { descript: 'ios', reg: /(iPhone) OS (\d+(?:_\d+)*)/i }];

  items.forEach(function (item) {
    var reg = item.reg;

    var match = reg.exec(userAgent);
    if (!match) {
      return;
    }

    var _match = (0, _slicedToArray3.default)(match, 3),
        os = _match[1],
        versionSource = _match[2];

    var versionString = versionSource.replace(/\D/g, '.');

    (0, _assign2.default)(result, {
      os: os.toLowerCase(),
      versionString: versionString,
      version: parseFloat(versionString, 10)
    });
  });

  return result;
};

var isAlipayBrowser = exports.isAlipayBrowser = function () {
  var ua = navigator.userAgent.toLowerCase();
  return (/AliApp|AlipayDefined|AlipayClient/i.test(ua) && !/DingTalk/i.test(ua)
  );
};

var isDingTalkBrowser = exports.isDingTalkBrowser = function () {
  var ua = navigator.userAgent.toLowerCase();
  return (/DingTalk/i.test(ua)
  );
};
// 判断支付宝小程序
exports.isAlipayMiniProgramBrowser = function () {
  // return isAlipayBrowser();
  var ua = navigator.userAgent.toLowerCase();
  return isAlipayBrowser() && /miniProgram/i.test(ua);
};

exports.interValSetting = function (num, timerEnd) {
  var cnum = num;
  var timer = setInterval(function () {
    cnum = cnum - 1;
    if (cnum === 0) {
      timerEnd();
      clearInterval(timer);
    }
    sessionStorage.setItem('callBellTime', cnum > 0 ? cnum : '');
  }, 1000);
};

/* 日期 */
exports.dateUtility = {
  format: function format(date) {
    var formatStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd';

    if (!date) {
      return date;
    }

    if (typeof date === 'string') {
      date = this.parse(date);
    }
    if (!(date instanceof Date)) {
      return date;
    }

    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var result = formatStr.replace(/yyyy/, year.toString()).replace(/(M+)/, function (str, $1) {
      return padStart(month.toString(), $1.length, '0');
    }).replace(/(d+)/, function (str, $1) {
      return padStart(date.getDate().toString(), $1.length, '0');
    }).replace(/(H+)/, function (str, $1) {
      return padStart(hours.toString(), $1.length, '0');
    }).replace(/(m+)/, function (str, $1) {
      return padStart(minutes.toString(), $1.length, '0');
    }).replace(/(s+)/, function (str, $1) {
      return padStart(seconds.toString(), $1.length, '0');
    });
    return result;
  },
  parse: function parse(str) {
    if (!str || typeof str !== 'string') {
      return str;
    }

    var _str$split = str.split(/\s+/),
        _str$split2 = (0, _slicedToArray3.default)(_str$split, 2),
        datePart = _str$split2[0],
        _str$split2$ = _str$split2[1],
        timePart = _str$split2$ === undefined ? '00:00:00' : _str$split2$;

    var _datePart$split = datePart.split(/\D+/),
        _datePart$split2 = (0, _slicedToArray3.default)(_datePart$split, 3),
        year = _datePart$split2[0],
        _datePart$split2$ = _datePart$split2[1],
        month = _datePart$split2$ === undefined ? 1 : _datePart$split2$,
        _datePart$split2$2 = _datePart$split2[2],
        day = _datePart$split2$2 === undefined ? 1 : _datePart$split2$2;

    if (!year) {
      return null;
    }

    var _timePart$split = timePart.split(/\D+/),
        _timePart$split2 = (0, _slicedToArray3.default)(_timePart$split, 3),
        _timePart$split2$ = _timePart$split2[0],
        hours = _timePart$split2$ === undefined ? 0 : _timePart$split2$,
        _timePart$split2$2 = _timePart$split2[1],
        minutes = _timePart$split2$2 === undefined ? 0 : _timePart$split2$2,
        _timePart$split2$3 = _timePart$split2[2],
        seconds = _timePart$split2$3 === undefined ? 0 : _timePart$split2$3;

    var result = new Date(year, month - 1, day, hours, minutes, seconds);
    return isNaN(+result) ? null : result;
  }
};

var formatPrice = exports.formatPrice = function (price) {
  if (!price) {
    return 0;
  }

  if (price.toString().indexOf('.') < 0) {
    return price;
  }

  if (price.toString().split('.')[1].length > 2) {
    return parseFloat(Number(price).toFixed(2));
  }

  return price;
};

// 判断时间是否满一天
exports.renderTime = function (startTime, endTime) {
  if (!startTime || !endTime) {
    return '';
  }
  var formatStartTime = startTime.substring(0, 5);
  var formatEndTime = endTime.substring(0, 5);
  var period = Number(formatEndTime.substring(0, 2) * 60) + Number(formatEndTime.substring(3, 5)) - (Number(formatStartTime.substring(0, 2) * 60) + Number(formatStartTime.substring(3, 5))) + 1;

  if (period / 60 < 24) {
    return formatStartTime + '-' + formatEndTime + '\uFF0C';
  }

  return '';
};

// 优惠券可用day展示
exports.renderDay = function (week) {
  if (!week) return false;

  var regDay = /1{1,}/g; // 匹配一个1或多个1
  var periDay = '';
  var strDay = '';
  var dayIndex = '';
  var days = '';
  // 数据重组
  var str1 = week.substring(0, 1);
  var str2 = week.substr(1, 6);
  var weekFormat = str2 + str1;

  var formatDay = function formatDay(day) {
    switch (day) {
      case 1:
        return (0, _helper.formatMessage)(_global2.default.monday);
      case 2:
        return (0, _helper.formatMessage)(_global2.default.tuesday);
      case 3:
        return (0, _helper.formatMessage)(_global2.default.wednesday);
      case 4:
        return (0, _helper.formatMessage)(_global2.default.thursday);
      case 5:
        return (0, _helper.formatMessage)(_global2.default.friday);
      case 6:
        return (0, _helper.formatMessage)(_global2.default.saturday);
      case 7:
        return (0, _helper.formatMessage)(_global2.default.sunday);
      default:
        return '';
    }
  };

  if (weekFormat === '1111111') {
    return '';
  }

  while (periDay != null) {
    periDay = regDay.exec(weekFormat);
    if (periDay) {
      dayIndex = periDay.index;
      days = periDay[0];

      if (days.length > 1) {
        strDay += '' + formatDay(dayIndex + 1) + (0, _helper.formatMessage)(_global2.default.to) + formatDay(dayIndex + days.length) + '\uFF0C';
      } else {
        strDay += formatDay(dayIndex + 1) + '\uFF0C';
      }
    }
  }

  if (strDay.indexOf('周一到周五') !== -1) {
    return strDay.replace(/周一到周五/g, '工作日');
  }

  if (strDay === '' + (0, _helper.formatMessage)(_global2.default.saturday) + (0, _helper.formatMessage)(_global2.default.to) + (0, _helper.formatMessage)(_global2.default.sunday) + '\uFF0C') {
    return (0, _helper.formatMessage)(_global2.default.weekend) + '\uFF0C';
  }

  return strDay;
};

// 获取用户昵称
exports.getUserName = function (userInfo) {
  return userInfo.name;
};

// 获取用户头像
exports.getUserAvatar = function (userInfo) {
  return userInfo.iconUri;
};

// 保留两位小数的jsPriceCalc (折扣)
exports.jsPriceCalc = function (totalPrice, discount) {
  var value = Number((totalPrice * (1 - discount)).toFixed(3));

  return parseFloat(value.toFixed(2));
};

// 获取当前JS所包含的hash值
exports.getWebpackHashFromScriptUrl = function () {
  var file = (document.currentScript || {}).src || '';
  var substr = file.match(/dist-(\S*)\//);
  var length = 0;

  if (substr && substr[1]) {
    length = substr[1].length + file.indexOf(substr[1]);
    return file.substring(0, length);
  }

  return '';
};

// 验证手机号 新增加199 198 166类型
exports.getPhoneNumberValidate = function () {
  var phoneReg = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[6]([8|6])\d{5}$/; // 大陆 + 港澳
  return phoneReg;
};

/**
 * 拼接Url以及参数
 * @param {*} url
 * @param {*} param
 */
var combinationUrl = exports.combinationUrl = function (url, param) {
  if (!param) {
    return url;
  }

  var paramInit = (0, _keys2.default)(param).reduce(function (paramStr, paramItemName) {
    return paramStr + '&' + paramItemName + '=' + param[paramItemName];
  }, '');

  var paramAllStr = paramInit.substring(1);

  return url + '?' + paramAllStr;
};

/**
 * 存储cook以及过期时间
 */
var setCook = function setCook(obj) {
  var day = obj.day,
      name = obj.name,
      value = obj.value,
      type = obj.type;

  var exp = new Date();
  exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000); // 过期时间
  document.cookie = name + '=' + value + ',type=' + type + ';expires=' + exp.toGMTString() + ';path=/';
};

/**
 * 存储cookie不同的类型，针对堂食点餐页和外卖点餐页
 * @params {*} obj
 */
exports.setCookieTime = function (obj) {
  var couponType = obj.couponType,
      type = obj.type,
      shopId = obj.shopId;

  var name_ = '';
  if (couponType === 'dishWM') {
    if (type === 'TS') {
      name_ = 'shopId_WM-TS';
    } else if (type === 'WM') {
      name_ = 'shopId_WM';
    }
  } else if (couponType === 'dishTS') {
    name_ = 'shopId_TS';
  }

  setCook({
    day: 0.003,
    name: name_,
    value: shopId,
    type: type
  });
};
/* 链接百度地图导航地址
 * @param {当前位置坐标} curPosition
 * @param {目的地坐标} desPosition
 */
exports.getBaiduAPI = function (curPosition, desPosition) {
  if (!curPosition) {
    // 没有开启定位的情况
    return;
  }

  if (curPosition.latlng === 'undefined,undefined') {
    return;
  }

  var destination_ = null;

  if (desPosition.latlng !== ',' && desPosition.commercialAdress) {
    destination_ = 'latlng:' + desPosition.latlng + '|name:' + desPosition.commercialAdress;
  } else if (desPosition.latlng === ',' && desPosition.commercialAdress) {
    destination_ = desPosition.commercialAdress;
  }
  // 定位到当前位置的情况
  var baiduWeb = combinationUrl('http://api.map.baidu.com/direction', {
    origin: 'latlng:' + curPosition.latlng + '|name:\u5F53\u524D\u4F4D\u7F6E',
    destination: destination_,
    mode: 'driving',
    output: 'html',
    origin_region: curPosition.city,
    destination_region: desPosition.city,
    src: 'yourCompanyName|yourAppName'
  });
  location.href = baiduWeb + '?vt=map';
};

/**
 * getOrderStatus
 * @param { status }
 */
exports.getOrderStatus = function (status) {
  var orderStatus = ['已完成', '已确认', '待配送', '正在配送', '配送完成', '已清账', '配送中', '美团外卖', '饿了么', '海底捞App', '已取餐'];

  return orderStatus.includes(status);
};

/* 改变url 参数 */
exports.changeUrlParam = function (url, name, value) {
  var newUrl = '';
  var reg = new RegExp('(^|)' + name + '=([^&]*)(|$)');
  var tmp = name + '=' + value;
  if (url.match(reg) != null) {
    newUrl = url.replace(reg, tmp);
  } else {
    if (url.match('[?]')) {
      newUrl = url + '&' + tmp;
    } else {
      newUrl = url + '?' + tmp;
    }
  }
  return newUrl;
};

/* 广告组广告引入 */
exports.includeAdGroupAdsJS = function (callback) {
  var time = new Date().getTime();
  var scriptEle = document.createElement('script');
  scriptEle.type = 'text/javascript';
  scriptEle.src = config.env === 'production' ? 'https://' + config.getAdGroupAdsJsUrl + '?v=' + time : config.apiAdsgroup + '/static/adWebSdk.min.js?v=' + time;
  var x = document.getElementsByTagName('head')[0];
  x.appendChild(scriptEle);

  scriptEle.onload = function () {
    // 回调
    callback();
  };
};

/* 引入支付宝JSAPI */
exports.includeAlipayJSApi = function (callback) {
  var scriptEle = document.createElement('script');
  scriptEle.type = 'text/javascript';
  scriptEle.src = 'https://a.alipayobjects.com/g/h5-lib/alipayjsapi/3.0.2/alipayjsapi.min.js';
  var x = document.getElementsByTagName('head')[0];
  x.appendChild(scriptEle);

  scriptEle.onload = function () {
    // 回调
    callback();
  };
};

/**
 * 缓存参数设置
 */
exports.setParamToSession = function (param) {
  var sessionParam = getUrlParam(param);

  if (!sessionParam || sessionStorage.getItem(param)) {
    return;
  }

  sessionStorage.setItem(param, sessionParam);
};

/**
 * 获取指定缓存参数
 */
exports.getParamFromSession = function (param) {
  return sessionStorage.getItem(param);
};

/* 判断门店是否可用 */
exports.getCommericalInfo = function (setErrorMsg, callback) {
  var shopId = getUrlParam('shopId');
  return _fetchHelper2.default.get('' + config.getCommericalInfoAPI, { shopId: shopId }).then(function (res) {
    if (res) {
      callback({ enableOnlineCharge: res.enableOnlineCharge, enablePortalStore: res.enablePortalStore });
    }
  }).catch(function () {
    var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    setErrorMsg(err.msg || (0, _helper.formatMessage)(_errorMessage2.default.requestAPIFail));
    console.log(err);
  });
};

/** 计算保留两位小数
 * @param num 传入值
 * @description 使用toFixed(2) 无法四舍五入 75.975这个数字
 */
var fomatFloat = exports.fomatFloat = function (num) {
  if (isNaN(num)) return;
  if (Math.floor(num) === num) {
    return num;
  }

  var _num$toString$split = num.toString().split('.'),
      _num$toString$split2 = (0, _slicedToArray3.default)(_num$toString$split, 2),
      intNum = _num$toString$split2[0],
      dec = _num$toString$split2[1];

  if (dec.length <= 2) {
    return num;
  }

  var _dec$split = dec.split(''),
      _dec$split2 = (0, _slicedToArray3.default)(_dec$split, 3),
      fir = _dec$split2[0],
      sec = _dec$split2[1],
      thi = _dec$split2[2];

  if (thi > 4) {
    sec = Number(sec) + 1;
  }
  if (sec >= 10) {
    sec = 0;
    fir = Number(fir) + 1;
  }
  if (fir >= 10) {
    fir = 0;
    intNum = Number(intNum) + 1;
  }
  var val = intNum + '.' + fir + sec;
  return Number(val);
};

/* 计算储值+赠送金额 */
exports.getTotalRestorePrice = function (storeItem, ruleInfo) {
  var fullValue = storeItem.fullValue,
      storeType = storeItem.storeType,
      sendValue = storeItem.sendValue,
      rate = storeItem.rate;
  var isFullSend = ruleInfo.isFullSend,
      sendType = ruleInfo.sendType;

  var storePriceTotal = fullValue;

  switch (storeType) {
    case StoreType.SMALLSTORE:
      {
        // 小额储值
        // storePriceTotal = Math.ceil(orderPrice * (sendValue * 0.01 + 1));
        storePriceTotal = sendValue + fullValue;
        break;
      }
    default:
      {
        // 正常储值
        // 是否有优惠
        if (isFullSend === 0) {
          if (sendType === SendStoreType.SENDFIXVALUE) {
            // 赠送固定金额
            storePriceTotal = sendValue + fullValue;
          } else if (sendType === SendStoreType.SENDPERCENTVALUE) {
            // 赠送百分比
            storePriceTotal = fullValue + rate * fullValue / 100;
          }
        }
        break;
      }
  }

  // 四舍五入 保留两位小数
  storePriceTotal = Number(fomatFloat(storePriceTotal));
  return storePriceTotal;
};

/**
 * 根据nationTelCode选择手机号校验规则
 */
exports.getCurrentPhoneReg = function (nationTelCode) {
  var countryList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var currentReg = countryList.filter(function (item) {
    return item.areaCode === nationTelCode;
  })[0];
  return (0, _extends3.default)({}, currentReg, { areaCode: nationTelCode, isAllowSendCode: true });
};

/* 获取推荐菜品 */
exports.getRecommendDish = function (businessType, scene) {
  var shopId = getUrlParam('shopId');
  return _fetchHelper2.default.post(config.recommendDishAPI + '?shopId=' + shopId, { shopId: shopId, businessType: businessType, scene: scene }).then(function () {
    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var dishList = res.dishList || [];
    return dishList;
  }).catch(function () {
    return [];
  });
};

/**
 * 判定session取出来的数据，是否需要parse
 */
exports.sessionParseData = function (value) {
  if (!value) {
    return;
  }
  var parseValue = JSON.parse(value);

  if (!value) {
    return;
  }

  if ((typeof parseValue === 'undefined' ? 'undefined' : (0, _typeof3.default)(parseValue)) === 'object') {
    return parseValue;
  }

  return value;
};

/* 连接菜品和猜你喜欢 */
exports.concatGoodsDetailWithRecommendList = function (recommendDishList, dishesDataDuplicate, includeStatus) {
  var dishesDataDuplicateNew = [];
  var recommendDishListNew = Array.prototype.slice.call(recommendDishList);
  if (!includeStatus) {
    recommendDishList.forEach(function (item) {
      var findObj = dishesDataDuplicate.find(function (itemt) {
        return itemt.id === item.id;
      });
      if (findObj) {
        dishesDataDuplicateNew.push((0, _assign2.default)({}, item, { order: findObj.order }));
      } else {
        dishesDataDuplicateNew.push(item);
      }
    });
  } else {
    dishesDataDuplicate.forEach(function (item) {
      var findObj = recommendDishListNew.find(function (itemt) {
        return itemt.id === item.id;
      });
      if (findObj) {
        var pos = recommendDishListNew.indexOf(findObj);
        recommendDishListNew.splice(pos, 1);
      }
    });

    dishesDataDuplicateNew = dishesDataDuplicate.concat(recommendDishListNew);
  }
  return dishesDataDuplicateNew;
};

/**
 * getTransferConfig 获取零售跳转链接后缀配置
 */
var getTransferConfig = exports.getTransferConfig = function (shopId) {
  _httpRequestHelper2.default.get(config.getQryCommercialConfig, { shopId: shopId }).then(function (result) {
    if (!result || !result.data) {
      return;
    }

    if (result.data.showScan) {
      _httpRequestHelper2.default.goto(config.commodityfeLinkURL(shopId) + 'scanShopping');
      return;
    }

    _httpRequestHelper2.default.goto(config.commodityfeLinkURL(shopId));
  });
};

/**
 * getTransferURL 获取跳转链接
 */
exports.getTransferURL = function (param) {
  var shopId = param.shopId,
      rest = (0, _objectWithoutProperties3.default)(param, ['shopId']);

  var params = (0, _extends3.default)({ shopId: shopId, type: 'WM' }, rest);

  _httpRequestHelper2.default.get(config.getRetailAPI, { shopId: shopId }).then(function (res) {
    if (!res || !res.data) {
      return;
    }

    if (res.data.wmPageTpl === WmPageTpl.XLS) {
      getTransferConfig(shopId, params);
      return;
    }

    _httpRequestHelper2.default.goto(config.dishMenu4RealtakeoutURL, params);
  });
};

/* 限制输入input textarea */
exports.limitInputAndTextareaMethod = function (str) {
  var reg = /[^\u4e00-\u9fa5_a-zA-Z0-9^%&',，。;=?$\x22\s\t\n\r]+/g;
  // const regBlank = /\s+/g;
  if (reg.test(str)) {
    return str.replace(reg, '');
  }
  return str;
};

/* 临时方法： 修复cityList数据 */
exports.formatCitylist = function (cityList) {
  cityList.forEach(function (item) {
    if (item.name === '长沙') {
      item.pinyin = 'ChangSha';
    }
  });

  return cityList;
};

// 获取用户id
exports.getCustomerId = function () {
  var shopId = getUrlParam('shopId');
  var customerIdKey = 'customerId';
  var customerId = sessionStorage.getItem(customerIdKey);

  if (customerId) return customerId;

  _httpRequestHelper2.default.get(config.getServiceStatusNoTableAPI + '?shopId=' + shopId, {}).then(function (res) {
    if (res.code === '200' && res.data.memberVO) {
      sessionStorage.setItem(customerIdKey, res.data.memberVO.customerId);
    }
  });

  return null;
};

/**
 * 获取用户id new
 * 目前大数点埋点
 * 防止高频触发，加一个flag，标识一下。
 */
exports.getCustomerIdNew = function () {
  var shopId = getUrlParam('shopId');
  var customerIdKey = 'customerId';
  var customerId = sessionStorage.getItem(customerIdKey);
  var alreadyInvokeAndError = sessionStorage.getItem('alreadyInvokeCustomerIdAndError');
  if (!shopId) return _promise2.default.resolve(null);
  if (customerId) return _promise2.default.resolve(customerId);
  if (alreadyInvokeAndError === 'true') return _promise2.default.resolve(null);
  return _httpRequestHelper2.default.get(config.individualAPI + '?shopId=' + shopId, {}).then(function (res) {
    if (res && res.code === '200' && res.data && res.data.customerId) {
      sessionStorage.setItem(customerIdKey, res.data.customerId);
      return res.data.customerId;
    }
    sessionStorage.setItem('alreadyInvokeCustomerIdAndError', 'true');
    return null;
  });
};

// 阻止页面的双重滚动
exports.preventScrollIntoScroll = function (holder, noPreventScrollClassNameList) {
  var startY = 0;
  var noPreventMoveFunc = function noPreventMoveFunc(item) {
    event.stopPropagation(); // 阻止冒泡
    var shouldPrevent = true;
    if (item.scrollHeight > item.offsetHeight) {
      var endY = event.changedTouches[0].pageY;
      var distanceY = endY - startY;
      var scrollTop = item.scrollTop;
      var scrollHeight = item.scrollHeight;
      var offsetHeight = item.offsetHeight;
      if (scrollTop === 0 && distanceY < 0 || scrollTop + offsetHeight === item.scrollHeight && distanceY > 0 || scrollTop > 0 && scrollTop + offsetHeight < scrollHeight) {
        shouldPrevent = false;
      }
    }
    if (!shouldPrevent) {
      return;
    }
    event.preventDefault();
  };

  var noPreventStartFunc = function noPreventStartFunc() {
    startY = event.changedTouches[0].pageY;
  };

  var holderMoveFunc = function holderMoveFunc() {
    event.preventDefault();
  };

  var addnoPreventScrollClassNameListMethod = function addnoPreventScrollClassNameListMethod() {
    noPreventScrollClassNameList.forEach(function (item) {
      [].slice.call(document.querySelectorAll(holder + ' ' + item)).forEach(function (itemt, indext) {
        itemt.addEventListener('touchmove', function (event) {
          return noPreventMoveFunc(itemt);
        }, false);
        itemt.addEventListener('touchstart', noPreventStartFunc, false);
      });
    });
  };

  var cancelnoPreventScrollClassNameListMethod = function cancelnoPreventScrollClassNameListMethod() {
    noPreventScrollClassNameList.forEach(function (item) {
      [].slice.call(document.querySelectorAll(holder + ' ' + item)).forEach(function (itemt, indext) {
        itemt.removeEventListener('touchmove', function (event) {
          return noPreventMoveFunc(itemt);
        }, false);
        itemt.removeEventListener('touchstart', noPreventStartFunc, false);
      });
    });
  };

  var addMethod = function addMethod() {
    document.querySelector(holder).addEventListener('touchmove', holderMoveFunc, false);
    cancelnoPreventScrollClassNameListMethod();
    addnoPreventScrollClassNameListMethod();
  };

  var cancelMethod = function cancelMethod() {
    document.querySelector(holder).removeEventListener('touchmove', holderMoveFunc, false);
    cancelnoPreventScrollClassNameListMethod();
  };

  return { addMethod: addMethod, cancelMethod: cancelMethod };
};

// 去支付页面
exports.gotoPayUrl = function (params) {
  var brandId = sessionStorage.getItem('currentBrandId');
  var mid = getCookie('mid_' + brandId);
  if (mid) {
    params.mid = mid;
  }

  _pageHelper2.default.navigateTo(config.payDetailURL, params);
};

/**
 * validateForeignAreaCode 校验外国区号
 * @param {*} areaCode
 */
exports.validateForeignAreaCode = function (areaCode) {
  if (!areaCode) {
    return;
  }

  return String(areaCode) === '86' ? '' : '+' + areaCode + ' ';
};

/**
 * 整合bookStatus返回的方法
 */
exports.getTranslateBookStatus = function (bookStatus, orderTime, tradePayStatus) {
  var currentTime = new Date().getTime();
  var translateBookStatus = '';

  switch (bookStatus) {
    case BookOrderStatus.TIMEOUT:
      {
        if (orderTime < currentTime) {
          translateBookStatus = BookingStatus.BOOKNOTARRIVAL;
          break;
        }
        translateBookStatus = BookingStatus.BOOKSUCCESS;
        break;
      }
    case BookOrderStatus.REFUSE:
      {
        translateBookStatus = BookingStatus.BOOKREFUSED;
        break;
      }
    case BookOrderStatus.NOTDEAL:
      {
        if (tradePayStatus === TradePayStatus.NOTPAY) {
          translateBookStatus = BookingStatus.BOOKUNPAID;
          break;
        }

        translateBookStatus = BookingStatus.BOOKCONFIRMING;
        break;
      }
    case BookOrderStatus.USERNOTARRIVAL:
      {
        if (orderTime < currentTime) {
          translateBookStatus = BookingStatus.BOOKNOTARRIVAL;
          break;
        }

        translateBookStatus = BookingStatus.BOOKSUCCESS;
        break;
      }
    case BookOrderStatus.USERLEAVESHOP:
      {
        translateBookStatus = BookingStatus.BOOKSUCCESS;
        break;
      }
    case BookOrderStatus.CANCEL:
      {
        translateBookStatus = BookingStatus.BOOKCANCEL;
        break;
      }
    case BookOrderStatus.USERARRIVAL:
      {
        translateBookStatus = BookingStatus.BOOKARRIVED;
        break;
      }
    case BookOrderStatus.ASSURE:
      {
        translateBookStatus = BookingStatus.BOOKSURE;
        break;
      }

    default:
      break;
  }

  return translateBookStatus;
};

/* 临时修改：根据情况判断一些特殊的 none null undefined 类型的字符串 */
exports.filterNoneString = function (type, str) {
  if (!str) {
    return null;
  }
  var reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/;
  switch (type) {
    case 'url':
      {
        // url网址
        if (!reg.test(str)) {
          return null;
        }
        return str;
      }
    case 'word':
      {
        // 文字
        var strTolowerCase = str.toLowerCase();
        if (strTolowerCase === 'none' || strTolowerCase === 'undefined' || strTolowerCase === 'null') {
          return null;
        }
        return str;
      }
    default:
      return str;
  }
};

exports.getRunEnv = function () {
  var isWeixin = getWeixinVersionInfo().weixin;

  if (isWeixin) return _const.runEnv.WEIXIN;

  var isWeixinMini = isWechatMiniProgramBrowser();

  if (isWeixinMini) return _const.runEnv.WEIXINMINI;

  var isAlipay = isAlipayBrowser();

  if (isAlipay) return _const.runEnv.ALI;

  return _const.runEnv.GENERAL;
};

// 判断是否是正餐，包括先付和后付
exports.isFormalMeal = function (form) {
  return form === 0 || form === 2;
};

/**
 * 获取登录用户信息
 * 如果返回false 表示未登录
 */
exports.getLoginUserInfo = function () {
  return _fetchHelper2.default.get('' + config.individualAPI, null, { enableDefaultResponseResolve: false }).then(function () {
    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _res$data = res.data,
        data = _res$data === undefined ? {} : _res$data;
    var code = data.code,
        _data$msg = data.msg,
        msg = _data$msg === undefined ? '' : _data$msg,
        info = data.data;

    if (code === 'NOT_LOGIN') {
      return false;
    } else if (Number(code) !== 200) {
      throw msg || '系统异常';
    } else {
      return info;
    }
  }).catch(function (ex) {
    throw ex;
  });
};

// 计算菜品价格 - 订单详情页使用
exports.calcMarketPrice = function () {
  var mainDish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var totalPrice = 0;
  var groupDishNum = mainDish.num;
  var isGroupDish = mainDish.type === 1;
  var singleDish = function singleDish() {
    var dish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var num = arguments[1];
    var subDish = arguments[2];

    var marketPrice = 0;
    var marketPriceExtraIngredient = 0;
    var marketPriceExtraPropertyType = 0;
    marketPrice += dish.marketPrice;
    var isWeightMode = dish.saleType === 1; // 称重模式
    if (dish.propertyTypeList && dish.propertyTypeList.length !== 0) {
      dish.propertyTypeList.forEach(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments[1];

        if (item.properties && item.properties.length !== 0) {
          item.properties.forEach(function (itemt, indext) {
            if (itemt.reprice) {
              if (isGroupDish) {
                // marketPriceExtraPropertyType += itemt.reprice * num * groupDishNum;
                marketPriceExtraPropertyType += itemt.reprice * (isWeightMode ? 1 : num) * groupDishNum;
              } else {
                // marketPriceExtraPropertyType += itemt.reprice * num;
                marketPriceExtraPropertyType += itemt.reprice * (isWeightMode ? 1 : num);
              }
            }
          });
        }
      });
    }
    if (dish.dishIngredientInfos && dish.dishIngredientInfos.length !== 0) {
      dish.dishIngredientInfos.forEach(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments[1];

        if (item.reprice) {
          // 修改配料有可能需要传分数
          if (isGroupDish) {
            marketPriceExtraIngredient += item.reprice * (item.num || 1) * (dish.saleType !== 1 ? num * groupDishNum : 1);
          } else {
            marketPriceExtraIngredient += item.reprice * (item.num || 1) * (dish.saleType !== 1 ? num : 1);
          }
        }
      });
    }
    if (isGroupDish && subDish) {
      marketPrice = marketPrice * num * groupDishNum;
    } else {
      marketPrice = marketPrice * num;
    }
    return Math.max(marketPrice + marketPriceExtraIngredient + marketPriceExtraPropertyType, 0);
  };

  // 但菜品价格计算
  totalPrice += singleDish(mainDish, mainDish.num, false);
  // 多菜品价格计算
  if (mainDish.subDishItems && mainDish.subDishItems.length !== 0) {
    mainDish.subDishItems.forEach(function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments[1];

      if (item.subDishVO && item.subDishVO.length !== 0) {
        item.subDishVO.forEach(function () {
          var itemt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var indext = arguments[1];

          totalPrice += singleDish(itemt, itemt.num, true);
        });
      }
    });
  }

  return formatPrice(totalPrice);
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(58)('wks');
var uid = __webpack_require__(45);
var Symbol = __webpack_require__(4).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(99);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(226);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(1);
var ctx = __webpack_require__(32);
var hide = __webpack_require__(23);
var has = __webpack_require__(24);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(138), __esModule: true };

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = vendor;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var apiBase = void 0;
var apiFintech = void 0;
var requestOptions = void 0;
var syncOrderDinnerSocketUrl = void 0;
var sockJsUncheckUrl = void 0;
var apiAdsgroup = void 0;
var apiStatistics = void 0;
var loyaltyHost = void 0;
var adHost = void 0;
function getHostNameWithProtocol(hostname) {
  if ((typeof location === 'undefined' ? 'undefined' : (0, _typeof3.default)(location)) === 'object') {
    return location.protocol + '//' + hostname;
  }

  return 'http://' + hostname;
}

switch ("production") {
  case 'production':
    apiBase = getHostNameWithProtocol("weixin.keruyun.com");
    apiStatistics = getHostNameWithProtocol("pbc.keruyun.com");
    apiFintech = "fintech.keruyun.com/eip";
    syncOrderDinnerSocketUrl = "wxws.keruyun.com";
    sockJsUncheckUrl = "pws.keruyun.com";
    apiAdsgroup = "cdn-ad-static.keruyun.com";
    loyaltyHost = getHostNameWithProtocol("loyalty.keruyun.com");
    adHost = getHostNameWithProtocol("ad.keruyun.com/ad-srs");

    requestOptions = {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json'
      }
    };
    break;
  default:
    apiBase = getHostNameWithProtocol(Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).DEV_HOST) + ':3001'; // 本地环境
    apiStatistics = getHostNameWithProtocol(Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).DEV_HOST) + ':3001'; // 本地环境
    adHost = 'https://citestad.shishike.com/ad-srs';
    // 仅在本地前后端联调使用
    if (Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).API_HOST) {
      apiBase = Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).API_HOST;
    }

    apiFintech = 'https://test-fintech.shishike.com/eip/'; // 对接Fintech的环境
    syncOrderDinnerSocketUrl = 'testwxws.shishike.com';
    sockJsUncheckUrl = 'citestpws.shishike.com';
    apiAdsgroup = 'http://172.16.30.3:8087';
    loyaltyHost = 'loyalty.keruyun.com';

    requestOptions = {
      method: 'GET',
      mod: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json'
      }
    };
}

module.exports = {
  // API
  queryTaxRateByGoodsApi: apiBase + '/taxRate/queryTaxRateByGoods.json', // 通过菜品查询消费税税率
  getIndustryApi: apiBase + '/brand/industry.json', // 获取业态信息
  deliveryOrderAPI: apiBase + '/order/deliveryOrderList.json',
  takeawayDishListAPI: apiBase + '/takeaway/dishAll.json',
  getGoodsDetailAPI: apiBase + '/orderall/goodsDetail.json',
  takeawayShopInfoAPI: apiBase + '/takeaway/orderPageInfo.json',
  orderallDishListAPI: apiBase + '/orderall/dishAll.json',
  orderAllYDListAPI: apiBase + '/prepare/dishAll.json',
  orderallShopInfoAPI: apiBase + '/orderall/orderPageInfo.json',
  orderDineInAPi: apiBase + '/orderall/dishBox.json',
  orderDineInTableListAPI: apiBase + '/orderall/tableInfoList.json',
  orderTakeAwayAPi: apiBase + '/takeaway/dishBox.json',
  orderCouponsAPI: apiBase + '/coupon/getCanUseCoupons.json',
  orderNewCouponsAPI: apiBase + '/coupon/getNewCanUseCoupons.json',
  orderWeixinGiftCardsAPI: apiBase + '/coupon/getWeixinGiftCards.json',
  orderDiscountInfoAPI: apiBase + '/shop/discountInfo.json',
  orderDinnerStatementAPI: apiBase + '/orderall/settlement4Dinner.json',
  orderDinnerStatementZeroAPI: apiBase + '/pay/pay4Zero.json',
  submitTSOrderAPI: apiBase + '/orderall/subOrder.json',
  submitWMOrderAPI: apiBase + '/takeaway/subOrder.json',
  userAddressAPI: apiBase + '/user/addressList.json',
  submitDinnerOrderAPI: apiBase + '/orderall/tradeBilling.json',
  orderedDishBenefitAPI: apiBase + '/marketplan/dishPrivilegeList.json', // 单商品优惠
  multiDishBenefitAPI: apiBase + '/marketplan/multiDishPrivilegeInfo.json', // 多商品优惠
  orderAddOnAPI: apiBase + '/marketplan/addOnOderPlanInfo.json', // 凑单商品列表
  orderCouponsCountAPI: apiBase + '/coupon/getCanUseCouponCnt.json', // 个人中心优惠券总计数量
  orderPurchaseBenefitAPI: apiBase + '/marketplan/markUpPlanInfo.json', // 加价-满额换购接口
  discountCardListApi: apiBase + '/rightsCard/queryCanUseCardList.json', // 折扣卡列表
  getRightsCardsListApi: apiBase + '/rightsCard/getRightsCardsList.json', // 商城折扣卡列表
  getLimitedPrivilegeApi: apiBase + '/marketplan/limitedPrivilege.json', // 茶百道限免优惠
  getOrderMemo: apiBase + '/order/orderMemoConfig.json', // 订单备注列表
  orderAgain: apiBase + '/takeaway/orderagain.json', // 再来一单

  individualAPI: apiBase + '/user/individual.json', // 获取用户基本信息(我的页面)
  individualviewAPI: apiBase + '/user/individualView.json', // 获取用户基本信息(设置页面)
  freePaymentCodeAPI: apiBase + '/member/noPwdPayCode.json', // 免密支付二维码
  logoutAPI: apiBase + '/user/logout.json', // 注销用户页面
  individualupdateAPI: apiBase + '/user/individualUpdate.json', // 设置页面 更新信息
  getUserAddressListAPI: apiBase + '/user/getAddressList.json',
  getAllAddressListAPI: apiBase + '/user/addressList.json',
  customerAddressAPI: apiBase + '/user/address.json',
  saveAddressAPI: apiBase + '/user/saveAddress.json',
  deleteAddressAPI: apiBase + '/user/delAddress.json',
  getOrderAddressInfoAPI: apiBase + '/user/getAddressInfo.json',
  submitTSOrderCartAPI: apiBase + '/orderall/subOrderDinner.json',
  placeCheckOrderAPI: apiBase + '/place/placeCheckOrder.json',
  mustOrderDishListAPI: apiBase + '/orderall/queryMustDishList.json',
  getIParkSecretAPI: apiBase + '/orderall/thirdPlatform/getIParkSecret.json', // 获取美食岛秘钥

  userLoginAPI: apiBase + '/user/login.json',
  userLoginWXURL: apiBase + '/user/login4WX',
  userLoginAlipayURL: apiBase + '/user/login4Alipay',
  aliapiAuthURL: apiBase + '/aliapi/authByAlipay',
  getMerchantsBankInfoAPI: apiBase + '/blank/getInfo.json',
  getUserLoginSupportAPI: apiBase + '/user/supportTypes.json',
  getServiceStatusHaveTableAPI: apiBase + '/orderall/serviceStatusHaveTable.json', // 获取基本信息(带桌台)
  getServiceStatusNoTableAPI: apiBase + '/orderall/serviceStatusNoTable.json', // 获取基本信息(不带桌台)
  getIsShowButtonAPI: apiBase + '/orderall/isShowButton.json', // 按钮是否显示
  getTableInfoAPI: apiBase + '/orderall/tableInfo.json', // 获取tableInfo
  getOtherTableIdAPI: apiBase + '/orderall/getTableId.json', // 获取用户是否在其他桌台下单
  getOrderTableTypeAPI: apiBase + '/orderall/orderTableType.json', // 获取tableInfo
  callServiceAPI: apiBase + '/orderall/callService.json', // 获取tableId
  memberIndexAPI: apiBase + '/member/index.json', // 获取会员基本信息
  grownLevelxAPI: apiBase + '/member/customerLevel.json', // 会员页面
  getCouponListAPI: apiBase + '/coupon/getCouponList.json', // 优惠券列表
  getBrandCouponNum: apiBase + '/coupon/brandCouponNum.json', // 优惠券使用张数
  // 跳转URL
  dishMenu4DinnerURL: apiBase + '/orderall/selectDish', // 堂食点餐页，后端会进行重定向，决定正餐、快餐跳转
  dishMenu4takeoutURL: apiBase + '/takeaway/getWMPageTpl', // 外卖和零售点餐页中转页面
  dishMenu4RealtakeoutURL: apiBase + '/takeaway/selectDish', // 真实的外卖点餐页

  bookingURL: apiBase + '/booking/book', // YD
  queueInfoURL: apiBase + '/queue/info', // PD
  paySuccessURL: apiBase + '/shop/paySuccess', // 支付成功页面
  // 点金计划
  goldenPlan: apiBase + '/shop/goldenplan', // 点金计划页
  blankJump: apiBase + '/shop/blankjump', // 空白跳转页
  goldenplanhint: apiBase + '/shop/goldenplanhint', // 错误提示页
  // 门店列表页
  shopTSListURL: apiBase + '/shop/list',
  shopWMListURL: apiBase + '/shop/wmList',
  cooksListAPI: apiBase + '/cook/cookList.json',

  editUserAddressURL: apiBase + '/user/address',
  editBakeAddressURL: apiBase + '/retail/address-edit',

  // evaluationURL: 'https://gldpartner.keruyun.com/gateway-fronend/mobile.html#/commentH5', // 评价页面
  evaluationURL: 'https://partner.keruyun.com/gateway-fronend/mobile.html#/commentH5', // 评价页面

  brandIndexURL: apiBase + '/brand/index', // 品牌首页
  shopDetailURL: apiBase + '/shop/detail', // 门店首页
  bakeDishMenuURL: apiBase + '/retail/', // 烘焙点餐页
  mineIndexURL: apiBase + '/integration/personal-center', // 个人中心页面
  mineCardMallURL: apiBase + '/integration/card-mall', // 个人中心 - 折扣卡商城页面
  mineSettingURL: apiBase + '/user/individualView', // 设置页面
  bindMobileURL: apiBase + '/user/bindMobile', // 绑定手机页面
  bindWXURL: apiBase + '/user/bindOpenid', // 绑定微信页面
  bindAlipayURL: apiBase + '/user/bindAlipay', // 绑定支付宝页面
  registerMemberURL: apiBase + '/member/register', // 注册会员
  logAddressURL: apiBase + '/user/notLogin', // 登录页面
  integralURL: apiBase + '/member/integral', // 我的积分
  valueCardURL: apiBase + '/member/valueCard', // 我的余额
  memberIndexURL: apiBase + '/member/index', // 会员页面
  grownLevelxURL: apiBase + '/member/grownLevel', // 会员页面
  growthValueURL: apiBase + '/member/growthValue', // 成长明细页面
  rechargeURL: apiBase + '/shop/recharge', // 充值页面
  orderallListURL: apiBase + '/order/orderallList', // 订单列表
  getCouponListURL: apiBase + '/coupon/getCouponList', // 优惠券
  addressListURL: apiBase + '/user/addressList', // 地址管理
  modifyPwdURL: apiBase + '/member/modifyPwd', // 修改密码
  tradeDetailUncheckURL: apiBase + '/order/tradeDetailUncheck', // 堂食正餐订单详情页 结算前
  dishCart4DinnerURL: apiBase + '/orderall/dishCart4Dinner', // 购物车详情页
  dishCart4DinnerPayFirst: apiBase + '/orderall/dishCart4DinnerPayFirst', // 购物车详情页
  settlement4DinnerURL: apiBase + '/orderall/settlement4Dinner', // 正餐结算页面
  takeout4DinnerURL: apiBase + '/takeaway/dishBox', // 外卖结算页面
  orderall4DinnerURL: apiBase + '/orderall/dishBox', // 快餐结算页面
  takeOutDetailURL: apiBase + '/order/takeOutDetail', // 外卖订单详情页面
  orderallDetailURL: apiBase + '/order/orderallDetail', // 堂食订单详情页面
  takeOutRefundDetailURL: apiBase + '/order/takeOutRefundDetail', // 部分退详情页面
  dishMenu4DinnerChoosePeopleURL: apiBase + '/orderall/dishMenu4DinnerChoosePeople', // 堂食正餐点餐选择人数
  changeMobileSucURL: apiBase + '/user/changeMobileSuc', // 修改绑定手机成功页
  changeMobileURL: apiBase + '/user/changeMobileInfo', // 修改绑定手机页
  valueCardDetailURL: apiBase + '/member/valueCardDetail',
  cooksListURL: apiBase + '/cook/cookList',
  cookPersonalIndexURL: apiBase + '/cook/cookInfo',
  validBindMobileURL: apiBase + '/user/validBindMobile', // 绑定手机验证码校验：是否会员/是否和其他微信绑定
  bookingDetailURL: apiBase + '/booking/bookingDetail', // 预定详情
  bookCheckOrderURL: apiBase + '/prepare/dishBoxBooking', // 预定下单页面
  isQueueURL: apiBase + '/queue/queueCheck.json', // 是否已排队
  queueDetailURL: apiBase + '/queue/success', // 排队详情
  queueCheckOrderURL: apiBase + '/prepare/dishBoxQueue', // 排队下单页面
  goodsDetailURL: apiBase + '/orderall/goodsDetail', // 商品详情页面
  exceptionLinkURL: apiBase + '/orderall/tableError', // 异常页面(链接无效)
  commodityfeLinkURL: function commodityfeLinkURL(shopId) {
    return apiBase + '/commodityfe/?shopId=' + shopId + '&/#/';
  }, // 新零售页面
  payDetailURL: apiBase + '/shop/payDetail',
  takeoutTrackURL: apiBase + '/order/deliveryOrderList',
  prepaidCodeUrl: apiBase + '/integration/prepaid-code',

  addPrepaidCodesAPI: apiBase + '/prepay/addPrepayCodes.json',
  couponReceivedInfoAPI: apiBase + '/coupon/query/presentCouponNote.json',
  queryMarketShareStatusAPI: apiBase + '/coupon/queryMarketShareStatus.json',

  getQryCommercialConfig: apiBase + '/commodity/qryCommercialConfig', // 零售配置导航接口
  getQueuePredictWaitTimeAPI: apiBase + '/queue/predictWaitTime.json', // 排队等待时间
  getDefaultSendArea: apiBase + '/user/getDefaultSendArea.json',
  queryDeliveryTime: apiBase + '/takeaway/queryDeliveryTime.json', // 点单页显示配送时间
  getOrderInLineAPI: apiBase + '/queue/info.json',
  submitOrderInLineAPI: apiBase + '/queue/add.json',
  checkQueueAPI: apiBase + '/queue/queueCheck.json',
  placeOrderAPI: apiBase + '/booking/book.json',
  payPlaceOrderAPI: apiBase + '/booking/getBookingDeposit.json',
  getCheckTableAvaliable: apiBase + '/booking/getTableByAreaAndNum.json',
  getPlaceOrderTablesAPI: apiBase + '/booking/getTables.json',
  submitPlaceOrderAPI: apiBase + '/booking/addBooking.json',
  confirmBookingAPI: apiBase + '/booking/confirmBooking.json', // 确认预定
  cancelBookingAPI: apiBase + '/booking/cancelBooking.json', // 取消预定

  checkMobileBindedAPI: apiBase + '/user/checkMobileBinded.json', // 发送验证码之前 验证手机号是否已经绑定
  checkMobileOccupyAPI: apiBase + '/user/checkMobileOccupy.json', // 发送验证码之前 验证手机号是否已经绑定
  sendCodeAPI: apiBase + '/user/sendCode.json', // 发送验证码
  bindPhoneAPI: apiBase + '/user/bindMobile.json', // 绑定手机
  changeMobileAPI: apiBase + '/user/changeMobile.json', // 修改已经绑定的手机号
  wxOauthAPI: apiBase + '/openapi/weixinOauthUrl', // 获取微信 openid
  bindWXAPI: apiBase + '/user/bindOpenid.json', // 绑定微信
  bindAlipayAPI: apiBase + '/user/bindAlipay.json', // 绑定支付宝
  getWXInfoAPI: apiBase + '/user/weixinUserInfo.json', // 获取微信信息
  getAlipayInfoAPI: apiBase + '/user/alipayUserInfo.json', // 获取支付宝信息

  getCurrentCountryList: apiBase + '/brand/getCurrencyList.json',

  registerInfoAPI: apiBase + '/member/register.json', // 获取用户信息
  registerAPI: apiBase + '/member/addMember.json', // 申请会员
  checkCodeAvaliableAPI: apiBase + '/user/validMobile.json',
  tradeDetailUncheckAPI: apiBase + '/order/tradeDetailUncheck.json', // 订单详情（结算前）
  tradeDetailUncheckPayFirstAPI: apiBase + '/order/tradeDetailDinnerPayFirst.json', // 订单详情（结算前，正餐先付）
  getWXAuthInfoAPI: apiBase + '/openapi/jsApiTicket.json',
  getWXCardAPI: apiBase + '/weixinapi/wxCardTicket.json', // 领取微信卡券
  getTableIdFromQRCodeAPI: apiBase + '/orderall/tableExt.json',
  getMainOrderAPI: apiBase + '/orderall/getMainOrder.json',
  validBindMobileAPI: apiBase + '/user/validBindMobile.json', // 绑定手机验证码校验：是否会员/是否和其他微信绑定
  validBindMobileActiveAPI: apiBase + '/user/validBindMobileActive.json', // 绑定手机验证码校验(会员卡激活)：是否会员/是否和其他微信绑定
  verifyMemberCodeAPI: apiBase + '/member/verifyMemberCode.json', // 验证核销会员码
  validateMemberCodeAPI: apiBase + '/member/validateMemberCode.json', // 验证会员码
  aliPayEnvelopeAPI: apiBase + '/aliapi/alipayMarketing.json', // 手机领取支付宝红包
  getInvoiceStatus: apiBase + '/order/invoiceStatus.json', // 开票状态接口
  getInvoiceUrl: apiBase + '/order/invoiceUrl.json', // 发票路径

  getBalanceInfoAPI: apiBase + '/member/valueCard.json', // 会员卡余额信息
  getBalanceShopDetailListAPI: apiBase + '/member/valueCardList.json', // 会员卡余额信息详情
  getCommercialGroupAPI: apiBase + '/user/getCommercialGroup.json',
  getIntegralDetailAPI: apiBase + '/member/integralDetail.json', //
  getGrownDetailAPI: apiBase + '/member/grownDetail.json', //
  getRechargeInfoAPI: apiBase + '/shop/recharge.json', // 会员卡充值信息
  addRechargeAPI: apiBase + '/member/addRecharge.json', // 会员卡充值
  storePayAPI: apiBase + '/member/storePay.json', // 储值并支付
  rechargeShopListAPI: apiBase + '/shop/allShopList.json', // 储值选择门店
  indexAPI: apiBase + '/brand/index.json',
  brandShopList: apiBase + '/shop/brandShopList.json', // 品牌下的门店列表
  modifyPwd: apiBase + '/member/modifyPwd.json', // 修改密码
  resetPassword: apiBase + '/member/resetPassword.json', // 重置密码
  getResetPasswordUserInfoAPI: apiBase + '/member/resetPwd.json', // 取密码重置用户信息

  cancelQueueAPI: apiBase + '/queue/cancel.json', // 取消排队
  supportBusinessTypesAPI: apiBase + '/order/supportBusinessTypes.json', // 订单列表
  orderListAPI: apiBase + '/order/orderallList.json', // 订单列表
  orderListMoreAPI: apiBase + '/order/historyOrderallList.json', // 十五天前的订单列表
  takeOutListAPI: apiBase + '/order/takeOutList.json', // 外卖列表
  takeOutRefundDetailAPI: apiBase + '/order/takeOutRefundDetail.json', // 部分退详情
  takeOutListMoreAPI: apiBase + '/order/historyTakeOutList.json', // 十五天前的外卖列表
  bookListAPI: apiBase + '/order/bookingList.json', // 预订列表
  queueListAPI: apiBase + '/queue/queueList.json', // 排队列表
  bakeListAPI: apiBase + '/bakingOrder/bakingOrderAllList.json', // 烘焙订单列表
  getDinnerDetailAPI: apiBase + '/order/orderallDetail.json', // 堂食结算后订单详情
  getHistoryDinnerDetailAPI: apiBase + '/order/historyOrderallDetail.json', // 历史订单堂食结算后订单详情
  getDishMarketInfosAPI: apiBase + '/orderall/dishMarketInfos.json',
  saveMarkRecordAPI: apiBase + '/order/saveMarkRecord.json', // 评分
  getRemindOrderAPI: apiBase + '/takeaway/remindOrder.json', // 催单次数

  getBookDetailAPI: apiBase + '/booking/bookingDetail.json', // 预订详情
  getQueueDetailAPI: apiBase + '/queue/success.json', // 排队详情
  bookingMyPreOrderAPI: apiBase + '/prepare/bookingMyPreOrder.json', // 预定我的菜单
  queueMyPreOrderAPI: apiBase + '/prepare/myPreOrder.json', // 排队我的菜单
  bookingSubOrderAPI: apiBase + '/prepare/bookingSubOrder.json',
  queueSubOrderAPI: apiBase + '/prepare/subOrder.json',

  getOrderPotTime: apiBase + '/order/getOrderPotTime.json', // 外卖 - 预约收锅时间获取
  setOrderPotTime: apiBase + '/order/orderPot.json', // 外卖 - 预约收锅时间设置
  getPotTimeList: apiBase + '/takeaway/genePotTimeList.json',
  getTakeoutDetailAPI: apiBase + '/order/takeOutDetail.json', // 外卖结算后订单详情
  getHistoryTakeoutDetailAPI: apiBase + '/order/historyTakeOutDetail.json', // 历史订单结算后订单详情
  getCurrIntegralRuleAPI: apiBase + '/member/currIntegralRule.json', // 获取当前积分信息
  getCurrGrownRuleAPI: apiBase + '/member/currGrownRule.json', // 获取当前成长值信息

  getPosLoginInfoAPI: apiBase + '/user/loginPosScanCode.json', // pos扫码信息
  loginWxByPosAPI: apiBase + '/user/loginWxByPos.json', // pos扫码登录
  getPayDetailAPI: apiBase + '/shop/payDetail.json',
  getEbuAPI: apiBase + '/pay/elmPay.json', // ebu 支付
  baiduPayAPI: apiBase + '/pay/baiduPay.json',
  weixinPayAPI: apiBase + '/pay/weixinPay.json',
  ccbPayAPI: apiBase + '/pay/ccbPay.json',
  balancePayAPI: apiBase + '/pay/valueCardPay.json',
  balancePayOmitPasswordAPI: apiBase + '/pay/valueCardPayOmitPassword.json',
  balancePayBrandAPI: apiBase + '/pay/qrcodeValueCardPay.json',
  balancePayBrandOmitPasswordAPI: apiBase + '/pay/qrcodeValueCardOmitPasswordPay.json',
  wxPayAPI: apiBase + '/pay/wxPay.json',
  aliPayAPI: apiBase + '/pay/aliPay.json',
  alipayJsAPI: apiBase + '/pay/alipayJsapi.json',
  uePayApi: apiBase + '/pay/uePay.json',
  bocPayApi: apiBase + '/pay/bocPay.json',
  touchngoPayApi: apiBase + '/pay/touchngoPay.json',
  mPayApi: apiBase + '/pay/mPay.json',

  cancelOrderAPI: apiBase + '/order/tradeCancel.json', // 取消订单
  shopListTSAPI: apiBase + '/shop/list.json', // 堂食门店列表 全部门店
  shopListTSNearAPI: apiBase + '/shop/nearByShopList.json', // 堂食门店列表 附近门店
  nearShopListAPI: apiBase + '/shop/nearShopList.json',
  takeawayAllShopListAPI: apiBase + '/shop/takeawayAllShopList.json',
  takeawayInfoAPI: apiBase + '/shop/takeawayInfo.json', // 外卖信息
  fetchCouponAPI: apiBase + '/coupon/fetchCoupon.json', // 点餐页获取优惠券
  sendCouponsAPI: apiBase + '/coupon/sendCoupon.json', // 点餐页获取优惠券新接口
  thirdPlatformLogin: apiBase + '/user/thirdPlatformLogin.json', // 第三方登录（目前美食岛）
  getPaymentIdByTradeId: apiBase + '/pay/iParkPay.json', // 通过orderId获取paymentId

  fakeSocketDataAPI: apiBase + '/fakeSocketData.json',

  shareCouponPage: apiBase + '/coupon/queryMarketSharePage',
  getShareCouponPage: apiBase + '/coupon/getShareCouponPage',
  queryMarketShareAPI: apiBase + '/coupon/queryMarketShare.json',
  shareCouponEventAPI: apiBase + '/coupon/shareEvent.json',
  shareCreateCoupInstanceAPI: apiBase + '/coupon/shareCreateCoupInstance.json',
  dishMenu4DinnerChoosePeopleAPI: apiBase + '/orderall/dishMenu4DinnerChoosePeople.json', // 选择人数
  shareRandomPriviledgeAPI: apiBase + '/marketplan/shareRandomPriviledge.json',
  shareSuccessAPI: apiBase + '/orderall/shareSuccess.json',
  switchUrlBeforeGetServiceStatusAPI: apiBase + '/shop/getRealUrl.json',

  getAdGroupAdsJsUrl: apiAdsgroup + '/ad-js-static/adWebSdk.min.js',

  rewardIndexAPI: apiBase + '/reward/index.json',
  cookIndexAPI: apiBase + '/cook/cookInfo.json',
  tableWayAPI: apiBase + '/shop/tableWay.json',
  cityListAPI: apiBase + '/shop/cityList.json',
  orderFromCurTabeAPI: apiBase + '/order/orderFromCurTable.json',
  activeOrderAPI: apiBase + '/order/activeOrder.json',
  serviceCardAPI: apiBase + '/shop/serviceCard.json',
  brandInfoAPI: apiBase + '/brand/type.json',
  becomeNoPasswordAPI: apiBase + '/pay/becomeNoPassword.json',
  recommendDishAPI: apiBase + '/orderall/recommendDishList.json',
  getRetailAPI: apiBase + '/takeaway/getWMPageTpl.json',
  updateBookingLockAPI: apiBase + '/booking/updateBookingLock.json',

  getProfessionalCommercialAPI: apiBase + '/brand/professionalCommercial.json',
  getCommericalInfoAPI: apiBase + '/shop/getCommericalInfo.json',
  getShopMinConsumeConfAPI: apiBase + '/shop/getShopMinConsumeConf.json',
  requestOptions: requestOptions,
  syncOrderDinnerSocketUrl: syncOrderDinnerSocketUrl,
  sockJsUncheckUrl: sockJsUncheckUrl,

  apiBase: apiBase,
  apiFintech: apiFintech,
  apiAdsgroup: apiAdsgroup,
  env: "production",

  recommendDishStatisticsAPI: apiStatistics + '/behavior/recommendDishScanRecord', // 推荐菜品埋点统计
  getShopBaseConfAPI: apiBase + '/shop/getShopBaseConf.json',
  integralMallURL: loyaltyHost + '/loyalty-mobile/#/', // 积分商城界面
  integralExchangeDetailUrl: loyaltyHost + '/loyalty-mobile/#/', // 积分商城兑换详情页面
  discountCardPurchaseDetail: 'exchangeDetail', // 折扣卡购买成功后跳转页面

  dataRecoveryURL: apiBase + '/integration/data-recovery', // 茶百道数据修复
  loginInCCBAppAPI: apiBase + '/user/ccb/login.json', // 建行无感登录
  decodeCipherTextForCCB: apiBase + '/member/ccb/decrypt.json', // 建行解密

  getMobilesByEuid: apiBase + '/order/getMobilesByEuid.json', // 饿了么通过euid获取手机号
  elmLogin: apiBase + '/user/elmLogin.json', // 饿了么静默登录

  shopHealthCodeInfoAPI: apiBase + '/shop/getShopHealthCodeInfo.json',

  getPayForGiftCoupon: apiBase + '/coupon/listPayGiftCoupon.json', // 获取支付有礼数据
  getNowPayForGiftCoupon: apiBase + '/coupon/payGiftReceiveCoupon.json', // 领取支付有礼券接口

  // golden-plan
  getAdTypeAPI: adHost + '/adgold/plan/material', // 获取物料以及展示形势
  postAdInfo: adHost + '/adgold/plan/statistic', // 上报相关信息
  postAdError: adHost + '/adgold/plan/statistic/error',

  // 外卖点餐页
  takeawaySelectDish: apiBase + '/takeaway/selectDish',

  getOrderComment: apiBase + '/order/getOrderComment.json', // 查询订单是否已评价

  mergeSwitchAPI: apiBase + '/brand/invoice/merge/switch.json', // 获取是否是嘉旺品牌
  batchInvoiceOrderListAPI: apiBase + '/order/batchInvoiceOrderList.json', // 获取嘉旺品牌下订单列表
  batchInvoiceOrderListURL: apiBase + '/order/batchInvoiceOrderList',
  batchInvoiceShopListAPI: apiBase + '/brand/getShopList.json', // 获取嘉旺品牌下的门店
  invoiceBatchUrl: apiBase + '/order/invoiceBatchUrl.json' // 获取批量开发票跳转链接
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 会员优惠类型
var MemberPrivTypes = exports.MemberPrivTypes = {
  DISCOUNT: 1, // 折扣
  REDUCE: 2, // 立减
  UNIFIED_DISCOUNT: 3 // 统一折扣
};

// 但商品优惠类型
var SiglePrivTypes = exports.SiglePrivTypes = {
  REDUCE: 1, // 立减
  DISCOUNT: 2 // 折扣
};

// 优惠劵使用类型
var CouponUseTypes = exports.CouponUseTypes = {
  ALL: 1, // 全部
  PART: 2, // 部分可用
  EXCEPTION: 3 // 部分不可用
};

// 优惠劵优惠类型
var CouponPrivTypes = exports.CouponPrivTypes = {
  REDUCE: 1, // 立减,
  DISCOUNT: 2 // 折扣
};

// 进位规则
var CarryTypes = exports.CarryTypes = {
  ROUND: 1, // 四舍五入
  CEIL: 2, // 无条件进位
  FLOOR: 3, // 无条件舍去
  THREE_SEVEN: 4 // 37进位
};

// 堂食就餐类型
var DinnerForms = exports.DinnerForms = {
  DINNER: 0, // 正餐
  FAST: 1 // 快餐
};

// 订单详情开票功能
var Invoice = exports.Invoice = {
  OPEN: 1, // 开通
  CLOSE: 0 // 关闭
};

// 开票状态
var InvoiceStatus = exports.InvoiceStatus = {
  DOWNLOAD: 1, // 下载状态
  OPEN: 0, // 申请开票状态
  LOADING: 2 // 正在开票中状态
};

var CouponTypes = exports.CouponTypes = {
  OFFERVALUE: 1, // 减满券
  ZKVALUE: 2, // 折扣券
  GIFTVALUE: 3, // 礼品券
  FACEVALUE: 4 // 代金券
};

var DeliveryWay = exports.DeliveryWay = {
  ALL: 0, // 外卖+自提
  SEND: 1, // 外卖
  SELF: 2 // 自提
};

// 非定时送达
var OnlyPromptlyDelivery = exports.OnlyPromptlyDelivery = {
  OPEN: 1, // 开启
  CLOSE: 0 // 不开启
};

// U鼎品牌编号
var UdingBrandId = exports.UdingBrandId = '41173';

// 海底捞品牌编号
var HDLBrandId = exports.HDLBrandId = '32467';

// cookie 品牌编号名
var kryApiBrandId = exports.kryApiBrandId = 'kry-api-brand-id';

// 单商品优惠类型
var SinglePrivTypes = exports.SinglePrivTypes = {
  BENEFIT: 1,
  MEMBER: 3 // 会员
};

// 订单子来源
var OrderChildSource = exports.OrderChildSource = {
  WX: 32,
  ALIPAY: 34,
  KOUBEI: 36,
  OTHER: 43,
  HDL: 37,
  HDLHOT: 38,
  HDLWS: 39,
  HDLCOOPERATION: 900,
  HDLBACKUPONE: 901,
  HDLBACKUPTWO: 902,
  HDLBACKUPTHREE: 1135,
  HDLBACKUPFOUR: 1136,
  HDLBACKUPFIVE: 1137,
  CMB: 28,
  WX_MINI: 35,
  ALIPAY_MINI: 42,
  CCB_APP: 54, // TODO: 随便写的，估计后面订单组会指定一个值
  EBU: 162 // ebu 饿了么企餐
};

/**
 * 订单子来源参数
 */

var HDLPublicParm = exports.HDLPublicParm = {
  HDLHOT: 1,
  HDLWS: 2,
  HDLCOOPERATION: 3,
  HDLBACKUPONE: 4,
  HDLBACKUPTWO: 5,
  HDLBACKUPTHREE: 6,
  HDLBACKUPFOUR: 7,
  HDLBACKUPFIVE: 8
};

var DinnerType = exports.DinnerType = {
  TAKEOUT: 'WM',
  DINNERHALL: 'TS'
};

/**
 * 成长类型
 */
var StoreGrownTypes = exports.StoreGrownTypes = {
  STOREDVALUE: 1, // 储值消费获取成长值
  RECHARGE: 2, // 充值时获取成长值
  CONSUME: 3 // 普通消费获取成长值
};

/**
 * 折扣后的最小金额
 */
var MinDiscountedAmount = exports.MinDiscountedAmount = 0.01;

/**
 * 快餐选择人数开关类型
 */
var InputSnackTableCounts = exports.InputSnackTableCounts = {
  MUST: 2, // 必须选人数
  CANT: 0, // 不能选人数
  ABLE: 1 // 非强制选人数
};

/**
 * 人数限制范围
 */
var MaxCustomerCount = exports.MaxCustomerCount = 99;

/**
 * mine-coupon-list pageSize
 */
var MineCouponListPageSize = exports.MineCouponListPageSize = 10;

/**
 * 单菜品最大可点份数
 */
var MaxOrderedDishCount = exports.MaxOrderedDishCount = 99999;

/**
 * 折扣项 calcWay
 */
var CalcWay = exports.CalcWay = {
  DISCOUNT: 1,
  PEOPLE: 2,
  REGULAR: 3,
  STAGE: 7 // 阶梯计费
};

/**
 * 订单状态
 * tradeStatus: 2, // 1:待确认 2:挂单 3:已确认 4:已完成(全部支付) 5:已退货 6:已作废 7：已拒绝 8:取消
 * tradePayStatus: 2, // 1:未支付 2：支付中 3:已支付 4：退款中 5: 已退款 6：退款失败, 7: 已支付确认
 */
var TradeStatus = exports.TradeStatus = {
  AWAIT: 1,
  HANGUP: 2,
  ASSURE: 3,
  FINISH: 4,
  RETURNED: 5,
  INVALID: 6,
  REFUSED: 7,
  CANCEL: 8
};

var TradePayStatus = exports.TradePayStatus = {
  NOTPAY: 1,
  PAYING: 2,
  PAID: 3,
  REFUND: 4,
  REFUNDED: 5,
  REFUNDFAIL: 6,
  CONFIRMED: 7
};

var OrderStatusText = exports.OrderStatusText = {
  '0': '待收锅',
  '1': '收锅中',
  '2': '收锅完成'
};

/**
 * 优惠券保存类型
 */
var CouponSubmitDataTypes = exports.CouponSubmitDataTypes = {
  SYSTEM: 1, // 系统券
  WECHAT: 2 // 微信卡券
};

/**
 * BookOrderStatus
 * 订单状态(未封装), -1:用户未到店,1:用户到店,2:用户离店,9:已取消,-2:未处理,-3:已拒绝,-4:逾期未到店
 */
var BookOrderStatus = exports.BookOrderStatus = {
  USERNOTARRIVAL: -1, // 未到店
  USERARRIVAL: 1, // 用户到店
  USERLEAVESHOP: 2, // 用户离店
  CANCEL: 9, // 已取消
  NOTDEAL: -2, // 未处理
  REFUSE: -3, // 已拒绝
  TIMEOUT: -4, // 逾期未到店
  ASSURE: 3 // 已确认
};

/**
 * BookingStatus
 * 解析之后的book状态
 */
var BookingStatus = exports.BookingStatus = {
  BOOKNOTARRIVAL: 'book-not-arrival', // 未到店
  BOOKSUCCESS: 'book-success', // 预定成功
  BOOKFAIL: 'book-fail', // 预定失败
  BOOKUNPAID: 'book-unpaid', // 未支付
  BOOKCONFIRMING: 'book-confirming', // 确认中
  BOOKCANCEL: 'book-cancel', // 取消预订
  BOOKARRIVALED: 'book-arrived', // 已到店
  BOOKSURE: 'book-sure', // 已确认
  BOOKREFUSED: 'book-refused' // 已拒绝
};

/**
 * QueueOrderStatus
 * 排队状态 0:排队中;1:入场;-1作废;-2取消
 */
var QueueOrderStatus = exports.QueueOrderStatus = {
  QUEUING: 0, // 排队中
  ENTER: 1, // 入场
  DUMP: -1, // 作废
  CANCEL: -2 // 取消
};

/**
 * applyProductType 整单商品优惠
 * 1: '所有商品可用', 2: '部分商品可用', 3: '部分商品不可用',
 */
var ApplyProductType = exports.ApplyProductType = {
  ALLPRODUCT: 1, // 所有商品可用
  PARTPRODUCT: 2, // 部分商品可用
  NOTPARTPRODUCT: 3 // 部分商品不可用
};

/**
 * 换购活动类型，换购还是赠送
 * 1: '赠送', 2: '加价换购'
 */
var PurchasedType = exports.PurchasedType = {
  PRESENT: 1,
  PURCHASE: 2
};

/*
 * WmPageTpl 外卖业态
 */
var WmPageTpl = exports.WmPageTpl = {
  WM: 'wm',
  XLS: 'xls'
};

/*
 * 外卖门店取餐方式
 */
var TakeoutMethod = exports.TakeoutMethod = {
  OPEN: 1, // 开启
  CLOSE: 0 // 关闭
};

/**
 * effectType 是否加入订单 1 加入  2 不加入
 */
var EffectType = exports.EffectType = {
  ADD: 1,
  NOADD: 2
};

/**
 * EffectDiscountType 税率计算金额来源 1 实付金额 2 菜品总价 + 各种附加费
 */
var EffectDiscountType = exports.EffectDiscountType = {
  AFTER: 1,
  BEFORE: 2
};

/**
 * 支付方式
 */
var PayWay = exports.PayWay = {
  ONLINE: '2', // 在线支付
  OFFLINE: '1' // 线下支付
};

/*
 * 正餐制作状态
 */
var DishMakeStatus = exports.DishMakeStatus = {
  AWAIT: 0,
  CUT: 1,
  MAKE: 2,
  DONE: 3,
  OBSOLETE: 4
};

/**
 * 正餐状态
 */
var DishStatus = exports.DishStatus = {
  UNCHECK: 1,
  CHECKED: 2,
  REFUSED: 3
};

/*
 * 菜品子属性类别
 */
var DishPropertyTypes = exports.DishPropertyTypes = {
  PRACTICE: 1, // 做法
  CUSTOMLABEL: 2, // 自定义标签
  REMARK: 3, // 备注
  SPECIFICATION: 4 // 规格
};

/*
 * 支付方式排序
 */
var PaymentMethodsSort = exports.PaymentMethodsSort = {
  BALANCEPAY: 1,
  STOREANDPAY: 2,
  WEIXINPAY: 3,
  ALIPAY: 4,
  BAIDUPAY: 5,
  ANTCREDITPAY: 5, // 花呗
  UEPAY: 6,
  BOCPAY: 7, // bocPay
  TOUCHNGOPAY: 8, // touchngoPay
  MPAY: 9
};

/*
 * 后端返回已经支付的记录
 * https://conf.shishike.com/pages/viewpage.action?pageId=18908207
 */
var PaidRecordMethod = exports.PaidRecordMethod = {
  BALANCEPAY: -1,
  WEIXINPAY: -5,
  ALIPAY: -6,
  PREPAY: -42
};

/*
 * 服务卡状态
 */
var ShopCardOrderStatus = exports.ShopCardOrderStatus = {
  AWAITCOMMERCIALCONFIRM: 1, // 等待商户确认
  ORDERCONFIRMED: 3, // 订单已确认
  AWAITCOMMERCIALCONFIRMADDDISH: 300, // 等待商户确认加菜
  ORDERDONE: 4, // 订单已完成
  ORDEROBSOLETE: 6, // 订单被作废
  ORDERREFUSED: 7 // 订单被拒绝
};

/*
 * 储值方式 1 正常储值 2 小额储值
 */
var StoreType = exports.StoreType = {
  NORMALSTORE: 1,
  SMALLSTORE: 2
};

/*
 * 储值赠送方式 1 赠送固定金额 2 赠送百分比
 */
var SendStoreType = exports.SendStoreType = {
  SENDFIXVALUE: 1,
  SENDPERCENTVALUE: 2
};

/**
 * 微信分享来源 1 门店首页 2 商品详情页 3 会员注册页 4 品牌首页
 */
var WxSharEventEntry = exports.WxSharEventEntry = {
  SHOP: 1,
  DETAIL: 2,
  MEMBER: 3,
  BRAND: 4
};
/*
 * 优惠券入口 1 点餐页 2 订单详情页 3 自动发券页
 */
var CouponEntry = exports.CouponEntry = {
  DISH: 1,
  DISHDETAIL: 2,
  RECEIVED: 3
};

/**
 * 海外环境判定
 */
var isOversea = exports.isOversea = undefined === 'oversea';

/**
 * 点餐页模板
 */
var DishTheme = exports.DishTheme = {
  DEFAULT: 'default',
  // BIG: 'BIG',
  BIG: 'big',
  HUGE: 'huge',
  TEA: 'tea'
};

var INDUSTRY = exports.INDUSTRY = {
  NORMAL: 'normal',
  TEA: 'tea'
};

/**
 * 运行环境.
 * 告知后台查询门店列表用
 */
var runEnv = exports.runEnv = {
  GENERAL: 1, // 普通浏览器(除此之外的其他环境)
  WEIXIN: 2, // 微信
  WEIXINMINI: 3, // 微信小程序
  ALI: 4 // 支付宝
};

/**
 * 折扣卡类型
 * 1 可用，2 不可用
 */
var DISCOUNT_CARD_STATUS = exports.DISCOUNT_CARD_STATUS = {
  VALID: 1,
  INVALID: 2
};

// 几种促销的类型定义
var MULTI_PROMOTIONS = exports.MULTI_PROMOTIONS = 'multiPromotions'; // 多商品促销
var MEMBER_PRICE = exports.MEMBER_PRICE = 'memberPrice'; // 会员价
var SINGLE_PROMOTIONS = exports.SINGLE_PROMOTIONS = 'singlePromotions'; // 单商品促销
var FULL_PROMOTIONS = exports.FULL_PROMOTIONS = 'fullPromotions'; // 买赠促销
var FULL_COUNT_PROMOTIONS = exports.FULL_COUNT_PROMOTIONS = 'fullCountPromotions'; // 下一份折扣
var LIMIT_PROMOTIONS = exports.LIMIT_PROMOTIONS = 'limitPromotions'; // 限免优惠

// 订单详情页-核销码 1 待取餐 2 已取餐
var TAKE_MEAL_STATUS = exports.TAKE_MEAL_STATUS = {
  MEAL_TOKEN: 2,
  NO_MEAL: 1
};
var DISCOUNT_CARDS = exports.DISCOUNT_CARDS = 'discountCards';

// 消费税模式（1 附加模式，2 包含模式）
var TAX_MODE = exports.TAX_MODE = {
  ADDITIONAL: 1,
  INCLUDE: 2
};
// 排队类型
var LINE_STATUS = exports.LINE_STATUS = {
  TABLE: 1, // 显示排队桌数
  POS_ERR: 2, // pos err
  NET_ERR: 3 // net err
};

// 第三方登录 source 值
var thirdPlatformLoginSource = exports.thirdPlatformLoginSource = {
  I_PARK_LOGIN_SOURCE: 20
};

var ACCESS_FROM = exports.ACCESS_FROM = {
  CCB_APP: 'ccbApp', // 建设银行app
  EBU: 'ebu' // 饿了么
};

// 建行标识
var CCB_INFO = exports.CCB_INFO = {
  CCB_PARAM_SJ: 'CCB_PARAM_SJ', // 建行登录密文
  CCB_USER_INFO: 'CCB_USER_INFO', // localstorge中存入建行userid和mobile
  CCB_HEADER: 'CloudMercWebView-User-Agent', // 建行header标志
  CCB_HEADER_IOS: 'iphone',
  CCB_HEADER_ANDROID: 'android'
};
// 饿了么标识
var EBU_INFO = exports.EBU_INFO = {
  EBU_EUID: 'euid' // 饿了么euId
};
// 饿了么登录公钥
var PUBLIC_KEY = exports.PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+s6CloIRGm0kJwvkMbjj2+AL9VMn4YJo6b7H5WFeZA72oa0A7WI/DrBfLrTLx2BTo4iRshYTtETwyv52YcSQN617J9RY9zjZN7rKP8PQmCPgmQ/lobayfia3gPqUxRtaE//i9tDGgtyRraBfE0EhYgJoDyS091l0C4U2SC12h6wIDAQAB';

var NEW_MINI_PROGRAM_NAME_KEY = exports.NEW_MINI_PROGRAM_NAME_KEY = 'wxminiprogramname';
var NEW_MINI_PROGRAM_NAME_VALUE = exports.NEW_MINI_PROGRAM_NAME_VALUE = 'portal-wx-miniprogram';

var MAP_TYPE = exports.MAP_TYPE = {
  B_MAP: 1, // 百度
  A_MAP: 2, // 高德
  G_MAP: 3 // 谷歌
};

// 业态
var BUSINESS_TYPE = exports.BUSINESS_TYPE = {
  FAST: 1, // 快餐
  DINNER: 2, // 正餐
  TAKEOUT: 3, // 外卖
  STORE: 4, // 储值
  BAKE: 18, // 烘焙
  DISCOUNT_CARDS: 24, // 折扣卡
  INTEGRAL: 25 // 积分商城
};

// 开台必点策略
var STRATEGY_TYPE = exports.STRATEGY_TYPE = {
  TABLE: 1, // 按桌台带入
  PEOPLE: 2, // 按人数带入
  SELFCHOOSE: 3 // 开台自选
};

var SYNC_CART_UNAVAILABLE = exports.SYNC_CART_UNAVAILABLE = 'sync_cart_unavailable';
var RECONNECTION_ATTEMPTS = exports.RECONNECTION_ATTEMPTS = 3; // 协同购物车重连次数

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(31)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(7),
    IntlProvider = _require.IntlProvider;

var config = __webpack_require__(13);
var commonHelper = __webpack_require__(3);

// const Sentry = require('@sentry/browser');
var Cookies = __webpack_require__(79);

var intl = null;
exports.initSingletonIntl = function (_ref) {
  var locale = _ref.locale,
      _ref$messages = _ref.messages,
      messages = _ref$messages === undefined ? {} : _ref$messages;

  var intlProvider = new IntlProvider({ locale: locale, messages: messages });

  intl = intlProvider.getChildContext().intl;
  return intl;
};

exports.formatMessage = function () {
  if (!intl) {
    // throw new Error('intl instance must be initialized before using it');
    return 'Intl is not yet initialized.';
  }
  var text = '';

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  try {
    var _intl;

    text = (_intl = intl).formatMessage.apply(_intl, args);
  } catch (e) {
    text = args.backup || '';
    // Sentry.captureException(e);
  }

  return text;
};

exports.getIntl = function () {
  return intl;
};

function loadCurrencyCSS(currency) {
  var style = document.createElement('style');

  style.textContent = '\n    .price::before {\n      content: "' + currency + '";\n    }\n\n    .discount::before {\n      content: "-' + currency + '";\n    }\n  ';

  document.body.appendChild(style);
}

exports.getShopBaseConf = function (loadFunc, applicationName) {
  var shopId = commonHelper.getUrlParam('shopId');
  sessionStorage.setItem('currency', '');
  _fetchHelper2.default.get(config.getShopBaseConfAPI + '?shopId=' + shopId, null, { enableDefaultResponseResolve: false }).then(function () {
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var res = response.data;
    var currency = '';
    var locale = 'zh_CN';
    // 读取本地用户设置
    var localLanguageSwitch = sessionStorage.getItem('language_switch');

    if (res && res.code === '200' && res.data) {
      console.log('res.data', res.data);
      var _res$data = res.data,
          _res$data$brandLangua = _res$data.brandLanguageDefault,
          brandLanguageDefault = _res$data$brandLangua === undefined ? locale : _res$data$brandLangua,
          _res$data$brandLangua2 = _res$data.brandLanguages,
          brandLanguages = _res$data$brandLangua2 === undefined ? [] : _res$data$brandLangua2,
          dateFormat = _res$data.dateFormat,
          dinningForm = _res$data.dinningForm,
          _res$data$languageSwi = _res$data.languageSwitch,
          languageSwitch = _res$data$languageSwi === undefined ? false : _res$data$languageSwi,
          currencySymbol = _res$data.currencySymbol,
          _res$data$showSaleNum = _res$data.showSaleNum,
          showSaleNum = _res$data$showSaleNum === undefined ? false : _res$data$showSaleNum,
          _res$data$brandId = _res$data.brandId,
          brandId = _res$data$brandId === undefined ? '' : _res$data$brandId,
          _res$data$commercialN = _res$data.commercialName,
          commercialName = _res$data$commercialN === undefined ? '' : _res$data$commercialN,
          _res$data$userProtoca = _res$data.userProtocal,
          userProtocal = _res$data$userProtoca === undefined ? '' : _res$data$userProtoca,
          _res$data$privacyProt = _res$data.privacyProtocal,
          privacyProtocal = _res$data$privacyProt === undefined ? '' : _res$data$privacyProt,
          _res$data$protocalSta = _res$data.protocalStatus,
          protocalStatus = _res$data$protocalSta === undefined ? 0 : _res$data$protocalSta;

      currency = currencySymbol;
      sessionStorage.setItem('currency', currency);
      sessionStorage.setItem('dateFormat', dateFormat);
      sessionStorage.setItem('diningForm', dinningForm); // 注意这里的 dinningForm，后端字段拼写错误多了一个n
      sessionStorage.setItem('showSaleNum', showSaleNum); // 是否开启了商品余量展示开关
      sessionStorage.setItem('brandId', brandId);
      sessionStorage.setItem('commercialName', commercialName);
      sessionStorage.setItem('userProtocal', userProtocal); // 后端返回的自定义用户协议
      sessionStorage.setItem('privacyProtocal', privacyProtocal); // 后端返回的自定义隐私协议
      sessionStorage.setItem('protocalStatus', protocalStatus);
      if (brandLanguages.length === 0) {
        brandLanguages.push(brandLanguageDefault); // 容错处理
      }
      // 将语言写入cookie
      var cookieLanguage = Cookies.get('language_switch_' + brandId);
      if (!cookieLanguage || cookieLanguage === 'undefined' || cookieLanguage === 'null' || !brandLanguages.includes(cookieLanguage) || !languageSwitch) {
        Cookies.set('language_switch_' + brandId, brandLanguageDefault, { expires: 90 }); // 90天有效期
      }
      var localBrandLanguages = sessionStorage.getItem('brandLanguages');
      locale = Cookies.get('language_switch_' + brandId) || brandLanguageDefault; // 如果重新写入了cookie或者用户修改过，需要重新读取
      // 如果语言开关开启
      if (languageSwitch.toString() !== localLanguageSwitch) {
        sessionStorage.setItem('language_switch', languageSwitch);
      }

      if (localBrandLanguages !== brandLanguages.join(',')) {
        sessionStorage.setItem('brandLanguages', brandLanguages.join(','));
      }
    }
    loadCurrencyCSS(currency);
    sessionStorage.setItem('locale', locale);
    loadFunc(locale);
  }).catch(function () {
    sessionStorage.setItem('currency', '');
  });
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(12);
var IE8_DOM_DEFINE = __webpack_require__(82);
var toPrimitive = __webpack_require__(56);
var dP = Object.defineProperty;

exports.f = __webpack_require__(15) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = common;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(160), __esModule: true };

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(116);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var createDesc = __webpack_require__(39);
module.exports = __webpack_require__(15) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(134), __esModule: true };

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(78);
var defined = __webpack_require__(52);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(167);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(169);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(231), __esModule: true };

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(233);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(237);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(44);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(52);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(159), __esModule: true };

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(83);
var enumBugKeys = __webpack_require__(59);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(154)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(85)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _fetch = __webpack_require__(144);

var _fetch2 = _interopRequireDefault(_fetch);

var _qs = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 将多个url参数组成字符串
function formatObjToParamStr(paramObj) {
  if (!paramObj) {
    return '';
  }

  return (0, _keys2.default)(paramObj).map(function (key) {
    var value = paramObj[key];
    return value == null ? null : key + '=' + value;
  }).filter(function (item) {
    return item !== null;
  }).join('&');
}

function getRequestUrl(url, params) {
  var requestUrl = url;
  var paramStr = formatObjToParamStr(params);

  if (paramStr) {
    var separator = requestUrl.indexOf('?') === -1 ? '?' : '&';
    requestUrl += '' + separator + paramStr;
  }

  return requestUrl;
}

function getQueryByName(name) {
  var queryString = window.location.search.split('?')[1] || '';
  var query = (0, _qs.parse)(queryString);
  return query[name] || '';
}

function post(url, queries, config) {
  var shopId = getQueryByName('shopId');
  if (shopId === '') {
    throw new Error('shop id is a will pass parameters');
  }
  var newUrl = /shopId=/.test(url) ? url : url + '?' + (0, _qs.stringify)({ shopId: shopId }); // url中含有shopId则不需要加上shopId了
  return _fetch2.default.post(newUrl, queries, config);
}

function get() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var queries = arguments[1];
  var config = arguments[2];

  var newQueries = queries || {};
  var shopId = getQueryByName('shopId') || '';
  var hasUrlShopId = /shopId=/.test(url);
  if (!newQueries.hasOwnProperty('shopId') && !hasUrlShopId) {
    newQueries.shopId = shopId;
  }
  var urlAry = url.split('?');
  var queryString = urlAry[1] || '';
  var query = (0, _qs.parse)(queryString);
  var param = (0, _assign2.default)({}, query, newQueries);
  if (!param.shopId) {
    throw new Error('shop id is a will pass parameters');
  }
  return _fetch2.default.get(urlAry[0], param, config);
}

function goto(url, params) {
  var requestUrl = getRequestUrl(url, params);

  location.href = requestUrl;
}

exports.default = {
  get: get,
  post: post,
  goto: goto
};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(74);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _seamlessImmutable = __webpack_require__(77);

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

var _commonHelper = __webpack_require__(3);

var _storagePairHelper = __webpack_require__(408);

var _const = __webpack_require__(14);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUrlParam = exports.getUrlParam = function (param) {
  var params = (0, _commonHelper.getUrlParams)() || {};

  return params[param] || null;
};

var isSingleDishWithoutProps = exports.isSingleDishWithoutProps = function (dish) {
  if (dish.type === 1) return false;

  var propTypeInfo = dish.dishPropertyTypeInfos || [];
  var ingredientInfos = dish.dishIngredientInfos || [];
  return !ingredientInfos.length && (!propTypeInfo.length || propTypeInfo.every(function (prop) {
    return prop.type === 4 || prop.type === 2;
  }));
};

var isGroupDish = exports.isGroupDish = function (dish) {
  return dish.groups !== undefined;
};

exports.isChildDish = function (dish) {
  return dish.isChildDish;
};

var getOrderedDishes = exports.getOrderedDishes = function (dishes) {
  return dishes.filter(function (dish) {
    return dish.order > 0 || dish.order && dish.order.length;
  });
};

var getDishMemberPrice = exports.getDishMemberPrice = function (dish) {
  var marketPrice = dish.marketPrice,
      discountType = dish.discountType,
      isMember = dish.isMember;

  if (!isMember) {
    // return 0;
    return null;
  }

  var memberPrice = null;
  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    // 折扣1  统一折扣3
    memberPrice = marketPrice * (dish.memberPrice || 0) * 0.1;
  } else if (discountType === _const.MemberPrivTypes.REDUCE) {
    // 固定价 2
    memberPrice = dish.memberPrice || 0;
  }
  if (memberPrice === null) return null; // 如果都不是 则是套餐中加价部分并且没有开启加价折扣
  return +memberPrice.toFixed(2);
};

var getDishesCount = exports.getDishesCount = function (dishes) {
  if (!Array.isArray(dishes)) return 0;
  var number = dishes.map(function (dish) {
    if (!dish) {
      return 0;
    }
    if (dish.order !== undefined) {
      if (isSingleDishWithoutProps(dish) || !Array.isArray(dish.order)) {
        return Number(dish.order) || 0;
      }
      return dish.order.map(function (order) {
        return Number(order.count) || 0;
      }).reduce(function (c, p) {
        return c + p;
      }, 0);
    }
    return 0;
  }).reduce(function (p, c) {
    return p + c;
  }, 0);

  return +number.toFixed(4);
};

// 包含变价的价格（做法、加料）
var getOrderPrice = function getOrderPrice(dish, orderData) {
  var marketPrice = dish.marketPrice,
      saleType = dish.saleType;
  var _orderData$dishProper = orderData.dishPropertyTypeInfos,
      dishPropertyTypeInfos = _orderData$dishProper === undefined ? [] : _orderData$dishProper,
      _orderData$dishIngred = orderData.dishIngredientInfos,
      dishIngredientInfos = _orderData$dishIngred === undefined ? [] : _orderData$dishIngred,
      count = orderData.count,
      _orderData$groups = orderData.groups,
      groups = _orderData$groups === undefined ? [] : _orderData$groups;

  var isWeighedMode = saleType === 1;

  // 套餐价格计算
  if (isGroupDish(dish)) {
    // 称重模式下的配料价格总计
    // 选中的子菜
    var checkedChildDishes = groups.reduce(function (list, group) {
      return list.concat(group.childInfos.filter(function (childDish) {
        return childDish.order;
      }));
    }, []);
    // 子菜的价格列表
    var prices = checkedChildDishes.map(function (item) {
      var isSingle = isSingleDishWithoutProps(item);
      var price = 0;

      if (isSingle) {
        price = item.marketPrice * item.order;
      } else {
        price = item.order.map(function (dishOrder) {
          return getOrderPrice(item, dishOrder);
        }).reduce(function (c, p) {
          return c + p;
        }, 0);
      }

      return price;
    });

    return (count * (marketPrice + prices.reduce(function (c, p) {
      return c + p;
    }, 0))).toFixed(2);
  }

  // 不是套餐的计算
  // 不算备注的做法列表
  var allProps = dishPropertyTypeInfos.filter(function (prop) {
    return prop.type !== 3;
  }).reduce(function (list, item) {
    return list.concat(item.properties || []);
  }, []);
  // 勾选的做法总价
  var checkedPropsPrice = allProps.filter(function (prop) {
    return prop.isChecked;
  }).map(function (prop) {
    return prop.reprice || 0;
  }).reduce(function (c, p) {
    return c + p;
  }, 0);
  // 勾选的配料总价，暂时没有一份菜对应多个配料(item.num)
  var checkedIngredientsPrice = dishIngredientInfos.filter(function (item) {
    return item.isChecked;
  }).map(function (item) {
    return item.reprice || 0;
  }).reduce(function (c, p) {
    return c + p;
  }, 0);

  var price = 0;

  // 计算称重商品配料的价格不需要乘上菜品的份数
  if (isWeighedMode) {
    price = count * marketPrice + checkedPropsPrice + checkedIngredientsPrice;
  } else {
    price = count * (marketPrice + checkedPropsPrice + checkedIngredientsPrice);
  }

  price = parseFloat(price.toFixed(2), 10);
  return Math.max(price, 0);
};

exports.getOrderPrice = getOrderPrice;

var getDishPrice = function getDishPrice(dish) {
  if (isSingleDishWithoutProps(dish)) {
    var singleDishPrice = parseFloat((dish.marketPrice * dish.order).toFixed(2));
    return singleDishPrice >= 0 ? singleDishPrice : 0;
  }

  var hasPropsDishPrice = dish.order.map(function (eachOrder) {
    return parseFloat(getOrderPrice(dish, eachOrder));
  }).reduce(function (c, p) {
    return c + p;
  }, 0);
  return hasPropsDishPrice >= 0 ? hasPropsDishPrice : 0;
};

exports.getDishPrice = getDishPrice;

//
exports.getActivityBenefitMaxId = function (dishes) {
  // 在活动优惠中选取最大优惠价
  var activityBenefitMaxId = 0,
      // 活动优惠最大的菜品id
  activityBenefitMaxValue = 0,
      // 活动优惠最大的菜品优惠价
  activityBenefitMaxIdList = [],
      // 参与活动优惠的商品id列表
  activityBenefitMaxValList = [],
      // 参与活动优惠的商品优惠价列表
  activityBenefitMaxlocation = -1,
      // 活动优惠最大的菜品在优惠价列表中的位置
  singleMarketObj = null,
      singleMarketingInfosPrice = 0,
      singleMarketingInfosMaxPrice = 0,
      singleMarketPriceList = [];
  // 遍历已经点好的菜品找出优惠最多的菜品
  if (dishes && dishes.length) {
    for (var k = 0; k < dishes.length; k++) {
      // 活动优惠中的单商品菜品
      if (dishes[k].activityBenefit) {
        activityBenefitMaxValList.push(dishes[k].activityBenefit);
        activityBenefitMaxIdList.push(dishes[k].id);
      } else if (dishes[k].order instanceof Array && dishes[k].order[0].activityBenefit) {
        // 活动优惠中的套餐菜品
        activityBenefitMaxValList.push(dishes[k].order[0].activityBenefit);
        activityBenefitMaxIdList.push(dishes[k].id);
      }
      // 活动优惠中的单商品折扣
      if (dishes[k].singleMarketingInfos && dishes[k].singleMarketingInfos instanceof Array && dishes[k].singleMarketingInfos.length) {
        // 添加单品折扣优惠价格比较
        // 遍历一个菜品中所有单商品折扣方式并找出满减和打折中优惠最多的一个
        for (var i = 0; i < dishes[k].singleMarketingInfos.length; i++) {
          singleMarketObj = dishes[k].singleMarketingInfos[i];
          // singleMarketingInfosPrice = singleMarketObj.type == 1 ? singleMarketObj.value : (singleMarketObj.type == 2 ? dishes[k].marketPrice - Number(dishes[k].marketPrice / 10 * singleMarketObj.value).toFixed(2) : 0 );
          if (singleMarketObj.type == 1) {
            // 单商品折扣满减
            singleMarketingInfosPrice = singleMarketObj.value;
          } else if (singleMarketObj.type == 2) {
            // 单商品折扣打折
            if (dishes[k].memberPrice) {
              // 单商品折扣非套餐的情况下
              if (dishes[k].order && !dishes[k].order.length) {
                singleMarketingInfosPrice = dishes[k].memberPrice - (dishes[k].memberPrice / 10 * singleMarketObj.value).toFixed(2);
              }
            } else {
              singleMarketingInfosPrice = dishes[k].marketPrice - Number(dishes[k].marketPrice / 10 * singleMarketObj.value).toFixed(2);
            }
          } else {
            singleMarketingInfosPrice = 0;
          }
          singleMarketPriceList.push(singleMarketingInfosPrice);
        }
        singleMarketingInfosMaxPrice = Math.max.apply(Math, singleMarketPriceList);
        if (activityBenefitMaxValList.indexOf(singleMarketingInfosMaxPrice) == -1) {
          activityBenefitMaxValList.push(singleMarketingInfosMaxPrice);
          activityBenefitMaxIdList.push(dishes[k].id);
        }
      }
    }
    if (activityBenefitMaxValList.length > 0) {
      activityBenefitMaxValue = Math.max.apply(Math, activityBenefitMaxValList);
      activityBenefitMaxlocation = activityBenefitMaxValList.indexOf(activityBenefitMaxValue);
      activityBenefitMaxId = activityBenefitMaxIdList[activityBenefitMaxlocation];
    }
  }
  // 返回活动优惠中最大优惠菜品的id 和 优惠价格
  return {
    activityBenefitMaxId: activityBenefitMaxId,
    activityBenefitMaxValue: activityBenefitMaxValue
  };
};

// calcOption 参数废弃
// memberPrice: boolean
var getDishesPrice = function getDishesPrice(dishes, calcOption, memberPrice) {
  var dishesPrice = dishes.map(function (dish) {
    var newDish = dish.asMutable ? dish.asMutable() : (0, _extends3.default)({}, dish); // 构建新的对象
    var memberPriceStr = newDish.memberPrice !== null && newDish.memberPrice !== undefined ? newDish.memberPrice.toString() : null; // 消除memberPrice为0的影响
    if (memberPrice && memberPriceStr) {
      // if (memberPrice && newDish.memberPrice) {
      // 使用会员价
      newDish.marketPrice = getDishMemberPrice(newDish);
    }
    return getDishPrice(newDish);
  }).reduce(function (c, p) {
    return c + p;
  }, 0);
  if (isFinite(dishesPrice) && Math.floor(dishesPrice) === dishesPrice) {
    return dishesPrice;
  }
  return parseFloat(dishesPrice.toFixed(2));
};
exports.getDishesPrice = getDishesPrice;

/**
 * getRealMarketPrice
 * @param { dish }
 * 考虑到菜品变价为负的情况，基准价>实际价格
 */

exports.getRealMarketPrice = function (dish) {
  return Math.min(dish.marketPrice, getDishPrice(dish));
};

/**
 * 计算菜品基准价
 */
var getDishMarketPrice = function getDishMarketPrice(dish) {
  if (isSingleDishWithoutProps(dish)) {
    return Math.max(0, dish.marketPrice * dish.order);
  }
  return (dish.order || []).map(function (order) {
    return dish.marketPrice * order.count;
  }).reduce(function (p, c) {
    return p + c;
  }, 0);
};

/**
 * 计算菜品基准价总和
 */
exports.getDishesMarketPrice = function (dishes) {
  var amount = (dishes || []).map(function (dish) {
    return getDishMarketPrice(dish);
  }).reduce(function (p, c) {
    return p + c;
  }, 0);
  return parseFloat(amount.toFixed(2), 10);
};

exports.getNewCountOfDish = function (dish, increment) {
  var newDish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var newCount = 0;

  if (isSingleDishWithoutProps(dish)) {
    if (dish.order === undefined) {
      newCount = newDish.order || dish.dishIncreaseUnit;
    } else if (dish.order + increment < dish.dishIncreaseUnit) {
      newCount = undefined;
    } else {
      newCount = dish.order + increment;
    }
    newCount = newCount <= 0 ? undefined : newCount;
  } else {
    var oldCount = getDishesCount([dish]);
    if (oldCount === 0) {
      // if never ordered this dish;
      newCount = dish.dishIncreaseUnit;
    } else if (oldCount + increment < dish.dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCount = 0;
    } else {
      newCount = oldCount + increment;
    }
  }

  return newCount;
};

var getOrderPropIds = function getOrderPropIds(order) {
  var dishPropertyTypeInfos = order.dishPropertyTypeInfos,
      dishIngredientInfos = order.dishIngredientInfos;

  var propsIds = [].concat.apply([], dishPropertyTypeInfos.map(function (prop) {
    return prop.properties.filter(function (property) {
      return property.isChecked;
    }).map(function (property) {
      return property.id;
    });
  }));
  var ingredientIds = (dishIngredientInfos || []).filter(function (ingredient) {
    return ingredient.isChecked;
  }).map(function (ingredient) {
    return ingredient.id;
  });
  return [propsIds, ingredientIds];
};

var getSignleDishRuleIds = function getSignleDishRuleIds(dish) {
  var rulePropertyCollection = [];
  dish.dishPropertyTypeInfos.map(function (property) {
    return property.properties.map(function (prop) {
      return rulePropertyCollection.push(prop.id);
    });
  });
  return rulePropertyCollection.join('^');
};

var getDishBoxCount = exports.getDishBoxCount = function (orderedDishes) {
  var dishBoxContainer = [];
  orderedDishes.map(function (orderDish) {
    if (isGroupDish(orderDish)) {
      orderDish.order.map(function (childOrder) {
        var count = childOrder.count;
        // let childDishCount = 0; // 判定所有子菜的餐盒费
        childOrder.groups.map(function (group) {
          return group.childInfos.filter(function (childDish) {
            return childDish.order;
          }).map(function (child) {
            if (child.boxQty && child.dishQty) {
              // 计算了子菜的餐盒费
              dishBoxContainer.push(Math.ceil(getDishesCount([child]) / parseFloat(child.dishQty)) * parseFloat(child.boxQty) * count);
              // childDishCount += child.boxQty;
            } else {
              return false;
            }
            return true;
          });
        });
        // 如何判定所有子菜都没有餐盒费
        // console.log('mmm', childDishCount);
        // if (childDishCount === 0 && orderDish.dishQty) { // 把套餐的餐盒费计算在内,所有子菜都不需要餐盒费
        //   dishBoxContainer.push(childOrder.count * orderDish.dishQty);
        // }
      });
    } else {
      if (orderDish.boxQty && orderDish.dishQty) {
        dishBoxContainer.push(Math.ceil(getDishesCount([orderDish]) / parseFloat(orderDish.dishQty)) * parseFloat(orderDish.boxQty));
      }
    }
    return true;
  });
  return dishBoxContainer.reduce(function (c, p) {
    return c + p;
  }, 0);
};

exports.getDishBoxprice = function (orderedDishes, dishBoxChargeInfo) {
  if (!dishBoxChargeInfo || dishBoxChargeInfo.orderFlag !== 1) {
    return 0;
  }
  return getDishBoxCount(orderedDishes) * dishBoxChargeInfo.content;
};

var hasSelectedProps = exports.hasSelectedProps = function (dish) {
  var _dish$order = (0, _slicedToArray3.default)(dish.order, 1),
      order = _dish$order[0];

  var hasProps = (order.dishPropertyTypeInfos || []).some(function (prop) {
    return prop.type !== 4 && prop.type !== 2 && (prop.properties || []).some(function (item) {
      return item.isChecked;
    });
  });
  var hasIngredients = (order.dishIngredientInfos || []).some(function (item) {
    return item.isChecked;
  });

  if (hasProps || hasIngredients) return true;
  return false;
};

// setCookie
var setCookie = exports.setCookie = function (name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + '=' + value + ';expires=' + exp.toGMTString() + ';path=/';
};

var getDishCookieObject = exports.getDishCookieObject = function (dish, orderIdx) {
  var isSingleDish = !isGroupDish(dish);
  var consumeType = getUrlParam('type');
  var shopId = getUrlParam('shopId');
  var id = dish.id,
      marketPrice = dish.marketPrice;

  var orderCount = isSingleDishWithoutProps(dish) ? getDishesCount([dish]) : dish.order[orderIdx].count;
  if (isSingleDish) {
    var spliceResultOfPropIds = null;
    if (isSingleDishWithoutProps(dish)) {
      if (dish.dishPropertyTypeInfos && dish.dishPropertyTypeInfos.length) {
        // 到这里就剩下只有规格的菜品了
        spliceResultOfPropIds = '-' + getSignleDishRuleIds(dish);
      } else {
        spliceResultOfPropIds = '-';
      }
    } else {
      spliceResultOfPropIds = getOrderPropIds(dish.order[orderIdx])[1].join('^') + '-' + getOrderPropIds(dish.order[orderIdx])[0].join('^');
    }
    return { key: consumeType + '_' + shopId + '_' + id + '_' + id + '|1-' + spliceResultOfPropIds, value: orderCount + '|' + marketPrice };
  }
  var splitPropsIds = [].concat.apply([], dish.order[orderIdx].groups.map(function (group) {
    var groupId = group.id;
    var result = group.childInfos.filter(function (childInfos) {
      return getDishesCount([childInfos]);
    }).map(function (childInfo) {
      var spliceResultOfPropIds = null;
      if (isSingleDishWithoutProps(childInfo)) {
        if (childInfo.dishPropertyTypeInfos && childInfo.dishPropertyTypeInfos.length) {
          // 到这里就剩下只有规格的菜品了
          spliceResultOfPropIds = '-' + getSignleDishRuleIds(childInfo);
        } else {
          spliceResultOfPropIds = '-';
        }
      } else {
        spliceResultOfPropIds = getOrderPropIds(childInfo.order[0])[1].join('^') + '-' + getOrderPropIds(childInfo.order[0])[0].join('^');
      }
      return childInfo.id + 'A' + groupId + '|' + getDishesCount([childInfo]) + '-' + spliceResultOfPropIds;
    });
    return [].concat.apply([], result);
  }));
  var groupChildDishIds = !splitPropsIds.join('#') || splitPropsIds.join('#') === '' ? id + '|1--' : splitPropsIds.join('#');
  return { key: consumeType + '_' + shopId + '_' + id + '_' + groupChildDishIds, value: orderCount + '|' + marketPrice };
};

var dishesLocalStorageMgr = (0, _storagePairHelper.createLastOrderedDishesMgr)();

exports.storeDishesLocalStorage = function (data, shopInfo, func) {
  var dishes = func ? func(data) : getOrderedDishes(data);
  var options = {
    shopId: getUrlParam('shopId'),
    shopName: shopInfo.commercialName || '',
    type: getUrlParam('type')
  };

  dishesLocalStorageMgr.set(dishes, options);
};

exports.clearDishesLocalStorage = function () {
  dishesLocalStorageMgr.clear();
};

exports.restoreDishesLocalStorage = function (data) {
  var shopId = getUrlParam('shopId');
  var type = getUrlParam('type');
  var dishes = dishesLocalStorageMgr.get({ shopId: shopId, type: type });
  if (!dishes) {
    return data;
  }

  data.dishList.forEach(function (dish) {
    var orderedDishIndex = dishes.findIndex(function (orderedDish) {
      return orderedDish.id === dish.id;
    });
    if (orderedDishIndex > -1) {
      dish.order = dishes[orderedDishIndex].order;
    }
  });

  return data;
};

exports.getDishesLocalStorage = function (args) {
  var dishes = dishesLocalStorageMgr.get(args);

  return dishes ? { dishes: dishes } : null;
};

var appendzero = exports.appendzero = function (number) {
  if (number < 10) {
    return '0' + number;
  }
  return number;
};

exports.isShopOpen = function () {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var now = new Date();
  var currentTime = appendzero(now.getHours()) + ':' + appendzero(now.getMinutes());

  var shopOpen = false;
  timeList.forEach(function (item, index) {
    if (currentTime >= item.startTime && currentTime <= item.endTime && !shopOpen) {
      shopOpen = true;
    }
  });

  return shopOpen;
};
exports.setDishCookie = function (dishesData, orderedData) {
  // 下面开始区分套餐cookie和单品菜cookie
  orderedData.map(function (orderData) {
    if (!isSingleDishWithoutProps(orderData)) {
      for (var index in orderData.order) {
        var setPackageDishCookie = getDishCookieObject(orderData, index);
        setCookie(setPackageDishCookie.key, setPackageDishCookie.value);
      }
      return true;
    }
    var setSignleDishCookie = getDishCookieObject(orderData, 0);
    return setCookie(setSignleDishCookie.key, setSignleDishCookie.value);
  });
};
exports.deleteOldDishCookie = function () {
  var oldCookieCollection = document.cookie.match(/(WM|TS).+?((?=;)|$)/g);
  if (oldCookieCollection && oldCookieCollection.length) {
    oldCookieCollection.forEach(function (cookie) {
      var date = new Date();
      date.setTime(date.getTime() - 10000);
      document.cookie = cookie + '=a; expires=' + date.toGMTString() + '; path=/';
    });
  }
};

exports.generateDishNameWithUnit = function (dishData, entry) {
  if (Array.isArray(dishData.dishPropertyTypeInfos) && dishData.dishPropertyTypeInfos.length) {
    var avaliableDishProps = dishData.dishPropertyTypeInfos.filter(function (prop) {
      return prop.type === 4;
    });
    if (avaliableDishProps.length) {
      var properties = avaliableDishProps.map(function (prop) {
        var _prop$properties = (0, _slicedToArray3.default)(prop.properties, 1),
            cur = _prop$properties[0];

        return cur && cur.name;
      }).join(', ');
      // return dishData.unitName ? `${dishData.name}(${properties})/${dishData.unitName}` : `${dishData.name}(${properties})`;
      switch (entry) {
        case 'dishMenu':
          return dishData.unitName !== '份' ? dishData.name + '(' + properties + ')/' + dishData.unitName : dishData.name + '(' + properties + ')';
        default:
          return dishData.name + '(' + properties + ')';
      }
    }
    // return dishData.unitName ? `${dishData.name}/${dishData.unitName}` : dishData.name;
    switch (entry) {
      case 'dishMenu':
        return dishData.unitName !== '份' ? dishData.name + '/' + dishData.unitName : dishData.name;
      default:
        return dishData.name;
    }
  }
  // return dishData.unitName ? `${dishData.name}/${dishData.unitName}` : dishData.name;
  switch (entry) {
    case 'dishMenu':
      return dishData.unitName !== '份' ? dishData.name + '/' + dishData.unitName : dishData.name;
    default:
      return dishData.name;
  }
};

exports.formatOpenTime = function (openTimeList) {
  var openTimeContent = '';
  // const resultObj = {};
  if (openTimeList && Array.isArray(openTimeList) && openTimeList.length !== 0) {
    var newOpenTimeList = [].slice.call(openTimeList); // 新数组
    var timeRange = '';
    var ignoreNum = [];
    openTimeList.forEach(function (item, index) {
      newOpenTimeList.splice(0, 1); // 去掉数组头
      if (ignoreNum.indexOf(index) !== -1) {
        return;
      }
      var basicStartTime = item.startTime; // 初始开始数据
      var basicEndTime = item.endTime; // 初始结束数据

      newOpenTimeList.forEach(function (newitem, newindex) {
        // 子循环
        // 如果时间有交集 分几种情况
        switch (true) {
          case newitem.startTime <= basicEndTime && newitem.startTime >= basicStartTime:
            if (newitem.endTime >= basicEndTime) {
              // 有交集
              basicEndTime = newitem.endTime;
            }
            ignoreNum.push(newindex + index + 1);
            break;
          case newitem.startTime <= basicStartTime:
            if (newitem.endTime >= basicStartTime && newitem.endTime <= basicEndTime) {
              // 有交集
              basicStartTime = newitem.startTime;
              ignoreNum.push(newindex + index + 1);
            } else if (newitem.endTime >= basicEndTime) {
              basicStartTime = newitem.startTime;
              basicEndTime = newitem.endTime;
              ignoreNum.push(newindex + index + 1);
            }
            break;
          default:
            break;
        }
      });
      timeRange = basicStartTime.slice(0, 5) + '-' + basicEndTime.slice(0, 5);
      openTimeContent += timeRange + ' ';
    });
  }
  return openTimeContent;
};

exports.formatMarket = function (marketList, formatDishesData) {
  var formatMarket = {};
  marketList.forEach(function (item, index) {
    var dishId = item.dishId;
    if (item.rules && item.rules.length !== 0 && formatDishesData[dishId]) {
      formatMarket[dishId] = item.rules;
    }
  });
  return formatMarket;
};

exports.formatMarketUpdate = function (marketList, formatDishesData) {
  var formatMarketUpdate = [];
  // 外部排序
  marketList.forEach(function (item, index) {
    var dishId = item.dishId;
    var dish = formatDishesData[dishId];

    if (item.rules && item.rules.length !== 0 && dish) {
      item.rules.forEach(function (itemt, indext) {
        formatMarketUpdate.push(itemt);
      });
    }
  });

  return formatMarketUpdate.sort(function (a, b) {
    if (b.updateTime > a.updateTime) {
      return 1;
    } else if (b.updateTime === a.updateTime) {
      return 0;
    }
    return -1;
  });
};

exports.formatDishesData = function (dishesData) {
  var formatDishesData = {};
  dishesData.forEach(function (item, index) {
    formatDishesData[item.brandDishId] = item;
  });
  return formatDishesData;
};

exports.matchDishesData = function (marketListUpdate, formatDishesData) {
  var marketMatchDishes = false;
  marketListUpdate.forEach(function (item, index) {
    if (formatDishesData[item.dishId]) {
      marketMatchDishes = true;
    }
  });
  return marketMatchDishes;
};

/*
  合并名称,销售单位,商品中类一致,商品参与的规格分组完全一致的菜品
*/
exports.mergeSameRuleDish = function (dishList, dishTypeList) {
  if (!dishList || !dishList.length) {
    return { dishList: [], dishTypeList: dishTypeList };
  }

  var mergedDishList = [];
  var sameRuleDishMap = {};
  var getDishRuleFlag = function getDishRuleFlag(dish) {
    var ids = dish.dishPropertyTypeInfos.filter(function (item) {
      return item.type === 4;
    }).map(function (item) {
      return item.properties[0].id;
    });
    return ids.sort().join('-');
  };

  dishList.forEach(function (dish, index) {
    if (dish.saleType === 1) {
      (0, _assign2.default)(dish, { stepNum: 1, dishIncreaseUnit: 1 });
    }

    // snail 2019-06-13 无论是什么售卖类型，都将做stepNum及dishIncreaseUnit 默认为1 向下求整的逻辑。
    var stepNum = dish.stepNum,
        dishIncreaseUnit = dish.dishIncreaseUnit;

    if (!stepNum) stepNum = 1;
    if (!dishIncreaseUnit) dishIncreaseUnit = 1;

    stepNum = isNaN(stepNum) ? stepNum : Math.floor(stepNum) === 0 ? 1 : Math.floor(stepNum);
    dishIncreaseUnit = isNaN(dishIncreaseUnit) ? dishIncreaseUnit : Math.floor(dishIncreaseUnit) === 0 ? 1 : Math.floor(dishIncreaseUnit);

    (0, _assign2.default)(dish, { stepNum: stepNum, dishIncreaseUnit: dishIncreaseUnit });

    if (isGroupDish(dish)) {
      mergedDishList.push(dish);
      return;
    }

    var ruleIdStr = dish.dishPropertyTypeInfos.filter(function (item) {
      return item.type === 4;
    }).map(function (item) {
      var firstProperty = item.properties && item.properties[0];
      if (firstProperty) {
        firstProperty.isChecked = true;
      }
      return item.id;
    }).join('-');
    var key = dish.name + '-' + dish.unitName + '-' + dish.dishTypeId + '-' + ruleIdStr;

    sameRuleDishMap[key] = (sameRuleDishMap[key] || []).concat([index]);
    dish.dishIngredientInfos = dish.dishIngredientInfos.map(function (item) {
      return (0, _extends3.default)({}, item, { isChecked: !!item.isChecked });
    });
    mergedDishList.push(dish);
  });

  var _loop = function _loop(key) {
    if (!sameRuleDishMap.hasOwnProperty(key)) {
      return 'continue';
    }

    var sameDishIndexs = sameRuleDishMap[key];
    if (sameDishIndexs.length <= 1) {
      return 'continue';
    }

    var marketPrices = [];
    sameDishIndexs.forEach(function (dishIndex) {
      var sameDish = dishList[dishIndex];
      sameDish.ruleFlag = getDishRuleFlag(sameDish);
      marketPrices.push(sameDish.marketPrice);
    });

    var minMarketPirice = Math.min.apply(null, marketPrices);
    var maxMarketPirice = Math.max.apply(null, marketPrices);
    var firstDishId = '';

    sameDishIndexs.forEach(function (dishIndex, index) {
      var dish = mergedDishList[dishIndex];
      if (index === 0) {
        firstDishId = dish.id;
        (0, _assign2.default)(dish, { sameDishIndexs: sameDishIndexs, mergedMinPrice: minMarketPirice === maxMarketPirice ? undefined : minMarketPirice });
        return;
      }

      (0, _assign2.default)(dish, { proxyDishId: firstDishId });
    });
  };

  for (var key in sameRuleDishMap) {
    var _ret = _loop(key);

    if (_ret === 'continue') continue;
  }

  return {
    dishList: mergedDishList,
    dishTypeList: dishTypeList
  };
};

exports.organizeDishData = function (dish) {
  var dishData = {};
  dishData.id = dish.id;
  dishData.name = dish.name;
  dishData.dishTypeId = dish.dishTypeId;
  dishData.brandDishId = dish.brandDishId;
  dishData.type = dish.type;
  dishData.marketPrice = dish.marketPrice;
  dishData.unitName = dish.unitName;
  dishData.dishIncreaseUnit = dish.dishIncreaseUnit;
  dishData.stepNum = dish.stepNum;
  dishData.dishTypeName = (0, _helper.formatMessage)(_global2.default.defaultSort);
  dishData.dishTypeOrder = 0;
  dishData.saleType = dish.saleType;
  dishData.proxyDishId = dish.proxyDishId;

  // 菜品属性
  var fillPropertyTypeList = function fillPropertyTypeList(propertyTypeList, dishType) {
    if (!propertyTypeList || !propertyTypeList.length) {
      return [];
    }

    return propertyTypeList.map(function (propertyType) {
      var name = propertyType.name,
          type = propertyType.type,
          id = propertyType.id,
          properties = propertyType.properties;

      return { id: id, name: name, type: type, properties: dishType === 'number' ? properties : properties.filter(function (item) {
          return item.isChecked;
        }) };
    });
  };

  var dishTypeList = JSON.parse(sessionStorage.dishTypeList || '[]');

  dishTypeList.forEach(function (item) {
    if (item.id === dish.dishTypeId) {
      dishData.dishTypeName = item.name;
      // dishData.dishTypeOrder = item.desc || 0;
      dishData.dishTypeOrder = 0;
    }
  });

  // 菜品配料
  var fillDishIngredientInfos = function fillDishIngredientInfos(dishIngredientInfos) {
    return (dishIngredientInfos || []).filter(function (item) {
      return item.isChecked;
    });
  };

  if (isSingleDishWithoutProps(dish)) {
    dishData.num = dish.order;
    dishData.propertyTypeList = dish.dishPropertyTypeInfos || [];
    dishData.dishIngredientInfos = dish.dishIngredientInfos || [];
  } else if (isGroupDish(dish)) {
    var _dish$order2 = (0, _slicedToArray3.default)(dish.order, 1),
        order = _dish$order2[0];

    dishData.num = order.count;
    dishData.subDishItems = [];
    order.groups.forEach(function (group) {
      // 分组的子菜遍历
      group.childInfos.forEach(function (childInfo) {
        if (!childInfo.order) {
          return;
        }
        var num = getDishesCount([childInfo]);
        if (!num) {
          return;
        }

        // const orderedChildDish = {};
        // orderedChildDish.groupId = group.id;
        // orderedChildDish.num = num;
        // orderedChildDish.itemId = childInfo.id;
        // orderedChildDish.name = childInfo.name;
        // orderedChildDish.marketPrice = childInfo.marketPrice;
        // orderedChildDish.unitName = childInfo.unitName;

        // let ingredientInfoList = childInfo.dishIngredientInfos;
        // let propertyTypeInfoList = childInfo.dishPropertyTypeInfos;
        // if (typeof childInfo.order !== 'number') {
        //   let ingredientInfoListTemp = childInfo.order.map((item) => item.dishIngredientInfos);
        //   if (ingredientInfoListTemp) {
        //     ingredientInfoList = ingredientInfoListTemp[0] || [];
        //   }
        //   let propertyTypeInfoListTemp = childInfo.order.map((item) => item.dishPropertyTypeInfos);
        //   if (propertyTypeInfoListTemp) {
        //     propertyTypeInfoList = propertyTypeInfoListTemp[0] || [];
        //   }
        // }

        // orderedChildDish.propertyTypeList = fillPropertyTypeList(propertyTypeInfoList || []);
        // orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(ingredientInfoList || []);
        // dishData.subDishItems.push(orderedChildDish);

        // 遍历order -- 改
        if (typeof childInfo.order !== 'number') {
          childInfo.order.map(function (item) {
            if (item.count === 0) return false;
            var orderedChildDish = {};
            orderedChildDish.groupId = group.id;
            orderedChildDish.itemId = childInfo.id;
            orderedChildDish.name = childInfo.name;
            orderedChildDish.marketPrice = childInfo.marketPrice;
            orderedChildDish.unitName = childInfo.unitName;
            orderedChildDish.num = item.count;
            orderedChildDish.saleType = childInfo.saleType;
            orderedChildDish.propertyTypeList = fillPropertyTypeList(item.dishPropertyTypeInfos || []);
            orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(item.dishIngredientInfos || []);
            dishData.subDishItems.push(orderedChildDish);
            return true;
          });
        } else {
          var orderedChildDish = {};
          orderedChildDish.groupId = group.id;
          orderedChildDish.num = num;
          orderedChildDish.itemId = childInfo.id;
          orderedChildDish.name = childInfo.name;
          orderedChildDish.marketPrice = childInfo.marketPrice;
          orderedChildDish.unitName = childInfo.unitName;
          orderedChildDish.saleType = childInfo.saleType;
          orderedChildDish.propertyTypeList = fillPropertyTypeList(childInfo.dishPropertyTypeInfos || [], 'number');
          orderedChildDish.dishIngredientInfos = fillDishIngredientInfos(childInfo.dishIngredientInfos || []);
          dishData.subDishItems.push(orderedChildDish);
        }
      });
    });
  } else {
    var _dish$order3 = (0, _slicedToArray3.default)(dish.order, 1),
        _order = _dish$order3[0];

    dishData.num = _order.count;
    dishData.propertyTypeList = fillPropertyTypeList(_order.dishPropertyTypeInfos);
    dishData.dishIngredientInfos = fillDishIngredientInfos(_order.dishIngredientInfos);
  }
  var time = new Date();
  return (0, _assign2.default)({}, dishData, { tag: time.getTime() });
};

exports.adjustOrderedDishIncrement = function (dish, increment) {
  var newDish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (isSingleDishWithoutProps(dish)) {
    var order = dish.order || newDish.order || 0;
    var _dish$dishIncreaseUni = dish.dishIncreaseUnit,
        dishIncreaseUnit = _dish$dishIncreaseUni === undefined ? 1 : _dish$dishIncreaseUni,
        _dish$stepNum = dish.stepNum,
        stepNum = _dish$stepNum === undefined ? 1 : _dish$stepNum;

    if (increment > 0 && order === 0) {
      return increment === stepNum ? dishIncreaseUnit : increment;
    }

    var calculdatedOrder = order + increment;
    if (calculdatedOrder <= 0) {
      return -order;
    }

    if (calculdatedOrder < dishIncreaseUnit) {
      return dishIncreaseUnit * (Math.abs(increment) / increment);
    }
  }

  return increment;
};

exports.getDishMemberPriceWithSameRuleDishes = function (dish, sameRuleDishes) {
  if (!sameRuleDishes) {
    return getDishMemberPrice(dish);
  }

  var memberDishPrices = [];
  sameRuleDishes.forEach(function (item) {
    if (dish.marketPrice === item.marketPrice && item.isMember) {
      memberDishPrices.push(getDishMemberPrice(item));
    }
  });
  return Math.min.apply(null, memberDishPrices);
};

exports.containsSubPropertyDetail = function (dish) {
  if (isSingleDishWithoutProps(dish)) {
    return false;
  }

  if (!isGroupDish(dish)) {
    return hasSelectedProps(dish);
  }

  var _ref = dish.order || [],
      _ref2 = (0, _slicedToArray3.default)(_ref, 1),
      order = _ref2[0];

  if (!order) {
    return false;
  }

  var _order$groups = order.groups,
      groups = _order$groups === undefined ? [] : _order$groups;

  return groups.some(function (group) {
    return group.childInfos.some(function (child) {
      return getDishesCount([child]) > 0;
    });
  });
};

var ballFlyAnimationTimer = {
  queue: [],
  current: null
};

var ballFlyWhenOrderDish = exports.ballFlyWhenOrderDish = function (options) {
  if (ballFlyAnimationTimer.isSingle === undefined) {
    ballFlyAnimationTimer.isSingle = navigator.userAgent.toLowerCase().indexOf('android') !== -1;
  }

  if (ballFlyAnimationTimer.isSingle && ballFlyAnimationTimer.current) {
    ballFlyAnimationTimer.queue = [options];
    return;
  }

  ballFlyAnimationTimer.current = options;
  var settings = (0, _assign2.default)({
    vertexRtop: 20,
    speed: 2.8,
    start: {},
    end: {}
  }, options);

  var init = function init() {
    document.body.insertAdjacentHTML('beforeend', '<ins class=\'' + (settings.className || '') + '\'></ins>');
    settings.elem = document.body.lastChild;
    var start = settings.start,
        end = settings.end,
        vertexRtop = settings.vertexRtop;


    var vertexTop = Math.min(start.top, end.top) - Math.abs(start.left - end.left) / 13;
    if (vertexTop < vertexRtop) {
      vertexTop = Math.min(vertexRtop, Math.min(start.top, end.top));
    }
    var distance = Math.sqrt(Math.pow(start.top - end.top, 2) + Math.pow(start.left - end.left, 2));
    var steps = Math.ceil(Math.min(Math.max(Math.log(distance) / 0.05 - 75, 30), 100) / settings.speed);
    var ratio = start.top === vertexTop ? 0 : -Math.sqrt((end.top - vertexTop) / (start.top - vertexTop));
    var vertexLeft = (ratio * start.left - end.left) / (ratio - 1);
    var curvature = end.left === vertexLeft ? 0 : (end.top - vertexTop) / Math.pow(end.left - vertexLeft, 2);

    (0, _assign2.default)(settings, {
      count: -1,
      steps: steps,
      vertexLeft: vertexLeft,
      vertexTop: vertexTop,
      curvature: curvature
    });
    (0, _assign2.default)(settings.elem.style, {
      left: settings.start.left + 'px',
      top: settings.start.top + 'px'
    });
  };

  var destory = function destory() {
    ballFlyAnimationTimer.current = null;
    settings.elem.parentNode.removeChild(settings.elem);
    settings.elem = null;
  };

  var queue = function queue() {
    var next = ballFlyAnimationTimer.queue.shift();
    if (next) {
      ballFlyWhenOrderDish(next);
    }
  };

  var move = function move() {
    var start = settings.start,
        steps = settings.steps,
        count = settings.count,
        end = settings.end;

    var left = start.left + (end.left - start.left) * count / steps;
    var top = settings.curvature === 0 ? start.top + (end.top - start.top) * count / steps : settings.curvature * Math.pow(left - settings.vertexLeft, 2) + settings.vertexTop;
    settings.elem.style.transform = 'translate3d(' + (left - start.left) + 'px,' + (top - start.top) + 'px,0)';
    settings.count++;

    var time = window.requestAnimationFrame(move);
    if (count === steps) {
      window.cancelAnimationFrame(time);
      destory();
      queue();

      if (settings.onEnd) {
        setTimeout(function () {
          settings.onEnd();
        }, 20);
      }
    }
  };
  init();
  move();
};

exports.divideOrderedDishes = function (dishes) {
  var func = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return null;
  };
  return [].concat.apply([], dishes.map(function (dish) {
    if (isSingleDishWithoutProps(dish)) {
      return [(0, _assign2.default)({}, dish, func(dish))];
    }
    return dish.order.map(function (dishOrder, idx) {
      return (0, _assign2.default)({}, dish, func(dish), { order: [(0, _assign2.default)({}, dishOrder)] });
    });
  }));
};

/**
 * 菜品打折数据去重
 */
exports.uniqueDiscountInfo = function (dishList) {
  var list = [];
  var uniqueIdMap = {};

  (dishList || []).forEach(function (dish) {
    var id = dish.dishId;

    if (!uniqueIdMap.hasOwnProperty(id)) {
      uniqueIdMap[id] = true;
      list.push(dish);
    }
  });
  return list;
};

/**
 * 配料属性
 */
exports.formatMemo = function (mainDish) {
  // 合并配料与菜品属性 BEGIN
  var dishIngredientList = mainDish.dishIngredientInfos || [];
  var propertyTypeList = mainDish.propertyTypeList || [];
  var dishIngredientArray = [];

  if (dishIngredientList && dishIngredientList.length !== 0) {
    dishIngredientArray = [{
      name: (0, _helper.formatMessage)(_dishMenu2.default.ingredients),
      type: 2.5,
      properties: dishIngredientList
    }];
  }
  propertyTypeList = propertyTypeList.concat(dishIngredientArray);
  // 合并配料与菜品属性 END

  if (!propertyTypeList || propertyTypeList.length === 0) {
    return '';
  }
  var memoList = (propertyTypeList || []).filter(function (item) {
    return item.type !== 4;
  });
  memoList = Array.prototype.slice.call(memoList).sort(function (a, b) {
    return a.type - b.type;
  }); // 按照 口味-标签-备注 进行排序
  var memo = '';
  memoList.forEach(function (item, index) {
    if (item.type === 1 || item.type === 2 || item.type === 3 || item.type === 2.5) {
      // 口味做法
      memo += ' | ' + item.name + ':';
    }
    (item.properties || []).forEach(function (itemt, indext) {
      if (itemt.name) {
        if (item.type === 2.5) {
          // 配料需要加上*num
          memo += itemt.name + 'x' + (itemt.num || 1) + ',';
        } else {
          memo += itemt.name + ',';
        }
      }
    });
    memo = memo.substring(0, memo.length - 1);
  });
  memo = memo.substring(2, memo.length);
  return memo;
};

var TS_AD_SHOW_KEY = 'fullscreen-ad-display-time';
var SELECT_PEOPLE_KEY = 'select-people-flag';

var getSelectPeopleFlag = function getSelectPeopleFlag() {
  var _latestFlag;

  var fromSelectPeople = getUrlParam('fromSelectPeople');
  var now = new Date();
  var today = now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate();

  var DISH_KEY = 'dish-' + today;
  var PEOPLE_KEY = 'people-' + today;
  var selectPeopleFlag = JSON.parse(window.localStorage.getItem(SELECT_PEOPLE_KEY)) || {};

  var dishNum = selectPeopleFlag[DISH_KEY];
  var peopleNum = selectPeopleFlag[PEOPLE_KEY];
  dishNum = dishNum ? dishNum + 1 : 1;
  if (fromSelectPeople === 'true') {
    peopleNum = peopleNum ? peopleNum + 1 : 1;
  }
  var latestFlag = (_latestFlag = {}, (0, _defineProperty3.default)(_latestFlag, DISH_KEY, dishNum), (0, _defineProperty3.default)(_latestFlag, PEOPLE_KEY, peopleNum), _latestFlag);
  window.localStorage.setItem(SELECT_PEOPLE_KEY, (0, _stringify2.default)(latestFlag));

  return {
    dishNum: dishNum,
    peopleNum: peopleNum
  };
};

exports.getFullscreenAdShow = function (_ref3) {
  var fullAdvertRule = _ref3.fullAdvertRule,
      fullAdvertImgUrl = _ref3.fullAdvertImgUrl,
      fullAdvertUrl = _ref3.fullAdvertUrl;

  var key = TS_AD_SHOW_KEY + '-' + getUrlParam('shopId');
  var show = false;
  // 每天显示一次
  var selectPeopleFlag = getSelectPeopleFlag() || {};
  if (fullAdvertRule === 1 && fullAdvertImgUrl) {
    // const last = window.localStorage.getItem(key);
    // const now = new Date();
    // const today = `${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}`;
    // const current = `${fullAdvertImgUrl}-${fullAdvertUrl}-${today}`;

    // if (!last || last !== current) {
    //   show = true;
    //   window.localStorage.setItem(key, current);
    // }
    var dishNum = selectPeopleFlag.dishNum,
        peopleNum = selectPeopleFlag.peopleNum;

    if (dishNum === 2 && peopleNum === 1 || dishNum === 1) {
      show = true;
    }
  }
  // 每次访问显示
  if (fullAdvertRule === 2 && fullAdvertImgUrl) {
    var hasShowed = window.sessionStorage.getItem(key);
    if (!hasShowed) {
      show = true;
      window.sessionStorage.setItem(key, 1);
    }
  }

  return show;
};

var getDishIds = function getDishIds(dishes) {
  return dishes.reduce(function (list, dish) {
    var spu = dish.productDishType === 1 && dish.dishList && dish.dishList.length;
    return spu ? list.concat(getDishIds(dish.dishList)) : list.concat(dish.dishId);
  }, []);
};

exports.getDishIds = getDishIds;

/**
 * 计算商品的基准价格
 * @param {Object} dish 商品对象
 */
var getDishBasePrice = function getDishBasePrice(dish) {
  var isSingleDish = isSingleDishWithoutProps(dish);
  var price = isSingleDish ? dish.marketPrice * dish.order : dish.marketPrice * dish.order[0].count;

  return price >= 0 ? price : 0;
};

exports.getDishBasePrice = getDishBasePrice;

/**
 * 计算商品列表的基准价格
 * @param {Array} dishes 商品列表
 */
var getDishesBasePrice = function getDishesBasePrice(dishes) {
  return dishes.reduce(function (total, dish) {
    return total + getDishBasePrice(dish);
  }, 0);
};

exports.getDishesBasePrice = getDishesBasePrice;

/**
 * 计算商品份数
 * @param {Array} dishes 商品列表
 */
var countDishesNumber = function countDishesNumber(dishes) {
  return dishes.reduce(function (count, dish) {
    var isSingleDish = isSingleDishWithoutProps(dish);
    return count + (isSingleDish ? dish.order : dish.order.reduce(function (t, c) {
      return t + c.count;
    }, 0));
  }, 0);
};

exports.countDishesNumber = countDishesNumber;

/**
 * 将带有不同做法的商品平铺出来
 * @param {Array} dishes 购物车的商品列表
 */
var divideDishes = function divideDishes(dishes, keyPrefix) {
  var prefix = keyPrefix ? '-' + keyPrefix + '_' + new Date().getTime() : '';

  return [].concat.apply([], dishes.map(function (dish) {
    if (isSingleDishWithoutProps(dish)) {
      return [(0, _extends3.default)({}, dish, {
        basePrice: dish.marketPrice * dish.order,
        key: '' + dish.brandDishId + prefix + '-0'
      })];
    }
    return dish.order.map(function (dishOrder, idx) {
      return (0, _extends3.default)({}, dish, {
        key: '' + dish.brandDishId + prefix + '-' + idx,
        basePrice: dish.marketPrice * dishOrder.count,
        order: [(0, _extends3.default)({}, dishOrder)],
        orderLength: dish.order.length
      });
    });
  }));
};

exports.divideDishes = divideDishes;

exports.mergeOrderedDishes = function (orderedDishes, selectedDishes) {
  // 去掉 immutable 属性
  var ordered = _seamlessImmutable2.default.asMutable(orderedDishes, { deep: true });
  // 新增的商品
  var newDishes = _seamlessImmutable2.default.asMutable(selectedDishes, { deep: true }).filter(function (dish) {
    var hadOne = ordered.find(function (item) {
      return item.brandDishId === dish.brandDishId;
    });

    if (hadOne) {
      // 如果购物车中已经有这个商品；则更新它的订单属性
      hadOne.order = typeof hadOne.order === 'number' ? hadOne.order + dish.order : hadOne.order.concat(dish.order);
    }

    return !hadOne;
  });
  return ordered.concat(newDishes);
};

var getValueForDiscount = function getValueForDiscount(originVal, discount) {
  return +(originVal * discount * 0.1).toFixed(2);
};

/**
 * 计算属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @return {dishPropertyTypeInfos,dishIngredientInfos}
 */
var computePropsAndIngredientMemberRePrice = function computePropsAndIngredientMemberRePrice(dish, discountValue, discountType) {
  var dishPropertyTypeInfos = dish.dishPropertyTypeInfos,
      dishIngredientInfos = dish.dishIngredientInfos;

  var res = { dishPropertyTypeInfos: dishPropertyTypeInfos, dishIngredientInfos: dishIngredientInfos };
  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
      res.dishPropertyTypeInfos = dishPropertyTypeInfos.map(function (prop) {
        var properties = prop.properties;

        var newProperties = properties.map(function (item) {
          var _item$reprice = item.reprice,
              reprice = _item$reprice === undefined ? 0 : _item$reprice;

          return (0, _assign2.default)({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
        });
        return (0, _assign2.default)({}, prop, { properties: newProperties });
      });
    }

    if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
      res.dishIngredientInfos = dishIngredientInfos.map(function (ingredient) {
        var _ingredient$reprice = ingredient.reprice,
            reprice = _ingredient$reprice === undefined ? 0 : _ingredient$reprice;

        return (0, _assign2.default)({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
      });
    }
  }

  return res;
};

exports.computePropsAndIngredientMemberRePrice = computePropsAndIngredientMemberRePrice;

/**
 * 计算order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @param {*} ableAddPriceDiscount 是否开启加价折扣
 * @return order
 */
var computeOrderMemberPrice = function computeOrderMemberPrice(dish, discountValue, discountType) {
  var ableAddPriceDiscount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var order = dish.order;

  if (typeof order === 'number') return order;

  if (Array.isArray(order)) {
    var newOrder = order.map(function (o) {
      var dishPropertyTypeInfos = o.dishPropertyTypeInfos,
          dishIngredientInfos = o.dishIngredientInfos;
      // 只有开启折扣或者统一折扣 && 开启加价折扣 -> 口味做法才能打折

      if ((discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) && ableAddPriceDiscount) {
        if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
          dishPropertyTypeInfos = dishPropertyTypeInfos.map(function (prop) {
            var properties = prop.properties;

            var newProperties = properties.map(function (item) {
              var _item$reprice2 = item.reprice,
                  reprice = _item$reprice2 === undefined ? 0 : _item$reprice2;

              return (0, _assign2.default)({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
            });
            return (0, _assign2.default)({}, prop, { properties: newProperties });
          });
        }

        if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
          dishIngredientInfos = dishIngredientInfos.map(function (ingredient) {
            var _ingredient$reprice2 = ingredient.reprice,
                reprice = _ingredient$reprice2 === undefined ? 0 : _ingredient$reprice2;

            return (0, _assign2.default)({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
          });
        }
      }

      return (0, _extends3.default)({}, o, {
        dishPropertyTypeInfos: dishPropertyTypeInfos,
        dishIngredientInfos: dishIngredientInfos
      });
    });
    return newOrder;
  }

  return dish.order;
};
exports.computeOrderMemberPrice = computeOrderMemberPrice;

/**
 * 计算group 中 order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @param {*} ableAddPriceDiscount 是否开启加价折扣
 * @return order
 */
var computeGroupOrderMemberPrice = function computeGroupOrderMemberPrice(dish, discountValue, discountType) {
  var ableAddPriceDiscount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var order = dish.order,
      isMember = dish.isMember;
  // 只有折扣和统一折扣需要全部设置会员价  固定价只有group套餐外层memberPrice才需要修改，对内部子菜无影响

  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    var newOrder = order.map(function (o) {
      var count = o.count,
          _o$groups = o.groups,
          groups = _o$groups === undefined ? [] : _o$groups;

      var newGroups = groups.map(function (group) {
        var _group$childInfos = group.childInfos,
            childInfos = _group$childInfos === undefined ? [] : _group$childInfos;

        var newChildInfos = childInfos.map(function (child) {
          return (0, _extends3.default)({}, child, {
            // memberMarketPrice: getDishMemberPrice({ isMember, ...child }, discountValue, discountType),
            // memberMarketPrice: getValueForDiscount(child.marketPrice, discountValue),
            memberMarketPrice: ableAddPriceDiscount ? getValueForDiscount(child.marketPrice, discountValue) : child.marketPrice,
            order: computeOrderMemberPrice((0, _extends3.default)({ isMember: isMember }, child), discountValue, discountType, ableAddPriceDiscount)
          });
        });
        return (0, _extends3.default)({}, group, {
          childInfos: newChildInfos
        });
      });

      return (0, _extends3.default)({}, o, {
        groups: newGroups
      });
    });

    return newOrder;
  }
  return order;
};
exports.computeGroupOrderMemberPrice = computeGroupOrderMemberPrice;

/**
 * 计算order中的属性、配料等的会员价
 * @param {*} dish 菜品信息
 * @param {*} discountValue 会员价折扣值
 * @param {*} discountType  会员价折扣类型（1-折扣，2-固定价）
 * @return {dishPropertyTypeInfos, dishIngredientInfos}
 */
var computeOrderPropsAndIngredientMemberRePrice = function computeOrderPropsAndIngredientMemberRePrice(dish, discountValue, discountType) {
  var dishPropertyTypeInfos = dish.dishPropertyTypeInfos,
      dishIngredientInfos = dish.dishIngredientInfos;

  var res = { dishPropertyTypeInfos: dishPropertyTypeInfos, dishIngredientInfos: dishIngredientInfos };
  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
      res.dishPropertyTypeInfos = dishPropertyTypeInfos.map(function (prop) {
        var properties = prop.properties;

        var newProperties = properties.map(function (item) {
          var _item$reprice3 = item.reprice,
              reprice = _item$reprice3 === undefined ? 0 : _item$reprice3;

          return (0, _assign2.default)({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
        });
        return (0, _assign2.default)({}, prop, { properties: newProperties });
      });
    }

    if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
      res.dishIngredientInfos = dishIngredientInfos.map(function (ingredient) {
        var _ingredient$reprice3 = ingredient.reprice,
            reprice = _ingredient$reprice3 === undefined ? 0 : _ingredient$reprice3;

        return (0, _assign2.default)({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
      });
    }
  }

  return res;
};

exports.computeOrderPropsAndIngredientMemberRePrice = computeOrderPropsAndIngredientMemberRePrice;

/**
 * 计算属性、配料等的会员价(套餐groups)
 * 各个子菜和子菜的口味做法 会员价
 * @param {*} groups
 * @param {*} discountValue
 * @param {*} discountType
 */
var computeMemberRePriceByGroups = function computeMemberRePriceByGroups(groups, discountValue, discountType) {
  var result = groups;
  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    result = groups.flatMap(function (group) {
      var childInfos = group.childInfos;

      if (Array.isArray(childInfos)) {
        var newChildInfos = childInfos.flatMap(function (child) {
          var marketPrice = child.marketPrice;

          var res = computePropsAndIngredientMemberRePrice(child, discountValue, discountType);
          res.memberMarketPrice = getValueForDiscount(marketPrice, discountValue);
          return (0, _assign2.default)({}, child, res);
        });
        return (0, _assign2.default)({}, group, { childInfos: newChildInfos });
      }
      return group;
    });
  }
  return result;
};

exports.computeMemberRePriceByGroups = computeMemberRePriceByGroups;

var getTotalMemberPriceBySingle = function getTotalMemberPriceBySingle(dish) {
  if (_seamlessImmutable2.default.isImmutable(dish)) {
    dish = _seamlessImmutable2.default.asMutable(dish, { deep: true });
  }
  var _dish = dish,
      order = _dish.order,
      saleType = _dish.saleType,
      memberMarketPrice = _dish.memberMarketPrice,
      isMember = _dish.isMember;

  var isWeightMode = saleType === 1; // 称重模式
  var memberPrice = memberMarketPrice !== undefined && memberMarketPrice !== null ? memberMarketPrice : getDishMemberPrice(dish);
  memberPrice = memberPrice === null ? dish.marketPrice : memberPrice;
  var totalPrice = 0;

  if (Array.isArray(order)) {
    var _order$reduce = order.reduce(function (priceAndNum, item) {
      var oldPrice = priceAndNum.price,
          oldNum = priceAndNum.num;
      var count = item.count,
          dishIngredientInfos = item.dishIngredientInfos,
          dishPropertyTypeInfos = item.dishPropertyTypeInfos;

      var diAmount = 0;
      var dpAmount = 0;
      if (Array.isArray(dishIngredientInfos)) {
        diAmount += dishIngredientInfos.reduce(function (ingredientPrice, ingredient) {
          var memberReprice = ingredient.memberReprice,
              reprice = ingredient.reprice,
              isChecked = ingredient.isChecked;

          var useMemberPrice = memberReprice !== undefined && memberReprice !== null;

          // return isChecked ? ingredientPrice + memberReprice : ingredientPrice;
          return isChecked ? ingredientPrice + (useMemberPrice ? memberReprice : reprice) : ingredientPrice;
        }, 0);
      }

      if (Array.isArray(dishPropertyTypeInfos)) {
        dishPropertyTypeInfos.forEach(function (propertyType) {
          var properties = propertyType.properties;

          if (Array.isArray(properties)) {
            dpAmount += properties.reduce(function (proPrice, pro) {
              var isChecked = pro.isChecked,
                  memberReprice = pro.memberReprice,
                  reprice = pro.reprice;

              var useMemberPrice = memberReprice !== undefined && memberReprice !== null;

              // return isChecked ? proPrice + memberReprice : proPrice;
              return isChecked ? proPrice + (useMemberPrice ? memberReprice : reprice) : proPrice;
            }, 0);
          }
        });
      }

      var changeAmount = isWeightMode ? dpAmount + diAmount : (dpAmount + diAmount) * count;
      return { price: oldPrice + changeAmount, num: count + oldNum };
    }, { price: 0, num: 0 }),
        price = _order$reduce.price,
        num = _order$reduce.num;

    totalPrice = memberPrice * num + price;
  } else if (!isNaN(order)) {
    totalPrice = memberPrice * order;
  }
  return +totalPrice.toFixed(2);
};

var getTotalMemberPriceByMulti = function getTotalMemberPriceByMulti(dish) {
  var order = dish.order,
      discountType = dish.discountType;

  var oneBasePrice = getDishMemberPrice(dish); // 单份菜品基价价格
  var allCount = 0; // order中总分数
  var discountTotal = 0; // 加价部分总和
  if (Array.isArray(order)) {
    order.forEach(function (orderItem) {
      var groups = orderItem.groups,
          count = orderItem.count;

      allCount += count;
      groups.forEach(function (group) {
        var childInfos = group.childInfos;

        childInfos.forEach(function (childInfo) {
          var marketPrice = childInfo.marketPrice,
              memberMarketPrice = childInfo.memberMarketPrice,
              childOrder = childInfo.order;

          var allChildOrder = Array.isArray(childOrder) ? childOrder.reduce(function (total, item) {
            return total + item.count;
          }, 0) : childOrder;
          var singlePrice = getTotalMemberPriceBySingle(childInfo);
          var basePrice = allChildOrder * (memberMarketPrice >= 0 ? memberMarketPrice : marketPrice);
          var childPrice = discountType === _const.MemberPrivTypes.REDUCE ? // (singlePrice + basePrice) :
          singlePrice // 修改会员价加价不折扣后不需要加basePrice
          : singlePrice;
          discountTotal += childPrice * count;
        });
      });
    });
  } else if (!isNaN(order)) {
    allCount = Number(order);
  }
  var allPrice = oneBasePrice * allCount + discountTotal;
  return +allPrice.toFixed(2);
};

/**
 * 获取菜品的会员价+口味做法会员价
 * 这个方法适用于已经将口味做法的会员价写入dish的菜品
 * memberRePrice
 * @param {*} dish
 */
var getTotalMemberPrice = function getTotalMemberPrice(dish) {
  var type = dish.type;

  var res = 0;
  if (type === 1) {
    res = getTotalMemberPriceByMulti(dish);
  } else {
    res = getTotalMemberPriceBySingle(dish);
  }

  return res;
};

exports.getTotalMemberPrice = getTotalMemberPrice;

/**
 * 根据dish 算出口味做法，配料以及套餐的会员价
 * @param {*} dish
 * @param {*} discountVal
 * @param {*} discountType
 */
var getPropAndIngredientMemberPrice = function getPropAndIngredientMemberPrice(dish, discountVal, discountType) {
  var groups = dish.groups;

  var result = computePropsAndIngredientMemberRePrice(dish, discountVal, discountType);
  var newGroups = groups;
  if (Array.isArray(groups)) {
    newGroups = computeMemberRePriceByGroups(groups, discountVal, discountType);
  }
  return {
    groups: newGroups,
    dishPropertyTypeInfos: result.dishPropertyTypeInfos,
    dishIngredientInfos: result.dishIngredientInfos
  };
};

exports.getPropAndIngredientMemberPrice = getPropAndIngredientMemberPrice;

/**
 * 获取菜品的会员价+口味做法会员价购物车所选菜品之和
 * memberRePrice
 * @param {*} dishs
 * @param {*} ableAddPriceDiscount
 */
exports.getMemberDishesPrice = function () {
  var dishes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ableAddPriceDiscount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var dishesPrice = dishes.reduce(function (all, cur) {
    var memberPriceStr = cur.isMember && cur.memberPrice !== null ? cur.memberPrice.toString() : null; // 消除memberPrice为0的影响
    // const isUseAddDiscount = cur.isMember && cur.isUserMember && memberPriceStr && ableAddPriceDiscount;
    // if (isUseAddDiscount) return all + getTotalMemberPrice(cur);
    // return all + getDishesPrice([cur], null, true);
    // return all + getDishesPrice([cur], null, cur.isMember);

    var useAddDiscount = (cur.discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT || cur.discountType === _const.MemberPrivTypes.DISCOUNT) && cur.isMember && cur.isUserMember && memberPriceStr && ableAddPriceDiscount;
    var useMemberPrice = cur.isMember && cur.isUserMember && memberPriceStr;
    if (useAddDiscount) {
      return all + getTotalMemberPrice(cur);
    } else if (!!useMemberPrice) {
      return all + getTotalMemberPrice(cur);
    }
    return all + getDishesPrice([cur], null, cur.isMember);
  }, 0);

  if (isFinite(dishesPrice) && Math.floor(dishesPrice) === dishesPrice) {
    return dishesPrice;
  }
  return parseFloat(dishesPrice.toFixed(2));
};

/**
 * 变价享受会员价。
 * 该方法主要是更改order
 * @param {*} order
 * @param {*} discountValue
 * @param {*} discountType
 */
var reConstructDishOrder = function reConstructDishOrder(order, discountValue, discountType) {
  var res = order;

  if (Array.isArray(order)) {
    if (_seamlessImmutable2.default.isImmutable(order)) {
      res = _seamlessImmutable2.default.asMutable(order, { deep: true });
    }
    res = res.map(function (orderItem) {
      var groups = orderItem.groups,
          dishIngredientInfos = orderItem.dishIngredientInfos,
          dishPropertyTypeInfos = orderItem.dishPropertyTypeInfos;

      var newOrderItem = (0, _extends3.default)({}, orderItem);
      if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
        if (Array.isArray(dishPropertyTypeInfos) && dishPropertyTypeInfos.length > 0) {
          newOrderItem.dishPropertyTypeInfos = dishPropertyTypeInfos.map(function (prop) {
            var properties = prop.properties;

            var newProperties = properties.map(function (item) {
              var _item$reprice4 = item.reprice,
                  reprice = _item$reprice4 === undefined ? 0 : _item$reprice4;

              return (0, _assign2.default)({}, item, { memberReprice: getValueForDiscount(reprice, discountValue) });
            });
            return (0, _assign2.default)({}, prop, { properties: newProperties });
          });
        }

        if (Array.isArray(dishIngredientInfos) && dishIngredientInfos.length > 0) {
          newOrderItem.dishIngredientInfos = dishIngredientInfos.map(function (ingredient) {
            var _ingredient$reprice4 = ingredient.reprice,
                reprice = _ingredient$reprice4 === undefined ? 0 : _ingredient$reprice4;

            return (0, _assign2.default)({}, ingredient, { memberReprice: getValueForDiscount(reprice, discountValue) });
          });
        }

        if (Array.isArray(groups)) {
          newOrderItem.groups = groups.map(function (group) {
            var childInfos = group.childInfos;

            var newChildInfos = Array.isArray(childInfos) ? childInfos.map(function (child) {
              var subOrder = child.order,
                  marketPrice = child.marketPrice;
              // const memberMarketPrice = getValueForDiscount(marketPrice, discountValue) || marketPrice || 0;

              var memberMarketPrice = getValueForDiscount(marketPrice, discountValue) || 0;
              return (0, _extends3.default)({}, child, {
                memberMarketPrice: memberMarketPrice,
                order: reConstructDishOrder(subOrder, discountValue, discountType)
              });
            }) : childInfos;

            return (0, _extends3.default)({}, group, { childInfos: newChildInfos });
          });
        }
      }

      return newOrderItem;
    });
  }
  return res;
};

exports.reConstructDishOrder = reConstructDishOrder;

/**
 * 将菜品信息中的会员价 写入正价，用于计算
 * @param {*} dish
 */
var covertMemberPriceInDish = function covertMemberPriceInDish(dish) {
  var order = dish.order,
      memberMarketPrice = dish.memberMarketPrice,
      discountType = dish.discountType,
      isMember = dish.isMember;

  var newMarketPrice = memberMarketPrice !== null && memberMarketPrice !== undefined ? memberMarketPrice : getDishMemberPrice((0, _extends3.default)({ isMember: isMember, discountType: discountType }, dish));

  var newOrder = order;
  if (Array.isArray(order)) {
    newOrder = order.map(function (orderItem) {
      var result = (0, _extends3.default)({}, orderItem);
      var groups = orderItem.groups,
          dishIngredientInfos = orderItem.dishIngredientInfos,
          dishPropertyTypeInfos = orderItem.dishPropertyTypeInfos;

      var newGroups = groups;
      if (Array.isArray(groups) && groups.length > 0) {
        newGroups = groups.map(function (group) {
          var childInfos = group.childInfos;

          var newChildInfos = childInfos.map(function (child) {
            // return covertMemberPriceInDish(child);
            if (discountType === _const.MemberPrivTypes.REDUCE) {
              // 2 套餐中的菜品不受整个套餐立减的影响
              return covertMemberPriceInDish((0, _extends3.default)({ memberMarketPrice: child.marketPrice }, child));
            }
            return covertMemberPriceInDish((0, _extends3.default)({ isMember: isMember, discountType: discountType }, child));
          });

          return (0, _extends3.default)({}, group, {
            childInfos: newChildInfos
          });
        });

        result.groups = newGroups;
      } else {
        if (Array.isArray(dishIngredientInfos)) {
          var diAry = dishIngredientInfos.map(function (di) {
            var memberReprice = di.memberReprice,
                reprice = di.reprice;
            // return { ...di, reprice: memberReprice || reprice };

            return (0, _extends3.default)({}, di, { reprice: memberReprice >= 0 ? memberReprice : reprice }); // 消除memberReprice为0的影响
          });
          result.dishIngredientInfos = diAry;
        }

        if (Array.isArray(dishPropertyTypeInfos)) {
          var dpAry = dishPropertyTypeInfos.map(function (dp) {
            var properties = dp.properties;

            var r = (0, _extends3.default)({}, dp);
            if (Array.isArray(properties)) {
              var newProperties = properties.map(function (prop) {
                var memberReprice = prop.memberReprice,
                    reprice = prop.reprice;
                // return { ...prop, reprice: memberReprice || reprice };

                return (0, _extends3.default)({}, prop, { reprice: memberReprice >= 0 ? memberReprice : reprice }); // 消除memberReprice为0的影响
              });
              r.properties = newProperties;
            }
            return r;
          });
          result.dishPropertyTypeInfos = dpAry;
        }
      }

      return result;
    });
  }
  return (0, _extends3.default)({}, dish, {
    marketPrice: newMarketPrice,
    order: newOrder
  });
};

exports.covertMemberPriceInDish = covertMemberPriceInDish;

// 获取必点菜的最小数量以及其提示语
var getMustOrderMinNum = function getMustOrderMinNum(_ref4) {
  var strategyType = _ref4.strategyType,
      strategyValue = _ref4.strategyValue,
      mustSelect = _ref4.mustSelect,
      dishIncreaseUnit = _ref4.dishIncreaseUnit,
      clearStatus = _ref4.clearStatus;
  var selfChooseCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  // 加菜模式就不用开台必点的属性了
  var orderId = getUrlParam('orderId');
  var type = getUrlParam('type');
  var formal = (0, _commonHelper.isFormalMeal)(Number(sessionStorage.getItem('diningForm'))) && type !== 'WM';

  if (orderId || !formal) {
    return {
      minimum: 0,
      msg: {}
    };
  }

  // 必点菜且未估清的状态
  var minimum = mustSelect && !clearStatus ? strategyType === 1 ? Math.max(dishIncreaseUnit, strategyValue) : strategyType === 2 ? Math.max(dishIncreaseUnit, strategyValue) : strategyType === 3 ? selfChooseCount : 0 : 0;
  var minimumMsg = strategyType === 3 && minimum ? (0, _helper.formatMessage)(_dishMenu2.default.selfChooseCannotLess, { value: minimum }) : (0, _helper.formatMessage)(_dishMenu2.default.mustOrderCannotLess, { value: minimum });
  var msg = mustSelect && !clearStatus ? {
    minimumMsg: minimumMsg
  } : null;

  return {
    minimum: minimum,
    msg: msg
  };
};

exports.getMustOrderMinNum = getMustOrderMinNum;

// 设置菜品列表的必点菜属性
var setDishListMustOrderProps = function setDishListMustOrderProps() {
  var dishList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var mustOrderDishList = arguments[1];
  return dishList.map(function (item) {
    var _ref5 = mustOrderDishList.find(function (mustItem) {
      return mustItem.id === item.id;
    }) || {},
        _ref5$mustSelect = _ref5.mustSelect,
        mustSelect = _ref5$mustSelect === undefined ? false : _ref5$mustSelect,
        strategyType = _ref5.strategyType,
        strategyValue = _ref5.strategyValue;

    return (0, _extends3.default)({}, item, {
      mustSelect: mustSelect,
      strategyType: strategyType,
      strategyValue: strategyValue
    });
  });
};

exports.setDishListMustOrderProps = setDishListMustOrderProps;

// 设置协同购物车过来的用户的菜品列表的必点菜属性
var setUserOrderedDishListMustOrderProps = function setUserOrderedDishListMustOrderProps() {
  var userOrderedDishList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var mustOrderDishList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return userOrderedDishList.map(function (_ref6) {
    var _ref6$dishList = _ref6.dishList,
        dishList = _ref6$dishList === undefined ? [] : _ref6$dishList,
        rest = (0, _objectWithoutProperties3.default)(_ref6, ['dishList']);
    return (0, _extends3.default)({
      dishList: setDishListMustOrderProps(dishList, mustOrderDishList)
    }, rest);
  });
};

exports.setUserOrderedDishListMustOrderProps = setUserOrderedDishListMustOrderProps;

// 是否叠加，算出可以获赠多少份商品
var getSuperimpose = function getSuperimpose(benefit, dishes) {
  var stackRule = benefit.stackRule,
      matched = benefit.matched,
      marketRuleDtos = benefit.marketRuleDtos;

  var superimpose = 0;
  if (stackRule && matched && marketRuleDtos && marketRuleDtos[0] && marketRuleDtos[0].policySubjectId === 12) {
    var _marketRuleDtos$ = marketRuleDtos[0],
        ruleSubjectId = _marketRuleDtos$.ruleSubjectId,
        policyValue1 = _marketRuleDtos$.policyValue1,
        logicValue = _marketRuleDtos$.logicValue;

    // 满量

    if (ruleSubjectId === 11) {
      superimpose = Math.floor(countDishesNumber(dishes) / logicValue) * policyValue1;
    }
    // 满额
    if (ruleSubjectId === 12) {
      superimpose = Math.floor(getDishesBasePrice(dishes) / logicValue) * policyValue1;
    }
  }

  return superimpose;
};

/**
 * 满赠 把活动商品转为普通商品的数据格式
 * @param {*} dish
 */
var turnpolicyDishesToDishes = function turnpolicyDishesToDishes(policyDishes) {
  var dishes = policyDishes.reduce(function (list, item) {
    var dishType = item.dishType,
        midDishes = item.midDishes;

    return list.concat(dishType === 1 ? item : midDishes);
  }, []).map(function (dish) {
    return (0, _extends3.default)({}, dish, {
      residueTotal: dish.saleableNum,
      name: dish.dishName,
      smallImgUrl: dish.icon,
      marketPrice: dish.price,
      brandDishId: dish.dishId,
      dishId: dish.dishShopId // 后端传值混乱
    });
  });
  return dishes;
};
exports.turnpolicyDishesToDishes = turnpolicyDishesToDishes;

/**
 * 满赠 生成需要被默认选上的赠品份数
 * @param {*} dish
 * @param {*} limit 最多选几分
 */

var selectDefaultGiveDish = function selectDefaultGiveDish(benefitDishe) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var dish = JSON.parse((0, _stringify2.default)(benefitDishe));
  var isSingle = isSingleDishWithoutProps(benefitDishe);
  var count = Number(limit);
  var order = null;
  if (isSingle) {
    order = count;
  } else {
    order = [{
      count: count,
      dishIngredientInfos: dish.dishIngredientInfos,
      dishPropertyTypeInfos: dish.dishPropertyTypeInfos
    }];
  }
  dish = (0, _extends3.default)({}, dish, {
    count: count,
    order: order
  });
  return dish;
};
exports.selectDefaultGiveDish = selectDefaultGiveDish;

/**
 * 满赠 默认选中赠品如果有必选做法 则默认选中第一个
 * @param {*} dish
 */
var selectFirstIngredient = function selectFirstIngredient(eslectedDish) {
  var dish = JSON.parse((0, _stringify2.default)(eslectedDish));
  var _dish$dishPropertyTyp = dish.dishPropertyTypeInfos,
      dishPropertyTypeInfos = _dish$dishPropertyTyp === undefined ? [] : _dish$dishPropertyTyp;

  dishPropertyTypeInfos.forEach(function (item) {
    var _item$isMandatory = item.isMandatory,
        isMandatory = _item$isMandatory === undefined ? 0 : _item$isMandatory,
        _item$properties = item.properties,
        properties = _item$properties === undefined ? [] : _item$properties;

    var checkedProperties = properties.filter(function (p) {
      return p.isChecked;
    });
    // 必选 && 没有默认 则默认选中第一个
    if (isMandatory === 1 && !checkedProperties.length) {
      properties[0].isChecked = true;
    }
  });
  return dish;
};

/**
 * 满赠 默认选中赠品
 * @param {*} state
 * @param {*} FULL_PROMOTIONS 满赠
 */
var selectDefaultGiveDishes = function selectDefaultGiveDishes(state) {
  var FULL_PROMOTIONS = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fullPromotions';

  try {
    var _state$allBenefits = state.allBenefits,
        allBenefits = _state$allBenefits === undefined ? {} : _state$allBenefits,
        divideDishList = state.divideDishes;


    var list = allBenefits[FULL_PROMOTIONS];
    var fullPromitionList = JSON.parse((0, _stringify2.default)(list));
    fullPromitionList.forEach(function (currentBenefit) {
      var matched = currentBenefit.matched,
          dishKeys = currentBenefit.dishKeys,
          benefitDishes = currentBenefit.benefitDishes;

      var _ref7 = currentBenefit.marketRuleDtos && currentBenefit.marketRuleDtos[0] || {},
          policyValue1 = _ref7.policyValue1,
          policyValue2 = _ref7.policyValue2,
          policySubjectId = _ref7.policySubjectId;
      // 满赠(policySubjectId 12为满赠) && 符合满赠条件 && 有菜品 && 赠品为空  -> 默认选中赠品


      if (policySubjectId === 12 && matched && dishKeys.length && !benefitDishes.length) {
        // 默认选中活动商品的第一个
        var policyDishes = currentBenefit.policyDishes && currentBenefit.policyDishes.length ? currentBenefit.policyDishes[0] : [];
        // 需要把活动商品转为普通商品的数据格式
        var dishes = turnpolicyDishesToDishes([policyDishes]);
        // 默认选中第一个赠送商品
        var benefitDishe = dishes.length ? dishes[0] : [];
        // console.log('---benefitDishe---', benefitDishe);
        // 如果做法有必选 则默认选中第一个必选做法
        benefitDishe = selectFirstIngredient(benefitDishe);
        // console.log('---默认选中第一个赠送商品 benefitDishe---', benefitDishe);
        var targetDishes = divideDishList.filter(function (dish) {
          return currentBenefit.dishKeys.indexOf(dish.key) > -1;
        });

        // 是否叠加的参数，算出可以获赠多少份商品 limit
        var superimpose = getSuperimpose(currentBenefit, targetDishes);
        // const { policyValue1, policyValue2, policySubjectId } = (currentBenefit.marketRuleDtos && currentBenefit.marketRuleDtos[0]) || {};
        var limit = superimpose || (policySubjectId === 12 ? policyValue1 : policyValue2);

        // 生成需要被默认选上的赠品
        benefitDishe = selectDefaultGiveDish(benefitDishe, limit);
        currentBenefit.benefitDishes = divideDishes([benefitDishe], 'benefit_dishes');
      }
    });
    return fullPromitionList;
  } catch (e) {
    console.warn('\u6EE1\u8D60 ' + e.message);
    return state.allBenefits[FULL_PROMOTIONS];
  }
};

exports.selectDefaultGiveDishes = selectDefaultGiveDishes;

/**
 * 再来一单 - 多规格菜品 order合并
 * @param {*} dish 后端再来一单烦恼会的dish
 */
var getAnthorOrder = function getAnthorOrder(dish) {
  var _dish$order4 = dish.order,
      order = _dish$order4 === undefined ? [] : _dish$order4,
      _dish$dishIngredientI = dish.dishIngredientInfos,
      dishIngredientInfos = _dish$dishIngredientI === undefined ? [] : _dish$dishIngredientI,
      _dish$dishPropertyTyp2 = dish.dishPropertyTypeInfos,
      dishPropertyTypeInfos = _dish$dishPropertyTyp2 === undefined ? [] : _dish$dishPropertyTyp2;

  var newOrder = order.reduce(function (all, cur) {
    var _cur$dishIngredientIn = cur.dishIngredientInfos,
        _dishIngredientInfos = _cur$dishIngredientIn === undefined ? [] : _cur$dishIngredientIn,
        _cur$dishPropertyType = cur.dishPropertyTypeInfos,
        _dishPropertyTypeInfos = _cur$dishPropertyType === undefined ? [] : _cur$dishPropertyType;

    var newIngredient = dishIngredientInfos.map(function (ing) {
      var _ing = _dishIngredientInfos.filter(function (d) {
        return d.id === ing.id;
      });
      if (_ing.length) {
        return (0, _extends3.default)({}, ing, _ing[0]);
      }
      return ing;
    });
    var newProperty = dishPropertyTypeInfos.map(function (pro) {
      var _pro = _dishPropertyTypeInfos.filter(function (d) {
        return d.id === pro.id;
      });
      if (_pro.length) {
        var _pro$properties = pro.properties,
            properties = _pro$properties === undefined ? [] : _pro$properties;

        var _pro$0$properties = _pro[0].properties,
            _properties = _pro$0$properties === undefined ? [] : _pro$0$properties;

        var newproperties = properties.map(function (p) {
          var _p = _properties.filter(function (d) {
            return d.id === p.id;
          });
          if (_p.length) {
            return (0, _extends3.default)({}, p, _p[0]);
          }
          return p;
        });
        return (0, _extends3.default)({}, pro, {
          properties: newproperties
        });
      }
      return pro;
    });
    return all.concat((0, _extends3.default)({}, cur, { dishIngredientInfos: newIngredient, dishPropertyTypeInfos: newProperty }));
  }, []);
  return newOrder;
};
exports.getAnthorOrder = getAnthorOrder;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(150);
var global = __webpack_require__(4);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(34);
var TO_STRING_TAG = __webpack_require__(5)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(17).f;
var has = __webpack_require__(24);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import * as Sentry from '@sentry/browser';

var FormattedMessage = function (_React$Component) {
  (0, _inherits3.default)(FormattedMessage, _React$Component);

  function FormattedMessage(props) {
    (0, _classCallCheck3.default)(this, FormattedMessage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FormattedMessage.__proto__ || (0, _getPrototypeOf2.default)(FormattedMessage)).call(this, props));

    _this.state = {
      error: false
    };
    return _this;
  }

  // eslint-disable-next-line camelcase


  (0, _createClass3.default)(FormattedMessage, [{
    key: 'unstable_handleError',
    value: function unstable_handleError(e) {
      this.setState({ error: true });
      // Sentry.captureException(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var error = this.state.error;
      var _props$backup = this.props.backup,
          backup = _props$backup === undefined ? '' : _props$backup;

      return error ? _react2.default.createElement(
        'span',
        null,
        backup
      ) : _react2.default.createElement(_reactIntl.FormattedMessage, this.props);
    }
  }]);
  return FormattedMessage;
}(_react2.default.Component);

exports.default = FormattedMessage;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(36);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(338);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(54);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);
var document = __webpack_require__(4).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(20);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(58)('keys');
var uid = __webpack_require__(45);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var global = __webpack_require__(4);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(38) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(37);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(148);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(156);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(12);
var dPs = __webpack_require__(153);
var enumBugKeys = __webpack_require__(59);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(55)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(89).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(60);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(34);
module.exports = __webpack_require__(1).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(44);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var core = __webpack_require__(1);
var LIBRARY = __webpack_require__(38);
var wksExt = __webpack_require__(66);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(199)();
var hasProto = __webpack_require__(201)();

var getProto = Object.getPrototypeOf || (
	hasProto
		? function (x) { return x.__proto__; } // eslint-disable-line no-proto
		: null
);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(69);
var hasOwn = __webpack_require__(203);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(202);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(341);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(339);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  urlLostInfo: {
    id: 'urlLostInfo',
    defaultMessage: '资源标识符缺少相关信息'
  },
  merchant: {
    id: 'merchant',
    defaultMessage: '商户'
  },
  allDay: {
    id: 'allDay',
    defaultMessage: '全天'
  },
  vipPrice: {
    id: 'vipPrice',
    defaultMessage: '会员价'
  },
  vip: {
    id: 'vip',
    defaultMessage: '会员'
  },
  notVip: {
    id: 'notVip',
    defaultMessage: '非会员'
  },
  noBenefit: {
    id: 'noBenefit',
    defaultMessage: '不享受优惠'
  },
  notHaveBenefit: {
    id: 'notHaveBenefit',
    defaultMessage: '享受折扣菜品优惠'
  },
  fullMoneyRule: {
    id: 'fullMoneyRule',
    defaultMessage: ' 满{symbol}{dishNum}{ruleName}'
  },
  fullDishNumRuleEvery: {
    id: 'fullDishNumRuleEvery',
    defaultMessage: '{symbol}每'
  },
  fullDishNumRule: {
    id: 'fullDishNumRule',
    defaultMessage: '{symbol}满{dishNum}份{ruleName}'
  },
  perOrderLimitNum: {
    id: 'perOrderLimitNum',
    defaultMessage: '{symbol}每单限{dishNum}份'
  },
  limitedVIP: {
    id: 'limitedVIP',
    defaultMessage: '仅限会员{symbol}'
  },
  limitedNotVIP: {
    id: 'limitedNotVIP',
    defaultMessage: '仅限非会员{symbol}'
  },
  allGoods: {
    id: 'allGoods',
    defaultMessage: '全部商品'
  },
  someGoods: {
    id: 'someGoods',
    defaultMessage: '部分商品'
  },
  conditionEnable: {
    id: 'conditionEnable',
    defaultMessage: '{condition}可用'
  },
  onLimitMax: {
    id: 'tooltip.onLimitMax',
    defaultMessage: '已达到添加上限'
  },
  historySearch: {
    id: 'search.historySearch',
    defaultMessage: '历史搜索'
  },
  clearSearch: {
    id: 'search.clearSearch',
    defaultMessage: '清空记录'
  },
  noSearchData: {
    id: 'search.noSearchData',
    defaultMessage: '哎呀  没有相关搜索结果'
  },
  searchPlacehodler: {
    id: 'search.searchPlacehodler',
    defaultMessage: '搜索店内商品'
  },
  noSearchResult: {
    id: 'search.noSearchResult',
    defaultMessage: '没有搜索结果'
  },
  discount: {
    id: 'coupon.discount',
    defaultMessage: '折'
  },
  getCoupon: {
    id: 'coupon.getCoupon',
    defaultMessage: '领券'
  },
  haveFinished: {
    id: 'coupon.haveFinished',
    defaultMessage: '已领完'
  },
  viewPackage: {
    id: 'coupon.viewPackage',
    defaultMessage: '查看礼包'
  },
  storePackage: {
    id: 'coupon.storePackage',
    defaultMessage: '进店礼包'
  },
  validOnTheDay: {
    id: 'coupon.validOnTheDay',
    defaultMessage: '当日有效'
  },
  validityPeriod: {
    id: 'coupon.validityPeriod',
    defaultMessage: '有效期'
  },
  receiveSuccess: {
    id: 'coupon.receiveSuccess',
    defaultMessage: '领取成功'
  },
  fullValueCanUse: {
    id: 'coupon.fullValueCanUse',
    defaultMessage: '消费满{currency}{fullValue}可用'
  },
  limitValueCanUse: {
    id: 'coupon.limitValueCanUse',
    defaultMessage: '满{currency}{limitValue}可用'
  },
  useUnlimited: {
    id: 'coupon.useUnlimited',
    defaultMessage: '使用无门槛'
  },
  viewCoupon: {
    id: 'coupon.viewCoupon',
    defaultMessage: '查看优惠券'
  },
  pickCoupon: {
    id: 'coupon.pickCoupon',
    defaultMessage: '立刻领取'
  },
  viewAndPickCoupon: {
    id: 'coupon.viewAndPickCoupon',
    defaultMessage: '查看领券'
  },
  viewReceivedCoupon: {
    id: 'coupon.viewReceivedCoupon',
    defaultMessage: '查看已领券'
  },
  goToLogin: {
    id: 'goToLogin',
    defaultMessage: '去登录'
  },
  goToLoginDesc: {
    id: 'goToLoginDesc',
    defaultMessage: '尚未登录，登录后立享会员权益！'
  },
  mustPayWithRestoreDesc: {
    id: 'mustPayWithRestoreDesc',
    defaultMessage: '您已选择会员价，只能使用储值支付'
  },
  isCancelDishCoupon: {
    id: 'isCancelDishCoupon',
    defaultMessage: '当前选择优惠与商品优惠不能通用，是否取消商品优惠，选择优惠券'
  },
  canUseCoupon: {
    id: 'canUseCoupon',
    defaultMessage: '可用优惠券'
  },
  notCanUseCoupon: {
    id: 'notCanUseCoupon',
    defaultMessage: '不可用优惠券'
  },
  canUseDiscount: {
    id: 'canUseDiscount',
    defaultMessage: '可用卡'
  },
  notCanUseDiscount: {
    id: 'notCanUseDiscount',
    defaultMessage: '不可用卡'
  },
  paid: {
    id: 'paid',
    defaultMessage: '已支付'
  },
  discounted: {
    id: 'discounted',
    defaultMessage: '已优惠'
  },
  invoiceTitle: {
    id: 'invoiceTitle',
    defaultMessage: '发票抬头'
  },
  taxpayerId: {
    id: 'taxpayerId',
    defaultMessage: '纳税人识别号'
  },
  optional: {
    id: 'optional',
    defaultMessage: '选填'
  },
  view: {
    id: 'view',
    defaultMessage: '查看'
  },
  allProducts: {
    id: 'allProducts',
    defaultMessage: '所有商品'
  },
  someProducts: {
    id: 'someProducts',
    defaultMessage: '部分商品'
  },
  someProductsNotHave: {
    id: 'someProductsNotHave',
    defaultMessage: '部分商品不'
  },
  friendlyReminder: {
    id: 'friendlyReminder',
    defaultMessage: '友情提示'
  },
  inputIndividualOrCompanyTitle: {
    id: 'placeholder.inputIndividualOrCompanyTitle',
    defaultMessage: '请输入个人或公司抬头'
  },
  inputTaxpayerId: {
    id: 'placeholder.inputTaxpayerId',
    defaultMessage: '请输入纳税人识别号'
  },
  inputNote: {
    id: 'placeholder.inputNote',
    defaultMessage: '输入备注'
  },
  mealOrder: {
    id: 'title.mealOrder',
    defaultMessage: '堂食点餐'
  },
  search: {
    id: 'title.search',
    defaultMessage: '搜索'
  },
  shopLogo: {
    id: 'alt.shopLogo',
    defaultMessage: '门店logo'
  },
  shopSwitch: {
    id: 'alt.shopSwitch',
    defaultMessage: '门店切换'
  },
  shopIcon: {
    id: 'alt.shopIcon',
    defaultMessage: '门店icon'
  },
  goToOrder: {
    id: 'goToOrder',
    defaultMessage: '继续点餐'
  },
  person: {
    id: 'person',
    defaultMessage: '人'
  },
  defaultSort: {
    id: 'defaultSort',
    defaultMessage: '默认分类'
  },
  monday: {
    id: 'monday',
    defaultMessage: '周一'
  },
  tuesday: {
    id: 'tuesday',
    defaultMessage: '周二'
  },
  wednesday: {
    id: 'wednesday',
    defaultMessage: '周三'
  },
  thursday: {
    id: 'thursday',
    defaultMessage: '周四'
  },
  friday: {
    id: 'friday',
    defaultMessage: '周五'
  },
  saturday: {
    id: 'saturday',
    defaultMessage: '周六'
  },
  sunday: {
    id: 'sunday',
    defaultMessage: '周天'
  },
  weekday: {
    id: 'weekday',
    defaultMessage: '工作日'
  },
  weekend: {
    id: 'weekend',
    defaultMessage: '周末'
  },
  to: {
    id: 'to',
    defaultMessage: '到'
  },
  back: {
    id: 'back',
    defaultMessage: '返回'
  },
  languageSwitch: {
    id: 'languageSwitch',
    defaultMessage: '切换语言'
  },
  microMart: {
    id: 'microMart',
    defaultMessage: '微商城'
  },
  onlyLeft: {
    id: 'onlyLeft',
    defaultMessage: '仅剩'
  },
  required: {
    id: 'required',
    defaultMessage: '必填'
  },
  couponExpirydate: {
    id: 'couponExpirydate',
    defaultMessage: '自领取{validDayNum}天内有效，当天不可用'
  },
  noAvailableCards: {
    id: 'noAvailableCards',
    defaultMessage: '暂无可用卡哦~'
  },
  enjoyDiscounts: {
    id: 'enjoyDiscounts',
    defaultMessage: '即刻购买可享整单最高<span>{discount}</span>折优惠'
  },
  unavailableCards: {
    id: 'unavailableCards',
    defaultMessage: '暂无不可用卡哦~'
  }
});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(116);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(76);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(176), __esModule: true };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(343);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(37);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(8);
var core = __webpack_require__(1);
var fails = __webpack_require__(31);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(15) && !__webpack_require__(31)(function () {
  return Object.defineProperty(__webpack_require__(55)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(24);
var toIObject = __webpack_require__(26);
var arrayIndexOf = __webpack_require__(129)(false);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestUrl = exports.post = exports.get = undefined;

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

__webpack_require__(72);

__webpack_require__(71);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _commonHelper = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * httpRequestService
 * @param url 请求的地址
 * @param options 请求的配置，比如，发送的数据和请求的方式
 * @param errorHandler 错误处理函数，可选参数，用于特殊的错误处理
 */
/**
 * http request helper
 * 抽象出了一层用于请求后端数据的 API
 * get 代表使用 get 方式请求
 * post 代表使用 post 方式请求
 * 统一进行了错误处理，在使用的时候只需要针对正确的数据进行处理
 * @usage
 *   get(url).then();
 *   post(url, params).then();
 */

var httpRequestService = function httpRequestService(url, errorHandler) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return fetch(url, options || _config2.default.requestOptions).then(function (res) {
    if (!res.ok) {
      console.error('获取数据失败，请重试');
      return {};
    }

    return res.json();
  }).catch(function (error) {
    if (errorHandler) {
      errorHandler();
    }
    console.error(error);
  });
};

var _get = function _get(url, errorHandler) {
  return httpRequestService(url, errorHandler);
};

exports.get = _get;
var _post = function _post(url, params, errorHandler) {
  var postOptions = (0, _assign2.default)({}, _config2.default.requestOptions, {
    method: 'POST',
    body: (0, _stringify2.default)(params || {})
  });

  return httpRequestService(url, errorHandler, postOptions);
};

// todo refactoring
exports.post = _post;
var getRequestUrl = exports.getRequestUrl = function getRequestUrl(url, params) {
  var requestUrl = url;
  var paramStr = (0, _commonHelper.formatObjToParamStr)(params);

  if (paramStr) {
    var separator = requestUrl.indexOf('?') === -1 ? '?' : '&';
    requestUrl += '' + separator + paramStr;
  }

  return requestUrl;
};

exports.default = {
  get: function get(url, params) {
    var requestUrl = getRequestUrl(url, params);

    return _get(requestUrl);
  },
  post: function post(url, params) {
    return _post(url, params);
  },
  goto: function goto(url, params) {
    var requestUrl = getRequestUrl(url, params);

    location.href = requestUrl;
  }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(38);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(88);
var hide = __webpack_require__(23);
var Iterators = __webpack_require__(34);
var $iterCreate = __webpack_require__(152);
var setToStringTag = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(112);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {



/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  navigatorExpandedTitle: {
    id: 'navigator.expandedTitle',
    defaultMessage: '收起'
  },
  navigatorCollapsedTitle: {
    id: 'navigator.collapsedTitle',
    defaultMessage: '快速导航'
  },
  navigatorOrderCenter: {
    id: 'navigator.orderCenter',
    defaultMessage: '订单中心'
  },
  navigatorMeCenter: {
    id: 'navigator.navigatorMeCenter',
    defaultMessage: '个人中心'
  },
  navigatorMemberCard: {
    id: 'navigator.memberCard',
    defaultMessage: '会员卡'
  },
  navigatorDishList: {
    id: 'navigator.dishList',
    defaultMessage: '菜单'
  },
  navigatorCommodityList: {
    id: 'navigator.commodityList',
    defaultMessage: '商品列表'
  },
  choseChildDish: {
    id: 'dish.choseChildDish',
    defaultMessage: '选子菜'
  },
  choseGroup: {
    id: 'dish.choseGroup',
    defaultMessage: '选择套餐'
  },
  addToGroup: {
    id: 'dish.addToGroup',
    defaultMessage: '加入套餐'
  },
  choseSpecification: {
    id: 'dish.choseSpecification',
    defaultMessage: '选规格'
  },
  soldout: {
    id: 'dish.soldout',
    defaultMessage: '已售罄'
  },
  monthlySales: {
    id: 'dish.monthlySales',
    defaultMessage: '月售'
  },
  addToShoppingCart: {
    id: 'dish.addToShoppingCart',
    defaultMessage: '加入购物车'
  },
  priceFrom: {
    id: 'dish.priceFrom',
    defaultMessage: '起'
  },
  picked: {
    id: 'dish.picked',
    defaultMessage: '已选'
  },
  atLeast: {
    id: 'dish.atLeast',
    defaultMessage: '必点n份数'
  },
  max: {
    id: 'dish.max',
    defaultMessage: '已达到添加上限'
  },
  registerGoToRegister: {
    id: 'register.goToRegister',
    defaultMessage: '去注册'
  },
  registerDescription: {
    id: 'register.description',
    defaultMessage: '注册会员享受更多福利哟'
  },
  chooseGroupDishCount: {
    id: 'dish.chooseGroupDishCount',
    defaultMessage: '请选择套餐份数'
  },
  mushDishCount: {
    id: 'dish.mushDishCount',
    defaultMessage: '{dishGroupName}/{replaceDishName}为必选菜, 必选{leastCellNum}份'
  },
  childDishOverMax: {
    id: 'dish.childDishOverMax',
    defaultMessage: '{dishGroupName}子菜份数超出可选范围'
  },
  childDishLessMin: {
    id: 'dish.childDishLessMin',
    defaultMessage: '{dishGroupName}未选择足够的子菜份数'
  },
  dishCount: {
    id: 'dish.dishCount',
    defaultMessage: '份'
  },
  mustChecked: {
    id: 'dish.mustChecked',
    defaultMessage: '选'
  },
  notChooseDish: {
    id: 'toast.notChooseDish',
    defaultMessage: '未选择菜品份数'
  },
  pleaseChooseDish: {
    id: 'toast.pleaseChooseDish',
    defaultMessage: '请选择份数'
  },
  chooseDeleteDish: {
    id: 'toast.chooseDeleteDish',
    defaultMessage: '请选择要删除的菜品'
  },
  keepLeastCellNum: {
    id: 'dish.keepLeastCellNum',
    defaultMessage: '此必选菜必须保留起卖份数{leastCellNum}份'
  },
  mustCheckedMinCount: {
    id: 'dish.mustCheckedMinCount',
    defaultMessage: '必点{minimum}'
  },
  notMoreMaxCount: {
    id: 'dish.notMoreMaxCount',
    defaultMessage: '最多选{maximum}份'
  },
  leastCellNum: {
    id: 'dish.leastCellNum',
    defaultMessage: '起卖份数为{leastCellNum}份'
  },
  chooseMinCount: {
    id: 'dish.chooseMinCount',
    defaultMessage: '至少选择{count}份'
  },
  chooseMaxCount: {
    id: 'dish.chooseMaxCount',
    defaultMessage: '最多选择{count}份'
  },
  confirmDelete: {
    id: 'dish.confirmDelete',
    defaultMessage: '确认删除'
  },
  justForVIP: {
    id: 'dish.justForVIP',
    defaultMessage: '专享'
  },
  discountLevel: {
    id: 'dish.discountLevel',
    defaultMessage: '{discountLevel}折优惠'
  },
  price: {
    id: 'dish.price',
    defaultMessage: '价'
  },
  memberPrice: {
    id: 'dish.memberPrice',
    defaultMessage: '会员价'
  },
  noDesc: {
    id: 'dish.noDesc',
    defaultMessage: '暂无'
  },
  goOnPick: {
    id: 'dish.goOnPick',
    defaultMessage: '继续选购'
  },
  descSubtitle: {
    id: 'dish.descSubtitle',
    defaultMessage: '商品介绍'
  },
  guessYouLove: {
    id: 'dish.guessYouLove',
    defaultMessage: '猜你喜欢'
  },
  changeView: {
    id: 'dish.changeView',
    defaultMessage: '换一批'
  },
  serviceBell: {
    id: 'dish.serviceBell',
    defaultMessage: '服务铃'
  },
  send: {
    id: 'dish.send',
    defaultMessage: '发送'
  },
  ignoreStep: {
    id: 'dish.ignoreStep',
    defaultMessage: '跳过'
  },
  loginBeforeOrder: {
    id: 'dish.loginBeforeOrder',
    defaultMessage: '登录后方可点菜下单噢~'
  },
  alreadyOrderedAndRedirecting: {
    id: 'dish.alreadyOrderedAndRedirecting',
    defaultMessage: '已经下单, 自动跳转中...'
  },
  ingredients: {
    id: 'dish.ingredients',
    defaultMessage: '配料'
  },
  inviteYouOrder: {
    id: 'dish.inviteYouOrder',
    defaultMessage: '小伙伴喊你一起点餐哦～'
  },
  scanTableQRCode: {
    id: 'dish.scanTableQRCode',
    defaultMessage: '扫桌台码'
  },
  dishEmpty: {
    id: 'dish.dishEmpty',
    defaultMessage: '购物车是空的'
  },
  must: {
    id: 'dish.must',
    defaultMessage: '必'
  },
  dishMenuGetVipPrice: {
    id: 'dishMenuGetVipPrice',
    defaultMessage: '会员价已享{discountValue}折'
  },
  mustOrder: {
    id: 'dish.mustOrder',
    defaultMessage: '开台必点'
  },
  selfChoose: {
    id: 'dish.selfChoose',
    defaultMessage: '开台自选'
  },
  addedToCart: {
    id: 'dish.addedToCart',
    defaultMessage: '已添加至购物车'
  },
  mustOrderCannotLess: {
    id: 'dish.mustOrderCannotLess',
    defaultMessage: '开台必点菜不可低于{value}份'
  },
  selfChooseModalTitle: {
    id: 'dish.selfChooseModalTitle',
    defaultMessage: '选择开台自选商品'
  },
  selfChooseModalCategoryTitle: {
    id: 'dish.selfChooseModalCategoryTitle',
    defaultMessage: '选择必选商品'
  },
  selfChooseModalNotSelect: {
    id: 'dish.selfChooseModalNotSelect',
    defaultMessage: '还未选择'
  },
  selfChooseLeastSelect: {
    id: 'dish.selfChooseLeastSelect',
    defaultMessage: '至少选择一份'
  },
  selfChooseModalFooter: {
    id: 'dish.selfChooseModalFooter',
    defaultMessage: '继续选购'
  },
  selfChooseCannotLess: {
    id: 'dish.selfChooseCannotLess',
    defaultMessage: '开台自选菜不可低于{value}份'
  }
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(23);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(4).document;
module.exports = document && document.documentElement;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(12);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(34);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(12);
var aFunction = __webpack_require__(44);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var invoke = __webpack_require__(162);
var html = __webpack_require__(89);
var cel = __webpack_require__(55);
var global = __webpack_require__(4);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(37)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(12);
var isObject = __webpack_require__(20);
var newPromiseCapability = __webpack_require__(65);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(83);
var hiddenKeys = __webpack_require__(59).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(42);
var createDesc = __webpack_require__(39);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(56);
var has = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(82);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(15) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(6);
var normalizeHeaderName = __webpack_require__(185);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(103);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(103);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var settle = __webpack_require__(186);
var buildURL = __webpack_require__(100);
var buildFullPath = __webpack_require__(188);
var parseHeaders = __webpack_require__(191);
var isURLSameOrigin = __webpack_require__(192);
var createError = __webpack_require__(104);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(193);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(187);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(70);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(210)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(217);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(240);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(24);
var toObject = __webpack_require__(33);
var IE_PROTO = __webpack_require__(57)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

exports.runInRootWhenMiniPrograme = runInRootWhenMiniPrograme;

var _commonHelper = __webpack_require__(3);

var _const = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wxminiProgramHelper = {
  _jssdkUrl: 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js',

  _init: function _init() {
    var _this = this;

    if (!this.isMiniProgramMode() || !this.isNewMiniprogram()) {
      return _promise2.default.reject(new Error('not in wxmini'));
    }

    if (this.inited) {
      return _promise2.default.resolve(window.wx);
    }

    return new _promise2.default(function (resolve, _reject) {
      var script = document.createElement('script');

      // other version js loaded;
      delete window.wx;
      delete window.jWeixin;

      script.onload = function () {
        _this.inited = true;
        resolve(window.wx);
      };

      script.src = _this._jssdkUrl;
      document.body.appendChild(script);
      script = null;
    });
  },
  isMiniProgramMode: function isMiniProgramMode() {
    return (0, _commonHelper.isWechatMiniProgramBrowser)();
  },
  isNewMiniprogram: function isNewMiniprogram() {
    return sessionStorage.getItem(_const.NEW_MINI_PROGRAM_NAME_KEY) === _const.NEW_MINI_PROGRAM_NAME_VALUE;
  },
  call: function call(method) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this._init().then(function (wx) {
      if (!wx || !wx.miniProgram) {
        throw new Error('wx jssdk unload');
      }

      var fn = wx.miniProgram[method];
      if (!fn) {
        throw new Error('miniProgram do not contains the method of ' + method);
      }

      return fn.apply(wx.miniProgram, args);
    }).catch(function (e) {
      console.warn(e.message);
    });
  },
  navigateTo: function navigateTo(url, params) {
    this.route('navigateTo', url, params);
  },
  redirectTo: function redirectTo(url, params) {
    this.route('redirectTo', url, params);
  },
  route: function route(method, url, params) {
    var nextUrl = url + '?' + (0, _commonHelper.formatObjToParamStr)(params);

    this.call(method, { url: nextUrl });
  }
};

function saveMidToCookie() {
  var _getUrlParams = (0, _commonHelper.getUrlParams)(),
      mid = _getUrlParams.mid,
      brandId = _getUrlParams.brandId;

  if (brandId) {
    sessionStorage.setItem('currentBrandId', brandId);
  }

  if (!mid || !brandId) {
    return;
  }

  (0, _commonHelper.setCookie)('mid_' + brandId, mid);
}

function saveMiniProgramName() {
  var params = (0, _commonHelper.getUrlParams)();
  var miniProgramName = params[_const.NEW_MINI_PROGRAM_NAME_KEY];

  if (miniProgramName) {
    sessionStorage.setItem(_const.NEW_MINI_PROGRAM_NAME_KEY, miniProgramName);
  }
}

function saveAliUserId() {
  var _getUrlParams2 = (0, _commonHelper.getUrlParams)(),
      userid = _getUrlParams2.userid;

  if (userid) {
    localStorage.setItem('userid', userid);
  }
}

function runInRootWhenMiniPrograme() {
  if ((0, _commonHelper.isAlipayMiniProgramBrowser)()) {
    // 将支付宝 userid存入localStorage
    saveAliUserId();
    saveMidToCookie();
    return;
  }
  if (!wxminiProgramHelper.isMiniProgramMode()) {
    return;
  }

  saveMidToCookie();
  saveMiniProgramName();
}

exports.default = wxminiProgramHelper;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(98);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(223);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(229), __esModule: true };

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  weixinBrowserError: {
    id: 'errorMessages.weixinBrowserError',
    defaultMessage: '请在微信、微信小程序或者支付宝浏览器中打开'
  },
  noTableError: {
    id: 'errorMessages.noTableError',
    defaultMessage: '非常抱歉，店里当前爆满，无可用桌台'
  },
  noTableUseError: {
    id: 'errorMessages.noTableUseError',
    defaultMessage: '没有可用桌台'
  },
  cantScanPlaceOrderError: {
    id: 'errorMessages.cantScanPlaceOrderError',
    defaultMessage: '商户配置错误, 无法扫码下单'
  },
  identifyQRCodeError: {
    id: 'errorMessages.identifyQRCodeError',
    defaultMessage: '无法识别该二维码'
  },
  operateFailError: {
    id: 'errorMessages.operateFailError',
    defaultMessage: '操作失败'
  },
  alipayConfigFailError: {
    id: 'errorMessages.alipayConfigFailError',
    defaultMessage: '支付宝配置失败...'
  },
  getQRCodeFailError: {
    id: 'errorMessages.getQRCodeFailError',
    defaultMessage: '获取二维码失效'
  },
  scanResultEmptyError: {
    id: 'errorMessages.scanResultEmptyError',
    defaultMessage: '扫码结果为空'
  },
  choosePlaceOrderError: {
    id: 'errorMseeage.choosePlaceOrderError',
    defaultMessage: '请选择需要的下单操作...'
  },
  goingServiceCardError: {
    id: 'errorMessage.goingServiceCardError',
    defaultMessage: '正在跳转到服务卡界面...'
  },
  pleaseHaveDinnerError: {
    id: 'errorMessage.pleaseHaveDinnerError',
    defaultMessage: '请点餐'
  },
  netWorkError: {
    id: 'errorMessage.netWorkError',
    defaultMessage: '网络出问题了...'
  },
  intoTableError: {
    id: 'errorMessage.intoTableError',
    defaultMessage: '进入桌台...'
  },
  alreadyPlaceOrderError: {
    id: 'errorMessage.alreadyPlaceOrderError',
    defaultMessage: '{user}已经下单, 自动跳转中...'
  },
  socketLinkError: {
    id: 'errorMessage.socketLinkError',
    defaultMessage: '协同点餐异常，请刷新页面'
  },
  noConfigServiceBellError: {
    id: 'errorMessage.noConfigServiceBellError',
    defaultMessage: '还没有配置服务噢...'
  },
  noBindTableError: {
    id: 'errorMessage.noBindTableError',
    defaultMessage: '未绑定桌台哦，小二会迷路呢'
  },
  waiterIsComingError: {
    id: 'errorMessage.waiterIsComingError',
    defaultMessage: '小二正在火速赶来的路上...'
  },
  chooseServiceError: {
    id: 'errorMessage.chooseServiceError',
    defaultMessage: '请选择服务'
  },
  collCartError: {
    id: 'errorMessage.collCartError',
    defaultMessage: '协同购物车错误'
  },
  orderIsInvalided: {
    id: 'errorMessage.orderIsInvalided',
    defaultMessage: '订单已作废，请重新下单'
  },
  orderIsRefused: {
    id: 'errorMessage.orderIsRefused',
    defaultMessage: '订单已拒绝，请重新下单'
  },
  orderIsCanceled: {
    id: 'errorMessage.orderIsCanceled',
    defaultMessage: '订单已取消，请重新下单'
  },
  unopenedOnlinePayment: {
    id: 'errorMessage.unopenedOnlinePayment',
    defaultMessage: '未开通线上支付无法结账'
  },
  completeTheInvoice: {
    id: 'errorMessage.completeTheInvoice',
    defaultMessage: '请把发票填写完整'
  },
  youAreInvoicing: {
    id: 'errorMessage.youAreInvoicing',
    defaultMessage: '别着急,正在开票中'
  },
  tasteScore: {
    id: 'errorMessage.tasteScore',
    defaultMessage: '请评价口味！'
  },
  serviceScore: {
    id: 'errorMessage.serviceScore',
    defaultMessage: '请评价服务！'
  },
  environmentScore: {
    id: 'errorMessage.environmentScore',
    defaultMessage: '请评价环境！'
  },
  commentSuccess: {
    id: 'errorMessage.commentSuccess',
    defaultMessage: '订单评价成功'
  },
  commentSuccessButNoCoupon: {
    id: 'errorMessage.commentSuccessButNoCoupon',
    defaultMessage: '订单评价成功，优惠券已赠完'
  },
  commentSuccessAndGetCoupon: {
    id: 'errorMessage.commentSuccessAndGetCoupon',
    defaultMessage: '订单评价成功，恭喜获得{sendCoupInfo}'
  },
  orderIsCommented: {
    id: 'errorMessage.orderIsCommented',
    defaultMessage: '该订单已评价'
  },
  orderIsNotSupportCommented: {
    id: 'errorMessage.orderIsNotSupportCommented',
    defaultMessage: '当前订单不支持评价'
  },
  commentAgainForNetwork: {
    id: 'errorMessage.commentAgainForNetwork',
    defaultMessage: '网络原因评价失败，请重新评价'
  },
  notMobileStore: {
    id: 'errorMessage.notMobileStore',
    defaultMessage: '当前门店未开通移动门店，请联系商户'
  },
  connectingCollCart: {
    id: 'loading.connectingCollCart',
    defaultMessage: '正在连接协同购物车...'
  },
  connecting: {
    id: 'loading.connecting',
    defaultMessage: '正在连接...'
  },
  beingInTheVoucher: {
    id: 'loading.beingInTheVoucher',
    defaultMessage: '正在领券中...'
  },
  onlyStockLeft: {
    id: 'errorMessage.onlyStockLeft',
    defaultMessage: '抱歉，库存仅剩{numTotal}'
  },
  enteredUpTo5digits: {
    id: 'errorMessage.enteredUpTo5digits',
    defaultMessage: '最多可输入5位数'
  },
  notLowerThanDishIncreaseUnit: {
    id: 'errorMessage.notLowerThanDishIncreaseUnit',
    defaultMessage: '不能低于起卖份数{dishIncreaseUnit}份'
  },
  dishChangeRule: {
    id: 'errorMessage.dishChangeRule',
    defaultMessage: '该商品起卖份数为{dishIncreaseUnit},增量为{stepNum},故修改份数为{dishChange}'
  },
  successGetCoupon: {
    id: 'errorMessage.successGetCoupon',
    defaultMessage: '成功领取优惠券'
  },
  failedGetCoupon: {
    id: 'errorMessage.failedGetCoupon',
    defaultMessage: '领取失败请重试'
  },
  onlyForDigital: {
    id: 'errorMessage.onlyForDigital',
    defaultMessage: '只能输入数字'
  },
  maxSupportUserNum: {
    id: 'errorMessage.maxSupportUserNum',
    defaultMessage: '最多支持{maximum}人'
  },
  minInputUserNum: {
    id: 'errorMessage.minInputUserNum',
    defaultMessage: '至少输入{minimum}人'
  },
  unknown: {
    id: 'errorMessage.unknown',
    defaultMessage: '未知'
  },
  netError: {
    id: 'errorMessage.netError',
    defaultMessage: '网络出错'
  },
  waiterWillCome: {
    id: 'callMessage.waiterWillCome',
    defaultMessage: '客官稍等，服务员马上就来'
  },
  sendFail: {
    id: 'errorMessage.sendFail',
    defaultMessage: '非常抱歉，发送失败了'
  },
  requestAPIFail: {
    id: 'errorMessage.requestAPIFail',
    defaultMessage: '请求接口失败'
  },
  tryAgainForGet: {
    id: 'errorMessage.tryAgainForGet',
    defaultMessage: '非常抱歉，领取失败，请重试'
  },
  cantCallTableQRCode: {
    id: 'errorMessage.cantCallTableQRCode',
    defaultMessage: '不能调起桌台扫码'
  },
  clearedCart: {
    id: 'toast.clearedCart',
    defaultMessage: '已清空购物车'
  },
  submittedOrder: {
    id: 'toast.submittedOrder',
    defaultMessage: '已提交本桌订单'
  },
  entringOrderDetailPage: {
    id: 'toast.entringOrderDetailPage',
    defaultMessage: '正在进入订单详情页...'
  },
  modifyNumOnCartPage: {
    id: 'toast.modifyNumOnCartPage',
    defaultMessage: '{invalidDishList}的数量有误，请在购物车界面修改商品数量'
  },
  networkFailTryRefresh: {
    id: 'errorMessage.networkFailTryRefresh',
    defaultMessage: '当前网络环境差，请刷新后重试'
  },
  phoneValidateError: {
    id: 'errorMessage.phoneValidate',
    defaultMessage: '请输入正确的手机号'
  },
  disconnected: {
    id: 'errorMessage.disconnected',
    defaultMessage: '连接已断开'
  },
  errorAndReconnect: {
    id: 'errorMessage.errorAndReconnect',
    defaultMessage: '连接异常, 正在重新连接...'
  }
});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActivityBenefitShared = undefined;

var _values = __webpack_require__(435);

var _values2 = _interopRequireDefault(_values);

var _toConsumableArray2 = __webpack_require__(75);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _from = __webpack_require__(76);

var _from2 = _interopRequireDefault(_from);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(74);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _changePurchaseCalculator = __webpack_require__(270);

var _orderSourceHelper = __webpack_require__(421);

var _index = __webpack_require__(426);

var _index2 = _interopRequireDefault(_index);

var _httpRequestHelper = __webpack_require__(84);

var _commonHelper = __webpack_require__(3);

var _const = __webpack_require__(14);

var _dishHelper = __webpack_require__(43);

var _helper = __webpack_require__(16);

var _order = __webpack_require__(249);

var _order2 = _interopRequireDefault(_order);

var _action4 = __webpack_require__(427);

var _action5 = _interopRequireDefault(_action4);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _address = __webpack_require__(423);

var _address2 = _interopRequireDefault(_address);

var _activate = __webpack_require__(420);

var _activate2 = _interopRequireDefault(_activate);

var _dinnerDetail = __webpack_require__(418);

var _dinnerDetail2 = _interopRequireDefault(_dinnerDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _find = __webpack_require__(411);
var Immutable = __webpack_require__(77);
var clonedeep = __webpack_require__(442);
var uniqBy = __webpack_require__(443);


var shopId = (0, _dishHelper.getUrlParam)('shopId');
var type = (0, _dishHelper.getUrlParam)('type');

var calcStageFee = function calcStageFee(price, stages) {
  if (!stages || !stages.length) {
    return 0;
  }

  var stage = stages.find(function (item) {
    return price >= item.startAmount && price < item.endAmount;
  });

  return stage ? stage.amount : 0;
};

/**
 * 判断一个对象是否为空
 */
exports.isEmptyObject = function (obj) {
  return (0, _keys2.default)(obj || {}).length === 0;
};

/**
 * 判断默认应该选中的配送时间
 */
var getDefaultSelectedDateTime = exports.getDefaultSelectedDateTime = function (timeTable, defaultSelectedDateTime, type) {
  var selectedDateTime = { date: '', time: '' };
  console.log('timeTable', timeTable);
  if (!timeTable) {
    return selectedDateTime;
  }

  console.log('defaultSelectedDateTime', defaultSelectedDateTime);
  if (defaultSelectedDateTime) {
    var times = timeTable[defaultSelectedDateTime.date];

    if (times && times.indexOf(defaultSelectedDateTime.time) !== -1) {
      return (0, _assign2.default)(selectedDateTime, defaultSelectedDateTime);
    }
  }

  var todayStr = _commonHelper.dateUtility.format(new Date());
  var defaultDate = '';

  for (var key in timeTable) {
    if (!timeTable.hasOwnProperty(key)) {
      continue;
    }

    var firstValue = type === 'ws' ? '' : timeTable[key] && timeTable[key][0];
    var isToday = todayStr === key;

    if (!defaultDate || isToday) {
      selectedDateTime.date = defaultDate = key;
      selectedDateTime.time = firstValue;
      if (isToday) {
        break;
      }
    }
  }

  return selectedDateTime;
};

/**
 * getDefaultWSTimeProps
 */
exports.getDefaultWSTimeProps = function (payload, type) {
  var _ref = payload || {},
      onlyPromptlyDelivery = _ref.onlyPromptlyDelivery,
      timeJson = _ref.timeJson,
      defaultSelectedDateTime = _ref.defaultSelectedDateTime;

  if (onlyPromptlyDelivery === _const.OnlyPromptlyDelivery.OPEN) {
    return { date: '', time: '尽快送达' };
  }
  return getDefaultSelectedDateTime(timeJson, defaultSelectedDateTime, type);
};

/**
 * serviceStatus
 */
exports.getMoreDishesUrl = function (serviceStatus) {
  var orderParam = serviceStatus.orderId ? '&orderId=' + serviceStatus.orderId : '';
  var tableParam = serviceStatus.tableId ? '&tableId=' + serviceStatus.tableId : '';
  var initializeUrl = type === 'TS' ? (0, _httpRequestHelper.getRequestUrl)(_config2.default.dishMenu4DinnerURL, {
    shopId: shopId,
    type: 'TS',
    addDishes: true
  }) : (0, _httpRequestHelper.getRequestUrl)(_config2.default.dishMenu4DinnerURL, { shopId: shopId, type: 'WM' });

  return !serviceStatus.tableId ? initializeUrl : '' + initializeUrl + tableParam + orderParam;
};

/**
 * 下单成功以后为后台设置一个callbackUrl
 */
exports.setCallbackUrl = function (id) {
  var callbackUrl = type === 'TS' ? 'http://' + location.host + '/order/orderallDetail' : 'http://' + location.host + '/order/takeOutDetail';
  var callbackUrlWithEncode = encodeURIComponent((0, _httpRequestHelper.getRequestUrl)(callbackUrl, { shopId: shopId, orderId: id }));

  sessionStorage.setItem('rurl_payDetaill', (0, _stringify2.default)(callbackUrlWithEncode));

  return callbackUrlWithEncode;
};

/**
 * 初始化时间选择器
 */
exports.initializeTimeTable = function (times) {
  if (!times || (typeof times === 'undefined' ? 'undefined' : (0, _typeof3.default)(times)) !== 'object') {
    return times;
  }

  var now = new Date();
  var todayTimes = times[_commonHelper.dateUtility.format(now)];

  if (!todayTimes || !todayTimes.length) {
    return times;
  }

  var firstItem = todayTimes[0];

  if (firstItem === '立即送餐') {
    todayTimes[0] = '尽快送达';
  }

  return times;
};

/**
 * 判断支付方式是否可用
 */
exports.isPaymentAvaliable = function (payment, diningForm, isPickupFromFrontDesk, sendAreaId, selfPayType, sendPayType, limit) {
  // 正餐先付仅供送餐到桌
  if ((0, _commonHelper.isFormalMeal)(diningForm)) {
    return sendPayType.indexOf(payment);
  }

  var tabActive = limit || JSON.parse(localStorage.basicListInfo || '{}').way || 'ws';

  if (type === 'WM') {
    if (tabActive === 'ws') {
      return sendPayType.indexOf(payment);
    }
    return selfPayType.indexOf(payment);
  }

  return isPickupFromFrontDesk ? selfPayType.indexOf(payment) : sendPayType.indexOf(payment);
};

/**
 * 微信卡券核销
 */
exports.handleWeixinCard = function (couponList, bool) {
  couponList.forEach(function (coupon) {
    if (coupon.weixinValue) {
      coupon.coupRuleBeanList = [];
      coupon.coupDishBeanList = [];
    }

    if (!coupon.coupRuleBeanList) {
      coupon.coupRuleBeanList = [];
    }

    if (!coupon.coupDishBeanList) {
      coupon.coupDishBeanList = [];
    }

    coupon.id = String(coupon.id);
  });

  return bool ? couponList : (couponList || []).filter(function (coupon) {
    return !coupon.weixinValue;
  });
};

/**
 * 判断支付方式是否应该checked
 */
exports.shouldPaymentAutoChecked = function (payment, diningForm, isPickupFromFrontDesk, sendAreaId, selfPayType, sendPayType, limit) {
  // 正餐先付，指定送餐到桌
  if ((0, _commonHelper.isFormalMeal)(diningForm)) {
    return selfPayType && sendPayType.indexOf(',') !== -1 ? payment === sendPayType.split(',')[0] : payment === sendPayType;
  }

  var tabActive = limit || JSON.parse(localStorage.basicListInfo || '{}').way || 'ws';

  if ((0, _dishHelper.getUrlParam)('type') === 'WM') {
    if (tabActive === 'ws') {
      return selfPayType && sendPayType.indexOf(',') !== -1 ? payment === sendPayType.split(',')[0] : payment === sendPayType;
    }
    return selfPayType && selfPayType.indexOf(',') !== -1 ? payment === selfPayType.split(',')[0] : payment === selfPayType;
  }

  if (isPickupFromFrontDesk) {
    return selfPayType && selfPayType.indexOf(',') !== -1 ? payment === selfPayType.split(',')[0] : payment === selfPayType;
  }

  return selfPayType && sendPayType.indexOf(',') !== -1 ? payment === sendPayType.split(',')[0] : payment === sendPayType;
};

/**
 * 获取线下支付方式在不通场景中的名字
 */
exports.getOfflinePaymentName = function (sendAreaId, sellType) {
  if (type === 'TS') {
    return '线下支付';
  }

  return sendAreaId === 0 && sellType === 'zt' ? (0, _helper.formatMessage)(_order2.default.orderOfflinePayment) : (0, _helper.formatMessage)(_order2.default.orderCashOnDelivery);
};

/**
 * 获取被选中的桌台信息
 */
exports.getSelectedTable = function (tableProps) {
  return {
    area: _find(tableProps.areas, { isChecked: true }),
    table: _find(tableProps.tables, { isChecked: true })
  };
};

/**
 * 判断前台自取是否应该自动选中
 */
exports.isPickUpAutoChecked = function (serviceProps) {
  return {
    name: '前台自取',
    isChecked: !!serviceProps && serviceProps.indexOf('totable') === -1,
    id: 'way-of-get-diner'
  };
};

/**
 * 初始化桌台信息
 */
exports.initializeAreaAdnTableProps = function (areaList) {
  var tableList = [];

  (areaList || []).forEach(function (item, index) {
    item.id = item.areaId;

    if (item.tables) {
      item.tables.forEach(function (table) {
        table.areaId = item.areaId;
      });
    }

    tableList = tableList.concat(item.tables || []);
  });

  if (!areaList || !tableList || !areaList.length || !tableList.length) {
    return {
      areaList: null,
      tableList: null,
      isEditable: false
    };
  }

  var tableId = (0, _dishHelper.getUrlParam)('tableId') || sessionStorage.getItem('tableId');

  if (!tableId) {
    tableList.forEach(function (table) {
      table.id = table.tableId;
    });

    return {
      areaList: areaList,
      tableList: tableList,
      isEditable: true
    };
  }

  tableList.forEach(function (table) {
    return table.synFlag === tableId ? (_find(areaList, { id: table.areaId }).isChecked = true, table.isChecked = true) : false;
  });

  if (_find(tableList, { isChecked: true }) !== undefined) {
    tableList.forEach(function (table) {
      table.id = table.tableId;
    });

    return {
      areaList: areaList,
      tableList: tableList,
      isEditable: false
    };
  }

  return {
    areaList: null,
    tableList: null,
    isEditable: true
  };
};

/**
 * 结算相关
 * 从localStorage中获取餐盒费
 */
var getDishBoxPrice = exports.getDishBoxPrice = function () {
  var dishBoxPrice = localStorage.getItem('dishBoxPrice');

  if (type === 'TS' || !dishBoxPrice || dishBoxPrice === 0) {
    return 0;
  }

  return parseFloat(dishBoxPrice);
};

/**
 * 计算配送费
 */
var countDeliveryPrice = exports.countDeliveryPrice = function (deliveryProps) {
  if (type === 'TS') {
    return 0;
  }

  if (!deliveryProps || !deliveryProps.deliveryPrice) {
    return 0;
  }

  return deliveryProps.deliveryPrice;
};

/**
 * 获取整单附加费（正餐 + 快餐）
 * @param {object} serviceProps
 */
var getOrderExtraPrice = function getOrderExtraPrice() {
  var serviceProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var extraPrice = 0;
  var benefitProps = serviceProps.benefitProps,
      diningForm = serviceProps.diningForm;

  if (benefitProps && (benefitProps.isPriviledge || (0, _commonHelper.isFormalMeal)(diningForm)) || benefitProps && !(0, _commonHelper.isFormalMeal)(diningForm) && (0, _dishHelper.getUrlParam)('type') === 'TS') {
    extraPrice = benefitProps.extraPrice;
  }

  return extraPrice;
};
exports.getOrderExtraPrice = getOrderExtraPrice;

/**
 * 计算进入页面时的总价
 * 自动抹零现规则是在积分，优惠券，折扣换算完以后才执行
 * 折扣信息为serviceProps.discountProps.inUseDiscount,已经计算好了的
 */
exports.countTotalPriceWithoutBenefit = function (dishesPrice, deliveryProps, serviceProps) {
  var total = [dishesPrice, // 菜品初始价格
  getDishBoxPrice(), // 餐盒费
  +countDeliveryPrice(deliveryProps)].reduce(function (p, n) {
    return p + n;
  });

  return parseFloat(total.toFixed(2));
};

// 计算被优惠的加价部分 如果ableAddPriceDiscount为false 则应为0
var getPrivChangePriceByOrder = function getPrivChangePriceByOrder(order, saleType) {
  var groups = order.groups,
      dishIngredientInfos = order.dishIngredientInfos,
      dishPropertyTypeInfos = order.dishPropertyTypeInfos,
      count = order.count;

  var diMemberPrice = 0;
  var dpMemberPrice = 0;
  var groupMemberPrice = 0;

  if (Array.isArray(dishIngredientInfos)) {
    diMemberPrice = dishIngredientInfos.reduce(function (diPrice, ingredient) {
      var _ingredient$memberRep = ingredient.memberReprice,
          memberReprice = _ingredient$memberRep === undefined ? 0 : _ingredient$memberRep,
          _ingredient$reprice = ingredient.reprice,
          reprice = _ingredient$reprice === undefined ? 0 : _ingredient$reprice,
          isChecked = ingredient.isChecked;
      // return isChecked && memberReprice ? diPrice + (reprice - memberReprice) : diPrice;

      return isChecked && memberReprice >= 0 ? diPrice + (reprice - memberReprice) : diPrice; // 消除memberReprice为0的影响
    }, 0);
  }

  if (Array.isArray(dishPropertyTypeInfos)) {
    dishPropertyTypeInfos.forEach(function (dishProp) {
      var properties = dishProp.properties;

      if (Array.isArray(properties)) {
        dpMemberPrice += properties.reduce(function (dpPrice, prop) {
          var _prop$memberReprice = prop.memberReprice,
              memberReprice = _prop$memberReprice === undefined ? 0 : _prop$memberReprice,
              _prop$reprice = prop.reprice,
              reprice = _prop$reprice === undefined ? 0 : _prop$reprice,
              isChecked = prop.isChecked;
          // return isChecked && memberReprice ? dpPrice + (reprice - memberReprice) : dpPrice;

          return isChecked && memberReprice >= 0 ? dpPrice + (reprice - memberReprice) : dpPrice; // 消除memberReprice为0的影响
        }, 0);
      }
    });
  }

  if (Array.isArray(groups)) {
    groups.forEach(function (group) {
      var childInfos = group.childInfos;

      if (Array.isArray(childInfos)) {
        childInfos.forEach(function (child) {
          var subOrder = child.order,
              _child$marketPrice = child.marketPrice,
              marketPrice = _child$marketPrice === undefined ? 0 : _child$marketPrice,
              _child$memberMarketPr = child.memberMarketPrice,
              memberMarketPrice = _child$memberMarketPr === undefined ? 0 : _child$memberMarketPr;

          var num = 0;
          if (Array.isArray(subOrder)) {
            subOrder.forEach(function (subOrderItem) {
              num += subOrderItem.count;
              groupMemberPrice += getPrivChangePriceByOrder(subOrderItem, subOrder.saleType || 2);
            });
          } else if (!isNaN(subOrder)) {
            num = subOrder;
          }

          groupMemberPrice += num * (marketPrice - memberMarketPrice);
        });
      }
    });
  }
  var newCount = saleType === 1 ? 1 : count;
  return +((diMemberPrice + dpMemberPrice + groupMemberPrice) * newCount).toFixed(2);
};

/**
 * 计算会员价格 优惠了多少钱
 */
var countMemberPrice = exports.countMemberPrice = function (isDiscountChecked, orderedDishes, discountProps) {
  if (!isDiscountChecked) {
    return 0;
  }

  var discountList = discountProps.discountList,
      discountType = discountProps.discountType,
      discount = discountProps.discount,
      ableAddPriceDiscount = discountProps.ableAddPriceDiscount;
  // 此处新加 数组去重

  var n = {};
  var validDiscountList = (discountList || []).map(function (item, index) {
    if (item.dishId && !n[item.dishId]) {
      n[item.dishId] = true;
      return item;
    }

    return null;
  }).filter(function (item) {
    return !!item;
  });

  var discountPriceList = [];
  var newOrderedDishes = Immutable.from([].concat(orderedDishes));

  for (var i = 0; i < newOrderedDishes.length; i++) {
    if (!newOrderedDishes[i].isRelatedToCoupon) {
      continue;
    }

    var dishCount = (0, _dishHelper.getDishesCount)([newOrderedDishes[i]]);

    if (dishCount <= newOrderedDishes[i].relatedCouponCount) {
      continue;
    }

    if ((0, _dishHelper.isSingleDishWithoutProps)(newOrderedDishes[i])) {
      Immutable.merge(newOrderedDishes[i], {
        order: dishCount - newOrderedDishes[i].relatedCouponCount
      });
    } else {
      var orderLength = newOrderedDishes[i].order.length;

      for (var j = 0; j < orderLength; j++) {
        if (newOrderedDishes[i].order[j].count <= newOrderedDishes[i].relatedCouponCount) {
          Immutable.merge(newOrderedDishes[i], {
            relatedCouponCount: newOrderedDishes[i].relatedCouponCount - newOrderedDishes[i].order[j].count
          });
          Immutable.merge(newOrderedDishes[i].order[j], { count: 0 });
        } else {
          Immutable.merge(newOrderedDishes[i].order[j], {
            count: newOrderedDishes[i].order[j].count - newOrderedDishes[i].relatedCouponCount
          });
        }
      }
    }
  }

  var calcExp = null;

  if (discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
    calcExp = function calcExp(price, count, discountValue, orderPrice, privChangePrice) {
      var privAmount = (1 - discountValue / 10) * price * count + privChangePrice;
      var realAmount = Math.max(_const.MinDiscountedAmount, orderPrice - privAmount);

      return Math.max(0, orderPrice - realAmount);
    };
  } else {
    calcExp = function calcExp(price, count, discountValue) {
      return Math.max(price - discountValue, 0) * count;
    };
  }

  var useDiscountDishes = newOrderedDishes.filter(function (dish) {
    return !dish.noUseDiscount && !dish.purchaseBenefit;
  });

  useDiscountDishes.forEach(function (orderedDish) {
    var dishDiscount = validDiscountList.find(function (item) {
      return item.dishId === orderedDish.id;
    });
    if (!dishDiscount && discountType !== _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
      return;
    }

    var discountValue = discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT ? discount : dishDiscount.value;

    if ((0, _dishHelper.isSingleDishWithoutProps)(orderedDish)) {
      var orderPrice = (0, _dishHelper.getDishPrice)(orderedDish);
      var privChangePrice = 0;
      discountPriceList.push(calcExp(orderedDish.marketPrice, (0, _dishHelper.getDishesCount)([orderedDish]), discountValue, orderPrice, privChangePrice));
    } else {
      orderedDish.order.forEach(function (order) {
        var orderPrice = (0, _dishHelper.getOrderPrice)(orderedDish, order); // 总价
        var privChangePrice = ableAddPriceDiscount ? getPrivChangePriceByOrder(order) : 0; // 被优惠的配料价格
        var discountPrice = calcExp(orderedDish.marketPrice, order.count, discountValue, orderPrice, privChangePrice);
        discountPriceList.push(Math.min(discountPrice, orderPrice));
      });
    }
  });

  return parseFloat(discountPriceList.reduce(function (p, c) {
    return p + c;
  }, 0).toFixed(2));
};

/**
 * 计算雅座的积分优惠
 */
var getMaxIntegralCanBeUsedForYaZuo = exports.getMaxIntegralCanBeUsedForYaZuo = function (integralsInfo, canBeUsedCommutation) {
  if (canBeUsedCommutation <= 0 || !integralsInfo) {
    return {
      maxIntegralCanBeUsed: null,
      maxDiscount: null
    };
  }

  var integralRate = integralsInfo.integralRate,
      integral = integralsInfo.integral;


  var discountByIntegral = parseFloat((integral * integralRate).toFixed(2));

  if (discountByIntegral <= canBeUsedCommutation) {
    return {
      maxIntegralCanBeUsed: integral,
      maxDiscount: discountByIntegral
    };
  }

  var maxIntegralCanBeUsed = Math.ceil(canBeUsedCommutation / integralRate);
  var maxDiscount = parseFloat((maxIntegralCanBeUsed * integralRate).toFixed(2));

  return {
    maxIntegralCanBeUsed: maxIntegralCanBeUsed,
    maxDiscount: maxDiscount > canBeUsedCommutation ? canBeUsedCommutation : maxDiscount
  };
};

/**
 * 计算积分换算金额
 */
exports.countIntegralsToCash = function (canBeUsedCommutation, integralsInfo) {
  // 不存在积分对象或者总额为0
  if (canBeUsedCommutation <= 0 || !integralsInfo) {
    return {
      commutation: 0,
      integralInUsed: 0
    };
  }
  // 雅座的积分兑换
  if (!integralsInfo.exchangeCashValue || !integralsInfo.exchangeIntegralValue) {
    var _getMaxIntegralCanBeU = getMaxIntegralCanBeUsedForYaZuo(integralsInfo, canBeUsedCommutation),
        maxIntegralCanBeUsed = _getMaxIntegralCanBeU.maxIntegralCanBeUsed,
        maxDiscount = _getMaxIntegralCanBeU.maxDiscount;

    return {
      commutation: maxDiscount,
      integralInUsed: maxIntegralCanBeUsed
    };
  }

  var limitType = integralsInfo.limitType;

  var canUsesIntegralTimes = Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue);
  if (limitType === 1) {
    var integralInUsed = canUsesIntegralTimes * integralsInfo.exchangeIntegralValue < integralsInfo.integral ? canUsesIntegralTimes * integralsInfo.exchangeIntegralValue : Math.floor(integralsInfo.integral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeIntegralValue;
    return {
      commutation: integralInUsed / integralsInfo.exchangeIntegralValue * integralsInfo.exchangeCashValue,
      integralInUsed: integralInUsed
    };
  } else if (limitType === 2) {
    if (integralsInfo.integral > integralsInfo.limitIntegral) {
      var moneyLimit = Math.floor(integralsInfo.limitIntegral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeCashValue;
      return {
        commutation: moneyLimit > canBeUsedCommutation ? Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue) * integralsInfo.exchangeCashValue : moneyLimit,
        integralInUsed: moneyLimit > canBeUsedCommutation ? Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue) * integralsInfo.exchangeIntegralValue : Math.floor(integralsInfo.limitIntegral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeIntegralValue
      };
    }

    var noLimitMoney = Math.floor(integralsInfo.integral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeCashValue;
    return {
      commutation: noLimitMoney > canBeUsedCommutation ? Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue) * integralsInfo.exchangeCashValue : noLimitMoney,
      integralInUsed: noLimitMoney > canBeUsedCommutation ? Math.floor(canBeUsedCommutation / integralsInfo.exchangeCashValue) * integralsInfo.exchangeIntegralValue : Math.floor(integralsInfo.integral / integralsInfo.exchangeIntegralValue) * integralsInfo.exchangeIntegralValue
    };
  }

  return false;
};

/**
 * 获取关联菜品的礼品券可以省多少钱
 */
var countRelatedDishGiftCouponPrice = function countRelatedDishGiftCouponPrice(dish, dishCount, dishPrice, relatedCouponDish, coupon, benefitMoneyCollection, serviceProps) {
  if (!serviceProps) {
    return;
  }

  relatedCouponDish.name = dish.name;
  relatedCouponDish.number = coupon.dishNum;

  var wholeOrderBenefit = serviceProps.wholeOrderBenefit,
      activityBenefit = serviceProps.activityBenefit;

  var countActivityBenefit = 0;
  var isSingleDish = (0, _dishHelper.isSingleDishWithoutProps)(dish);
  var activityBenefitNum = 0;

  if (wholeOrderBenefit && wholeOrderBenefit.isChecked) {
    activityBenefitNum = (isSingleDish ? dish.order : dish.order[0].count) || 1;
    countActivityBenefit = activityBenefit.privilegePrices[dish.id] && activityBenefit.privilegePrices[dish.id].prices.reduce(function (c, p) {
      return c + p;
    }) / activityBenefitNum;
  } else {
    var activityBenefitMoney = isSingleDish ? dish.activityBenefit : dish.order[0].activityBenefit;
    activityBenefitNum = (isSingleDish ? dish.activityBenefitNum : dish.order[0].activityBenefitNum) || 1;

    if (coupon.dishNum <= activityBenefitNum) {
      countActivityBenefit = activityBenefitMoney / activityBenefitNum * coupon.dishNum || 0;
    } else {
      countActivityBenefit = activityBenefitMoney;
    }
  }

  var realDishBenefitPrice = countActivityBenefit;

  var partOne = dish.marketPrice * (coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber) - realDishBenefitPrice;
  var partTwo = dishPrice / dishCount * (coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber) - realDishBenefitPrice;
  var partThree = dish.marketPrice * dishCount - realDishBenefitPrice;
  var partFour = dishPrice - realDishBenefitPrice;

  if (!(wholeOrderBenefit && wholeOrderBenefit.isChecked)) {
    // if (!dish.noUseDiscount && dish.isMember && dish.memberPrice) {
    if (!dish.noUseDiscount && dish.isMember && dish.memberPrice !== null && dish.memberPrice !== undefined) {
      partOne = partTwo = partThree = partFour = (0, _dishHelper.getDishMemberPrice)(dish);
    }
  }

  if (coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber > 0) {
    if (coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber < dishCount) {
      benefitMoneyCollection.push(dish.marketPrice < dishPrice / dishCount ? partOne : partTwo);
    } else {
      benefitMoneyCollection.push(dish.marketPrice < dishPrice / dishCount ? partThree : partFour);
    }
    relatedCouponDish.joinBenefitDishesNumber = coupon.dishNum - relatedCouponDish.joinBenefitDishesNumber < dishCount ? coupon.dishNum : relatedCouponDish.joinBenefitDishesNumber + dishCount;
  }
};

/**
 * 获取与礼品券有关的菜品优惠情况
 */
var getRelatedToDishCouponProps = exports.getRelatedToDishCouponProps = function (coupon, serviceProps, orderedDishesProps) {
  var dishesList = orderedDishesProps || JSON.parse(localStorage.getItem('lastOrderedDishes')) || {};
  var relatedCouponDish = {
    name: null,
    number: null,
    couponValue: null,
    joinBenefitDishesNumber: 0
  };
  var benefitMoneyCollection = [];

  (dishesList.dishes || []).forEach(function (dish) {
    if ((0, _dishHelper.isSingleDishWithoutProps)(dish)) {
      if (dish.brandDishId === coupon.dishId) {
        var dishCount = (0, _dishHelper.getDishesCount)([dish]);
        var dishPrice = (0, _dishHelper.getDishPrice)(dish);
        countRelatedDishGiftCouponPrice(dish, dishCount, dishPrice, relatedCouponDish, coupon, benefitMoneyCollection, serviceProps);
      }
    } else {
      dish.order.forEach(function (order) {
        if (dish.brandDishId === coupon.dishId) {
          var _dishCount = order.count;
          var _dishPrice = (0, _dishHelper.getOrderPrice)(dish, order);
          countRelatedDishGiftCouponPrice(dish, _dishCount, _dishPrice, relatedCouponDish, coupon, benefitMoneyCollection, serviceProps);
        }
      });
    }
  });

  relatedCouponDish.couponValue = benefitMoneyCollection.length ? parseFloat(benefitMoneyCollection.reduce(function (c, p) {
    return c + p;
  }).toFixed(2)) : 0;
  return relatedCouponDish;
};
/**
 * 计算实际可用的优惠券的数量
 */
exports.getCouponsLength = function (couponsList, privateRoom, serviceProps, orderedDishesProps) {
  if (privateRoom) {
    return couponsList.length;
  }

  var couponLength = 0;

  couponsList.forEach(function (coupon) {
    var _coupon$fullValue = coupon.fullValue,
        fullValue = _coupon$fullValue === undefined ? 0 : _coupon$fullValue,
        _coupon$orderAccount = coupon.orderAccount,
        orderAccount = _coupon$orderAccount === undefined ? 0 : _coupon$orderAccount;


    if (fullValue > orderAccount) {
      return false;
    }

    if (coupon.coupDishBeanList.length) {
      if (getRelatedToDishCouponProps(coupon.coupDishBeanList[0], serviceProps, orderedDishesProps).name) {
        couponLength = couponLength + 1;
      }
    } else if (coupon.coupRuleBeanList.length) {
      couponLength = couponLength + 1;
    } else if (coupon.weixinValue) {
      couponLength = couponLength + 1;
    }
  });

  return couponLength;
};

/**
 * 实际优惠的钱
 */
exports.getDishBenefitPrice = function (dish, serviceProps, dishes, isHDL) {
  var dishBenefitPrice = 0;
  var activityBenefit = serviceProps.activityBenefit,
      wholeOrderBenefit = serviceProps.wholeOrderBenefit;
  var privilegePrices = activityBenefit.privilegePrices;
  // 针对海底捞活动优惠中选择最大优惠价

  var _getActivityBenefitMa = (0, _dishHelper.getActivityBenefitMaxId)(dishes),
      activityBenefitMaxId = _getActivityBenefitMa.activityBenefitMaxId,
      activityBenefitMaxValue = _getActivityBenefitMa.activityBenefitMaxValue;

  // 整单优惠权重分配金额,针对每道菜减去了多少钱


  if (wholeOrderBenefit && wholeOrderBenefit.isChecked && privilegePrices) {
    if (privilegePrices.hasOwnProperty(dish.id)) {
      dishBenefitPrice = privilegePrices[dish.id].prices.reduce(function (c, p) {
        return c + p;
      });
    }
    return dishBenefitPrice;
  }

  // 单商品会员价
  var isSupportMemberPrice = dish.isMember && !dish.noUseDiscount;
  if (isSupportMemberPrice) {
    dishBenefitPrice = countMemberPrice(true, Immutable.from([dish]), serviceProps.discountProps);
    if (isHDL && dish.id === activityBenefitMaxId) {
      dishBenefitPrice += activityBenefitMaxValue;
    }
    return dishBenefitPrice;
  }
  // 单商品营销
  if (isHDL) {
    if (dish.activityBenefit || dish.order instanceof Array && dish.order[0].activityBenefit) {
      // 当外面reduce遍历到当前菜品id和最大优惠id相等情况下，抛出最大优惠价加入总价计算，否则都返回 0
      dishBenefitPrice = dish.id === activityBenefitMaxId ? activityBenefitMaxValue : 0;
    } else if (dish.order.length) {
      dishBenefitPrice = dish.order.reduce(function (c, p) {
        return c + (p.activityBenefit || 0);
      }, 0);
    }
  } else {
    if (dish.activityBenefit) {
      dishBenefitPrice = dish.activityBenefit;
    } else if (dish.order.length) {
      dishBenefitPrice = dish.order.reduce(function (c, p) {
        return c + (p.activityBenefit || 0);
      }, 0);
    }
  }

  return dishBenefitPrice;
};

/**
 *
 * @param {*} price 需要进位的价格
 * @param {*} mCarryLimit 3七进位时 mCarryLimit = 2,表示看小数点后第2位
 */
exports.threeSevenUp = function (price, mCarryLimit) {
  if (mCarryLimit <= 0) {
    return price;
  }
  var bei = Math.pow(10, mCarryLimit);
  var bei_1 = Math.pow(10, mCarryLimit - 1);
  var bei_2 = Math.pow(10, mCarryLimit + 1);

  var intValue = Math.floor(price * bei_2 / bei_1 % 10);
  var atom = Math.abs(intValue);
  var a1 = parseInt(atom / 5);
  var a2 = atom % 5 >= 3 ? 5 : 0;
  var after = (a1 * 5 + a2) / bei;
  after = intValue > 0 ? after : -after;
  var before = Math.floor(price * bei_1) / bei_1;
  var bbb = (before * bei_2 + after * bei_2) / bei_2;
  var numArr = bbb.toString().split('.');
  var zs = numArr[0];
  var xs = numArr[1] ? numArr[1].substr(0, mCarryLimit) : '';
  var arr = [zs, xs];
  return +arr.join('.');
};

exports.carryPrice = function (carryRuleVO, price) {
  var _CarryTypes$ROUND$Car;

  var transferType = carryRuleVO.transferType,
      scale = carryRuleVO.scale;

  var result = { change: 0, price: price };
  var multiple = Math.pow(10, scale);

  var rule = (_CarryTypes$ROUND$Car = {}, (0, _defineProperty3.default)(_CarryTypes$ROUND$Car, _const.CarryTypes.ROUND, function () {
    result.price = +price.toFixed(scale);
  }), (0, _defineProperty3.default)(_CarryTypes$ROUND$Car, _const.CarryTypes.CEIL, function () {
    result.price = Math.ceil(price * multiple) / multiple;
  }), (0, _defineProperty3.default)(_CarryTypes$ROUND$Car, _const.CarryTypes.FLOOR, function () {
    result.price = Math.floor(price * multiple) / multiple;
  }), (0, _defineProperty3.default)(_CarryTypes$ROUND$Car, _const.CarryTypes.THREE_SEVEN, function () {
    result.price = exports.threeSevenUp(price, scale);
  }), _CarryTypes$ROUND$Car)[transferType] || function () {
    return null;
  };

  rule();

  result.change = +(price - result.price).toFixed(2);
  return result;
};

// 校验收货地址信息
var validateAddressInfo = exports.validateAddressInfo = function (info, isTakeaway, filter, noMobile) {
  var rules = {
    name: [{
      msg: (0, _helper.formatMessage)(_address2.default.addressInvalidName),
      validate: function validate(value) {
        return !!(0, _commonHelper.checkInvalidSymbol)(value.trim());
      }
    }],
    sex: [{
      msg: (0, _helper.formatMessage)(_action5.default.actionselectSex),
      validate: function validate(value) {
        var gender = +value;
        return gender === 1 || gender === 0;
      }
    }],
    mobile: [{
      msg: (0, _helper.formatMessage)(_order2.default.orderinputPN),
      validate: function validate(value) {
        return !!value.trim();
      }
    }]
  };

  if (noMobile) {
    delete rules.mobile;
  }

  if (isTakeaway) {
    (0, _assign2.default)(rules, {
      baseAddress: [{
        msg: (0, _helper.formatMessage)(_address2.default.addressselectAddress),
        validate: function validate(value) {
          return !!value.trim();
        }
      }],
      street: [{
        msg: (0, _helper.formatMessage)(_address2.default.addressInvalidStreet),
        validate: function validate(value) {
          return !!(0, _commonHelper.checkEmojiWith)(value.trim());
        }
      }]
    });
  }

  for (var key in rules) {
    if (!rules.hasOwnProperty(key)) {
      continue;
    }

    if (filter && filter(key)) {
      continue;
    }

    var rule = rules[key];
    var value = info[key];

    if (typeof value !== 'number') {
      value = value || '';
    }

    for (var i = 0, len = rule.length; i < len; i++) {
      var item = rule[i];
      var valid = item.validate(value);
      if (!valid) {
        return { valid: false, msg: item.msg };
      }
    }
  }

  return { valid: true, msg: '' };
};

var getSubmitDishData = exports.getSubmitDishData = function (dishesData, shopId_) {
  var customerProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = { singleDishInfos: [], multiDishInfos: [] };
  var isHDL = customerProps.isHDL;

  var getSingleDishInfo = function getSingleDishInfo(dishes, func) {
    return [].concat.apply([], (dishes || []).map(function (dish) {
      var dishBenefitPrice = 0;

      if (dish.activityBenefit) {
        dishBenefitPrice = dish.activityBenefit;
      }

      var orderDishes = [];
      var benefitDish = dish.benefitOptions || Array.isArray(dish.order) && dish.order[0] && dish.order[dish.order.length - 1].benefitOptions || [];
      var beSelectedBenefit = _find(benefitDish, function (benefit) {
        return benefit.isChecked;
      });
      var priId = dish.isMember ? '0' : null;
      var priType = dish.isMember ? 3 : null; // 会员价的情况
      var priDishNum = 0;

      if (beSelectedBenefit) {
        priId = String(beSelectedBenefit.priId);
        priType = beSelectedBenefit.priType;
        priDishNum = beSelectedBenefit.dishNum;
      } else if (dish.noBenefit) {
        priId = null;
        priType = null;
      }

      if (dish.purchaseBenefit) {
        priId = null;
        priType = null;
      }

      var order = dish.order;
      var dishInfo = {
        num: 0,
        price: dish.marketPrice,
        ingredientIds: [],
        propertyIds: [],
        dishId: dish.id,
        itemId: dish.itemId,
        shopId: shopId,
        brandDishId: dish.brandDishId,
        priType: priType,
        priId: priId,
        priDishNum: priDishNum,
        dishName: dish.dishName,
        dishBenefitPrice: dishBenefitPrice
      };

      if (func) {
        func(dishInfo);
      }

      if (typeof order === 'number' && order > 0) {
        dishInfo.num = order;
        dishInfo.priId = priId && String(priId) || null;
        dishInfo.priType = priType;

        if (dish.dishPropertyTypeInfos && dish.dishPropertyTypeInfos.length > 0) {
          (dish.dishPropertyTypeInfos || []).forEach(function (item) {
            [].push.apply(dishInfo.propertyIds, (item.properties || []).filter(function (subItem) {
              return subItem.isChecked || item.type === 4;
            }).map(function (subItem) {
              return subItem.id;
            }));
          });
        }

        orderDishes.push(dishInfo);
      } else if (Array.isArray(order) && order.length) {
        var orderPrices = [];
        var orderNum = [];
        order.forEach(function (item) {
          orderPrices.push((0, _dishHelper.getOrderPrice)(dish, item));
          orderNum.push(item.count);
        });

        var maxOrderPrice = orderPrices[0];

        for (var i = 1; i < orderPrices.length; i++) {
          if (maxOrderPrice < orderPrices[i]) maxOrderPrice = orderPrices[i];
        }

        var maxCount = orderNum[0];

        for (var _i = 1; _i < orderNum.length; _i++) {
          if (maxCount < orderNum[_i]) maxCount = orderNum[_i];
        }

        var relatedPrivilege = false;

        orderDishes = order.map(function (orderDish) {
          var duplicateDishInfo = (0, _assign2.default)({}, dishInfo, {
            dishBenefitPrice: orderDish.activityBenefit
          });
          duplicateDishInfo.num = orderDish.count;
          duplicateDishInfo.ingredientIds = (orderDish.dishIngredientInfos || []).filter(function (item) {
            return item.isChecked;
          }).map(function (item) {
            return item.id;
          });
          duplicateDishInfo.propertyIds = [];

          (orderDish.dishPropertyTypeInfos || []).forEach(function (item) {
            [].push.apply(duplicateDishInfo.propertyIds, (item.properties || []).filter(function (subItem) {
              return subItem.isChecked;
            }).map(function (subItem) {
              return subItem.id;
            }));
          });

          var dishInfoWithPriId = beSelectedBenefit && beSelectedBenefit.type === 1 && !relatedPrivilege || beSelectedBenefit && beSelectedBenefit.type === 2 && !relatedPrivilege || beSelectedBenefit && beSelectedBenefit.priType === 2 && orderDish.hasGiftBenefit;

          if (dishInfoWithPriId) {
            (0, _assign2.default)(duplicateDishInfo, {
              priId: String(priId),
              priType: priType,
              priGiftId: []
            });
            relatedPrivilege = true;
          } else {
            duplicateDishInfo.priId = duplicateDishInfo.priType = null;
          }

          if (!beSelectedBenefit && dish.isMember && !dish.noBenefit) {
            duplicateDishInfo.priId = String(priId);
            duplicateDishInfo.priType = priType;
          }

          return duplicateDishInfo;
        });
      }

      return orderDishes.filter(function (orderDish) {
        return orderDish.num > 0;
      });
    }));
  };

  if (isHDL) {
    result.singleDishInfos = getSingleDishInfo(dishesData.filter(function (dish) {
      return dish.type === 0;
    })).reduce(function (itemList, itemNext) {
      var itemNextAsMutable = Immutable.isImmutable(itemNext) ? itemNext.asMutable() : (0, _extends3.default)({}, itemNext);
      var curDishBenefitPrice = itemNextAsMutable.dishBenefitPrice,
          curPriType = itemNextAsMutable.priType,
          curPriDishNum = itemNextAsMutable.priDishNum; // 当前但商品优惠

      if (!curDishBenefitPrice || curPriType !== 1 || curPriDishNum !== 1) {
        // 未使用优惠
        return itemList.concat(itemNextAsMutable);
      }

      itemList.forEach(function (item) {
        var oriDishBenefitPrice = item.dishBenefitPrice,
            oriPriType = item.priType,
            oriPriDishNum = item.priDishNum;


        if (!oriDishBenefitPrice || oriPriType !== 1 || oriPriDishNum !== 1) {
          return;
        }

        if (curDishBenefitPrice >= oriDishBenefitPrice) {
          (0, _assign2.default)(item, { priId: null, priType: null });
        } else {
          (0, _assign2.default)(itemNextAsMutable, { priId: null, priType: null });
        }
      });
      return itemList.concat(itemNextAsMutable);
    }, []).map(function (item) {
      delete item.dishBenefitPrice;
      delete item.priDishNum;
      return item;
    });
  } else {
    result.singleDishInfos = getSingleDishInfo(dishesData.filter(function (dish) {
      return dish.type === 0;
    })).map(function (item) {
      var itemAsMutable = Immutable.isImmutable(item) ? item.asMutable() : (0, _extends3.default)({}, item);

      delete itemAsMutable.dishBenefitPrice;
      delete itemAsMutable.priDishNum;
      return itemAsMutable;
    });
  }

  var relatedMuilPrivilege = {};

  result.multiDishInfos = [].concat.apply([], dishesData.filter(function (dish) {
    return dish.type === 1;
  }).map(function (dish) {
    var orderDishes = [];
    var benefitDish = dish.benefitOptions || dish.order[0] && dish.order[dish.order.length - 1].benefitOptions || [];
    var beSelectedBenefit = _find(benefitDish, function (benefit) {
      return benefit.isChecked;
    });
    var priId = beSelectedBenefit ? String(beSelectedBenefit.priId) : null;
    var priType = beSelectedBenefit ? beSelectedBenefit.priType : null;

    if (!beSelectedBenefit && !dish.noBenefit && dish.isMember) {
      priId = '0';
      priType = 3;
    }

    if (dish.purchaseBenefit) {
      priId = null;
      priType = null;
    }

    var dishInfo = {
      num: 0,
      price: dish.marketPrice,
      priId: priId,
      priType: priType,
      dishId: dish.id,
      itemId: dish.itemId,
      subDish: [],
      shopId: shopId,
      brandDishId: dish.brandDishId
    };

    (dish.order || []).forEach(function (orderDish) {
      if (!orderDish.count) {
        return;
      }

      if (relatedMuilPrivilege[dish.brandDishId] && priType === 1) {
        (0, _assign2.default)(dishInfo, { priId: null, priType: null });
      }

      var duplicateDishInfo = (0, _assign2.default)({}, dishInfo, {
        num: orderDish.count,
        subDish: []
      });

      if (!relatedMuilPrivilege[duplicateDishInfo.brandDishId]) {
        relatedMuilPrivilege[duplicateDishInfo.brandDishId] = true;
      }

      (orderDish.groups || []).forEach(function (group) {
        [].push.apply(duplicateDishInfo.subDish, getSingleDishInfo(group.childInfos, function (info) {
          var _info = info;
          _info.groupId = group.id;
        }));
      });

      orderDishes.push(duplicateDishInfo);
    });

    return orderDishes;
  }));

  return result;
};

var filterChosenDish = exports.filterChosenDish = function (dishes, benefitProp, marketUseCoupon, status) {
  var newDishes = dishes.asMutable({ deep: true });

  newDishes.filter(function (dish) {
    if (dish.benefitOptions) {
      return dish;
    } else if (dish.order[0] && dish.order[dish.order.length - 1].benefitOptions) {
      return dish;
    }

    return false;
  }).map(function (dish) {
    (dish.benefitOptions || dish.order[dish.order.length - 1].benefitOptions).forEach(function (benefit) {
      if (benefitProp.dishId === dish.brandDishId && benefit.priId === benefitProp.priId) {
        benefit.isChecked = true;

        if (status) {
          benefit.isChecked = false;
        }

        dish.noUseDiscount = true;
        dish.noBenefit = false;
        var reduce = 0;
        var num = 1;
        var benefitDishNum = 1;
        var averageReduce = 0;

        if (benefitProp.type === 1) {
          reduce = benefitProp.reduce;
          num = benefitProp.dishNum;
          benefitDishNum = benefitProp.dishNum;
          averageReduce = Math.min(reduce / num, dish.marketPrice);
        } else if (benefitProp.type === 2) {
          reduce = (1 - benefitProp.discount / 10) * dish.marketPrice * benefitProp.dishNum;
          num = benefitProp.dishNum;
          benefitDishNum = benefitProp.dishNum;
        }

        if (benefitProp.priType === 1) {
          if (dish.benefitOptions) {
            var activeBenefitNum = Math.min(dish.order, num);

            dish.activityBenefit = {
              1: Math.min(dish.marketPrice * activeBenefitNum, reduce),
              2: Math.min(dish.marketPrice * (1 - benefitProp.discount / 10) * activeBenefitNum, reduce)
            }[benefitProp.type];

            dish.activityBenefitNum = activeBenefitNum;
          } else {
            dish.order.forEach(function (item) {
              item.activityBenefit = 0;
              item.activityBenefitNum = 0;
              var activeBenefitNum = Math.max(Math.min(item.count, benefitDishNum), 0);
              var eachOrderPrice = {
                1: averageReduce * activeBenefitNum,
                2: dish.marketPrice * (1 - benefitProp.discount / 10) * activeBenefitNum
              }[benefitProp.type];

              if (benefitDishNum > 0) {
                if (eachOrderPrice >= reduce) {
                  item.activityBenefit = Math.min(reduce, eachOrderPrice);
                  item.activityBenefitNum = activeBenefitNum;
                  reduce = 0;
                } else {
                  item.activityBenefit = eachOrderPrice;
                  item.activityBenefitNum = activeBenefitNum;
                  reduce = reduce - eachOrderPrice;
                }
              } else {
                item.activityBenefit = 0;
              }

              benefitDishNum = Math.min(benefitDishNum - 1, benefitDishNum - item.count); // 限定份数
            });
          }
        }
      } else if (benefitProp.dishId === dish.brandDishId) {
        benefit.isChecked = false;
      }
    });

    return dish;
  });

  return newDishes;
};

var reorganizedActivityBenefit = exports.reorganizedActivityBenefit = function (activityBenefit, dishes, benefitProp, marketUseCoupon) {
  var newDishes = filterChosenDish(dishes, benefitProp);
  var marketUseCouponPrice = filterChosenDish(dishes, benefitProp, marketUseCoupon);
  var newActivityBenefit = activityBenefit.asMutable({ deep: true });

  if (benefitProp.priType === 1) {
    newActivityBenefit.benefitMoney += benefitProp.reduce;
  }

  return {
    dishes: newDishes,
    activityBenefit: newActivityBenefit,
    marketUseCouponPrice: marketUseCouponPrice
  };
};

/**
 * 活动优惠菜品选择会员价 或者不选择任何优惠
 */
exports.setDishBenefitInfo = function (chosenDish, dish, benefitType) {
  if (chosenDish.id !== dish.id) {
    return dish;
  }

  var newDish = dish.asMutable({ deep: true });
  newDish.noBenefit = benefitType === 'noBenefit';
  newDish.noUseDiscount = benefitType === 'purchaseBenefit' || benefitType === 'noBenefit';
  newDish.purchaseBenefit = benefitType === 'purchaseBenefit';

  if (newDish.benefitOptions || newDish.order[0] && newDish.order[newDish.order.length - 1].benefitOptions) {
    if ((0, _dishHelper.isSingleDishWithoutProps)(newDish)) {
      newDish.activityBenefit = 0;
      newDish.benefitOptions.forEach(function (benefit) {
        benefit.isChecked = false;
      });
    } else {
      newDish.activityBenefit = 0;
      newDish.order.forEach(function (order) {
        order.activityBenefit = 0;
      });

      newDish.order[newDish.order.length - 1].benefitOptions.forEach(function (benefit) {
        benefit.isChecked = false;
      });
    }
  }

  return newDish;
};

var countAcvitityMoney = exports.countAcvitityMoney = function (dishes) {
  var acvitityCollection = [];

  dishes.filter(function (dish) {
    return dish.benefitOptions || dish.order[0] && dish.order[dish.order.length - 1].benefitOptions;
  }).forEach(function (dish) {
    var dishAcvitityCollection = [];

    if ((0, _dishHelper.isSingleDishWithoutProps)(dish)) {
      dishAcvitityCollection.push(dish.activityBenefit || 0);
    } else {
      dish.order.forEach(function (order) {
        dishAcvitityCollection.push(order.activityBenefit || 0);
      });

      if (dish.activityBenefit) {
        dishAcvitityCollection.push(dish.activityBenefit * dish.order.length);
      }
    }

    if (parseFloat(dishAcvitityCollection.reduce(function (c, p) {
      return c + p;
    }).toFixed(2)) > (0, _dishHelper.getDishPrice)(dish)) {
      dishAcvitityCollection = [];
      dishAcvitityCollection.push((0, _dishHelper.getDishPrice)(dish));
    }

    for (var i = 0; i < dishAcvitityCollection.length; i++) {
      acvitityCollection.push(dishAcvitityCollection[i]);
    }
  });

  return acvitityCollection.length ? parseFloat(acvitityCollection.reduce(function (c, p) {
    return c + p;
  }).toFixed(2)) : 0;
};

/**
 * 为已点菜品添加对应的优惠选项
 */
var addBenefitTodish = exports.addBenefitTodish = function (benefitProps, dish, dishes, hasPriviledge) {
  var orderedDish = dish.asMutable({ deep: true });

  /**
   * 如果是加菜模式 已经有优惠
   */
  if (hasPriviledge) {
    return Array.isArray(orderedDish) ? orderedDish[0] : orderedDish;
  }

  (benefitProps.dishPriList || []).forEach(function (benefit) {
    if (benefit.dishId === orderedDish.brandDishId) {
      benefit.dishPriInfo.forEach(function (info) {
        info.id = info.priId;
        info.dishId = orderedDish.brandDishId;
      });

      if (Array.isArray(orderedDish.order)) {
        var hasGiftCoupon = _find(benefit.dishPriInfo, function (info) {
          return info.priType === 2;
        });

        if (hasGiftCoupon) {
          var hasMoreCountDish = (0, _dishHelper.getDishesPrice)(dishes) >= hasGiftCoupon.fullValue;
          /**
           * 表面有复合礼品券优惠的菜品
           */
          if (hasMoreCountDish) {
            orderedDish.order[orderedDish.order.length - 1].benefitOptions = benefit.dishPriInfo;
          } else {
            orderedDish.order[orderedDish.order.length - 1].benefitOptions = (benefit.dishPriInfo || []).filter(function (info) {
              return info.priType !== 2;
            });
          }
        } else {
          orderedDish.order[orderedDish.order.length - 1].benefitOptions = benefit.dishPriInfo;
        }

        if (!orderedDish.isMember) {
          var lastOrderDish = orderedDish.order[orderedDish.order.length - 1];

          if (Array.isArray(lastOrderDish.benefitOptions) && lastOrderDish.benefitOptions.length > 0) {
            lastOrderDish.benefitOptions[0].isChecked = true;
          }

          orderedDish = filterChosenDish(Immutable.from([orderedDish]), orderedDish.order[orderedDish.order.length - 1].benefitOptions[0]);
        }
      } else {
        var _hasGiftCoupon = _find(benefit.dishPriInfo, function (info) {
          return info.priType === 2;
        });

        if (_hasGiftCoupon) {
          if ((0, _dishHelper.getDishesPrice)(dishes) >= _hasGiftCoupon.fullValue) {
            orderedDish.benefitOptions = benefit.dishPriInfo;
          } else {
            orderedDish.benefitOptions = (benefit.dishPriInfo || []).filter(function (info) {
              return info.priType !== 2;
            });
          }
        } else {
          orderedDish.benefitOptions = benefit.dishPriInfo;
        }

        if (!orderedDish.isMember) {
          if (Array.isArray(orderedDish.benefitOptions) && orderedDish.benefitOptions.length > 0) {
            orderedDish.benefitOptions[0].isChecked = true;
          }

          orderedDish = filterChosenDish(Immutable.from([orderedDish]), orderedDish.benefitOptions[0]);
        }
      }
    }
  });

  return Array.isArray(orderedDish) ? orderedDish[0] : orderedDish;
};

exports.countInitializeBenefit = function (benefitProps, dishes, hasPriviledge) {
  var newOrderedDishes = dishes.asMutable({ deep: true });
  var dishCollection = [];

  for (var i = 0; i < newOrderedDishes.length; i++) {
    var dish = addBenefitTodish(benefitProps, Immutable.from(newOrderedDishes[i]), dishes, hasPriviledge);
    dishCollection.push(dish);
  }

  return countAcvitityMoney(dishCollection);
};

/**
 * getActivityBenefitShared
 * @param {object} objParam
 */
var getActivityBenefitShared = exports.getActivityBenefitShared = function getActivityBenefitShared(objParam) {
  var benefitProps = objParam.benefitProps,
      orderedDishes = objParam.orderedDishes,
      needAddBenefit = objParam.needAddBenefit,
      hasPriviledge = objParam.hasPriviledge;

  var newOrderedDishes = orderedDishes.asMutable({ deep: true });
  var activityBenefitShared = true;

  for (var i = 0; i < newOrderedDishes.length; i++) {
    var dish = needAddBenefit ? addBenefitTodish(benefitProps, Immutable.from(newOrderedDishes[i]), newOrderedDishes, hasPriviledge) : newOrderedDishes[i];
    var checkedBenefit = [];

    if (dish.order instanceof Array && dish.order.length) {
      checkedBenefit = (dish.order[dish.order.length - 1].benefitOptions || []).filter(function (item) {
        return item.isChecked && item.shared === false;
      });
    } else if (typeof dish.order === 'number' && dish.benefitOptions) {
      checkedBenefit = (dish.benefitOptions || []).filter(function (item) {
        return item.isChecked && item.shared === false;
      });
    }

    if (checkedBenefit.length) {
      activityBenefitShared = false;
      break;
    }
  }

  return activityBenefitShared;
};

/**
 * 针对已有的单品优惠函数再封装一层，获取加价购是否互斥的逻辑
 */
exports.getPurchaseAndBenefitShared = function (params) {
  var serviceProps = params.serviceProps,
      orderedDishes = params.orderedDishes;

  var activityBenefitShared = (0, _changePurchaseCalculator.removePurchaseAndDishPriviege)(serviceProps, orderedDishes);

  activityBenefitShared = getActivityBenefitShared(params);

  return activityBenefitShared;
};

/**
 * 计算附加费（正餐）
 */
exports.countExtraPrivilege = function (privilegeArray) {
  if (!privilegeArray) {
    return false;
  }

  var benefitCollection = [];

  privilegeArray.forEach(function (privilege) {
    benefitCollection.push(+privilege.privilegeAmount);
  });

  return benefitCollection.length ? parseFloat(benefitCollection.reduce(function (c, p) {
    return c + p;
  }).toFixed(2)) : 0;
};

exports.combineAddPrivilege = function (addPrivilege, addPrivilegeFromShop, peopleCount, orderedDishesProps) {
  var copyAddPrivilegeFromShop = clonedeep(addPrivilegeFromShop || []).filter(function (item) {
    return !item.serviceCharge;
  });
  var serviceFromShop = clonedeep(addPrivilegeFromShop || []).filter(function (item) {
    return item.serviceCharge;
  })[0] || {};
  var copyAddPrivilege = clonedeep(addPrivilege || []).filter(function (item) {
    return item.promoId !== serviceFromShop.id;
  });

  var originPrice = (0, _dishHelper.getDishesPrice)(orderedDishesProps);
  var addPrivilegeList = [];

  if (!copyAddPrivilegeFromShop || copyAddPrivilegeFromShop.length === 0) {
    return copyAddPrivilege;
  }

  copyAddPrivilegeFromShop.forEach(function (item, index) {
    var extraPrice = 0;

    switch (item.calcWay) {
      case _const.CalcWay.DISCOUNT:
        // 折扣
        extraPrice += item.content / 100 * originPrice;
        break;
      case _const.CalcWay.PEOPLE:
        // 人数
        extraPrice += peopleCount * item.content;
        break;
      case _const.CalcWay.REGULAR:
        // 固定金额
        extraPrice += item.content;
        break;
      case _const.CalcWay.STAGE:
        extraPrice += calcStageFee(originPrice, item.sections);
        break;
      default:
        break;
    }

    item.privilegeAmount = parseFloat(extraPrice.toFixed(2));
    item.privilegeName = item.name;
    item.promoId = item.id;
  });

  addPrivilegeList = addPrivilegeList.concat(copyAddPrivilegeFromShop);

  /**
   * 合并 addPrivilege 以及 addPrivilegeFromShop
   */
  (copyAddPrivilege || []).forEach(function (item, index) {
    var include = false;

    copyAddPrivilegeFromShop.forEach(function (itemt, indext) {
      if (itemt.promoId === item.promoId) {
        include = true;
      }
    });

    if (!include) {
      addPrivilegeList.push(item);
    }
  });

  return addPrivilegeList;
};

exports.getMultiDishPrivilegeInfoDishList = function (detail) {
  var dishList = detail.dishList || [];
  var applyProductType = detail.applyProductType;

  if (!dishList || dishList.length === 0) {
    return {
      detailDishIdList: [],
      rangeStatus: { applyProductType: applyProductType, range: '' }
    };
  }

  var detailDishIdList = [];
  var range = '';

  var innerListCount = function innerListCount(dishItem, bool) {
    switch (dishItem.productDishType) {
      case 1:
        {
          // 中类
          var productDishTypeOne = '';
          productDishTypeOne += dishItem.dishTypeName + '(';

          if (dishItem.dishList && dishItem.dishList.length > 0) {
            dishItem.dishList.forEach(function (item, index) {
              productDishTypeOne += innerListCount(item, false);
              detailDishIdList.push(item.dishId); // 把中类下的菜ID加上
            });
          }

          return productDishTypeOne.substring(0, productDishTypeOne.length - 1) + ')，';
        }
      case 2:
        {
          // 菜品
          var productDishTypeTwo = '';

          if (bool) {
            productDishTypeTwo += dishItem.dishName + ',';
          } else {
            return dishItem.dishName + ',';
          }

          detailDishIdList.push(dishItem.dishId);

          return productDishTypeTwo;
        }
      default:
        break;
    }
  };

  dishList.forEach(function (item, index) {
    range = range + innerListCount(item, true);
  });

  return {
    detailDishIdList: detailDishIdList,
    rangeStatus: {
      applyProductType: applyProductType,
      range: range.substring(0, range.length - 1)
    }
  };
};

exports.setMarketUseCouponList = function (marketUseCouponList, id, addItem) {
  var obj = (0, _assign2.default)({}, marketUseCouponList);
  obj[id] = addItem;

  return obj;
};

var sortDishPrivilegeList = function sortDishPrivilegeList(dishPriInfo) {
  if (!dishPriInfo || !dishPriInfo.length) {
    return dishPriInfo || [];
  }

  return dishPriInfo.map(function (item) {
    var dishPriType = item.type,
        discount = item.discount,
        reduce = item.reduce;

    var isDiscount = dishPriType === _const.CouponPrivTypes.DISCOUNT;

    return (0, _extends3.default)({}, item, {
      _sort: isDiscount ? Math.pow(10, 10) + (10 - discount) : reduce
    });
  }).sort(function (prev, next) {
    return next._sort - prev._sort;
  });
};

exports.initActivityBenefitList = function (obj, dishes) {
  var itemList = [];

  obj.forEach(function (item, index) {
    item.dishPriInfo.forEach(function (itemt, indext) {
      if (itemt.priType === 2 && itemt.isChecked === true) {
        itemList.push({ id: itemt.dishId, info: itemt });
      }
    });
    item.dishPriInfo = sortDishPrivilegeList(item.dishPriInfo);
  });

  return itemList;
};

exports.setInitMarketUseCouponList = function (obj, activityBenefit, dishes, itemList) {
  var marketUseCouponObj = {};

  (itemList || []).forEach(function (item, index) {
    var marketUseCouponPrice = reorganizedActivityBenefit(activityBenefit, dishes, item.info, true).marketUseCouponPrice;

    marketUseCouponObj[item.id] = marketUseCouponPrice;
  });

  return marketUseCouponObj;
};

exports.addOrderAccountToCoupon = function () {
  var couponList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var orderAccount = arguments[1];

  couponList.forEach(function (item) {
    var _item$fullValue = item.fullValue,
        fullValue = _item$fullValue === undefined ? 0 : _item$fullValue;

    var diffAmount = +(fullValue - orderAccount).toFixed(2);

    (0, _assign2.default)(item, { orderAccount: orderAccount, diffAmount: diffAmount });
  });

  couponList.sort(function (prev, next) {
    return prev.diffAmount - next.diffAmount;
  });
};

/**
 * get timejson between startTime and endTime.
 * @param {Date} startTime
 * @param {Date} startTime
 */
exports.getLaterTime = function () {
  var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

  var timeObject = {};
  var minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

  var startHour = startTime.getHours();
  var endHour = endTime.getHours();
  var endMinute = endTime.getMinutes();

  var startMinute = function () {
    var tmp = Math.ceil(startTime.getMinutes() / 10) * 10;
    if (startTime.getMinutes() % 10 === 0) {
      tmp += 10;
    }

    if (tmp >= 60) {
      startHour = (startHour + 1) % 24;
      tmp = 0;
    }

    return tmp;
  }();

  startMinute = startMinute < 10 ? '00' : startMinute.toString();

  for (var i = 0; startHour + i < 24 && (startHour + i) % 24 <= endHour; i++) {
    var j = (startHour + i) % 24;

    if (j === startHour && startHour === endHour) {
      timeObject[j] = minutes.filter(function (val) {
        return val >= startMinute && val <= endMinute;
      });
    } else if (j === startHour) {
      timeObject[j] = minutes.filter(function (val) {
        return val >= startMinute;
      });
    } else if (j === endHour) {
      timeObject[j] = minutes.filter(function (val) {
        return val <= endMinute;
      });
    } else {
      timeObject[j] = minutes;
    }

    if (timeObject[j].length === 0) {
      delete timeObject[j];
    }
  }

  return timeObject;
};

/**
 * 是否菜品礼品券
 * @param {object} coupon
 */
var isDishGiftCoupon = exports.isDishGiftCoupon = function (coupon) {
  var coupDishBeanList = coupon.coupDishBeanList,
      couponType = coupon.couponType;


  return couponType === _const.CouponTypes.GIFTVALUE && coupDishBeanList && coupDishBeanList.length > 0;
};

var getCardCodeAndCouponIds = exports.getCardCodeAndCouponIds = function () {
  var currentCouponsDetail = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var result = {
    coupons: [],
    cardCodes: [],
    weixinGiftId: '',
    giftDishCoupons: []
  };
  var coupons = result.coupons,
      giftDishCoupons = result.giftDishCoupons;

  var weixinCards = [];

  currentCouponsDetail.forEach(function (coupon) {
    var id = coupon.id,
        weixinValue = coupon.weixinValue;
    // 菜品礼品券

    if (isDishGiftCoupon(coupon)) {
      giftDishCoupons.push(id);
    }

    // 微信礼品券
    if (weixinValue) {
      weixinCards.push(coupon);
    }

    // 筛选除了菜品礼品券之外的券
    if (!giftDishCoupons.some(function (item) {
      return item === id;
    })) {
      coupons.push({
        couponId: id,
        couponType: weixinValue ? _const.CouponSubmitDataTypes.WECHAT : _const.CouponSubmitDataTypes.SYSTEM
      });
    }
  });

  result.cardCodes = weixinCards.map(function (item) {
    return item.codeNumber;
  });

  return result;
};

exports.amendSubmitCouponData = function (coupons, _ref2, giftCouponToDishRelations) {
  var singleDishInfos = _ref2.singleDishInfos,
      multiDishInfos = _ref2.multiDishInfos;

  var ret = {
    coupons: []
  };
  var giftDishCoupons = [];

  coupons.forEach(function (coupon) {
    var coupDishBeanList = coupon.coupDishBeanList,
        id = coupon.id,
        weixinValue = coupon.weixinValue;


    if (isDishGiftCoupon(coupon)) {
      var _coupDishBeanList = (0, _slicedToArray3.default)(coupDishBeanList, 1),
          first = _coupDishBeanList[0];

      giftDishCoupons.push({ id: id, dishId: first.dishId });
    } else {
      ret.coupons.push({
        couponId: id,
        couponType: weixinValue ? _const.CouponSubmitDataTypes.WECHAT : _const.CouponSubmitDataTypes.SYSTEM
      });
    }
  });

  if (!giftDishCoupons.length) {
    return ret;
  }

  var relateCouponIdToDish = function relateCouponIdToDish(dishData) {
    var matchedCouponIds = (giftCouponToDishRelations[dishData.dishId] || []).shift();

    if (matchedCouponIds) {
      return (0, _assign2.default)(dishData, { priGiftId: matchedCouponIds });
    }

    return dishData;
  };

  if (singleDishInfos && singleDishInfos.length) {
    singleDishInfos.forEach(function (dishProp, index) {
      var dishData = Immutable.from(dishProp).asMutable({ deep: true });
      singleDishInfos[index] = relateCouponIdToDish(dishData);
    });
  }

  if (multiDishInfos && multiDishInfos.length) {
    multiDishInfos.forEach(function (dishProp, index) {
      var dishData = Immutable.from(dishProp).asMutable({ deep: true });
      multiDishInfos[index] = relateCouponIdToDish(dishData);
    });
  }

  return ret;
};

var getPayMethod = function getPayMethod(selectedPayMethod) {
  var payMethodScope = selectedPayMethod.id === 'online-payment' ? _const.PayWay.ONLINE : _const.PayWay.OFFLINE;

  return payMethodScope;
};

exports.getSubmitUrlParams = function (state, note, receipt, sellType, consumePassword, taxIdentyNo, scanTableId, isHDL, tableware) {
  var orderedDishesProps = state.orderedDishesProps,
      serviceProps = state.serviceProps,
      commercialProps = state.commercialProps,
      customerProps = state.customerProps,
      tableProps = state.tableProps,
      selectedPayMethod = state.selectedPayMethod,
      orderMemo = state.orderMemo;

  var dishes = orderedDishesProps.dishes;
  var tableIdFromQRCode = sessionStorage.getItem('tableId');

  var _chargeCalcaltor$calc = _index2.default.calc(orderedDishesProps, serviceProps, commercialProps, void 0, isHDL),
      memberPoint = _chargeCalcaltor$calc.memberPoint,
      needPayPrice = _chargeCalcaltor$calc.real;

  var integral = serviceProps.integralsInfo && serviceProps.integralsInfo.isChecked ? memberPoint.integralInUsed : 0;
  var payMethodScope = getPayMethod(selectedPayMethod);
  var sourceChild = (0, _dishHelper.getUrlParam)('hdlScence') || (0, _commonHelper.getParamFromSession)('hdlScence') || window.navigator.userAgent;
  var currentCouponsDetail = serviceProps.couponsProps.currentCouponsDetail;

  var useDiscount = !serviceProps.discountProps.inUseDiscount ? 0 : 1;
  var serviceApproach = serviceProps.isPickupFromFrontDesk && serviceProps.isPickupFromFrontDesk.isChecked ? 'pickup' : 'totable';

  var _getCardCodeAndCoupon = getCardCodeAndCouponIds(currentCouponsDetail),
      cardCodes = _getCardCodeAndCoupon.cardCodes;

  var tables = tableProps.tables || [];

  if (commercialProps.inputSnackTableCount === 2 && !customerProps.customerCount && serviceApproach === 'totable') {
    return { success: false, msg: (0, _helper.formatMessage)(_order2.default.orderSelectDinnerPeople) };
  }

  // 号牌模式，前台自取，公众号进入，没有tableId，需要选桌台
  if (!tableIdFromQRCode && commercialProps.numberPlateModel && serviceApproach === 'pickup') {
    if (tables.filter(function (table) {
      return table.isChecked;
    }).length === 0) {
      return { success: false, msg: (0, _helper.formatMessage)(_order2.default.orderUnSelectPlate) };
    }
  }

  var tableId = void 0;
  if (type === 'TS' && tableIdFromQRCode) {
    if (serviceApproach && serviceApproach.indexOf('pickup') !== -1) {
      tableId = 0;
    } else {
      tableId = tableIdFromQRCode;
    }
  } else if (type === 'TS' && serviceApproach === 'totable' && tables.length) {
    if (scanTableId) {
      tableId = scanTableId;
    } else if (tables.filter(function (table) {
      return table.isChecked;
    }).length === 0) {
      return serviceProps.serviceApproach.indexOf('pickup') !== -1 && serviceProps.serviceApproach.indexOf('totable') === -1 ? { success: false, msg: (0, _helper.formatMessage)(_order2.default.orderOpenSelfGetSwitch) } : { success: false, msg: (0, _helper.formatMessage)(_order2.default.orderUnSelectTableInfo) };
    } else {
      tableId = tables.filter(function (table) {
        return table.isChecked;
      })[0].synFlag;
    }
  } else if (type === 'TS' && serviceApproach && serviceApproach.indexOf('pickup') !== -1 || type === 'WM') {
    tableId = 0;
  } else {
    return { success: false, msg: (0, _helper.formatMessage)(_order2.default.ordernoTablePrompt) };
  }
  var newSourceChild = (0, _orderSourceHelper.getBrowserCode)(sourceChild);
  var params = {
    shopId: shopId,
    useDiscount: useDiscount,
    memo: note,
    needPayPrice: needPayPrice,
    payMethod: payMethodScope,
    invoice: receipt,
    consumePassword: consumePassword,
    taxIdentyNo: taxIdentyNo,
    sourceChild: newSourceChild
  };

  if (serviceProps.couponsProps.privateRoom) {
    params.yaZuoIntegral = Number(integral);
  } else {
    params.integral = Number(integral);
  }

  (0, _assign2.default)(params, getSubmitDishData(dishes || [], parseInt(params.shopId, 10) || 0, customerProps));

  // if (payMethodScope === '1' && cardCodes.length) {
  // 要让 快餐和外卖不走这条线 snail
  if ((type === 'WM' || !(0, _commonHelper.isFormalMeal)(commercialProps.diningForm)) && payMethodScope === '1' && cardCodes.length) {
    return needPayPrice === 0 ? {
      success: false,
      msg: (0, _helper.formatMessage)(_activate2.default.activateCardSorry) + '\uFF0C' + sessionStorage.getItem('currency') + '0' + (0, _helper.formatMessage)(_order2.default.orderCannotUseWXCard)
    } : { success: false, msg: (0, _helper.formatMessage)(_order2.default.orderCannotUsePrompt) };
  }

  if (type === 'WM') {
    var sendAreaId = state.serviceProps.sendAreaId === -1 ? 0 : state.serviceProps.sendAreaId;
    var selectedDateTime = sellType === 'ws' ? state.timeProps.onlyPromptlyDelivery === 1 ? { date: '', time: '' } : state.timeProps.selectedDateTime : state.timePropsZt.selectedDateTime;
    var selectedAddress = null;
    var isSelfFetch = false;

    // 设置餐具数量
    if (isHDL && tableware === 0) {
      params.memo = '\u65E0\u9700\u9910\u5177' + (note.length ? '，' : '') + note;
    }

    // 只要是海底捞外卖就传这个参数
    if (isHDL) {
      params.dinnerwareNum = tableware || 0;
    }

    if (sellType === 'zt' && !selectedDateTime.date) {
      return { success: false, msg: (0, _helper.formatMessage)(_order2.default.orderNoUseableShopTime) };
    }

    if (state.customerProps.addresses instanceof Array && state.customerProps.addresses.length) {
      selectedAddress = state.customerProps.addresses.find(function (address) {
        return address.isChecked;
      });
    }

    if (!selectedAddress && sellType === 'ws') {
      return { success: false, msg: (0, _helper.formatMessage)(_address2.default.addressselectAddress) };
    } else if (selectedAddress && sellType === 'ws') {
      if (!state.timeProps.selectedDateTime.time) {
        if (state.timeProps.onlyPromptlyDelivery !== _const.OnlyPromptlyDelivery.OPEN) {
          // 未开启尽快送达-且没选时间则提示必须选时间
          return { success: false, msg: (0, _helper.formatMessage)(_address2.default.selectDeliveryArriveTime) };
        }
      }
      var validateAddressResult = validateAddressInfo(selectedAddress, true, function (key) {
        return ['baseAddress', 'street'].indexOf(key) !== -1;
      });
      if (!validateAddressResult.valid) {
        return { success: false, msg: validateAddressResult.msg };
      }

      var sex = selectedAddress.sex;
      isSelfFetch = selectedAddress.id === 0;

      if (!selectedDateTime.date && sellType === 'ws' && state.timeProps.onlyPromptlyDelivery === 0) {
        return {
          success: false,
          msg: '' + (0, _helper.formatMessage)(_order2.default.orderHelperSelect) + (isSelfFetch ? (0, _helper.formatMessage)(_dinnerDetail2.default.takeMeal) : (0, _helper.formatMessage)(_order2.default.orderArrived)) + (0, _helper.formatMessage)(_order2.default.orderHelperTime)
        };
      }

      var toShopFlag = isSelfFetch ? 1 : 0;
      var mobile = selectedAddress.mobile.toString();

      if (mobile.indexOf('4') === 0 && mobile.length === 9) {
        mobile = '0' + mobile;
      }

      var latitude = selectedAddress.latitude || 0;
      var longitude = selectedAddress.longitude || 0;

      (0, _assign2.default)(params, {
        name: selectedAddress.name,
        nationalCode: selectedAddress.nationalCode,
        mobile: mobile,
        sex: sex,
        orderType: 'WM',
        address: isSelfFetch ? '' : selectedAddress.address,
        memberAddressId: String(selectedAddress.id),
        sendAreaId: sellType === 'ws' ? String(sendAreaId) : '',
        toShopFlag: toShopFlag,
        latitude: latitude,
        longitude: longitude
      });
    }

    if (selectedDateTime.time) {
      params.time = (selectedDateTime.date + ' ' + selectedDateTime.time).trim();
      // 选了立即送达
      if (isNaN(selectedDateTime.time.slice(0, 2) * 1)) {
        params.deliveryArriveTime = (0, _moment2.default)(((0, _moment2.default)().unix() + state.timeProps.averageSendTime * 60) * 1000).format('HH:mm');
      } else {
        params.deliveryArriveTime = selectedDateTime.time;
      }
    } else {
      // 开启尽快送达-获取送达时间传给后端用于计算服务费
      if (state.timeProps.onlyPromptlyDelivery === _const.OnlyPromptlyDelivery.OPEN) {
        params.deliveryArriveTime = (0, _moment2.default)(state.timeProps.preDeliveryTime * 1).format('HH:mm');
      }
    }
  } else {
    var _state$timePropsTS$se = state.timePropsTS.selectedDateTime,
        date = _state$timePropsTS$se.date,
        time = _state$timePropsTS$se.time;

    var _sex = +String(state.customerProps.sex) || '';
    var currentDate = new Date();
    var year = currentDate.getFullYear();
    var day = currentDate.getDate();
    var month = currentDate.getMonth() + 1;
    var takeMealtime = date && time ? year + '-' + month + '-' + day + ' ' + date + ':' + time : null;

    (0, _assign2.default)(params, {
      name: state.customerProps.name || '',
      mobile: state.customerProps.mobile,
      sex: _sex,
      orderType: 'TS',
      tableId: tableId,
      peopleCount: state.customerProps.customerCount,
      serviceApproach: serviceApproach,
      takeMealtime: takeMealtime
    });
  }

  // 最后校验订单备注
  if (orderMemo.switchStatus && !note.length) {
    return { success: false, msg: (0, _helper.formatMessage)(_order2.default.orderMemoIsRequired) };
  }
  return { success: true, params: params, needPayPrice: needPayPrice };
};

/**
 * 下单人数范围
 */
exports.getCustomerRange = function (customerRange) {
  return Array.apply(null, { length: customerRange }).map(function (item, index) {
    return {
      id: index + 1,
      name: index + 1,
      isChecked: false
    };
  });
};

/**
 * 获取整单优惠的原则状态
 */
exports.getWholeOrderBenefitWordWithColor = function (applyProductType) {
  var _ApplyProductType$ALL;

  var wholeOrderBenefitWord = (_ApplyProductType$ALL = {}, (0, _defineProperty3.default)(_ApplyProductType$ALL, _const.ApplyProductType.ALLPRODUCT, '所有商品可用'), (0, _defineProperty3.default)(_ApplyProductType$ALL, _const.ApplyProductType.PARTPRODUCT, '部分商品可用'), (0, _defineProperty3.default)(_ApplyProductType$ALL, _const.ApplyProductType.NOTPARTPRODUCT, '部分商品不可用'), _ApplyProductType$ALL)[applyProductType];
  var checkBenefitWordColor = applyProductType === _const.ApplyProductType.PARTPRODUCT || applyProductType === _const.ApplyProductType.NOTPARTPRODUCT;

  return { wholeOrderBenefitWord: wholeOrderBenefitWord, checkBenefitWordColor: checkBenefitWordColor };
};

/**
 * getmMarketUseCouponPrice 叠加 MarketUseCouponPrice
 */
exports.getmMarketUseCouponPrice = function (marketUseCouponObj) {
  var marketUseCouponPrice = 0;
  for (var i in marketUseCouponObj) {
    if (marketUseCouponObj[i]) {
      marketUseCouponPrice += Number(marketUseCouponObj[i]);
    }
  }

  return marketUseCouponPrice;
};

var getBenefitTitle = function getBenefitTitle(_ref3, justRule, superimpose, dishesCount) // 在活动列表内的商品数量
{
  var benefitName = _ref3.benefitName,
      benefitType = _ref3.benefitType,
      discount = _ref3.discount,
      reduce = _ref3.reduce,
      typeOfBenefit = _ref3.type,
      marketRuleDtos = _ref3.marketRuleDtos,
      dishNum = _ref3.dishNum,
      consumeLimit = _ref3.consumeLimit,
      matched = _ref3.matched,
      diff = _ref3.diff,
      benefitDishes = _ref3.benefitDishes,
      stackRule = _ref3.stackRule,
      freeNum = _ref3.freeNum,
      totalDishCount = _ref3.totalDishCount;

  var fulledText = (0, _helper.formatMessage)(_order2.default.orderfulled); // 已满
  var dishCountText = (0, _helper.formatMessage)(_dishMenu2.default.dishCount); // 份
  var lessText = (0, _helper.formatMessage)(_order2.default.less); // 还差
  var canText = (0, _helper.formatMessage)(_order2.default.can); // 可
  var alreadyText = (0, _helper.formatMessage)(_order2.default.already); // 已
  var yuanText = (0, _helper.formatMessage)(_order2.default.yuan); // 元
  var fullText = (0, _helper.formatMessage)(_order2.default.full); // 满
  var enjoyText = (0, _helper.formatMessage)(_order2.default.enjoy); // 享
  var reduceText = (0, _helper.formatMessage)(_order2.default.reduce); // 减
  var discountText = (0, _helper.formatMessage)(_order2.default.discount); // 折
  var addText = (0, _helper.formatMessage)(_order2.default.add); // 加
  var chooseText = (0, _helper.formatMessage)(_order2.default.choose); // 选
  var buyText = (0, _helper.formatMessage)(_order2.default.yuanBuy); // 元换购商品
  var giftsText = (0, _helper.formatMessage)(_order2.default.gifts); // 份赠品
  var nextText = (0, _helper.formatMessage)(_order2.default.next); // 下一份
  var lowestPriceText = (0, _helper.formatMessage)(_order2.default.lowestPrice); // 最低价
  var everyText = (0, _helper.formatMessage)(_order2.default.every); // 每
  var limitFreeText = '限免'; // 限免
  var addIngredientText = '加料'; // 加料

  diff = (0, _commonHelper.formatPrice)(diff);

  var title = '';
  if (benefitType === _const.MEMBER_PRICE) {
    title = benefitName;
  }

  if (benefitType === _const.LIMIT_PROMOTIONS) {
    if (justRule) {
      // 每满 1 份 限免2份加料
      title = '' + everyText + fullText + '1' + dishCountText + '\uFF0C' + limitFreeText + dishNum + dishCountText + addIngredientText;
    } else {
      // 已满3份，已限免6份加料
      title = '' + fulledText + totalDishCount + dishCountText + '\uFF0C' + alreadyText + limitFreeText + freeNum + dishCountText + addIngredientText;
    }
  }

  // 单商品只有满量促销
  if (benefitType === _const.SINGLE_PROMOTIONS) {
    var condition = '' + dishNum + dishCountText; // 2份
    // 减8元  享1折
    var action = typeOfBenefit === 1 ? '' + reduceText + reduce + yuanText : '' + enjoyText + discount + discountText;
    if (justRule) {
      title = '' + fullText + condition + action; // 满 2份 减8元/享1折
    } else if (matched) {
      title = '' + fulledText + condition + ', ' + alreadyText + action; // 已满 2份, 已 减8元/享1折
    } else {
      // 满 2份 可 减8元/享1折, 还差 8 份
      title = '' + fullText + condition + canText + action + ', ' + lessText + diff + dishCountText;
    }
  }

  // 多商品只有满额促销
  if (benefitType === _const.MULTI_PROMOTIONS) {
    var _condition = '' + consumeLimit + yuanText; // 100元
    // 减100元   享8折
    var _action = typeOfBenefit === 1 ? '' + reduceText + reduce + yuanText : '' + enjoyText + discount + discountText;
    if (justRule) {
      title = '' + fullText + _condition + _action; // 满 100元 减100元/享8折
    } else if (matched) {
      title = '' + fulledText + _condition + ', ' + alreadyText + _action; // 已满 100元, 已 减100元/享8折
    } else {
      title = '' + fullText + _condition + _action + ', ' + lessText + diff + yuanText; // 满 100元 减100元/享8折, 还差 50 元
    }
  }

  // 满额，满量促销都有
  if (benefitType === _const.FULL_PROMOTIONS) {
    var _marketRuleDtos$ = marketRuleDtos[0],
        ruleSubjectId = _marketRuleDtos$.ruleSubjectId,
        policySubjectId = _marketRuleDtos$.policySubjectId,
        logicValue = _marketRuleDtos$.logicValue,
        policyValue1 = _marketRuleDtos$.policyValue1;

    var chosenDishNum = (0, _dishHelper.countDishesNumber)(benefitDishes);
    var _condition2 = '' + logicValue + (ruleSubjectId === 11 ? dishCountText : yuanText);
    var _action2 = policySubjectId === 17 ? '' + addText + policyValue1 + buyText : '' + chooseText + (chosenDishNum || superimpose || policyValue1) + giftsText;
    if (justRule) {
      title = '' + fullText + _condition2 + canText + _action2;
    } else if (matched) {
      title = '' + fulledText + _condition2 + ', ' + (chosenDishNum > 0 ? alreadyText : canText) + _action2;
    } else {
      title = '' + fullText + _condition2 + _action2 + ', ' + lessText + diff + (ruleSubjectId === 11 ? dishCountText : yuanText);
    }
  }

  if (benefitType === _const.FULL_COUNT_PROMOTIONS) {
    var _marketRuleDtos$2 = marketRuleDtos[0],
        _logicValue = _marketRuleDtos$2.logicValue,
        _policyValue = _marketRuleDtos$2.policyValue1,
        productType = _marketRuleDtos$2.productType;

    var isSingle = productType === 1;
    // 多商品，可叠加，计算出可以有多少份享受折扣
    var hasBenefitCount = stackRule && dishesCount ? Math.floor(dishesCount / (_logicValue + 1)) : 1;
    var conditionValue = (isSingle ? _logicValue : _logicValue + 1) * (hasBenefitCount || 1);
    var prefix = matched && dishesCount >= conditionValue ? '' + fulledText + conditionValue + dishCountText : '' + lessText + (isSingle ? diff : diff + 1) + dishCountText;
    var suffix = isSingle ? nextText : '' + lowestPriceText + (hasBenefitCount || 1) + dishCountText;
    var _action3 = matched && dishesCount > _logicValue ? alreadyText : canText;

    if (justRule) {
      title = '' + (stackRule ? everyText : '') + fullText + conditionValue + dishCountText + ', ' + suffix + enjoyText + _policyValue + discountText;
    } else {
      title = prefix + ', ' + suffix + _action3 + enjoyText + _policyValue + discountText;
    }
  }

  return title;
};

exports.getBenefitTitle = getBenefitTitle;

/**
 * 判断加入商品后是否满足优惠
 * @param {*} benefit 优惠实例
 * @param {*} dishes 符合优惠实例规则的商品列表
 */
var isMatchBenefit = function isMatchBenefit(benefit, dishes) {
  var benefitType = benefit.benefitType;

  var totalPrice = (0, _dishHelper.getDishesBasePrice)(dishes);
  var totalNum = (0, _dishHelper.countDishesNumber)(dishes);

  var matched = false;
  var diff = 0;

  if (benefitType === _const.LIMIT_PROMOTIONS) {
    // 限免
    matched = benefit.totalDishCount > 0; // 只要被免价>0 则表示匹配
    diff = 0;
  }

  if (benefitType === _const.MULTI_PROMOTIONS) {
    matched = benefit.consumeLimit <= totalPrice;
    diff = matched ? 0 : benefit.consumeLimit - totalPrice;
  }

  if (benefitType === _const.FULL_PROMOTIONS || benefitType === _const.FULL_COUNT_PROMOTIONS) {
    var marketRuleDtos = benefit.marketRuleDtos;
    var _marketRuleDtos$3 = marketRuleDtos[0],
        ruleSubjectId = _marketRuleDtos$3.ruleSubjectId,
        logicValue = _marketRuleDtos$3.logicValue;
    // ruleSubjectId 11.满额 12.满量

    if (ruleSubjectId === 11 && totalNum >= logicValue || ruleSubjectId === 12 && totalPrice >= logicValue) {
      matched = true;
    } else {
      diff = logicValue - (ruleSubjectId === 11 ? totalNum : totalPrice);
    }
  }

  if (benefitType === _const.SINGLE_PROMOTIONS) {
    var dishNum = benefit.dishNum;

    matched = totalNum >= dishNum;
    diff = matched ? 0 : dishNum - totalNum;
  }

  if (benefitType === _const.MEMBER_PRICE) {
    matched = true;
  }

  return {
    matched: matched,
    diff: diff
  };
};

exports.isMatchBenefit = isMatchBenefit;

exports.transformSinglePromotions = function (list) {
  var allActivities = list.reduce(function (all, curr) {
    return all.concat(curr.dishPriInfo.map(function (pri) {
      pri.dishId = curr.dishId;
      return pri;
    }));
  }, []);

  var uniqList = uniqBy(allActivities, 'planId').map(function (item) {
    var benefit = (0, _extends3.default)({}, item, {
      benefitKey: item.planId,
      benefitId: item.planId,
      benefitName: item.priName,
      benefitType: _const.SINGLE_PROMOTIONS,
      canUseDishIds: [item.dishId],
      dishKeys: [],
      matched: false,
      diff: 0, // 如果不满足条件的差值
      conflicted: false
      // shared: true, // 活动配置
    });

    benefit.benefitRuleText = getBenefitTitle(benefit, true);

    return benefit;
  });

  var discountList = uniqList.filter(function (item) {
    return item.type === 2;
  }).sort(function (a, b) {
    return a.discount - b.discount;
  });
  var reduceList = uniqList.filter(function (item) {
    return item.type === 1;
  }).sort(function (a, b) {
    return b.reduce - a.reduce;
  });

  return reduceList.concat(discountList);
};

// 限免优惠只对非套餐加料有效
var isIngredientDish = function isIngredientDish(dish) {
  var _ref4 = dish || {},
      order = _ref4.order,
      groups = _ref4.groups,
      _ref4$dishIngredientI = _ref4.dishIngredientInfos,
      dishIngredientInfos = _ref4$dishIngredientI === undefined ? [] : _ref4$dishIngredientI;

  if (typeof order === 'number' || groups) return false;
  return !!dishIngredientInfos.length;
};
// 在所有菜品中筛选出参加限免的菜品（只要某个被选中的配料中包含限免配料dishBrandIds 则默认此菜参加限免活动）
var getLimitDishes = function getLimitDishes() {
  var divideDishes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var dishBrandIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var dishNum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!divideDishes) return {};
  var limitCanUseIdsObj = {};
  var allFree = [];
  var totalDishCount = 0;

  divideDishes.forEach(function () {
    var dish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var order = dish.order;

    if (!isIngredientDish(dish) || !Array.isArray(order)) return;
    order.forEach(function () {
      var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var count = o.count,
          _o$dishIngredientInfo = o.dishIngredientInfos,
          dishIngredientInfos = _o$dishIngredientInfo === undefined ? [] : _o$dishIngredientInfo;
      // 此处item.id -> item.dishBrandId

      var checkedIngredientList = dishIngredientInfos.filter(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return item.isChecked && dishBrandIds.indexOf(item.dishBrandId) > -1;
      });
      totalDishCount = totalDishCount + (!!checkedIngredientList.length ? count : 0);
      if (!!checkedIngredientList.length) {
        dishIngredientInfos.forEach(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          // 此处item.id -> item.dishBrandId
          if (item.isChecked && dishBrandIds.indexOf(item.dishBrandId) > -1) {
            var _allFree;

            limitCanUseIdsObj[dish.key] = true;
            var freeList = (0, _from2.default)({ length: count }).map(function (_item) {
              return (0, _defineProperty3.default)({}, item.dishBrandId, item.reprice);
            });
            (_allFree = allFree).push.apply(_allFree, (0, _toConsumableArray3.default)(freeList));
          }
        });
      }
    });
  });

  allFree = allFree.sort(function (a, b) {
    return (0, _values2.default)(a)[0] - (0, _values2.default)(b)[0];
  }); // 限免从低价开始
  var shouldFreeNum = totalDishCount * dishNum; // 应该限免的份数
  var freeNum = allFree.length >= shouldFreeNum ? shouldFreeNum : allFree.length; // 实际限免份数
  var reduce = allFree.slice(0, freeNum).reduce(function (all, curr) {
    return all + (0, _values2.default)(curr)[0];
  }, 0);

  return {
    limitCanUseIds: (0, _keys2.default)(limitCanUseIdsObj), // 可以使用限免的菜品key
    totalDishCount: totalDishCount, // 可使用限免菜品的总份数
    freeNum: freeNum, // 被减免的加料总份数
    reduce: reduce // 被减免加料的总金额
  };
};
exports.getLimitDishes = getLimitDishes;

// 重新计算限免优惠
exports.reCalLimitFree = function (state) {
  var divideDishes = state.divideDishes,
      _state$onSelectBenefi = state.onSelectBenefitDish,
      currentBenefit = _state$onSelectBenefi.currentBenefit,
      dishKey = _state$onSelectBenefi.dishKey,
      allBenefits = state.allBenefits;


  var updateKeys = currentBenefit.dishKeys.filter(
  // 当前优惠组内剩下的菜品key
  function (key) {
    return key !== dishKey;
  });
  var currentDishes = divideDishes.filter(
  // 当前优惠组内剩下的菜品
  function (dish) {
    return updateKeys.indexOf(dish.key) > -1;
  });

  var limitPromotion = allBenefits[_const.LIMIT_PROMOTIONS] && allBenefits[_const.LIMIT_PROMOTIONS].length && allBenefits[_const.LIMIT_PROMOTIONS][0];
  if (!limitPromotion) return [];

  var _ref6 = limitPromotion || {},
      dishBrandIds = _ref6.dishBrandIds,
      dishNum = _ref6.dishNum;

  var _getLimitDishes = getLimitDishes(currentDishes, dishBrandIds, dishNum),
      totalDishCount = _getLimitDishes.totalDishCount,
      freeNum = _getLimitDishes.freeNum,
      reduce = _getLimitDishes.reduce;

  return [(0, _extends3.default)({}, limitPromotion, {
    dishKeys: updateKeys,
    totalDishCount: totalDishCount,
    freeNum: freeNum,
    reduce: reduce
  })];
};
// 清除groups中所有的优惠商品
exports.clearPromotion = function (state, groups) {
  groups.forEach(function (bType) {
    state = state.updateIn(['allBenefits', bType], function (benefits) {
      return benefits.flatMap(function (benefit) {
        return benefit.merge(bType === _const.LIMIT_PROMOTIONS ? {
          totalDishCount: 0,
          freeNum: 0,
          reduce: 0,
          dishKeys: [],
          matched: false,
          conflicted: false,
          diff: 0,
          benefitDishes: []
        } : {
          dishKeys: [],
          matched: false,
          conflicted: false,
          diff: 0,
          benefitDishes: []
        });
      });
    });
  });
  return state;
};

// 限免优惠
exports.transformLimitPromotions = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var divideDishes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var _data$planId = data.planId,
      planId = _data$planId === undefined ? '' : _data$planId,
      _data$dishNum = data.dishNum,
      dishNum = _data$dishNum === undefined ? 0 : _data$dishNum,
      _data$dishBrandIds = data.dishBrandIds,
      dishBrandIds = _data$dishBrandIds === undefined ? [] : _data$dishBrandIds;

  if (!dishBrandIds.length) return [];

  var _getLimitDishes2 = getLimitDishes(divideDishes, dishBrandIds, dishNum),
      limitCanUseIds = _getLimitDishes2.limitCanUseIds,
      totalDishCount = _getLimitDishes2.totalDishCount,
      freeNum = _getLimitDishes2.freeNum,
      reduce = _getLimitDishes2.reduce;

  var benefit = {
    benefitKey: planId,
    benefitId: planId,
    benefitName: '限免',
    benefitType: _const.LIMIT_PROMOTIONS,
    canUseDishIds: [], // 当前所有菜品中能够使用限免优惠的dish id集合
    dishKeys: [],
    matched: false,
    diff: 0, // 如果不满足条件的差值
    conflicted: false,
    shared: true, // 与优惠券可共用
    dishBrandIds: dishBrandIds,
    limitCanUseIds: limitCanUseIds, // 当前所有菜品中能够使用限免优惠的dish key集合
    totalDishCount: totalDishCount, // 参加活动菜品总份数
    dishNum: dishNum, // 每一份限免份数
    freeNum: freeNum, // 实际限免份数
    reduce: reduce // 限免后应该减去的总价格
  };
  benefit.benefitRuleText = getBenefitTitle(benefit, true);
  return totalDishCount > 0 ? [benefit] : [];
};

exports.transformMultiPromotions = function (list, dishes) {
  var ALLPRODUCT = _const.ApplyProductType.ALLPRODUCT,
      PARTPRODUCT = _const.ApplyProductType.PARTPRODUCT;

  var dishIds = dishes.map(function (dish) {
    return dish.brandDishId;
  });

  var transformedList = list.map(function (item) {
    var limitDishIds = (0, _dishHelper.getDishIds)(item.dishList);
    var applyProductType = item.applyProductType;

    var canUseDishIds = applyProductType === ALLPRODUCT ? dishIds : applyProductType === PARTPRODUCT ? limitDishIds : dishIds.filter(function (id) {
      return limitDishIds.indexOf(id) === -1;
    });
    var benefit = (0, _extends3.default)({}, item, {
      benefitKey: item.planId,
      benefitId: item.planId,
      benefitName: item.ruleName,
      benefitType: _const.MULTI_PROMOTIONS,
      canUseDishIds: canUseDishIds,
      dishKeys: [],
      matched: false,
      diff: 0, // 如果不满足条件的差值
      conflicted: false
      // shared: true, // 活动配置
    });

    benefit.benefitRuleText = getBenefitTitle(benefit, true);

    return benefit;
  });

  var discountList = transformedList.filter(function (item) {
    return item.type === 2;
  }).sort(function (a, b) {
    return a.discount - b.discount;
  });
  var reduceList = transformedList.filter(function (item) {
    return item.type === 1;
  }).sort(function (a, b) {
    return b.reduce - a.reduce;
  });

  return reduceList.concat(discountList);
};

exports.transformFullPromotions = function (list) {
  return list.map(function (item) {
    var benefit = (0, _extends3.default)({}, item, {
      benefitKey: item.id,
      benefitId: item.id,
      benefitName: item.name,
      benefitType: _const.FULL_PROMOTIONS,
      canUseDishIds: item.activityDishes.reduce(function (total, dish) {
        return dish.dishType === 2 ? total.concat(dish.midDishes) : total.concat(dish);
      }, []).map(function (dish) {
        return dish.dishId;
      }),
      dishKeys: [],
      benefitDishes: [], // 加价购、赠送的商品
      matched: false,
      diff: 0, // 如果不满足条件的差值
      conflicted: false,
      shared: false // 目前满额，满量促销与优惠券一定互斥
    });

    benefit.benefitRuleText = getBenefitTitle(benefit, true);

    return benefit;
  });
};

exports.transformDiscountCards = function (list) {
  return list.map(function (item) {
    return (0, _extends3.default)({}, item, {
      benefitKey: item.cardNum,
      benefitId: item.cardNum,
      benefitName: item.cardKindName,
      benefitType: _const.DISCOUNT_CARDS,
      canUseDishIds: [], // 暂时为所有商品适用
      dishKeys: [],
      matched: false,
      diff: 0,
      conflicted: false,
      shared: true
    });
  });
};

// 下一份优惠
exports.transformFullCountPromotions = function (list) {
  return list.reduce(function (result, item) {
    var marketRuleDtos = item.marketRuleDtos,
        activityDishes = item.activityDishes;

    var dishes = (activityDishes || []).reduce(function (total, dish) {
      return dish.dishType === 2 ? total.concat(dish.midDishes) : total.concat(dish);
    }, []);

    var _ref7 = (marketRuleDtos || [])[0] || {},
        productType = _ref7.productType;

    var transform = function transform(promotion) {
      var benefit = (0, _extends3.default)({}, promotion, {
        benefitKey: promotion.benefitKey || promotion.id,
        benefitId: promotion.id,
        benefitName: promotion.name,
        benefitType: _const.FULL_COUNT_PROMOTIONS,
        canUseDishIds: promotion.activityDishes.reduce(function (total, dish) {
          return dish.dishType === 2 ? total.concat(dish.midDishes) : total.concat(dish);
        }, []).map(function (dish) {
          return dish.dishId;
        }),
        dishKeys: [],
        benefitDishes: [],
        matched: false,
        diff: 0, // 如果不满足条件的差值
        conflicted: false,
        shared: false // 目前满量（下一份优惠）促销与优惠券一定互斥
      });

      benefit.benefitRuleText = getBenefitTitle(benefit, true);

      return benefit;
    };

    // 如果配置了多个活动商品且活动模式为单商品，拆分为多个活动，每个活动对应一个商品
    if (productType === 1 && dishes.length > 1) {
      result = result.concat(dishes.map(function (dish) {
        return transform((0, _extends3.default)({}, item, {
          benefitKey: item.id + '-' + dish.dishId, // 根据商品拆分活动，需要一个唯一的key
          activityDishes: [dish]
        }));
      }));
    } else {
      result = result.concat(transform(item));
    }

    return result;
  }, []);
};

// 是否叠加，算出可以获赠多少份商品
exports.getSuperimpose = function (benefit, dishes) {
  var stackRule = benefit.stackRule,
      matched = benefit.matched,
      marketRuleDtos = benefit.marketRuleDtos;

  var superimpose = 0;
  if (stackRule && matched && marketRuleDtos && marketRuleDtos[0] && marketRuleDtos[0].policySubjectId === 12) {
    var _marketRuleDtos$4 = marketRuleDtos[0],
        ruleSubjectId = _marketRuleDtos$4.ruleSubjectId,
        policyValue1 = _marketRuleDtos$4.policyValue1,
        logicValue = _marketRuleDtos$4.logicValue;

    // 满量

    if (ruleSubjectId === 11) {
      superimpose = Math.floor((0, _dishHelper.countDishesNumber)(dishes) / logicValue) * policyValue1;
    }
    // 满额
    if (ruleSubjectId === 12) {
      superimpose = Math.floor((0, _dishHelper.getDishesBasePrice)(dishes) / logicValue) * policyValue1;
    }
  }

  return superimpose;
};

// 获取当前使用的是单商品优惠或者多商品优惠
var getCurrentBenefitType = function getCurrentBenefitType(allBenefits) {
  var hasSingle = allBenefits[_const.SINGLE_PROMOTIONS].find(function (item) {
    return item.dishKeys.length > 0;
  });
  var hasMulti = allBenefits[_const.MULTI_PROMOTIONS].find(function (item) {
    return item.dishKeys.length > 0;
  });

  return hasSingle ? _const.SINGLE_PROMOTIONS : hasMulti ? _const.MULTI_PROMOTIONS : '';
};

exports.getCurrentBenefitType = getCurrentBenefitType;

// 海底捞，是否会有单多商品优惠冲突
exports.isBenefitConflict = function (allBenefits, targetType) {
  var mainType = getCurrentBenefitType(allBenefits);

  return mainType ? mainType === _const.SINGLE_PROMOTIONS && targetType === _const.MULTI_PROMOTIONS || mainType === _const.MULTI_PROMOTIONS && targetType === _const.SINGLE_PROMOTIONS : false;
};

// 限免优惠是否会有和其他优惠冲突
exports.isLimitFreeConflict = function (allBenefits) {
  var currentBenefit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var targetType = arguments[2];

  if (!targetType) return false;
  // const otherBenefit = ''; // 有商品的优惠列表
  // const benefitsList = Object.keys(allBenefits)
  //   .filter(key => key !== LIMIT_PROMOTIONS)
  //   .reduce((list, key) => (allBenefits[key] ? list.concat(allBenefits[key]) : list), [])
  //   .filter(benefit => benefit.dishKeys.length);
  var limitBenefitsList = allBenefits[_const.LIMIT_PROMOTIONS].filter(function (benefit) {
    return benefit.dishKeys.length;
  });
  return limitBenefitsList.length || currentBenefit.benefitType === _const.LIMIT_PROMOTIONS || targetType === _const.LIMIT_PROMOTIONS;
};

/**
 * 将商品划分到优惠中去
 * groups 指定目标分组的名称列表
 * specialKeys 指定要划分的商品范围
 */
var groupDishesToBenefit = function groupDishesToBenefit(state, groups, specialKeys) {
  var _state = state,
      allBenefits = _state.allBenefits,
      divideDishes = _state.divideDishes,
      isHDL = _state.customerProps.isHDL;

  var isInit = !specialKeys;
  var hasMulti = false;
  var hasLimitFree = false;
  var dishPool = isInit ? [].concat((0, _toConsumableArray3.default)(divideDishes)) : divideDishes.filter(function (dish) {
    return specialKeys.indexOf(dish.key) > -1;
  });

  groups.forEach(function (benefitType) {
    if (hasLimitFree && benefitType !== _const.LIMIT_PROMOTIONS) return;
    if (hasMulti && isHDL && benefitType === _const.SINGLE_PROMOTIONS) return;

    allBenefits[benefitType].forEach(function (benefit, index) {
      var canUseDishIds = benefit.canUseDishIds,
          _benefit$limitCanUseI = benefit.limitCanUseIds,
          limitCanUseIds = _benefit$limitCanUseI === undefined ? [] : _benefit$limitCanUseI,
          dishKeys = benefit.dishKeys;
      // let availableDishes = dishPool.filter(dish => canUseDishIds.indexOf(dish.brandDishId) > -1);

      var availableDishes = dishPool.filter(function (dish) {
        return canUseDishIds.indexOf(dish.brandDishId) > -1 || limitCanUseIds.indexOf(dish.key) > -1;
      });
      if (!isInit && dishKeys.length) {
        availableDishes = availableDishes.concat(divideDishes.filter(function (dish) {
          return dishKeys.indexOf(dish.key) > -1;
        }));
      }

      var _isMatchBenefit = isMatchBenefit(benefit, availableDishes),
          matched = _isMatchBenefit.matched;

      // 满足活动条件，将商品划分到活动中


      if (matched) {
        var keys = availableDishes.map(function (dish) {
          return dish.key;
        });
        state = state.setIn(['allBenefits', benefitType, index, 'dishKeys'], keys).setIn(['allBenefits', benefitType, index, 'matched'], matched);
        // 将设置到活动中的商品剔除
        dishPool = dishPool.filter(function (dish) {
          return keys.indexOf(dish.key) === -1;
        });

        if (benefitType === _const.LIMIT_PROMOTIONS) {
          // 限免与其他所有活动互斥
          hasLimitFree = true;
        }

        // 记录是否有多商品活动满足条件，后续海底捞就不再划分商品到单商品活动中
        if (benefitType === _const.MULTI_PROMOTIONS) {
          hasMulti = true;
        }
      } else if (isInit) {
        // 切换tab的时候要重置内容
        state = state.setIn(['allBenefits', benefitType, index, 'dishKeys'], []).setIn(['allBenefits', benefitType, index, 'matched'], false);
      }

      if (isInit) {
        state = state.setIn(['allBenefits', benefitType, index, 'benefitDishes'], []).setIn(['allBenefits', benefitType, index, 'conflicted'], false).setIn(['allBenefits', benefitType, index, 'diff'], 0);
      }
    });
  });

  return {
    state: state,
    dishPool: dishPool
  };
};

exports.groupDishesToBenefit = groupDishesToBenefit;

exports.transferBenefitDishes = function (state, benefitType, groups) {
  var keys = [];

  var newState = state.updateIn(['allBenefits', benefitType], function (list) {
    return list.flatMap(function (item) {
      keys = keys.concat(item.dishKeys);
      return item.merge({
        dishKeys: [],
        conflicted: false,
        matched: false,
        diff: 0
      });
    });
  });

  if (keys.length) {
    groups = groups.filter(function (item) {
      return item !== benefitType;
    });

    var _groupDishesToBenefit = groupDishesToBenefit(newState, groups, keys),
        updatedState = _groupDishesToBenefit.state,
        dishPool = _groupDishesToBenefit.dishPool;

    newState = updatedState.setIn(['pureDishes'], updatedState.pureDishes.concat(dishPool));
  }

  return newState;
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(125);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(276);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { getOSVersionInfo } from '../../helper/common-helper.js';

function protocolIsHttps() {
  return location.protocol === 'https:';
}

function getImageHttpsProtocolUrl(src) {
  if (!src) {
    return src;
  }
  var prevOldCdn = 'http://kry-official.qiniudn.com'; // 最老的cdn
  var oldCdn = 'https://img.keruyun.net'; // 七牛cdn
  var newCdn = 'https://img-static.keruyun.com'; // 阿里cdn
  var url = src;

  if (/^http:\/\/img\.keruyun\.(net|com)/i.test(url)) {
    url = url.replace('http://', 'https://');
  }

  if (url.indexOf(prevOldCdn) === 0) {
    url = url.replace(prevOldCdn, newCdn);
  }

  if (url.indexOf(oldCdn) === 0) {
    url = url.replace(oldCdn, newCdn);
  }

  return url;
}

var HttpsProtocolImage = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(HttpsProtocolImage, _React$Component);
  (0, _createClass3.default)(HttpsProtocolImage, null, [{
    key: 'getFinalImageUrl',
    value: function getFinalImageUrl(url) {
      if (!protocolIsHttps()) {
        return url;
      }

      /*
      const osInfo = getOSVersionInfo();
      if (osInfo.os === 'iphone' && osInfo.version >= 10) {
        return getImageHttpsProtocolUrl(url);
      }
       return url;
      */
      return getImageHttpsProtocolUrl(url);
    }
  }]);

  function HttpsProtocolImage(props) {
    (0, _classCallCheck3.default)(this, HttpsProtocolImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HttpsProtocolImage.__proto__ || (0, _getPrototypeOf2.default)(HttpsProtocolImage)).call(this, props));

    Object.defineProperty(_this, 'handleImageLoadError', {
      enumerable: true,
      writable: true,
      value: function value(event) {
        var target = event.target;
        var loadErrorImageSrc = _this.props.loadErrorImageSrc;


        if (_this._loadedImages.indexOf(target.src) !== -1) {
          return;
        }

        _this._loadedImages.push(target.src);
        if (loadErrorImageSrc) {
          target.src = loadErrorImageSrc;
        }
      }
    });

    _this._loadedImages = [];
    return _this;
  }

  (0, _createClass3.default)(HttpsProtocolImage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          alt = _props.alt,
          className = _props.className,
          style = _props.style,
          role = _props.role,
          bgImg = _props.bgImg;

      var finalUrl = HttpsProtocolImage.getFinalImageUrl(src);

      if (!finalUrl) {
        return _react2.default.createElement('span', { className: className, style: style });
      }

      if (bgImg) {
        return _react2.default.createElement('div', {
          className: className,
          alt: alt,
          onError: this.handleImageLoadError,
          role: role,
          style: (0, _assign2.default)(style, { backgroundImage: 'url(' + finalUrl + ')' })
        });
      }

      return _react2.default.createElement('img', {
        className: className,
        src: finalUrl,
        alt: alt,
        onError: this.handleImageLoadError,
        style: style,
        role: role
      });
    }
  }]);
  return HttpsProtocolImage;
}(_react2.default.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    src: _react2.default.PropTypes.string,
    alt: _react2.default.PropTypes.string,
    role: _react2.default.PropTypes.string,
    className: _react2.default.PropTypes.string,
    loadErrorImageSrc: _react2.default.PropTypes.string,
    style: _react2.default.PropTypes.object,
    bgImg: _react2.default.PropTypes.bool
  }
}), _temp);
exports.default = HttpsProtocolImage;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(128);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _commonHelper = __webpack_require__(3);

var _config = __webpack_require__(13);

var _wxMiniprogramHelper = __webpack_require__(113);

var _wxMiniprogramHelper2 = _interopRequireDefault(_wxMiniprogramHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var interceptor = {
  handlers: {},

  add: function add(url, handler) {
    var _this = this;

    var urls = [].concat(url);

    urls.forEach(function (item) {
      _this.handlers[item] = handler;
    });
  },
  exec: function exec(url, params) {
    var fixedUrl = url.replace(/^https?:\/\//, '').split('/').slice(1).join('/');

    var handler = this.handlers['/' + fixedUrl];
    if (!handler || !_wxMiniprogramHelper2.default.isMiniProgramMode() || !_wxMiniprogramHelper2.default.isNewMiniprogram()) {
      return false;
    }

    for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      rest[_key - 2] = arguments[_key];
    }

    handler.apply(undefined, [url, params].concat(rest));

    return true;
  }
};

// 支付页
interceptor.add('/shop/payDetail', function (url, params) {
  _wxMiniprogramHelper2.default.navigateTo('/pages/pay/checkout', params);
});

// 登录页
interceptor.add(['/user/notLogin', '/user-login.html'], function (url, params) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'navigateTo';

  _wxMiniprogramHelper2.default[method]('/pages/login/index', params);
});

var pageHelper = {
  navigateTo: function navigateTo(url, params) {
    // TODO: 暂时屏蔽掉拦截器。所有都还是走h5
    if (interceptor.exec(url, params) === true) {
      return;
    }
    console.log('--------navigateTo', url);
    location.href = url + '?' + (0, _commonHelper.formatObjToParamStr)(params);
  },
  redirectWhenInit: function redirectWhenInit() {
    var params = (0, _commonHelper.getUrlParams)();

    return interceptor.exec(location.pathname, params, 'redirectTo');
  },
  navigateToLoginPage: function navigateToLoginPage(params) {
    try {
      // 此处接入支付宝小程序
      if ((0, _commonHelper.isAlipayMiniProgramBrowser)()) {
        __webpack_require__(126).aliPageHelper.navigateToLoginPage(params);
        return;
      }

      var tableId = sessionStorage.getItem('tableId');
      var tableQuery = '';
      if (tableId) {
        tableQuery = '&tableId=' + tableId;
      }

      var finalParams = (0, _extends3.default)({
        returnUrl: encodeURIComponent('' + location.href + tableQuery)
      }, params);

      this.navigateTo(_config.logAddressURL, finalParams);
    } catch (ex) {
      console.log('--------navigateToLoginPage ex', ex);
    }
  }
};

exports.default = pageHelper;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPageTypeFromUrl = undefined;

var _regenerator = __webpack_require__(110);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(111);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _divolte = __webpack_require__(242);

var _divolte2 = _interopRequireDefault(_divolte);

var _divolteCommonInfo = __webpack_require__(247);

var _commonHelper = __webpack_require__(3);

var _globalBuryingPoint = __webpack_require__(248);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isGldOrTestOrDevEvn() {
  return (/^(ci)?test/i.test(location.hostname) || /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(location.hostname) || /^(dev|gld)/i.test(location.hostname)
  );
}
/*
  暂时只统计pageview事件, 屏蔽所有的点击事件统计
*/

var configs = [{ xpath: 'none' }];

var EXCLUDE_EVENT = ['error', 'click', 'performance-timing', 'resource-timing'];
var EVN_SCRIPT_MAP = {
  prod: {
    // url: 'https://divolte.keruyun.com/portal/divolte.js',
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    validator: function validator() {
      return (/^weixin/i.test(location.hostname)
      );
    }
  },
  test: {
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    // url: 'https://citestbigdata-kry-divolte-private.shishike.com/portal/divolte.js',
    validator: function validator() {
      return (/^(ci)?test/i.test(location.hostname) || /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(location.hostname)
      );
    }
  },
  dev: {
    url: 'https://divolte.keruyun.com/portal/divolte.js',
    // url: 'https://citestbigdata-kry-divolte-private.shishike.com/portal/divolte.js',
    validator: function validator() {
      return (/^(dev|gld)/i.test(location.hostname)
      );
    }
  }
};
var DEV_MODE = "production" === 'development';

var LOAD_STATUS = {
  willLoad: 'willLoad',
  loaded: 'loaded',
  loadError: 'loadError'
};

var buryingPointConfig = { enableDebug: DEV_MODE, excludeEvent: EXCLUDE_EVENT };

/**
 * 埋点工具
 */

var BuryingPoint = function () {
  function BuryingPoint() {
    (0, _classCallCheck3.default)(this, BuryingPoint);

    this.isGldOrTestOrDevEvn = isGldOrTestOrDevEvn();
    this.dynamicDefaultParamFun = function () {};
    this.setDynamicDefaultParam(_divolteCommonInfo.getDynamicInfo);
    this.setFixedDefaultParam((0, _divolteCommonInfo.getFixedInfo)());
    this.defaultParam = {};
    this._init();
  }

  (0, _createClass3.default)(BuryingPoint, [{
    key: '_init',
    value: function _init() {
      var _this = this;

      this.loadStatus = LOAD_STATUS.willLoad;
      // 三个参数。
      // configs 配置信息。配置一些要监听的事件
      // defaultParam {
      //  enableDebug,是否开启调试模式
      //  excludeEvent,排除的监听的默认事件
      // }
      // scriptObj:根据环境加载divolte的script
      var info = this.getDefaultCommonInfo();
      var divoltePromise = (0, _divolte2.default)(configs, (0, _extends3.default)({}, info, buryingPointConfig), EVN_SCRIPT_MAP);
      if (!divoltePromise || !divoltePromise.then) {
        console.error('kry-divolte必须高于1.2.3');
        this.loadStatus = LOAD_STATUS.loadError;
        return null;
      }
      this.divoltePromise = divoltePromise.then(function (data) {
        _this.loadStatus = LOAD_STATUS.loaded;
      }).catch(function (ex) {
        _this.loadStatus = LOAD_STATUS.loadError;
        console.error(ex);
      });
    }
  }, {
    key: 'getToolObj',
    value: function getToolObj() {
      if (this.loadStatus === LOAD_STATUS.willLoad) {
        return this.divoltePromise;
      } else if (this.loadStatus === LOAD_STATUS.loaded) {
        return _promise2.default.resolve();
      }
      return _promise2.default.reject(new Error('无法加载divolte对象'));
    }
    /**
     * 获取默认信息
     * 1、界面固定的信息
     * 2、界面可能发生变化的信息
     * 3、界面路径带的参数（为了和kry-divolte保持一致）
     */

  }, {
    key: 'getDefaultCommonInfo',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var fixedInfo, dynamicInfo, urlParams;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fixedInfo = this.defaultFixedParam || {};

                if (!this.dynamicDefaultParamFun) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return this.dynamicDefaultParamFun();

              case 4:
                _context.t0 = _context.sent;
                _context.next = 8;
                break;

              case 7:
                _context.t0 = {};

              case 8:
                dynamicInfo = _context.t0;
                urlParams = (0, _commonHelper.getUrlParams)() || {};
                return _context.abrupt('return', (0, _extends3.default)({}, urlParams, fixedInfo, dynamicInfo));

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDefaultCommonInfo() {
        return _ref.apply(this, arguments);
      }

      return getDefaultCommonInfo;
    }()

    /**
     * 发送信息
     * @param {*} eventType
     * @param {*} param
     */

  }, {
    key: 'send',
    value: function send(eventType) {
      var _this2 = this;

      var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.getToolObj().then(function (data) {
        return _this2.getDefaultCommonInfo();
      }).then(function (info) {
        var sendInfo = (0, _extends3.default)({}, info, param || {}, { eventType: eventType });
        if (_this2.isGldOrTestOrDevEvn) {
          console.group('触发埋点');
          console.log('事件', eventType);
          console.log('参数', sendInfo);
          console.groupEnd();
        }
        window.divolte.signal(eventType, sendInfo);
      }).catch(function (ex) {
        console.error(ex);
      });
    }
    /**
     * 设置默认传递的参数,固定（界面打开后不会再变化）
     * @param {*} info
     */

  }, {
    key: 'setFixedDefaultParam',
    value: function setFixedDefaultParam(info) {
      this.defaultFixedParam = info;
    }
  }, {
    key: 'setDynamicDefaultParam',
    value: function setDynamicDefaultParam(fun) {
      this.dynamicDefaultParamFun = fun;
    }
  }]);
  return BuryingPoint;
}();

var buryingPoint = new BuryingPoint();
(0, _globalBuryingPoint.allBuryingPoint)(buryingPoint);

exports.default = buryingPoint;
exports.getPageTypeFromUrl = _divolteCommonInfo.getPageTypeFromUrl;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.aliPageHelper = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _commonHelper = __webpack_require__(3);

var _config = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var aliminiProgramHelper = {
  _jssdkUrl: 'https://appx/web-view.min.js',

  _init: function _init() {
    var _this = this;

    if (!this.isMiniProgramMode()) {
      return _promise2.default.reject(new Error('not in ali'));
    }

    if (this.inited) {
      return _promise2.default.resolve(window.my);
    }

    return new _promise2.default(function (resolve, _reject) {
      var script = document.createElement('script');

      // other version js loaded;
      delete window.my;

      script.onload = function () {
        _this.inited = true;
        resolve(window.my);
      };

      script.src = _this._jssdkUrl;
      document.body.appendChild(script);
      script = null;
    });
  },
  isMiniProgramMode: function isMiniProgramMode() {
    return (0, _commonHelper.isAlipayMiniProgramBrowser)();
  },
  call: function call(method) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    this._init().then(function (my) {
      if (!my || !my[method]) {
        throw new Error('ali jssdk unload');
      }

      var fn = my[method];
      if (!fn) {
        throw new Error('miniProgram do not contains the method of ' + method);
      }
      return fn.apply(my, args);
    }).catch(function (e) {
      // alert(e.message);
      console.warn(e.message);
    });
  },
  navigateTo: function navigateTo(url, params) {
    this.route('navigateTo', url, params);
  },


  // redirectTo在小程序中不会保留页面栈 不能用my.navigateBack返回  但navigateTo可以
  redirectTo: function redirectTo(url, params) {
    this.route('redirectTo', url, params);
  },
  route: function route(method, url, params) {
    var nextUrl = url + '?' + (0, _commonHelper.formatObjToParamStr)(params);

    this.call(method, { url: nextUrl });
  },
  postMessage: function postMessage() {
    this.call('postMessage');
  },
  onMessage: function onMessage(cb) {
    this._init().then(function (my) {
      my.onMessage = cb;
    });
  }
};

exports.default = aliminiProgramHelper;


var interceptor = {
  handlers: {},

  add: function add(url, handler) {
    var _this2 = this;

    var urls = [].concat(url);

    urls.forEach(function (item) {
      _this2.handlers[item] = handler;
    });
  },
  exec: function exec(url, params) {
    var fixedUrl = url.replace(/^https?:\/\//, '').split('/').slice(1).join('/');

    var handler = this.handlers['/' + fixedUrl];
    if (!handler || !aliminiProgramHelper.isMiniProgramMode()) {
      return false;
    }

    for (var _len2 = arguments.length, rest = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      rest[_key2 - 2] = arguments[_key2];
    }

    handler.apply(undefined, [url, params].concat(rest));

    return true;
  }
};

// 支付页
// interceptor.add('/shop/payDetail', (url, params) => {
//   aliminiProgramHelper.navigateTo('/pages/pay/pay', params);
// });

// 登录页
interceptor.add(['/user/notLogin', '/user-login.html'], function (url, params) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'navigateTo';

  aliminiProgramHelper[method]('/pages/login/login', params);
});

var aliPageHelper = {
  navigateTo: function navigateTo(url, params) {
    // TODO: 暂时屏蔽掉拦截器。所有都还是走h5
    if (interceptor.exec(url, params) === true) {
      return;
    }
    console.log('--------navigateTo', url);
    location.href = url + '?' + (0, _commonHelper.formatObjToParamStr)(params);
  },
  redirectWhenInit: function redirectWhenInit() {
    var params = (0, _commonHelper.getUrlParams)();

    return interceptor.exec(location.pathname, params, 'redirectTo');
  },
  navigateToLoginPage: function navigateToLoginPage(params) {
    try {
      var tableId = sessionStorage.getItem('tableId');
      var tableQuery = '';
      if (tableId) {
        tableQuery = '&tableId=' + tableId;
      }
      var finalParams = (0, _extends3.default)({
        returnUrl: encodeURIComponent('' + location.href + tableQuery)
      }, params);
      this.navigateTo(_config.logAddressURL, finalParams);
    } catch (ex) {
      console.log('--------navigateToLoginPage ex', ex);
    }
  }
};

exports.aliPageHelper = aliPageHelper;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(35);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var call = __webpack_require__(90);
var isArrayIter = __webpack_require__(91);
var anObject = __webpack_require__(12);
var toLength = __webpack_require__(53);
var getIterFn = __webpack_require__(64);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(53);
var toAbsoluteIndex = __webpack_require__(130);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(54);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(23);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(45)('meta');
var isObject = __webpack_require__(20);
var has = __webpack_require__(24);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(31)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
module.exports = __webpack_require__(1).Object.keys;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(33);
var $keys = __webpack_require__(36);

__webpack_require__(81)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(256);

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(139);
module.exports = __webpack_require__(1).Object.assign;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(8);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(140) });


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(15);
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(61);
var pIE = __webpack_require__(42);
var toObject = __webpack_require__(33);
var IObject = __webpack_require__(78);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(31)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(4);
var core = __webpack_require__(1);
var dP = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(15);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(37);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26);
var gOPN = __webpack_require__(97).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProtectPosition", function() { return ProtectPosition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/**
 * 服务端响应错误字典
 */
var serverErrorMap = new Map([[400, '请求错误(400)'], [401, '未授权(401)'], [403, '拒绝访问(403)'], [404, '地址不存在(404)'], [408, '请求超时(408)'], [500, '服务器错误(500)'], [501, '服务未实现(501)'], [502, '网络错误(502)'], [503, '服务不可用(503)'], [504, '网络超时(504)'], [505, 'HTTP版本不受支持(505)'], [999, '连接服务器失败'], [90001, '响应数据结构不合法']]);

/**
 * 服务端响应错误字典
 */
var serverErrorMap$1 = new Map([[400, '请求错误(400)'], [401, '未授权(401)'], [403, '拒绝访问(403)'], [404, '地址不存在(404)'], [408, '请求超时(408)'], [500, '服务器错误(500)'], [501, '服务未实现(501)'], [502, '网络错误(502)'], [503, '服务不可用(503)'], [504, '网络超时(504)'], [505, 'HTTP版本不受支持(505)'], [999, '连接服务器失败'], [90001, '响应数据结构不合法']]);

/*
 * @Author: snail
 * @Date: 2019-07-26 10:48:30
 * @Last Modified by: snail
 * @Last Modified time: 2020-01-13 16:28:09
 *
 * 请求错误类。
 * 1.提供错误码字典
 * 2.将axios错误对象处理为系统统一的ResponseError
 */

var defaultServerErrorPrefix = '连接出错';
var ERROR_DATA_STRUCT = 90001;
/**
 * 将axios的错误对象转换成ResponseError对象
 * @param err
 */

function axiosError2ResponseError(err) {
  var code = !!err && err.response ? err.response.status : 999;
  var msg = serverErrorMap$1.get(code) || "".concat(defaultServerErrorPrefix, "(").concat(code, ")");
  return {
    code: code,
    msg: msg
  };
}

var SUCCESS_CODE = '200';

var fetchResponseResolve = function fetchResponseResolve(res) {
  var _res$data = res.data,
      json = _res$data === void 0 ? {} : _res$data;
  var _json$code = json.code,
      code = _json$code === void 0 ? ERROR_DATA_STRUCT : _json$code,
      _json$msg = json.msg,
      msg = _json$msg === void 0 ? serverErrorMap.get(ERROR_DATA_STRUCT) : _json$msg,
      data = json.data;

  if (code === SUCCESS_CODE || code === Number(SUCCESS_CODE)) {
    return Promise.resolve(data);
  }

  var responseError = {
    code: code,
    msg: msg
  };
  return Promise.reject(responseError);
};

/**
 * Add integers, wrapping at 2^32.
 * This uses 16-bit operations internally to work around bugs in interpreters.
 *
 * @param {number} x First integer
 * @param {number} y Second integer
 * @returns {number} Sum
 */
function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/**
 * Bitwise rotate a 32-bit number to the left.
 *
 * @param {number} num 32-bit number
 * @param {number} cnt Rotation count
 * @returns {number} Rotated number
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} q q
 * @param {number} a a
 * @param {number} b b
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} a a
 * @param {number} b b
 * @param {number} c c
 * @param {number} d d
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} a a
 * @param {number} b b
 * @param {number} c c
 * @param {number} d d
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} a a
 * @param {number} b b
 * @param {number} c c
 * @param {number} d d
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
/**
 * Basic operation the algorithm uses.
 *
 * @param {number} a a
 * @param {number} b b
 * @param {number} c c
 * @param {number} d d
 * @param {number} x x
 * @param {number} s s
 * @param {number} t t
 * @returns {number} Result
 */


function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
/**
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 *
 * @param {Array} x Array of little-endian words
 * @param {number} len Bit length
 * @returns {Array<number>} MD5 Array
 */


function binlMD5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[(len + 64 >>> 9 << 4) + 14] = len;
  var i;
  var olda;
  var oldb;
  var oldc;
  var oldd;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (i = 0; i < x.length; i += 16) {
    olda = a;
    oldb = b;
    oldc = c;
    oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/**
 * Convert an array of little-endian words to a string
 *
 * @param {Array<number>} input MD5 Array
 * @returns {string} MD5 string
 */


function binl2rstr(input) {
  var i;
  var output = '';
  var length32 = input.length * 32;

  for (i = 0; i < length32; i += 8) {
    output += String.fromCharCode(input[i >> 5] >>> i % 32 & 0xff);
  }

  return output;
}
/**
 * Convert a raw string to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 *
 * @param {string} input Raw input string
 * @returns {Array<number>} Array of little-endian words
 */


function rstr2binl(input) {
  var i;
  var output = [];
  output[(input.length >> 2) - 1] = undefined;

  for (i = 0; i < output.length; i += 1) {
    output[i] = 0;
  }

  var length8 = input.length * 8;

  for (i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32;
  }

  return output;
}
/**
 * Calculate the MD5 of a raw string
 *
 * @param {string} s Input string
 * @returns {string} Raw MD5 string
 */


function rstrMD5(s) {
  return binl2rstr(binlMD5(rstr2binl(s), s.length * 8));
}
/**
 * Calculates the HMAC-MD5 of a key and some data (raw strings)
 *
 * @param {string} key HMAC key
 * @param {string} data Raw input string
 * @returns {string} Raw MD5 string
 */


function rstrHMACMD5(key, data) {
  var i;
  var bkey = rstr2binl(key);
  var ipad = [];
  var opad = [];
  ipad[15] = opad[15] = undefined;

  if (bkey.length > 16) {
    bkey = binlMD5(bkey, key.length * 8);
  }

  for (i = 0; i < 16; i += 1) {
    ipad[i] = bkey[i] ^ 0x36363636;
    opad[i] = bkey[i] ^ 0x5c5c5c5c;
  }

  var hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
  return binl2rstr(binlMD5(opad.concat(hash), 512 + 128));
}
/**
 * Convert a raw string to a hex string
 *
 * @param {string} input Raw input string
 * @returns {string} Hex encoded string
 */


function rstr2hex(input) {
  var hexTab = '0123456789abcdef';
  var output = '';
  var x;
  var i;

  for (i = 0; i < input.length; i += 1) {
    x = input.charCodeAt(i);
    output += hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f);
  }

  return output;
}
/**
 * Encode a string as UTF-8
 *
 * @param {string} input Input string
 * @returns {string} UTF8 string
 */


function str2rstrUTF8(input) {
  return unescape(encodeURIComponent(input));
}
/**
 * Encodes input string as raw MD5 string
 *
 * @param {string} s Input string
 * @returns {string} Raw MD5 string
 */


function rawMD5(s) {
  return rstrMD5(str2rstrUTF8(s));
}
/**
 * Encodes input string as Hex encoded string
 *
 * @param {string} s Input string
 * @returns {string} Hex encoded string
 */


function hexMD5(s) {
  return rstr2hex(rawMD5(s));
}
/**
 * Calculates the raw HMAC-MD5 for the given key and data
 *
 * @param {string} k HMAC key
 * @param {string} d Input string
 * @returns {string} Raw MD5 string
 */


function rawHMACMD5(k, d) {
  return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d));
}
/**
 * Calculates the Hex encoded HMAC-MD5 for the given key and data
 *
 * @param {string} k HMAC key
 * @param {string} d Input string
 * @returns {string} Raw MD5 string
 */


function hexHMACMD5(k, d) {
  return rstr2hex(rawHMACMD5(k, d));
}
/**
 * Calculates MD5 value for a given string.
 * If a key is provided, calculates the HMAC-MD5 value.
 * Returns a Hex encoded string unless the raw argument is given.
 *
 * @param {string} string Input string
 * @param {string} [key] HMAC key
 * @param {boolean} [raw] Raw output switch
 * @returns {string} MD5 output
 */


function md5(string, key, raw) {
  if (!key) {
    if (!raw) {
      return hexMD5(string);
    }

    return rawMD5(string);
  }

  if (!raw) {
    return hexHMACMD5(key, string);
  }

  return rawHMACMD5(key, string);
} // if (typeof define === 'function' && define.amd) {
//   define(function () {
//     return md5
//   })
// } else if (typeof module === 'object' && module.exports) {
//   module.exports = md5
// } else {
//   $.md5 = md5
// }

/*
 * @Author: snail
 * @Date: 2020-04-28 16:08:54
 * @Last Modified by: snail
 * @Last Modified time: 2020-05-11 13:38:35
 * 生成相关参数信息，用于防篡改和防重放
 */

function randomString(len) {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/

  var maxPos = $chars.length;
  var pwd = '';

  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
}
/**
 * 获取保护API参数信息
 */


function getProtectInfo() {
  var kryTimestamp = new Date().getTime();
  var kryNoncestr = kryTimestamp + randomString(15);
  var krySignature = md5(kryTimestamp + kryNoncestr);
  return {
    kryTimestamp: kryTimestamp,
    kryNoncestr: kryNoncestr,
    krySignature: krySignature
  };
}

var methodMap = {
  get: 'enableProtectByGet',
  post: 'enableProtectByPost'
};

function isGetProtectParamInfo(method, instanceEnableProtect) {
  var enableProtect = this.enableProtect;
  var methodEnableProtect = this[methodMap[method]];
  if (instanceEnableProtect === null) return enableProtect && methodEnableProtect;
  return instanceEnableProtect;
}
/**
 * 获取API 保护参数
 */


function getProtectParamInfo(method, instanceEnableProtect) {
  if (isGetProtectParamInfo.bind(this, method, instanceEnableProtect)()) {
    return getProtectInfo();
  }

  return null;
}

var ProtectPosition;

(function (ProtectPosition) {
  ProtectPosition["HEAD"] = "head";
  ProtectPosition["PARAM"] = "param";
})(ProtectPosition || (ProtectPosition = {}));

var SerializeTypes;

(function (SerializeTypes) {
  SerializeTypes["ARRAY"] = "array";
  SerializeTypes["REPEAT"] = "repeat";
})(SerializeTypes || (SerializeTypes = {}));

var defaultInstanceConfig = {
  enableDefaultResponseResolve: true,
  enableDefaultResponseErrorResolve: true,
  enableProtect: null
};

function toQueryString(object, serializeType) {
  if (!object) return '';
  return Object.keys(object).reduce(function (ret, item) {
    var prefix = !ret ? '' : "".concat(ret, "&");
    var before = "".concat(prefix).concat(encodeURIComponent(item), "=");
    var curVal = object[item];

    if (!Array.isArray(curVal)) {
      return "".concat(before).concat(encodeURIComponent(curVal));
    } // from key:[1, 2] to key=1&key=2


    if (serializeType === SerializeTypes.ARRAY) {
      var params = curVal.reduce(function (r, d) {
        return "".concat(!r ? '' : "".concat(r, "&")).concat(encodeURIComponent(item), "=").concat(encodeURIComponent(d));
      }, '');
      return "".concat(prefix).concat(params);
    } // from key:[1, 2] to key=1,2


    return "".concat(before).concat(encodeURIComponent(curVal.map(function (d) {
      return JSON.stringify(d);
    }).join(',')));
  }, '');
}

function responseInterceptor(response) {
  return fetchResponseResolve(response);
}

function responseErrorInterceptor(error) {
  return Promise.reject(axiosError2ResponseError(error));
} // Global settings


__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
var fetch = {
  protectPosition: ProtectPosition.HEAD,
  enableProtect: true,
  enableProtectByGet: true,
  enableProtectByPost: true,

  /**
   * 发起get请求
   * @param url
   * @param queries
   * @param config
   */
  get: function get(url, queries, config) {
    var finallyUrl = url;
    var headers = undefined;
    var newQueries = Object.assign({}, queries);

    var _Object$assign = Object.assign({}, defaultInstanceConfig, config),
        enableDefaultResponseResolve = _Object$assign.enableDefaultResponseResolve,
        enableDefaultResponseErrorResolve = _Object$assign.enableDefaultResponseErrorResolve,
        enableProtect = _Object$assign.enableProtect;

    var protectInfo = getProtectParamInfo.bind(this, 'get', enableProtect)();

    if (protectInfo) {
      if (this.protectPosition === ProtectPosition.PARAM) {
        Object.assign(newQueries, protectInfo);
      } else {
        var kryTimestamp = protectInfo.kryTimestamp,
            kryNoncestr = protectInfo.kryNoncestr,
            krySignature = protectInfo.krySignature;
        headers = {
          'kry-timestamp': kryTimestamp,
          'kry-noncestr': kryNoncestr,
          'kry-signature': krySignature
        };
      }
    }

    if (newQueries) {
      var queryString = toQueryString(newQueries, SerializeTypes.REPEAT);
      finallyUrl = (finallyUrl || '').indexOf('?') !== -1 ? "".concat(finallyUrl, "&").concat(queryString) : "".concat(finallyUrl, "?").concat(queryString);
    }

    var axiosObj = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

    if (!enableDefaultResponseResolve || !enableDefaultResponseErrorResolve) {
      axiosObj = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();
      axiosObj.interceptors.response.use(!enableDefaultResponseResolve ? null : responseInterceptor, !enableDefaultResponseErrorResolve ? null : responseErrorInterceptor);
    }

    var requestConfig = {
      method: 'get',
      url: finallyUrl,
      headers: headers
    };
    return axiosObj(requestConfig).then(function (data) {
      return data;
    }); // return axiosObj.get(finallyUrl, config as object, header);
  },

  /**
   * 发起post请求
   * @param url
   * @param queries
   * @param config
   */
  post: function post(url, queries, config) {
    var newQueries = Object.assign({}, queries);
    var headers = undefined;

    var _Object$assign2 = Object.assign({}, defaultInstanceConfig, config),
        enableDefaultResponseResolve = _Object$assign2.enableDefaultResponseResolve,
        enableDefaultResponseErrorResolve = _Object$assign2.enableDefaultResponseErrorResolve,
        enableProtect = _Object$assign2.enableProtect;

    var protectInfo = getProtectParamInfo.bind(this, 'post', enableProtect)();

    if (this.protectPosition === ProtectPosition.PARAM) {
      Object.assign(newQueries, protectInfo);
    } else {
      var kryTimestamp = protectInfo.kryTimestamp,
          kryNoncestr = protectInfo.kryNoncestr,
          krySignature = protectInfo.krySignature;
      headers = {
        'kry-timestamp': kryTimestamp,
        'kry-noncestr': kryNoncestr,
        'kry-signature': krySignature
      };
    }

    var axiosObj = __WEBPACK_IMPORTED_MODULE_0_axios___default.a;

    if (!enableDefaultResponseResolve || !enableDefaultResponseErrorResolve) {
      axiosObj = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create();
      axiosObj.interceptors.response.use(!enableDefaultResponseResolve ? null : responseInterceptor, !enableDefaultResponseErrorResolve ? null : responseErrorInterceptor);
    } // return axiosObj.post(url, newQueries, config as object);


    var requestConfig = {
      method: 'post',
      url: url,
      headers: headers,
      data: newQueries
    };
    return axiosObj(requestConfig).then(function (data) {
      return data;
    });
  },

  /**
   * 设置默认请求参数
   * @param options
   */
  setDefaults: function setDefaults(options) {
    if (options) {
      var keys = Object.keys(options);
      keys.forEach(function (key) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults[key] = options[key];
      });
    }
  },

  /**
   * 设置请求拦截器
   * @param onFulfilled
   * @param onRejected
   */
  setRequestInterceptor: function setRequestInterceptor(onFulfilled, onRejected) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(onFulfilled, onRejected);
  },

  /**
   * 设置响应拦截器
   * @param onFulfilled
   * @param onRejected
   */
  setResponseInterceptor: function setResponseInterceptor(onFulfilled, onRejected) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.response.use(onFulfilled, onRejected);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (fetch);



/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function padStart(source, maxLength, fillString) {
  return source.padStart(maxLength, fillString);
}

module.exports = padStart;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(332);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(287);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(149), __esModule: true };

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(40);
module.exports = __webpack_require__(155);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(151);
var step = __webpack_require__(137);
var Iterators = __webpack_require__(34);
var toIObject = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(85)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(63);
var descriptor = __webpack_require__(39);
var setToStringTag = __webpack_require__(47);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(23)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(17);
var anObject = __webpack_require__(12);
var getKeys = __webpack_require__(36);

module.exports = __webpack_require__(15) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(54);
var defined = __webpack_require__(52);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(60);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(34);
module.exports = __webpack_require__(1).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(157), __esModule: true };

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(46);
__webpack_require__(40);
module.exports = __webpack_require__(158);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(12);
var get = __webpack_require__(64);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86);
__webpack_require__(40);
__webpack_require__(46);
__webpack_require__(161);
__webpack_require__(165);
__webpack_require__(166);
module.exports = __webpack_require__(1).Promise;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(38);
var global = __webpack_require__(4);
var ctx = __webpack_require__(32);
var classof = __webpack_require__(60);
var $export = __webpack_require__(8);
var isObject = __webpack_require__(20);
var aFunction = __webpack_require__(44);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(128);
var speciesConstructor = __webpack_require__(92);
var task = __webpack_require__(93).set;
var microtask = __webpack_require__(163)();
var newPromiseCapabilityModule = __webpack_require__(65);
var perform = __webpack_require__(94);
var userAgent = __webpack_require__(164);
var promiseResolve = __webpack_require__(95);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(132)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(47)($Promise, PROMISE);
__webpack_require__(141)(PROMISE);
Wrapper = __webpack_require__(1)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(96)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 162 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var macrotask = __webpack_require__(93).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(37)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(8);
var core = __webpack_require__(1);
var global = __webpack_require__(4);
var speciesConstructor = __webpack_require__(92);
var promiseResolve = __webpack_require__(95);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(8);
var newPromiseCapability = __webpack_require__(65);
var perform = __webpack_require__(94);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(168), __esModule: true };

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40);
__webpack_require__(46);
module.exports = __webpack_require__(66).f('iterator');


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(170), __esModule: true };

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171);
__webpack_require__(86);
__webpack_require__(173);
__webpack_require__(174);
module.exports = __webpack_require__(1).Symbol;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(4);
var has = __webpack_require__(24);
var DESCRIPTORS = __webpack_require__(15);
var $export = __webpack_require__(8);
var redefine = __webpack_require__(88);
var META = __webpack_require__(133).KEY;
var $fails = __webpack_require__(31);
var shared = __webpack_require__(58);
var setToStringTag = __webpack_require__(47);
var uid = __webpack_require__(45);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(66);
var wksDefine = __webpack_require__(67);
var enumKeys = __webpack_require__(172);
var isArray = __webpack_require__(142);
var anObject = __webpack_require__(12);
var isObject = __webpack_require__(20);
var toObject = __webpack_require__(33);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(56);
var createDesc = __webpack_require__(39);
var _create = __webpack_require__(63);
var gOPNExt = __webpack_require__(143);
var $GOPD = __webpack_require__(98);
var $GOPS = __webpack_require__(61);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(36);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(97).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(42).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(38)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(36);
var gOPS = __webpack_require__(61);
var pIE = __webpack_require__(42);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('asyncIterator');


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(67)('observable');


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(76);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(40);
__webpack_require__(177);
module.exports = __webpack_require__(1).Array.from;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(32);
var $export = __webpack_require__(8);
var toObject = __webpack_require__(33);
var call = __webpack_require__(90);
var isArrayIter = __webpack_require__(91);
var toLength = __webpack_require__(53);
var createProperty = __webpack_require__(178);
var getIterFn = __webpack_require__(64);

$export($export.S + $export.F * !__webpack_require__(96)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(17);
var createDesc = __webpack_require__(39);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(180);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var bind = __webpack_require__(99);
var Axios = __webpack_require__(181);
var mergeConfig = __webpack_require__(105);
var defaults = __webpack_require__(102);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(106);
axios.CancelToken = __webpack_require__(194);
axios.isCancel = __webpack_require__(101);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(195);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var buildURL = __webpack_require__(100);
var InterceptorManager = __webpack_require__(182);
var dispatchRequest = __webpack_require__(183);
var mergeConfig = __webpack_require__(105);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);
var transformData = __webpack_require__(184);
var isCancel = __webpack_require__(101);
var defaults = __webpack_require__(102);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(104);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(189);
var combineURLs = __webpack_require__(190);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(6);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(106);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(197);
var parse = __webpack_require__(208);
var formats = __webpack_require__(70);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(198);
var utils = __webpack_require__(107);
var formats = __webpack_require__(70);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68);
var callBound = __webpack_require__(204);
var inspect = __webpack_require__(206);

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(200);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var test = {
	foo: {}
};

var $Object = Object;

module.exports = function hasProto() {
	return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(69);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(68);

var callBind = __webpack_require__(205);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(69);
var GetIntrinsic = __webpack_require__(68);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(207);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(107);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 209 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(211), src$en$$ = __webpack_require__(216);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(109), src$es5$$ = __webpack_require__(212), src$compiler$$ = __webpack_require__(213), intl$messageformat$parser$$ = __webpack_require__(214);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(109);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(215)['default'];
exports['default'] = exports;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(219)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(224);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(220);
var en_1 = __webpack_require__(223);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(108);
var diff_1 = __webpack_require__(221);
var es5_1 = __webpack_require__(222);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 224 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(253);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var emojiList = ['😀', '😉', '😁', '😆', '😅', '😂', '🤣', '😊', '🙂', '😄', '🙃', '😇', '😃', '😚', '🥰', '😙', '☺', '😍', '😗', '🥲', '😘', '🤩', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤔', '🤭', '🤗', '🤫', '😐', '😶', '🤨', '😬', '😏', '😑', '😒', '🙄', '🤐', '🤥', '😌', '😔', '😪', '😴', '🤤', '🥶', '🤧', '😷', '🤯', '🥴', '😵', '🤒', '🥵', '🤮', '🤕', '🤢', '🥸', '🤠', '🥳', '🤓', '😎', '🧐', '😕', '😖', '😧', '🥺', '😫', '😱', '😞', '😯', '😮', '😭', '😟', '😓', '😩', '😢', '😲', '😨', '🥱', '😳', '🙁', '😥', '😣', '😦', '☹', '😰', '☠', '😤', '😈', '😡', '💀', '👿', '🤬', '😠', '💩', '🤡', '🤖', '👽', '👾', '👻', '👺', '👹', '🙀', '😽', '😸', '😿', '😾', '😻', '😺', '😼', '😹', '🙉', '🙊', '🙈', '🗯', '🕳', '🗨', '🧡', '💟', '💭', '🤎', '💞', '🤍', '💌', '🖤', '💢', '💓', '💯', '💕', '💋', '💨', '💦', '💫', '💗', '💔', '💘', '💚', '💙', '💜', '💛', '💥', '💖', '💬', '💣', '💤', '❤', '❣', '💝', '🤚', '🖖', '👋', '🖐', '✋', '🤙', '🤞', '🤟', '🤘', '🤌', '🤏', '👌', '✌', '🖕', '👆', '👇', '👈', '👉', '☝', '🤛', '🤜', '👍', '✊', '👊', '👎', '👐', '🤝', '👏', '🤲', '🙏', '🙌', '✍', '🤳', '💅', '🫁', '🫀', '👁', '👄', '👅', '👂', '👃', '🦴', '👀', '🦶', '🦵', '🦻', '🦷', '🦿', '🦾', '💪', '🧠', '🧓', '🧑', '🧒', '👩', '👦', '👧', '👨', '👱', '👶', '👴', '👵', '🧔', '🙋', '🙍', '🙇', '🙎', '🧏', '🤦', '🙆', '💁', '🤷', '🙅', '👲', '👷', '💂', '🥷', '🧕', '🕵', '👸', '👳', '👰', '👮', '🤱', '🤰', '🤴', '🤵', '🧛', '🧚', '🎅', '🧞', '🧙', '👼', '🧜', '🧝', '🤶', '🧟', '🦹', '🦸', '🕴', '🧍', '💆', '💇', '💃', '👯', '🕺', '🏃', '🚶', '🧎', '🧗', '🧖', '🤹', '🤸', '🤺', '🤼', '🤾', '🚣', '🚵', '🚴', '🤽', '⛷', '🏋', '⛹', '🏌', '🏂', '🏇', '🏊', '🏄', '🧘', '🛌', '🛀', '💏', '👬', '👪', '👭', '👫', '💑', '🫂', '👤', '👣', '🗣', '👥', '🏽', '🏼', '🏻', '🏾', '🏿', '🦳', '🦲', '🦰', '🦱', '🐿', '🐮', '🐭', '🐫', '🐪', '🐯', '🦏', '🦍', '🦌', '🦊', '🦒', '🐀', '🐨', '🦘', '🦇', '🐎', '🐐', '🐏', '🐒', '🐑', '🐕', '🐖', '🐗', '🦓', '🐱', '🦣', '🦛', '🐰', '🦝', '🐩', '🦔', '🐁', '🐄', '🐵', '🐆', '🐅', '🐇', '🐈', '🦄', '🐘', '🐃', '🐴', '🐂', '🐶', '🐷', '🦡', '🦥', '🦧', '🦦', '🦙', '🦨', '🐹', '🦫', '🦮', '🐽', '🐾', '🐼', '🐻', '🐺', '🦁', '🦬', '🐣', '🐔', '🐤', '🕊', '🦩', '🐥', '🦢', '🦤', '🐧', '🐦', '🐓', '🦜', '🦚', '🦃', '🦅', '🦉', '🪶', '🦆', '🐸', '🐍', '🦎', '🐢', '🐊', '🦕', '🦖', '🐉', '🐲', '🦭', '🐋', '🦈', '🐚', '🐳', '🐟', '🐙', '🐬', '🐡', '🐠', '🦋', '🦗', '🦟', '🦠', '🪱', '🪲', '🪳', '🦂', '🪰', '🐝', '🐞', '🐛', '🐜', '🕸', '🐌', '🕷', '🌹', '💮', '🌷', '🌺', '🏵', '🌼', '🌻', '💐', '🥀', '🌸', '🌲', '🌳', '🌴', '🌵', '🌾', '🍀', '🌱', '🍂', '🍃', '🍁', '🌿', '☘', '🪴', '🥝', '🥥', '🫐', '🍓', '🍒', '🥭', '🍑', '🍋', '🍊', '🍉', '🫒', '🍍', '🍈', '🍎', '🍇', '🍅', '🍌', '🍏', '🍐', '🧄', '🫑', '🥜', '🌰', '🥑', '🥕', '🧅', '🥔', '🥒', '🥬', '🌶', '🥦', '🍆', '🍄', '🌽', '🍳', '🧈', '🧇', '🍲', '🧆', '🫓', '🌯', '🌮', '🌭', '🧀', '🧂', '🫔', '🫕', '🥯', '🍕', '🍖', '🍔', '🥪', '🥫', '🍗', '🍿', '🥖', '🥗', '🥙', '🥘', '🥞', '🥚', '🥓', '🍟', '🍞', '🥨', '🥩', '🥐', '🥣', '🥡', '🍚', '🍙', '🍘', '🍱', '🥠', '🍛', '🍠', '🥮', '🍢', '🍡', '🍤', '🍣', '🍥', '🍝', '🍜', '🥟', '🦞', '🦪', '🦀', '🦑', '🦐', '🍫', '🍦', '🍧', '🍬', '🍩', '🍪', '🍨', '🍯', '🧁', '🍭', '🥧', '🍮', '🍰', '🎂', '🥃', '🥂', '🍺', '🧉', '☕', '🥤', '🧃', '🍾', '🥛', '🫖', '🍹', '🍵', '🍻', '🧊', '🍼', '🧋', '🍶', '🍷', '🍸', '🍴', '🥄', '🔪', '🥢', '🏺', '🍽', '🌏', '🧭', '🌎', '🗺', '🗾', '🌍', '🌐', '🏜', '🌋', '🏖', '🏝', '🗻', '🏔', '⛰', '🏞', '🏕', '🗽', '🏭', '🏬', '🏦', '🏥', '🗼', '🏩', '🏪', '🏫', '🏘', '🏚', '🏛', '🏤', '🏟', '🏗', '💒', '🏨', '🏢', '🏡', '🪨', '🏠', '🏣', '🏰', '🧱', '🏯', '🪵', '🛖', '🕌', '🕋', '🕍', '⛪', '⛩', '🛕', '🎡', '⛺', '🎢', '💈', '🌇', '🌉', '🌅', '🌆', '🌃', '🌄', '♨', '🎪', '🌁', '🏙', '🎠', '⛲', '🚧', '🚥', '🚃', '🚘', '🚲', '🚈', '🚇', '🚆', '🚅', '🚄', '🛢', '🚚', '🚜', '🚉', '🚂', '🚗', '🚊', '🚙', '🚋', '🚛', '🚌', '🚝', '🚍', '🚎', '🚏', '🛑', '🚐', '🛣', '🚑', '🚦', '🚒', '🚨', '🚓', '🏎', '🚔', '🏍', '🚕', '⛽', '🚖', '🛴', '🚞', '🛹', '🛤', '🛻', '🛺', '🛵', '🛼', '🦼', '🦽', '🚤', '🚢', '⛵', '⚓', '🛳', '🛶', '⛴', '🛥', '🛩', '🚡', '🛫', '🚀', '🚁', '🛰', '✈', '🚟', '🛬', '🛸', '🚠', '🪂', '💺', '🧳', '🛎', '⏱', '⌛', '⏰', '⌚', '⏲', '🕧', '🕦', '🕔', '🕤', '⏳', '🕥', '🕢', '🕣', '🕠', '🕡', '🕞', '🕟', '🕜', '🕝', '🕕', '🕓', '🕚', '🕰', '🕘', '🕙', '🕖', '🕗', '🕛', '🕒', '🕑', '🕐', '⚡', '🔥', '🌊', '🌑', '⭐', '🌂', '☂', '☔', '💧', '🌒', '☃', '🌀', '⛄', '🌈', '⛅', '🌌', '☁', '☀', '🪐', '☄', '🌠', '🌓', '🌧', '🌟', '🌫', '🌙', '🌚', '⛱', '🌝', '🌨', '⛈', '❄', '🌔', '🌥', '🌪', '🌩', '🌦', '🌤', '🌕', '🌡', '🌖', '🌬', '🌗', '🌞', '🌘', '🌛', '🌜', '🎆', '🎁', '🎃', '✨', '🎇', '🎀', '🎉', '🎟', '🎈', '🎋', '🎊', '🎗', '🎫', '🎑', '🎍', '🎏', '🧧', '🎎', '🎐', '🎄', '🧨', '🏆', '🎖', '🏅', '🥇', '🥉', '🥈', '🤿', '🥌', '🏀', '🏓', '🎣', '🏑', '🏐', '🎽', '🎾', '🎿', '⚽', '🏒', '🥎', '⛸', '🥏', '⚾', '🥊', '🥍', '🏈', '🥋', '🏏', '🥅', '🏉', '🎳', '⛳', '🛷', '🏸', '♣', '♥', '♦', '🕹', '♠', '♟', '🔮', '🧩', '🃏', '🎴', '🀄', '🎱', '🎲', '🎰', '🪆', '🪅', '🎮', '🪁', '🪄', '🪀', '🧿', '🧸', '🎯', '🎨', '🪢', '🧵', '🖼', '🧶', '🎭', '🪡', '🎓', '👗', '👙', '👛', '🧢', '⛑', '👞', '👟', '👝', '👜', '🦺', '🪖', '🧣', '👕', '👡', '👑', '💄', '🧤', '👚', '👢', '💍', '🧥', '👘', '💎', '🧦', '🕶', '👓', '🎩', '👖', '🛍', '🩰', '🎒', '🥻', '🩴', '🥾', '🩱', '👔', '🥼', '🩲', '🥿', '🩳', '👠', '📿', '🥽', '👒', '📢', '🔇', '🔈', '📣', '📯', '🔊', '🔔', '🔕', '🔉', '📻', '🎛', '🎙', '🎤', '🎚', '🎶', '🎼', '🎵', '🎧', '🎻', '🪕', '🎺', '🎷', '🪗', '🥁', '🪘', '🎹', '🎸', '📞', '📠', '📱', '📟', '☎', '📲', '🖱', '🖲', '🖥', '🖨', '🧮', '⌨', '🔋', '🔌', '📀', '💿', '💾', '💽', '💻', '📹', '📸', '📷', '🎥', '💡', '🎬', '🪔', '🏮', '📺', '🕯', '🔎', '📼', '🎞', '🔍', '🔦', '📽', '🏷', '📑', '📓', '📃', '📕', '📒', '📗', '📔', '📙', '📖', '🔖', '📘', '📜', '📚', '📄', '🗞', '📰', '💸', '💷', '💹', '💶', '💵', '🪙', '💴', '💳', '💰', '🧾', '📪', '📫', '📬', '📭', '📧', '📤', '📥', '🗳', '📦', '📨', '📩', '✉', '📮', '📝', '🖍', '🖋', '🖌', '✒', '🖊', '✏', '🗄', '🗃', '🗂', '✂', '📈', '🖇', '📌', '🗓', '📊', '🗑', '📐', '📋', '📉', '📏', '🗒', '📁', '📍', '💼', '📅', '📆', '📇', '📂', '📎', '🔓', '🔒', '🔑', '🔐', '🔏', '🗝', '🗜', '⚙', '🗡', '🏹', '🪝', '🪜', '🛡', '⛓', '🛠', '⛏', '🪓', '🪚', '🧲', '🪃', '🦯', '🧰', '🔧', '🔗', '🔩', '🔨', '⚔', '🔫', '⚖', '⚒', '🪛', '🔭', '🔬', '📡', '🧪', '🧫', '🧬', '⚗', '🩺', '🩹', '💉', '🩸', '💊', '🪥', '🛁', '🪤', '🛗', '🛋', '🧴', '🪣', '🛒', '🪠', '🚿', '🛏', '🧯', '🪟', '🧷', '🪞', '🧺', '🪑', '🧹', '🧼', '🪒', '🧽', '🚽', '🧻', '🚪', '⚱', '🚬', '⚰', '🪧', '🗿', '🪦', '♿', '🚼', '🚻', '🚺', '🚹', '🚮', '🚰', '🏧', '🛅', '🛄', '🛃', '🛂', '🚾', '☢', '⚠', '☣', '🚷', '🚳', '🚸', '⛔', '📵', '🚫', '🚱', '🚯', '🚭', '🔞', '↔', '↩', '↕', '↖', '↗', '↘', '↪', '↙', '🔝', '🔃', '⬇', '🔚', '🔙', '🔜', '🔛', '⬅', '⬆', '⤵', '⤴', '➡', '🔄', '⚛', '🔯', '✝', '☪', '☦', '☯', '☮', '🕎', '🛐', '🕉', '✡', '☸', '♉', '♋', '♐', '♑', '♏', '♒', '♓', '♍', '♈', '♌', '♎', '⛎', '♊', '📳', '▶', '⏸', '◀', '⏯', '⏩', '⏪', '⏮', '⏫', '⏬', '⏺', '⏭', '📴', '🔅', '🔆', '🔁', '🔂', '🎦', '🔀', '🔼', '🔽', '⏹', '⏏', '📶', '⚧', '♀', '♂', '➕', '➖', '➗', '♾', '✖', '⁉', '〰', '❓', '❔', '❕', '❗', '‼', '💱', '💲', '❌', '⭕', '❎', '®', '™', '♻', '➰', '☑', '🔰', '🔱', '✅', '➿', '©', '〽', '⚕', '✔', '⚜', '📛', '✴', '❇', '✳', '🔟', '🈯', '🈲', '🈚', '🈳', '㊙', '🈹', '🆚', '🆙', '🈁', '🔠', '🈴', '🅰', '🆓', '🈵', '🆘', '🆔', '🆎', '🔡', '🆕', '🈸', '🉐', '🉑', '🈺', '🆖', '🆗', 'ℹ', '🈶', '㊗', '🈷', '🆑', '🈂', '🔢', '🅿', '🔤', '🅾', '🆒', '🅱', 'Ⓜ', '🔣', '🔴', '⚫', '⚪', '🔵', '🔶', '🔷', '◼', '▫', '◻', '▪', '🔻', '🔺', '🔳', '◽', '🔲', '◾', '🔹', '🔸', '🔘', '🟪', '🟩', '🟡', '💠', '🟠', '🟨', '🟤', '⬜', '🟥', '🟫', '🟧', '🟣', '🟢', '🟦', '⬛', '🏳', '🎌', '🏁', '🏴', '🚩', '🏁', '🚩', '🎌', '🏴', '🏳️', '🏳️‍🌈', '🏴‍☠️', '🇦🇨', '🇦🇩', '🇦🇪', '🇦🇫', '🇦🇬', '🇦🇮', '🇦🇱', '🇦🇲', '🇦🇴', '🇦🇶', '🇦🇷', '🇦🇸', '🇦🇹', '🇦🇺', '🇦🇼', '🇦🇽', '🇦🇿', '🇧🇦', '🇧🇧', '🇧🇩', '🇧🇪', '🇧🇫', '🇧🇬', '🇧🇭', '🇧🇮', '🇧🇯', '🇧🇱', '🇧🇲', '🇧🇳', '🇧🇴', '🇧🇶', '🇧🇷', '🇧🇸', '🇧🇹', '🇧🇻', '🇧🇼', '🇧🇾', '🇧🇿', '🇨🇦', '🇨🇨', '🇨🇩', '🇨🇫', '🇨🇬', '🇨🇭', '🇨🇮', '🇨🇰', '🇨🇱', '🇨🇲', '🇨🇳', '🇨🇴', '🇨🇵', '🇨🇷', '🇨🇺', '🇨🇻', '🇨🇼', '🇨🇽', '🇨🇾', '🇨🇿', '🇩🇪', '🇩🇬', '🇩🇯', '🇩🇰', '🇩🇲', '🇩🇴', '🇩🇿', '🇪🇦', '🇪🇨', '🇪🇪', '🇪🇬', '🇪🇭', '🇪🇷', '🇪🇸', '🇪🇹', '🇪🇺', '🇫🇮', '🇫🇯', '🇫🇰', '🇫🇲', '🇫🇴', '🇫🇷', '🇬🇦', '🇬🇧', '🇬🇩', '🇬🇪', '🇬🇫', '🇬🇬', '🇬🇭', '🇬🇮', '🇬🇱', '🇬🇲', '🇬🇳', '🇬🇵', '🇬🇶', '🇬🇷', '🇬🇸', '🇬🇹', '🇬🇺', '🇬🇼', '🇬🇾', '🇭🇰', '🇭🇲', '🇭🇳', '🇭🇷', '🇭🇹', '🇭🇺', '🇮🇨', '🇮🇩', '🇮🇪', '🇮🇱', '🇮🇲', '🇮🇳', '🇮🇴', '🇮🇶', '🇮🇷', '🇮🇸', '🇮🇹', '🇯🇪', '🇯🇲', '🇯🇴', '🇯🇵', '🇰🇪', '🇰🇬', '🇰🇭', '🇰🇮', '🇰🇲', '🇰🇳', '🇰🇵', '🇰🇷', '🇰🇼', '🇰🇾', '🇰🇿', '🇱🇦', '🇱🇧', '🇱🇨', '🇱🇮', '🇱🇰', '🇱🇷', '🇱🇸', '🇱🇹', '🇱🇺', '🇱🇻', '🇱🇾', '🇲🇦', '🇲🇨', '🇲🇩', '🇲🇪', '🇲🇫', '🇲🇬', '🇲🇭', '🇲🇰', '🇲🇱', '🇲🇲', '🇲🇳', '🇲🇴', '🇲🇵', '🇲🇶', '🇲🇷', '🇲🇸', '🇲🇹', '🇲🇺', '🇲🇻', '🇲🇼', '🇲🇽', '🇲🇾', '🇲🇿', '🇳🇦', '🇳🇨', '🇳🇪', '🇳🇫', '🇳🇬', '🇳🇮', '🇳🇱', '🇳🇴', '🇳🇵', '🇳🇷', '🇳🇺', '🇳🇿', '🇴🇲', '🇵🇦', '🇵🇪', '🇵🇫', '🇵🇬', '🇵🇭', '🇵🇰', '🇵🇱', '🇵🇲', '🇵🇳', '🇵🇷', '🇵🇸', '🇵🇹', '🇵🇼', '🇵🇾', '🇶🇦', '🇷🇪', '🇷🇴', '🇷🇸', '🇷🇺', '🇷🇼', '🇸🇦', '🇸🇧', '🇸🇨', '🇸🇩', '🇸🇪', '🇸🇬', '🇸🇭', '🇸🇮', '🇸🇯', '🇸🇰', '🇸🇱', '🇸🇲', '🇸🇳', '🇸🇴', '🇸🇷', '🇸🇸', '🇸🇹', '🇸🇻', '🇸🇽', '🇸🇾', '🇸🇿', '🇹🇦', '🇹🇨', '🇹🇩', '🇹🇫', '🇹🇬', '🇹🇭', '🇹🇯', '🇹🇰', '🇹🇱', '🇹🇲', '🇹🇳', '🇹🇴', '🇹🇷', '🇹🇹', '🇹🇻', '🇹🇼', '🇹🇿', '🇺🇦', '🇺🇬', '🇺🇲', '🇺🇳', '🇺🇸', '🇺🇾', '🇺🇿', '🇻🇦', '🇻🇨', '🇻🇪', '🇻🇬', '🇻🇮', '🇻🇳', '🇻🇺', '🇼🇫', '🇼🇸', '🇽🇰', '🇾🇪', '🇾🇹', '🇿🇦', '🇿🇲', '🇿🇼', '🏴󠁧󠁢󠁥󠁮󠁧󠁿', '🏴󠁧󠁢󠁳󠁣󠁴󠁿', '🏴󠁧󠁢󠁷󠁬󠁳󠁿'];

var emojiRegStr = emojiList.map(function (e) {
  var emojistr = '';
  for (var i = 0; i <= e.length - 1; i++) {
    emojistr += '\\u' + e.charCodeAt(i).toString(16);
  }

  return '(' + emojistr + ')';
}).join('|');

exports.default = emojiRegStr;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(270);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(230);
var $Object = __webpack_require__(1).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(15), 'Object', { defineProperty: __webpack_require__(17).f });


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(232);
module.exports = __webpack_require__(1).Object.getPrototypeOf;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(33);
var $getPrototypeOf = __webpack_require__(112);

__webpack_require__(81)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(235);
module.exports = __webpack_require__(1).Object.setPrototypeOf;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(8);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(236).set });


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(20);
var anObject = __webpack_require__(12);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(32)(Function.call, __webpack_require__(98).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(238), __esModule: true };

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239);
var $Object = __webpack_require__(1).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(8);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(63) });


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(241);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 241 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _divolte = __webpack_require__(243);

/**
 * @namespace kryfe-divolte
 */
exports.default = _divolte.init;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDivolteScriptUrl = exports.getUrlParams = exports.init = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getDistinctID = __webpack_require__(244);

var _registerEventsHandler = __webpack_require__(245);

var _registerEventsHandler2 = _interopRequireDefault(_registerEventsHandler);

var _utils = __webpack_require__(246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// get divolte script url, depends on environment
function getDivolteScriptUrl(options) {
  var defaultOptions = {
    dev: {
      url: 'http://devdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return (/^dev/i.test(location.hostname)
        );
      }
    },
    test: {
      url: 'http://testdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return (/^test/i.test(location.hostname)
        );
      }
    },
    prod: {
      url: 'http://devdivolte.shishike.com/divolte.js',
      validator: function validator() {
        return true;
      }
    }
  };

  var opts = Object.assign({}, defaultOptions, options);
  var env = Object.keys(opts).find(function (item) {
    return opts[item].validator();
  });

  return env ? opts[env].url : null;
}

// get url params
function getUrlParams() {
  var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search.substr(1);

  var ret = {};

  if (queryString) {
    queryString.split('&').forEach(function (item) {
      var data = item.split('=');
      ret[data[0]] = data[1];
    });
  }

  return ret;
}

// trigger custom events
function triggerCustomEvents(customEvents, defaultParams, e) {
  var eventName = e.eventName,
      content = e.content,
      target = e.target;

  // only 'error' and 'load' events has 'eventName',

  var customEvent = eventName ? { eventName: eventName } : customEvents.find(function (_ref) {
    var xpath = _ref.xpath;

    if (xpath instanceof Array) {
      return xpath.find(function (path) {
        var node = document.querySelector(path);
        return node && node.contains(target);
      });
    } else if (typeof xpath === 'string') {
      var node = document.querySelector(xpath);
      return node && node.contains(target);
    }
    return null;
  });

  if (customEvent && customEvent.eventName) {
    // eslint-disable-next-line no-unused-vars
    var enableDebug = defaultParams.enableDebug,
        excludeEvent = defaultParams.excludeEvent,
        willSendDefaultParams = _objectWithoutProperties(defaultParams, ['enableDebug', 'excludeEvent']);

    var params = Object.assign(content ? _extends({}, content) : {}, willSendDefaultParams, getUrlParams());

    if (target && target.className) {
      params.clickEventSource = target.className;
    }
    if (defaultParams && defaultParams.enableDebug) {
      /* eslint-disable no-console */
      console.group('divolte will send info');
      console.log('customEvent', customEvent);
      console.log('param', params);
      console.groupEnd();
      /* eslint-enable no-console */
    }
    divolte.signal(customEvent.eventName, params);
  }
}

// init, inject a script into document
function init(customEvents) {
  var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var urlOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return new Promise(function (resolve, reject) {
    if (!(0, _utils.isArray)(customEvents) || customEvents.length === 0) {
      throw new Error("customEvents must be an array, and please make sure it's not empty!");
    }

    if (!(0, _utils.isPlainObject)(defaultParams)) {
      throw new Error('defaultParams must be an object!');
    }
    Object.assign(defaultParams);

    if (!(0, _utils.isPlainObject)(urlOptions)) {
      throw new Error('urlOptions must be an object!');
    }
    var script = null;
    try {
      script = document.createElement('script');
      script.id = 'divolte-collection';
      script.src = getDivolteScriptUrl(urlOptions);
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    } catch (ex) {
      reject(ex);
    }
    // add click event on body, after loaded divolte js file
    script.addEventListener('load', function () {
      if (defaultParams.distinctID) {
        (0, _registerEventsHandler2.default)(triggerCustomEvents.bind(null, customEvents, defaultParams), defaultParams);
        return;
      }

      (0, _getDistinctID.getDistinctID)().then(function (distinctID) {
        Object.assign(defaultParams, {
          distinctID: distinctID
        });
        (0, _registerEventsHandler2.default)(triggerCustomEvents.bind(null, customEvents, defaultParams), defaultParams);
      });

      // release memory
      script = null;
      resolve();
    });

    script.addEventListener('error', function (ex) {
      reject(ex);
    });
  });
}

exports.init = init;
exports.getUrlParams = getUrlParams;
exports.getDivolteScriptUrl = getDivolteScriptUrl;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISTINCE_ID = undefined;
exports.getDistinctID = getDistinctID;

var _jsCookie = __webpack_require__(79);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FINGERPRINT_ID = 'fingerprintjs2Script';
var DISTINCE_ID = exports.DISTINCE_ID = 'DISTINCE_ID';

function loadFingerprint() {
  return new Promise(function (resolve, reject) {
    if (!!document.querySelector('#' + FINGERPRINT_ID)) resolve();

    var script = document.createElement('script');
    script.id = FINGERPRINT_ID;
    script.src = '//wx-static.keruyun.com/cdn/fingerprintjs2/1.5.1/fingerprint2.min.js';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);

    script.addEventListener('load', function () {
      script = null;
      resolve();
    });

    script.addEventListener('error', function () {
      reject(new Error('加载fingerprintjs2失败'));
    });
  });
}

function getDistinctID() {
  return new Promise(function (resolve) {
    var distinctID = _jsCookie2.default.get(DISTINCE_ID);
    if (distinctID) {
      resolve(distinctID);
    }

    loadFingerprint().then(function () {
      var fp = new Fingerprint2();
      fp.get(function (id) {
        _jsCookie2.default.set(DISTINCE_ID, id);
        resolve(id);
      });
    });
  });
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var eventMap = {
  click: function click(handler) {
    document.body.addEventListener('click', function (e) {
      // trigger default event, while handle custom-events
      handler(e);

      // trigger global 'click' event
      handler({
        eventName: 'click',
        target: e.target,
        content: {
          pageX: e.pageX,
          pageY: e.pageY
        }
      });
    }, false);
  },
  error: function error(handler) {
    window.addEventListener('error', function (e) {
      var error = e.error;


      handler({
        eventName: 'error',
        content: {
          // will change property name
          content: error && error.stack
        }
      });
    }, false);
  },
  load: function load(handler) {
    var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    window.addEventListener('load', function () {
      var _defaultParams$exclud = defaultParams.excludeEvent,
          excludeEvent = _defaultParams$exclud === undefined ? [] : _defaultParams$exclud;

      if (!Array.isArray(excludeEvent)) excludeEvent = [];
      if (window.performance) {
        var timing = window.performance.timing;
        if (timing) {
          var navigation = window.performance.navigation;

          var firstPaintTime = null;
          if (window.chrome && window.chrome.loadTimes) {
            var loadTimes = window.chrome.loadTimes();
            firstPaintTime = loadTimes.firstPaintTime - loadTimes.startLoadTime;
          } else if (timing.msFirstPaint) {
            firstPaintTime = timing.msFirstPaint - timing.navigationStart;
          }

          if (!excludeEvent.includes('performance-timing')) {
            handler({
              eventName: 'performance-timing',
              content: {
                duration: timing.responseEnd - timing.navigationStart,
                redirect: timing.redirectEnd - timing.redirectStart,
                appCache: timing.domainLookupStart - timing.fetchStart,
                dnsTime: timing.domainLookupEnd - timing.domainLookupStart,
                connect: timing.connectEnd - timing.connectStart,
                fetchFirstByte: timing.responseStart - timing.navigationStart,
                firstPaintTime: firstPaintTime,
                requestTime: timing.responseStart - timing.requestStart,
                responseTime: timing.responseEnd - timing.responseStart,
                domReady: timing.domInteractive - timing.navigationStart,
                onLoadTime: timing.loadEventEnd - timing.navigationStart,
                navigationType: navigation ? navigation.type : null,
                navigationRedirectCount: navigation ? navigation.redirectCount : null
              }
            });
          }
        }

        if (window.performance.getEntriesByType && !excludeEvent.includes('resource-timing')) {
          var resourceTimingList = window.performance.getEntriesByType('resource');
          if (resourceTimingList && resourceTimingList.length > 0) {
            var supportedTypes = ['script', 'link', 'css'];

            resourceTimingList.filter(function (item) {
              return supportedTypes.indexOf(item.initiatorType) !== -1;
            }).map(function (item) {
              return {
                initiatorType: item.initiatorType,
                size: item.transferSize,
                duration: item.duration,
                redirect: item.redirectEnd - item.redirectStart,
                appCache: item.domainLookupStart - item.fetchStart,
                dnsTime: item.domainLookupEnd - item.domainLookupStart,
                connect: item.connectEnd - item.connectStart,
                fetchFirstByte: item.responseStart - item.startTime,
                requestTime: item.responseStart - item.requestStart,
                responseTime: item.responseEnd - item.responseStart
              };
            }).forEach(function (content) {
              return handler({
                eventName: 'resource-timing',
                content: content
              });
            });
          }
        }
      }
    }, false);
  },
  hashchange: function hashchange(handler) {
    window.addEventListener('hashchange', function () {
      handler({ eventName: 'hashchange' });
    }, false);
  },
  popstate: function popstate(handler) {
    window.addEventListener('popstate', function () {
      handler({ eventName: 'popstate' });
    }, false);
  }
};

// register 'click', 'error' and 'load' events
function registerEventsHandler(handler) {
  var defaultParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _defaultParams$exclud2 = defaultParams.excludeEvent,
      excludeEvent = _defaultParams$exclud2 === undefined ? [] : _defaultParams$exclud2;

  if (!Array.isArray(excludeEvent)) {
    excludeEvent = [];
  }
  Object.keys(eventMap).forEach(function (key) {
    if (excludeEvent.includes(key)) return;
    eventMap[key](handler, defaultParams);
  });
}

exports.default = registerEventsHandler;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var toString = [].toString;
var hasOwn = Object.prototype.hasOwnProperty;
var types = {
  '[object Boolean]': 'bool',
  '[object Number]': 'number',
  '[object String]': 'string',
  '[object Object]': 'object',
  '[object Array]': 'array',
  '[object Function]': 'function',
  '[object Date]': 'date',
  '[object RegExp]': 'regExp'
};
var type = function type(obj) {
  return obj === null ? String(obj) : types[toString.call(obj)] || 'object';
};
var isWindow = function isWindow(obj) {
  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && 'setInterval' in obj;
};
var isArray = Array.isArray || function (obj) {
  return type(obj) === 'array';
};

var isPlainObject = function isPlainObject(obj) {
  if (!obj || type(obj) !== 'object' || isWindow(obj) || obj.nodeType) {
    return false;
  }
  try {
    if (obj.constructor && !hasOwn.call(obj, 'constructor') && !hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')) {
      return false;
    }
  } catch (e) {
    return false;
  }
  var key = void 0;
  // eslint-disable-next-line
  for (key in obj) {}
  return key === undefined || hasOwn.call(obj, key);
};

exports.isPlainObject = isPlainObject;
exports.isArray = isArray;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(110);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(111);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getInfoByFieldsAsync = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fields) {
    var res, i, l, field, fieldFunName, funName, val;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            res = {};
            i = 0, l = fields.length;

          case 2:
            if (!(i < l)) {
              _context.next = 15;
              break;
            }

            field = fields[i];
            fieldFunName = field.charAt(0).toUpperCase() + field.slice(1);
            funName = 'get' + fieldFunName;
            val = '';

            if (!(commonInfoUtils.hasOwnProperty(funName) && typeof commonInfoUtils[funName] === 'function')) {
              _context.next = 11;
              break;
            }

            _context.next = 10;
            return commonInfoUtils[funName]();

          case 10:
            val = _context.sent;

          case 11:
            res[field] = val;

          case 12:
            i++;
            _context.next = 2;
            break;

          case 15:
            return _context.abrupt('return', res);

          case 16:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getInfoByFieldsAsync(_x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getFixedInfo = getFixedInfo;
exports.getDynamicInfo = getDynamicInfo;
exports.getPageTypeFromUrl = getPageTypeFromUrl;

var _commonHelper = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function randomString() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 32;

  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678oOLloOLlVvUuI1';
  var maxPos = $chars.length;
  var actualLength = len - 13;
  actualLength = actualLength > 0 ? actualLength : 5;
  var pwd = '';
  for (var i = 0; i < actualLength; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd + new Date().getTime();
}

// 获取埋点工具的session id
/*
 * @Author: snail
 * @Date: 2020-02-27 16:58:09
 * @Last Modified by: snail
 * @Last Modified time: 2020-03-26 15:36:53
 */
var getStatisticsSessionId = function getStatisticsSessionId() {
  var statisticsSessionId = sessionStorage.getItem('statisticsSessionId');
  if (!statisticsSessionId) {
    statisticsSessionId = Math.random().toString(36).substring(2) + Date.now();
    sessionStorage.setItem('statisticsSessionId', statisticsSessionId);
  }
  return statisticsSessionId;
};
/**
 * 获取公共信息的集合
 */
// const fixedCommonInfoFields = ['sessionId', 'shopId'];
// const fixedCommonInfoFields = ['sessionId', 'shopId'];
// const dynamicCommonInfoFields = ['customerId', 'timestamp', 'recomdFiled', 'pageTitle', 'eventId'];
var fixedCommonInfoFields = ['shopId'];
var dynamicCommonInfoFields = ['customerId', 'timestamp', 'recomFiled', 'recomMark', 'pageTitle'];
var commonInfoUtils = {
  getEventId: function getEventId() {
    return randomString(48);
  },
  getRecomMark: function getRecomMark() {
    return '';
  },

  /**
   * 是否是推荐栏目
   */
  getRecomFiled: function getRecomFiled() {
    return location.href.indexOf('#hot-dish') !== -1 ? '1' : '0';
  },

  /**
   * 获取用户id
   */
  getCustomerId: function getCustomerId() {
    return (0, _commonHelper.getCustomerIdNew)();
  },

  /**
   * 获取时间戳
   */
  getTimestamp: function getTimestamp() {
    return new Date().getTime();
  },

  /**
   * 获取sessionId
   */
  getSessionId: function getSessionId() {
    return getStatisticsSessionId();
  },

  /**
   * 获取页面名称
   */
  getPageTitle: function getPageTitle() {
    return document.title.toString();
  },

  /**
   * 门店ID
   */
  getShopId: function getShopId() {
    return (0, _commonHelper.getUrlParam)('shopId');
  }
};

function getInfoByFieldsSync(fields) {
  var res = {};
  fields.forEach(function (field) {
    var fieldFunName = field.charAt(0).toUpperCase() + field.slice(1);
    var funName = 'get' + fieldFunName;
    var val = '';
    if (commonInfoUtils.hasOwnProperty(funName) && typeof commonInfoUtils[funName] === 'function') {
      val = commonInfoUtils[funName]();
    }
    res[field] = val;
  });
}

function getFixedInfo() {
  return getInfoByFieldsSync(fixedCommonInfoFields);
}

function getDynamicInfo() {
  return getInfoByFieldsAsync(dynamicCommonInfoFields);
}

var pathMapPageType = {
  '/takeaway/selectDish': '外卖点餐页',
  '/orderall/dishMenu4Quik': '快餐点餐页',
  '/orderall/dishMenu4Dinner': '堂食点餐页'
};

/**
 * 根据界面路径，获取埋点的pageType字段
 */
function getPageTypeFromUrl() {
  return pathMapPageType[location.pathname] || document.title || '';
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allBuryingPoint = allBuryingPoint;
function getPathStr(path) {
  var xPath = [];
  if (Array.isArray(path)) {
    path.forEach(function (node) {
      if (node.tagName) {
        var str = (node.tagName || '').toLocaleLowerCase();
        var id = !!node.id ? '#' + node.id : '';
        var className = !!node.className ? '.' + node.className.split(' ').join('.') : '';
        xPath.push('' + str + id + className);
      }
    });
  }
  return xPath.reverse().join('>');
}

function getTagUrl(node) {
  return node.src || node.href || '';
}

function allBuryingPoint(buryingPoint) {
  /**
   * 界面元素点击事件埋点
   */
  document.body.addEventListener('click', function (event) {
    var e = event || window.event;
    var _e$target = e.target,
        target = _e$target === undefined ? {} : _e$target,
        _e$path = e.path,
        path = _e$path === undefined ? [] : _e$path;

    var _ref = target || {},
        _ref$id = _ref.id,
        id = _ref$id === undefined ? '' : _ref$id,
        _ref$tagName = _ref.tagName,
        tagName = _ref$tagName === undefined ? '' : _ref$tagName,
        _ref$textContent = _ref.textContent,
        textContent = _ref$textContent === undefined ? '' : _ref$textContent,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        _ref$nodeType = _ref.nodeType,
        nodeType = _ref$nodeType === undefined ? '' : _ref$nodeType;

    var param = {
      objectId: id,
      objectName: (tagName || '').toLocaleLowerCase(),
      objectContent: textContent,
      objectClassName: className,
      objectType: nodeType,
      objectSelector: getPathStr(path),
      objectTargetUrl: getTagUrl(target)
    };
    buryingPoint.send('ObjectClick', param);
  }, false);
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(74);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _defineMessages;

var _reactIntl = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _reactIntl.defineMessages)((_defineMessages = {
  orderInclusiveTax: {
    id: 'order.inclusiveTax',
    defaultMessage: '消费税(已包含)'
  },
  orderStatusIng: {
    id: 'order.status.ing',
    defaultMessage: '未完成'
  },
  orderStatusDone: {
    id: 'order.status.done',
    defaultMessage: '已完成'
  },
  uncheckRecommendation: {
    id: 'order.uncheckRecommendation',
    defaultMessage: '大厨拿手菜'
  },
  orderSerialNo: {
    id: 'order.serialNo',
    defaultMessage: '流水号'
  },
  orderWholeNotes: {
    id: 'order.wholeNotes',
    defaultMessage: '整单备注'
  },
  orderUncheckMessageOne: {
    id: 'order.uncheckMessageOne',
    defaultMessage: '订单已提交，等待商家确认'
  },
  orderUncheckMessageTwo: {
    id: 'order.uncheckMessageTwo',
    defaultMessage: '商户已接单，祝您用餐愉快！'
  },
  orderSurChargeAmount: {
    id: 'order.uncheck.suerChargeAmount',
    defaultMessage: '附加费总计'
  },
  orderPrivilegeAmount: {
    id: 'order.privilegeAmount',
    defaultMessage: '优惠总计'
  },
  orderCommodities: {
    id: 'order.commodities',
    defaultMessage: '商品'
  },
  orderProceedToCheckout: {
    id: 'order.proceedToCheckout',
    defaultMessage: '去结账'
  },
  orderWaiter: {
    id: 'order.Waiter',
    defaultMessage: '服务员'
  },
  orderPicked: {
    id: 'order.picked',
    defaultMessage: '已选商品'
  },
  orderTotalDishes: {
    id: 'order.totalDishes',
    defaultMessage: '共{count}份'
  },
  limitDishesCount: {
    id: 'order.limitDishesCount',
    defaultMessage: '仅限{count}份'
  },
  modifyOrder: {
    id: 'order.modifyOrder',
    defaultMessage: '修改订单'
  },
  orderGift: {
    id: 'order.gift',
    defaultMessage: '送'
  },
  memberPrivilege: {
    id: 'order.memberPrivilege',
    defaultMessage: '会员优惠'
  },
  rightsCardPrivilege: {
    id: 'order.rightsCardPrivilege',
    defaultMessage: '折扣卡优惠'
  },
  deductScore: {
    id: 'order.deductScore',
    defaultMessage: '抵扣{privilegeValue}积分'
  },
  deductScore1: {
    id: 'order.deductScore1',
    defaultMessage: '抵扣{privilegeValue}捞币'
  },
  activityPrivilege: {
    id: 'order.activityPrivilege',
    defaultMessage: '活动优惠'
  },
  limitPrivilege: {
    id: 'order.limitPrivilege',
    defaultMessage: '限免优惠'
  },
  giftPrivilegeName: {
    id: 'order.giftPrivilegeName',
    defaultMessage: '礼品券-赠送{privilegeName}'
  },
  giftPrivilege: {
    id: 'order.giftPrivilege',
    defaultMessage: '礼品券'
  },
  elsePrivilege: {
    id: 'order.elsePrivilege',
    defaultMessage: '其他优惠'
  },
  inUseCards: {
    id: 'order.inUseCards',
    defaultMessage: '已选{count}张'
  },
  canUseCards: {
    id: 'order.canUseCards',
    defaultMessage: '{count}张可用'
  },
  useCardsTitle: {
    id: 'order.useCardsTitle',
    defaultMessage: '使用礼品卡'
  },
  useCouponsTitle: {
    id: 'order.useCouponsTitle',
    defaultMessage: '使用优惠券'
  },
  freeDeliveryPrice: {
    id: 'order.freeDeliveryPrice',
    defaultMessage: '满{currency}{freeDeliveryPrice}减免配送费'
  },
  couponGiftName: {
    id: 'order.couponGiftName',
    defaultMessage: '优惠券优惠{giftName}'
  },
  cardsReduct: {
    id: 'order.cardsReduct',
    defaultMessage: '礼品卡抵扣'
  },
  primaryPrice: {
    id: 'order.primaryPrice',
    defaultMessage: '原价'
  },
  goodsPrice: {
    id: 'order.goodsPrice',
    defaultMessage: '商品金额'
  },
  includeTaxPrice: {
    id: 'order.includeTaxPrice',
    defaultMessage: '含税价'
  },
  floorPrice: {
    id: 'order.floorPrice',
    defaultMessage: '自动抹零'
  },
  adjustPrice: {
    id: 'order.adjustPrice',
    defaultMessage: '尾数调整'
  },
  totalDiscout: {
    id: 'order.totalDiscout',
    defaultMessage: '共优惠'
  },
  orderTotal: {
    id: 'order.orderTotal',
    defaultMessage: '共计'
  },
  orderTime: {
    id: 'order.orderTime',
    defaultMessage: '下单时间'
  },
  earnestMoney: {
    id: 'order.earnestMoney',
    defaultMessage: '已收定金'
  },
  payMethod: {
    id: 'order.payMethod',
    defaultMessage: '支付方式'
  },
  orderId: {
    id: 'order.orderId',
    defaultMessage: '订单编号'
  },
  oneMoreOrder: {
    id: 'order.oneMoreOrder',
    defaultMessage: '再来一单'
  },
  payImmediately: {
    id: 'order.payImmediately',
    defaultMessage: '立即支付'
  },
  deliveryPrice: {
    id: 'order.deliveryPrice',
    defaultMessage: '配送费'
  },
  dishBoxPrice: {
    id: 'order.dishBoxPrice',
    defaultMessage: '餐盒费'
  },
  saleTax: {
    id: 'order.saleTax',
    defaultMessage: '消费税'
  },
  lowestConsumption: {
    id: 'order.lowestConsumption',
    defaultMessage: '最低消费差额附加费'
  },
  serviceCharge: {
    id: 'order.serviceCharge',
    defaultMessage: '服务费'
  },
  reservedSuccessfully: {
    id: 'order.reservedSuccessfully',
    defaultMessage: '预定成功'
  },
  noShow: {
    id: 'order.noShow',
    defaultMessage: '未到店'
  },
  reservationFailed: {
    id: 'order.reservationFailed',
    defaultMessage: '预订失败'
  },
  unpaid: {
    id: 'order.unpaid',
    defaultMessage: '未支付'
  },
  confirming: {
    id: 'order.confirming',
    defaultMessage: '确认中'
  },
  cancelled: {
    id: 'order.cancelled',
    defaultMessage: '取消预订'
  },
  checkedIn: {
    id: 'order.checkedIn',
    defaultMessage: '已到店'
  },
  confirmed: {
    id: 'order.confirmed',
    defaultMessage: '已确认'
  },
  rejected: {
    id: 'order.rejected',
    defaultMessage: '已拒绝'
  },
  needToPay: {
    id: 'order.needToPay',
    defaultMessage: '还需付'
  },
  selectBenefit: {
    id: 'dialog.selectBenefit',
    defaultMessage: '该商品可参加以下优惠'
  },
  wholeBenefitSelect: {
    id: 'dialog.wholeBenefitSelect',
    defaultMessage: '选择整单商品优惠'
  },
  applyProductType: {
    id: 'dialog.applyProductType',
    defaultMessage: '查看适用商品'
  },
  notApplyProductType: {
    id: 'dialog.notApplyProductType',
    defaultMessage: '查看不适用商品'
  },
  applyProductRange: {
    id: 'dialog.applyProductRange',
    defaultMessage: '商品适用范围'
  },
  isKoubei: {
    id: 'isKoubei',
    defaultMessage: '开始口碑秒付'
  },
  chooseCoupon: {
    id: 'chooseCoupon',
    defaultMessage: '选择优惠券'
  },
  orderSettlement: {
    id: 'orderSettlement',
    defaultMessage: '订单结算'
  },
  ordertableType: {
    id: 'order.tableType',
    defaultMessage: '{pNum}人桌'
  },
  orderlastTable: {
    id: 'order.lastTable',
    defaultMessage: '剩余{count}桌'
  },
  ordernoTablePrompt: {
    id: 'order.noTablePrompt',
    defaultMessage: '没有可用桌台'
  },
  orderoccupied: {
    id: 'order.occupied',
    defaultMessage: '该桌台已被占用'
  },
  orderselectTable: {
    id: 'order.selectTable',
    defaultMessage: '选择桌台'
  },
  orderconfirm: {
    id: 'order.confirm',
    defaultMessage: '确定'
  },
  orderquicklyComeShop: {
    id: 'order.quicklyComeShop',
    defaultMessage: '尽快到店'
  },
  orderquicklySend: {
    id: 'order.quicklySend',
    defaultMessage: '尽快送达'
  },
  ordergotoStore: {
    id: 'order.gotoStore',
    defaultMessage: '到店'
  },
  ordertakeFood: {
    id: 'order.takeFood',
    defaultMessage: '取餐'
  },
  orderArrived: {
    id: 'order.Arrived',
    defaultMessage: '送达'
  },
  orderchooseTime: {
    id: 'order.chooseTime',
    defaultMessage: '选择{postfix}时间'
  },
  ordergotoAddOn: {
    id: 'order.gotoAddOn',
    defaultMessage: '去凑单'
  },
  orderwithoutVIP: {
    id: 'order.withoutVIP',
    defaultMessage: '不使用会员价'
  },
  orderreChoose: {
    id: 'order.reChoose',
    defaultMessage: '重新挑选'
  },
  orderreExchange: {
    id: 'order.reExchange',
    defaultMessage: '重新换购'
  },
  ordergotoChoose: {
    id: 'order.gotoChoose',
    defaultMessage: '去挑选'
  },
  ordergotoExchange: {
    id: 'order.gotoExchange',
    defaultMessage: '去换购'
  },
  orderAdapt: {
    id: 'order.Adapt',
    defaultMessage: '所用商品适用'
  },
  ordercheckNoAdapt: {
    id: 'order.checkNoAdapt',
    defaultMessage: '查看不适用商品'
  },
  ordercheckAdapt: {
    id: 'order.checkAdapt',
    defaultMessage: '查看适用商品'
  },
  orderMutex: {
    id: 'order.Mutex',
    defaultMessage: '本活动与优惠券互斥'
  },
  ordernoAdaptCoupon: {
    id: 'order.noAdaptCoupon',
    defaultMessage: '不使用优惠券'
  },
  orderselectedGift: {
    id: 'order.selectedGift',
    defaultMessage: '已选赠品'
  },
  orderexchangedGoods: {
    id: 'order.exchangedGoods',
    defaultMessage: '已换购商品'
  },
  orderfillToCut: {
    id: 'order.fillToCut',
    defaultMessage: '满减'
  },
  orderfillToDiscount: {
    id: 'order.fillToDiscount',
    defaultMessage: '满折'
  },
  orderfillToGive: {
    id: 'order.fillToGive',
    defaultMessage: '满赠'
  },
  orderExchange: {
    id: 'order.Exchange',
    defaultMessage: '换购'
  },
  orderVIPPrice: {
    id: 'order.VIPPrice',
    defaultMessage: '会员价'
  },
  modify: {
    id: 'order.modify',
    defaultMessage: '修改'
  },
  orderwithoutShare: {
    id: 'order.withoutShare',
    defaultMessage: '不与整单优惠共享'
  },
  orderchooseActivity: {
    id: 'order.chooseActivity',
    defaultMessage: '请选择要参与的活动'
  },
  orderwithoutActivity: {
    id: 'order.withoutActivity',
    defaultMessage: '不参与促销活动'
  },
  ordercomfirmJoinDiscount: {
    id: 'order.comfirmJoinDiscount',
    defaultMessage: "此促销与优惠券互斥, 参与促销将重置优惠券, 确认参与促销?'"
  },
  ordermutexOfDiscount: {
    id: 'order.mutexOfDiscount',
    defaultMessage: '满减优惠与折扣商品不可同享'
  },
  ordercomfirmChange: {
    id: 'order.comfirmChange',
    defaultMessage: '更改可能导致部分商品不能参与优惠，确定更改吗？'
  },
  orderchooseDiscount: {
    id: 'order.chooseDiscount',
    defaultMessage: '选择参与商品优惠'
  },
  orderbalance: {
    id: 'order.balance',
    defaultMessage: '余额：'
  },
  ordergiftCard: {
    id: 'order.giftCard',
    defaultMessage: '礼品卡抵扣'
  },
  orderToplimit: {
    id: 'order.Toplimit',
    defaultMessage: '已到添加上限'
  },
  orderInsufficient: {
    id: 'order.Insufficient',
    defaultMessage: '库存不足'
  },
  orderranOut: {
    id: 'order.ranOut',
    defaultMessage: '已售罄'
  },
  orderchooseStandards: {
    id: 'order.chooseStandards',
    defaultMessage: '选规格'
  },
  orderchooseDishs: {
    id: 'order.chooseDishs',
    defaultMessage: '选子菜'
  },
  orderExchanged: {
    id: 'order.exchanged',
    defaultMessage: '已换购'
  },
  orderappointedGoods: {
    id: 'order.appointedGoods',
    defaultMessage: '指定商品'
  },
  orderChoosed: {
    id: 'order.Choosed',
    defaultMessage: '选好啦'
  },
  orderFilled: {
    id: 'order.Filled',
    defaultMessage: '凑好啦'
  },
  orderselectPayWay: {
    id: 'order.selectPayWay',
    defaultMessage: '请选择支付方式'
  },
  ordertable: {
    id: 'order.table',
    defaultMessage: '桌台'
  },
  orderfulled: {
    id: 'order.fulled',
    defaultMessage: '已满'
  },
  ordergoOnPurchase: {
    id: 'order.goOnPurchase',
    defaultMessage: '单品再买'
  },
  orderchooseTable: {
    id: 'order.chooseTable',
    defaultMessage: '选择桌台'
  },
  orderplsChooseTable: {
    id: 'order.plsChooseTable',
    defaultMessage: '请选择桌台'
  },
  ordertableOccupied: {
    id: 'order.tableOccupied',
    defaultMessage: '该桌台已被占用'
  },
  ordernoFreeTable: {
    id: 'order.noFreeTable',
    defaultMessage: '没有可用桌台'
  },
  orderchoosedCount: {
    id: 'order.choosedCount',
    defaultMessage: '已选{count}份'
  },
  orderpeopleNumber: {
    id: 'order.peopleNumber',
    defaultMessage: '就餐人数'
  },
  orderchooseNumber: {
    id: 'order.chooseNumber',
    defaultMessage: '选择人数'
  },
  ordernumberPlate: {
    id: 'order.numberPlate',
    defaultMessage: '号牌'
  },
  orderchooseNumberPlate: {
    id: 'order.chooseNumberPlate',
    defaultMessage: '请选择号牌'
  },
  ordermutexWithDiscount: {
    id: 'order.mutexWithDiscount',
    defaultMessage: '当前选择优惠与整单优惠不能通用，是否取消整单优惠，选择优惠券'
  },
  ordermutexWithAddPrice: {
    id: 'order.mutexWithAddPrice',
    defaultMessage: '当前选择优惠与单商品优惠/加价购不能通用，是否取消单商品优惠/加价购，选择优惠券'
  },
  ordername: {
    id: 'order.name',
    defaultMessage: '姓名：'
  },
  ordername1: {
    id: 'order.name1',
    defaultMessage: '姓名'
  },
  orderinputName: {
    id: 'order.inputName',
    defaultMessage: '请输入姓名'
  },
  orderSex: {
    id: 'order.Sex',
    defaultMessage: '性别：'
  },
  orderSex1: {
    id: 'order.Sex1',
    defaultMessage: '性别'
  },
  orderWoman: {
    id: 'order.Woman',
    defaultMessage: '女士'
  },
  orderMan: {
    id: 'order.Man',
    defaultMessage: '先生'
  },
  orderPN: {
    id: 'order.PN',
    defaultMessage: '手机号'
  },
  orderinputPN: {
    id: 'order.inputPN',
    defaultMessage: '请输入手机号码'
  },
  orderaddress: {
    id: 'order.address',
    defaultMessage: '可选收货地址'
  },
  orderoutOfRange: {
    id: 'order.outOfRange',
    defaultMessage: '不在配送范围内'
  },
  ordernoAddress: {
    id: 'order.noAddress',
    defaultMessage: '主人还没有收货地址'
  },
  ordergotoAdd: {
    id: 'order.gotoAdd',
    defaultMessage: '快来添加一个吧～'
  },
  orderaddAddressPrompt: {
    id: 'order.addAddressPrompt',
    defaultMessage: '如需新增，请删除或修改已有地址'
  },
  orderaddAddress: {
    id: 'order.addAddress',
    defaultMessage: '新增地址'
  },
  orderTelephoneNumber: {
    id: 'order.TelephoneNumber',
    defaultMessage: '联系电话：'
  },
  orderTelephoneNumber1: {
    id: 'order.TelephoneNumber1',
    defaultMessage: '联系电话'
  },
  orderSave: {
    id: 'order.Save',
    defaultMessage: '保存'
  },
  orderwayOfGetFood: {
    id: 'order.wayOfGetFood',
    defaultMessage: '取餐方式'
  },
  ordertoTable: {
    id: 'order.toTable',
    defaultMessage: '送餐到桌'
  },
  orderselfTake: {
    id: 'order.selfTake',
    defaultMessage: '前台自取'
  },
  orderusePointsToDiscount: {
    id: 'order.usePointsToDiscount',
    defaultMessage: '可用{integralValue}积分抵扣'
  },
  orderusePointsToDiscount1: {
    id: 'order.usePointsToDiscount1',
    defaultMessage: '可用{integralValue}捞币抵扣'
  },
  orderplsInputName: {
    id: 'order.plsInputName',
    defaultMessage: '请输入姓名：'
  },
  orderPS: {
    id: 'order.PS',
    defaultMessage: '备注：'
  },
  orderExchangeDiscount: {
    id: 'order.ExchangeDiscount',
    defaultMessage: '换促销'
  },
  ordertopping: {
    id: 'order.topping',
    defaultMessage: '配料'
  },
  ordertablewareNumber: {
    id: 'order.tablewareNumber',
    defaultMessage: '餐具份数'
  },
  ordernoTableware: {
    id: 'order.noTableware',
    defaultMessage: '无需餐具'
  },
  orderRecommend: {
    id: 'order.Recommend',
    defaultMessage: '推荐'
  },
  orderTablewares: {
    id: 'order.Tablewares',
    defaultMessage: '（筷子、刀、勺、吸管）'
  },
  orderinputPrompt1: {
    id: 'order.inputPrompt1',
    defaultMessage: '请输入大于0的数字'
  },
  orderinputPrompt2: {
    id: 'order.inputPrompt2',
    defaultMessage: '不能超过99份'
  },
  orderuseable: {
    id: 'order.useable',
    defaultMessage: '所有商品可用'
  },
  ordercheckUseable: {
    id: 'order.checkUseable',
    defaultMessage: '查看适用商品'
  },
  ordertoJoinDiscount: {
    id: 'order.toJoinDiscount',
    defaultMessage: '选择参与整单优惠'
  },
  orderTheTotalDishs: {
    id: 'order.totalTheDishs',
    defaultMessage: '共计{dishCount}份菜'
  },
  otherInfo: {
    id: 'otherInfo',
    defaultMessage: '其他信息'
  },
  orderGetNumber: {
    id: 'order.GetNumber',
    defaultMessage: '{createTime} 取号'
  },
  orderQueuePrompt: {
    id: 'order.QueuePrompt',
    defaultMessage: '听到叫号请到迎宾台，过号作废'
  },
  orderDinnerStateUseMemberIntegral: {
    id: 'orderDinner.UseMemberIntegral',
    defaultMessage: '使用会员积分'
  },
  orderDinnerStateMyIntegral: {
    id: 'orderDinner.MyIntegral',
    defaultMessage: '我的积分'
  },
  orderDinnerStateEnjoyMembershipPrice: {
    id: 'orderDinner.EnjoyMembershipPrice',
    defaultMessage: '享受会员价'
  },
  orderDinnerStateWholeBenefitDiscount: {
    id: 'orderDinner.WholeBenefit',
    defaultMessage: '整单商品优惠'
  },
  orderOnlinePayment: {
    id: 'order.OnlinePayment',
    defaultMessage: '在线支付'
  },
  orderOfflinePayment: {
    id: 'order.OfflinePayment',
    defaultMessage: '线下支付'
  },
  orderCashOnDelivery: {
    id: 'order.CashOnDelivery',
    defaultMessage: '货到付款'
  },
  orderEnjoyed: {
    id: 'order.Enjoyed',
    defaultMessage: '已享'
  },
  orderExclusivePrice: {
    id: 'order.ExclusivePrice',
    defaultMessage: '专享价'
  },
  orderInvoicingWarn: {
    id: 'order.InvoicingWarn',
    defaultMessage: '该订单所在门店不支持开发票'
  },
  orderWaitingInLine: {
    id: 'order.WaitingInLine',
    defaultMessage: '排队中'
  },
  orderAlreadyAdmitted: {
    id: 'order.AlreadyAdmitted',
    defaultMessage: '已入场'
  },
  orderAbolished: {
    id: 'order.Abolished',
    defaultMessage: '已作废'
  },
  orderCancelled: {
    id: 'order.Cancelled',
    defaultMessage: '已取消'
  },
  orderWatingForTables: {
    id: 'order.WatingForTables',
    defaultMessage: '前面{number}桌等待'
  },
  orderGoodsNotInvolved: {
    id: 'order.GoodsNotInvolved',
    defaultMessage: '未参与加价购的商品'
  },
  orderManualInput: {
    id: 'order.ManualInput',
    defaultMessage: '手动输入'
  },
  orderToDay: {
    id: 'orderToDay',
    defaultMessage: '今日'
  },
  orderNoUseableShopTime: {
    id: 'orderNoUseableShopTime',
    defaultMessage: '没有可用到店时间'
  },
  orderNoUseableSendTime: {
    id: 'orderNoUseableSendTime',
    defaultMessage: '没有可用送达时间'
  },
  orderComeToShop: {
    id: 'orderComeToShop',
    defaultMessage: '到店取餐'
  },
  orderSelectTableWare: {
    id: 'orderSelectTableWare',
    defaultMessage: '推荐选无需餐具，未选择'
  },
  orderAdeptGoods: {
    id: 'orderAdeptGoods',
    defaultMessage: '适用商品'
  },
  orderNoAdeptGoods: {
    id: 'orderNoAdeptGoods',
    defaultMessage: '不适用商品'
  },
  orderSelectPlate: {
    id: 'orderSelectPlate',
    defaultMessage: '选择号牌'
  },
  orderSelectTable: {
    id: 'orderSelectTable',
    defaultMessage: '选择桌台'
  },
  orderTotalPrice: {
    id: 'orderTotalPrice',
    defaultMessage: '总金额'
  },
  orderDiscountPropmpt: {
    id: 'orderDiscountPropmpt',
    defaultMessage: '折扣单品每单限一份，按照折扣最大力度的单品享受，超出部分按照原价购买。'
  },
  orderCannotGetDiscount: {
    id: 'orderCannotGetDiscount',
    defaultMessage: '您选择的配送时段在优惠时段以外，无法享受优惠'
  },
  orderGetPot: {
    id: 'orderGetPot',
    defaultMessage: '锅底为必选菜品，请确认已选锅底'
  },
  returnToDish: {
    id: 'returnToDish',
    defaultMessage: '回到点餐页'
  },
  notOrderMustDish: {
    id: 'notOrderMustDish',
    defaultMessage: '您还未选必点菜'
  },
  orderLowestSpend: {
    id: 'orderLowestSpend',
    defaultMessage: '本桌最低消费{lowestConsumption}元，还差{tradeAmount}元'
  },
  orderPersons: {
    id: 'orderPersons',
    defaultMessage: '{count}人'
  },
  orderPersonAbove: {
    id: 'orderPersonAbove',
    defaultMessage: '人以上'
  },
  orderTableQuantity: {
    id: 'orderTableQuantity',
    defaultMessage: '{count}桌'
  },
  orderTableName: {
    id: 'order.tableName',
    defaultMessage: '{pNum}人桌(余下{count}桌)'
  },
  buyMore: {
    id: 'order.buyMore',
    defaultMessage: '再买'
  },
  Subtotal: {
    id: 'order.Subtotal',
    defaultMessage: '小计'
  },
  canDiscount: {
    id: 'order.canDiscount',
    defaultMessage: '可享优惠'
  },
  yuan: {
    id: 'order.yuan',
    defaultMessage: '元'
  },
  reduce: {
    id: 'order.reduce',
    defaultMessage: '减'
  },
  enjoy: {
    id: 'order.enjoy',
    defaultMessage: '享'
  },
  add: {
    id: 'order.add',
    defaultMessage: '加'
  },
  choose: {
    id: 'order.choose',
    defaultMessage: '选'
  },
  discount: {
    id: 'order.discount',
    defaultMessage: '折'
  },
  yuanBuy: {
    id: 'order.yuanBuy',
    defaultMessage: '元换购商品'
  },
  gifts: {
    id: 'order.gifts',
    defaultMessage: '份赠品'
  },
  full: {
    id: 'order.full',
    defaultMessage: '满'
  },
  can: {
    id: 'order.can',
    defaultMessage: '可'
  },
  already: {
    id: 'order.already',
    defaultMessage: '已'
  },
  less: {
    id: 'order.less',
    defaultMessage: '还差'
  },
  orderNotSelectedGiftCard: {
    id: 'orderNotSelectedGiftCard',
    defaultMessage: '未选择礼品卡'
  },
  orderSelectDinnerPeople: {
    id: 'orderSelectDinnerPeople',
    defaultMessage: '请选择就餐人数'
  },
  orderUnSelectPlate: {
    id: 'orderUnSelectPlate',
    defaultMessage: '未选择号牌'
  },
  orderOpenSelfGetSwitch: {
    id: 'orderOpenSelfGetSwitch',
    defaultMessage: '请打开前台自取开关'
  },
  orderUnSelectTableInfo: {
    id: 'orderUnSelectTableInfo',
    defaultMessage: '未选择桌台信息'
  },
  orderCannotUseWXCard: {
    id: 'orderCannotUseWXCard',
    defaultMessage: '订单不可使用微信卡券'
  },
  orderCannotUsePrompt: {
    id: 'orderCannotUsePrompt',
    defaultMessage: '非常抱歉，线下支付不可使用微信卡券'
  },
  orderHelperSelect: {
    id: 'orderHelperSelect',
    defaultMessage: '请选择'
  },
  orderHelperTime: {
    id: 'orderHelperTime',
    defaultMessage: '时间'
  },
  next: {
    id: 'order.next',
    defaultMessage: '下一份'
  },
  lowestPrice: {
    id: 'order.lowestPrice',
    defaultMessage: '最低价'
  },
  chooseNext: {
    id: 'order.chooseNext',
    defaultMessage: '选择下一份'
  },
  every: {
    id: 'order.every',
    defaultMessage: '每'
  },
  orderMemoIsRequired: {
    id: 'orderMemoIsRequired',
    defaultMessage: '订单备注不能为空'
  },
  quickMemo1: {
    id: 'quickMemo1',
    defaultMessage: '挂门把手上'
  },
  quickMemo2: {
    id: 'quickMemo2',
    defaultMessage: '放前台'
  },
  quickMemo3: {
    id: 'quickMemo3',
    defaultMessage: '放门口'
  },
  quickMemo4: {
    id: 'quickMemo4',
    defaultMessage: '请电话联系我'
  },
  orderNumber: {
    id: 'orderNumber',
    defaultMessage: '个订单'
  },
  total: {
    id: 'total',
    defaultMessage: '共'
  }
}, (0, _defineProperty3.default)(_defineMessages, 'yuan', {
  id: 'yuan',
  defaultMessage: '元'
}), (0, _defineProperty3.default)(_defineMessages, 'orderAllChoose', {
  id: 'orderAllChoose',
  defaultMessage: '本页全选'
}), (0, _defineProperty3.default)(_defineMessages, 'noOrder', {
  id: 'noOrder',
  defaultMessage: '当前门店没有订单'
}), (0, _defineProperty3.default)(_defineMessages, 'allOrdersLoaded', {
  id: 'allOrdersLoaded',
  defaultMessage: '已加载所有订单'
}), (0, _defineProperty3.default)(_defineMessages, 'loadMore', {
  id: 'loadMore',
  defaultMessage: '点击加载更多'
}), (0, _defineProperty3.default)(_defineMessages, 'openInvoice', {
  id: 'openInvoice',
  defaultMessage: '当前门店未开通发票业务，请与商家联系'
}), (0, _defineProperty3.default)(_defineMessages, 'orderUsecard', {
  id: 'order.useDiscountCard',
  defaultMessage: '使用折扣卡'
}), (0, _defineProperty3.default)(_defineMessages, 'orderDiscounts', {
  id: 'order.discounts',
  defaultMessage: '折扣不与商品优惠、会员价同享'
}), (0, _defineProperty3.default)(_defineMessages, 'orderNoCards', {
  id: 'order.noCards',
  defaultMessage: '暂无可用卡'
}), (0, _defineProperty3.default)(_defineMessages, 'orderInvalidTaxIdentyNo', {
  id: 'order.invalidTaxIdentyNo',
  defaultMessage: '纳税人识别号信息不允许含有特殊字符'
}), (0, _defineProperty3.default)(_defineMessages, 'orderInvalidReceipt', {
  id: 'order.invalidReceipt',
  defaultMessage: '发票抬头信息不允许含有特殊字符'
}), (0, _defineProperty3.default)(_defineMessages, 'orderInvalidNote', {
  id: 'order.invalidNote',
  defaultMessage: '订单备注信息不允许含有特殊字符'
}), _defineMessages));

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(75);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

__webpack_require__(146);

__webpack_require__(147);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(114);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _redux = __webpack_require__(122);

var _reactRedux = __webpack_require__(115);

var _reactIntl = __webpack_require__(7);

var _en = __webpack_require__(251);

var _en2 = _interopRequireDefault(_en);

var _zh = __webpack_require__(252);

var _zh2 = _interopRequireDefault(_zh);

var _th = __webpack_require__(253);

var _th2 = _interopRequireDefault(_th);

var _reduxThunk = __webpack_require__(254);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactTapEventPlugin = __webpack_require__(228);

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _commonHelper = __webpack_require__(3);

var _helper = __webpack_require__(16);

var _PermissionProvider = __webpack_require__(255);

var _PermissionProvider2 = _interopRequireDefault(_PermissionProvider);

var _helper2 = __webpack_require__(256);

var _wxMiniprogramHelper = __webpack_require__(113);

var _wxMiniprogramHelper2 = _interopRequireDefault(_wxMiniprogramHelper);

var _topNavigator = __webpack_require__(258);

var _topNavigator2 = _interopRequireDefault(_topNavigator);

var _navigator = __webpack_require__(260);

var _navigator2 = _interopRequireDefault(_navigator);

__webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import logger from './helper/logger';

// import sg from 'react-intl/locale-data/sg';
var isScanCodeFromConf = (0, _commonHelper.getUrlParam)('scan'); // 如果页面带入此参数，代表是符合微信扫码活动

// import initSentry from './helper/sentry';
window.Intl = __webpack_require__(262);

(0, _reactTapEventPlugin2.default)();
// initSentry();

/**
 * 重要提示
 * 此处新增了语言类型，需要在 /src/helper/const/supportLanguage.js 中新增对应的语言类型
 * 同时在 src/helper/const/languages.js 中新增对应的语言资源
 */

(0, _reactIntl.addLocaleData)([].concat((0, _toConsumableArray3.default)(_en2.default), (0, _toConsumableArray3.default)(_zh2.default), (0, _toConsumableArray3.default)(_th2.default)));
(0, _reactIntl.addLocaleData)({ locale: 'zh_CN', parentLocale: 'zh' });
(0, _reactIntl.addLocaleData)({ locale: 'en_GB', parentLocale: 'en' });
(0, _reactIntl.addLocaleData)({ locale: 'zh_TW', parentLocale: 'zh' });
(0, _reactIntl.addLocaleData)({ locale: 'th_TH', parentLocale: 'th' });

var baseUrl = (0, _commonHelper.getWebpackHashFromScriptUrl)();

// 装载对应语言包
function loadLanguage(languageDefault) {
  var script = document.createElement('script');
  var current = languageDefault;

  (0, _assign2.default)(script, {
    type: 'text/javascript',
    src: baseUrl + '/lang/' + current + '/index.js'
  });

  document.body.appendChild(script);

  return new _promise2.default(function (resolve, reject) {
    script.onload = function () {
      resolve(this, languageDefault);
    };

    script.onerror = function (error) {
      reject(error);
    };
  });
}

var addReduxDevTools = function addReduxDevTools(composeList) {
  if (window.__REDUX_DEVTOOLS_EXTENSION__) {
    composeList.push(window.__REDUX_DEVTOOLS_EXTENSION__());
  }
};

function injectTopNavigator() {
  var div = document.createElement('div');
  document.body.appendChild(div);

  _reactDom2.default.render(_react2.default.createElement(_topNavigator2.default, { text: '\u8FD4\u56DE' }), div);

  div = null;
}
function topNavigator() {
  if (history.length > 1) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    _reactDom2.default.render(_react2.default.createElement(_navigator2.default, null), div);
  }
}

var createRootApplication = function createRootApplication(applicationName, reducer) {
  // 支付宝平台小程序添加蚂蚁能量 判断条件 1.是支付宝小程序环境下 2.点餐类型type==="TS" 3.在平台版后加fromPlatform==='1'用于区分平台版和模板
  if ((0, _commonHelper.isAlipayMiniProgramBrowser)() && (0, _commonHelper.getUrlParam)('type') === 'TS' && (0, _commonHelper.getUrlParam)('fromPlatform') === '1') {
    localStorage.setItem('antsEnergy', true);
  }
  // 海底捞模板小程序
  if ((0, _commonHelper.getUrlParam)('wxminiprogramname') === 'h5WxApp' || (0, _commonHelper.getUrlParam)('hdlScence') === '2') {
    sessionStorage.setItem('ISHDL', '1');
  }
  if (!reducer || typeof reducer !== 'function') {
    _reactDom2.default.render(applicationName, document.getElementById('app-placeholder'));
    return;
  }

  var composeList = [];

  if (false) {
    // composeList.push(applyMiddleware(thunkMiddleware, logger));
    composeList.push((0, _redux.applyMiddleware)(_reduxThunk2.default));

    addReduxDevTools(composeList);
  } else {
    composeList.push((0, _redux.applyMiddleware)(_reduxThunk2.default));
  }

  var store = _redux.compose.apply(undefined, composeList)(_redux.createStore)(reducer);

  var render = function render(messages, languageDefault) {
    var sessionIsScanCodeFromConf = sessionStorage.isScanCodeFromConf === 'true';
    // 因为原有逻辑判定是否是扫码点餐部分，session中存入isScanCode
    // 此处如果初次进入页面带入的参数&scan=true,session中存入isScanCodeFromConf
    if (isScanCodeFromConf === 'true' && !sessionIsScanCodeFromConf) {
      // 避免频繁写入
      sessionStorage.isScanCodeFromConf = true;
    }
    var intlCfg = { messages: messages, locale: languageDefault };
    var elem = document.getElementById('app-placeholder');
    var rootCls = (' locale--' + intlCfg.locale).toLocaleLowerCase();

    (0, _helper.initSingletonIntl)(intlCfg);
    // 切换语言之后，将原来的 ‘local--’删除
    // 因为语言类名肯定在最后，所以采用如下方法
    var localeClassIndex = elem.className.indexOf('locale--');
    if (localeClassIndex !== -1) {
      elem.className = elem.className.slice(0, localeClassIndex);
    }
    elem.className += rootCls; // 将新的语言类名填上
    (0, _wxMiniprogramHelper.runInRootWhenMiniPrograme)();

    _reactDom2.default.render(_react2.default.createElement(
      _reactRedux.Provider,
      { store: store },
      _react2.default.createElement(
        _reactIntl.IntlProvider,
        intlCfg,
        _react2.default.createElement(
          _PermissionProvider2.default,
          { permissions: (0, _helper2.getPermissions)() },
          applicationName
        )
      )
    ), elem);

    var topNavSelf = applicationName.type.topNavSelf;

    if (sessionStorage.getItem('ISHDL') === '1') {
      // 海底捞模板小程序
      topNavigator();
    } else if (_wxMiniprogramHelper2.default.isMiniProgramMode() && !topNavSelf) {
      injectTopNavigator();
    }
  };

  var loadFunc = function loadFunc(languageDefault) {
    loadLanguage(languageDefault).then(function () {
      render(window.__LANG_MESSAGES__, languageDefault);
    }).catch(function () {
      render({});
    });
  };
  exports.reload = loadFunc;

  (0, _helper.getShopBaseConf)(loadFunc, applicationName);
};

exports.default = createRootApplication;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},"hour-short":{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},"minute-short":{displayName:"分",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}},"second-short":{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},"day-short":{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},"year-short":{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},"month-short":{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},"day-short":{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},"hour-short":{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},"minute-short":{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}},"second-short":{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.th=t())}(this,function(){"use strict";return[{locale:"th",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"ปี",relative:{0:"ปีนี้",1:"ปีหน้า","-1":"ปีที่แล้ว"},relativeTime:{future:{other:"ในอีก {0} ปี"},past:{other:"{0} ปีที่แล้ว"}}},"year-short":{displayName:"ปี",relative:{0:"ปีนี้",1:"ปีหน้า","-1":"ปีที่แล้ว"},relativeTime:{future:{other:"ใน {0} ปี"},past:{other:"{0} ปีที่แล้ว"}}},month:{displayName:"เดือน",relative:{0:"เดือนนี้",1:"เดือนหน้า","-1":"เดือนที่แล้ว"},relativeTime:{future:{other:"ในอีก {0} เดือน"},past:{other:"{0} เดือนที่ผ่านมา"}}},"month-short":{displayName:"เดือน",relative:{0:"เดือนนี้",1:"เดือนหน้า","-1":"เดือนที่แล้ว"},relativeTime:{future:{other:"ใน {0} เดือน"},past:{other:"{0} เดือนที่แล้ว"}}},day:{displayName:"วัน",relative:{0:"วันนี้",1:"พรุ่งนี้",2:"มะรืนนี้","-2":"เมื่อวานซืน","-1":"เมื่อวาน"},relativeTime:{future:{other:"ในอีก {0} วัน"},past:{other:"{0} วันที่ผ่านมา"}}},"day-short":{displayName:"วัน",relative:{0:"วันนี้",1:"พรุ่งนี้",2:"มะรืนนี้","-2":"เมื่อวานซืน","-1":"เมื่อวาน"},relativeTime:{future:{other:"ใน {0} วัน"},past:{other:"{0} วันที่แล้ว"}}},hour:{displayName:"ชั่วโมง",relative:{0:"ชั่วโมงนี้"},relativeTime:{future:{other:"ในอีก {0} ชั่วโมง"},past:{other:"{0} ชั่วโมงที่ผ่านมา"}}},"hour-short":{displayName:"ชม.",relative:{0:"ชั่วโมงนี้"},relativeTime:{future:{other:"ใน {0} ชม."},past:{other:"{0} ชม. ที่แล้ว"}}},minute:{displayName:"นาที",relative:{0:"นาทีนี้"},relativeTime:{future:{other:"ในอีก {0} นาที"},past:{other:"{0} นาทีที่ผ่านมา"}}},"minute-short":{displayName:"น.",relative:{0:"นาทีนี้"},relativeTime:{future:{other:"ใน {0} นาที"},past:{other:"{0} นาทีที่แล้ว"}}},second:{displayName:"วินาที",relative:{0:"ขณะนี้"},relativeTime:{future:{other:"ในอีก {0} วินาที"},past:{other:"{0} วินาทีที่ผ่านมา"}}},"second-short":{displayName:"วิ",relative:{0:"ขณะนี้"},relativeTime:{future:{other:"ใน {0} วินาที"},past:{other:"{0} วินาทีที่แล้ว"}}}}}]});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(257);

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PermissionProvider = (_temp = _class = function (_React$PureComponent) {
  (0, _inherits3.default)(PermissionProvider, _React$PureComponent);

  function PermissionProvider(props, context) {
    (0, _classCallCheck3.default)(this, PermissionProvider);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PermissionProvider.__proto__ || (0, _getPrototypeOf2.default)(PermissionProvider)).call(this, props, context));

    _this.permissions = props.permissions;
    return _this;
  }

  (0, _createClass3.default)(PermissionProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var permissions = this.permissions;


      return {
        viewable: function viewable(key) {
          return permissions[key.toLowerCase()] !== false;
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.Children.only(this.props.children);
    }
  }]);
  return PermissionProvider;
}(_react2.default.PureComponent), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    permissions: _react2.default.PropTypes.object
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    permissions: {}
  }
}), Object.defineProperty(_class, 'childContextTypes', {
  enumerable: true,
  writable: true,
  value: {
    viewable: _react2.default.PropTypes.func
  }
}), _temp);
exports.default = PermissionProvider;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEPLOY_AREA = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.getPermissions = getPermissions;

var _oversea = __webpack_require__(257);

var _oversea2 = _interopRequireDefault(_oversea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEPLOY_AREA = exports.DEPLOY_AREA = {
  OVERSEA: 'oversea'
};

var isOversea = undefined === DEPLOY_AREA.OVERSEA;
function getPermissions() {
  var result = {};

  if (isOversea) {
    result = (0, _extends3.default)({}, _oversea2.default);
  }

  return result;
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 海外版功能模块权限
 */

exports.default = {
  'entry.wm': true, // 外卖
  'entry.yd': true, // 预订
  'entry.hy': false, // 会员
  'entry.pd': true, // 排队
  'vip.charge': false, // 充值
  'vip.address': false, // 地址
  'order.checkout': true, // 结账
  'order.submit': false // 提交订单
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TopNavigator(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === undefined ? '返回' : _ref$text;

  if (history.length <= 2) {
    return null;
  }

  var handleBtnTouchTap = function handleBtnTouchTap() {
    history.back();
  };

  return _react2.default.createElement('button', {
    title: text,
    className: 'top-navigator',
    onTouchTap: handleBtnTouchTap
  });
}

exports.default = TopNavigator;

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(261);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TopNavigator(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === undefined ? '返回' : _ref$text;

  if (history.length <= 1) {
    return null;
  }

  var handleBtnTouchTap = function handleBtnTouchTap() {
    history.back();
  };

  return _react2.default.createElement('button', {
    title: text,
    className: 'top-navigator',
    onTouchTap: handleBtnTouchTap
  });
}

exports.default = TopNavigator;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(263);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(264);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 264 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(258);

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var toastIcon = __webpack_require__(267);

module.exports = React.createClass({
  displayName: 'Toast',
  propTypes: {
    clearErrorMsg: React.PropTypes.func.isRequired,
    errorMessage: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]).isRequired,
    tapHidden: React.PropTypes.bool,
    timeout: React.PropTypes.number,
    isShowIcon: React.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return { timeout: 1500, isShowIcon: true };
  },
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        clearErrorMsg = _props.clearErrorMsg,
        timeout = _props.timeout;

    if (timeout === -1) {
      return;
    }
    this.timeout = setTimeout(function () {
      clearErrorMsg();
    }, timeout);
  },
  componentDidMount: function componentDidMount() {
    if (this.refs && this.refs.toast) {
      this.refs.toast.focus();
    }
  },
  tapToast: function tapToast(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    var _props2 = this.props,
        tapHidden = _props2.tapHidden,
        clearErrorMsg = _props2.clearErrorMsg;


    if (tapHidden) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      clearErrorMsg();
    }
  },
  render: function render() {
    var _this = this;

    var _props3 = this.props,
        errorMessage = _props3.errorMessage,
        isShowIcon = _props3.isShowIcon;


    if ((typeof errorMessage === 'undefined' ? 'undefined' : (0, _typeof3.default)(errorMessage)) === 'object' && !React.isValidElement(errorMessage)) {
      return false;
    }

    return React.createElement(
      'div',
      { className: 'c-toast', onTouchTap: function onTouchTap(evt) {
          return _this.tapToast(evt);
        }, ref: 'toast', tabIndex: '-1' },
      React.createElement(
        'div',
        { className: 'c-toast__content' },
        isShowIcon && React.createElement('img', { src: toastIcon, style: { width: 28 }, alt: '' }),
        errorMessage
      )
    );
  }
});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/warning-white.svg";

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 269 */,
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIsMutexReducerMethod = exports.resetPurChaseBenefitReducerMethod = exports.getFinalDishesWidthPurchase = exports.getPurchaseBenefitMethodBasicInfo = exports.getActivityBenefitWithDish = exports.setNoBenefitWithPurchasePrivilege = exports.removePurchaseAndDishPriviege = exports.initActivityDishesList = exports.getHasPurchaseBenefitGroup = exports.getChosenActivityDish = exports.getPurchaseBenefitInfo = exports.initBenefitRulesList = exports.initDishesRulesList = exports.purchaseCalculatorValidate = exports.purchaseCalculateDetail = exports.getPurchaseMethod = undefined;

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(75);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _dishHelper = __webpack_require__(43);

var _changePurchase = __webpack_require__(441);

var _orderHelper = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 整合满额赠送, 满额加价, 满量赠送, 满量加价
 *
 */
var getPurchaseMethod = exports.getPurchaseMethod = function getPurchaseMethod(ruleSubjectId, policySubjectId) {
  switch (ruleSubjectId) {
    case _changePurchase.RuleSubjectId.FullSales:
      {
        // 满额
        if (policySubjectId === _changePurchase.PolicySubjectId.SubjectAdd) {
          // 满额加价
          return { code: _changePurchase.PurchaseMethod.FullSalesAdd, text: '满额加价' };
        } else if (policySubjectId === _changePurchase.PolicySubjectId.SubjectSend) {
          // 满额赠送
          return { code: _changePurchase.PurchaseMethod.FullSalesSend, text: '满额赠送' };
        }
        break;
      }
    case _changePurchase.RuleSubjectId.FullVolume:
      {
        if (policySubjectId === _changePurchase.PolicySubjectId.SubjectAdd) {
          // 满量加价
          return { code: _changePurchase.PurchaseMethod.FullVolumeAdd, text: '满量加价' };
        } else if (policySubjectId === _changePurchase.PolicySubjectId.SubjectSend) {
          // 满量赠送
          return { code: _changePurchase.PurchaseMethod.FullVolumeSend, text: '满量赠送' };
        }
        break;
      }
    default:
      break;
  }
};

/**
 * purchaseCalculateDetail 加价购具体的计算规则
 * @param {优惠方案的优惠规则} benefitRule
 * @param {参与该优惠方案的菜品} calcDishes
 */
/**
 * 满额换购、满额赠送计算规则
 */
var purchaseCalculateDetail = exports.purchaseCalculateDetail = function purchaseCalculateDetail(benefitRule, calcDishes) {
  if (!benefitRule || !calcDishes.length) {
    return false;
  }

  var _benefitRule$calculat = benefitRule.calculatRules,
      logicValue = _benefitRule$calculat.logicValue,
      ruleSubjectId = _benefitRule$calculat.ruleSubjectId;

  // 满额, 不区分是赠送还是换购

  if (ruleSubjectId === _changePurchase.RuleSubjectId.FullSales) {
    var purchaseWidthDishAmount = (0, _dishHelper.getDishesMarketPrice)(calcDishes);

    if (purchaseWidthDishAmount >= logicValue) {
      return true;
    }
  }

  // 满量, 不区分是赠送还是换购
  if (ruleSubjectId === _changePurchase.RuleSubjectId.FullVolume) {
    var purchaseWidthDishCount = (0, _dishHelper.getDishesCount)(calcDishes);

    if (purchaseWidthDishCount >= logicValue) {
      return true;
    }
  }

  return false;
};

/**
 * 每个活动的计算校验规则，只针对单菜品
 * 切换菜品优惠的时候，就要校验一次每个活动的规则
 * 页面展示：校验通过，展示【去换购】，校验不通过，则不展示【去换购】
 */
var purchaseCalculatorValidate = exports.purchaseCalculatorValidate = function purchaseCalculatorValidate(serviceProps, orderedDishesProps) {
  var markUpBenefitProps = serviceProps.markUpBenefitProps;


  if (!markUpBenefitProps) {
    return [];
  }

  var dishes = orderedDishesProps.dishes;
  var dishesRules = markUpBenefitProps.dishesRules,
      benefitRules = markUpBenefitProps.benefitRules;

  var newDishesRules = [];

  // 计算校验规则，第一步，先把菜品信息组合起来
  (benefitRules || []).forEach(function (benefitRule, index) {
    var dishIds = benefitRule.dishIds; // 该活动下的所有菜品ID

    var purchaseBenefitId = benefitRule.purchaseBenefitId; // 优惠活动ID
    // 参与计算的菜品
    var calcDishes = [];

    (dishIds || []).forEach(function (dishId) {
      var dish = dishes.filter(function (dish_) {
        return dish_.brandDishId === dishId;
      })[0];

      var currentBenefit = dishesRules[dishId].find(function (dishRule) {
        if (dishRule.benefit.id === purchaseBenefitId && dishRule.checked) {
          return dishRule;
        }
      });

      // 找到了多个菜品 对应 一个活动的关系
      if (dish && !!currentBenefit) {
        calcDishes.push(dish);
      }
    });

    newDishesRules[index] = (0, _extends3.default)({}, benefitRule, { showPurchaseBtn: purchaseCalculateDetail(benefitRule, calcDishes) });
  });

  return newDishesRules;
};

/**
 * 格式化数据
 * 把数据格式为由菜品Id为键值 对应为参与活动的数组
 * exap:
 * {
 *   '544124895': ['111','333']
 *   '459566664': ['222','333']
 * }
 */
var initDishesRulesList = exports.initDishesRulesList = function initDishesRulesList(purchaseBenefitList) {
  var containDishObj = {};
  if (!purchaseBenefitList) {
    return [];
  }

  (purchaseBenefitList || []).forEach(function (purchaseBenefit) {
    var dishIds = purchaseBenefit.dishIds; // dishIds

    if (!dishIds) {
      // 关联Dish的Id
      return;
    }

    dishIds.forEach(function (dishId) {
      var brandId = purchaseBenefit.brandId,
          couponShared = purchaseBenefit.couponShared,
          description = purchaseBenefit.description,
          id = purchaseBenefit.id,
          name = purchaseBenefit.name,
          planState = purchaseBenefit.planState,
          planType = purchaseBenefit.planType;
      var _purchaseBenefit$mark = purchaseBenefit.marketRuleDtos[0],
          ruleSubjectId = _purchaseBenefit$mark.ruleSubjectId,
          policySubjectId = _purchaseBenefit$mark.policySubjectId;

      var otherBenefit = {
        brandId: brandId,
        couponShared: couponShared,
        description: description,
        id: id,
        name: name,
        planState: planState,
        planType: planType,
        purchaseBenefitMethod: getPurchaseMethod(ruleSubjectId, policySubjectId)
      };

      if (!containDishObj[dishId]) {
        containDishObj[dishId] = [{
          benefit: otherBenefit,
          checked: true
        }];
      } else {
        containDishObj[dishId].push({
          benefit: otherBenefit,
          checked: false
        });
      }
    });
  });

  return containDishObj;
};

/**
 * 格式化数据
 * 把数据格式为由活动Id为键值 对应为菜品数组
 * exap:
 * {
 *   '544124895': ['111','333']
 *   '459566664': ['222','333']
 * }
 */
var initBenefitRulesList = exports.initBenefitRulesList = function initBenefitRulesList(purchaseBenefitList, orderedDishesProps) {
  var containBenefitObj = {};
  var containBenefitList = [];

  if (!purchaseBenefitList) {
    return [];
  }

  purchaseBenefitList.forEach(function (purchaseBenefit) {
    var purchaseBenefitId = purchaseBenefit.id;

    if (!containBenefitObj[purchaseBenefitId]) {
      containBenefitObj[purchaseBenefitId] = true;
      var _purchaseBenefit$mark2 = purchaseBenefit.marketRuleDtos[0],
          ruleSubjectId = _purchaseBenefit$mark2.ruleSubjectId,
          ruleLogic = _purchaseBenefit$mark2.ruleLogic,
          logicValue = _purchaseBenefit$mark2.logicValue,
          policyDetailId = _purchaseBenefit$mark2.policyDetailId,
          policyValue1 = _purchaseBenefit$mark2.policyValue1,
          policyValue2 = _purchaseBenefit$mark2.policyValue2,
          policySubjectId = _purchaseBenefit$mark2.policySubjectId;

      var purchaseBenefitMethod = getPurchaseMethod(ruleSubjectId, policySubjectId);

      containBenefitList.push({
        purchaseBenefitId: purchaseBenefitId,
        name: purchaseBenefit.name,
        dishIds: purchaseBenefit.dishIds,
        calculatRules: {
          ruleLogic: ruleLogic,
          logicValue: logicValue,
          policyDetailId: policyDetailId,
          policyValue1: policyValue1,
          policyValue2: policyValue2,
          ruleSubjectId: ruleSubjectId,
          policySubjectId: policySubjectId,
          purchaseBenefitMethod: purchaseBenefitMethod
        },
        couponShared: purchaseBenefit.couponShared
      });
    }
  });

  purchaseCalculatorValidate(containBenefitList, orderedDishesProps);
  return containBenefitList;
};

/**
 * 根据菜品brandDishId获取选中的加价购或者满减的方案
 */
var getPurchaseBenefitInfo = exports.getPurchaseBenefitInfo = function getPurchaseBenefitInfo() {
  var dishesRules = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brandDishId = arguments[1];

  if (!brandDishId) {
    return;
  }

  var purchaseBenefitList = dishesRules[brandDishId] || [];
  var hasPurchaseBenefitList = !!purchaseBenefitList.length;
  var chosenPurchaseBenefit = purchaseBenefitList && purchaseBenefitList.find(function (dishRule) {
    return dishRule.checked;
  });
  var hasChosenPurchaseBenefit = !!chosenPurchaseBenefit;

  return {
    hasPurchaseBenefitList: hasPurchaseBenefitList,
    purchaseBenefitList: purchaseBenefitList,
    chosenPurchaseBenefit: chosenPurchaseBenefit,
    hasChosenPurchaseBenefit: hasChosenPurchaseBenefit
  };
};

/**
 * 根据 加价购方案ID purchaseBenefitId 判断 activityDishes 是否存在被选中的 order/count 值
 */
var getChosenActivityDish = exports.getChosenActivityDish = function getChosenActivityDish(activityDishes, purchaseBenefitId, mode) {
  return !!activityDishes[purchaseBenefitId].find(function (activityDish) {
    return activityDish[mode];
  });
};

/**
 * 查询所有菜品中是否存在加价购的分组(动态)
 */
var getHasPurchaseBenefitGroup = exports.getHasPurchaseBenefitGroup = function getHasPurchaseBenefitGroup(dishes) {
  return !!dishes.find(function (dish) {
    return dish.purchaseBenefit;
  });
};

/**
 * 格式化换购菜品的数据格式
 * @param {接口方案数据} purchaseBenefitList
 */
var initActivityDishesList = exports.initActivityDishesList = function initActivityDishesList(purchaseBenefitList) {
  var activityDishList = {};

  if (!purchaseBenefitList) {
    return [];
  }

  purchaseBenefitList.forEach(function (item, index) {
    var policyDishes = item.policyDishes;

    activityDishList[item.id] = [];
    var param = {
      count: 0,
      order: 0,
      activityBenefit: 0,
      activityBenefitNum: 0,
      marketPriceTotal: 0,
      realPriceTotal: 0
    };

    policyDishes.forEach(function (temp) {
      var _activityDishList$ite;

      var dishType = temp.dishType,
          midDishes = temp.midDishes;

      // 非中类

      if (dishType === _changePurchase.MarkUpActivityDishType.SINGLEDISH) {
        activityDishList[item.id].push((0, _extends3.default)({}, temp, param, { marketPrice: temp.price, planId: item.id }));

        return;
      }

      // 中类下的菜品, 要考虑到展示中类名称
      var midDishList = midDishes.map(function (itemx) {
        return (0, _extends3.default)({}, itemx, param, { marketPrice: itemx.price, planId: item.id });
      });
      (_activityDishList$ite = activityDishList[item.id]).push.apply(_activityDishList$ite, (0, _toConsumableArray3.default)(midDishList));
    });
  });

  return activityDishList;
};

/**
 * 本阶段将加价购与其他优惠都互斥,还是启用之前单品优惠的 isMutex 字段
 */
var removePurchaseAndDishPriviege = exports.removePurchaseAndDishPriviege = function removePurchaseAndDishPriviege(serviceProps, dishes) {
  var isMutex = serviceProps.isMutex;
  var _serviceProps$markUpB = serviceProps.markUpBenefitProps,
      activityDishes = _serviceProps$markUpB.activityDishes,
      dishesRules = _serviceProps$markUpB.dishesRules;

  if (!activityDishes) {
    return isMutex;
  }

  var purchaseStatus = isMutex;
  var keys = (0, _keys2.default)(activityDishes);

  // 如果所有菜品选了加价购但是没有加菜，此时应该将isMutex设置为true
  if (!isMutex) {
    var ruleKeys = (0, _keys2.default)(dishesRules);
    var changes = [];
    ruleKeys.forEach(function (key) {
      var checked = dishesRules[key].filter(function (item) {
        return item.checked;
      }) || [];
      dishes.forEach(function (dish) {
        var brandDishId = dish.brandDishId;


        var benefit = [];
        if (typeof dish.order === 'number') {
          benefit = dish.benefitOptions;
        } else {
          benefit = dish.order[dish.order.length - 1].benefitOptions;
        }

        var checkedBenefit = [];

        if (benefit && benefit.length) {
          checkedBenefit = benefit.filter(function (ben) {
            return ben.isChecked;
          });
        }

        if (checked.length && brandDishId === key) {
          changes.push(brandDishId);
        }
      });
    });

    if (changes.length === dishes.length) {
      purchaseStatus = true;
    }
  }

  // 在确认换购菜品加了菜的时候，设置的
  keys.forEach(function (key) {
    var checkedBenefit = activityDishes[key].find(function (activityDish) {
      return activityDish.order;
    });

    if (checkedBenefit) {
      purchaseStatus = false;
    }
  });

  return purchaseStatus;
};

/**
 * setNoBenefitWithPurchasePrivilege 碰到与优惠券互斥的时候，设置选项为不选优惠
 * @param {obj} dish
 * @param {obj} serviceProps
 */
var setNoBenefitWithPurchasePrivilege = exports.setNoBenefitWithPurchasePrivilege = function setNoBenefitWithPurchasePrivilege(dish, serviceProps, callBack) {
  var dishesRules = serviceProps.markUpBenefitProps.dishesRules;


  if (!dishesRules || !dish) {
    return;
  }

  var purchaseStatus = true;

  if (!dishesRules[dish.brandDishId]) {
    return true;
  }

  var purchaseBenefit = dishesRules[dish.brandDishId].filter(function (item) {
    return item.checked;
  })[0];

  if (purchaseBenefit && purchaseBenefit.checked) {
    purchaseStatus = false;
  }

  return purchaseStatus;
};

/**
 * decentralizationCalculation 分权计算
 * @param {[]} dishes
 * @param {obj} calculateRules
 */
var decentralizationCalculation = function decentralizationCalculation(dishes, calculatRules) {
  if (!calculatRules) {
    return dishes;
  }

  var policyValue1 = calculatRules.policyValue1,
      policyDetailId = calculatRules.policyDetailId;
  var ChangePurchase = _changePurchase.MarkUpPolicyDetail.ChangePurchase,
      SendPurchase = _changePurchase.MarkUpPolicyDetail.SendPurchase;

  var newDishes = [];

  // 优惠计算，只管换购还是赠送，不用管是满额还是满量 赠送商品
  if (policyDetailId === SendPurchase) {
    newDishes = dishes.map(function (dish) {
      if (!dish.order) {
        return (0, _extends3.default)({}, dish, {
          activityBenefitNum: 0,
          activityBenefit: 0,
          marketPriceTotal: 0,
          realPriceTotal: 0
        });
      }

      return (0, _extends3.default)({}, dish, {
        activityBenefitNum: dish.order,
        activityBenefit: dish.order * dish.marketPrice,
        marketPriceTotal: dish.order * dish.marketPrice,
        realPriceTotal: 0
      });
    });
  }

  // 换购商品
  if (policyDetailId === ChangePurchase) {
    var benefitAmount = 0;

    dishes.forEach(function (dish) {
      benefitAmount += dish.order * dish.marketPrice;
    });

    newDishes = dishes.map(function (dish, index) {
      if (!dish.order) {
        return (0, _extends3.default)({}, dish, {
          activityBenefitNum: 0,
          activityBenefit: 0,
          marketPriceTotal: 0,
          realPriceTotal: 0
        });
      }

      var marketPriceWidthOrder = dish.order * dish.marketPrice; // 应付价
      var realPrice = marketPriceWidthOrder / benefitAmount * policyValue1; // 实际价

      // 换购商品的marketPrice 为 0
      if (benefitAmount === 0) {
        realPrice = !marketPriceWidthOrder && !index ? policyValue1 : 0;
      }

      var comparePrice = marketPriceWidthOrder - realPrice;

      return (0, _extends3.default)({}, dish, {
        activityBenefitNum: dish.order,
        marketPriceTotal: marketPriceWidthOrder,
        realPriceTotal: Number(realPrice),
        activityBenefit: Math.max(comparePrice, 0)
      });
    });
  }

  return newDishes;
};

var getActivityBenefitWithDish = exports.getActivityBenefitWithDish = function getActivityBenefitWithDish(serviceProps) {
  var _serviceProps$markUpB2 = serviceProps.markUpBenefitProps,
      dishesRules = _serviceProps$markUpB2.dishesRules,
      benefitRules = _serviceProps$markUpB2.benefitRules,
      activityDishes = _serviceProps$markUpB2.activityDishes;


  if (!dishesRules || !(benefitRules || []).length || !activityDishes) {
    return {};
  }

  // 重新整理 activityDishes ,需要赋值 activityBenefitNum，activityBenefit 方便后续计算
  var newActivityDishesState = {};

  benefitRules.forEach(function (benefit) {
    var calculatRules = benefit.calculatRules;


    if (activityDishes[benefit.purchaseBenefitId]) {
      var dishes = activityDishes[benefit.purchaseBenefitId];

      // dishes 参与分权计算
      if (dishes.length) {
        var currentPrivDish = decentralizationCalculation(dishes, calculatRules);
        newActivityDishesState[benefit.purchaseBenefitId] = currentPrivDish;
      }
    }
  });

  return newActivityDishesState;
};

/**
 * 根据 purchaseBenefitMethod 定制展示信息以及商品分数的限制
 */
var getPurchaseBenefitMethodBasicInfo = exports.getPurchaseBenefitMethodBasicInfo = function getPurchaseBenefitMethodBasicInfo(calculatRules) {
  var logicValue = calculatRules.logicValue,
      policyValue1 = calculatRules.policyValue1,
      policyValue2 = calculatRules.policyValue2,
      purchaseBenefitMethod = calculatRules.purchaseBenefitMethod;

  var chosenpurchaseWord = '';
  var badgeName = '';
  var purchaseLimit = 0;

  switch (purchaseBenefitMethod.code) {
    case _changePurchase.PurchaseMethod.FullSalesSend:
      {
        // 满额赠送
        badgeName = '满赠';
        chosenpurchaseWord = '\u6EE1' + logicValue + '\u5143\u53EF\u6362\u8D2D';
        purchaseLimit = policyValue1;
        break;
      }

    case _changePurchase.PurchaseMethod.FullSalesAdd:
      {
        // 满额加价
        badgeName = '加价购';
        chosenpurchaseWord = '\u6EE1' + logicValue + '\u5143\u518D\u52A0' + policyValue1 + '\u5143\u53EF\u6362\u8D2D';
        purchaseLimit = policyValue2;
        break;
      }

    case _changePurchase.PurchaseMethod.FullVolumeSend:
      {
        // 满量赠送
        badgeName = '满赠';
        chosenpurchaseWord = '\u6EE1' + logicValue + '\u4EFD\u53EF\u6362\u8D2D';
        purchaseLimit = policyValue1;
        break;
      }

    case _changePurchase.PurchaseMethod.FullVolumeAdd:
      {
        // 满量加价
        badgeName = '加价购';
        chosenpurchaseWord = '\u6EE1' + logicValue + '\u4EFD\u518D\u52A0' + policyValue1 + '\u5143\u53EF\u6362\u8D2D';
        purchaseLimit = policyValue2;
        break;
      }

    default:
      break;
  }

  return { chosenpurchaseWord: chosenpurchaseWord, purchaseLimit: purchaseLimit, badgeName: badgeName };
};

var getFinalDishesWidthPurchase = exports.getFinalDishesWidthPurchase = function getFinalDishesWidthPurchase(markUpBenefitProps) {
  var activityDishes = markUpBenefitProps.activityDishes;


  if (!activityDishes) {
    return { finalDishes: [], purchaseRealTotal: 0, purchaseMarketTotal: 0 };
  }

  var compareBenefit = 0;
  var finalDishes = [];
  for (var key in activityDishes) {
    var marketTotal = 0;
    var realTotal = 0;
    activityDishes[key].forEach(function (dish) {
      if (dish.order > 0) {
        marketTotal += dish.marketPriceTotal;
        realTotal += dish.realPriceTotal;
        finalDishes.push(dish);
      }
    });

    if (realTotal < marketTotal) {
      compareBenefit = marketTotal - realTotal;
    }
  }

  var purchaseRealTotal = 0;
  var purchaseMarketTotal = 0;

  finalDishes.forEach(function (dish) {
    purchaseRealTotal += dish.realPriceTotal;
    purchaseMarketTotal += dish.marketPrice * dish.order;
  });

  return { finalDishes: finalDishes, purchaseRealTotal: purchaseRealTotal, purchaseMarketTotal: purchaseMarketTotal, compareBenefit: compareBenefit };
};

/**
 * resetPurChaseBenefitReducerMethod
 */
var resetPurChaseBenefitReducerMethod = exports.resetPurChaseBenefitReducerMethod = function resetPurChaseBenefitReducerMethod(nextState, benefitRules, noShowPurchaseBtn) {
  var newNextState = nextState;
  benefitRules.forEach(function (item) {
    if (noShowPurchaseBtn && item.showPurchaseBtn) {
      // 是否需要排除item.showPurchaseBtn为true的情况
      return;
    }

    newNextState = newNextState.updateIn(['serviceProps', 'markUpBenefitProps', 'activityDishes', item.purchaseBenefitId], function (dishes) {
      return dishes.flatMap(function (dish) {
        return dish.set('count', 0).set('order', 0).set('activityBenefitNum', 0).set('activityBenefit', 0).set('marketPriceTotal', 0).set('realPriceTotal', 0);
      });
    });
  });

  return newNextState;
};

/**
 * setIsMutexReducerMethod
 */
var setIsMutexReducerMethod = exports.setIsMutexReducerMethod = function setIsMutexReducerMethod(nextState, coverParams) {
  var newNextState = nextState.setIn(['serviceProps', 'isMutex'], (0, _orderHelper.getPurchaseAndBenefitShared)((0, _extends3.default)({
    benefitProps: nextState.serviceProps.activityBenefitProps,
    orderedDishes: nextState.orderedDishesProps.dishes,
    needAddBenefit: false,
    serviceProps: nextState.serviceProps
  }, coverParams)));

  return newNextState;
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _commonHelper = __webpack_require__(3);

__webpack_require__(419);

var React = __webpack_require__(2);


module.exports = React.createClass({
  displayName: 'Dialog',
  propTypes: {
    theme: React.PropTypes.string,
    className: React.PropTypes.string,
    zIndexTop: React.PropTypes.bool,
    children: React.PropTypes.any,
    buttons: React.PropTypes.array,
    onClose: React.PropTypes.func,
    noPreventScrollClassNameList: React.PropTypes.array,
    needPreventScrollDefault: React.PropTypes.bool,
    closable: React.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      theme: 'default',
      closable: true
    };
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        noPreventScrollClassNameList = _props.noPreventScrollClassNameList,
        needPreventScrollDefault = _props.needPreventScrollDefault;

    this.refs.modal.focus();

    if (!needPreventScrollDefault) {
      return;
    }
    this.preventScrollIntoScroll = (0, _commonHelper.preventScrollIntoScroll)('.modal', noPreventScrollClassNameList);
    this.preventScrollIntoScroll.addMethod();
  },
  componentWillUnmount: function componentWillUnmount() {
    var needPreventScrollDefault = this.props.needPreventScrollDefault;


    if (!needPreventScrollDefault) {
      return;
    }
    this.preventScrollIntoScroll.cancelMethod();
  },
  onClose: function onClose(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }

    if (this.props.onClose) {
      this.props.onClose();
    }
  },
  render: function render() {
    var _props2 = this.props,
        title = _props2.title,
        buttons = _props2.buttons,
        theme = _props2.theme,
        className = _props2.className,
        closable = _props2.closable,
        zIndexTop = _props2.zIndexTop;

    var buttonElems = (buttons || []).map(function (button, index) {
      var btnCls = button.className || 'dialog-footer-btn-default';
      return React.createElement(
        'button',
        {
          key: index,
          className: btnCls,
          onTouchTap: button.onClick
        },
        button.text
      );
    });

    var style = {
      // maxHeight: window.innerHeight - 44 - (buttonElems.length ? 49 : 0) - 40,
      maxHeight: 400
    };
    return React.createElement(
      'div',
      { className: 'modal ' + (zIndexTop && 'modal-index-top'), ref: 'modal', tabIndex: '-1' },
      React.createElement('div', { className: 'mask', onTouchTap: this.onClose }),
      React.createElement(
        'div',
        { className: 'dialog ' + theme + ' ' + (className || '') },
        React.createElement(
          'div',
          { className: 'dialog-header' },
          React.createElement(
            'p',
            { className: 'dialog-title' },
            title
          ),
          closable && React.createElement('button', { className: 'btn dialog-btn-close', onTouchTap: this.onClose })
        ),
        React.createElement(
          'div',
          { className: 'dialog-body', style: style },
          this.props.children
        ),
        React.createElement(
          'div',
          { className: 'dialog-footer' },
          buttonElems
        )
      )
    );
  }
});

/***/ }),
/* 272 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

exports.createStoragePairsMgr = createStoragePairsMgr;
exports.createSessionStoragePairsMgr = createSessionStoragePairsMgr;
exports.createLocalStoragePairsMgr = createLocalStoragePairsMgr;
exports.createShareCouponMgr = createShareCouponMgr;
exports.createReceivedCouponMgr = createReceivedCouponMgr;
exports.createLastOrderedDishesMgr = createLastOrderedDishesMgr;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * create storage key-value pairs manager object
 */
function createStoragePairsMgr(storage, _ref) {
  var key = _ref.key;

  return {
    key: key,

    clear: function clear() {
      storage.removeItem(this.key);
    },
    getOnce: function getOnce() {
      this.clear();

      return this.value;
    },
    get: function get() {
      var jsonStr = storage.getItem(this.key);
      if (!jsonStr) {
        return null;
      }

      return JSON.parse(jsonStr) || null;
    },
    set: function set(obj) {
      storage.setItem(this.key, (0, _stringify2.default)(obj));
    }
  };
}

function createSessionStoragePairsMgr(_ref2) {
  var key = _ref2.key;

  return createStoragePairsMgr(window.sessionStorage, { key: key });
}

function createLocalStoragePairsMgr(_ref3) {
  var key = _ref3.key;

  return createStoragePairsMgr(window.localStorage, { key: key });
}

/**
 * createShareCouponMgr
 */
function createShareCouponMgr() {
  return createLocalStoragePairsMgr({ key: 'shareCoupon' });
}

/**
 * createReceivedCouponMgr
 */
function createReceivedCouponMgr() {
  return createLocalStoragePairsMgr({ key: 'receivedCoupon' });
}

function createLastOrderedDishesMgr() {
  var mgr = createLocalStoragePairsMgr({ key: 'lastOrderedDishes' });

  return {
    get: function get(_ref4) {
      var shopId = _ref4.shopId,
          type = _ref4.type;

      var value = mgr.get();
      if (!value) {
        return null;
      }

      var dishes = value.dishes,
          storedShopId = value.shopId,
          storedType = value.type,
          expires = value.expires;

      if (shopId === storedShopId && type === storedType && expires >= Date.now() && dishes && dishes.length) {
        return dishes;
      }

      mgr.clear();
      return null;
    },
    set: function set(lastOrderedDishes, _ref5) {
      var type = _ref5.type,
          shopId = _ref5.shopId,
          _ref5$shopName = _ref5.shopName,
          shopName = _ref5$shopName === undefined ? '' : _ref5$shopName;

      mgr.set({
        dishes: lastOrderedDishes,
        shopId: shopId,
        type: type,
        shopName: shopName,
        expires: Date.now() + 24 * 60 * 60 * 1000
      });
    },
    clear: function clear() {
      mgr.clear();
    }
  };
}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  confirm: {
    id: 'button.confirm',
    defaultMessage: '确认'
  },
  sure: {
    id: 'button.sure',
    defaultMessage: '确定'
  },
  cancel: {
    id: 'button.cancel',
    defaultMessage: '取消'
  },
  submit: {
    id: 'button.submit',
    defaultMessage: '提交'
  },
  iknown: {
    id: 'button.iknown',
    defaultMessage: '我知道了'
  },
  receiveWelfare: {
    id: 'button.receiveWelfare',
    defaultMessage: '领取福利'
  },
  known: {
    id: 'button.known',
    defaultMessage: '知道了'
  },
  close: {
    id: 'button.close',
    defaultMessage: '关闭'
  },
  finish: {
    id: 'button.finish',
    defaultMessage: '完成'
  },
  buyNow: {
    id: 'button.buyNow',
    defaultMessage: '去购买'
  }
});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _const = __webpack_require__(14);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _commonHelper = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const shopId = getUrlParam('shopId');

/* eslint-disable no-throw-literal */
var ccbAppHelper = {
  /**
   * @description 清除cookie
   * 进入建行环境 每次都重新登录
   */
  clearAllCookie: function clearAllCookie() {
    var date = new Date();
    date.setTime(date.getTime() - 10000);
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--;) {
        document.cookie = keys[i] + '=0; expire=' + date.toGMTString() + '; path=/';
      }
    }
  },
  isCcbEvn: function isCcbEvn() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var _path = path;
    if (!_path) {
      _path = location.search || '';
    }
    var res = _path.match(/accessFrom=(.*?)(&|$)/);

    var accessFrom = window.sessionStorage ? window.sessionStorage.getItem('ACCESS_FROM') : ''; // 建行登录标志
    if (res && Array.isArray(res) && res[1] === _const.ACCESS_FROM.CCB_APP || accessFrom === _const.ACCESS_FROM.CCB_APP) {
      window.sessionStorage.setItem('ACCESS_FROM', _const.ACCESS_FROM.CCB_APP);
      return !0;
    }
    return !1;
  },

  /**
   * @param str 形如a=1&b=3的字符串
   * @param param 需要解构的字段
   * 获取a=1&b=3中的某个字段
   */
  getParam: function getParam() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var param = arguments[1];

    // MERCHANTID=105451058149876&POSID=041638808&BRANCHID=370617001&ORDERID=CPRG31067679&PAYMENT=145.43
    // &CURCODE=01&TXCODE=520100&REMARK1=&REMARK2=&TYPE=1&PUB=22b39f606e7c7f265572d605020111&GATEWAY=0
    // &CLIENTIP=&REGINFO=&PROINFO=%u5c0f%u6797%u6d4b%u8bd5%2d%u6d88%u8d39&REFERER=&MAC=315d9e7ccfa02db98015c8c051980ca2
    var reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i');
    var r = str.match(reg);
    if (!r) return null;
    return r[2];
  },

  /**
   * 解密密文
   */
  decodeCipherText: function decodeCipherText() {
    var ccbParamSJ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return _fetchHelper2.default.get(_config2.default.decodeCipherTextForCCB, {
      ccbParamSJ: ccbParamSJ
    }).then(function (data) {
      if (data === null || data === '') {
        throw { code: '5001', msg: '解密后内容为空' };
      }
      try {
        // return JSON.parse(result || '');
        var userId = ccbAppHelper.getParam(data, 'userid') || '';
        var mobile = ccbAppHelper.getParam(data, 'mobile') || '';
        return {
          userId: userId,
          mobile: mobile
        };
      } catch (ex) {
        throw { code: '5002', msg: '解密后内容结构异常' };
      }
    });
  },

  /**
   * 获取建行App登录的人员信息
   */
  getUserInfo: function getUserInfo() {
    var ccbParamSJ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var param = decodeURIComponent(ccbParamSJ);
    return ccbAppHelper.decodeCipherText(param).then(function (data) {
      if (!data || !data.userId || !data.mobile) {
        throw { code: '5003', msg: '解密后内容信息不正确' };
      }
      return data;
    });
  },
  login: function login(info) {
    var shopId = info.shopId,
        ccbParamSJ = info.ccbParamSJ;

    return _fetchHelper2.default.get(_config2.default.loginInCCBAppAPI, { shopId: shopId, ccbParamSJ: decodeURIComponent(ccbParamSJ), nationTelCode: '86', fromBrand: false }).then(function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _data$ccbParam = data.ccbParam,
          ccbParam = _data$ccbParam === undefined ? '' : _data$ccbParam;

      if (ccbParam === null || ccbParam === '') {
        throw { code: '5001', msg: '登录后返回参数为空' };
      }
      try {
        var userId = ccbAppHelper.getParam(ccbParam, 'userid') || '';
        var mobile = ccbAppHelper.getParam(ccbParam, 'mobile') || '';
        return {
          userId: userId,
          mobile: mobile
        };
      } catch (ex) {
        throw { code: '5002', msg: '解密后内容结构异常' };
      }
    }).catch(function (ex) {
      throw ex;
    });
  },


  /**
   * 判断用户是否登录
   */
  getUserIndividual: function getUserIndividual(info) {
    var storgeCcbParamSJ = window.sessionStorage && window.sessionStorage.getItem(_const.CCB_INFO.CCB_PARAM_SJ);
    if (storgeCcbParamSJ) return _promise2.default.resolve();
    var shopId = info.shopId,
        ccbParamSJ = info.ccbParamSJ,
        errMsg = info.errMsg;

    if (!ccbParamSJ) {
      throw errMsg;
    }
    return ccbAppHelper.login({ shopId: shopId, ccbParamSJ: ccbParamSJ }).then(function (userInfo) {
      if (window.localStorage) {
        localStorage.setItem(_const.CCB_INFO.CCB_USER_INFO, (0, _stringify2.default)(userInfo));
        sessionStorage.setItem(_const.CCB_INFO.CCB_PARAM_SJ, ccbParamSJ);
      }
      return true;
    }).catch(function (ex) {
      throw ex;
    });
  },


  /**
   * 根据跳转接口报文头CloudMercWebView-User-Agent判断当前是ios还是Android
   */
  checkIosOrAndroid: function checkIosOrAndroid() {
    var ccbSys = localStorage.getItem('CCB_SYS'); // 当前系统 安卓/ios
    if (ccbSys) return ccbSys;
    var CCB_HEADER = _const.CCB_INFO.CCB_HEADER,
        CCB_HEADER_IOS = _const.CCB_INFO.CCB_HEADER_IOS,
        CCB_HEADER_ANDROID = _const.CCB_INFO.CCB_HEADER_ANDROID;

    var CloudMercWebView = (0, _commonHelper.getCookie)(CCB_HEADER) && (0, _commonHelper.getCookie)(CCB_HEADER).toLowerCase();
    ccbAppHelper.showEle('==getCookie CloudMercWebView: ' + CloudMercWebView + '--');
    if (!CloudMercWebView) {
      ccbAppHelper.showEle('==无法获取cookie CloudMercWebView-User-Agent--');
      return CCB_HEADER_IOS;
    }
    if (CloudMercWebView.indexOf(CCB_HEADER_IOS) > -1) {
      localStorage.setItem('CCB_SYS', CCB_HEADER_IOS);
      ccbAppHelper.showEle('==CCB_SYS: ' + CCB_HEADER_IOS + '--');
      return CCB_HEADER_IOS;
    }
    if (CloudMercWebView.indexOf(CCB_HEADER_ANDROID) > -1) {
      localStorage.setItem('CCB_SYS', CCB_HEADER_ANDROID);
      ccbAppHelper.showEle('==CCB_SYS: ' + CCB_HEADER_ANDROID + '--');
      return CCB_HEADER_ANDROID;
    }
  },
  showEle: function showEle(msg) {
    // 使用 ccbAppHelper.showEle('xxxx');
    // 建行环境不好调试 解除以下注释可将所有错误打印在支付页

    // let $showErr = document.getElementById('showErr');
    // if (!$showErr) {
    //   const ele = document.createElement('div');
    //   ele.id = 'showErr';
    //   ele.style.position = 'absolute';
    //   ele.style.left = '0';
    //   ele.style.top = '100px';
    //   ele.style.width = '100%';
    //   ele.style.wordBreak = 'break-word';
    //   $showErr = ele;

    //   document.body.appendChild($showErr);
    // }
    // let e = document.createElement('p');
    // e.innerHTML = msg;
    // $showErr.appendChild(e);
    // e = null;
  },


  /**
   * 支付字符串截取重组操作
   * @param str 为pay/ccbPay.json返回的url
   */
  getPayInfoStr: function getPayInfoStr(payinfoStr) {
    // MERCHANTID=105451058149876&POSID=041638808&BRANCHID=370000000&ORDERID=CPRG31069850&PAYMENT=0.01
    // &CURCODE=01&TXCODE=520100&REMARK1=&REMARK2=YS44000010000023&TYPE=1&PUB=22b39f606e7c7f265572d605020111
    // &GATEWAY=0&CLIENTIP=&REGINFO=&PROINFO=%u5c0f%u6797%u6d4b%u8bd5%2d%u6d88%u8d39&REFERER=
    // &THIRDAPPINFO=comccbpay1234567890cloudmerchant&PAYMAP=0101000000&FRZTIME=
    if (!payinfoStr) return;
    var PAYMAP = ccbAppHelper.getParam(payinfoStr, 'PAYMAP');
    var payinfo = payinfoStr.replace(/&PAYMAP=[^&]*/, ''); // 去除PAYMAP后的字串
    if (window.localStorage) {
      var userInfoStr = localStorage.getItem(_const.CCB_INFO.CCB_USER_INFO);
      var userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
      if (userInfo) {
        payinfo = payinfo + '&PHONENO=' + userInfo.mobile + '&KIKID=' + userInfo.userId + '&PAYMAP=' + PAYMAP;
      }
    }
    return payinfo;
  },


  /**
   * 唤起支付
   * @param conf 为支付传入的参数字符串payinfo和returnUrl
   */
  ccbPayFor: function ccbPayFor() {
    var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var payinfo = conf.payinfo,
        _conf$returnUrl = conf.returnUrl,
        returnUrl = _conf$returnUrl === undefined ? '' : _conf$returnUrl;

    var payinfoStr = ccbAppHelper.getPayInfoStr(payinfo);
    if (!payinfoStr) {
      ccbAppHelper.showEle('==ccbPayFor 唤起支付 无法获取payinfo--');
      // throw { code: '5003', msg: '无法支付所需payinfo' };
      // location.href = returnUrl;
      // return;
    }
    var sys = ccbAppHelper.checkIosOrAndroid();
    ccbAppHelper.showEle('==\u5F53\u524D\u7CFB\u7EDF' + sys + ', \u91CD\u7EC4\u540E\u7684payinfoStr: ' + payinfoStr + '--');
    var remark2 = ccbAppHelper.getParam(payinfo, 'REMARK2'); // 获取支付参数REMARK2供CCBBridge.requestNative使用
    if (!remark2) {
      ccbAppHelper.showEle('==ccbPayFor--无法获取remark2--');
      // location.href = returnUrl;
      // throw { code: '5003', msg: '获取REMARK2失败' };
      // return;
    }
    ccbAppHelper.activeForH5AndCcb(remark2, returnUrl); // 支付完成后的回调
    ccbAppHelper.showEle('==支付完成回调设置成功--');

    var CCB_HEADER_IOS = _const.CCB_INFO.CCB_HEADER_IOS,
        CCB_HEADER_ANDROID = _const.CCB_INFO.CCB_HEADER_ANDROID;

    if (sys === CCB_HEADER_IOS) {
      ccbAppHelper.showEle('==应该唤起ios支付--');
      window.location = 'mbspay://direct?' + payinfoStr; // ios唤起支付
    } else if (sys === CCB_HEADER_ANDROID) {
      ccbAppHelper.showEle('==应该唤起安卓支付--');
      window.mbspay.directpay(payinfoStr); // 安卓唤起支付
    }
  },

  /**
   * 与建行APP交互 支付后的回调场景
   */
  activeForH5AndCcb: function activeForH5AndCcb() {
    var remark2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var returnUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    // 支付完成后重新回到移动门店 session被清除了 需要重新写入标识
    var accessFrom = sessionStorage.getItem('ACCESS_FROM');
    var ccbParamSJ = sessionStorage.getItem('CCB_PARAM_SJ');
    var backUrl = decodeURIComponent(returnUrl) + '&accessFrom=' + accessFrom + '&ccbParamSJ=' + ccbParamSJ;
    ccbAppHelper.showEle('==backUrl--' + backUrl);

    var callbackName = 'portalCcbPayCallback';
    var params = {
      action: 'setCache',
      params: {
        key: remark2, // 回调的key，同下单参数的remark2
        value: backUrl // 回调的url，支付成功后云商APP根据key跳转场景方url
      }
    };
    if (!window.CCBBridge) {
      ccbAppHelper.showEle('==window.CCBBridge undefined--');
      throw { code: '5003', msg: 'window.CCBBridge undefined' };
      // location.href = returnUrl;
      // return;
    }
    ccbAppHelper.showEle('==正在设置支付回调--');
    ccbAppHelper.showEle('' + backUrl);
    window[callbackName] = function (result) {
      ccbAppHelper.showEle('支付成功后回调结果：');
      ccbAppHelper.showEle(result);
    };
    window.CCBBridge.requestNative((0, _stringify2.default)(params), callbackName);
  }
};

exports.default = ccbAppHelper;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function find(arr, cb) {
  if (Object.prototype.toString.call(arr) !== '[object Array]') {
    return undefined;
  }

  if (typeof cb !== 'function') {
    var keys = (0, _keys2.default)(cb);
    return arr.find(function (item) {
      return keys.every(function (key) {
        return item[key] === cb[key];
      });
    });
  }

  return arr.find(cb);
}

module.exports = find;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  actionVerifying: {
    id: 'action.Verifying',
    defaultMessage: '验证中...'
  },
  actionverifyFailed: {
    id: 'action.verifyFailed',
    defaultMessage: '手机验证失败'
  },
  actionrequestFailed: {
    id: 'action.requestFailed',
    defaultMessage: '请求数据失败'
  },
  actioncannotSendVerifyCode: {
    id: 'action.cannotSendVerifyCode',
    defaultMessage: '不能发送验证码：'
  },
  actionsubmitOrder: {
    id: 'action.submitOrder',
    defaultMessage: '提交订单中...'
  },
  actionconfirmOrderFailed: {
    id: 'action.confirmOrderFailed',
    defaultMessage: '确认订单失败！！'
  },
  actiongetBandInfoFailed: {
    id: 'action.getBandInfoFailed',
    defaultMessage: '获取品牌门店信息失败...'
  },
  actiongetBaseInfoFailed: {
    id: 'action.getBaseInfoFailed',
    defaultMessage: '获取基本信息失败...'
  },
  actionsendVerityCodeFailed: {
    id: 'action.sendVerityCodeFailed',
    defaultMessage: '验证码发送失败'
  },
  actionsendVerifyCodeSuccess: {
    id: 'action.sendVerifyCodeSuccess',
    defaultMessage: '验证码发送成功注意查收'
  },
  actionLoading: {
    id: 'action.Loading',
    defaultMessage: '加载中...'
  },
  actioncannotFindShopId: {
    id: 'action.cannotFindShopId',
    defaultMessage: '找不到门店号'
  },
  actiongetPersonalInfoFailed: {
    id: 'action.getPersonalInfoFailed',
    defaultMessage: '获取个人基本信息失败'
  },
  actionbindPNFailed: {
    id: 'action.bindPNFailed',
    defaultMessage: '绑定手机失败'
  },
  actionbindWXFailed: {
    id: 'action.bindWXFailed',
    defaultMessage: '绑定微信失败'
  },
  actionbindAlipayFailed: {
    id: 'action.bindAlipayFailed',
    defaultMessage: '绑定支付宝失败'
  },
  actionactivateVipFailed: {
    id: 'action.activateVipFailed',
    defaultMessage: '激活会员卡失败'
  },
  actioninfoGetFailed: {
    id: 'action.infoGetFailed',
    defaultMessage: '信息获取失败'
  },
  actiongradeFailed: {
    id: 'action.gradeFailed',
    defaultMessage: '评分失败'
  },
  actionchangeUrlFailed: {
    id: 'action.changeUrlFailed',
    defaultMessage: '转化url失败'
  },
  actiongetTableInfoFailed: {
    id: 'action.getTableInfoFailed',
    defaultMessage: '获取桌台信息失败'
  },
  actiongetUseableTableFailed: {
    id: 'action.getUseableTableFailed',
    defaultMessage: '获取可用桌台信息失败'
  },
  actiongetInterfaceFailed: {
    id: 'action.getInterfaceFailed',
    defaultMessage: '获取接口失败'
  },
  actionOrderCenterFailed: {
    id: 'action.OrderCenterFailed',
    defaultMessage: '订单中心业务开关接口失败'
  },
  actioncannotFindCookerId: {
    id: 'action.cannotFindCookerId',
    defaultMessage: '找不到厨师ID'
  },
  actionsaveAddressFailed: {
    id: 'action.saveAddressFailed',
    defaultMessage: '保存收货地址失败'
  },
  actiondeleteAddressFailed: {
    id: 'action.deleteAddressFailed',
    defaultMessage: '删除收货地址失败'
  },
  actioncannotBindCard: {
    id: 'action.cannotBindCard',
    defaultMessage: '无法绑定该卡，请检查您输入的卡号和密码。如遇问题，请联系海底捞顾客关怀中心4008107107'
  }
});

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);
var isAliBrowser = __webpack_require__(3).isAlipayBrowser();
var loadUrl = __webpack_require__(414);
__webpack_require__(415);

module.exports = React.createClass({
  displayName: 'Loading',
  propTypes: {
    word: React.PropTypes.string
  },
  getInitialState: function getInitialState() {
    return {};
  },
  componentDidMount: function componentDidMount() {},
  render: function render() {
    var word = this.props.word;

    return React.createElement(
      'div',
      { className: 'loading-hover' },
      !isAliBrowser ? React.createElement(
        'div',
        { className: 'load-div' },
        React.createElement('div', { className: 'load-table-animation' }),
        React.createElement(
          'p',
          { className: 'load-word' },
          word
        )
      ) : React.createElement(
        'div',
        { className: 'load-gif' },
        React.createElement('img', { src: loadUrl, alt: '\u83CA\u82B1\u8F6C', className: 'load-pic' }),
        React.createElement(
          'p',
          { className: 'load-word' },
          word
        )
      )
    );
  }
});

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/load.gif";

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */,
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SET_BRAND_INFO: 'SET_BRAND_INFO',
  SET_LOAD_MSG: 'SET_LOAD_MSG',
  SET_ERROR_MSG: 'SET_ERROR_MSG',
  CLEAR_ERROR_MSG: 'CLEAR_ERROR_MSG',
  SET_RECEIVED_COUPONS_INFO: 'SET_RECEIVED_COUPONS_INFO',
  SET_LANGUAGE_INFO: 'SET_LANGUAGE_INFO'
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  offlinePay: {
    id: 'offlinePay',
    defaultMessage: '线下支付'
  },
  onlinePay: {
    id: 'onlinePay',
    defaultMessage: '在线支付'
  },
  myComment: {
    id: 'comment.myComment',
    defaultMessage: '我的评价'
  },
  commentForCoupon: {
    id: 'comment.commentForCoupon',
    defaultMessage: '评价领券'
  },
  iwantComment: {
    id: 'comment.iwantComment',
    defaultMessage: '我要评价'
  },
  goodComment: {
    id: 'comment.good',
    defaultMessage: '好'
  },
  middleComment: {
    id: 'comment.middleComment',
    defaultMessage: '中'
  },
  poorComment: {
    id: 'comment.poorComment',
    defaultMessage: '差'
  },
  goodScore: {
    id: 'comment.goodScore',
    defaultMessage: '超赞'
  },
  middleScore: {
    id: 'comment.middleScore',
    defaultMessage: '一般'
  },
  poorScore: {
    id: 'comment.poorScore',
    defaultMessage: '很差'
  },
  commentPlaceholder: {
    id: 'comment.commentPlaceholder',
    defaultMessage: '客官，菜品还令你满意吗？说说它的优点和美中不足的地方'
  },
  downloadInvoice: {
    id: 'invoice.downloadInvoice',
    defaultMessage: '下载发票'
  },
  applyForInvoice: {
    id: 'invoice.applyForInvoice',
    defaultMessage: '申请开票'
  },
  invoicing: {
    id: 'invoice.invoicing',
    defaultMessage: '开票中'
  },
  refundFailAndContactMerchant: {
    id: 'refundFailAndContactMerchant',
    defaultMessage: '退款失败，请联系商户'
  },
  orderIsCanceledText: {
    id: 'orderIsCanceledText',
    defaultMessage: '订单已取消'
  },
  minutes: {
    id: 'time.minutes',
    defaultMessage: '分'
  },
  seconds: {
    id: 'time.seconds',
    defaultMessage: '秒'
  },
  autoInvalidated: {
    id: 'time.autoInvalidated',
    defaultMessage: '{time}后自动作废'
  },
  forgetIt: {
    id: 'forgetIt',
    defaultMessage: '算了'
  },
  cancelOrder: {
    id: 'cancelOrder',
    defaultMessage: '取消订单'
  },
  suerForCancelOrder: {
    id: 'suerForCancelOrder',
    defaultMessage: '确认要取消订单吗？'
  },
  coupon: {
    id: 'coupon',
    defaultMessage: '优惠劵'
  },
  itsYourCoupon: {
    id: 'itsYourCoupon',
    defaultMessage: '客官！是你的优惠劵'
  },
  clickForGetCoupon: {
    id: 'clickForGetCoupon',
    defaultMessage: '点击领取'
  },
  redEnvelopes: {
    id: 'redEnvelopes',
    defaultMessage: '发红包'
  },
  getShareRedEnvelopes: {
    id: 'getShareRedEnvelopes',
    defaultMessage: '客官！恭喜你获得分享红包'
  },
  clickForShare: {
    id: 'clickForShare',
    defaultMessage: '点击分享'
  },
  takeMealNum: {
    id: 'takeMealNum',
    defaultMessage: '取餐号'
  },
  numberPlate: {
    id: 'numberPlate',
    defaultMessage: '号牌'
  },
  takeMealCode: {
    id: 'takeMealCode',
    defaultMessage: '核销码'
  },
  takeMeal: {
    id: 'takeMeal',
    defaultMessage: '取餐'
  },
  today: {
    id: 'today',
    defaultMessage: '今天'
  },
  orderDetail: {
    id: 'orderDetail',
    defaultMessage: '订单详情'
  },
  merchantResponse: {
    id: 'merchantResponse',
    defaultMessage: '商家回复'
  },
  commentTheOrder: {
    id: 'commentTheOrder',
    defaultMessage: '请对订单进行评价'
  },
  tasteScoreText: {
    id: 'tasteScoreText',
    defaultMessage: '口味'
  },
  serviceScoreText: {
    id: 'serviceScoreText',
    defaultMessage: '服务'
  },
  environmentScoreText: {
    id: 'environmentScoreText',
    defaultMessage: '环境'
  },
  getCommentCoupon: {
    id: 'getCommentCoupon',
    defaultMessage: '恭喜获得评价领券'
  },
  getCommentCoupInfo: {
    id: 'getCommentCoupInfo',
    defaultMessage: '恭喜获得{sendCoupInfo}'
  },
  goToView: {
    id: 'goToView',
    defaultMessage: '去查看'
  },
  getCommentGifts: {
    id: 'getCommentGifts',
    defaultMessage: '恭喜获得评价专属礼包'
  },
  getSpendGifts: {
    id: 'getSpendGifts',
    defaultMessage: '恭喜您获得消费礼包'
  },
  sendYouCoupon: {
    id: 'sendYouCoupon',
    defaultMessage: '优惠券5分钟内由系统账户发放到您的账户'
  }
});

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  activateCardPlsRetry: {
    id: 'activateCard.plsRetry',
    defaultMessage: '操作失败，请重试'
  },
  activateCardSorry: {
    id: 'activateCard.Sorry',
    defaultMessage: '非常抱歉'
  },
  activateCardphoneIsBound: {
    id: 'activateCard.phoneIsBound',
    defaultMessage: '当前登陆手机号已与其他微信号绑定过'
  },
  activateCardactivateWithOtherPN: {
    id: 'activateCard.activateWithOtherPN',
    defaultMessage: '请使用对应微信号或其他手机号激活'
  },
  activateCarduseOtherPN: {
    id: 'activateCard.useOtherPN',
    defaultMessage: '使用其他手机号激活'
  },
  activateCardactivateFaild: {
    id: 'activateCard.activateFaild',
    defaultMessage: '非常抱歉，激活失败了'
  },
  activateCardReason: {
    id: 'activateCard.Reason',
    defaultMessage: '原因：'
  },
  activateCardRetry: {
    id: 'activateCard.Retry',
    defaultMessage: '重试'
  },
  activateCardCongratulations: {
    id: 'activateCard.Congratulations',
    defaultMessage: '恭喜'
  },
  activateCardwxCardActivated: {
    id: 'activateCard.wxCardActivated',
    defaultMessage: '您的微信会员卡已被成功激活'
  },
  activateCardtoCheckCard: {
    id: 'activateCard.toCheckCard',
    defaultMessage: '快去卡包中看看吧！'
  },
  activateCardusePNtoActivate: {
    id: 'activateCard.usePNtoActivate',
    defaultMessage: '您将使用以下手机号激活微信会员卡'
  },
  activateCardactivateTobindWx: {
    id: 'activateCard.activateTobindWx',
    defaultMessage: '激活后该手机号将与您的微信绑定'
  },
  activateCarduseOtherPNtoActivate: {
    id: 'activateCard.useOtherPNtoActivate',
    defaultMessage: '如果该手机号不是您的，请使用其他手机号激活'
  },
  activateCardtoActivate: {
    id: 'activateCard.toActivate',
    defaultMessage: '去激活'
  }
});

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _const = __webpack_require__(14);

var _CcbAppHelper = __webpack_require__(410);

var _CcbAppHelper2 = _interopRequireDefault(_CcbAppHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Browser = {
  海底捞备用来源五: {
    isChecked: function isChecked(hdlScence) {
      return +hdlScence === _const.HDLPublicParm.HDLBACKUPFIVE;
    },
    code: _const.OrderChildSource.HDLBACKUPFIVE
  },

  海底捞备用来源四: {
    isChecked: function isChecked(hdlScence) {
      return +hdlScence === _const.HDLPublicParm.HDLBACKUPFOUR;
    },
    code: _const.OrderChildSource.HDLBACKUPFOUR
  },

  海底捞备用来源三: {
    isChecked: function isChecked(hdlScence) {
      return +hdlScence === _const.HDLPublicParm.HDLBACKUPTHREE;
    },
    code: _const.OrderChildSource.HDLBACKUPTHREE
  },

  海底捞备用来源二: {
    isChecked: function isChecked(hdlScence) {
      return +hdlScence === _const.HDLPublicParm.HDLBACKUPTWO;
    },
    code: _const.OrderChildSource.HDLBACKUPTWO
  },

  海底捞备用来源一: {
    isChecked: function isChecked(hdlScence) {
      return +hdlScence === _const.HDLPublicParm.HDLBACKUPONE;
    },
    code: _const.OrderChildSource.HDLBACKUPONE
  },

  海底捞合作来源: {
    isChecked: function isChecked(hdlScence) {
      return +hdlScence === _const.HDLPublicParm.HDLCOOPERATION;
    },
    code: _const.OrderChildSource.HDLCOOPERATION
  },

  海底捞公众号HOT: {
    isChecked: function isChecked(hdlScence) {
      return +hdlScence === _const.HDLPublicParm.HDLHOT;
    },
    code: _const.OrderChildSource.HDLHOT
  },

  海底捞公众号WS: {
    isChecked: function isChecked(hdlScence) {
      return +hdlScence === _const.HDLPublicParm.HDLWS;
    },
    code: _const.OrderChildSource.HDLWS
  },
  微信小程序: {
    isChecked: function isChecked(userAgent) {
      return (/micromessenger/i.test(userAgent) && /miniProgram/i.test(userAgent)
      );
    },
    code: _const.OrderChildSource.WX_MINI
  },
  微信: {
    isChecked: function isChecked(userAgent) {
      return (/micromessenger/i.test(userAgent) && !/miniProgram/i.test(userAgent)
      );
    },
    code: _const.OrderChildSource.WX
  },
  支付宝小程序: {
    isChecked: function isChecked(userAgent) {
      return (/AliApp|AlipayDefined|AlipayClient/i.test(userAgent) && /miniProgram/i.test(userAgent) && userAgent.indexOf('KoubeiClient') === -1
      );
    },
    code: _const.OrderChildSource.ALIPAY_MINI
  },
  支付宝: {
    isChecked: function isChecked(userAgent) {
      return (/AliApp|AlipayDefined|AlipayClient/i.test(userAgent) && !/miniProgram/i.test(userAgent) && userAgent.indexOf('KoubeiClient') === -1
      );
    },
    code: _const.OrderChildSource.ALIPAY
  },

  口碑: {
    isChecked: function isChecked(userAgent) {
      return userAgent.indexOf('KoubeiClient') !== -1;
    },
    code: _const.OrderChildSource.KOUBEI
  },

  海底捞: {
    isChecked: function isChecked(userAgent) {
      return userAgent.indexOf('Haidilao') !== -1;
    },
    code: _const.OrderChildSource.HDL
  },

  招行: {
    isChecked: function isChecked(userAgent) {
      var str = userAgent ? (userAgent + '').toLocaleLowerCase() : '';
      return str.indexOf('cmb') !== -1 || str.indexOf('cmblife') !== -1;
      // return userAgent.indexOf('CMB') !== -1 || userAgent.indexOf('cmb') !== -1 || userAgent.indexOf('CMBLIFE') !== -1 || userAgent.indexOf('cmblife') !== -1;
    },
    code: _const.OrderChildSource.CMB
  },
  建设银行App: {
    isChecked: function isChecked(userAgent) {
      return _CcbAppHelper2.default.isCcbEvn(userAgent);
    },
    code: _const.OrderChildSource.CCB_APP
  }
};

exports.getBrowserCode = function () {
  var realUserAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;

  var userAgent = realUserAgent;
  var childSource = _const.OrderChildSource.OTHER;

  (0, _keys2.default)(Browser).some(function (key) {
    if (Browser[key].isChecked(userAgent)) {
      childSource = Browser[key].code;
      return true;
    }

    return false;
  });

  return childSource;
};

/***/ }),
/* 422 */,
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  addressinputRightPN: {
    id: 'address.inputRightPN',
    defaultMessage: '请输入正确手机号'
  },
  addressname: {
    id: 'address.name',
    defaultMessage: '姓名'
  },
  addressinputName: {
    id: 'address.inputName',
    defaultMessage: '请输入姓名'
  },
  addresssex: {
    id: 'address.sex',
    defaultMessage: '性别'
  },
  addressPN: {
    id: 'address.PN',
    defaultMessage: '联系电话'
  },
  addressinputPN: {
    id: 'address.inputPN',
    defaultMessage: '请输入手机号码'
  },
  addressAddress: {
    id: 'address.Address',
    defaultMessage: '收货地址'
  },
  addressselectAddress: {
    id: 'address.selectAddress',
    defaultMessage: '请选择收货地址'
  },
  selectDeliveryArriveTime: {
    id: 'address.selectDeliveryArriveTime',
    defaultMessage: '请选择送达时间'
  },
  addressdoorplateInfo: {
    id: 'address.doorplateInfo',
    defaultMessage: '门牌信息'
  },
  addressinputDoorplate: {
    id: 'address.inputDoorplate',
    defaultMessage: '请输入门牌信息'
  },
  addresssaveAddress: {
    id: 'address.saveAddress',
    defaultMessage: '保存地址'
  },
  addressdeleteAddress: {
    id: 'address.deleteAddress',
    defaultMessage: '删除地址'
  },
  addressconfirmDelete: {
    id: 'address.confirmDelete',
    defaultMessage: '您确定删除该地址吗？'
  },
  addressBirthday: {
    id: 'address.birthday',
    defaultMessage: '生日'
  },
  addressInvalidName: {
    id: 'address.invalidName',
    defaultMessage: '地址信息中姓名不允许含有特殊字符'
  },
  addressInvalidStreet: {
    id: 'address.invalidStreet',
    defaultMessage: '地址信息中门牌信息不允许含有特殊字符'
  }
});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var JsSHA = __webpack_require__(429);
exports.getSendCodeParamStr = function (obj) {
  var key = '2039a66ba1d64576a8fba398b8b7598b';
  var props = [];
  var n = 0;

  for (var prop in obj) {
    if (!obj[prop]) {
      continue;
    }

    props[n] = prop;
    n++;
  }

  props.sort();
  var paramStr = '';
  function concat(length) {
    var preIndex = length - 1;
    if (length === 1) {
      paramStr = props[0] + '=' + obj[props[0]];
    } else {
      paramStr = concat(preIndex) + '&' + props[preIndex] + '=' + obj[props[preIndex]];
    }
    return paramStr;
  }

  concat(n);
  var value = paramStr + '&key=' + key;
  var shaObj = new JsSHA('SHA-1', 'TEXT');
  shaObj.update(value);
  return paramStr + '&sign=' + shaObj.getHash('HEX');
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  title: {
    id: 'shoppingcart.title',
    defaultMessage: '购物车'
  },
  clear: {
    id: 'shoppingcart.clear',
    defaultMessage: '清空购物车'
  },
  clearConfirmed: {
    id: 'shoppingcart.clearConfirmed',
    defaultMessage: '您确定要清空购物车吗？'
  },
  commercialClosed: {
    id: 'shoppingcart.commercialClosed',
    defaultMessage: '商户已打烊'
  },
  isEmpty: {
    id: 'shoppingcart.isEmpty',
    defaultMessage: '购物车是空的'
  },
  closeOk: {
    id: 'shoppingcart.closeOk',
    defaultMessage: '选好啦'
  },
  chosen: {
    id: 'shoppingcart.chosen',
    defaultMessage: '选好了'
  },
  needDeliveryFee: {
    id: 'shoppingcart.needDeliveryFee',
    defaultMessage: '另需配送费{currency}{shipmentFee}'
  },
  freeDeliveryFee: {
    id: 'shoppingcart.freeDeliveryFee',
    defaultMessage: '已免{currency}{shipmentFee}配送费'
  },
  man: {
    id: 'shoppingCart.man',
    defaultMessage: '先生'
  },
  woman: {
    id: 'shoppingCart.woman',
    defaultMessage: '女士'
  },
  anonymous: {
    id: 'shoppintCart.anonymous',
    defaultMessage: '匿名用户'
  },
  totalOfDishes: {
    id: 'shoppingCart.totalOfDishes',
    defaultMessage: '共 {dishesCount} 份'
  },
  dishNameTotalOfDishes: {
    id: 'shoppingCart.dishNameTotalOfDishes',
    defaultMessage: '{dishTypeName} {dishesCount}份'
  },
  totalPrice: {
    id: 'shoppingCart.totalPrice',
    defaultMessage: '总计'
  },
  isEmptyAndGetDish: {
    id: 'shoppingCart.isEmptyAndGetDish',
    defaultMessage: '购物车空空的呢，快去点餐吧～'
  },
  customerImg: {
    id: 'shoppingCart.customerImg',
    defaultMessage: '用户头像'
  },
  notes: {
    id: 'shoppingCart.notes',
    defaultMessage: '备注'
  },
  peopleCountOfMeal: {
    id: 'shoppingCart.peopleCountOfMeal',
    defaultMessage: '就餐人数'
  },
  peopleCount: {
    id: 'shoppingCart.peopleCount',
    defaultMessage: '人数'
  },
  changeShoppingCart: {
    id: 'shoppingCart.changeShoppingCart',
    defaultMessage: '购物车内容被修改啦'
  },
  looking: {
    id: 'shoppingCart.looking',
    defaultMessage: '快去看看吧～'
  },
  isAddOrder: {
    id: 'shoppingCart.isAddOrder',
    defaultMessage: '当前桌台存在订单，是否直接加菜?'
  },
  func: {
    id: 'shoppingCart.func',
    defaultMessage: '功能'
  },
  addDish: {
    id: 'shoppingCart.addDish',
    defaultMessage: '加菜'
  },
  backShoppingCart: {
    id: 'shoppingCart.backShoppingCart',
    defaultMessage: '返回购物车'
  },
  success: {
    id: 'shoppingCart.success',
    defaultMessage: '下单成功！'
  },
  known: {
    id: 'shoppingCart.known',
    defaultMessage: '朕知道了'
  },
  checkoutMoney: {
    id: 'shoppingCart.checkoutMoney',
    defaultMessage: '结账'
  },
  checkoutMoneyForBar: {
    id: 'shoppingCart.checkoutMoneyForBar',
    defaultMessage: '去吧台结账'
  },
  checkoutMoneyForBarReason: {
    id: 'shoppingCart.checkoutMoneyForBarReason',
    defaultMessage: '当前显示价格仅为参考总价，最终以吧台结账信息为准'
  },
  placedOrder: {
    id: 'shoppingCart.placeOrder',
    defaultMessage: '已下单'
  },
  mineCoupons: {
    id: 'shoppingCart.mineCoupons',
    defaultMessage: '优惠券'
  },
  confirmOrder: {
    id: 'shoppingCart.confirmOrder',
    defaultMessage: '确认下单'
  },
  confirmPay: {
    id: 'shoppingCart.confirmPay',
    defaultMessage: '确认买单'
  },
  confirmPayDesc: {
    id: 'shoppingCart.confirmPayDesc',
    defaultMessage: '若有其他优惠，将在付款时抵扣'
  },
  placeOnOrder: {
    id: 'shoppingCart.placeOnOrder',
    defaultMessage: '下单'
  },
  shopConfirm: {
    id: 'shoppingCart.shopConfirm',
    defaultMessage: '商户确认'
  },
  eatting: {
    id: 'shoppingCart.eatting',
    defaultMessage: '就餐'
  },
  scanPlaceOrder: {
    id: 'shoppingCart.scanPlaceOrder',
    defaultMessage: '扫码下单'
  },
  selectTablePlaceOrder: {
    id: 'shoppingCart.selectTablePlaceOrder',
    defaultMessage: '选桌下单'
  },
  confirmTable: {
    id: 'shoppingCart.confirmTable',
    defaultMessage: '确认桌台'
  },
  minimumConsumptionReminder: {
    id: 'shoppingCart.minimumConsumptionReminder',
    defaultMessage: '本桌最低消费{lowerValue}元，还差{value}元'
  },
  pleaseChooseTable: {
    id: 'shoppingCart.pleaseChooseTable',
    defaultMessage: '请选择桌台'
  },
  gotoModify: {
    id: 'shoppingCart.gotoModify',
    defaultMessage: '去修改'
  },
  confirmTheOrder: {
    id: 'shoppingCart.confirmTheOrder',
    defaultMessage: '确认订单'
  },
  chooseJoinOrder: {
    id: 'shoppingCart.chooseJoinOrder',
    defaultMessage: '选择加入的订单'
  },
  sureOrder: {
    id: 'shoppingCart.sureOrder',
    defaultMessage: '确定下单'
  },
  createMyOrder: {
    id: 'shoppingCart.createMyOrder',
    defaultMessage: '创建我自己的订单'
  },
  createTime: {
    id: 'shoppingCart.createTime',
    defaultMessage: '创建时间'
  },
  allDishNum: {
    id: 'shoppingCart.allDishNum',
    defaultMessage: '共{allDishNum}份菜'
  },
  singleDiscountWithoutReduce: {
    id: 'shoppingCart.singleDiscountWithoutReduce',
    defaultMessage: '满减与折扣/第二份半价商品不同享'
  },
  singleDiscountWithReduce: {
    id: 'shoppingCart.singleDiscountWithReduce',
    defaultMessage: '折扣商品每单限购1份，超出部分按原价购买'
  },
  orderIsLocked: {
    id: 'orderIsLocked',
    defaultMessage: '订单已经锁定'
  },
  tinyCartUpTo: {
    id: 'tinyCartUpTo',
    defaultMessage: '起'
  },
  mustOrderTip: {
    id: 'shoppingCart.mustOrderTip',
    defaultMessage: '下单必须添加必点菜哦'
  },
  goAddMustOrder: {
    id: 'shoppingCart.goAddMustOrder',
    defaultMessage: '去添加'
  },
  dishesLoading: {
    id: 'shoppingCart.dishesLoading',
    defaultMessage: '拼命加载商品中~'
  }
});

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(75);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _couponPrivCalculator = __webpack_require__(430);

var _couponPrivCalculator2 = _interopRequireDefault(_couponPrivCalculator);

var _orderHelper = __webpack_require__(118);

var _dishHelper = __webpack_require__(43);

var _commonHelper = __webpack_require__(3);

var _serviceChargeCalc = __webpack_require__(436);

var _changePurchaseCalculator = __webpack_require__(270);

var _const = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  // 优惠劵优惠
  couponCalc: function couponCalc(dishes, serviceProps) {
    return _couponPrivCalculator2.default.calc(dishes, serviceProps);
  },


  // 单商品优惠
  singleProdPrivCalc: function singleProdPrivCalc(dishes, serviceProps, isHDL) {
    return dishes.reduce(function (acc, cur) {
      acc += (0, _orderHelper.getDishBenefitPrice)(cur, serviceProps, dishes, isHDL);
      return acc;
    }, 0);
  },


  // 多商品优惠
  multiProdPrivCalc: function multiProdPrivCalc(dishes, serviceProps) {
    return serviceProps.activityBenefit.benefitMoney || 0;
  },
  privCalc: function privCalc(dishes, serviceProps, isHDL) {
    var _ref = serviceProps.wholeOrderBenefit || {},
        isMultiPriv = _ref.isChecked;

    return [isMultiPriv ? this.multiProdPrivCalc(dishes, serviceProps) : this.singleProdPrivCalc(dishes, serviceProps, isHDL), this.couponCalc(dishes, serviceProps)].reduce(function (acc, cur) {
      return acc + cur;
    }, 0);
  },


  // 自动进位计算
  autoCarryCalc: function autoCarryCalc(carryRuleVO, charge) {
    var _carryPrice = (0, _orderHelper.carryPrice)(carryRuleVO, charge),
        smallChange = _carryPrice.change,
        priceWithClearSmallChange = _carryPrice.price;

    return {
      smallChange: smallChange,
      priceWithClearSmallChange: priceWithClearSmallChange
    };
  },


  // 会员积分
  memberPointCalc: function memberPointCalc(serviceProps, realCharge) {
    var integralsInfo = serviceProps.integralsInfo,
        privateRoom = serviceProps.couponsProps.privateRoom,
        integralsDetail = serviceProps.integralsDetail;

    if (!integralsInfo || !integralsInfo.isChecked) {
      return { commutation: 0, integralInUsed: 0 };
    }

    if (!privateRoom) {
      return (0, _orderHelper.countIntegralsToCash)(realCharge, integralsDetail);
    }

    var _getMaxIntegralCanBeU = (0, _orderHelper.getMaxIntegralCanBeUsedForYaZuo)(realCharge, integralsDetail),
        maxDiscount = _getMaxIntegralCanBeU.maxDiscount,
        maxIntegralCanBeUsed = _getMaxIntegralCanBeU.maxIntegralCanBeUsed;

    return { commutation: maxDiscount, integralInUsed: maxIntegralCanBeUsed };
  },


  // 会员积分
  fakeMemberPointCalc: function fakeMemberPointCalc(dishes, serviceProps) {
    var privateRoom = serviceProps.couponsProps.privateRoom,
        integralsDetail = serviceProps.integralsDetail;

    if (!privateRoom) {
      return (0, _orderHelper.countIntegralsToCash)(this.calcTotalCharge(dishes, serviceProps), integralsDetail);
    }

    var _getMaxIntegralCanBeU2 = (0, _orderHelper.getMaxIntegralCanBeUsedForYaZuo)(this.calcTotalCharge(dishes, serviceProps), integralsDetail),
        maxDiscount = _getMaxIntegralCanBeU2.maxDiscount,
        maxIntegralCanBeUsed = _getMaxIntegralCanBeU2.maxIntegralCanBeUsed;

    return { commutation: maxDiscount, integralInUsed: maxIntegralCanBeUsed };
  },


  // 配送费用减免
  shippingFeeCalc: function shippingFeeCalc(dishes, serviceProps) {
    var _ref2 = serviceProps.deliveryProps || {},
        freeDeliveryPrice = _ref2.freeDeliveryPrice,
        deliveryPrice = _ref2.deliveryPrice;

    var dishCharge = (0, _dishHelper.getDishesPrice)(dishes);

    if (dishCharge >= freeDeliveryPrice && deliveryPrice > 0) {
      return deliveryPrice;
    }

    return 0;
  },


  // 礼品卡优惠
  giftCardCalc: function giftCardCalc(serviceProps, realCharge) {
    var _ref3 = serviceProps.cardsProps || {},
        _ref3$inUseValue = _ref3.inUseValue,
        inUseValue = _ref3$inUseValue === undefined ? 0 : _ref3$inUseValue;

    return Math.min(inUseValue, realCharge);
  },


  // 原价
  calcTotalCharge: function calcTotalCharge(dishes, serviceProps) {
    var dishCharge = (0, _dishHelper.getDishesPrice)(dishes);

    return (0, _orderHelper.countTotalPriceWithoutBenefit)(dishCharge, serviceProps.deliveryProps, serviceProps);
  },


  // 最低消费
  calcLowestConsumptionCharge: function calcLowestConsumptionCharge(_ref4) {
    var serviceProps = _ref4.serviceProps,
        ret = _ref4.ret,
        purchaseRealTotal = _ref4.purchaseRealTotal;
    var lowestConsumption = serviceProps.lowestConsumption;
    var total = ret.total,
        totalPriv = ret.totalPriv;

    var chargeValue = total - totalPriv + Math.max(purchaseRealTotal, 0);

    if (!lowestConsumption) {
      return 0;
    }

    if (total - totalPriv + Math.max(purchaseRealTotal, 0) < lowestConsumption) {
      return lowestConsumption - chargeValue;
    }

    return 0;
  },


  // todo remove duplicate calc
  calc: function calc(orderedDishesProps, serviceProps) {
    var commercialProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var peopleCount = arguments[3];
    var isHDL = arguments[4];
    var hasPriviledge = commercialProps.hasPriviledge;

    if (hasPriviledge) {
      return this.calcInAddDishMode(serviceProps, commercialProps);
    }

    return this.calcInNormalMode(orderedDishesProps, serviceProps, commercialProps, peopleCount, isHDL);
  },


  // 普通模式
  calcInNormalMode: function calcInNormalMode(orderedDishesProps, serviceProps, commercialProps, peopleCount, isHDL) {
    var dishes = orderedDishesProps.dishes;
    var integralsInfo = serviceProps.integralsInfo,
        markUpBenefitProps = serviceProps.markUpBenefitProps,
        benefitProps = serviceProps.benefitProps,
        _serviceProps$taxInfo = serviceProps.taxInfo,
        _serviceProps$taxInfo2 = _serviceProps$taxInfo.addFeeTaxes,
        addFeeTaxes = _serviceProps$taxInfo2 === undefined ? [] : _serviceProps$taxInfo2,
        _serviceProps$taxInfo3 = _serviceProps$taxInfo.dishConsumeTaxs,
        dishConsumeTaxs = _serviceProps$taxInfo3 === undefined ? [] : _serviceProps$taxInfo3,
        _serviceProps$taxInfo4 = _serviceProps$taxInfo.taxMode,
        taxMode = _serviceProps$taxInfo4 === undefined ? -1 : _serviceProps$taxInfo4;
    // TODO, 计算加价购,在原来 dishes 的基础上再合并上参与加价购的商品

    var _getFinalDishesWidthP = (0, _changePurchaseCalculator.getFinalDishesWidthPurchase)(markUpBenefitProps),
        finalDishes = _getFinalDishesWidthP.finalDishes,
        purchaseRealTotal = _getFinalDishesWidthP.purchaseRealTotal,
        purchaseMarketTotal = _getFinalDishesWidthP.purchaseMarketTotal,
        compareBenefit = _getFinalDishesWidthP.compareBenefit;

    var newDishes = dishes.concat(finalDishes || []);

    var ret = {
      priv: 0,
      total: this.calcTotalCharge(dishes, serviceProps),
      memberPoint: { commutation: 0, integralInUsed: 0 },
      totalPriv: 0,
      coupon: this.couponCalc(dishes, serviceProps),
      real: 0,
      giftCardPriv: 0,
      carry: { smallChange: 0, priceWithClearSmallChange: 0 },
      exciseTaxPriv: benefitProps.taxFee || 0,
      serviceCharge: benefitProps.serviceCharge.initAmount,
      lowestConsumptionCharge: 0, // 最低消费差值
      taxInfo: {}
    };
    var taxInfo = {};

    var beforeAndAfterPriv = {
      beforePrivTotal: 0, // 标记优惠前总价
      afterPrivTotal: 0, // 标记优惠后总价
      beforePrivServiceCharge: 0, // 标记优惠前服务费
      afterPrivServiceCharge: 0, // 标记优惠后服务费
      beforePrivExciseTax: 0, // 标记优惠前消费税
      afterPrivExciseTax: 0 // 标记优惠后消费税
    };

    var carryRuleVO = commercialProps.carryRuleVO;
    var serviceCharge = benefitProps.serviceCharge;

    // 单、多商品优和优惠劵优惠

    ret.priv = this.privCalc(dishes, serviceProps, isHDL);
    ret.totalPriv += ret.priv;
    beforeAndAfterPriv.beforePrivTotal = ret.total;

    // 配送费减免
    var shippingFee = this.shippingFeeCalc(newDishes, serviceProps);
    if (shippingFee) {
      ret.totalPriv += shippingFee;
    }

    // 积分
    if (integralsInfo && integralsInfo.isChecked) {
      ret.memberPoint = this.memberPointCalc(serviceProps, ret.total - ret.totalPriv);
      ret.totalPriv += ret.memberPoint.commutation;
    }

    // 礼品卡
    var giftCardPriv = this.giftCardCalc(serviceProps, ret.total - ret.totalPriv);
    ret.giftCardPriv = giftCardPriv;
    ret.totalPriv += giftCardPriv;

    beforeAndAfterPriv.afterPrivTotal = ret.total - ret.totalPriv;

    // 服务费计算
    (0, _assign2.default)(beforeAndAfterPriv, (0, _serviceChargeCalc.calcServiceCharge)({ serviceCharge: serviceCharge, beforeAndAfterPriv: beforeAndAfterPriv, peopleCount: peopleCount }));
    ret.serviceCharge = (0, _commonHelper.formatPrice)(beforeAndAfterPriv.beforePrivServiceCharge + beforeAndAfterPriv.afterPrivServiceCharge);

    // 服务费加入总价
    ret.total += ret.serviceCharge + (0, _orderHelper.getOrderExtraPrice)(serviceProps);

    // 最低消费
    ret.lowestConsumptionCharge = this.calcLowestConsumptionCharge({ serviceProps: serviceProps, ret: ret, purchaseRealTotal: purchaseRealTotal });
    ret.total += ret.lowestConsumptionCharge;

    // 计算菜品的消费税（优惠后的价格）
    if (dishConsumeTaxs.length) {
      // 优惠后的金额(还未计算优惠券分摊)
      var _couponCalculator$get = _couponPrivCalculator2.default.getRealPrices(dishes, serviceProps),
          realPrices = _couponCalculator$get.realPrices;

      var afterCouponPrices = _couponPrivCalculator2.default.getAfterCouponPrices(dishes, serviceProps);

      var dishPrices = (0, _keys2.default)(realPrices).reduce(function (res, dishId) {
        var afterCouponPrice = afterCouponPrices[dishId];
        if (afterCouponPrice && afterCouponPrice.length) {
          res[dishId] = Math.max(realPrices[dishId] - afterCouponPrice.reduce(function (t, c) {
            return t + c;
          }, 0), 0);
        } else {
          res[dishId] = realPrices[dishId];
        }

        return res;
      }, {});

      dishConsumeTaxs.forEach(function (_ref5) {
        var dishId = _ref5.dishId,
            _ref5$taxs = _ref5.taxs,
            taxs = _ref5$taxs === undefined ? [] : _ref5$taxs;

        var dishPrice = dishPrices[dishId];
        if (dishPrice && taxs.length) {
          taxInfo = (0, _serviceChargeCalc.calcDishForTaxType)(dishPrice, taxs, taxInfo, taxMode);
        }
      });
    }

    // 计算附加费的消费税
    if (addFeeTaxes.length) {
      var addFees = [].concat((0, _toConsumableArray3.default)(benefitProps.extraPrivilege || []), [(0, _extends3.default)({}, serviceCharge, {
        privilegeAmount: ret.serviceCharge
      })]);

      addFeeTaxes.forEach(function (_ref6) {
        var addFeeId = _ref6.addFeeId,
            _ref6$taxs = _ref6.taxs,
            taxs = _ref6$taxs === undefined ? [] : _ref6$taxs;

        var addFee = addFees.find(function (item) {
          return item.id === addFeeId;
        });
        if (addFee && addFee.privilegeAmount) {
          taxInfo = (0, _serviceChargeCalc.calcDishForTaxType)(addFee.privilegeAmount, taxs, taxInfo, taxMode);
        }
      });
    }

    // 消费税总额
    ret.taxInfo = (0, _keys2.default)(taxInfo).map(function (key) {
      return taxInfo[key];
    });
    ret.exciseTaxPriv = ret.taxInfo.reduce(function (t, c) {
      return t + c.amount;
    }, 0);
    ret.total += taxMode === _const.TAX_MODE.INCLUDE ? 0 : ret.exciseTaxPriv;

    // 进位规则
    if (carryRuleVO) {
      ret.carry = this.autoCarryCalc(carryRuleVO, ret.total - ret.totalPriv);
      ret.totalPriv += ret.carry.smallChange;
    }

    ret.serviceCharge = (0, _commonHelper.formatPrice)(ret.serviceCharge);
    ret.priv = (0, _commonHelper.formatPrice)(ret.priv);
    ret.purchasePriv = (0, _commonHelper.formatPrice)(purchaseMarketTotal - purchaseRealTotal);
    ret.exciseTaxPriv = (0, _commonHelper.formatPrice)(ret.exciseTaxPriv);
    ret.real = (0, _commonHelper.formatPrice)(ret.total - ret.totalPriv + Math.max(purchaseRealTotal, 0));
    ret.totalPriv = (0, _commonHelper.formatPrice)(ret.totalPriv);
    ret.compareBenefit = (0, _commonHelper.formatPrice)(compareBenefit);
    ret.total = (0, _commonHelper.formatPrice)(ret.total + purchaseMarketTotal);
    ret.lowestConsumptionCharge = (0, _commonHelper.formatPrice)(ret.lowestConsumptionCharge);

    return ret;
  },


  // 加菜模式
  calcInAddDishMode: function calcInAddDishMode(serviceProps, commercialProps) {
    var ret = {
      priv: 0,
      total: 0,
      memberPoint: { commutation: 0, integralInUsed: 0 },
      totalPriv: 0,
      coupon: 0,
      real: 0,
      giftCardPriv: 0,
      purchasePriv: 0,
      carry: { smallChange: 0, priceWithClearSmallChange: 0 },
      exciseTaxPriv: serviceProps.benefitProps.taxFee || 0,
      serviceCharge: (0, _commonHelper.formatPrice)(serviceProps.benefitProps.serviceCharge.initAmount || 0),
      lowestConsumptionCharge: (0, _commonHelper.formatPrice)(0)
    };
    var _serviceProps$benefit = serviceProps.benefitProps,
        priviledgeAmount = _serviceProps$benefit.priviledgeAmount,
        totalAmount = _serviceProps$benefit.totalAmount;
    var carryRuleVO = commercialProps.carryRuleVO;


    ret.total = priviledgeAmount + totalAmount;
    ret.totalPriv = priviledgeAmount;

    if (carryRuleVO) {
      ret.carry = this.autoCarryCalc(carryRuleVO, totalAmount);
      ret.totalPriv += ret.carry.smallChange;
    }

    ret.real = (0, _commonHelper.formatPrice)(ret.total - ret.totalPriv);
    return ret;
  }
}; /**
    * 金额计算
    * 普通模式，根据前端选择的单商品、多商品优惠，优惠券，积分，进位规则计算相关费用
    * 加菜模式，附加费，优惠金额，总计均有后端返回，前端仅做绑定
    */

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  actionselectSex: {
    id: 'action.selectSex',
    defaultMessage: '请选择性别'
  },
  actioninputNamePrompt: {
    id: 'action.inputNamePrompt',
    defaultMessage: '请输入姓名'
  },
  actionselectBirthday: {
    id: 'action.selectBirthday',
    defaultMessage: '请选择生日'
  },
  actionselectPSW: {
    id: 'action.selectPSW',
    defaultMessage: '请填写交易密码'
  },
  actionselectPSW6: {
    id: 'action.selectPSW6',
    defaultMessage: '请填写6位数交易密码'
  }
});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(432),
      utf8 = __webpack_require__(272).utf8,
      isBuffer = __webpack_require__(433),
      bin = __webpack_require__(272).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/*
 A JavaScript implementation of the SHA family of hashes, as
 defined in FIPS PUB 180-4 and FIPS PUB 202, as well as the corresponding
 HMAC implementation as defined in FIPS PUB 198a

 Copyright 2008-2020 Brian Turek, 1998-2009 Paul Johnston & Contributors
 Distributed under the BSD License
 See http://caligatio.github.com/jsSHA/ for more information
*/
(function(aa){function C(d,b,a){var h=0,k=[],m=0,g,l,c,f,n,q,u,r,I=!1,v=[],x=[],t,y=!1,z=!1,w=-1;a=a||{};g=a.encoding||"UTF8";t=a.numRounds||1;if(t!==parseInt(t,10)||1>t)throw Error("numRounds must a integer >= 1");if("SHA-1"===d)n=512,q=K,u=ba,f=160,r=function(b){return b.slice()};else if(0===d.lastIndexOf("SHA-",0))if(q=function(b,h){return L(b,h,d)},u=function(b,h,k,a){var e,f;if("SHA-224"===d||"SHA-256"===d)e=(h+65>>>9<<4)+15,f=16;else if("SHA-384"===d||"SHA-512"===d)e=(h+129>>>10<<
5)+31,f=32;else throw Error("Unexpected error in SHA-2 implementation");for(;b.length<=e;)b.push(0);b[h>>>5]|=128<<24-h%32;h=h+k;b[e]=h&4294967295;b[e-1]=h/4294967296|0;k=b.length;for(h=0;h<k;h+=f)a=L(b.slice(h,h+f),a,d);if("SHA-224"===d)b=[a[0],a[1],a[2],a[3],a[4],a[5],a[6]];else if("SHA-256"===d)b=a;else if("SHA-384"===d)b=[a[0].a,a[0].b,a[1].a,a[1].b,a[2].a,a[2].b,a[3].a,a[3].b,a[4].a,a[4].b,a[5].a,a[5].b];else if("SHA-512"===d)b=[a[0].a,a[0].b,a[1].a,a[1].b,a[2].a,a[2].b,a[3].a,a[3].b,a[4].a,
a[4].b,a[5].a,a[5].b,a[6].a,a[6].b,a[7].a,a[7].b];else throw Error("Unexpected error in SHA-2 implementation");return b},r=function(b){return b.slice()},"SHA-224"===d)n=512,f=224;else if("SHA-256"===d)n=512,f=256;else if("SHA-384"===d)n=1024,f=384;else if("SHA-512"===d)n=1024,f=512;else throw Error("Chosen SHA variant is not supported");else if(0===d.lastIndexOf("SHA3-",0)||0===d.lastIndexOf("SHAKE",0)){var F=6;q=D;r=function(b){var d=[],a;for(a=0;5>a;a+=1)d[a]=b[a].slice();return d};w=1;if("SHA3-224"===
d)n=1152,f=224;else if("SHA3-256"===d)n=1088,f=256;else if("SHA3-384"===d)n=832,f=384;else if("SHA3-512"===d)n=576,f=512;else if("SHAKE128"===d)n=1344,f=-1,F=31,z=!0;else if("SHAKE256"===d)n=1088,f=-1,F=31,z=!0;else throw Error("Chosen SHA variant is not supported");u=function(b,d,a,h,k){a=n;var e=F,f,g=[],m=a>>>5,l=0,c=d>>>5;for(f=0;f<c&&d>=a;f+=m)h=D(b.slice(f,f+m),h),d-=a;b=b.slice(f);for(d%=a;b.length<m;)b.push(0);f=d>>>3;b[f>>2]^=e<<f%4*8;b[m-1]^=2147483648;for(h=D(b,h);32*g.length<k;){b=h[l%
5][l/5|0];g.push(b.b);if(32*g.length>=k)break;g.push(b.a);l+=1;0===64*l%a&&(D(null,h),l=0)}return g}}else throw Error("Chosen SHA variant is not supported");c=M(b,g,w);l=A(d);this.setHMACKey=function(b,a,k){var e;if(!0===I)throw Error("HMAC key already set");if(!0===y)throw Error("Cannot set HMAC key after calling update");if(!0===z)throw Error("SHAKE is not supported for HMAC");g=(k||{}).encoding||"UTF8";a=M(a,g,w)(b);b=a.binLen;a=a.value;e=n>>>3;k=e/4-1;for(e<b/8&&(a=u(a,b,0,A(d),f));a.length<=
k;)a.push(0);for(b=0;b<=k;b+=1)v[b]=a[b]^909522486,x[b]=a[b]^1549556828;l=q(v,l);h=n;I=!0};this.update=function(b){var d,a,e,f=0,g=n>>>5;d=c(b,k,m);b=d.binLen;a=d.value;d=b>>>5;for(e=0;e<d;e+=g)f+n<=b&&(l=q(a.slice(e,e+g),l),f+=n);h+=f;k=a.slice(f>>>5);m=b%n;y=!0};this.getHash=function(b,a){var e,g,c,n;if(!0===I)throw Error("Cannot call getHash after setting HMAC key");c=N(a);if(!0===z){if(-1===c.shakeLen)throw Error("shakeLen must be specified in options");f=c.shakeLen}switch(b){case "HEX":e=function(b){return O(b,
f,w,c)};break;case "B64":e=function(b){return P(b,f,w,c)};break;case "BYTES":e=function(b){return Q(b,f,w)};break;case "ARRAYBUFFER":try{g=new ArrayBuffer(0)}catch(p){throw Error("ARRAYBUFFER not supported by this environment");}e=function(b){return R(b,f,w)};break;case "UINT8ARRAY":try{g=new Uint8Array(0)}catch(p){throw Error("UINT8ARRAY not supported by this environment");}e=function(b){return S(b,f,w)};break;default:throw Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}n=u(k.slice(),
m,h,r(l),f);for(g=1;g<t;g+=1)!0===z&&0!==f%32&&(n[n.length-1]&=16777215>>>24-f%32),n=u(n,f,0,A(d),f);return e(n)};this.getHMAC=function(b,a){var e,g,c,p;if(!1===I)throw Error("Cannot call getHMAC without first setting HMAC key");c=N(a);switch(b){case "HEX":e=function(b){return O(b,f,w,c)};break;case "B64":e=function(b){return P(b,f,w,c)};break;case "BYTES":e=function(b){return Q(b,f,w)};break;case "ARRAYBUFFER":try{e=new ArrayBuffer(0)}catch(v){throw Error("ARRAYBUFFER not supported by this environment");
}e=function(b){return R(b,f,w)};break;case "UINT8ARRAY":try{e=new Uint8Array(0)}catch(v){throw Error("UINT8ARRAY not supported by this environment");}e=function(b){return S(b,f,w)};break;default:throw Error("outputFormat must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}g=u(k.slice(),m,h,r(l),f);p=q(x,A(d));p=u(g,f,n,p,f);return e(p)}}function a(d,b){this.a=d;this.b=b}function T(d,b,a,h){var k,m,g,l,c;b=b||[0];a=a||0;m=a>>>3;c=-1===h?3:0;for(k=0;k<d.length;k+=1)l=k+m,g=l>>>2,b.length<=g&&b.push(0),
b[g]|=d[k]<<8*(c+l%4*h);return{value:b,binLen:8*d.length+a}}function O(a,b,e,h){var k="";b/=8;var m,g,c;c=-1===e?3:0;for(m=0;m<b;m+=1)g=a[m>>>2]>>>8*(c+m%4*e),k+="0123456789abcdef".charAt(g>>>4&15)+"0123456789abcdef".charAt(g&15);return h.outputUpper?k.toUpperCase():k}function P(a,b,e,h){var k="",m=b/8,g,c,p,f;f=-1===e?3:0;for(g=0;g<m;g+=3)for(c=g+1<m?a[g+1>>>2]:0,p=g+2<m?a[g+2>>>2]:0,p=(a[g>>>2]>>>8*(f+g%4*e)&255)<<16|(c>>>8*(f+(g+1)%4*e)&255)<<8|p>>>8*(f+(g+2)%4*e)&255,c=0;4>c;c+=1)8*g+6*c<=b?k+=
"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(p>>>6*(3-c)&63):k+=h.b64Pad;return k}function Q(a,b,e){var h="";b/=8;var k,c,g;g=-1===e?3:0;for(k=0;k<b;k+=1)c=a[k>>>2]>>>8*(g+k%4*e)&255,h+=String.fromCharCode(c);return h}function R(a,b,e){b/=8;var h,k=new ArrayBuffer(b),c,g;g=new Uint8Array(k);c=-1===e?3:0;for(h=0;h<b;h+=1)g[h]=a[h>>>2]>>>8*(c+h%4*e)&255;return k}function S(a,b,e){b/=8;var h,k=new Uint8Array(b),c;c=-1===e?3:0;for(h=0;h<b;h+=1)k[h]=a[h>>>2]>>>8*(c+h%4*e)&
255;return k}function N(a){var b={outputUpper:!1,b64Pad:"=",shakeLen:-1};a=a||{};b.outputUpper=a.outputUpper||!1;!0===a.hasOwnProperty("b64Pad")&&(b.b64Pad=a.b64Pad);if(!0===a.hasOwnProperty("shakeLen")){if(0!==a.shakeLen%8)throw Error("shakeLen must be a multiple of 8");b.shakeLen=a.shakeLen}if("boolean"!==typeof b.outputUpper)throw Error("Invalid outputUpper formatting option");if("string"!==typeof b.b64Pad)throw Error("Invalid b64Pad formatting option");return b}function M(a,b,e){switch(b){case "UTF8":case "UTF16BE":case "UTF16LE":break;
default:throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");}switch(a){case "HEX":a=function(b,a,d){var g=b.length,c,p,f,n,q,u;if(0!==g%2)throw Error("String of HEX type must be in byte increments");a=a||[0];d=d||0;q=d>>>3;u=-1===e?3:0;for(c=0;c<g;c+=2){p=parseInt(b.substr(c,2),16);if(isNaN(p))throw Error("String of HEX type contains invalid characters");n=(c>>>1)+q;for(f=n>>>2;a.length<=f;)a.push(0);a[f]|=p<<8*(u+n%4*e)}return{value:a,binLen:4*g+d}};break;case "TEXT":a=function(a,d,c){var g,
l,p=0,f,n,q,u,r,t;d=d||[0];c=c||0;q=c>>>3;if("UTF8"===b)for(t=-1===e?3:0,f=0;f<a.length;f+=1)for(g=a.charCodeAt(f),l=[],128>g?l.push(g):2048>g?(l.push(192|g>>>6),l.push(128|g&63)):55296>g||57344<=g?l.push(224|g>>>12,128|g>>>6&63,128|g&63):(f+=1,g=65536+((g&1023)<<10|a.charCodeAt(f)&1023),l.push(240|g>>>18,128|g>>>12&63,128|g>>>6&63,128|g&63)),n=0;n<l.length;n+=1){r=p+q;for(u=r>>>2;d.length<=u;)d.push(0);d[u]|=l[n]<<8*(t+r%4*e);p+=1}else if("UTF16BE"===b||"UTF16LE"===b)for(t=-1===e?2:0,l="UTF16LE"===
b&&1!==e||"UTF16LE"!==b&&1===e,f=0;f<a.length;f+=1){g=a.charCodeAt(f);!0===l&&(n=g&255,g=n<<8|g>>>8);r=p+q;for(u=r>>>2;d.length<=u;)d.push(0);d[u]|=g<<8*(t+r%4*e);p+=2}return{value:d,binLen:8*p+c}};break;case "B64":a=function(b,a,d){var c=0,l,p,f,n,q,u,r,t;if(-1===b.search(/^[a-zA-Z0-9=+\/]+$/))throw Error("Invalid character in base-64 string");p=b.indexOf("=");b=b.replace(/\=/g,"");if(-1!==p&&p<b.length)throw Error("Invalid '=' found in base-64 string");a=a||[0];d=d||0;u=d>>>3;t=-1===e?3:0;for(p=
0;p<b.length;p+=4){q=b.substr(p,4);for(f=n=0;f<q.length;f+=1)l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(q.charAt(f)),n|=l<<18-6*f;for(f=0;f<q.length-1;f+=1){r=c+u;for(l=r>>>2;a.length<=l;)a.push(0);a[l]|=(n>>>16-8*f&255)<<8*(t+r%4*e);c+=1}}return{value:a,binLen:8*c+d}};break;case "BYTES":a=function(b,a,d){var c,l,p,f,n,q;a=a||[0];d=d||0;p=d>>>3;q=-1===e?3:0;for(l=0;l<b.length;l+=1)c=b.charCodeAt(l),n=l+p,f=n>>>2,a.length<=f&&a.push(0),a[f]|=c<<8*(q+n%4*e);return{value:a,
binLen:8*b.length+d}};break;case "ARRAYBUFFER":try{a=new ArrayBuffer(0)}catch(h){throw Error("ARRAYBUFFER not supported by this environment");}a=function(b,a,d){return T(new Uint8Array(b),a,d,e)};break;case "UINT8ARRAY":try{a=new Uint8Array(0)}catch(h){throw Error("UINT8ARRAY not supported by this environment");}a=function(b,a,d){return T(b,a,d,e)};break;default:throw Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");}return a}function y(a,b){return a<<b|a>>>32-b}function U(d,
b){return 32<b?(b-=32,new a(d.b<<b|d.a>>>32-b,d.a<<b|d.b>>>32-b)):0!==b?new a(d.a<<b|d.b>>>32-b,d.b<<b|d.a>>>32-b):d}function x(a,b){return a>>>b|a<<32-b}function t(d,b){var e=null,e=new a(d.a,d.b);return e=32>=b?new a(e.a>>>b|e.b<<32-b&4294967295,e.b>>>b|e.a<<32-b&4294967295):new a(e.b>>>b-32|e.a<<64-b&4294967295,e.a>>>b-32|e.b<<64-b&4294967295)}function V(d,b){var e=null;return e=32>=b?new a(d.a>>>b,d.b>>>b|d.a<<32-b&4294967295):new a(0,d.a>>>b-32)}function ca(a,b,e){return a&b^~a&e}function da(d,
b,e){return new a(d.a&b.a^~d.a&e.a,d.b&b.b^~d.b&e.b)}function W(a,b,e){return a&b^a&e^b&e}function ea(d,b,e){return new a(d.a&b.a^d.a&e.a^b.a&e.a,d.b&b.b^d.b&e.b^b.b&e.b)}function fa(a){return x(a,2)^x(a,13)^x(a,22)}function ga(d){var b=t(d,28),e=t(d,34);d=t(d,39);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function ha(a){return x(a,6)^x(a,11)^x(a,25)}function ia(d){var b=t(d,14),e=t(d,18);d=t(d,41);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function ja(a){return x(a,7)^x(a,18)^a>>>3}function ka(d){var b=t(d,
1),e=t(d,8);d=V(d,7);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function la(a){return x(a,17)^x(a,19)^a>>>10}function ma(d){var b=t(d,19),e=t(d,61);d=V(d,6);return new a(b.a^e.a^d.a,b.b^e.b^d.b)}function G(a,b){var e=(a&65535)+(b&65535);return((a>>>16)+(b>>>16)+(e>>>16)&65535)<<16|e&65535}function na(a,b,e,h){var c=(a&65535)+(b&65535)+(e&65535)+(h&65535);return((a>>>16)+(b>>>16)+(e>>>16)+(h>>>16)+(c>>>16)&65535)<<16|c&65535}function H(a,b,e,h,c){var m=(a&65535)+(b&65535)+(e&65535)+(h&65535)+(c&65535);
return((a>>>16)+(b>>>16)+(e>>>16)+(h>>>16)+(c>>>16)+(m>>>16)&65535)<<16|m&65535}function oa(d,b){var e,h,c;e=(d.b&65535)+(b.b&65535);h=(d.b>>>16)+(b.b>>>16)+(e>>>16);c=(h&65535)<<16|e&65535;e=(d.a&65535)+(b.a&65535)+(h>>>16);h=(d.a>>>16)+(b.a>>>16)+(e>>>16);return new a((h&65535)<<16|e&65535,c)}function pa(d,b,e,h){var c,m,g;c=(d.b&65535)+(b.b&65535)+(e.b&65535)+(h.b&65535);m=(d.b>>>16)+(b.b>>>16)+(e.b>>>16)+(h.b>>>16)+(c>>>16);g=(m&65535)<<16|c&65535;c=(d.a&65535)+(b.a&65535)+(e.a&65535)+(h.a&65535)+
(m>>>16);m=(d.a>>>16)+(b.a>>>16)+(e.a>>>16)+(h.a>>>16)+(c>>>16);return new a((m&65535)<<16|c&65535,g)}function qa(d,b,e,h,c){var m,g,l;m=(d.b&65535)+(b.b&65535)+(e.b&65535)+(h.b&65535)+(c.b&65535);g=(d.b>>>16)+(b.b>>>16)+(e.b>>>16)+(h.b>>>16)+(c.b>>>16)+(m>>>16);l=(g&65535)<<16|m&65535;m=(d.a&65535)+(b.a&65535)+(e.a&65535)+(h.a&65535)+(c.a&65535)+(g>>>16);g=(d.a>>>16)+(b.a>>>16)+(e.a>>>16)+(h.a>>>16)+(c.a>>>16)+(m>>>16);return new a((g&65535)<<16|m&65535,l)}function B(d,b){return new a(d.a^b.a,d.b^
b.b)}function A(d){var b=[],e;if("SHA-1"===d)b=[1732584193,4023233417,2562383102,271733878,3285377520];else if(0===d.lastIndexOf("SHA-",0))switch(b=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428],e=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],d){case "SHA-224":break;case "SHA-256":b=e;break;case "SHA-384":b=[new a(3418070365,b[0]),new a(1654270250,b[1]),new a(2438529370,b[2]),new a(355462360,b[3]),new a(1731405415,
b[4]),new a(41048885895,b[5]),new a(3675008525,b[6]),new a(1203062813,b[7])];break;case "SHA-512":b=[new a(e[0],4089235720),new a(e[1],2227873595),new a(e[2],4271175723),new a(e[3],1595750129),new a(e[4],2917565137),new a(e[5],725511199),new a(e[6],4215389547),new a(e[7],327033209)];break;default:throw Error("Unknown SHA variant");}else if(0===d.lastIndexOf("SHA3-",0)||0===d.lastIndexOf("SHAKE",0))for(d=0;5>d;d+=1)b[d]=[new a(0,0),new a(0,0),new a(0,0),new a(0,0),new a(0,0)];else throw Error("No SHA variants supported");
return b}function K(a,b){var e=[],h,c,m,g,l,p,f;h=b[0];c=b[1];m=b[2];g=b[3];l=b[4];for(f=0;80>f;f+=1)e[f]=16>f?a[f]:y(e[f-3]^e[f-8]^e[f-14]^e[f-16],1),p=20>f?H(y(h,5),c&m^~c&g,l,1518500249,e[f]):40>f?H(y(h,5),c^m^g,l,1859775393,e[f]):60>f?H(y(h,5),W(c,m,g),l,2400959708,e[f]):H(y(h,5),c^m^g,l,3395469782,e[f]),l=g,g=m,m=y(c,30),c=h,h=p;b[0]=G(h,b[0]);b[1]=G(c,b[1]);b[2]=G(m,b[2]);b[3]=G(g,b[3]);b[4]=G(l,b[4]);return b}function ba(a,b,e,c){var k;for(k=(b+65>>>9<<4)+15;a.length<=k;)a.push(0);a[b>>>5]|=
128<<24-b%32;b+=e;a[k]=b&4294967295;a[k-1]=b/4294967296|0;b=a.length;for(k=0;k<b;k+=16)c=K(a.slice(k,k+16),c);return c}function L(d,b,e){var h,k,m,g,l,p,f,n,q,u,r,t,v,x,y,A,z,w,F,B,C,D,E=[],J;if("SHA-224"===e||"SHA-256"===e)u=64,t=1,D=Number,v=G,x=na,y=H,A=ja,z=la,w=fa,F=ha,C=W,B=ca,J=c;else if("SHA-384"===e||"SHA-512"===e)u=80,t=2,D=a,v=oa,x=pa,y=qa,A=ka,z=ma,w=ga,F=ia,C=ea,B=da,J=X;else throw Error("Unexpected error in SHA-2 implementation");e=b[0];h=b[1];k=b[2];m=b[3];g=b[4];l=b[5];p=b[6];f=b[7];
for(r=0;r<u;r+=1)16>r?(q=r*t,n=d.length<=q?0:d[q],q=d.length<=q+1?0:d[q+1],E[r]=new D(n,q)):E[r]=x(z(E[r-2]),E[r-7],A(E[r-15]),E[r-16]),n=y(f,F(g),B(g,l,p),J[r],E[r]),q=v(w(e),C(e,h,k)),f=p,p=l,l=g,g=v(m,n),m=k,k=h,h=e,e=v(n,q);b[0]=v(e,b[0]);b[1]=v(h,b[1]);b[2]=v(k,b[2]);b[3]=v(m,b[3]);b[4]=v(g,b[4]);b[5]=v(l,b[5]);b[6]=v(p,b[6]);b[7]=v(f,b[7]);return b}function D(d,b){var e,c,k,m,g=[],l=[];if(null!==d)for(c=0;c<d.length;c+=2)b[(c>>>1)%5][(c>>>1)/5|0]=B(b[(c>>>1)%5][(c>>>1)/5|0],new a(d[c+1],d[c]));
for(e=0;24>e;e+=1){m=A("SHA3-");for(c=0;5>c;c+=1){k=b[c][0];var p=b[c][1],f=b[c][2],n=b[c][3],q=b[c][4];g[c]=new a(k.a^p.a^f.a^n.a^q.a,k.b^p.b^f.b^n.b^q.b)}for(c=0;5>c;c+=1)l[c]=B(g[(c+4)%5],U(g[(c+1)%5],1));for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)b[c][k]=B(b[c][k],l[c]);for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)m[k][(2*c+3*k)%5]=U(b[c][k],Y[c][k]);for(c=0;5>c;c+=1)for(k=0;5>k;k+=1)b[c][k]=B(m[c][k],new a(~m[(c+1)%5][k].a&m[(c+2)%5][k].a,~m[(c+1)%5][k].b&m[(c+2)%5][k].b));b[0][0]=B(b[0][0],Z[e])}return b}var c,
X,Y,Z;c=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];X=[new a(c[0],3609767458),new a(c[1],602891725),new a(c[2],3964484399),new a(c[3],2173295548),new a(c[4],4081628472),new a(c[5],3053834265),new a(c[6],2937671579),new a(c[7],3664609560),new a(c[8],2734883394),new a(c[9],1164996542),new a(c[10],1323610764),new a(c[11],3590304994),new a(c[12],4068182383),new a(c[13],
991336113),new a(c[14],633803317),new a(c[15],3479774868),new a(c[16],2666613458),new a(c[17],944711139),new a(c[18],2341262773),new a(c[19],2007800933),new a(c[20],1495990901),new a(c[21],1856431235),new a(c[22],3175218132),new a(c[23],2198950837),new a(c[24],3999719339),new a(c[25],766784016),new a(c[26],2566594879),new a(c[27],3203337956),new a(c[28],1034457026),new a(c[29],2466948901),new a(c[30],3758326383),new a(c[31],168717936),new a(c[32],1188179964),new a(c[33],1546045734),new a(c[34],1522805485),
new a(c[35],2643833823),new a(c[36],2343527390),new a(c[37],1014477480),new a(c[38],1206759142),new a(c[39],344077627),new a(c[40],1290863460),new a(c[41],3158454273),new a(c[42],3505952657),new a(c[43],106217008),new a(c[44],3606008344),new a(c[45],1432725776),new a(c[46],1467031594),new a(c[47],851169720),new a(c[48],3100823752),new a(c[49],1363258195),new a(c[50],3750685593),new a(c[51],3785050280),new a(c[52],3318307427),new a(c[53],3812723403),new a(c[54],2003034995),new a(c[55],3602036899),
new a(c[56],1575990012),new a(c[57],1125592928),new a(c[58],2716904306),new a(c[59],442776044),new a(c[60],593698344),new a(c[61],3733110249),new a(c[62],2999351573),new a(c[63],3815920427),new a(3391569614,3928383900),new a(3515267271,566280711),new a(3940187606,3454069534),new a(4118630271,4000239992),new a(116418474,1914138554),new a(174292421,2731055270),new a(289380356,3203993006),new a(460393269,320620315),new a(685471733,587496836),new a(852142971,1086792851),new a(1017036298,365543100),new a(1126000580,
2618297676),new a(1288033470,3409855158),new a(1501505948,4234509866),new a(1607167915,987167468),new a(1816402316,1246189591)];Z=[new a(0,1),new a(0,32898),new a(2147483648,32906),new a(2147483648,2147516416),new a(0,32907),new a(0,2147483649),new a(2147483648,2147516545),new a(2147483648,32777),new a(0,138),new a(0,136),new a(0,2147516425),new a(0,2147483658),new a(0,2147516555),new a(2147483648,139),new a(2147483648,32905),new a(2147483648,32771),new a(2147483648,32770),new a(2147483648,128),new a(0,
32778),new a(2147483648,2147483658),new a(2147483648,2147516545),new a(2147483648,32896),new a(0,2147483649),new a(2147483648,2147516424)];Y=[[0,36,3,41,18],[1,44,10,45,2],[62,6,43,15,61],[28,55,25,21,56],[27,20,39,8,14]]; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return C}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof exports?("undefined"!==typeof module&&module.exports&&(module.exports=C),exports=C):aa.jsSHA=C})(this);


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(74);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _dishHelper = __webpack_require__(43);

var _orderHelper = __webpack_require__(118);

var _const = __webpack_require__(14);

var _common = __webpack_require__(431);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  多种优惠劵优惠计算
 */

function initRealPrice(orderedDishes, calcPriv) {
  var realPrices = {};

  orderedDishes.forEach(function (dish) {
    var id = dish.id;

    realPrices[id] = Math.max((0, _dishHelper.getDishPrice)(dish) - calcPriv(dish), 0);
  });

  return realPrices;
}

function distributeBasePrices(_ref) {
  var activityBenefit = _ref.activityBenefit,
      activityBenefitNum = _ref.activityBenefitNum,
      marketPrice = _ref.marketPrice,
      count = _ref.count;

  var realBasePrices = Array.apply(null, { length: count }).map(function (item) {
    return marketPrice;
  });

  if (activityBenefit <= 0) {
    return realBasePrices;
  }

  var privAmount = activityBenefit / activityBenefitNum;
  var i = 0;
  while (i < activityBenefitNum) {
    realBasePrices[i] = Math.max(marketPrice - privAmount, 0);
    i++;
  }

  return realBasePrices;
}

function calcRealBasePricesWhenMulitPriv(dishes, multiPrivilegePrices) {
  var ret = {};

  dishes.forEach(function (dish) {
    var id = dish.id,
        marketPrice = dish.marketPrice;

    var count = (0, _dishHelper.getDishesCount)([dish]);

    var _ref2 = multiPrivilegePrices[id] || { prices: [] },
        prices = _ref2.prices;

    var activityBenefitNum = count;
    var activityBenefit = 0;

    if (prices.length) {
      activityBenefit = prices.reduce(function (acc, cur) {
        return acc + cur;
      }, 0);
    }

    ret[id] = distributeBasePrices({ count: count, marketPrice: marketPrice, activityBenefit: activityBenefit, activityBenefitNum: activityBenefitNum });
  });

  return ret;
}

function calcRealBasePricesWhenSinglePriv(dishes, discountProps) {
  var ret = {};

  var distributeBasePricesWhenSinglePriv = function distributeBasePricesWhenSinglePriv(dish) {
    var order = dish.order,
        marketPrice = dish.marketPrice;


    if (Array.isArray(order)) {
      return order.reduce(function (arr, cur) {
        arr = arr.concat(distributeBasePrices((0, _extends3.default)({}, cur, { marketPrice: marketPrice })));
        return arr;
      }, []).asMutable({ deep: true });
    }

    return distributeBasePrices((0, _extends3.default)({}, dish, { count: order }));
  };

  var distributeBasePricesWhenMemberPrice = function distributeBasePricesWhenMemberPrice(dish) {
    var marketPrice = dish.marketPrice;
    var discountList = discountProps.discountList,
        discountType = discountProps.discountType,
        discount = discountProps.discount;

    var count = (0, _dishHelper.getDishesCount)([dish]);
    var dishDiscount = discountList.find(function (item) {
      return item.dishId === dish.id;
    });
    var discountValue = discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT ? discount : (dishDiscount || {}).value;
    var basePrice = marketPrice;
    var memberPriceStr = discountValue !== null && discountValue !== undefined ? discountValue.toString() : null; // 消除memberPrice为0的影响
    // if (discountValue) {
    if (memberPriceStr) {
      basePrice = discountType === _const.MemberPrivTypes.DISCOUNT || discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT ? marketPrice * discountValue / 10 : discountType === 2 ? marketPrice - discountValue : marketPrice;
    }
    return Array.apply(null, { length: count }).map(function () {
      return basePrice;
    });
  };

  dishes.forEach(function (dish) {
    var id = dish.id,
        noUseDiscount = dish.noUseDiscount,
        isMember = dish.isMember;

    var isSupportMemberPrice = isMember && !noUseDiscount;

    ret[id] = isSupportMemberPrice ? distributeBasePricesWhenMemberPrice(dish) : distributeBasePricesWhenSinglePriv(dish);
  });

  return ret;
}

function initRealPriceDiffMultiPriv(orderedDishes, multiPrivilegePrices) {
  var realPrices = initRealPrice(orderedDishes, function (dish) {
    var _ref3 = multiPrivilegePrices[dish.id] || { prices: [] },
        prices = _ref3.prices;

    return prices.reduce(function (acc, cur) {
      return acc + cur;
    }, 0);
  });

  return {
    realPrices: realPrices,
    realBasePrices: calcRealBasePricesWhenMulitPriv(orderedDishes, multiPrivilegePrices)
  };
}

function initRealPriceDiffSinglePriv(orderedDishes, serviceProps) {
  var realPrices = initRealPrice(orderedDishes, function (dish) {
    return (0, _orderHelper.getDishBenefitPrice)(dish, serviceProps);
  });

  return {
    realPrices: realPrices,
    realBasePrices: calcRealBasePricesWhenSinglePriv(orderedDishes, serviceProps.discountProps)
  };
}

function getCouponValue(coupon, key) {
  var coupRuleBeanList = coupon.coupRuleBeanList,
      weixinValue = coupon.weixinValue;

  if (weixinValue) {
    return +weixinValue || 0;
  }

  var currentCoupon = coupRuleBeanList.filter(function (couponDetaile) {
    return couponDetaile.ruleName === key;
  })[0];

  return Number(currentCoupon && currentCoupon.ruleValue) || 0;
}

function totalRealPrices(realPrices) {
  return (0, _keys2.default)(realPrices).reduce(function (acc, key) {
    return acc + realPrices[key];
  }, 0);
}

function mergeCouponPrivilegePrices(masterPrices, prices) {
  var ret = (0, _extends3.default)({}, masterPrices);

  (0, _keys2.default)(prices).forEach(function (key) {
    ret[key] = (ret[key] || []).concat(prices[key]);
  });

  return ret;
}

var couponPriv = {
  getCalcOption: function getCalcOption(coupon, serviceProps) {
    var _options;

    var privateRoom = serviceProps.couponsProps.privateRoom;
    var coupDishBeanList = coupon.coupDishBeanList;


    var options = (_options = {}, (0, _defineProperty3.default)(_options, _const.CouponTypes.ZKVALUE, {
      ruleName: 'zkValue',
      calcExpression: function calcExpression(_ref4) {
        var price = _ref4.price,
            value = _ref4.value;
        return price * (1 - value / 10);
      }
    }), (0, _defineProperty3.default)(_options, _const.CouponTypes.OFFERVALUE, {
      ruleName: 'offerValue',
      calcExpression: function calcExpression(_ref5) {
        var price = _ref5.price,
            value = _ref5.value,
            total = _ref5.total;
        return Math.min(value * (price / total), price);
      }
    }), (0, _defineProperty3.default)(_options, _const.CouponTypes.FACEVALUE, {
      ruleName: 'faceValue',
      calcExpression: function calcExpression(_ref6) {
        var price = _ref6.price,
            value = _ref6.value,
            total = _ref6.total;
        return Math.min(value * (price / total), price);
      }
    }), (0, _defineProperty3.default)(_options, _const.CouponTypes.GIFTVALUE, {
      ruleName: 'giftName',
      calcExpression: function calcExpression(_ref7) {
        var dish = _ref7.dish,
            currentBasePrices = _ref7.currentBasePrices;

        if (privateRoom || !coupDishBeanList.length || !currentBasePrices.length) {
          return 0;
        }

        var _coupDishBeanList = (0, _slicedToArray3.default)(coupDishBeanList, 1),
            firstCouponDish = _coupDishBeanList[0];

        if (dish.brandDishId !== firstCouponDish.dishId) {
          return 0;
        }

        var price = 0;
        while (!price && currentBasePrices.length) {
          price = currentBasePrices.shift();
        }

        return price;
      }
    }), _options);

    var ret = options[coupon.couponType];
    if (privateRoom) {
      ret.couponValue = coupon.faceValue || 0;
    }

    return ret;
  },
  calc: function calc(_ref8) {
    var coupon = _ref8.coupon,
        subRealPrices = _ref8.subRealPrices,
        serviceProps = _ref8.serviceProps,
        dishes = _ref8.dishes,
        realBasePrices = _ref8.realBasePrices;

    var ret = {};

    var _getCalcOption = this.getCalcOption(coupon, serviceProps),
        ruleName = _getCalcOption.ruleName,
        calcExpression = _getCalcOption.calcExpression,
        couponValue = _getCalcOption.couponValue;

    var value = couponValue != null ? couponValue : getCouponValue(coupon, ruleName);
    var total = totalRealPrices(subRealPrices) || 1;

    (0, _keys2.default)(subRealPrices).forEach(function (id) {
      var realPrice = subRealPrices[id] || 0;
      var currentBasePrices = realBasePrices[id] || [];
      var dish = dishes.filter(function (item) {
        return item.id === id;
      })[0];
      var subtraction = ret[id] = calcExpression({
        price: realPrice,
        value: value,
        total: total,
        dish: dish,
        currentBasePrices: currentBasePrices
      });

      subRealPrices[id] = Math.max(realPrice - subtraction, 0);
    });
    return ret;
  }
};

function initRealPrices(orderedDishes, serviceProps) {
  var wholeOrderBenefit = serviceProps.wholeOrderBenefit;
  var multiPrivilegePrices = serviceProps.activityBenefit.privilegePrices;

  var isMultiPrivilege = wholeOrderBenefit && wholeOrderBenefit.isChecked;

  return isMultiPrivilege ? initRealPriceDiffMultiPriv(orderedDishes, multiPrivilegePrices) : initRealPriceDiffSinglePriv(orderedDishes, serviceProps);
}

exports.default = {
  /**
   * 排序规则 菜品礼品券<部分可用优惠券<全部可用优惠券
   */
  sortCoupons: function sortCoupons(coupons) {
    var dishGiftCoupons = [];
    var others = [];

    coupons.forEach(function (coupon) {
      if ((0, _orderHelper.isDishGiftCoupon)(coupon)) {
        dishGiftCoupons.push(coupon);
      } else {
        others.push(coupon);
      }
    });

    var unlimitCoupons = [];
    var limitCoupons = [];

    others.forEach(function (coupon) {
      if (coupon.dishConditionType === _const.CouponUseTypes.ALL) {
        unlimitCoupons.push(coupon);
      } else {
        limitCoupons.push(coupon);
      }
    });

    return [].concat(dishGiftCoupons, limitCoupons, unlimitCoupons);
  },


  /**
   * 获取菜品礼品券和菜品的关联
   * @param {Array} orderedDishes
   * @param {Object} serviceProps
   */
  getGiftCouponToDishRelations: function getGiftCouponToDishRelations(orderedDishes, serviceProps) {
    var result = {};
    var coupons = serviceProps.couponsProps.currentCouponsDetail;


    if (!coupons.length || !orderedDishes.length) {
      return result;
    }

    var giftCoupons = coupons.filter(function (coupon) {
      return (0, _orderHelper.isDishGiftCoupon)(coupon);
    });
    if (!giftCoupons.length) {
      return result;
    }

    var _initRealPrices = initRealPrices(orderedDishes, serviceProps),
        realBasePrices = _initRealPrices.realBasePrices;

    var distributeCouponIds = function distributeCouponIds(dish, validCouponIds) {
      var id = dish.id,
          order = dish.order;

      var currentBasePrices = realBasePrices[id];
      var couponIds = Array.apply(null, { length: currentBasePrices.length }).map(function (item) {
        return '';
      });

      currentBasePrices.forEach(function (price, i) {
        if (price > 0 && validCouponIds.length) {
          var couponId = validCouponIds.shift();

          couponIds[i] = couponId;
          currentBasePrices[i] = 0;
        }
      });

      if (Array.isArray(order)) {
        var start = 0;

        return order.map(function (orderItem, index) {
          var count = orderItem.count;

          var end = start + count;
          var ids = couponIds.slice(start, end).filter(function (item) {
            return !!item;
          });

          start = end;

          return ids;
        }).asMutable({ deep: true });
      }

      return [couponIds.filter(function (item) {
        return !!item;
      })];
    };

    orderedDishes.forEach(function (dish) {
      var brandDishId = dish.brandDishId;

      var validCouponIds = [];

      giftCoupons.forEach(function (coupon) {
        var _coupon$coupDishBeanL = (0, _slicedToArray3.default)(coupon.coupDishBeanList, 1),
            first = _coupon$coupDishBeanL[0];

        if (first.dishId !== brandDishId) {
          return;
        }

        validCouponIds.push(coupon.id);
      });

      if (validCouponIds.length) {
        result[dish.id] = distributeCouponIds(dish, validCouponIds);
      }
    });

    return result;
  },
  getAfterCouponPrices: function getAfterCouponPrices(orderedDishes, serviceProps) {
    var coupons = serviceProps.couponsProps.currentCouponsDetail;

    if (!orderedDishes.length || !coupons.length) {
      return [];
    }

    var ret = {};

    var _initRealPrices2 = initRealPrices(orderedDishes, serviceProps),
        realPrices = _initRealPrices2.realPrices,
        realBasePrices = _initRealPrices2.realBasePrices;

    this.sortCoupons(coupons.asMutable({ deep: true })).forEach(function (coupon) {
      var dishes = (0, _common.getCanUsePrivDishes)(orderedDishes, coupon);
      if (!dishes.length) {
        return;
      }

      var subRealPrices = dishes.reduce(function (obj, dish) {
        obj[dish.id] = realPrices[dish.id];
        return obj;
      }, {}).asMutable();
      var couponPrivilegePrices = couponPriv.calc({
        subRealPrices: subRealPrices,
        coupon: coupon,
        serviceProps: serviceProps,
        dishes: dishes,
        realBasePrices: realBasePrices
      });

      (0, _assign2.default)(realPrices, subRealPrices);
      ret = mergeCouponPrivilegePrices(ret, couponPrivilegePrices);
    });

    return ret;
  },
  calc: function calc(orderedDishes, serviceProps) {
    // 计算优惠金额
    var ret = this.getAfterCouponPrices(orderedDishes, serviceProps);

    return (0, _keys2.default)(ret).reduce(function (acc, key) {
      return acc + ret[key].reduce(function (sum, cur) {
        return sum + cur;
      }, 0);
    }, 0);
  },
  getRealPrices: function getRealPrices(orderedDishes, serviceProps) {
    return initRealPrices(orderedDishes, serviceProps);
  }
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCanUsePrivDishes = getCanUsePrivDishes;

var _const = __webpack_require__(14);

/**
 *
 * @param {Array} orderedDishes 菜品列表
 * @param {Object} priv 优惠劵|优惠规则
 * @param {String} typeName
 */
function getCanUsePrivDishes(orderedDishes, priv) {
  var typeName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dishConditionType';

  if (!priv || !orderedDishes || !orderedDishes.length) {
    return [];
  }

  var dishList = priv.dishList,
      dishConditionType = priv[typeName];

  if (dishConditionType === _const.CouponUseTypes.ALL) {
    return orderedDishes;
  }

  var operedDishes = dishList.reduce(function (acc, cur) {
    return [cur.dishId].concat((cur.dishList || []).map(function (item) {
      return item.dishId;
    })).filter(function (id) {
      return !!id;
    }).reduce(function (obj, key) {
      obj[key] = true;
      return obj;
    }, acc);
  }, {});

  var part = dishConditionType === _const.CouponUseTypes.PART;
  return orderedDishes.filter(function (dish) {
    return !!operedDishes[dish.brandDishId] === part;
  });
}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 433 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

__webpack_require__(72);

__webpack_require__(71);

var _reduxActions = __webpack_require__(265);

var _config = __webpack_require__(13);

var config = _interopRequireWildcard(_config);

var _commonHelper = __webpack_require__(3);

var _commonHelper2 = _interopRequireDefault(_commonHelper);

var _orderHelper = __webpack_require__(118);

var _commonActionType = __webpack_require__(417);

var _commonActionType2 = _interopRequireDefault(_commonActionType);

var _orderActionType = __webpack_require__(447);

var _orderActionType2 = _interopRequireDefault(_orderActionType);

var _orderListActionType = __webpack_require__(448);

var _orderListActionType2 = _interopRequireDefault(_orderListActionType);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

var _md = __webpack_require__(428);

var _md2 = _interopRequireDefault(_md);

var _helper = __webpack_require__(16);

var _part = __webpack_require__(412);

var _part2 = _interopRequireDefault(_part);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var orderedCoupon = _commonHelper2.default.getUrlParam('orderId');
var fromPay = _commonHelper2.default.getUrlParam('fromPay');

// 提示信息
var setErrorMsg = exports.setErrorMsg = (0, _reduxActions.createAction)(_commonActionType2.default.SET_ERROR_MSG, function (error) {
  return error;
});
// 时间戳
var setTimestamp = exports.setTimestamp = (0, _reduxActions.createAction)('SET_TIMESTAMP', function (timestamp) {
  return timestamp;
});
// 加载时提示信息
var setLoadMsg = exports.setLoadMsg = (0, _reduxActions.createAction)(_commonActionType2.default.SET_LOAD_MSG, function (loadinfo) {
  return loadinfo;
});
// 获取桌台信息
var setTableList = exports.setTableList = (0, _reduxActions.createAction)('SET_TABLE_LIST', function (tablelist) {
  return tablelist;
});
// hash
exports.setChildView = (0, _reduxActions.createAction)('SET_CHILDVIEW', function (viewHash) {
  return viewHash;
});
// dishMenuStatus
var setServiceStatus = exports.setServiceStatus = (0, _reduxActions.createAction)('SET_SERVICE_STATUS', function (serviceStatus) {
  return serviceStatus;
});

var shopId = _commonHelper2.default.getUrlParam('shopId');

// 发送验证码参数
var getSendCodeParamStr = __webpack_require__(424).getSendCodeParamStr;

// 获取个人基本信息
var setUserInfo = exports.setUserInfo = (0, _reduxActions.createAction)('SET_USER_INFO', function (userinfo) {
  return userinfo;
});

// 将url参数整合成字符串
var formatObjToParamStr = _commonHelper2.default.formatObjToParamStr;
// post、form方式提交数据
var getFetchPostParam = _commonHelper2.default.getFetchPostParam;

// 设置微信信息
var setWXInfo = exports.setWXInfo = (0, _reduxActions.createAction)('SET_WX_INFO', function (wxInfo) {
  return wxInfo;
});

// 设置支付宝信息
var setAlipayInfo = exports.setAlipayInfo = (0, _reduxActions.createAction)('SET_ALIPAY_INFO', function (alipayInfo) {
  return alipayInfo;
});

// 控制菜品描述详情的显示和隐藏
var setDishDescPopup = exports.setDishDescPopup = (0, _reduxActions.createAction)('TOGGLE_DISH_DESC', function (dishDesc) {
  return dishDesc;
});

// 控制菜品选项的显示和隐藏
var setDishDetailPopup = exports.setDishDetailPopup = (0, _reduxActions.createAction)('TOGGLE_DISH_DETAIL', function (dishDetail) {
  return dishDetail;
});

// 控制优惠券选择张数
var setMaxCouponNum = (0, _reduxActions.createAction)(_orderActionType2.default.SET_MAX_COUPONS_NUM, function (prop) {
  return prop;
});

var setBrandInfo = exports.setBrandCustomConfig = (0, _reduxActions.createAction)(_commonActionType2.default.SET_BRAND_INFO, function (brandInfo) {
  return brandInfo;
});

// 订单中心业务开关接口
var setSupportBusinessTypes = (0, _reduxActions.createAction)(_orderListActionType2.default.SET_SUPPORT_BUSINESS_TYPES, function (supportbusinesstypes) {
  return supportbusinesstypes;
});

var setReceivedCouponsInfo = (0, _reduxActions.createAction)(_commonActionType2.default.SET_RECEIVED_COUPONS_INFO, function (couponList) {
  return couponList;
});

var changeActivePurchaseBenefit = (0, _reduxActions.createAction)(_orderActionType2.default.CHANGE_ACTIVE_PURCHASE_BENEFIT, function (changeactivepurchasebenefit) {
  return changeactivepurchasebenefit;
});

var confirmChosenPurchaseBenefit = (0, _reduxActions.createAction)(_orderActionType2.default.CONFIRM_CHOSEN_PURCHASE_BENEFIT, function (purchaseBenefitId) {
  return purchaseBenefitId;
});

var sameCountWithOrderPurchaseBenefit = (0, _reduxActions.createAction)(_orderActionType2.default.SAME_COUNT_WITH_ORDER_PURCHASE_BENEFIT, function (purchaseBenefitId) {
  return purchaseBenefitId;
});

exports.toggleSelectorCheckedStatus = (0, _reduxActions.createAction)('TOGGLE_SELECTOR_CHECKED_SATUS', function (selectorCheckedStatus) {
  return selectorCheckedStatus;
});

// 设置最低消费
var setMinConsume = (0, _reduxActions.createAction)('SET_SHOP_MIN_CONSUME', function (params) {
  return params;
});

// 菜品描述详情详情的显示和隐藏
exports.toggleDishDescPopup = function (dishData) {
  return function (dispatch) {
    if (dishData && location.hash === '#dish-desc') {
      dispatch(setDishDescPopup(dishData));
      return;
    }

    dispatch(setDishDescPopup(undefined));
  };
};

// 菜品选项的显示和隐藏
exports.toggleDishDetailPopup = function (dishData) {
  return function (dispatch) {
    if (dishData) {
      dispatch(setDishDetailPopup(dishData));
      return;
    }

    dispatch(setDishDetailPopup(undefined));
  };
};

// 发送验证码
exports.sendCode = function (phoneNum, nationTelCode, callBack) {
  return function (dispatch, getStates) {
    var codeObj = (0, _assign2.default)({}, { shopId: shopId, mobile: phoneNum, nationTelCode: nationTelCode, timestamp: new Date().getTime() });
    var paramStr = getSendCodeParamStr(codeObj);
    var sendCodeURl = config.sendCodeAPI + '?' + paramStr;
    _fetchHelper2.default.get(sendCodeURl, null, { enableDefaultResponseResolve: false }).then(function () {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var res = response.data;
      if (res.code === '200') {
        dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actionsendVerifyCodeSuccess)));
        dispatch(setTimestamp(res.data.timeStamp));
        if (callBack) {
          callBack();
        }
      } else if (res.code === '10100') {
        dispatch(setErrorMsg(res.msg));
        setTimeout(function () {
          return location.reload(true);
        }, 1500);
      } else {
        dispatch(setErrorMsg(res.msg));
      }
    });
  };
};

// 获取个人信息资料
exports.getUserInfo = function (id) {
  return function (dispatch, getStates) {
    dispatch(setLoadMsg({ status: true, word: (0, _helper.formatMessage)(_part2.default.actionLoading) }));
    if (!shopId) {
      dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actioncannotFindShopId)));
      return;
    }
    fetch(config.individualAPI + '?shopId=' + shopId, config.requestOptions).then(function (res) {
      if (!res.ok) {
        dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actiongetPersonalInfoFailed)));
      }
      return res.json();
    }).then(function (basicData) {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (basicData.code !== '200') {
        dispatch(setErrorMsg(basicData.msg));
        setTimeout(function () {
          if (basicData.code === 'NOT_LOGIN') {
            location.href = config.logUrl + '?shopId=' + shopId + '&returnUrl=' + encodeURIComponent(window.location.pathname + window.location.search);
          }
        }, 1500);
        return;
      }
      // console.log(basicData.data);
      dispatch(setUserInfo(basicData.data));
    }).catch(function (err) {
      console.info(err);
    });
  };
};

// 校验手机绑定验证码
exports.checkBindCode = function (phoneInfo, vipCallBack, successCallBack, boundCallBack) {
  return function (dispatch, getStates) {
    dispatch(setLoadMsg({ status: true, word: (0, _helper.formatMessage)(_part2.default.actionVerifying) }));
    var timestamp = getStates().timestamp || new Date().getTime();
    var paramStr = formatObjToParamStr(phoneInfo);
    var validBindMobileURL = config.validBindMobileAPI + '?shopId=' + shopId + '&timeStamp=' + timestamp + '&' + paramStr;

    _fetchHelper2.default.get(validBindMobileURL, null, { enableDefaultResponseResolve: false }).then(function () {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var res = response.data;
      if (res.code === '200') {
        if (res.data.vip) {
          // 是会员
          vipCallBack();
        } else {
          // 验证成功
          successCallBack();
        }
        dispatch(setLoadMsg({ status: false, word: '' }));
      } else if (res.code === '11005') {
        // 该手机已于其他微信号绑定
        boundCallBack();
        dispatch(setLoadMsg({ status: false, word: '' }));
      } else {
        dispatch(setErrorMsg(res.msg));
        dispatch(setLoadMsg({ status: false, word: '' }));
      }
    });
  };
};

// 绑定手机
exports.bindPhone = function (phoneInfo, successCallBack) {
  return function (dispatch) {
    var phoneNum = phoneInfo.phoneNum;
    var tradePassword = phoneInfo.password;
    var bindPhoneURL = config.bindPhoneAPI + '?shopId=' + shopId;
    var nationTelCode = sessionStorage.getItem('nationTelCode');

    var param = {
      shopId: shopId,
      mobile: phoneNum,
      nationTelCode: nationTelCode
    };
    if (tradePassword) {
      // 如果有交易密码
      (0, _assign2.default)(param, { tradePassword: (0, _md2.default)(tradePassword).toUpperCase() });
    }
    var requestOptions = (0, _assign2.default)({}, config.requestOptions);
    requestOptions.method = 'POST';
    requestOptions.body = (0, _stringify2.default)(param);
    _fetchHelper2.default.post(bindPhoneURL, param, { enableDefaultResponseResolve: false }).then(function () {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var res = response.data;
      if (res.code === '200') {
        successCallBack(res.data);
      } else if (res.code === '11006') {
        // 自有公众号和客如云公众号数据合并
        var needDataRecovery = true;
        successCallBack({}, needDataRecovery);
        dispatch(setLoadMsg({ status: false, word: '' }));
      } else {
        dispatch(setLoadMsg({ status: false, word: '' }));
        dispatch(setErrorMsg(res.msg));
      }
    });
  };
};

// 绑定第三方应用信息
var handleThirdPartyBinding = function handleThirdPartyBinding(bindUrl, errorMsg, dispatch, callback) {
  fetch(bindUrl, config.requestOptions).then(function (res) {
    if (!res.ok) {
      dispatch(setErrorMsg(errorMsg));
    }
    return res.json();
  }).then(function (result) {
    if (result.code === '200') {
      callback();
    } else {
      dispatch(setErrorMsg(result.msg));
    }
  });
};

// 绑定微信
exports.bindWX = function (phoneInfo) {
  return function (dispatch) {
    var _ref = phoneInfo || {},
        phoneNum = _ref.phoneNum;

    var mobile = phoneNum || phoneInfo || ''; // 兼容phoneInfo 为phoneNum情况
    var bindWXURL = config.bindWXAPI + '?shopId=' + shopId + '&mobile=' + mobile;
    var errorMsg = (0, _helper.formatMessage)(_part2.default.actionbindWXFailed);

    handleThirdPartyBinding(bindWXURL, errorMsg, dispatch, function () {
      location.hash = '#wx-success';
    });
  };
};

// 绑定支付宝
exports.bindAlipay = function (phoneNum) {
  return function (dispatch) {
    var bindAlipayUrl = config.bindAlipayAPI + '?shopId=' + shopId + '&mobile=' + phoneNum;
    var errorMsg = (0, _helper.formatMessage)(_part2.default.actionbindAlipayFailed);
    handleThirdPartyBinding(bindAlipayUrl, errorMsg, dispatch, function () {
      location.hash = '#alipay-success';
    });
  };
};

// 激活会员卡流程中的绑定微信流程
exports.activateCardWithWX = function (phoneInfo, callback) {
  return function (dispatch) {
    var _ref2 = phoneInfo || {},
        phoneNum = _ref2.phoneNum;

    var mobile = phoneNum || phoneInfo || ''; // 兼容phoneInfo 为phoneNum情况
    var bindWXURL = config.bindWXAPI + '?shopId=' + shopId + '&mobile=' + mobile;
    var errorMsg = (0, _helper.formatMessage)(_part2.default.actionactivateVipFailed);

    handleThirdPartyBinding(bindWXURL, errorMsg, dispatch, callback);
  };
};

// 获取第三方应用信息
var fetchThirdPartyInfo = function fetchThirdPartyInfo(url, dispatch, callback) {
  fetch(url, config.requestOptions).then(function (res) {
    if (!res.ok) {
      dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actioninfoGetFailed)));
    }
    return res.json();
  }).then(function (result) {
    if (result.code === '200') {
      callback(result.data);
    } else {
      dispatch(setErrorMsg(result.msg));
    }
  });
};

// 获取微信用户信息
exports.getWXInfo = function () {
  return function (dispatch) {
    var url = config.getWXInfoAPI + '?shopId=' + shopId;
    fetchThirdPartyInfo(url, dispatch, function (data) {
      var headImg = data.headUrl;
      var wxName = data.name;
      var wxInfo = {
        headUrl: headImg,
        name: wxName,
        shopIdWX: shopId
      };
      dispatch(setWXInfo(wxInfo));
    });
  };
};

// 获取支付宝用户信息
exports.getAlipayInfo = function () {
  return function (dispatch) {
    var url = config.getAlipayInfoAPI + '?shopId=' + shopId;
    fetchThirdPartyInfo(url, dispatch, function (data) {
      var headImg = data.headUrl;
      var alipayName = data.name;
      var alipayInfo = {
        headUrl: headImg,
        name: alipayName,
        shopIdAlipay: shopId
      };
      dispatch(setAlipayInfo(alipayInfo));
    });
  };
};

// 用户退出
exports.logout = function (successCallBack, faildCallBack) {
  return function () {
    var logoutURL = config.logoutAPI + '?shopId=' + shopId;
    fetch(logoutURL, config.requestOptions).then(function (res) {
      if (!res.ok) {
        faildCallBack();
      }
      return res.json();
    }).then(function (res) {
      if (res.code === '200') {
        successCallBack();
      } else {
        faildCallBack();
      }
    });
  };
};

// 获取第三方账号的绑定状态
exports.getThirdPartyBindingStatus = function () {
  return function (dispatch) {
    dispatch(setLoadMsg({ status: true, word: (0, _helper.formatMessage)(_part2.default.actionLoading) }));
    if (!shopId) {
      dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actioncannotFindShopId)));
      return;
    }
    fetch(config.individualAPI + '?shopId=' + shopId, config.requestOptions).then(function (res) {
      if (!res.ok) {
        dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actionrequestFailed)));
      }
      return res.json();
    }).then(function (basicData) {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (basicData.code === '200') {
        var data = basicData.data;

        if (data.loginType === 1 && data.bindMobile) {
          // 保存电话号码到sessionStorage
          sessionStorage.mobile = data.mobile;
          location.hash = '#phone-success';
        } else if (data.loginType === 0 && data.bindWx) {
          location.hash = '#wx-success';
        } else if (data.loginType === 4 && data.bindAlipay) {
          location.hash = '#alipay-success';
        }
      }
    }).catch(function (err) {
      console.info(err);
    });
  };
};

// 评分
exports.saveMarkRecord = function (scoreInfo, successCallBack, faildCallBack) {
  return function (dispatch) {
    dispatch(setLoadMsg({ status: true, word: (0, _helper.formatMessage)(_part2.default.actionLoading) }));
    var saveMarkRecordURL = config.saveMarkRecordAPI + '?shopId=' + shopId;
    scoreInfo.shopId = shopId;
    fetch(saveMarkRecordURL, getFetchPostParam(scoreInfo)).then(function (res) {
      if (!res.ok) {
        dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actiongradeFailed)));
      }
      return res.json();
    }).then(function (res) {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (res.code === '200') {
        successCallBack(res.data);
      } else {
        faildCallBack(res.code, res.msg);
      }
    }).catch(function (err) {
      dispatch(setLoadMsg({ status: false, word: '' }));
      console.info(err);
    });
  };
};

// 扫码转化url为正常逻辑下的带有tableId和tabkeKey的url
exports.switchUrlBeforeGetServiceStatus = function (url) {
  return function (dispatch) {
    if (url.indexOf('z.keruyun.com') === -1) {
      return new _promise2.default(function (resolve) {
        resolve(url);
      });
    }

    var str = url.split('?')[0];
    var index = str.lastIndexOf('/');
    str = str.substring(index + 1, str.length);

    return fetch(config.switchUrlBeforeGetServiceStatusAPI + '?shopId=' + shopId + '&shortlink=' + str, config.requestOptions).then(function (res) {
      if (!res.ok) {
        dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actionchangeUrlFailed)));
      }
      return res.json();
    }).then(function (res) {
      if (res.code !== '200') {
        return null;
      }

      return res.data;
    }).catch(function (err) {
      console.log(err.message);
    });
  };
};

// 获取dishMenu各种状态
exports.getServiceStatus = function (tableInfo) {
  return function (dispatch) {
    var _ref3 = tableInfo || {},
        tableId = _ref3.tableId,
        tableKey = _ref3.tableKey,
        orderId = _ref3.orderId;

    var tableInfoStr = '';
    if (tableId || tableKey) {
      var tableStr = tableId ? 'tableId' : 'tableKey';
      tableInfoStr += '&' + tableStr + '=' + (tableId || tableKey);
    }
    if (orderId) {
      tableInfoStr += '&orderId=' + orderId;
    }
    var getDishMenuStatusUrl = config.getServiceStatusNoTableAPI + '?shopId=' + shopId + tableInfoStr;

    return _fetchHelper2.default.get(getDishMenuStatusUrl, null, { enableDefaultResponseResolve: false }).then(function () {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var res = response.data;
      if (res.code === '200') {
        dispatch(setServiceStatus(res.data));
        return res.data;
      }
      return { errCode: res.code, errMsg: res.msg };
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setErrorMsg(err.msg || (0, _helper.formatMessage)(_part2.default.actiongetTableInfoFailed)));
    });
  };
};

// 获取 tableList 可用桌台
exports.getTableList = function () {
  return function (dispatch) {
    var orderDineInTableListURL = config.orderDineInTableListAPI + '?shopId=' + shopId;

    return fetch(orderDineInTableListURL, config.requestOptions).then(function (res) {
      if (!res.ok) {
        dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actiongetUseableTableFailed)));
      }
      return res.json();
    }).then(function (res) {
      if (res.code === '200') {
        dispatch(setTableList(res.data));
        return (0, _orderHelper.initializeAreaAdnTableProps)(res.data.areaList);
      }
      return null;
    });
  };
};
// Fintech Ad
exports.getFintechActivity = function (obj, successCallBack) {
  return function (dispatch) {
    var requestOptions = (0, _assign2.default)({}, config.requestOptions);
    requestOptions.method = 'POST';
    requestOptions.body = (0, _stringify2.default)(obj);

    return fetch('https://' + config.getFintechActivity, requestOptions).then(function (res) {
      if (!res.ok) {
        dispatch(setErrorMsg((0, _helper.formatMessage)(_part2.default.actiongetInterfaceFailed)));
      }

      return res.json();
    }).then(function (res) {
      if ((0, _stringify2.default)(res.status) === '1000') {
        return res.content;
      }

      dispatch(setErrorMsg(res.msg));
    });
  };
};

exports.getMaxCouponNum = function () {
  return function (dispatch) {
    _fetchHelper2.default.get(config.getBrandCouponNum, { shopId: shopId }).then(function (res) {
      dispatch(setMaxCouponNum(res));
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setErrorMsg(err.msg));
    });
  };
};

var fetchBrandInfo = exports.fetchBrandInfo = function () {
  return function (dispatch) {
    return _fetchHelper2.default.get(config.brandInfoAPI, { shopId: shopId }).then(function (res) {
      dispatch(setBrandInfo(res));
      return res;
    });
  };
};

// 订单中心业务开关接口
exports.getSupportBusinessTypes = function () {
  return function (dispatch, getStates) {
    _fetchHelper2.default.get(config.supportBusinessTypesAPI, { shopId: shopId }).then(function (res) {
      if (res) {
        dispatch(setSupportBusinessTypes(res));
      }
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setErrorMsg(err.msg || (0, _helper.formatMessage)(_part2.default.actionOrderCenterFailed)));
    });
  };
};

// 修改所选择的加价购的分数
exports.changeActivePurchaseBenefit = function (newCount, chosenActivityDish) {
  return function (dispatch, getStates) {
    dispatch(changeActivePurchaseBenefit({ newCount: newCount, chosenActivityDish: chosenActivityDish }));
  };
};

// 选定加价购菜品
exports.confirmChosenPurchaseBenefit = function (purchaseBenefitId) {
  return function (dispatch, getStates) {
    dispatch(confirmChosenPurchaseBenefit(purchaseBenefitId));
  };
};

// 统一count和order里面的数据
exports.sameCountWithOrderPurchaseBenefit = function (purchaseBenefitId) {
  return function (dispatch, getStates) {
    dispatch(sameCountWithOrderPurchaseBenefit(purchaseBenefitId));
  };
};

// 优惠券多个场景默认展示的请求
exports.getReceivedCouponsInfo = function (_ref4) {
  var consumeType = _ref4.consumeType;
  return function (dispatch, getStates) {
    if (!orderedCoupon && !fromPay) {
      return;
    }

    dispatch(fetchBrandInfo()).then(function (data) {
      if (!data) {
        return;
      }
      var brandId = data.brandId;


      _fetchHelper2.default.post(config.couponReceivedInfoAPI + '?shopId=' + shopId, { shopId: shopId, orderId: orderedCoupon, consumeType: consumeType, brandId: brandId }).then(function (res) {
        if (!res) {
          return;
        }

        dispatch(setReceivedCouponsInfo(res));
      });
    });
  };
};

exports.getMinConsumeConf = function () {
  return function (dispatch) {
    _fetchHelper2.default.get(config.getShopMinConsumeConfAPI + '?shopId=' + shopId).then(function (res) {
      dispatch(setMinConsume(res));
    }).catch(function (err) {
      console.log(err);
    });
  };
};

exports.getPayForGiftCoupon = function (callback) {
  return function () {
    var params = {
      orderId: orderedCoupon,
      commercialId: shopId
    };
    var requestUrl = config.getPayForGiftCoupon + '?orderId=' + orderedCoupon + '&commercialId=' + shopId;
    _fetchHelper2.default.get(requestUrl, params).then(function (res) {
      callback(res);
    }).catch(function (error) {
      console.log(error);
      callback(error);
    });
  };
};
exports.getNowPayForGift = function (callback) {
  return function () {
    var params = {
      orderId: orderedCoupon,
      commercialId: shopId
    };
    var requestUrl = '' + config.getNowPayForGiftCoupon;
    _fetchHelper2.default.post(requestUrl, params).then(function (res) {
      callback(res);
    }).catch(function (error) {
      console.log(error);
      callback(error);
    });
  };
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(437), __esModule: true };

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calcDishForTaxType = exports.calcExciseCharge = exports.calcServiceChargeAll = exports.calcServiceCharge = undefined;

var _const = __webpack_require__(14);

var calcServiceChargeMethod = function calcServiceChargeMethod(_ref) {
  var serviceCharge = _ref.serviceCharge,
      peopleCount = _ref.peopleCount,
      originPrice = _ref.originPrice;
  var calcWay = serviceCharge.calcWay,
      content = serviceCharge.content;

  var prv = 0;

  switch (calcWay) {
    case _const.CalcWay.DISCOUNT:
      // 占总价多少钱
      prv = content / 100 * originPrice;
      break;
    case _const.CalcWay.PEOPLE:
      // 人数
      prv = (peopleCount || 1) * content;
      break;
    case _const.CalcWay.REGULAR:
      // 固定金额
      prv = content;
      break;
    default:
      break;
  }

  return prv;
};

// 服务费计算 整体方法
// 服务费计算
var calcServiceCharge = exports.calcServiceCharge = function calcServiceCharge(_ref2) {
  var serviceCharge = _ref2.serviceCharge,
      beforeAndAfterPriv = _ref2.beforeAndAfterPriv,
      peopleCount = _ref2.peopleCount;

  // 服务费, 优惠前计算
  if (serviceCharge && serviceCharge.beforePrivilegeCalc) {
    beforeAndAfterPriv.beforePrivServiceCharge = calcServiceChargeMethod({
      peopleCount: peopleCount,
      serviceCharge: serviceCharge,
      originPrice: beforeAndAfterPriv.beforePrivTotal
    });
  }

  // 服务费, 优惠后计算
  if (serviceCharge && !serviceCharge.beforePrivilegeCalc) {
    beforeAndAfterPriv.afterPrivServiceCharge = calcServiceChargeMethod({
      peopleCount: peopleCount,
      serviceCharge: serviceCharge,
      originPrice: beforeAndAfterPriv.afterPrivTotal
    });
  }

  return beforeAndAfterPriv;
};

// 服务费计算 整体方法
var calcServiceChargeAll = exports.calcServiceChargeAll = function calcServiceChargeAll(_ref3) {
  var serviceCharge = _ref3.serviceCharge,
      beforeAndAfterPriv = _ref3.beforeAndAfterPriv,
      peopleCount = _ref3.peopleCount;

  // 服务费, 优惠前计算
  // if (serviceCharge && serviceCharge.beforePrivilegeCalc) {
  beforeAndAfterPriv.beforePrivServiceCharge = calcServiceChargeMethod({
    peopleCount: peopleCount,
    serviceCharge: serviceCharge,
    originPrice: beforeAndAfterPriv.beforePrivTotal
  });
  // }

  // 服务费, 优惠后计算
  // if (serviceCharge && !serviceCharge.beforePrivilegeCalc) {
  beforeAndAfterPriv.afterPrivServiceCharge = calcServiceChargeMethod({
    peopleCount: peopleCount,
    serviceCharge: serviceCharge,
    originPrice: beforeAndAfterPriv.afterPrivTotal
  });
  // }

  return beforeAndAfterPriv;
};

// 消费税计算
// 消费税 优惠前 = 菜品总价 + 各种附加费; 优惠后 = 实际支付的钱
var calcExciseTaxChargeMethod = function calcExciseTaxChargeMethod(consumptionTaxDTO, priv) {
  var _consumptionTaxDTO$ta = consumptionTaxDTO.taxRate,
      taxRate = _consumptionTaxDTO$ta === undefined ? 0 : _consumptionTaxDTO$ta,
      effectType = consumptionTaxDTO.effectType;


  if (effectType === _const.EffectType.NOADD) {
    return 0;
  }

  var rate = taxRate / 100;

  return Math.max(priv * rate, 0);
};

var calcExciseCharge = exports.calcExciseCharge = function calcExciseCharge(_ref4) {
  var joinTax = _ref4.joinTax,
      consumptionTaxDTO = _ref4.consumptionTaxDTO,
      beforeAndAfterPriv = _ref4.beforeAndAfterPriv,
      initServiceCharge = _ref4.initServiceCharge,
      lowestConsumptionCharge = _ref4.lowestConsumptionCharge;

  // 消费税, 优惠前
  if (consumptionTaxDTO && consumptionTaxDTO.discountType === _const.EffectDiscountType.BEFORE) {
    // 服务费加入消费税计算
    if (joinTax) {
      beforeAndAfterPriv.beforePrivTotal += initServiceCharge;
    }

    return calcExciseTaxChargeMethod(consumptionTaxDTO, beforeAndAfterPriv.beforePrivTotal + lowestConsumptionCharge);
  }

  // 消费税, 优惠后
  if (consumptionTaxDTO && consumptionTaxDTO.discountType === _const.EffectDiscountType.AFTER) {
    // 服务费加入消费税计算
    if (joinTax) {
      beforeAndAfterPriv.afterPrivTotal += initServiceCharge;
    }

    return calcExciseTaxChargeMethod(consumptionTaxDTO, beforeAndAfterPriv.afterPrivTotal + lowestConsumptionCharge);
  }
};

var calcDishForTaxType = exports.calcDishForTaxType = function calcDishForTaxType(priceForTax, taxes, taxInfo, taxMode) {
  taxes.forEach(function (_ref5) {
    var typeTaxCode = _ref5.typeTaxCode,
        typeTaxName = _ref5.typeTaxName,
        rate = _ref5.rate;

    var taxAmount = taxMode === _const.TAX_MODE.INCLUDE ? priceForTax * (rate / (rate + 100)) : priceForTax * rate / 100;
    if (taxInfo[typeTaxName]) {
      taxInfo[typeTaxName].amount += taxAmount;
    } else {
      taxInfo[typeTaxName] = {
        typeTaxName: typeTaxName,
        typeTaxCode: typeTaxCode,
        amount: taxAmount
      };
    }
  });

  return taxInfo;
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(438);
module.exports = __webpack_require__(1).Object.values;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(8);
var $values = __webpack_require__(439)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var getKeys = __webpack_require__(36);
var toIObject = __webpack_require__(26);
var isEnum = __webpack_require__(42).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 273,
	"./af.js": 273,
	"./ar": 274,
	"./ar-dz": 275,
	"./ar-dz.js": 275,
	"./ar-kw": 276,
	"./ar-kw.js": 276,
	"./ar-ly": 277,
	"./ar-ly.js": 277,
	"./ar-ma": 278,
	"./ar-ma.js": 278,
	"./ar-sa": 279,
	"./ar-sa.js": 279,
	"./ar-tn": 280,
	"./ar-tn.js": 280,
	"./ar.js": 274,
	"./az": 281,
	"./az.js": 281,
	"./be": 282,
	"./be.js": 282,
	"./bg": 283,
	"./bg.js": 283,
	"./bm": 284,
	"./bm.js": 284,
	"./bn": 285,
	"./bn-bd": 286,
	"./bn-bd.js": 286,
	"./bn.js": 285,
	"./bo": 287,
	"./bo.js": 287,
	"./br": 288,
	"./br.js": 288,
	"./bs": 289,
	"./bs.js": 289,
	"./ca": 290,
	"./ca.js": 290,
	"./cs": 291,
	"./cs.js": 291,
	"./cv": 292,
	"./cv.js": 292,
	"./cy": 293,
	"./cy.js": 293,
	"./da": 294,
	"./da.js": 294,
	"./de": 295,
	"./de-at": 296,
	"./de-at.js": 296,
	"./de-ch": 297,
	"./de-ch.js": 297,
	"./de.js": 295,
	"./dv": 298,
	"./dv.js": 298,
	"./el": 299,
	"./el.js": 299,
	"./en-au": 300,
	"./en-au.js": 300,
	"./en-ca": 301,
	"./en-ca.js": 301,
	"./en-gb": 302,
	"./en-gb.js": 302,
	"./en-ie": 303,
	"./en-ie.js": 303,
	"./en-il": 304,
	"./en-il.js": 304,
	"./en-in": 305,
	"./en-in.js": 305,
	"./en-nz": 306,
	"./en-nz.js": 306,
	"./en-sg": 307,
	"./en-sg.js": 307,
	"./eo": 308,
	"./eo.js": 308,
	"./es": 309,
	"./es-do": 310,
	"./es-do.js": 310,
	"./es-mx": 311,
	"./es-mx.js": 311,
	"./es-us": 312,
	"./es-us.js": 312,
	"./es.js": 309,
	"./et": 313,
	"./et.js": 313,
	"./eu": 314,
	"./eu.js": 314,
	"./fa": 315,
	"./fa.js": 315,
	"./fi": 316,
	"./fi.js": 316,
	"./fil": 317,
	"./fil.js": 317,
	"./fo": 318,
	"./fo.js": 318,
	"./fr": 319,
	"./fr-ca": 320,
	"./fr-ca.js": 320,
	"./fr-ch": 321,
	"./fr-ch.js": 321,
	"./fr.js": 319,
	"./fy": 322,
	"./fy.js": 322,
	"./ga": 323,
	"./ga.js": 323,
	"./gd": 324,
	"./gd.js": 324,
	"./gl": 325,
	"./gl.js": 325,
	"./gom-deva": 326,
	"./gom-deva.js": 326,
	"./gom-latn": 327,
	"./gom-latn.js": 327,
	"./gu": 328,
	"./gu.js": 328,
	"./he": 329,
	"./he.js": 329,
	"./hi": 330,
	"./hi.js": 330,
	"./hr": 331,
	"./hr.js": 331,
	"./hu": 332,
	"./hu.js": 332,
	"./hy-am": 333,
	"./hy-am.js": 333,
	"./id": 334,
	"./id.js": 334,
	"./is": 335,
	"./is.js": 335,
	"./it": 336,
	"./it-ch": 337,
	"./it-ch.js": 337,
	"./it.js": 336,
	"./ja": 338,
	"./ja.js": 338,
	"./jv": 339,
	"./jv.js": 339,
	"./ka": 340,
	"./ka.js": 340,
	"./kk": 341,
	"./kk.js": 341,
	"./km": 342,
	"./km.js": 342,
	"./kn": 343,
	"./kn.js": 343,
	"./ko": 344,
	"./ko.js": 344,
	"./ku": 345,
	"./ku.js": 345,
	"./ky": 346,
	"./ky.js": 346,
	"./lb": 347,
	"./lb.js": 347,
	"./lo": 348,
	"./lo.js": 348,
	"./lt": 349,
	"./lt.js": 349,
	"./lv": 350,
	"./lv.js": 350,
	"./me": 351,
	"./me.js": 351,
	"./mi": 352,
	"./mi.js": 352,
	"./mk": 353,
	"./mk.js": 353,
	"./ml": 354,
	"./ml.js": 354,
	"./mn": 355,
	"./mn.js": 355,
	"./mr": 356,
	"./mr.js": 356,
	"./ms": 357,
	"./ms-my": 358,
	"./ms-my.js": 358,
	"./ms.js": 357,
	"./mt": 359,
	"./mt.js": 359,
	"./my": 360,
	"./my.js": 360,
	"./nb": 361,
	"./nb.js": 361,
	"./ne": 362,
	"./ne.js": 362,
	"./nl": 363,
	"./nl-be": 364,
	"./nl-be.js": 364,
	"./nl.js": 363,
	"./nn": 365,
	"./nn.js": 365,
	"./oc-lnc": 366,
	"./oc-lnc.js": 366,
	"./pa-in": 367,
	"./pa-in.js": 367,
	"./pl": 368,
	"./pl.js": 368,
	"./pt": 369,
	"./pt-br": 370,
	"./pt-br.js": 370,
	"./pt.js": 369,
	"./ro": 371,
	"./ro.js": 371,
	"./ru": 372,
	"./ru.js": 372,
	"./sd": 373,
	"./sd.js": 373,
	"./se": 374,
	"./se.js": 374,
	"./si": 375,
	"./si.js": 375,
	"./sk": 376,
	"./sk.js": 376,
	"./sl": 377,
	"./sl.js": 377,
	"./sq": 378,
	"./sq.js": 378,
	"./sr": 379,
	"./sr-cyrl": 380,
	"./sr-cyrl.js": 380,
	"./sr.js": 379,
	"./ss": 381,
	"./ss.js": 381,
	"./sv": 382,
	"./sv.js": 382,
	"./sw": 383,
	"./sw.js": 383,
	"./ta": 384,
	"./ta.js": 384,
	"./te": 385,
	"./te.js": 385,
	"./tet": 386,
	"./tet.js": 386,
	"./tg": 387,
	"./tg.js": 387,
	"./th": 388,
	"./th.js": 388,
	"./tk": 389,
	"./tk.js": 389,
	"./tl-ph": 390,
	"./tl-ph.js": 390,
	"./tlh": 391,
	"./tlh.js": 391,
	"./tr": 392,
	"./tr.js": 392,
	"./tzl": 393,
	"./tzl.js": 393,
	"./tzm": 394,
	"./tzm-latn": 395,
	"./tzm-latn.js": 395,
	"./tzm.js": 394,
	"./ug-cn": 396,
	"./ug-cn.js": 396,
	"./uk": 397,
	"./uk.js": 397,
	"./ur": 398,
	"./ur.js": 398,
	"./uz": 399,
	"./uz-latn": 400,
	"./uz-latn.js": 400,
	"./uz.js": 399,
	"./vi": 401,
	"./vi.js": 401,
	"./x-pseudo": 402,
	"./x-pseudo.js": 402,
	"./yo": 403,
	"./yo.js": 403,
	"./zh-cn": 404,
	"./zh-cn.js": 404,
	"./zh-hk": 405,
	"./zh-hk.js": 405,
	"./zh-mo": 406,
	"./zh-mo.js": 406,
	"./zh-tw": 407,
	"./zh-tw.js": 407
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 加价购相关的值定义
 */

/**
 * planType 加价购_方案类型
 */
var MarkUpPlanType = exports.MarkUpPlanType = {
  FullVolumePromotion: 19, // 满量促销
  FullSalesPromotion: 20, // 满额促销
  BuySendGift: 21, // 买赠活动
  BundledSales: 23 // 捆绑销售
};

/**
 * RuleSubjectId 加价购_营销规则
 */
var RuleSubjectId = exports.RuleSubjectId = {
  FullVolume: 11, // 满量
  FullSales: 12 // 满额
};

/**
 * PolicySubjectId 加价购_营销规则
 */
var PolicySubjectId = exports.PolicySubjectId = {
  SubjectSend: 12, // 赠送商品
  SubjectAdd: 17 // 加价购商品
};

/**
 * 整合之后的四种规则
 */
var PurchaseMethod = exports.PurchaseMethod = {
  FullSalesSend: 1, // 满额赠送
  FullSalesAdd: 2, // 满额加价
  FullVolumeSend: 3, // 满量赠送
  FullVolumeAdd: 4 // 满量加价
};

/**
 * MarkUpRuleLogic 加价购_规则逻辑
 */
var MarkUpRuleLogic = exports.MarkUpRuleLogic = {
  EQ: 1, // 等于
  LTE: 2, // 小于等于
  GTE: 3, // 大于等于
  LT: 7, // 小于
  GT: 8 // 大于
};

/**
 * MarkUpPolicySubjectId 加价购_策略科目类型
 */
var MarkUpPolicySubject = exports.MarkUpPolicySubject = {
  ChangePurchase: 17 // 加价购_策略科目类型_换购
};

/**
 * MarkUpPolicyDetail 加价购_策略细节类型
 */
var MarkUpPolicyDetail = exports.MarkUpPolicyDetail = {
  // 加价购_策略细节类型_加价购商品
  // 171 表示 加价金额：policy_value1, 赠送数量：policy_value2
  // 满量或满额后，加X元，赠送N份赠送商品
  ChangePurchase: 171,

  // 加价购_策略细节类型_赠送商品
  // 121 表示 赠送商品 赠送数量：policy_value1
  // 指定商品满额或满量，赠送指定商品数量N份
  SendPurchase: 121
};

/**
 * MarkUpActivityDishType 加价购_享受活动的商品
 */
var MarkUpActivityDishType = exports.MarkUpActivityDishType = {
  SINGLEDISH: 1, // 单菜品
  MIDDISH: 2 // 中类菜品
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateTag = '[object Date]';
var objectTag = '[object Object]';
var slice = Array.prototype.slice;

function getTag(value) {
  return toString.call(value);
}
function isTypeOf(value, tag) {
  return getTag(value) === tag;
}
function isPlainObject(value) {
  return getTag(value) === objectTag;
}
function toArray(arrayLike, from, to) {
  return slice.call(arrayLike, from, to);
}
function merge(object) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var sources = toArray(args, 0);
  if (sources.length === 0) {
    return object;
  }
  for (var _a = 0, target = sources; _a < target.length; _a++) {
    var source = target[_a];
    if (!isTypeOf(source, objectTag)) {
      continue;
    }
    for (var _b = 0, _c = (0, _keys2.default)(source); _b < _c.length; _b++) {
      var key = _c[_b];
      var value = source[key];
      if (isTypeOf(object[key], objectTag)) {
        object[key] = merge(object[key], value);
      } else {
        object[key] = clone(value);
      }
    }
  }
  return object;
}
/**
 * 克隆
 * @param {T} value
 * @returns {T}
 */
function clone(value) {
  if (value === null) {
    return value;
  }
  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
  if (type === 'number' || type === 'string' || type === 'boolean' || type === 'undefined') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(clone);
  }
  if (isPlainObject(value)) {
    return merge({}, value);
  }
  if (isTypeOf(value, dateTag)) {
    return new Date(value.getTime());
  }
  return value;
}

module.exports = clone;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : (0, _typeof3.default)(global)) == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : (0, _typeof3.default)(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : (0, _typeof3.default)(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : (0, _typeof3.default)(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}();

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var _Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(_keys2.default, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObject(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer: while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = comparator || value !== 0 ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    } else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
  return new Set(values);
};

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
          return seen.add(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
  getTag = function getTag(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function (string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity]
 *  The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return array && array.length ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {}
// No operation performed.


/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = uniqBy;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(268)(module)))

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(72);
__webpack_require__(71);


var config = __webpack_require__(13);
var getUrlParam = __webpack_require__(3).getUrlParam;
var wxClient = __webpack_require__(446);

var wxAuthInfo = null;
var fetchWXAuthInfo = function fetchWXAuthInfo(args) {
  if (wxAuthInfo) {
    return new _promise2.default(function (resolve, reject) {
      resolve(wxAuthInfo);
    });
  }

  var url = encodeURIComponent(location.href.split('#').shift());
  var shopId = getUrlParam('shopId');
  return _fetchHelper2.default.get('' + config.getWXAuthInfoAPI, { shopId: shopId, reqUrl: url }).then(function (result) {
    if (result) {
      // 成功获取数据
      // wxAuthInfo = result.data; 此处不做缓存 每次调用都需要请求jsticket接口 否则操作不成功
      return result;
    }
  }).catch(function (err) {
    wxAuthInfo = null;
    if (args.error) {
      args.error({ errMsg: err.msg });
    }
    throw new Error(err.msg);
  });
};

var callWxClientMethod = function callWxClientMethod(apiName, args) {
  fetchWXAuthInfo(args).then(function (authInfo) {
    if (!authInfo || !authInfo.appid) {
      // 如果没有数据 截止到这里
      return;
    }
    var _wxClient = wxClient((0, _assign2.default)({
      debug: false,
      appId: authInfo.appid,
      timestamp: 0,
      nonceStr: authInfo.noncestr,
      signature: '',
      success: function success(suc) {
        var wx = _wxClient.wx || window.wx;
        if (wx && wx[apiName]) {
          wx[apiName](args);
        }
      },
      error: function error(err) {
        if (args.error) {
          args.error(err);
        }
      },
      jsApiList: [apiName]
    }, authInfo));
  }).catch(function (err) {
    // 兼容处理
    if (args.error) {
      args.error(err);
    }
  });
};

var registerWxClientEvent = function registerWxClientEvent(events, args) {
  fetchWXAuthInfo(args).then(function (authInfo) {
    if (!authInfo || !authInfo.appid) {
      // 如果没有数据 截止到这里
      return;
    }
    var _wxClient = wxClient((0, _assign2.default)({
      debug: false,
      appId: authInfo.appid,
      timestamp: 0,
      nonceStr: authInfo.noncestr,
      signature: '',
      success: function success(suc) {
        var wx = _wxClient.wx || window.wx;
        args.success(wx);
      },
      error: function error(err) {
        if (args.error) {
          args.error(err);
        }
      },
      jsApiList: events
    }, authInfo));
  });
};

// 领取微信卡券 专用
var weixinCard = null;
var fetchWeixinCard = function fetchWeixinCard(args) {
  if (weixinCard) {
    return new _promise2.default(function (resolve, reject) {
      resolve(weixinCard);
    });
  }
  var url = encodeURIComponent(location.href.split('?').shift());
  return fetch(config.getWXCardAPI + '?shopId=' + args.shopId + '&cardId=' + args.cardId + '&reqUrl=' + url, config.requestOptions).then(function (res) {
    if (!res.ok) {
      throw new Error('获取信息失败...');
    }
    return res.json();
  }).then(function (result) {
    return result.data || {};
  }).catch(function (err) {
    weixinCard = {};
    throw new Error(err);
  });
};

// 领取微信卡券 专用
var callWxCardClientMethod = function callWxCardClientMethod(apiName, args) {
  fetchWXAuthInfo(args).then(function (authInfo) {
    fetchWeixinCard(args).then(function (wxCard) {
      var strCardExt = '{"nonce_str":"' + wxCard.noncestr + '","timestamp":"' + wxCard.timestamp + '","signature":"' + wxCard.signature + '"}';
      var _wxClient = wxClient({
        debug: false,
        appId: authInfo.appid,
        timestamp: authInfo.timestamp,
        nonceStr: authInfo.noncestr,
        signature: authInfo.signature,
        jsApiList: [apiName],
        success: function success(suc) {
          if (args.success) {
            args.success();
          }
          var wx = _wxClient.wx || window.wx;
          if (wx[apiName]) {
            wx[apiName]({
              cardList: [{
                cardId: wxCard.cardId,
                cardExt: strCardExt
              }],
              success: function success(data) {
                if (args.success) {
                  args.success(data);
                }
              },
              error: function error(data) {
                if (args.error) {
                  args.error(data);
                }
              }
            });
          }
        },
        error: function error(err) {
          if (args.error) {
            args.error(err);
          }
        }
      });
    }).catch(function (err) {
      args.error(err);
    });
  });
};

exports.callWxClientMethod = function (name, args) {
  return callWxClientMethod(name, args);
};
exports.registerWxClientEvent = function (events, args) {
  return registerWxClientEvent(events, args);
};
exports.callWxCardClientMethod = function (name, args) {
  return callWxCardClientMethod(name, args);
};

/***/ }),
/* 445 */,
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @license MIT
 * client side js to use wechat jssdk,
 * https://github.com/JasonBoy/wechat-jssdk
 */

;!(function(window, document, location) {
  var _script_url = location.protocol + '//res.wx.qq.com/open/js/jweixin-1.0.0.js';
  var defaultApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage'];
  /**
   *
   * @param wechatConfig, should contain like:
   *   {
   *      appId: 'xxxx',
   *      timestamp: '',
   *      nonceStr: '',
   *      signature: '',
   *      jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
   *   }
   * @param cbSuccess {function}
   * @param cbError {function}
   * @param debug {boolean}
   * @param customUrl
   * @returns {WechatJSSDK}
   */
  function WechatJSSDK (wechatConfig, cbSuccess, cbError, debug, customUrl) {
    customUrl && (_script_url = customUrl);
    //using new _wechat_jssdk(config);
    if(this instanceof WechatJSSDK) {
      this.config = wechatConfig;
      var apiList = this.config.jsApiList;
      if(!apiList || apiList.length <= 0) {
        this.config.jsApiList = defaultApiList;
      } else {
        for(var i = 0, length = defaultApiList.length; i < length; i++) {
          var defaultItem = defaultApiList[i];
          if(apiList.indexOf(defaultItem) < 0) {
            apiList.push(defaultItem);
          }
        }
      }
      this.debug = wechatConfig.hasOwnProperty('debug') ? wechatConfig.debug : true === debug;
      if(wechatConfig.success) {
        this.cbSuccess = wechatConfig.success;
        delete wechatConfig.success;
      } else {
        this.cbSuccess = cbSuccess;
      }
      if(wechatConfig.error) {
        this.cbError = wechatConfig.error;
        delete wechatConfig.error;
      } else {
        this.cbError = cbError;
      }
      this.loadScript();
    } else {
      return new WechatJSSDK(wechatConfig, cbSuccess, cbError, debug, customUrl);
    }
  }

  var _moment_config = {
    title: document.title,
    link: location.href,
    type: 'link'
    // imgUrl: location.origin + '/public/img/logo.png'
  };
  var _chat_config = {
    title: document.title,
    link: location.href,
    type: 'link',
    desc: document.title
  };

  WechatJSSDK.prototype.signSignature = function() {
    var self = this;
    var config = this.config;
    var debug = this.debug;
    if(debug) {
      config.debug = debug;
    }
    if(!window.wx) {
      console.warn('wechat js not defined');
      return;
    }
    var wx = window.wx;
    wx.config(config);
    wx.ready(function () {
      console.log('sign signature finished...');
      debug && alert('sign signature finished...');
      //initialize share on moment and chat features
      wx['onMenuShareTimeline'](_moment_config);
      wx['onMenuShareAppMessage'](_chat_config);
      self.signFinished = true;
      self.cbSuccess && self.cbSuccess();
    });

    wx.error(function (err) {
      debug && alert(err ? ('sign err: ' + JSON.stringify(err)) : 'ok');
      self.cbError && self.cbError(err);
    });

    //export original wx object
    self.wx || (self.wx = wx);
  };
  
  WechatJSSDK.prototype.updateConfig = function(newConfig) {
    delete newConfig.success;
    delete newConfig.error;
    this.config = newConfig;
  };

  WechatJSSDK.prototype.loadScript = function() {
    var self = this;
    var ele = document.createElement('script');
    ele.src = _script_url;
    ele.async = true;
    var linkEle = document.getElementsByTagName('script')[0];
    linkEle.parentNode.insertBefore(ele, linkEle);
    ele.onload = function() {
      console.log('script loaded');
      //init the wechat config
      self.signSignature();
    };
  };

  WechatJSSDK.prototype.setMomentConfig = function(info) {
    if(!info) return;
    for(var key in info) {
      if(info.hasOwnProperty(key)) {
        _moment_config[key] = info[key];
      }
    }
  };

  WechatJSSDK.prototype.setChatConfig = function(info) {
    if(!info) return;
    for(var key in info) {
      if(info.hasOwnProperty(key)) {
        _chat_config[key] = info[key];
      }
    }
  };

  //call other wechat api manually
  WechatJSSDK.prototype.callWechatApi = function(apiName, config) {
    if(!apiName) return;
    if(this.config.jsApiList.indexOf(apiName) < 0) {
      debug && alert('the wechat api [' + apiName + '] you call was not registered, \npls add the api into your [jsApiList] config');
      return;
    }
    var customAPI = window.wx[apiName];
    if(!customAPI || 'function' !== typeof customAPI) {
      debug && alert('no such api [' + apiName + '] found!');
      return;
    }
    customAPI(config);
  };

  if(true) {
    module.exports = WechatJSSDK;
  } else {
    window._wechat_jssdk = WechatJSSDK;
  }

})(window, document, window.location);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SET_MAX_COUPONS_NUM: 'SET_MAX_COUPONS_NUM',
  SET_ORDER_PROPS: 'SET_ORDER_PROPS',
  ON_SELECT_WHOLE_BENEFIT: 'ON_SELECT_WHOLE_BENEFIT',
  CLOSE_WHOLE_BENEFIT_SELECT: 'CLOSE_WHOLE_BENEFIT_SELECT',
  CHANGE_PURCHARSE_DISH: 'CHANGE_PURCHARSE_DISH',
  SET_PURCHASE_RULE_ITEMS: 'SET_PURCHASE_RULE_ITEMS',
  CHANGE_ACTIVE_PURCHASE_BENEFIT: 'CHANGE_ACTIVE_PURCHASE_BENEFIT',
  CONFIRM_CHOSEN_PURCHASE_BENEFIT: 'CONFIRM_CHOSEN_PURCHASE_BENEFIT',
  SAME_COUNT_WITH_ORDER_PURCHASE_BENEFIT: 'SAME_COUNT_WITH_ORDER_PURCHASE_BENEFIT'
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SET_SUPPORT_BUSINESS_TYPES: 'SET_SUPPORT_BUSINESS_TYPES',
  SET_ORDER_LIST: 'SET_ORDER_LIST',
  SET_ORDER_LIST_MORE: 'SET_ORDER_LIST_MORE',
  SET_TAKE_OUT_LIST: 'SET_TAKE_OUT_LIST',
  SET_TAKE_OUT_LIST_MORE: 'SET_TAKE_OUT_LIST_MORE',
  SET_BOOK_LIST: 'SET_BOOK_LIST',
  SET_QUEUE_LIST: 'SET_QUEUE_LIST',
  SET_BAKE_LIST: 'SET_BAKE_LIST',
  SET_BAKE_LIST_MORE: 'SET_BAKE_LIST_MORE',
  SET_IS_INVOICE: 'SET_IS_INVOICE',
  SET_IS_HDL: 'SET_IS_HDL',
  SET_USER_INFO: 'SET_USER_INFO',
  SET_INVOICE_STATUS: 'SET_INVOICE_STATUS',
  SET_BRAND_SETTING: 'SET_BRAND_SETTING'
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  commoncannotPay: {
    id: 'common.cannotPay',
    defaultMessage: '存在加菜单未处理，不能结账。请联系商户'
  },
  commonisSelected: {
    id: 'common.isSelected',
    defaultMessage: '选好啦'
  },
  commonorderCenter: {
    id: 'common.orderCenter',
    defaultMessage: '订单中心'
  },
  commonok: {
    id: 'common.ok',
    defaultMessage: '确定'
  },
  commonfillToUse1: {
    id: 'common.fillToUse1',
    defaultMessage: '满{currency}<span className="price">{fullValue}</span>可用'
  },
  commonRule: {
    id: 'common.Rule',
    defaultMessage: '使用规则'
  },
  commoninputPW: {
    id: 'common.inputPW',
    defaultMessage: '请输入密码'
  },
  commonforgetPW: {
    id: 'common.forgetPW',
    defaultMessage: '忘记密码？'
  },
  commondiscount: {
    id: 'common.discount',
    defaultMessage: '折'
  },
  commoncoupon: {
    id: 'common.coupon',
    defaultMessage: '礼品券'
  },
  commonwoman: {
    id: 'common.woman',
    defaultMessage: '女士'
  },
  commonman: {
    id: 'common.man',
    defaultMessage: '先生'
  },
  commonreturn: {
    id: 'common.return',
    defaultMessage: '返回'
  },
  commoncheckPN: {
    id: 'common.checkPN',
    defaultMessage: '验证手机号'
  },
  commonLoading: {
    id: 'common.loading',
    defaultMessage: '加载中'
  },
  loadingText: {
    id: 'common.getLoading',
    defaultMessage: '领取中...'
  }
});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var shallowCompare = __webpack_require__(120);
var classnames = __webpack_require__(50);

module.exports = function (Component) {
  return React.createClass({
    displayName: 'DynamicClassHOC',
    propTypes: {
      className: React.PropTypes.string,
      children: React.PropTypes.any
    },
    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    },
    componentWillUpdate: function componentWillUpdate() {},
    render: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);

      var classProps = {};
      var otherProps = {};
      for (var item in props) {
        if (props.hasOwnProperty(item)) {
          if (/^is/.test(item)) {
            var lowerKey = /^is(.*)/.exec(item)[1].toLowerCase();
            classProps['is-' + lowerKey] = props[item];
          } else {
            otherProps[item] = props[item];
          }
        }
      }
      var otherPropsWithA = {};
      if (Component === 'a') {
        // a标签删除
        for (var i in otherProps) {
          if (i.indexOf('data-') !== -1 || /^(onTouchTap|onClick|id|class)$/i.test(i)) {
            otherPropsWithA[i] = otherProps[i];
          }
        }
        otherProps = otherPropsWithA;
      }
      return React.createElement(
        Component,
        (0, _extends3.default)({ className: classnames(className, classProps) }, otherProps),
        children
      )
      // React.createElement(Component, Object.assign({}, { className:classnames(className, transformedClassProps) }, otherProps), children)
      ;
    }
  });
};

/***/ }),
/* 451 */,
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findIndex(arr, cb) {
  if (Object.prototype.toString.call(arr) !== '[object Array]') {
    return -1;
  }

  if (typeof cb !== 'function') {
    var keys = (0, _keys2.default)(cb);
    return arr.findIndex(function (item) {
      return keys.every(function (key) {
        return item[key] === cb[key];
      });
    });
  }

  return arr.findIndex(cb);
}

module.exports = findIndex;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _helper = __webpack_require__(16);

var _shoppingCart = __webpack_require__(425);

var _shoppingCart2 = _interopRequireDefault(_shoppingCart);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable quote-props */
var organizeDishData = __webpack_require__(43).organizeDishData;
var tableInfoLocalStorageKey = 'lastTableInfo';
var helper = __webpack_require__(43);

exports.clearTableInfoInSessionStorage = function () {
  sessionStorage.removeItem(tableInfoLocalStorageKey);
};

var setTableInfoInSessionStorage = exports.setTableInfoInSessionStorage = function (shopId, tableInfo) {
  var tableInfoWrap = {
    shopId: shopId,
    tableInfo: tableInfo
  };
  sessionStorage.setItem(tableInfoLocalStorageKey, (0, _stringify2.default)(tableInfoWrap));
};

var getTableInfoInSessionStorage = exports.getTableInfoInSessionStorage = function (shopId) {
  var json = sessionStorage.getItem(tableInfoLocalStorageKey);
  if (!json) {
    return {};
  }

  var tableInfoWrap = JSON.parse(json) || {};
  return tableInfoWrap.shopId === shopId ? tableInfoWrap.tableInfo : {};
};

exports.overWriteSessionStorage = function (shopId, param) {
  setTableInfoInSessionStorage(shopId, (0, _assign2.default)({}, getTableInfoInSessionStorage(shopId), param));
};

exports.getAllDishFromUserOrderedDishList = function (userOrderedDishList) {
  if (!userOrderedDishList || !userOrderedDishList.length) {
    return [];
  }

  var result = [];
  userOrderedDishList.forEach(function (item) {
    [].push.apply(result, item.dishList);
  });
  return result;
};

/**
 * 验证菜品份数的有效性 份数 = 起卖份数 + n * 步长
 * @param {Array} dishList
 */
exports.validateOrderedDishCount = function (dishList) {
  var result = { valid: true, msg: '' };
  var invalidDishList = [];
  var dividedDishes = dishList.reduce(function (list, dish) {
    var order = dish.order;

    if (!Array.isArray(order)) {
      return list.concat(dish);
    }

    var name = dish.name,
        stepNum = dish.stepNum,
        dishIncreaseUnit = dish.dishIncreaseUnit;

    return list.concat(order.map(function (item) {
      return { name: name, stepNum: stepNum, order: item.count, dishIncreaseUnit: dishIncreaseUnit };
    }));
  }, []);

  var validate = function validate(orderedDish) {
    var order = orderedDish.order,
        stepNum = orderedDish.stepNum,
        dishIncreaseUnit = orderedDish.dishIncreaseUnit;

    var diff = order - dishIncreaseUnit;

    return diff >= 0 && diff % stepNum === 0;
  };

  dividedDishes.forEach(function (dish) {
    var valid = validate(dish);
    var name = dish.name;


    if (!valid && invalidDishList.indexOf(name) === -1) {
      invalidDishList.push(name);
    }
  });

  result.valid = invalidDishList.length === 0;
  if (!result.valid) {
    result.msg = (0, _helper.formatMessage)(_errorMessage2.default.modifyNumOnCartPage, { invalidDishList: invalidDishList.join(',') });
  }

  return result;
};

exports.getConfirmedOrderedDishListFromUserOrderedList = function (userOrderedDishList) {
  var result = [];
  if (!userOrderedDishList || !userOrderedDishList.length) {
    return result;
  }

  var types = {};

  var _userOrderedDishList = (0, _slicedToArray3.default)(userOrderedDishList, 1),
      userOrderedDish = _userOrderedDishList[0];

  var userInfo = userOrderedDish.userInfo;

  (userOrderedDish.dishList || []).forEach(function (dish) {
    var curType = types[dish.dishTypeId] || {
      dishTypeName: dish.dishTypeName,
      dishResults: []
    };

    var order = dish.order;
    if (Array.isArray(order) && order.length > 0) {
      [].push.apply(curType.dishResults, order.map(function (item) {
        var _dish = (0, _assign2.default)({}, dish);
        _dish.order = [item];
        return { userInfo: userInfo, orderDish: organizeDishData(_dish) };
      }));
    } else {
      curType.dishResults.push({ userInfo: userInfo, orderDish: organizeDishData(dish) });
    }
    types[dish.dishTypeId] = curType;
  });

  for (var name in types) {
    if (types.hasOwnProperty(name)) {
      result.push(types[name]);
    }
  }

  return result;
};

var divideDishes = exports.divideDishes = function (originOrderDish) {
  if (!originOrderDish || !originOrderDish.length) {
    return null;
  }

  function divideDishesFunc(dishes) {
    return [].concat.apply([], dishes.map(function (dish) {
      if (helper.isSingleDishWithoutProps(dish)) {
        return [(0, _assign2.default)({}, dish, { key: '' + dish.id })];
      }

      return dish.order.map(function (dishOrder, idx) {
        return (0, _assign2.default)({}, dish, { key: dish.id + '-' + idx }, { order: [(0, _assign2.default)({}, dishOrder)] });
      });
    }));
  }
  var dividedDishes = divideDishesFunc(originOrderDish);
  var newDividedDishes = [];
  dividedDishes.forEach(function (item) {
    newDividedDishes.push((0, _assign2.default)({}, item.asMutable ? item.asMutable() : item, { marketPrice: helper.getDishPrice(item) }));
  });
  return newDividedDishes;
};

exports.getOrderDish = function (originOrderDish, bool) {
  var orderDish = [];
  if (bool) {
    (divideDishes(originOrderDish) || []).forEach(function (itemt, indext) {
      var orderedChildDishes = void 0;
      if (itemt.order && itemt.order.length > 0 && itemt.order[0].groups) {
        orderedChildDishes = [].concat.apply([], itemt.order[0].groups.map(function (group) {
          return helper.getOrderedDishes(group.childInfos);
        })).filter(function (childDish) {
          return helper.getDishesCount([childDish]);
        });
      }

      orderDish.push({
        dishResults: [{
          orderDish: (0, _assign2.default)({}, itemt, {
            dishIngredientInfos: itemt.order && itemt.order.length > 0 && itemt.order[0].dishIngredientInfos ? itemt.order[0].dishIngredientInfos : itemt.dishIngredientInfos
          }, {
            propertyTypeList: itemt.order && itemt.order.length > 0 && itemt.order[0].dishPropertyTypeInfos ? itemt.order[0].dishPropertyTypeInfos : itemt.dishPropertyTypeInfos
          }, itemt.groups ? { subDishItems: orderedChildDishes } : {}),
          userInfo: itemt.userInfo
        }],
        dishTypeName: itemt.dishTypeName,
        dishTypeId: itemt.dishTypeId
      });
    });
  } else {
    orderDish = originOrderDish;
  }

  var mergeMemoInfo = function mergeMemoInfo(_ref) {
    var dishIngredientInfos = _ref.dishIngredientInfos,
        dishPropertyTypeInfos = _ref.dishPropertyTypeInfos,
        subDishItemsObj = _ref.subDishItemsObj;

    var propetiesArry = [];
    var title = '';
    var newMemo = [];
    var memoItem = [];
    var dishSubType = [];

    // 第四层，子菜的口味，做法，备注，配料
    if (dishPropertyTypeInfos && dishPropertyTypeInfos.length > 0) {
      dishPropertyTypeInfos.forEach(function (propertyType) {
        propetiesArry = [];
        if (propertyType.type === 3) {
          title = (0, _helper.formatMessage)(_shoppingCart2.default.notes) + '\uFF1A';
        } else {
          title = propertyType.name + '：';
        }
        // 第五层，多种口味，多种做法，多条备注
        propertyType.properties.forEach(function (properties) {
          if (properties.name && (properties.isChecked || propertyType.type === 4)) {
            propetiesArry.push(properties.name);
          }
        });
        // 过滤属性内容为空
        if (propetiesArry && propetiesArry.length > 0) {
          if (propertyType.type === 3) {
            memoItem.push(title + propetiesArry.join('、'));
          } else if (propertyType.type === 4) {
            dishSubType.push(propetiesArry.join('，'));
          } else {
            newMemo.push(title + propetiesArry.join('、'));
          }
        }
      });
      newMemo = newMemo.concat(memoItem);
      propetiesArry = [];
    }
    // 配料
    if (dishIngredientInfos && dishIngredientInfos.length > 0) {
      dishIngredientInfos.forEach(function (ingredient) {
        if (!ingredient.isChecked) {
          return;
        }
        propetiesArry.push(ingredient.name);
      });

      // 牛肉没被选上呢, isChecked属性问题
      if (propetiesArry.length > 0) {
        newMemo.push((0, _helper.formatMessage)(_dishMenu2.default.ingredients) + '\uFF1A' + propetiesArry.join('、'));
      }
    }

    subDishItemsObj.memo = newMemo.join(' | ');
  };

  var orderDishArry = [];
  var dishesArry = []; // 点菜信息，菜品和用户
  var subDishItemsArry = [];
  var totalDishNum = 0; // 菜品总份数

  if (orderDish) {
    orderDish.forEach(function (orderResult) {
      // 第一层，菜品种类
      var orderDishObj = {};
      var dishNum = 0; // 单菜数量
      dishesArry = [];
      orderDishObj.dishTypeName = orderResult.dishTypeName;
      orderDishObj.dishTypeId = orderResult.dishTypeId;
      orderResult.dishResults.forEach(function (dishResult, index) {
        // 第二层，一条完整的点菜信息：用户头像，菜品信息
        var dishesObj = {};
        var dishItems = {};
        var dishMainType = [];
        subDishItemsArry = [];
        dishesObj.userPicPath = dishResult.userInfo.userPicPath;
        dishesObj.order = dishResult.orderDish.order;
        dishItems.num = 0;
        dishItems.marketPrice = dishResult.orderDish.marketPrice;
        if (dishResult.orderDish.order && dishResult.orderDish.order.length > 0) {
          dishResult.orderDish.order.forEach(function (item) {
            dishItems.num += item.count;
          });
        } else if (typeof dishResult.orderDish.order === 'number') {
          dishItems.num = dishResult.orderDish.order;
        } else {
          dishItems.num = dishResult.orderDish.num;
        }

        var memoArry = [];
        var propetiesArry = [];
        var title = '';

        dishNum += dishItems.num;
        orderDishObj.dishNum = dishNum;

        // 第三层，菜品信息，有子菜
        if (dishResult.orderDish.subDishItems && dishResult.orderDish.subDishItems.length > 0) {
          dishResult.orderDish.subDishItems.forEach(function (subDishItems) {
            var propertyTypeList = [];
            var dishIngredientInfos = [];
            if (subDishItems.order && subDishItems.order.length > 0 && subDishItems.order[0].dishIngredientInfos) {
              dishIngredientInfos = subDishItems.order[0].dishIngredientInfos;
            } else {
              dishIngredientInfos = subDishItems.dishIngredientInfos;
            }

            if (subDishItems.order && subDishItems.order.length > 0 && subDishItems.order[0].dishPropertyTypeInfos) {
              propertyTypeList = subDishItems.order[0].dishPropertyTypeInfos;
            } else {
              propertyTypeList = subDishItems.propertyTypeList || subDishItems.dishPropertyTypeInfos;
            }

            var subDishItemsObj = {};
            subDishItemsObj.num = 0;
            var isMemo = false;
            var memoItem = []; // 子菜口味备注配料
            var dishSubType = []; // 子菜规格

            // 此时不应该合并份数 TODO
            if (subDishItems.order && subDishItems.order.length > 0) {
              subDishItems.order.forEach(function (item) {
                subDishItemsObj.num += item.count;
              });
            } else if (typeof subDishItems.order === 'number') {
              subDishItemsObj.num = subDishItems.order;
            } else {
              subDishItemsObj.num = subDishItems.num;
            }

            memoArry = [];

            if (subDishItems.order && subDishItems.order.length > 0) {
              subDishItems.order.forEach(function (item) {
                var count = item.count,
                    dishPropertyTypeInfos = item.dishPropertyTypeInfos,
                    test = item.dishIngredientInfos;

                subDishItemsObj.num = count;
                mergeMemoInfo({ dishIngredientInfos: test, dishPropertyTypeInfos: dishPropertyTypeInfos, subDishItemsObj: subDishItemsObj });

                var dishSubTypeStr = dishSubType && dishSubType.length > 0 ? '(' + dishSubType.join('，') + ')' : '';

                subDishItemsObj.dishName = '' + subDishItems.name + dishSubTypeStr; // /${subDishItems.unitName}

                // 子菜数量大于0才算
                if (subDishItemsObj.num > 0) {
                  subDishItemsArry.push((0, _extends3.default)({}, subDishItemsObj));
                }
              });
            } else {
              mergeMemoInfo({ dishIngredientInfos: dishIngredientInfos, dishPropertyTypeInfos: propertyTypeList, subDishItemsObj: subDishItemsObj });
              var dishSubTypeStr = dishSubType && dishSubType.length > 0 ? '(' + dishSubType.join('，') + ')' : '';
              subDishItemsObj.dishName = '' + subDishItems.name + dishSubTypeStr; // /${subDishItems.unitName}

              // 子菜数量大于0才算
              if (subDishItemsObj.num > 0) {
                subDishItemsArry.push(subDishItemsObj);
              }
            }
          });

          dishItems.subDishItems = subDishItemsArry;
        } else {
          var isMemo = false;
          var memoItem = [];
          // 第三层，菜品信息，无子菜
          if (dishResult.orderDish.propertyTypeList && dishResult.orderDish.propertyTypeList.length > 0) {
            dishResult.orderDish.propertyTypeList.forEach(function (propertyTypeMain) {
              propetiesArry = [];
              isMemo = true;
              if (propertyTypeMain.type === 3) {
                title = (0, _helper.formatMessage)(_shoppingCart2.default.notes) + '\uFF1A';
              } else {
                title = propertyTypeMain.name + '：';
              }

              // 第四层，多种口味，多种做法，多条备注
              propertyTypeMain.properties.forEach(function (propertiesMain) {
                if (!propertiesMain.isChecked) {
                  return;
                }
                propetiesArry.push(propertiesMain.name);
              });

              // 过滤属性内容为空
              if (propetiesArry && propetiesArry.length > 0) {
                if (propertyTypeMain.type === 3) {
                  memoItem.push(title + propetiesArry.join('、'));
                } else if (propertyTypeMain.type === 4) {
                  dishMainType.push(propetiesArry.join('，'));
                } else if (propertyTypeMain.type === 2) {
                  memoArry = [];
                } else {
                  memoArry.push(title + propetiesArry.join('、'));
                }
              }
            });

            memoArry = memoArry.concat(memoItem);
            propetiesArry = [];
          }

          // 配料
          if (dishResult.orderDish.dishIngredientInfos && dishResult.orderDish.dishIngredientInfos.length > 0) {
            dishResult.orderDish.dishIngredientInfos.forEach(function (ingredientMain) {
              if (!ingredientMain.isChecked) {
                return;
              }
              propetiesArry.push(ingredientMain.name);
            });
            if (isMemo && propetiesArry.length > 0) {
              memoArry.splice(1, 0, (0, _helper.formatMessage)(_dishMenu2.default.ingredients) + '\uFF1A' + propetiesArry.join('、'));
            } else if (propetiesArry.length > 0) {
              memoArry.push((0, _helper.formatMessage)(_dishMenu2.default.ingredients) + '\uFF1A' + propetiesArry.join('、'));
            }
          }
          dishItems.memo = memoArry.join(' | ');
        }

        var dishMainTypeStr = dishMainType && dishMainType.length > 0 ? '(' + dishMainType.join('，') + ')' : '';
        dishItems.dishName = '' + dishResult.orderDish.name + dishMainTypeStr;
        dishesObj.dishItems = dishItems;
        // 主菜数量大于0才算
        if (dishItems.num > 0) {
          dishesArry.push(dishesObj);
        }
      });

      totalDishNum += dishNum;
      orderDishObj.dishes = dishesArry;
      orderDishArry.push(orderDishObj);
    });
  }
  return { totalNum: totalDishNum, orderDishItems: orderDishArry };
};

exports.doClearSocketShoppingCart = function (args) {
  var setToastProps = args.setToastProps,
      userInfo = args.userInfo,
      tradeDetailUncheckURL = args.tradeDetailUncheckURL;

  if (userInfo.clearType === 'DEFAULT') {
    setToastProps({
      mainMessage: (0, _helper.formatMessage)(_errorMessage2.default.clearedCart),
      buttonProp: { text: (0, _helper.formatMessage)(_shoppingCart2.default.known) },
      onBtnTap: function onBtnTap() {
        return setToastProps(null);
      },
      imgProp: userInfo.userPicPath,
      userName: userInfo.userNickname
    });
    return;
  }

  if (userInfo.clearType === 'ORDER_SUCCESS') {
    if (userInfo.orderId === 0) {
      // console.log('orderId等于0的情况');
      return;
    }
    setToastProps({
      mainMessage: (0, _helper.formatMessage)(_errorMessage2.default.submittedOrder),
      viceMessage: (0, _helper.formatMessage)(_errorMessage2.default.entringOrderDetailPage),
      imgProp: userInfo.userPicPath,
      userName: userInfo.userNickname
    });

    setTimeout(function () {
      location.href = tradeDetailUncheckURL;
    }, 2000);
    return;
  }
};

/***/ }),
/* 454 */,
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var shallowCompare = __webpack_require__(120);

var ActiveSelect = React.createClass({
  displayName: 'ActiveSelect',
  propTypes: {
    optionsData: React.PropTypes.array.isRequired,
    isPrivateRoom: React.PropTypes.bool,
    optionComponent: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]).isRequired,
    onSelectOption: React.PropTypes.func.isRequired,
    className: React.PropTypes.string,
    needAmount: React.PropTypes.number,
    dishes: React.PropTypes.array,
    serviceProps: React.PropTypes.object,
    commercialProps: React.PropTypes.object,
    fromWholeOrderBenefit: React.PropTypes.bool,
    extTitle: React.PropTypes.string,
    sendSubComponentParam: React.PropTypes.object,
    isHDL: React.PropTypes.bool,
    showDelivery: React.PropTypes.bool
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  onSelectOption: function onSelectOption(evt, wholeBenefitData) {
    evt.preventDefault();
    var optionsData = this.props.optionsData;
    var id = evt.currentTarget.dataset.id;

    if (wholeBenefitData) {
      this.props.onSelectOption(evt, wholeBenefitData);
      return;
    }
    var optionData = optionsData.find(function (item) {
      if (isNaN(id).toString()) {
        return String(item.id) === String(id);
      }
      return false;
    });
    this.props.onSelectOption(evt, optionData);
  },
  renderOptions: function renderOptions(params) {
    var _this = this;

    var _props = this.props,
        fromWholeOrderBenefit = _props.fromWholeOrderBenefit,
        extTitle = _props.extTitle,
        sendSubComponentParam = _props.sendSubComponentParam;

    var subComponentParam = sendSubComponentParam || {};
    return (params.optionsData || []).map(function (optionData) {
      var label = optionData.label,
          oldPrice = optionData.oldPrice,
          newPrice = optionData.newPrice;
      // 如果showDelivery=true则需要展示新旧配送费
      // 新旧价格相等则-展示新价格
      // 新旧价格不等-且新的价格存在和等于0-展示新价格

      if (params.showDelivery) {
        label = React.createElement(
          'div',
          null,
          oldPrice != newPrice && React.createElement(
            'span',
            { className: newPrice || newPrice == 0 ? 'delivery-oldPrice' : '' },
            '\uFFE5',
            oldPrice
          ),
          '\xA0',
          (newPrice || newPrice == 0) && React.createElement(
            'span',
            { className: 'delivery-newPrice' },
            '\uFFE5',
            newPrice
          )
        );
      }
      return React.createElement(params.optionComponent, (0, _assign2.default)({}, {
        key: optionData.id,
        isPrivateRoom: params.isPrivateRoom,
        needAmount: params.needAmount,
        'data-option': '',
        'data-id': optionData.id,
        onTouchTap: _this.onSelectOption,
        dishes: params.dishes,
        serviceProps: params.serviceProps,
        dishNames: optionData.dishNames,
        extTitle: extTitle,
        isHDL: params.isHDL
      }, fromWholeOrderBenefit ? { commercialProps: params.commercialProps, showWholeBenefitRange: params.showWholeBenefitRange } : {}, optionData, subComponentParam), label);
    });
  },
  render: function render() {
    var className = this.props.className;


    var optionElements = this.renderOptions(this.props);
    return React.createElement(
      'div',
      { className: className },
      optionElements
    );
  }
});

module.exports = ActiveSelect;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys2 = __webpack_require__(25);

var _keys3 = _interopRequireDefault(_keys2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseComponent = function (_React$Component) {
  (0, _inherits3.default)(BaseComponent, _React$Component);

  function BaseComponent() {
    (0, _classCallCheck3.default)(this, BaseComponent);
    return (0, _possibleConstructorReturn3.default)(this, (BaseComponent.__proto__ || (0, _getPrototypeOf2.default)(BaseComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(BaseComponent, [{
    key: 'bind',
    value: function bind() {
      var _this2 = this;

      for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
        methods[_key] = arguments[_key];
      }

      methods.forEach(function (element) {
        _this2[element] = _this2[element].bind(_this2);
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var thisProps = this.props || {};
      var thisState = this.state || {};

      var nextPropsClone = nextProps || {};
      var nextStateClone = nextState || {};

      var thisPropsKeyList = (0, _keys3.default)(thisProps);
      var nextPropsKeyList = (0, _keys3.default)(nextPropsClone);

      var thisStateKeyList = (0, _keys3.default)(thisState);
      var nextStateKeyList = (0, _keys3.default)(nextStateClone);

      if (thisPropsKeyList.length !== nextPropsKeyList.length || thisStateKeyList.length !== nextStateKeyList.length) {
        return true;
      }

      for (var keys in nextPropsClone) {
        if (nextPropsClone[keys] !== thisProps[keys]) {
          return true;
        }
      }

      for (var _keys in nextStateClone) {
        if (nextStateClone[_keys] !== thisState[_keys]) {
          return true;
        }
      }

      return false;
    }
  }]);
  return BaseComponent;
}(_react2.default.Component);

exports.default = BaseComponent;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  ActivateValidateApplicationuseOtherPNtoActivate: {
    id: 'ActivateValidateApplication.useOtherPNtoActivate',
    defaultMessage: '该手机号已与其它微信号绑定过，请在对应微信号内或使用其他手机号激活'
  },
  ActivateValidateApplicationConfirm: {
    id: 'ActivateValidateApplication.Confirm',
    defaultMessage: '确定'
  },
  AddressListApplicationaddAddressPrompt: {
    id: 'AddressListApplication.addAddressPrompt',
    defaultMessage: '主人还没有收货地址，快来添加一个吧～'
  },
  AddressListApplicationaddAddressPrompt2: {
    id: 'AddressListApplication.addAddressPrompt2',
    defaultMessage: '主人还没有收货地址'
  },
  AddressListApplicationaddAddressPrompt3: {
    id: 'AddressListApplication.addAddressPrompt3',
    defaultMessage: '快来添加一个吧～'
  },
  AddressListApplicationdeleteToModifyAddress: {
    id: 'AddressListApplication.deleteToModifyAddress',
    defaultMessage: '如需新增，请删除或修改已有地址'
  },
  AddressListApplicationaddAddress: {
    id: 'AddressListApplication.addAddress',
    defaultMessage: '新增地址'
  },
  BindAlipayApplicationAliPay: {
    id: 'BindAlipayApplication.AliPay',
    defaultMessage: '支付宝'
  },
  BindWXApplicationWXID: {
    id: 'BindWXApplication.WXID',
    defaultMessage: '微信号'
  },
  BookCheckOrderApplicationunknownShop: {
    id: 'BookCheckOrderApplication.unknownShop',
    defaultMessage: '未知的门店'
  },
  BookCheckOrderApplicationselectedGoods: {
    id: 'BookCheckOrderApplication.selectedGoods',
    defaultMessage: '已选商品'
  },
  BookCheckOrderApplicationtotalGoods: {
    id: 'BookCheckOrderApplication.totalGoods',
    defaultMessage: '共{dishesCount}份'
  },
  BookCheckOrderApplicationmodifyOrder: {
    id: 'BookCheckOrderApplication.modifyOrder',
    defaultMessage: '修改订单'
  },
  BookCheckOrderApplicationTotal: {
    id: 'BookCheckOrderApplication.Total',
    defaultMessage: '总计：'
  },
  BookCheckOrderApplicationPS: {
    id: 'BookCheckOrderApplication.PS',
    defaultMessage: '备注'
  },
  BookCheckOrderApplicationconfirmMenu: {
    id: 'BookCheckOrderApplication.confirmMenu',
    defaultMessage: '确认菜单'
  },
  BookDetailApplicationshowMenu: {
    id: 'BookDetailApplication.showMenu',
    defaultMessage: '查看菜单'
  },
  BookDetailApplicationadvanceDish: {
    id: 'BookDetailApplication.advanceDish',
    defaultMessage: '预点菜'
  },
  BookDetailApplicationgotoPay: {
    id: 'BookDetailApplication.gotoPay',
    defaultMessage: '去支付'
  },
  BookDetailApplicationcancelOrder: {
    id: 'BookDetailApplication.cancelOrder',
    defaultMessage: '取消订单'
  },
  BookDetailApplicationCancelBook: {
    id: 'BookDetailApplication.CancelBook',
    defaultMessage: '取消预定'
  },
  BookDetailApplicationConfirmToshop: {
    id: 'BookDetailApplication.ConfirmToshop',
    defaultMessage: '确定到店'
  },
  BookDetailApplicationConfirmComeInTime: {
    id: 'BookDetailApplication.ConfirmComeInTime',
    defaultMessage: '请确认是否准时到店'
  },
  BookDetailApplicationAdvanced: {
    id: 'BookDetailApplication.Advanced',
    defaultMessage: '已付订金'
  },
  BrandIndexApplicationCancelBookPrompt: {
    id: 'BrandIndexApplication.CancelBookPrompt',
    defaultMessage: '取消预订后，商户将不会为您保留位置，请确认'
  },
  BrandIndexApplicationNeedAdvance: {
    id: 'BrandIndexApplication.NeedAdvance',
    defaultMessage: '需付订金'
  },
  BrandIndexApplicationAdvancedPrompt: {
    id: 'BrandIndexApplication.AdvancedPrompt',
    defaultMessage: '您已付预付金，不支持在线取消，请联系商户'
  },
  BrandIndexApplicationBookInfo: {
    id: 'BrandIndexApplication.BookInfo',
    defaultMessage: '预订信息'
  },
  BrandIndexApplicationOrderId: {
    id: 'BrandIndexApplication.OrderId',
    defaultMessage: '订单编号'
  },
  BrandIndexApplicationBookTime: {
    id: 'BrandIndexApplication.BookTime',
    defaultMessage: '预订时间'
  },
  BrandIndexApplicationTableType: {
    id: 'BrandIndexApplication.TableType',
    defaultMessage: '桌台类型'
  },
  BrandIndexApplicationBookPeople: {
    id: 'BrandIndexApplication.BookPeople',
    defaultMessage: '预订人数'
  },
  BrandIndexApplicationConnectPerson: {
    id: 'BrandIndexApplication.ConnectPerson',
    defaultMessage: '联  系 人'
  },
  BrandIndexApplicationConnectWay: {
    id: 'BrandIndexApplication.ConnectWay',
    defaultMessage: '联系方式'
  },
  BrandIndexApplicationPS: {
    id: 'BrandIndexApplication.PS',
    defaultMessage: '备      注'
  },
  CombinedPaymentorderChanged: {
    id: 'CombinedPayment.orderChanged',
    defaultMessage: '服务员修改了订单'
  },
  CombinedPaymentplsInputVipTradePW: {
    id: 'CombinedPayment.plsInputVipTradePW',
    defaultMessage: '请输入会员交易密码'
  },
  CombinedPaymentWXPay: {
    id: 'CombinedPayment.WXPay',
    defaultMessage: '微信支付'
  },
  CombinedPaymentAliPay: {
    id: 'CombinedPayment.AliPay',
    defaultMessage: '支付宝支付'
  },
  CombinedPaymentAntCreditPay: {
    id: 'CombinedPayment.AntCreditPay',
    defaultMessage: '花呗支付'
  },
  CombinedPaymentAntCredit: {
    id: 'CombinedPayment.AntCredit',
    defaultMessage: '花呗分期'
  },
  CombinedPaymentAntCreditFee: {
    id: 'CombinedPayment.AntCreditFee',
    defaultMessage: '服务费{fee}元/期'
  },
  uePayBtn: {
    id: 'CombinedPayment.uePay',
    defaultMessage: '極易付支付'
  },
  bocPayBtn: {
    id: 'CombinedPayment.bocPay',
    defaultMessage: '澳門中銀手機銀行支付'
  },
  mPayBtn: {
    id: 'CombinedPayment.mPayBtn',
    defaultMessage: 'MPay 支付'
  },
  touchngoPayBtn: {
    id: 'CombinedPayment.touchngoPay',
    defaultMessage: 'TNG 支付'
  },
  PayDetailBrandApplicationOtherPay: {
    id: 'CombinedPayment.OtherPay',
    defaultMessage: '第三方支付'
  },
  CombinedPaymentPaySuccess: {
    id: 'CombinedPayment.PaySuccess',
    defaultMessage: '支付成功'
  },
  CustomerAddressApplicationinputReceiveAddress: {
    id: 'CustomerAddressApplication.inputReceiveAddress',
    defaultMessage: '请输入收货位置'
  },
  DishMenuApplicationmircAppUnOpen: {
    id: 'DishMenuApplication.mircAppUnOpen',
    defaultMessage: '该门店未开通小程序业务'
  },
  DishMenuApplicationgotoRegister: {
    id: 'DishMenuApplication.gotoRegister',
    defaultMessage: '去注册'
  },
  DishMenuApplicationregisterToGetGift: {
    id: 'DishMenuApplication.registerToGetGift',
    defaultMessage: '注册会员享受更多福利哟～'
  },
  DishMenuApplicationgetSpecialGift: {
    id: 'DishMenuApplication.getSpecialGift',
    defaultMessage: '恭喜获得评价专属礼包'
  },
  DishMenuApplicationgetSpecialGiftSuccess: {
    id: 'DishMenuApplication.getSpecialGiftSuccess',
    defaultMessage: '成功领取专属礼包'
  },
  QueueDetailApplicationlineUpToOrder: {
    id: 'QueueDetailApplication.lineUpToOrder',
    defaultMessage: '排队点菜'
  },
  OrderInlineApplicationoccluedMobileShop: {
    id: 'OrderInlineApplication.occluedMobileShop',
    defaultMessage: '当前门店未开通移动门店，请联系商户'
  },
  PayDetailApplicationchoosePayWay: {
    id: 'PayDetailApplication.choosePayWay',
    defaultMessage: '请选择支付方式'
  },
  BrandIndexApplicationshopInfo: {
    id: 'BrandIndexApplication.shopInfo',
    defaultMessage: '门店信息'
  },
  BrandIndexApplicationwaitInfo: {
    id: 'BrandIndexApplication.waitInfo',
    defaultMessage: '前方等待{count}桌'
  },
  BrandIndexApplicationnetErr: {
    id: 'BrandIndexApplication.netErr',
    defaultMessage: '当前网络不佳，请稍后再试'
  },
  BrandIndexApplicationnotWait: {
    id: 'BrandIndexApplication.notWait',
    defaultMessage: 'POS机当前未联网，无法排队取号'
  },

  BookCheckOrderTotal: {
    id: 'BookCheckOrder.Total',
    defaultMessage: '共{dishCount}份'
  },
  QueueDetailWait: {
    id: 'QueueDetail.Wait',
    defaultMessage: '在您之前还有{count}桌客人等候'
  },
  QueueDetailYouCan: {
    id: 'QueueDetail.YouCan',
    defaultMessage: '您可以'
  },
  editAddress: {
    id: 'editAddress',
    defaultMessage: '编辑地址'
  },
  AddAddress: {
    id: 'AddAddress',
    defaultMessage: '新增地址'
  },
  queueDetailGetNumber: {
    id: 'queueDetailGetNumber',
    defaultMessage: '取号'
  },
  isPaymentCompleted: {
    id: 'isPaymentCompleted',
    defaultMessage: '是否完成支付？'
  },
  paymentComplete: {
    id: 'paymentComplete',
    defaultMessage: '已完成支付'
  },
  paymentRetry: {
    id: 'paymentRetry',
    defaultMessage: '重新支付'
  },
  systemException: {
    id: 'systemException',
    defaultMessage: '系统异常'
  },
  loginFailed: {
    id: 'loginFailed',
    defaultMessage: '登录异常，不可点餐'
  },
  dishMenuTestButton: {
    id: 'dishMenuTestButton',
    defaultMessage: '商品信息变更，请核对下单'
  }
});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReducerContainer = function () {
  function ReducerContainer() {
    (0, _classCallCheck3.default)(this, ReducerContainer);
  }

  (0, _createClass3.default)(ReducerContainer, null, [{
    key: 'create',
    value: function create() {
      var reducers = {};

      return {
        add: function add(actionType, reducer) {
          reducers[actionType] = reducer;
        },
        exist: function exist(actionType) {
          return reducers.hasOwnProperty(actionType);
        },
        getNextState: function getNextState(type, state, payload) {
          var reducer = reducers[type];
          return reducer ? reducer(state, payload) : null;
        }
      };
    }
  }, {
    key: 'createReducer',
    value: function createReducer(initialState, handlers) {
      if (!initialState || !handlers) {
        throw new Error('must pass args of "initialState" and "handlers" to createReducer!');
      }

      return function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
        var _ref = arguments[1];
        var type = _ref.type,
            payload = _ref.payload;

        var handler = handlers[type];

        if (typeof handler !== 'function') {
          return state;
        }

        return handler(state, payload);
      };
    }
  }, {
    key: 'appendReducer',
    value: function appendReducer(masterReducer) {
      for (var _len = arguments.length, reducers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        reducers[_key - 1] = arguments[_key];
      }

      return function (state, action) {
        var nextState = masterReducer(state, action);

        return reducers.reduce(function (currentState, reducer) {
          return reducer(currentState, action);
        }, nextState);
      };
    }
  }]);
  return ReducerContainer;
}();

exports.default = ReducerContainer;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(278);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _findIndex = __webpack_require__(452);
var React = __webpack_require__(2);

var _require = __webpack_require__(114),
    findDOMNode = _require.findDOMNode;

var shallowCompare = __webpack_require__(120);
var classnames = __webpack_require__(50);
var IScroll = __webpack_require__(465);
var ActiveSelect = __webpack_require__(455);

__webpack_require__(125);
__webpack_require__(466);

module.exports = React.createClass({
  displayName: 'ActiveScrollSelect',
  propTypes: (0, _extends3.default)({
    className: React.PropTypes.string,
    viewportHeight: React.PropTypes.number
  }, ActiveSelect.propTypes),
  getDefaultProps: function getDefaultProps() {
    return {
      viewportHeight: 5
    };
  },
  componentWillMount: function componentWillMount() {
    this._cache = {};
  },
  componentDidMount: function componentDidMount() {
    var viewport = findDOMNode(this);
    var _props = this.props,
        optionsData = _props.optionsData,
        viewportHeight = _props.viewportHeight;

    this.adjustViewportHeight(viewport, viewportHeight);
    this.applyIScrollPlugin(viewport);
    this.scrollToSelectedOption(optionsData);
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  componentDidUpdate: function componentDidUpdate() {
    var _props2 = this.props,
        optionsData = _props2.optionsData,
        viewportHeight = _props2.viewportHeight;

    var viewport = findDOMNode(this);
    this.adjustViewportHeight(viewport, viewportHeight);
    this._cache.iScroll.refresh();
    this.scrollToSelectedOption(optionsData);
  },
  applyIScrollPlugin: function applyIScrollPlugin(viewport) {
    var _this = this;

    var cache = this._cache;
    var iScroll = cache.iScroll = new IScroll(viewport, { snap: '[data-option]', snapThreshold: 0.5, bounceTime: 5 });
    iScroll.on('beforeScrollStart', function () {
      if (cache.selectTimmer) {
        window.clearTimeout(cache.selectTimmer);
      }
    });
    iScroll.on('scrollEnd', function () {
      var _props3 = _this.props,
          optionsData = _props3.optionsData,
          onSelectOption = _props3.onSelectOption;
      // if (!cache.autoScrolling) {
      //   cache.selectTimmer = setTimeout(() => onSelectOption(null, optionsData[iScroll.currentPage.pageY]), 50);
      // }

      onSelectOption(null, optionsData[iScroll.currentPage.pageY]);
      cache.autoScrolling = false;
    });
  },
  adjustViewportHeight: function adjustViewportHeight(viewport, viewportHeight) {
    // We need to adjust the height of viewport according to the height of Option
    var optionElement = viewport.querySelector('[data-option]');
    if (optionElement) {
      // viewport.style.height = `${optionElement.offsetHeight * viewportHeight}px`;
      viewport.style.height = 200 + 'px'; // this is a temp fix for performance issue
    }
  },
  scrollToSelectedOption: function scrollToSelectedOption(options) {
    var optionIdx = _findIndex(options, { isChecked: true });
    var cache = this._cache;

    if (optionIdx !== -1) {
      cache.iScroll.goToPage(0, optionIdx, 100);
    }
    cache.autoScrolling = true;
  },
  buildPlaceholderElement: function buildPlaceholderElement(viewportHeight) {
    var placeholderOffset = this._cache.placeholderOffset = viewportHeight / 2;
    var placeholders = [];
    for (var i = 1; i <= placeholderOffset; i++) {
      placeholders.push(React.createElement('a', { key: 'placeholder-' + i, 'data-option': 'false' }));
    }
    return React.createElement(
      'div',
      { className: 'placeholder-container' },
      placeholders
    );
  },
  onSelectOption: function onSelectOption(evt, optionData) {
    var cache = this._cache;
    var onSelectOption = this.props.onSelectOption;

    if (!cache.autoScrolling) {
      cache.selectTimmer = setTimeout(function () {
        return onSelectOption(evt, optionData);
      }, 50);
    }
    cache.autoScrolling = false;
  },
  render: function render() {
    var _props4 = this.props,
        className = _props4.className,
        viewportHeight = _props4.viewportHeight,
        optionComponent = _props4.optionComponent,
        props = (0, _objectWithoutProperties3.default)(_props4, ['className', 'viewportHeight', 'optionComponent']);

    var topPlaceholder = this.buildPlaceholderElement(viewportHeight);
    var bottomPlaceholder = this.buildPlaceholderElement(viewportHeight);
    return React.createElement(
      'div',
      { className: classnames('scroll-select', className) },
      React.createElement(
        'div',
        { className: 'scroll-wrapper' },
        topPlaceholder,
        React.createElement(ActiveSelect, (0, _extends3.default)({ optionComponent: optionComponent }, props, { onSelectOption: this.onSelectOption })),
        bottomPlaceholder
      )
    );
  }
});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _tips = __webpack_require__(508);

var _tips2 = _interopRequireDefault(_tips);

var _handleInput = __webpack_require__(510);

var _handleInput2 = _interopRequireDefault(_handleInput);

var _const = __webpack_require__(14);

var _reactIntl = __webpack_require__(7);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _helper = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var ReactDOM = __webpack_require__(114);
var classnames = __webpack_require__(50);

__webpack_require__(516);

module.exports = React.createClass({
  displayName: 'Counter',
  propTypes: {
    count: React.PropTypes.number.isRequired,
    maximum: React.PropTypes.number,
    minimum: React.PropTypes.number,
    step: React.PropTypes.number,
    hiddenNum: React.PropTypes.number,
    onCountChange: React.PropTypes.func.isRequired,
    onTouchTap: React.PropTypes.func,
    msg: React.PropTypes.object,
    ifShowToolTip: React.PropTypes.bool,
    showHandleInput: React.PropTypes.func,
    dishItem: React.PropTypes.object,
    showHandleDishCount: React.PropTypes.func,
    onlyAddCounter: React.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      count: 0,
      minimum: 0,
      step: 1,
      hiddenNum: 0
    };
  },
  getInitialState: function getInitialState() {
    return {
      msg: '',
      msgRec: { bottom: -100, right: -100 },
      tooltip: false,
      tooltipText: '',
      tipInlineStyle: {}
    };
  },

  countUpdated: true, // 是否已经接收到更新的count
  componentWillMount: function componentWillMount() {
    this.tipTimeout = null;
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps && this.props.count !== nextProps.count) {
      this.countUpdated = true;
      this.handleDishCount(false, false, nextProps.count, nextProps.dishItem);
    }
  },
  showToolTip: function showToolTip(args) {
    var _this = this;

    var tooltipText = args.tooltipText,
        increment = args.increment;

    var tipInlineStyle = {};
    var counterWidth = this.refs.counter.offsetWidth;
    var counterSingleWidth = this.refs.counteradd.offsetWidth;
    var halfCounterSingleWidth = counterSingleWidth / 2;
    var minusTriggerRight = void 0;
    var addTriggerRight = minusTriggerRight = halfCounterSingleWidth - 5;
    var minusTipOuterRight = counterWidth - counterSingleWidth;

    if (increment > 0) {
      // 增加的提示
      tipInlineStyle = {
        tipTriggerStyle: {
          right: addTriggerRight
        },
        tipStyle: {
          right: 0,
          borderRadius: 5
        }
      };
    } else {
      tipInlineStyle = {
        tipOuterStyle: {
          right: minusTipOuterRight
        },
        tipTriggerStyle: {
          right: minusTriggerRight
        },
        tipStyle: {
          right: 0,
          borderRadius: 5
        }
      };
    }

    this.setState({
      tooltipText: tooltipText,
      tooltip: true,
      tipInlineStyle: tipInlineStyle
    }, function () {
      clearTimeout(_this.tipTimeout);
      _this.tipTimeout = setTimeout(function () {
        _this.setState({ tooltip: false });
      }, 1000);
    });
  },
  onBtnsTap: function onBtnsTap(evt, count, increment) {
    if (evt) {
      // 解决透传问题
      evt.preventDefault();
    }
    // 连续点两次，第二次count还未更新
    if (!this.countUpdated) {
      return;
    }

    var _props = this.props,
        maximum = _props.maximum,
        minimum = _props.minimum,
        onCountChange = _props.onCountChange,
        onTouchTap = _props.onTouchTap,
        ifShowToolTip = _props.ifShowToolTip,
        _props$msg = _props.msg,
        msg = _props$msg === undefined ? {
      maximumMsg: React.createElement(_formattedMessage2.default, _global2.default.onLimitMax),
      minimumMsg: ''
    } : _props$msg;

    var maxNumber = !maximum && maximum !== 0 ? _const.MaxOrderedDishCount : maximum;
    if (Number(count + increment) > _const.MaxOrderedDishCount) {
      evt.stopPropagation();
      return false;
    }

    if (onTouchTap) onTouchTap(evt);

    // 即将变更
    this.countUpdated = false;

    if (increment > 0 && maxNumber >= count + increment) {
      return onCountChange(count + increment, increment);
    } else if (increment < 0 && count + increment >= minimum) {
      return onCountChange(count + increment, increment);
    } else if (increment < 0 && count < Math.abs(increment) && !minimum) {
      return onCountChange(0, increment);
    }

    // 未执行变更
    this.countUpdated = true;

    if (ifShowToolTip) {
      var tooltipText = increment > 0 ? msg.maximumMsg : msg.minimumMsg;
      this.showToolTip({ evt: evt, increment: increment, tooltipText: tooltipText });
      return false;
    }

    return false;
  },
  handleDishCount: function handleDishCount(evt, display, count, dishItem, shouldSendHandleDishCount) {
    if (evt) {
      evt.preventDefault();
    }
    var handleInputDOM = document.getElementById('handleInputDOM');
    var showHandleDishCount = this.props.showHandleDishCount;


    if (handleInputDOM && handleInputDOM.getAttribute('data-editable') === 'true' && dishItem) {
      // ReactDOM.render(
      //   <HandleInput dishItem={dishItem} count={count} onOrderBtnTap={this.props.onCountChange} flag={this.props.flag} display={display} />,
      //   handleInputDOM
      // );

      var intlCfg = {
        messages: window.__LANG_MESSAGES__,
        locale: sessionStorage.getItem('locale')
      };
      (0, _helper.initSingletonIntl)(intlCfg);

      ReactDOM.render(React.createElement(
        _reactIntl.IntlProvider,
        intlCfg,
        React.createElement(_handleInput2.default, {
          dishItem: dishItem,
          count: count,
          onOrderBtnTap: this.props.onCountChange,
          flag: this.props.flag,
          display: display
        })
      ), handleInputDOM);
      if (display) {
        handleInputDOM.style.display = 'block';
      }
    }
    if (showHandleDishCount && shouldSendHandleDishCount) {
      showHandleDishCount();
    }
  },
  render: function render() {
    var _this2 = this;

    var _props2 = this.props,
        count = _props2.count,
        step = _props2.step,
        maximum = _props2.maximum,
        minimum = _props2.minimum,
        hiddenNum = _props2.hiddenNum,
        dishItem = _props2.dishItem,
        onlyAddCounter = _props2.onlyAddCounter;
    var _state = this.state,
        tooltip = _state.tooltip,
        tooltipText = _state.tooltipText,
        tipInlineStyle = _state.tipInlineStyle;

    var handleInputDOM = document.getElementById('handleInputDOM');

    var className = classnames('counter ', {
      'counter-max': count === maximum || count === _const.MaxOrderedDishCount || count + step > _const.MaxOrderedDishCount,
      'counter-min': (count <= minimum || minimum && count <= step) && count !== hiddenNum,
      'counter-min--nonum': count === minimum && count === hiddenNum,
      'counter--modify': handleInputDOM && handleInputDOM.getAttribute('data-editable') === 'true' && dishItem
    });
    var countStyle = void 0;
    if (count < 10) {
      countStyle = { width: '16px' };
    } else if (count >= 10 && count <= 99) {
      countStyle = { width: '21px' };
    } else {
      countStyle = { width: '27px' };
    }
    return React.createElement(
      'div',
      { className: className, ref: 'counter' },
      !onlyAddCounter && React.createElement(
        'a',
        { className: 'counter-minus', ref: 'counterminus' },
        React.createElement('span', {
          className: 'counter-click-mask',
          onTouchTap: function onTouchTap(evt) {
            return _this2.onBtnsTap(evt, count, -step);
          }
        })
      ),
      !onlyAddCounter && React.createElement(
        'span',
        {
          className: 'counter-num',
          style: { minWidth: '25px', zIndex: 11 },
          onTouchTap: function onTouchTap(evt) {
            _this2.handleDishCount(evt, true, count, dishItem, true);
          }
        },
        count
      ),
      React.createElement(
        'a',
        { className: 'counter-add', ref: 'counteradd' },
        React.createElement(
          'span',
          {
            className: 'counter-click-mask',
            onTouchTap: function onTouchTap(evt) {
              return _this2.onBtnsTap(evt, count, step);
            },
            'data-count': count
          },
          onlyAddCounter && count > 0 && React.createElement(
            'span',
            {
              className: 'counter-click-mask--counter counter-special',
              style: countStyle
            },
            count > 99 ? '99+' : count
          )
        )
      ),
      tooltip && tooltipText && React.createElement(_tips2.default, {
        tipInlineStyle: tipInlineStyle,
        tooltipText: tooltipText,
        ref: 'tips'
      })
    );
  }
});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _const = __webpack_require__(14);

var _aesHelper = __webpack_require__(467);

var _aesHelper2 = _interopRequireDefault(_aesHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const showAlert = process.env.BUILD_ENV !== 'prod' || process.env.BUILD_ENV !== 'prodexp' || process.env.BUILD_ENV !== 'sgprod';

/* eslint-disable no-undef */
/*
 * @Author: snail
 * @Date: 2020-03-25 16:47:18
 * @Last Modified by: snail
 * @Last Modified time: 2020-05-28 09:52:20
 * 美食岛App相关api
 */

var getScriptPath = function getScriptPath() {
  return ((document.currentScript ? document.currentScript.src : '') || './').replace(/[^\/]*\.js$/, '');
};

var I_PARK_JS_BRIDGE_ID = 'iParkJSBridgeScript';
var I_PARK_JS_BRIDGE_PATH = getScriptPath() + 'iParkJSBridge.js';

var REFUND_ORDER_NOTIFY_URL = "https://custom.keruyun.com" + '/v1/msd/upPlus/orderStatusNotify';

var iParkJsMethod = {
  closePage: { isSupportParams: false, isSupportCallBack: false },
  reloadPage: { isSupportParams: false, isSupportCallBack: false },
  setActionBarStyle: { isSupportParams: true, isSupportCallBack: false },
  getLoginUserInfo: { isSupportParams: true, isSupportCallBack: true },
  placeOrder: { isSupportParams: true, isSupportCallBack: true },
  queryOrder: { isSupportParams: true, isSupportCallBack: true },
  refundOrder: { isSupportParams: true, isSupportCallBack: true }
};

var getCallBackFun = function getCallBackFun(method, params, resolve, reject) {
  var isSuccess = function isSuccess(result) {
    var _ref = result || {},
        _ref$errorCode = _ref.errorCode,
        errorCode = _ref$errorCode === undefined ? '' : _ref$errorCode,
        _ref$data = _ref.data,
        data = _ref$data === undefined ? {} : _ref$data;
    // if (showAlert) {
    //   alert(`回调成功与否拦截器，method：${method};params:${params};errorCode:${errorCode}`);
    // }


    if (method === 'placeOrder') {
      var status = data.status;

      return errorCode === 200 && status === 'TRADE_SUCCESS';
    }
    return errorCode === 200;
  };

  var isWillDeal = function isWillDeal(result) {
    var _ref2 = result || {},
        _ref2$errorCode = _ref2.errorCode,
        errorCode = _ref2$errorCode === undefined ? '' : _ref2$errorCode,
        _ref2$data = _ref2.data,
        data = _ref2$data === undefined ? {} : _ref2$data;

    if (method === 'placeOrder') {
      var status = data.status;

      if (errorCode === 200 && (status === 'NEW_ORDER' || status === 'WAIT_BUYER_PAY' || status === 'UNKNOWN')) return false;
    }
    return true;
  };

  return function (result) {
    var _result = typeof result === 'string' ? JSON.parse(result || '') : result;

    var _ref3 = _result || {},
        _ref3$errorCode = _ref3.errorCode,
        errorCode = _ref3$errorCode === undefined ? '' : _ref3$errorCode,
        _ref3$msg = _ref3.msg,
        msg = _ref3$msg === undefined ? '未知异常' : _ref3$msg,
        _ref3$data = _ref3.data,
        data = _ref3$data === undefined ? {} : _ref3$data;

    if (!isWillDeal(_result)) return;
    if (isSuccess(_result)) {
      resolve(data);
    } else {
      // if (showAlert) {
      //   alert(_result.toString());
      // }
      reject(new Error('[' + errorCode + ']:' + msg));
    }
  };
};

var iParkPlugin = {
  init: function init() {
    return new _promise2.default(function (resolve, reject) {
      if (!!document.querySelector('#' + I_PARK_JS_BRIDGE_ID)) resolve();

      var dom = document.createElement('script');
      dom.id = I_PARK_JS_BRIDGE_ID;
      dom.src = I_PARK_JS_BRIDGE_PATH;
      dom.async = true;
      dom.defer = true;

      document.body.appendChild(dom);

      dom.addEventListener('load', function () {
        dom = null;
        resolve();
      });

      dom.addEventListener('error', function () {
        reject(new Error('加载iParkJSBridge失败'));
      });
    });
  },
  getMethodInfo: function getMethodInfo(method) {
    if (!iParkJsMethod.hasOwnProperty(method)) throw new Error('iParkJSBridge不支持该方法');
    return iParkJsMethod[method];
  },
  _call: function _call(method, params) {
    return new _promise2.default(function (resolve, reject) {
      try {
        var _iParkPlugin$getMetho = iParkPlugin.getMethodInfo(method),
            isSupportParams = _iParkPlugin$getMetho.isSupportParams,
            isSupportCallBack = _iParkPlugin$getMetho.isSupportCallBack;

        var envErrorMsg = '环境异常(请在美食岛APP中使用)';
        window.iParkCallback = isSupportCallBack ? getCallBackFun(method, params, resolve, reject) : null;
        var _param = isSupportCallBack && !params ? {} : params;
        if (!isSupportParams && !isSupportCallBack) {
          var res = iParkJSBridge.call(method);
          if (res === false) reject(envErrorMsg);
          resolve();
        } else if (!isSupportParams && !!isSupportCallBack) {
          var _res = iParkJSBridge.call(method, _param, window.iParkCallback);
          if (_res === false) reject(envErrorMsg);
        } else if (!!isSupportParams && !isSupportCallBack) {
          var _res2 = iParkJSBridge.call(method, _param);
          if (_res2 === false) reject(envErrorMsg);
          resolve();
        } else if (!!isSupportParams && !!isSupportCallBack) {
          var _res3 = iParkJSBridge.call(method, _param, window.iParkCallback);
          if (_res3 === false) reject(envErrorMsg);
        }
      } catch (ex) {
        reject(ex);
      }
    });
  },
  call: function call(method, params) {
    return iParkPlugin.init().then(function (data) {
      return iParkPlugin._call(method, params);
    });
  }
};

var iParkHelper = {
  /**
   * 获取iPark用户信息
   * {
   * userId	String	用户Id
   * mobilePhone	String	手机号码
   * nickName	String	昵称
   * headPhoto	String	用户头像地址
   * }
   * @returns Promise
   */
  getUserInfo: function getUserInfo() {
    if (false) {
      return _promise2.default.resolve({ mobilePhone: 13699477230, userId: '1231232', nickName: '小鸟', headPhoto: 'd' });
    }
    return iParkPlugin.call('getLoginUserInfo', { needMobilePhone: true });
  },

  /**
   * 判断是否是美食岛App环境
   * @param {*} path
   */
  isIParkEvn: function isIParkEvn() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var _path = path;
    if (!_path) {
      _path = location.search || '';
    }
    var res = _path.match(/accessFrom=(.*?)(&|$)/);

    var accessFrom = window.sessionStorage ? window.sessionStorage.getItem('ACCESS_FROM') : '';
    if (res && Array.isArray(res) && res[1] === 'iParkApp' || accessFrom === 'iParkApp') {
      window.sessionStorage.setItem('ACCESS_FROM', 'iParkApp');
      return !0;
    }
    return !1;
  },


  /**
   * 登录
   */
  iParkLogin: function iParkLogin(info) {
    _aesHelper2.default.encrypt(info.mobile).then(function (mobilePhoneCiphertext) {
      var param = (0, _extends3.default)({}, info, {
        source: _const.thirdPlatformLoginSource.I_PARK_LOGIN_SOURCE,
        fromBrand: 1 // 默认是从品牌首页登录
      }, {
        mobile: mobilePhoneCiphertext
      });
      return _fetchHelper2.default.get(_config2.default.thirdPlatformLogin, param);
    });
  },


  /**
   * 获取ipark秘钥信息
   */
  getIParkSecret: function getIParkSecret() {
    return _fetchHelper2.default.get(_config2.default.getIParkSecretAPI).then(function (data) {
      var _ref4 = data || {},
          _ref4$secret = _ref4.secret,
          secret = _ref4$secret === undefined ? '' : _ref4$secret;

      return _aesHelper2.default.decrypt(secret);
    });
  },


  /**
   * 订单退款
   * @param {*} param
   */
  refundOrder: function refundOrder(param) {
    var userInfo = {};
    var secret = '';
    var promise = iParkHelper.getUserInfo().then(function (user) {
      return userInfo = user;
    }).catch(function (ex) {
      throw new Error('iPark获取用户信息失败');
    });
    var promiseSecret = iParkHelper.getIParkSecret().then(function (res) {
      secret = res;
    });
    return _promise2.default.all([promise, promiseSecret]).then(function (data) {
      var _userInfo = userInfo,
          userId = _userInfo.userId,
          mobilePhone = _userInfo.mobilePhone;

      var key = 'iPark_' + userId + '_' + mobilePhone + '_' + secret;
      var productId = param.productId;

      return iParkPlugin.call('refundOrder', (0, _assign2.default)({}, param, { key: key, notifyUrl: REFUND_ORDER_NOTIFY_URL + '?productId=' + productId }));
    }).then(function (data) {
      var type = data.type;

      if (type === 1) {
        throw new Error('订单不存在！请联系商家处理');
      }
      return data;
    });
  },


  /**
   * 唤起支付插件
   * @param param {
   * amount:number  订单金额,单位【分】；注意⚠️！！！一定要以【分】为单位传入，且不允许有小数！比如10.1元，那么就是 10.1*100=1010
   * productId:string  商品号id
   * productType:String 下单商品类型: 1会议订单支付、2临时停车缴费、3月卡充值、4美食岛下单
   * key:String 支付key，格式（iPark_用户ID_手机号_secret）组建的字符串 ,secret另行提供（secret属于唯一鉴别调用方的私钥，请务必妥善保管）
   * }
   *
   * @return result {
   *    merOrderId  下单成功后的单号
   *    status  下单支付结果，具体查看：下单结果状态说明
   * }
   *
   * 取值	说明
   * NEW_ORDER	新订单
   * UNKNOWN	不明确的交易状态
   * TRADE_CLOSED	在指定时间段内未支付时关闭的交易;在交易完成全额退款成功时关闭的交易;支付失败的交易。 TRADE_CLOSED的交易不允许进行任何操作。
   * WAIT_BUYER_PAY	交易创建，等待买家付款
   * TRADE_SUCCESS	支付成功
   * TRADE_REFUND	订单转入退货流程，退货可能是部分也可能是全部。
   */
  invokePayPlugin: function invokePayPlugin(param) {
    var userInfo = {};
    var secret = '';
    var promise = iParkHelper.getUserInfo().then(function (user) {
      return userInfo = user;
    }).catch(function (ex) {
      throw new Error('iPark获取用户信息失败');
    });
    var promiseSecret = iParkHelper.getIParkSecret().then(function (res) {
      secret = res;
    });

    return _promise2.default.all([promise, promiseSecret]).then(function () {
      var _userInfo2 = userInfo,
          _userInfo2$userId = _userInfo2.userId,
          userId = _userInfo2$userId === undefined ? '' : _userInfo2$userId,
          _userInfo2$mobilePhon = _userInfo2.mobilePhone,
          mobilePhone = _userInfo2$mobilePhon === undefined ? '' : _userInfo2$mobilePhon;

      var newParam = (0, _extends3.default)({}, param, {
        key: 'iPark_' + userId + '_' + mobilePhone + '_' + secret,
        notifyUrl: '' + REFUND_ORDER_NOTIFY_URL
      });
      return iParkPlugin.call('placeOrder', newParam);
    }).catch(function (ex) {
      throw ex;
    });
  }
};

exports.default = iParkHelper;

/***/ }),
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(18))(337);

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-undef */
/*
 * @Author: snail
 * @Date: 2020-04-02 10:19:34
 * @Last Modified by: snail
 * @Last Modified time: 2020-04-03 09:06:34
 */

var getScriptPath = function getScriptPath() {
  return ((document.currentScript ? document.currentScript.src : '') || './').replace(/[^\/]*\.js$/, '');
};

var AES_SCRIPT_ID = 'aesScript';
var AES_SCRIPT_PATH = getScriptPath() + 'aes-min.js';

var AES_KEY = '';
var AES_IV = '';

var aesPlugin = {
  init: function init() {
    return new _promise2.default(function (resolve, reject) {
      if (!!document.querySelector('#' + AES_SCRIPT_ID)) resolve();

      var dom = document.createElement('script');
      dom.id = AES_SCRIPT_ID;
      dom.src = AES_SCRIPT_PATH;
      dom.async = true;
      dom.defer = true;

      document.body.appendChild(dom);

      dom.addEventListener('load', function () {
        dom = null;
        resolve();
      });

      dom.addEventListener('error', function () {
        reject(new Error('加载aes.js失败'));
      });
    });
  },

  /**
   * 生成key和iv
   */
  generateKeyAndIv: function generateKeyAndIv() {
    return aesPlugin.init().then(function (data) {
      if (!AES_KEY || !AES_IV) {
        AES_KEY = CryptoJS.enc.Utf8.parse('kryPortalABEFCDG'); // 十六位十六进制数作为密钥
        AES_IV = CryptoJS.enc.Utf8.parse('ABCDE1FKryPortal'); // 十六位十六进制数作为密钥偏移量
      }

      return { key: AES_KEY, iv: AES_IV };
    });
  },

  /**
   * 解密
   * @param {*}} word
   */
  decrypt: function decrypt(word) {
    return aesPlugin.generateKeyAndIv().then(function (data) {
      var key = data.key,
          iv = data.iv;

      var decrypted = CryptoJS.AES.decrypt(word, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      return decrypted.toString(CryptoJS.enc.Utf8);
    }).catch(function (ex) {
      throw new Error('解密失败');
    });
  },


  /**
   * 加密
   * @param {*} word
   */
  encrypt: function encrypt(word) {
    var _word = typeof word === 'string' ? word : word.toString();
    return aesPlugin.generateKeyAndIv().then(function (data) {
      var key = data.key,
          iv = data.iv;

      var encrypted = CryptoJS.AES.encrypt(_word, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    }).catch(function (ex) {
      throw new Error('加密失败');
    });
  }
};

var aesHelper = {
  decrypt: aesPlugin.decrypt,
  encrypt: aesPlugin.encrypt
};

exports.default = aesHelper;

/***/ }),
/* 468 */,
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _commonHelper = __webpack_require__(3);

var _wxClientHelper = __webpack_require__(444);

var _const = __webpack_require__(14);

var _share = __webpack_require__(470);

var _share2 = _interopRequireDefault(_share);

var _defaultMember = __webpack_require__(471);

var _defaultMember2 = _interopRequireDefault(_defaultMember);

var _defaultDish = __webpack_require__(472);

var _defaultDish2 = _interopRequireDefault(_defaultDish);

var _httpRequestHelper = __webpack_require__(84);

var _httpRequestHelper2 = _interopRequireDefault(_httpRequestHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(72);
__webpack_require__(71);

var params = (0, _commonHelper.getUrlParams)() || {};
var shopId = params.shopId;

var search = location.search;

// 配置 title link  imgUrl
function getConfigItem(entry) {
  switch (entry) {
    case _const.WxSharEventEntry.SHOP:
      return _promise2.default.resolve({
        title: '门店首页',
        desc: '这家店的东西都很不错~一定有你喜欢的',
        link: _config2.default.shopDetailURL + '?shopId=' + shopId,
        imgUrl: _share2.default
      });

    case _const.WxSharEventEntry.DETAIL:
      {
        return _promise2.default.resolve({
          title: document.title, // '商品详情页',
          desc: '好东西，一定要分享啦',
          link: '' + _config2.default.goodsDetailURL + search,
          imgUrl: _defaultDish2.default
        });
      }

    case _const.WxSharEventEntry.MEMBER:
      return _httpRequestHelper2.default.get(_config2.default.indexAPI, { shopId: shopId }).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (res.code !== '200') {
          return {};
        }

        return {
          title: '会员注册页',
          desc: '\u6210\u4E3A[' + res.data.brand.name + ']\u4F1A\u5458\uFF0C\u4EAB\u53D7\u4F1A\u5458\u4E13\u5C5E\u6743\u76CA',
          link: _config2.default.registerMemberURL + '?shopId=' + shopId,
          imgUrl: _defaultMember2.default
        };
      });

    case _const.WxSharEventEntry.BRAND:
      {
        return _promise2.default.resolve({
          title: '品牌首页',
          desc: '这家店的东西都很不错~一定有你喜欢的',
          link: _config2.default.brandIndexURL + '?shopId=' + shopId,
          imgUrl: _share2.default
        });
      }

    default:
      return _promise2.default.resolve({});
  }
}

var initWXShareEventWithConfig = function initWXShareEventWithConfig(args, callBack) {
  var entry = args.entry,
      _this = args._this;


  if (_this.initSharEvent) {
    return;
  }

  _this.initSharEvent = true;

  var shareConfigObj = getConfigItem(entry);
  // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
  var shareTimeline = function shareTimeline(wx) {
    if (wx.onMenuShareTimeline) {
      shareConfigObj.then(function (res) {
        wx.onMenuShareTimeline((0, _extends3.default)({}, res, {
          success: function success() {
            if (callBack) {
              callBack();
            }
          } // 成功回调事件
        }));
      });
    }
  };

  // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
  var shareAppMessage = function shareAppMessage(wx) {
    if (wx.onMenuShareAppMessage) {
      shareConfigObj.then(function (res) {
        wx.onMenuShareAppMessage((0, _extends3.default)({}, res, {
          success: function success() {
            if (callBack) {
              callBack();
            }
          } // 成功回调事件
        }));
      });
    }
  };

  // onMenuShareAppMessage onMenuShareTimeline
  (0, _wxClientHelper.registerWxClientEvent)(['onMenuShareAppMessage', 'onMenuShareTimeline'], {
    success: function success(wx) {
      shareTimeline(wx);
      shareAppMessage(wx);
    },
    error: function error(err) {
      console.log('公众号配置错误');
    }
  });
};

exports.initWXShareEventWithConfig = initWXShareEventWithConfig;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/share.png";

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/defaultMember.png";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/defaultDish.png";

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  shareNumber: {
    id: 'coupon.shareNumber',
    defaultMessage: '{number}份'
  },
  discoutLevel: {
    id: 'coupon.discoutLevel',
    defaultMessage: '{dishNumText}可享{discount}折'
  },
  benefit: {
    id: 'coupon.benefit',
    defaultMessage: '优惠'
  },
  switchBenefit: {
    id: 'coupon.switchBenefit',
    defaultMessage: '切换优惠'
  },
  purchaseBenefit: {
    id: 'coupon.purchaseBenefit',
    defaultMessage: '加价购满赠'
  },
  singleProductBenefit: {
    id: 'coupon.singleProductBenefit',
    defaultMessage: '单商品优惠'
  },
  notUseBenefit: {
    id: 'coupon.notUseBenefit',
    defaultMessage: '未使用优惠'
  },
  benefitCoupon: {
    id: 'coupon.benefitCoupon',
    defaultMessage: '优惠券'
  },
  cannotBeSharedWith: {
    id: 'coupon.cannotBeSharedWith',
    defaultMessage: '不可与{info}共享'
  },
  maxCouponNumPrefix: {
    id: 'coupon.maxCouponNumPrefix',
    defaultMessage: '最多可以使用'
  },
  maxCouponNumSuffix: {
    id: 'coupon.maxCouponNumSuffix',
    defaultMessage: '张优惠券'
  },
  pickedCouponNumPrefix: {
    id: 'coupon.pickedCouponNumPrefix',
    defaultMessage: '已选'
  },
  pickedCouponNumSuffix: {
    id: 'coupon.pickedCouponNumSuffix',
    defaultMessage: '张'
  },
  manjianCoupon: {
    id: 'coupon.manjianCoupon',
    defaultMessage: '满减券'
  },
  zhekouCoupon: {
    id: 'coupon.zhekouCoupon',
    defaultMessage: '折扣券'
  },
  ptlipinCoupon: {
    id: 'coupon.ptlipinCoupon',
    defaultMessage: '礼品券'
  },
  cplipinCoupon: {
    id: 'coupon.cplipinCoupon',
    defaultMessage: '商品券'
  },
  daijinCoupon: {
    id: 'coupon.daijinCoupon',
    defaultMessage: '代金券'
  },
  useRules: {
    id: 'coupon.useRules',
    defaultMessage: '使用规则'
  },
  usePeriod: {
    id: 'coupon.usePeriod',
    defaultMessage: '使用时段'
  },
  thisCoupon: {
    id: 'coupon.thisCoupon',
    defaultMessage: '本券'
  },
  distributionMode: {
    id: 'coupon.distributionMode',
    defaultMessage: '可用配送方式:'
  },
  send: {
    id: 'coupon.send',
    defaultMessage: '外卖'
  },
  self: {
    id: 'coupon.self',
    defaultMessage: '自提'
  },
  couponAvailableInSomeStores: {
    id: 'coupon.availableInSomeStores',
    defaultMessage: '部分门店可用'
  },
  couponAvailableInAllStores: {
    id: 'coupon.availableInAllStores',
    defaultMessage: '全部门店可用'
  },
  couponViewUseableStores: {
    id: 'coupon.viewUseableStores',
    defaultMessage: '查看适用门店'
  },
  couponAvailableStores: {
    id: 'coupon.availableStores',
    defaultMessage: '适用门店'
  },
  couponTooLate: {
    id: 'coupon.TooLate',
    defaultMessage: '来晚了，活动结束啦'
  },
  couponWarnLong: {
    id: 'coupon.couponWarnLong',
    defaultMessage: '当前选择优惠与单商品/多商品优惠不能通用，是否取消单商品/多商品优惠，选择优惠券'
  },
  couponWarnLong2: {
    id: 'coupon.couponWarnLong2',
    defaultMessage: '当前选择优惠与加价购/满赠促销不能通用，是否取消加价购/满赠促销，选择优惠券'
  },
  couponWarnLong3: {
    id: 'coupon.couponWarnLong3',
    defaultMessage: '当前选择优惠与整单优惠不能通用，是否取消整单优惠，选择优惠券'
  },
  couponWarnLong4: {
    id: 'coupon.couponWarnLong4',
    defaultMessage: '当前选择优惠与单商品优惠/加价购不能通用，是否取消单商品优惠/加价购，选择优惠券'
  },
  couponShareRedBag: {
    id: 'couponShareRedBag',
    defaultMessage: '给您发红包了！数量有限，先到先得'
  },
  couponFastComeFastGet: {
    id: 'couponFastComeFastGet',
    defaultMessage: '数量有限，先到先得!'
  },
  couponUseCouponProcess: {
    id: 'couponUseCouponProcess',
    defaultMessage: '长按扫码关注>去点餐>下单使用优惠劵!'
  },
  couponFillToUse: {
    id: 'common.fillToUse',
    defaultMessage: '满{value}可用'
  },
  couponNoThreshold: {
    id: 'couponNoThreshold',
    defaultMessage: '无门槛'
  },
  couponShareToFriends: {
    id: 'couponShareToFriends',
    defaultMessage: '立即分享给好友'
  },
  couponUseNow: {
    id: 'couponUseNow',
    defaultMessage: '立即使用'
  },
  couponShareDiscount: {
    id: 'couponShareDiscount',
    defaultMessage: '分享优惠'
  },
  couponShareSuccess: {
    id: 'couponShareSuccess',
    defaultMessage: '分享成功'
  },
  couponFocus: {
    id: 'couponFocus',
    defaultMessage: '关注门店'
  }
});

/***/ }),
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  isClose: {
    id: 'shop.isClose',
    defaultMessage: '本店已经打烊啦'
  },
  hdlHasCouponIsClose: {
    id: 'shop.hdlHasCouponIsClose',
    defaultMessage: '抱歉，店铺繁忙或歇业中，暂时无法接餐，送您一张代金券'
  },

  isDisable: {
    id: 'shop.isDisable',
    defaultMessage: '暂未开放该功能'
  },
  isNotAcceptOrder: {
    id: 'shop.isNotAcceptOrder',
    defaultMessage: '该店铺临时歇业'
  },
  openFlag: {
    id: 'shop.openFlag',
    defaultMessage: '营业中'
  },
  closedFlag: {
    id: 'shop.closedFlag',
    defaultMessage: '已打烊'
  },
  deliveryFlag: {
    id: 'shop.deliveryFlag',
    defaultMessage: '商家配送'
  },
  openhour: {
    id: 'shop.openhour',
    defaultMessage: '营业时间'
  },
  deliveryFee: {
    id: 'shop.deliveryFee',
    defaultMessage: '配送费{currency}{shipmentFee}'
  },
  deliveryTime: {
    id: 'shop.deliveryTime',
    defaultMessage: '送达{sendTime}分钟'
  },
  morePrivilege: {
    id: 'shop.morePrivilege',
    defaultMessage: '更多优惠'
  },
  moreInfo: {
    id: 'shop.moreInfo',
    defaultMessage: '更多信息'
  },
  info: {
    id: 'shop.info',
    defaultMessage: '商家信息'
  },
  announcement: {
    id: 'shop.announcement',
    defaultMessage: '商家公告'
  },
  tel: {
    id: 'shop.tel',
    defaultMessage: '电话'
  },
  address: {
    id: 'shop.address',
    defaultMessage: '地址'
  },
  vipPriceAvaliableTime: {
    id: 'shop.vipPriceAvaliableTime',
    defaultMessage: '会员价生效时段'
  },
  privilegeInfo: {
    id: 'shop.privilegeInfo',
    defaultMessage: '优惠信息'
  },
  notConfig: {
    id: 'shop.notConfig',
    defaultMessage: '未配置'
  },
  unknownShop: {
    id: 'shop.unknownShop',
    defaultMessage: '未知的门店'
  },
  payconfigError: {
    id: 'pay.configError',
    defaultMessage: '公众号配置错误'
  },
  payShare: {
    id: 'pay.Share',
    defaultMessage: '点击右上角分享给好友喔'
  },
  shopOpen: {
    id: 'shop.Open',
    defaultMessage: '营业中'
  },
  shopClosed: {
    id: 'shop.Closed',
    defaultMessage: '已打烊'
  },
  shoptoTable: {
    id: 'shop.toTable',
    defaultMessage: '送餐到桌'
  },
  shopgetFoods: {
    id: 'shop.getFoods',
    defaultMessage: '前台取餐'
  },
  shopstartOrderring: {
    id: 'shop.startOrderring',
    defaultMessage: '开始点餐'
  },
  shopnewOrder: {
    id: 'shop.newOrder',
    defaultMessage: '新建订单'
  },
  shopstartPaying: {
    id: 'shop.startPaying',
    defaultMessage: '开始点餐结账'
  },
  shopunLogin: {
    id: 'shop.unLogin',
    defaultMessage: '未登录'
  },
  shopwaitFotComfirm: {
    id: 'shop.waitFotComfirm',
    defaultMessage: '等待商户确认'
  },
  shoporderConfirmed: {
    id: 'shop.orderConfirmed',
    defaultMessage: '订单已确认'
  },
  shopconfirmAddDish: {
    id: 'shop.confirmAddDish',
    defaultMessage: '等待商户确认加菜'
  },
  shoporderComplete: {
    id: 'shop.orderComplete',
    defaultMessage: '订单已完成'
  },
  shopDropped: {
    id: 'shop.Dropped',
    defaultMessage: '订单被作废'
  },
  shoporderConfused: {
    id: 'shop.orderConfused',
    defaultMessage: '订单被拒绝'
  },
  shoptobePaid: {
    id: 'shop.tobePaid',
    defaultMessage: '待支付'
  },
  shopAnonymous: {
    id: 'shop.Anonymous',
    defaultMessage: '匿名用户'
  },
  shopordered: {
    id: 'shop.ordered',
    defaultMessage: '已点'
  },
  shoporderedDish: {
    id: 'shop.orderedDish',
    defaultMessage: '份菜'
  },
  shopaddDishs: {
    id: 'shop.addDishs',
    defaultMessage: '加菜'
  },
  shopgotoPay: {
    id: 'shop.gotoPay',
    defaultMessage: '去支付'
  },
  shopcheckDetail: {
    id: 'shop.checkDetail',
    defaultMessage: '查看详情'
  },
  shoplogToNext: {
    id: 'shop.logToNext',
    defaultMessage: '登录后方可进行操作噢~'
  },
  shopgoOnOrder: {
    id: 'shop.goOnOrder',
    defaultMessage: '继续点餐'
  },
  shopaddToOrder: {
    id: 'shop.addToOrder',
    defaultMessage: '一起的，加入点餐'
  },
  shopordering: {
    id: 'shop.ordering',
    defaultMessage: '正在点餐中, 是否{methodInfoOne}？'
  },
  shopopenTime: {
    id: 'shop.openTime',
    defaultMessage: '营业时间：'
  },
  shopunConfig: {
    id: 'shop.unConfig',
    defaultMessage: '未配置'
  },
  shopNull: {
    id: 'shop.Null',
    defaultMessage: '暂无'
  },
  shopremainAddress: {
    id: 'shop.remainAddress',
    defaultMessage: '还有{num}个收货地址'
  },
  shopcloseUpAddress: {
    id: 'shop.closeUpAddress',
    defaultMessage: '收起收货地址列表'
  },
  shopyourAddress: {
    id: 'shop.yourAddress',
    defaultMessage: '您的收货地址'
  },
  shopnotSearchAddress: {
    id: 'shop.notSearchAddress',
    defaultMessage: '附近没有搜索到地址'
  },
  shopNearAddress: {
    id: 'shop.NearAddress',
    defaultMessage: '附近地址'
  },
  shoplocateFailed: {
    id: 'shop.locateFailed',
    defaultMessage: '定位失败，请手动搜索地址'
  },
  shopreGet: {
    id: 'shop.reGet',
    defaultMessage: '重新获取'
  },
  shopshowAllShop: {
    id: 'shop.showAllShop',
    defaultMessage: '查看所有门店'
  },
  shopcannotGetAddress: {
    id: 'shop.cannotGetAddress',
    defaultMessage: '无法获取地址'
  },
  shopnoShopIn5km: {
    id: 'shop.noShopIn5km',
    defaultMessage: '5公里内没有门店'
  },
  shopunSetLocation: {
    id: 'shop.unSetLocation',
    defaultMessage: '或店铺未设置位置信息'
  },
  shopnoShopInfo: {
    id: 'shop.noShopInfo',
    defaultMessage: '没有相关门店信息'
  },
  shopanonymousShop: {
    id: 'shop.anonymousShop',
    defaultMessage: '匿名门店'
  },
  shopnoStoreInfo: {
    id: 'shop.noStoreInfo',
    defaultMessage: '没有相关档口信息'
  },
  shopChanging: {
    id: 'shop.Changing',
    defaultMessage: '正在切换'
  },
  shopshopList: {
    id: 'shop.shopList',
    defaultMessage: '门店列表'
  },
  shopinputShopToSearch: {
    id: 'shop.inputShopToSearch',
    defaultMessage: '请输入要搜索的门店'
  },
  shopinputStoreToSearch: {
    id: 'shop.inputStoreToSearch',
    defaultMessage: '请输入要搜索的档口'
  },
  shopscrollToLoad: {
    id: 'shop.scrollToLoad',
    defaultMessage: '滚动加载更多门店...'
  },
  shopkrySupport: {
    id: 'shop.krySupport',
    defaultMessage: '客如云提供技术支持'
  },
  shopdistributionAble: {
    id: 'shop.distributionAble',
    defaultMessage: '可配送门店:'
  },
  shopcannotDistributeShop: {
    id: 'shop.cannotDistributeShop',
    defaultMessage: '以下门店不在配送范围内'
  },
  shopcannotDistributeAddress: {
    id: 'shop.cannotDistributeAddress',
    defaultMessage: '当前配送地址不在配送范围内哟'
  },
  loadNearShopListFailed: {
    id: 'shop.loadNearShopListFailed',
    defaultMessage: '暂无法获取附近门店信息'
  },
  shoplocateFailed2: {
    id: 'shop.locateFailed2',
    defaultMessage: '定位失败，请手动选择地址'
  },
  shopnoStoreNearby: {
    id: 'shop.noStoreNearby',
    defaultMessage: '附近没有可为您服务的档口哟'
  },
  shopnoShopNearby: {
    id: 'shop.noShopNearby',
    defaultMessage: '附近没有可为您服务的门店哟'
  },
  shoplocateFailedMSG: {
    id: 'shop.locateFailedMSG',
    defaultMessage: '定位失败啦'
  },
  shopturnOff: {
    id: 'shop.turnOff',
    defaultMessage: '已关闭'
  },
  shopinputTakeOutShop: {
    id: 'shop.inputTakeOutShop',
    defaultMessage: '请输入外送门店'
  },
  shopinputSelfPick: {
    id: 'shop.inputSelfPick',
    defaultMessage: '请输入自提门店'
  },
  shopdropToLoadShop: {
    id: 'shop.dropToLoadShop',
    defaultMessage: '下拉加载更多门店...'
  },
  shopnotSearchAddressPrompt: {
    id: 'shop.notSearchAddressPrompt',
    defaultMessage: '没搜到您说的地址哟'
  },
  shopclickToChangeCity: {
    id: 'shop.clickToChangeCity',
    defaultMessage: '点我切换城市'
  },
  shopclickToLocate: {
    id: 'shop.clickToLocate',
    defaultMessage: '点击定位当前位置'
  },
  wantToJoin: {
    id: 'shop.wantToJoin',
    defaultMessage: '要加入'
  },
  sendDate: {
    id: 'shop.sendDate',
    defaultMessage: '{month}月{day}日 {startTime}开始配送'
  },
  sendDateToday: {
    id: 'shop.sendDateToday',
    defaultMessage: '{startTime}开始配送'
  },
  acceptPreOrderIng: {
    id: 'shop.acceptPreOrderIng',
    defaultMessage: '接受预定{ing}'
  }
});

/***/ }),
/* 478 */,
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);
var Dialog = __webpack_require__(271);

__webpack_require__(481);

module.exports = React.createClass({
  displayName: 'MessageDialog',
  propTypes: {
    btnText: React.PropTypes.any,
    children: React.PropTypes.any,
    onCancel: React.PropTypes.func,
    onConfirm: React.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {};
  },
  onConfirm: function onConfirm(evt) {
    if (evt) {
      evt.preventDefault();
    }

    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  },
  onCancel: function onCancel(evt) {
    if (evt) {
      evt.preventDefault();
    }
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  },
  render: function render() {
    var btnText = this.props.btnText;

    var buttons = [{
      text: btnText,
      className: 'dialog-btn',
      onClick: this.onConfirm
    }];

    return React.createElement(
      Dialog,
      {
        theme: 'sliver',
        onClose: this.onCancel,
        buttons: buttons,
        className: 'message-dialog'
      },
      this.props.children
    );
  }
});

/***/ }),
/* 480 */,
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var keys = __webpack_require__(658);
var hasBinary = __webpack_require__(567);
var sliceBuffer = __webpack_require__(660);
var after = __webpack_require__(661);
var utf8 = __webpack_require__(662);

var base64encoder;
if (global && global.ArrayBuffer) {
  base64encoder = __webpack_require__(663);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(664);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if ('function' == typeof supportsBinary) {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if ('function' == typeof utf8encode) {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (global.ArrayBuffer && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (Blob && data instanceof global.Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data)) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    packet.data = fr.result;
    exports.encodePacket(packet, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (Blob && packet.data instanceof global.Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += global.btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data == 'string') {
    if (data.charAt(0) == 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data);
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary == 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, true, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data != 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data == '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = ''
    , n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (':' != chr) {
      length += chr;
    } else {
      if ('' == length || (length != (n = Number(length)))) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      msg = data.substr(i + 1, n);

      if (length != msg.length) {
        // parser error - ignoring payload
        return callback(err, 0, 1);
      }

      if (msg.length) {
        packet = exports.decodePacket(msg, binaryType, true);

        if (err.type == packet.type && err.data == packet.data) {
          // parser error in individual packet - ignoring payload
          return callback(err, 0, 1);
        }

        var ret = callback(packet, i + n, l);
        if (false === ret) return;
      }

      // advance cursor
      i += n;
      length = '';
    }
  }

  if (length != '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  var numberTooLong = false;
  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] == 255) break;

      if (msgLength.length > 310) {
        numberTooLong = true;
        break;
      }

      msgLength += tailArray[i];
    }

    if(numberTooLong) return callback(err, 0, 1);

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _buildOrderBtn = __webpack_require__(494);

var _buildOrderBtn2 = _interopRequireDefault(_buildOrderBtn);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _const = __webpack_require__(14);

var _commonHelper = __webpack_require__(3);

var _industryHelper = __webpack_require__(489);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var classnames = __webpack_require__(50);
var helper = __webpack_require__(43);

var shallowCompare = __webpack_require__(120);
var shopId = helper.getUrlParam('shopId');
var type = helper.getUrlParam('type');

__webpack_require__(499);

module.exports = React.createClass({
  displayName: 'DishListItem',
  contextTypes: {
    brandType: React.PropTypes.string
  },
  propTypes: {
    dishData: React.PropTypes.object.isRequired,
    sameRuleDishList: React.PropTypes.array,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    onImageBtnTap: React.PropTypes.func.isRequired,
    diningForm: React.PropTypes.number,
    marketList: React.PropTypes.object,
    theme: React.PropTypes.string,
    highLightName: React.PropTypes.string,
    hotTag: React.PropTypes.bool,
    num: React.PropTypes.number,
    showHandleInput: React.PropTypes.func,
    isFromSearch: React.PropTypes.bool, // 是否来自于搜索
    onlyAddCounter: React.PropTypes.bool,
    needImgWidth: React.PropTypes.number,
    isHDL: React.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {};
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  onBtnTap: function onBtnTap(newCount, increment) {
    var _props = this.props,
        dishData = _props.dishData,
        onOrderBtnTap = _props.onOrderBtnTap,
        onPropsBtnTap = _props.onPropsBtnTap;
    // const count = helper.getDishesCount([dishData])
    // if (increment < 0 && dishData.id == sessionStorage.getItem('reducePriceKey') && count-1 < 1) {
    //   sessionStorage.removeItem('reducePriceKey');
    //   sessionStorage.removeItem('reducePrice');
    //   localStorage.removeItem('lastOrderedDishes')
    // }

    if (increment) {
      onOrderBtnTap(dishData, increment);
    } else {
      onPropsBtnTap(dishData);
    }
    this.saveSearchHistory(dishData);
  },
  saveSearchHistory: function saveSearchHistory(dishData) {
    var isFromSearch = this.props.isFromSearch;


    if (isFromSearch) {
      var obj = {};
      obj[shopId] = dishData.name;
      var searchedDataFromLocalHistory = JSON.parse(localStorage.searchedDataFromLocalHistory || '{}');
      var sd = searchedDataFromLocalHistory[shopId];
      var sdArray = (searchedDataFromLocalHistory[shopId] || '').split(',');

      if (sd) {
        var position = sdArray.indexOf(dishData.name);
        if (position !== -1) {
          // 如果找到了就提前
          delete sdArray[position];
          sd = sdArray.filter(function (item) {
            return !!item;
          }).join(',');
        }

        var fillsd = ',' + sd;
        if (!sd) {
          fillsd = '';
        }

        searchedDataFromLocalHistory[shopId] = ('' + dishData.name + fillsd).split(',').slice(0, 15).join(',');
        localStorage.searchedDataFromLocalHistory = (0, _stringify2.default)(searchedDataFromLocalHistory);
      } else {
        localStorage.searchedDataFromLocalHistory = (0, _stringify2.default)((0, _assign2.default)({}, searchedDataFromLocalHistory, obj));
      }
    }
  },
  onDishImageTap: function onDishImageTap() {
    var _props2 = this.props,
        dishData = _props2.dishData,
        onImageBtnTap = _props2.onImageBtnTap;

    location.hash = '#dish-desc';
    onImageBtnTap(dishData);

    this.saveSearchHistory(dishData);
  },
  isShowMemberFlag: function isShowMemberFlag() {
    var dishData = this.props.dishData;


    return dishData.isMember && !dishData.isUserMember;
  },
  showHandleDishCount: function showHandleDishCount() {
    var dishData = this.props.dishData;

    this.saveSearchHistory(dishData);
  },
  buildDishName: function buildDishName(dishData) {
    if (helper.isSingleDishWithoutProps(dishData) && Array.isArray(dishData.dishPropertyTypeInfos) && dishData.dishPropertyTypeInfos.length) {
      var properties = dishData.dishPropertyTypeInfos.map(function (prop) {
        return prop.properties[0].name;
      }).join(', ');
      return dishData.name + ' ' + properties + '/' + dishData.unitName;
    }

    return dishData.name;
  },
  buildDishSoldNum: function buildDishSoldNum(dishData) {
    var soldNum = parseInt(dishData.soldNum, 10);

    if (!soldNum || soldNum === 0) {
      return false;
    }

    return React.createElement(
      'span',
      { className: 'dish-sales-volume' },
      React.createElement(_formattedMessage2.default, _dishMenu2.default.monthlySales),
      soldNum
    );
  },


  // 判断是否是套餐商品
  isDishMultiInfo: function isDishMultiInfo(dishData) {
    if (dishData && dishData['@type'] && dishData['@type'] === 'dishMultiInfo') {
      return true;
    }
    return false;
  },
  renderPrivInfo: function renderPrivInfo() {
    var _props3 = this.props,
        theme = _props3.theme,
        dishData = _props3.dishData;

    var _ref = dishData || {},
        _ref$marketingInfos = _ref.marketingInfos,
        marketingInfos = _ref$marketingInfos === undefined ? [] : _ref$marketingInfos;

    if (theme !== _const.DishTheme.DEFAULT || !marketingInfos.length) {
      return false;
    }

    return React.createElement(
      'p',
      { className: 'dish-item-priv-info o-fz--11' },
      marketingInfos.map(function (name) {
        return React.createElement(
          'span',
          { key: name },
          name
        );
      })
    );
  },
  renderHDLPrivInfo: function renderHDLPrivInfo(sameRuleDishList, dishData) {
    var theme = this.props.theme;

    var _ref2 = dishData || {},
        _ref2$singleMarketing = _ref2.singleMarketingInfos,
        singleMarketingInfos = _ref2$singleMarketing === undefined ? [] : _ref2$singleMarketing,
        isMember = _ref2.isMember;

    if (theme !== _const.DishTheme.DEFAULT || !singleMarketingInfos.length || isMember) {
      return false;
    }
    var memberPrice = dishData.isMember && '' + helper.getDishMemberPriceWithSameRuleDishes(dishData, sameRuleDishList) || 0;
    var formateSingleMarketingInfos = singleMarketingInfos.map(function (info) {
      var reduceTotal = 0;
      switch (info.type) {
        case _const.SiglePrivTypes.DISCOUNT:
          reduceTotal = dishData.isMember && memberPrice > 0 ? memberPrice * (1 - info.value * 0.1) : dishData.marketPrice * (1 - info.value * 0.1);
          break;
        case _const.SiglePrivTypes.REDUCE:
          reduceTotal = info.value;
          break;
        default:
          break;
      }

      return (0, _extends3.default)({}, info, { reduceTotal: reduceTotal });
    });

    var _concat$sort$ = [].concat(formateSingleMarketingInfos).sort(function (a, b) {
      return b.reduceTotal - a.reduceTotal;
    })[0],
        reduceName = _concat$sort$.name,
        reduceTotal = _concat$sort$.reduceTotal;


    return {
      part: React.createElement(
        'p',
        { className: 'dish-item-priv-info o-fz--11' },
        reduceName
      ),
      reduceTotal: reduceTotal
    };
  },


  /**
   * 价格展示
   * 如果不是会员
   *    如果 是海底捞 并且 singlePrice 存在。
   */
  buildDishPriceElement: function buildDishPriceElement(dishData, sameRuleDishList, theme, isHDL, industry) {
    var _this = this;

    var marketPrice = dishData.marketPrice,
        discountType = dishData.discountType,
        discountValue = dishData.memberPrice;

    var pricePostfix = dishData.mergedMinPrice ? (0, _helper.formatMessage)(_dishMenu2.default.priceFrom) : '';
    var pricePostfixElem = dishData.mergedMinPrice ? React.createElement(
      'small',
      null,
      (0, _helper.formatMessage)(_dishMenu2.default.priceFrom),
      ' '
    ) : false;
    var priceMultiInfoPostfix = React.createElement(
      'small',
      null,
      (0, _helper.formatMessage)(_dishMenu2.default.priceFrom),
      ' '
    );
    var isShowMemberFlag = this.isShowMemberFlag();
    var memberPriceTag = this.buildMemberPriceTag(dishData, sameRuleDishList);

    var buildElements = function buildElements() {
      var singlePrice = _this.renderHDLPrivInfo(sameRuleDishList, dishData).reduceTotal;
      if (!dishData.isMember) {
        if (isHDL && singlePrice) {
          return React.createElement(
            'p',
            null,
            React.createElement(
              'span',
              { className: 'dish-item-price-number price' },
              (0, _commonHelper.formatPrice)(marketPrice - singlePrice),
              _this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfixElem,
              dishData.isMember && _this.props.hotTag && memberPriceTag
            ),
            React.createElement(
              'span',
              { className: 'dish-item-price-number price-after' },
              React.createElement(
                'i',
                { className: 'price' },
                marketPrice,
                _this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfix
              )
            )
          );
        }
        return React.createElement(
          'p',
          null,
          React.createElement(
            'span',
            { className: 'dish-item-price-number dish-item-price-nosub price' },
            marketPrice,
            _this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfixElem,
            dishData.isMember && _this.props.hotTag && memberPriceTag
          )
        );
      }

      var memberPrice = '' + helper.getDishMemberPriceWithSameRuleDishes(dishData, sameRuleDishList);
      var prices = [memberPrice, marketPrice];
      if (isShowMemberFlag) {
        prices.reverse();
      }
      var main = prices[0],
          sub = prices[1];

      return React.createElement(
        'p',
        null,
        React.createElement(
          'span',
          { className: 'dish-item-price-number price' },
          main,
          _this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfixElem,
          dishData.isMember && _this.props.hotTag && memberPriceTag
        ),
        React.createElement(
          'span',
          { className: 'dish-item-price-number price-after' },
          isShowMemberFlag ? '' : React.createElement(
            'i',
            { className: 'price' },
            sub,
            _this.isDishMultiInfo(dishData) ? priceMultiInfoPostfix : pricePostfix
          )
        ),
        industry === _const.INDUSTRY.TEA && !isShowMemberFlag && (discountType === 1 || discountType === 3) && !!discountValue && React.createElement(
          'span',
          { className: 'dish-item-discount-info' },
          (0, _helper.formatMessage)(_dishMenu2.default.dishMenuGetVipPrice, {
            discountValue: discountValue
          })
        )
      );
    };

    return React.createElement(
      'span',
      {
        className: classnames('dish-item-price', {
          'dish-item-price-flag': isShowMemberFlag
        })
      },
      buildElements()
    );
  },


  /**
   * 构建会员价格标签
   */
  buildMemberPriceTag: function buildMemberPriceTag(dishData, sameRuleDishList) {
    var isShowMemberFlag = this.isShowMemberFlag();
    if (!isShowMemberFlag) {
      return null;
    }

    var pricePostfix = dishData.mergedMinPrice ? (0, _helper.formatMessage)(_dishMenu2.default.priceFrom) : '';
    var price = helper.getDishMemberPriceWithSameRuleDishes(dishData, sameRuleDishList);

    return React.createElement(
      'p',
      { className: 'dish-member-price-tag' },
      (0, _helper.formatMessage)(_global2.default.vipPrice),
      React.createElement(
        'i',
        { className: 'price' },
        price,
        pricePostfix
      )
    );
  },
  highLightName: function highLightName(name, nameWithUnit) {
    var nameWithUnitArray = [];
    var highLightName = this.props.highLightName;


    if (highLightName) {
      if (nameWithUnit) {
        nameWithUnitArray = nameWithUnit.split(name);
      }
      // 给高亮颜色
      var newArray = name.split(highLightName);
      var positions = [];
      var searchSubStr = function searchSubStr(str, subStr) {
        var pos = str.indexOf(subStr);
        while (pos > -1) {
          positions.push(pos);
          pos = str.indexOf(subStr, pos + 1);
        }
      };

      searchSubStr(name, highLightName);

      if (positions && positions.length > 0) {
        positions.forEach(function (item, index) {
          newArray.splice(item - newArray[0].length - 1, 0, React.createElement(
            'span',
            { className: 'o-search-keyword' },
            highLightName
          ));
        });
        var totalArray = newArray.map(function (item, index) {
          return React.createElement(
            'span',
            { key: index },
            item
          );
        });
        totalArray.push(nameWithUnitArray[1]);
        return totalArray;
      }
    }

    return nameWithUnit || name;
  },
  render: function render() {
    var industry = (0, _industryHelper.getIndustryFromBody)();
    var _props4 = this.props,
        dishData = _props4.dishData,
        sameRuleDishList = _props4.sameRuleDishList,
        theme = _props4.theme,
        changeShowDataItems = _props4.changeShowDataItems,
        showHandleInput = _props4.showHandleInput,
        onlyAddCounter = _props4.onlyAddCounter,
        needImgWidth = _props4.needImgWidth,
        isHDL = _props4.isHDL;

    var isClear = sameRuleDishList ? sameRuleDishList.every(function (dish) {
      return dish.clearStatus;
    }) : dishData.clearStatus;
    var imgUrl = theme === _const.DishTheme.HUGE || _const.DishTheme.BIG ? dishData.largeImgList && dishData.largeImgList[0] : dishData.smallImgUrl;
    var dishImageStyle = imgUrl && dishData ? {
      backgroundImage: 'url(' + _httpsProtocolImage2.default.getFinalImageUrl(imgUrl) + ')',
      height: needImgWidth
    } : { height: needImgWidth };
    var dishSoldNum = this.buildDishSoldNum(dishData);
    var memberPriceTag = this.buildMemberPriceTag(dishData, sameRuleDishList);

    var marginStyle = {};
    if (theme === _const.DishTheme.BIG) {
      marginStyle = this.props.num % 2 !== 0 ? { marginLeft: '10px' } : { marginRight: '10px' };
    }
    if (theme === _const.DishTheme.HUGE) {
      marginStyle = { marginLeft: '15px', marginRight: '15px' };
    }
    var enableSaleNum = (type === 'WM' ? dishData.residueTotalWechat : dishData.residueTotal) || 0;
    var showSaleNum = sessionStorage.getItem('showSaleNum') === 'true' || false; // 是否开启了商品余量展示开关
    var isShowRemainderTip = enableSaleNum <= 10 && enableSaleNum > 0 && showSaleNum;

    return React.createElement(
      'div',
      { className: 'dish-on-selling', style: marginStyle },
      dishData.currRemainTotal !== 0 && React.createElement(
        'div',
        { className: classnames('dish-list-item', { soldout: isClear }) },
        React.createElement(
          'div',
          {
            className: classnames('dish-item-img', {
              'is-memberdish': industry !== _const.INDUSTRY.TEA && dishData.isMember
            }, {
              'dish-img-default': (!dishData.largeImgList || dishData.largeImgList.length === 0) && !dishData.smallImgUrl
            }),
            onTouchTap: this.onDishImageTap,
            style: dishImageStyle
          },
          isShowRemainderTip && React.createElement(
            'div',
            { className: 'dish-item-img-residue' },
            React.createElement(_formattedMessage2.default, _global2.default.onlyLeft),
            ' ',
            enableSaleNum + ' ' + dishData.unitName
          )
        ),
        React.createElement(
          'div',
          { className: 'dish-item-content' },
          React.createElement(
            'div',
            { className: 'dish-item-main-body' },
            React.createElement(
              'div',
              { className: 'dish-item-fill' },
              React.createElement(
                'span',
                { className: 'dish-item-name' },
                dishData.sameDishIndexs ? React.createElement(
                  'span',
                  null,
                  this.highLightName(dishData.name),
                  dishData.unitName !== '份' ? '/' + dishData.unitName : ''
                ) : this.highLightName(dishData.name, helper.generateDishNameWithUnit(dishData, 'dishMenu'))
              ),
              (industry === _const.INDUSTRY.TEA || industry === _const.INDUSTRY.NORMAL) && theme === _const.DishTheme.DEFAULT && !!dishData.dishDesc && React.createElement(
                'span',
                { className: 'dish-item-desc' },
                dishData.dishDesc
              ),
              dishSoldNum
            ),
            React.createElement(
              'div',
              { className: 'dish-item-bottom' },
              React.createElement(
                'div',
                { className: 'dish-price-container' },
                this.buildDishPriceElement(dishData, sameRuleDishList, theme, isHDL, industry),
                React.createElement(_buildOrderBtn2.default, {
                  dishData: dishData,
                  sameRuleDishList: sameRuleDishList,
                  isClear: isClear,
                  changeShowDataItems: changeShowDataItems,
                  showHandleInput: showHandleInput,
                  showHandleDishCount: this.showHandleDishCount,
                  onBtnTap: this.onBtnTap,
                  onlyAddCounter: onlyAddCounter
                })
              ),
              dishData.isMember && !this.props.hotTag && memberPriceTag
            )
          ),
          React.createElement(
            'div',
            { className: 'dish-item-ext' },
            isHDL ? this.renderHDLPrivInfo().part : this.renderPrivInfo()
          )
        )
      )
    );
  }
});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIndustryFromBody = exports.setIndustryToBody = exports.getIndustryBodyClassName = undefined;

var _const = __webpack_require__(14);

var INDUSTRY_PREFIX = 'industry-';

function getIndustryBodyClassName(industry) {
  return '' + INDUSTRY_PREFIX + industry;
}

function setIndustryToBody(industry) {
  var industryName = getIndustryBodyClassName(industry);
  document.body.className = document.body.className + ' ' + industryName;
}

function getIndustryFromBody() {
  var cn = document.body.className || '';
  var cnAry = cn.split(' ');
  var res = _const.INDUSTRY.NORMAL;
  cnAry.forEach(function (item) {
    var idx = item.indexOf(INDUSTRY_PREFIX);
    if (idx !== -1) {
      res = item.substr(idx + INDUSTRY_PREFIX.length);
      return res;
    }
  });
  return res;
}

exports.getIndustryBodyClassName = getIndustryBodyClassName;
exports.setIndustryToBody = setIndustryToBody;
exports.getIndustryFromBody = getIndustryFromBody;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 491 */,
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _activeScrollSelect = __webpack_require__(460);

var _activeScrollSelect2 = _interopRequireDefault(_activeScrollSelect);

var _helper = __webpack_require__(16);

var _button = __webpack_require__(409);

var _button2 = _interopRequireDefault(_button);

__webpack_require__(495);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FloatingScrollSelector = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FloatingScrollSelector, _Component);

  function FloatingScrollSelector(props) {
    (0, _classCallCheck3.default)(this, FloatingScrollSelector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FloatingScrollSelector.__proto__ || (0, _getPrototypeOf2.default)(FloatingScrollSelector)).call(this, props));

    _this.state = {
      activedOption: null
    };

    _this.confirmSelecting = _this.confirmSelecting.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(FloatingScrollSelector, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          dataList = _props.dataList,
          toggleSelectorCheckedStatus = _props.toggleSelectorCheckedStatus,
          defaultCheckedIndex = _props.defaultCheckedIndex;


      if (dataList && dataList.length > 0) {
        toggleSelectorCheckedStatus(defaultCheckedIndex <= 0 ? 0 : defaultCheckedIndex);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProp) {
      var dataList = nextProp.dataList;
      var activedOption = this.state.activedOption;

      if (Array.isArray(dataList)) {
        var checkedItem = dataList.find(function (item) {
          return item.isChecked;
        });
        if (!!checkedItem && !activedOption) {
          this.setState(function () {
            return { activedOption: checkedItem };
          });
        }
      }
    }
  }, {
    key: 'checkActiveOption',
    value: function checkActiveOption(option) {
      var _this2 = this;

      var _props2 = this.props,
          dataList = _props2.dataList,
          toggleSelectorCheckedStatus = _props2.toggleSelectorCheckedStatus;


      dataList.forEach(function (item, index) {
        if (item.id === option.id) {
          if (!item.isChecked) {
            toggleSelectorCheckedStatus(index);
            _this2.setState(function () {
              return { activedOption: item };
            });
          }
        }
      });
    }
  }, {
    key: 'confirmSelecting',
    value: function confirmSelecting(e) {
      var _props3 = this.props,
          closeSelector = _props3.closeSelector,
          setSelectedOption = _props3.setSelectedOption,
          defaultCheckedIndex = _props3.defaultCheckedIndex,
          dataList = _props3.dataList;
      var activedOption = this.state.activedOption;


      setSelectedOption(activedOption || dataList[defaultCheckedIndex]);
      closeSelector(e);
    }
  }, {
    key: 'createSelectorOptions',
    value: function createSelectorOptions() {
      var _this3 = this;

      var _props4 = this.props,
          dataList = _props4.dataList,
          optionComponent = _props4.optionComponent;


      return _react2.default.createElement(
        'div',
        { className: 'o-flex' },
        _react2.default.createElement(_activeScrollSelect2.default, {
          className: 'row-floating-select',
          optionsData: dataList,
          optionComponent: optionComponent,
          onSelectOption: function onSelectOption(event, option) {
            return _this3.checkActiveOption(option);
          }
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var selectorOptions = this.createSelectorOptions();
      var _props5 = this.props,
          closeSelector = _props5.closeSelector,
          selectorTitle = _props5.selectorTitle;


      return _react2.default.createElement(
        'div',
        {
          className: 'scroll-select-container floating-select-container',
          tabIndex: '-1'
        },
        _react2.default.createElement('div', { className: 'scroll-select-close', onTouchTap: closeSelector }),
        _react2.default.createElement(
          'div',
          { className: 'scroll-select-content' },
          _react2.default.createElement(
            'div',
            { className: 'scroll-select-header' },
            _react2.default.createElement(
              'span',
              null,
              selectorTitle
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'scroll-select-confirm btn--yellow',
                onTouchTap: this.confirmSelecting
              },
              (0, _helper.formatMessage)(_button2.default.sure)
            )
          ),
          selectorOptions
        )
      );
    }
  }]);
  return FloatingScrollSelector;
}(_react.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    dataList: _react2.default.PropTypes.array,
    defaultCheckedIndex: _react2.default.PropTypes.number,
    selectorTitle: _react2.default.PropTypes.string.isRequired,
    optionComponent: _react2.default.PropTypes.func.isRequired,

    toggleSelectorCheckedStatus: _react2.default.PropTypes.func.isRequired,
    setSelectedOption: _react2.default.PropTypes.func.isRequired,
    closeSelector: _react2.default.PropTypes.func.isRequired
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    defaultCheckedIndex: 0
  }
}), _temp);
exports.default = FloatingScrollSelector;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _dynamicClassHoc = __webpack_require__(450);

var _dynamicClassHoc2 = _interopRequireDefault(_dynamicClassHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptionComponent = (0, _dynamicClassHoc2.default)('a');

var PayMethodOption = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PayMethodOption, _Component);

  function PayMethodOption() {
    (0, _classCallCheck3.default)(this, PayMethodOption);
    return (0, _possibleConstructorReturn3.default)(this, (PayMethodOption.__proto__ || (0, _getPrototypeOf2.default)(PayMethodOption)).apply(this, arguments));
  }

  (0, _createClass3.default)(PayMethodOption, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          props = (0, _objectWithoutProperties3.default)(_props, ['name']);


      return _react2.default.createElement(
        OptionComponent,
        props,
        _react2.default.createElement(
          'span',
          null,
          name
        )
      );
    }
  }]);
  return PayMethodOption;
}(_react.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    name: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.number, _react2.default.PropTypes.string]).isRequired
  }
}), _temp);
exports.default = PayMethodOption;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _counter = __webpack_require__(461);

var _counter2 = _interopRequireDefault(_counter);

var _classnames = __webpack_require__(50);

var _classnames2 = _interopRequireDefault(_classnames);

var _dishHelper = __webpack_require__(43);

var _dishHelper2 = _interopRequireDefault(_dishHelper);

var _reactAddonsShallowCompare = __webpack_require__(120);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

var _helper = __webpack_require__(16);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _registerDivolte = __webpack_require__(124);

var _registerDivolte2 = _interopRequireDefault(_registerDivolte);

var _brand = __webpack_require__(497);

var _brand2 = _interopRequireDefault(_brand);

__webpack_require__(517);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuildOrderBtn = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(BuildOrderBtn, _React$Component);

  function BuildOrderBtn(props) {
    (0, _classCallCheck3.default)(this, BuildOrderBtn);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BuildOrderBtn.__proto__ || (0, _getPrototypeOf2.default)(BuildOrderBtn)).call(this, props));

    _this.state = {
      showCount: props.dishData.order
    };
    _this.incrementStore = 0;
    return _this;
  }

  // snail


  (0, _createClass3.default)(BuildOrderBtn, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dishData) {
        this.setState({ showCount: nextProps.dishData.order });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }

    /**
     * 埋点购物车
     */

  }, {
    key: 'buryingPointAddToCart',
    value: function buryingPointAddToCart() {
      var dish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      try {
        var pageType = (0, _registerDivolte.getPageTypeFromUrl)();
        _registerDivolte2.default.send('AddToShoppingCart', { commodityId: dish.id || '', pageType: pageType });
      } catch (ex) {
        console.error(ex);
      }
    }
  }, {
    key: 'onBtnTouchTap',
    value: function onBtnTouchTap(newCount, increment) {
      var _this2 = this;

      var _props = this.props,
          onBtnTap = _props.onBtnTap,
          dishData = _props.dishData;

      if (newCount < 0) return;
      this.incrementStore += increment;
      this.setState({ showCount: newCount });
      this.delayTimer && clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(function () {
        var incrementFinally = _this2.incrementStore;
        if (incrementFinally > 0) {
          _this2.buryingPointAddToCart(dishData);
        }
        _this2.incrementStore = 0;
        onBtnTap(newCount, incrementFinally, dishData);
      }, 100);
    }
  }, {
    key: 'buildOrderBtn',
    value: function buildOrderBtn(dishData, sameRuleDishList, isClear) {
      var _this3 = this;

      var onlyAddCounter = this.props.onlyAddCounter;
      var showCount = this.state.showCount;
      // 表示被沽清

      if (isClear) {
        return _react2.default.createElement(
          'span',
          { className: 'dish-item-soldout-text' },
          _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.soldout)
        );
      }

      if (_dishHelper2.default.isSingleDishWithoutProps(dishData) && !sameRuleDishList) {
        var _helper$getMustOrderM = _dishHelper2.default.getMustOrderMinNum(dishData),
            minimum = _helper$getMustOrderM.minimum,
            msg = _helper$getMustOrderM.msg;

        return _react2.default.createElement(_counter2.default, {
          changeShowDataItems: this.props.changeShowDataItems,
          count: showCount,
          onCountChange: function onCountChange(newCount, increment) {
            return _this3.onBtnTouchTap(newCount, increment);
          },
          step: dishData.stepNum,
          showHandleInput: this.props.showHandleInput,
          dishItem: dishData,
          soldoutClassName: 'dish-item-soldout-text',
          showHandleDishCount: this.props.showHandleDishCount,
          onlyAddCounter: onlyAddCounter,
          minimum: showCount > 0 ? minimum : 0,
          msg: msg,
          ifShowToolTip: true
        });
      }

      var dishes = sameRuleDishList || [dishData];
      var count = _dishHelper2.default.getDishesCount(dishes);
      var brandType = this.context.brandType;

      var title = Array.isArray(dishData.groups) ? (0, _brand2.default)(brandType, 'dish-menu.select-child-dish', (0, _helper.formatMessage)(_dishMenu2.default.choseChildDish)) : (0, _helper.formatMessage)(_dishMenu2.default.choseSpecification);

      var countStyle = void 0;
      if (count < 10) {
        countStyle = { width: '16px' };
      } else if (count >= 10 && count <= 99) {
        countStyle = { width: '21px' };
      } else {
        countStyle = { width: '27px' };
      }
      return _react2.default.createElement(
        'div',
        { className: 'counter' },
        _react2.default.createElement(
          'button',
          { className: 'btn--ellips btn-choose-property', onTouchTap: function onTouchTap(newCount, increment) {
              return _this3.onBtnTouchTap(newCount, increment);
            } },
          title,
          count > 0 ? _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)('build-order--counter counter-special', { 'counter-special--modify': count > 99 }), style: countStyle },
            count > 99 ? '99+' : count
          ) : false
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          dishData = _props2.dishData,
          sameRuleDishList = _props2.sameRuleDishList,
          isClear = _props2.isClear;

      var buildOrderBtn = this.buildOrderBtn(dishData, sameRuleDishList, isClear);
      return _react2.default.createElement(
        'div',
        null,
        buildOrderBtn
      );
    }
  }]);
  return BuildOrderBtn;
}(_react2.default.Component), Object.defineProperty(_class, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'BuildOrderBtn'
}), Object.defineProperty(_class, 'proptypes', {
  enumerable: true,
  writable: true,
  value: {
    dishData: _react2.default.PropTypes.object,
    sameRuleDishList: _react2.default.PropTypes.array,
    isClear: _react2.default.PropTypes.bool,
    changeShowDataItems: _react2.default.PropTypes.object,
    showHandleInput: _react2.default.PropTypes.func,
    showHandleDishCount: _react2.default.PropTypes.func,
    onBtnTap: _react2.default.PropTypes.func,
    onlyAddCounter: _react2.default.PropTypes.bool
  }
}), _temp);
exports.default = BuildOrderBtn;

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */,
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBrandConfig;
/**
 * 品牌自定义设置
 */

var CONFIG = {
  // 马家私房面
  MJSFM: {
    'dish-menu.select-child-dish': '去定制'
  }
};

function getBrandConfig(brandType, key, defaultConfig) {
  var config = CONFIG[brandType];
  var result = config ? config[key] : '';

  return result || defaultConfig;
}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(11))(268);

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(643);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    return exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (typeof process !== 'undefined' && 'env' in process) {
    return Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).DEBUG;
  }
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 501 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(665);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && 'WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    return exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (typeof process !== 'undefined' && 'env' in process) {
    return Object({"NODE_ENV":"production","DEPLOY_AREA":undefined,"RELEASE_FOR_SENTRY":"v3.6.44-prod","BUILD_ENV":"prod","AD_HOST":"ad.keruyun.com/ad-srs"}).DEBUG;
  }
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127)))

/***/ }),
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactIntl = __webpack_require__(7);

exports.default = (0, _reactIntl.defineMessages)({
  dishPS: {
    id: 'dish.PS',
    defaultMessage: '备注'
  },
  dishtoppings: {
    id: 'dish.toppings',
    defaultMessage: '配料'
  },
  dishfillToCut: {
    id: 'dish.fillToCut',
    defaultMessage: '满{full}立减{currency}'
  },
  dishfillToDiscount: {
    id: 'dish.fillToDiscount',
    defaultMessage: '满{full}可享{discount}折'
  },
  dishinTotal: {
    id: 'dish.inTotal',
    defaultMessage: '共{dishesDataDuplicate}份'
  },
  dishtotal: {
    id: 'dish.total',
    defaultMessage: '总计：'
  },
  dishxxPart: {
    id: 'dish.xxPart',
    defaultMessage: '{getDishesCount}份'
  },
  dishremake: {
    id: 'dish.remake',
    defaultMessage: '备注:'
  },
  dishSubmit: {
    id: 'dish.Submit',
    defaultMessage: '提交订单'
  },
  dishstoreIsClosed: {
    id: 'dish.storeIsClosed',
    defaultMessage: '非常抱歉，门店已打烊'
  },
  dishlowestCust: {
    id: 'dish.lowestCust',
    defaultMessage: '本桌最低消费{lowestConsumptionValue}元'
  },
  dishgotoAddOn: {
    id: 'dish.gotoAddOn',
    defaultMessage: '去凑单'
  },
  dishselectEnough: {
    id: 'dish.selectEnough',
    defaultMessage: '请选择足够的子菜份数'
  },
  dishrequired: {
    id: 'dish.required',
    defaultMessage: '必选'
  },
  dishselectName: {
    id: 'dish.selectName',
    defaultMessage: '请选择{name}'
  },
  dishguessYouLike: {
    id: 'dish.guessYouLike',
    defaultMessage: '猜你喜欢'
  },
  unlimited: {
    id: 'dish.unlimited',
    defaultMessage: '不限'
  },
  dishCartDiscounted: {
    id: 'dishCartDiscounted',
    defaultMessage: '折扣已减'
  },
  dishCartCut: {
    id: 'dishCartCut',
    defaultMessage: '已减'
  },
  dishCartCutNow: {
    id: 'dishCartCutNow',
    defaultMessage: '立减{currency}{reduce}'
  },
  dishCartGetDiscount: {
    id: 'dishCartGetDiscount',
    defaultMessage: '可享{discount}折'
  },
  dishCartNoSendPay: {
    id: 'dishCartNoSendPay',
    defaultMessage: '免配送费'
  },
  dishCartCanGet: {
    id: 'dishCartCanGet',
    defaultMessage: '可享'
  }
});

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var classnames = __webpack_require__(50);
var ICON_SIZE = 12;


var BtnShortcutDefault = React.createClass({
  displayName: 'BtnShortcutDefault',
  propTypes: {
    btnAttributes: React.PropTypes.object,
    children: React.PropTypes.array,
    disabled: React.PropTypes.bool,
    mainButton: React.PropTypes.bool,
    isChildrenShow: React.PropTypes.bool,
    isNavi: React.PropTypes.bool
  },

  getComponentClassName: function getComponentClassName() {
    var _props = this.props,
        _props$btnAttributes = _props.btnAttributes,
        btnAttributes = _props$btnAttributes === undefined ? {} : _props$btnAttributes,
        disabled = _props.disabled,
        mainButton = _props.mainButton,
        isChildrenShow = _props.isChildrenShow,
        isNavi = _props.isNavi;

    var classNames = [isNavi ? 'btn-shortcut-navi' : 'btn-shortcut'];

    [].push.apply(classNames, ['btn-shortcut-' + (btnAttributes.size || 'default'), '' + (btnAttributes.classnames || '')]);

    if (disabled) {
      classNames.push('btn-shortcut--disabled');
    }

    if (mainButton && isChildrenShow) {
      classNames.push('btn-shortcut--bordered');
    }

    return classNames.join(' ').trim();
  },
  handleTouchTap: function handleTouchTap(evt) {
    var _props2 = this.props,
        disabled = _props2.disabled,
        _props2$btnAttributes = _props2.btnAttributes,
        btnAttributes = _props2$btnAttributes === undefined ? {} : _props2$btnAttributes;

    if (disabled) {
      return;
    }

    if (disabled && btnAttributes.text === '选好啦') {
      return;
    }

    if (evt) {
      evt.preventDefault();
    }

    var onClick = btnAttributes.onClick;

    if (onClick) {
      onClick();
    }
  },
  render: function render() {
    var _props3 = this.props,
        btnAttributes = _props3.btnAttributes,
        mainButton = _props3.mainButton;

    var defaultIconSize = ICON_SIZE + 'px';

    return React.createElement(
      'div',
      { className: this.getComponentClassName(), onTouchTap: this.handleTouchTap },
      btnAttributes.icon && React.createElement(_httpsProtocolImage2.default, {
        className: 'btn-shortcut-icon',
        style: { width: '' + (btnAttributes.iconWidth || defaultIconSize), verticalAlign: '' + (btnAttributes.verticalAlign || '') },
        src: btnAttributes.icon,
        role: 'presentation'
      }),
      !mainButton && btnAttributes.childIcon && React.createElement('img', { className: 'btn-shortcut-childicon', src: btnAttributes.childIcon, alt: btnAttributes.text }),
      btnAttributes.text && React.createElement(
        'span',
        {
          className: classnames('btn-shortcut-text', {
            'btn-sync-yellow': btnAttributes.moduleBg
          })
        },
        btnAttributes.text
      ),
      this.props.bell ? this.props.bell : null
    );
  }
});

module.exports = BtnShortcutDefault;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(509);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tips = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Tips, _React$Component);

  function Tips() {
    (0, _classCallCheck3.default)(this, Tips);
    return (0, _possibleConstructorReturn3.default)(this, (Tips.__proto__ || (0, _getPrototypeOf2.default)(Tips)).apply(this, arguments));
  }

  (0, _createClass3.default)(Tips, [{
    key: 'getTriggerWidth',
    value: function getTriggerWidth() {
      return this.refs.trigger.offsetWidth;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tipInlineStyle = _props.tipInlineStyle,
          tooltipText = _props.tooltipText;

      return _react2.default.createElement(
        'div',
        { className: 'o-tooltip__outer', style: tipInlineStyle.tipOuterStyle },
        _react2.default.createElement(
          'div',
          {
            ref: 'tooltip',
            className: 'o-tooltip',
            style: tipInlineStyle.tipStyle
          },
          tooltipText,
          _react2.default.createElement('div', { className: 'o-tooltip__trigger', style: tipInlineStyle.tipTriggerStyle, ref: 'trigger' })
        )
      );
    }
  }]);
  return Tips;
}(_react2.default.Component), Object.defineProperty(_class, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'Tips'
}), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    tipInlineStyle: _react2.default.PropTypes.object,
    tooltipText: _react2.default.PropTypes.any
  }
}), _temp);
exports.default = Tips;

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInteger = __webpack_require__(511);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _BaseComponent2 = __webpack_require__(456);

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _dishHelper = __webpack_require__(43);

var _dishHelper2 = _interopRequireDefault(_dishHelper);

var _const = __webpack_require__(14);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _button = __webpack_require__(409);

var _button2 = _interopRequireDefault(_button);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var Immutable = __webpack_require__(77);
__webpack_require__(515);

var isSingleDishWithoutProps = _dishHelper2.default.isSingleDishWithoutProps,
    getDishPrice = _dishHelper2.default.getDishPrice;

var Toast = __webpack_require__(266);

var HandleInput = (_temp = _class = function (_BaseComponent) {
  (0, _inherits3.default)(HandleInput, _BaseComponent);

  function HandleInput(props) {
    (0, _classCallCheck3.default)(this, HandleInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HandleInput.__proto__ || (0, _getPrototypeOf2.default)(HandleInput)).call(this, props));

    _this.state = {
      dishNum: _this.props.count,
      keyBoardStatus: true,
      errorMessage: ''
    };

    _this.bind('addNewDishNum', 'deleteDishNum', 'confirmDishNum', 'clearErrorMsg', 'handleInputRules');
    return _this;
  }

  (0, _createClass3.default)(HandleInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var display = nextProps.display,
          count = nextProps.count;


      if (display) {
        this.setState({
          dishNum: count,
          keyBoardStatus: true
        });
      }
    }

    // 键盘输入控制

  }, {
    key: 'addNewDishNum',
    value: function addNewDishNum(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      }

      var _state = this.state,
          keyBoardStatus = _state.keyBoardStatus,
          dishNum = _state.dishNum;
      var numTotal = this.props.numTotal;

      var text = evt.target.innerHTML;

      var newDishNum = keyBoardStatus ? text : Number(dishNum + text);
      // 最多可售份数
      if (Number(newDishNum) > numTotal) {
        this.setState({
          errorMessage: (0, _helper.formatMessage)(_errorMessage2.default.onlyStockLeft, { numTotal: numTotal }),
          keyBoardStatus: true,
          dishNum: numTotal
        });

        return {
          status: false,
          dishChange: numTotal
        };
      }

      if (Number(newDishNum) > _const.MaxOrderedDishCount) {
        this.setState({
          errorMessage: (0, _helper.formatMessage)(_errorMessage2.default.enteredUpTo5digits)
        });

        return false;
      }

      this.setState({
        dishNum: Number(newDishNum),
        keyBoardStatus: false
      });

      return true;
    }
  }, {
    key: 'deleteDishNum',
    value: function deleteDishNum(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      }

      var dishNum = String(this.state.dishNum);
      var text = dishNum.substr(0, dishNum.length - 1);

      this.setState({
        dishNum: Number(text)
      });
    }
  }, {
    key: 'confirmDishNum',
    value: function confirmDishNum(evt) {
      if (evt) {
        evt.preventDefault();
        evt.stopPropagation();
      }
      var _props = this.props,
          onOrderBtnTap = _props.onOrderBtnTap,
          count = _props.count;
      var dishNum = this.state.dishNum;

      var _handleInputRules = this.handleInputRules(dishNum),
          status = _handleInputRules.status;

      if (status) {
        var increment = dishNum - count;

        if (increment) {
          onOrderBtnTap(count + increment, increment);
        }

        this.cancelHandleInput();
      }
    }
  }, {
    key: 'cancelHandleInput',
    value: function cancelHandleInput(evt) {
      if (evt) {
        evt.preventDefault();
      }

      document.getElementById('handleInputDOM').style.display = 'none';
    }
  }, {
    key: 'getOrderCounter',
    value: function getOrderCounter(dishItem) {
      // 根据菜品类型不同获取菜品数量
      var orderCount = 0;

      var order = dishItem.order,
          dishIngredientInfos = dishItem.dishIngredientInfos;


      if (isSingleDishWithoutProps(dishItem)) {
        // 单菜品
        orderCount = order;
      } else {
        // 多规格和选子菜
        if (dishIngredientInfos.length === 0) {
          // 有多规格的情况
          orderCount = order;
        } else {
          orderCount = order[0].count; // 每次显示的是第一条数据的count
        }
      }

      return orderCount;
    }
  }, {
    key: 'getOrderPrice_',
    value: function getOrderPrice_(dishItem) {
      var dishTemp = Immutable.from(dishItem).setIn(['order', '0', 'count'], 1);

      if (isSingleDishWithoutProps(dishItem)) {
        return dishItem.marketPrice;
      }

      return getDishPrice(dishTemp);
    }
  }, {
    key: 'clearErrorMsg',
    value: function clearErrorMsg() {
      this.setState({
        errorMessage: ''
      });
    }
  }, {
    key: 'getRemaining',
    value: function getRemaining(numTotal, dishIncreaseUnit, stepNum) {
      var Remaining = (numTotal - dishIncreaseUnit) / (stepNum || 1);

      return Math.floor(Remaining) * stepNum + dishIncreaseUnit;
    }
  }, {
    key: 'handleInputRules',
    value: function handleInputRules(dishCount) {
      var _props2 = this.props,
          dishItem = _props2.dishItem,
          numTotal = _props2.numTotal;
      var stepNum = dishItem.stepNum,
          dishIncreaseUnit = dishItem.dishIncreaseUnit;

      var rules = { status: true };

      if (dishIncreaseUnit && dishCount < dishIncreaseUnit && (this.props.flag || !this.props.flag && dishCount !== 0)) {
        // 起卖份数
        this.setState({
          errorMessage: (0, _helper.formatMessage)(_errorMessage2.default.notLowerThanDishIncreaseUnit, { dishIncreaseUnit: dishIncreaseUnit }),
          keyBoardStatus: true,
          dishNum: dishIncreaseUnit
        });

        rules = {
          status: false,
          dishChange: dishIncreaseUnit
        };

        return rules;
      }

      if (stepNum && dishCount !== 0) {
        var temp = (dishCount - (dishIncreaseUnit || 0)) / stepNum;

        if (!(0, _isInteger2.default)(temp)) {
          rules.status = false;
          var fixedNum = Math.ceil(temp) * stepNum + dishIncreaseUnit;

          if (fixedNum <= numTotal) {
            rules.dishChange = fixedNum;
          } else {
            rules.dishChange = Math.floor((numTotal - dishIncreaseUnit) / stepNum) * stepNum + dishIncreaseUnit;
          }

          this.setState({
            errorMessage: (0, _helper.formatMessage)(_errorMessage2.default.notLowerThanDishIncreaseUnit, { dishIncreaseUnit: dishIncreaseUnit || 1, stepNum: stepNum, dishChange: rules.dishChange }),
            keyBoardStatus: true,
            dishNum: rules.dishChange
          });

          return rules;
        }
      }

      return rules;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dishItem = this.props.dishItem;
      var _state2 = this.state,
          dishNum = _state2.dishNum,
          errorMessage = _state2.errorMessage;

      var numArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

      var numItem = numArr.map(function (item, index) {
        return React.createElement(
          'button',
          { key: index, onTouchTap: function onTouchTap(evt) {
              _this2.addNewDishNum(evt);
            } },
          item
        );
      });

      return React.createElement(
        'div',
        { className: 'handle-input', onTouchTap: function onTouchTap(evt) {
            evt.preventDefault();_this2.cancelHandleInput(evt);
          } },
        React.createElement(
          'div',
          { className: 'handle-input-box', onTouchTap: function onTouchTap(evt) {
              evt.preventDefault();evt.stopPropagation();
            } },
          React.createElement(
            'div',
            { className: 'handle-input-dish' },
            React.createElement(
              'div',
              { className: 'dish-detail' },
              React.createElement(
                'span',
                { className: 'dish-detail-img' },
                React.createElement(_httpsProtocolImage2.default, { src: dishItem.largeImgList[0] || dishItem.smallImgUrl })
              ),
              React.createElement(
                'div',
                { className: 'dish-detail-info' },
                React.createElement(
                  'span',
                  { className: 'dishInfo' },
                  dishItem.name
                ),
                React.createElement(
                  'span',
                  { className: 'price' },
                  this.getOrderPrice_(dishItem)
                )
              ),
              React.createElement(
                'div',
                { className: 'dish-detail-count' },
                React.createElement('span', {
                  className: 'handle-close',
                  onTouchTap: function onTouchTap(evt) {
                    return _this2.cancelHandleInput(evt);
                  }
                }),
                React.createElement(
                  'span',
                  { className: '' },
                  React.createElement(
                    'i',
                    null,
                    String(dishNum)
                  ),
                  dishItem.unitName !== '份' ? '' + dishItem.unitName : '份'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'handle-input-bord' },
            React.createElement(
              'div',
              { className: 'bord-num' },
              numItem
            ),
            React.createElement(
              'div',
              { className: 'bord-event' },
              React.createElement('button', { onTouchTap: function onTouchTap(evt) {
                  _this2.deleteDishNum(evt);
                } }),
              React.createElement(
                'button',
                { onTouchTap: function onTouchTap(evt) {
                    _this2.confirmDishNum(evt);
                  } },
                React.createElement(_formattedMessage2.default, _button2.default.finish)
              )
            )
          )
        ),
        errorMessage ? React.createElement(Toast, { errorMessage: errorMessage, clearErrorMsg: this.clearErrorMsg, timeout: 2000 }) : false
      );
    }
  }]);
  return HandleInput;
}(_BaseComponent3.default), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    cancelHandleInput: React.PropTypes.func,
    dishItem: React.PropTypes.object,
    onOrderBtnTap: React.PropTypes.func,
    count: React.PropTypes.number
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    numTotal: _const.MaxOrderedDishCount
  }
}), _temp);
exports.default = HandleInput;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(512), __esModule: true };

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
module.exports = __webpack_require__(1).Number.isInteger;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(8);

$export($export.S, 'Number', { isInteger: __webpack_require__(514) });


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 518 */,
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(520);

var _dishHelper = __webpack_require__(43);

var _dishHelper2 = _interopRequireDefault(_dishHelper);

var _guessyoulove = __webpack_require__(521);

var _guessyoulove2 = _interopRequireDefault(_guessyoulove);

var _guessyouloveChange = __webpack_require__(522);

var _guessyouloveChange2 = _interopRequireDefault(_guessyouloveChange);

var _dishListItem = __webpack_require__(488);

var _dishListItem2 = _interopRequireDefault(_dishListItem);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _classnames = __webpack_require__(50);

var _classnames2 = _interopRequireDefault(_classnames);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GuessYouLove = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(GuessYouLove, _React$Component);

  function GuessYouLove(props) {
    (0, _classCallCheck3.default)(this, GuessYouLove);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GuessYouLove.__proto__ || (0, _getPrototypeOf2.default)(GuessYouLove)).call(this, props));

    _this.state = {
      partNumber: 3
    };

    _this.onDishBtnTap = _this.onDishBtnTap.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(GuessYouLove, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // 计算猜你喜欢图片需要的长和宽
      setTimeout(function () {
        _this2.calcWidthAndHeight();
      }, 0);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps && nextProps.initDishNumber) {
        this.setState({ partNumber: nextProps.initDishNumber });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // 计算猜你喜欢图片需要的长和宽
      /*
      if (this.state.partNumber !== prevState.partNumber) {
        this.calcWidthAndHeight();
      }
      */
    }
  }, {
    key: 'calcWidthAndHeight',
    value: function calcWidthAndHeight() {
      // const { outerClassName } = this.props;
      var recommendDishListInner = this.refs.recommendDishListInner;

      if (!recommendDishListInner) {
        return;
      }

      var offsetWidth = recommendDishListInner.offsetWidth;
      var needImgWidth = Math.floor((offsetWidth - 15 * 2 - 8 * 2) / 3);

      this.setState({ needImgWidth: needImgWidth });
    }
  }, {
    key: 'onDishBtnTap',
    value: function onDishBtnTap(dishData, action) {
      var _props = this.props,
          onOrderBtnTap = _props.onOrderBtnTap,
          onPropsBtnTap = _props.onPropsBtnTap,
          fromWay = _props.fromWay,
          isSync = _props.isSync;

      if (action) {
        this.onOrderDishUpdateInfo = {
          dishData: dishData,
          action: action
        };
        if (fromWay === 'DishMenuCart') {
          var _increment = _dishHelper2.default.adjustOrderedDishIncrement(dishData, action);
          if (isSync) {
            onOrderBtnTap((0, _assign2.default)({}, dishData), _increment);
          } else {
            onOrderBtnTap((0, _assign2.default)({}, dishData, { order: _increment || 1 }), action);
          }
        } else {
          onOrderBtnTap(dishData, action);
        }
      } else {
        onPropsBtnTap(dishData);
      }
    }
  }, {
    key: 'redirectToGoodsDetail',
    value: function redirectToGoodsDetail(id) {
      var redirectToGoodsDetail = this.props.redirectToGoodsDetail;


      if (redirectToGoodsDetail) {
        this.props.redirectToGoodsDetail(id);
      }
    }
  }, {
    key: 'setDishTypeData',
    value: function setDishTypeData(theme, onDishBtnTap, dishData, dishesData, idx) {
      var _this3 = this;

      var linkType = this.props.linkType;
      var needImgWidth = this.state.needImgWidth;

      var changeShowData = _dishHelper2.default.getOrderedDishes(dishesData);
      var changeShowDataItems = changeShowData.reduce(function (changeItems, itemt) {
        changeItems[itemt.id] = itemt;
        return changeItems;
      }, {});

      var imgUrl = dishData.smallImgUrl;
      var dishImageStyle = imgUrl && dishData ? { backgroundImage: 'url(' + _httpsProtocolImage2.default.getFinalImageUrl(imgUrl) + ')', height: needImgWidth } : { height: needImgWidth };
      var newItem = _react2.default.createElement(
        'li',
        { className: 'dish-item-dish', style: { width: needImgWidth }, key: idx },
        !linkType ? _react2.default.createElement(_dishListItem2.default, {
          changeShowDataItems: changeShowDataItems,
          theme: theme,
          dishData: dishData,
          onOrderBtnTap: onDishBtnTap,
          onPropsBtnTap: onDishBtnTap,
          onImageBtnTap: function onImageBtnTap() {},
          marketList: {},
          diningForm: 1,
          hotTag: false,
          showHandleInput: function showHandleInput() {},
          onlyAddCounter: true,
          needImgWidth: needImgWidth
        }) : _react2.default.createElement(
          'div',
          { className: 'dish-on-selling', onTouchTap: function onTouchTap() {
              return _this3.redirectToGoodsDetail(dishData.id);
            } },
          _react2.default.createElement(
            'div',
            { className: 'dish-list-item' },
            _react2.default.createElement('div', { className: (0, _classnames2.default)('dish-item-img', { 'dish-img-default': !dishData.smallImgUrl }), style: dishImageStyle }),
            _react2.default.createElement(
              'div',
              { className: 'dish-item-content' },
              _react2.default.createElement(
                'div',
                { className: 'dish-item-fill' },
                _react2.default.createElement(
                  'span',
                  { className: 'dish-item-name' },
                  dishData.name,
                  dishData.unitName !== '份' ? '/' + dishData.unitName : ''
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'dish-item-bottom' },
                _react2.default.createElement(
                  'div',
                  { className: 'dish-price-container' },
                  _react2.default.createElement(
                    'span',
                    { className: 'dish-item-price' },
                    _react2.default.createElement(
                      'span',
                      { className: 'dish-item-price-number dish-item-price-nosub price' },
                      dishData.marketPrice
                    )
                  )
                )
              )
            )
          )
        )
      );

      return newItem;
    }
  }, {
    key: 'buildDishElements',
    value: function buildDishElements(dishesData, onDishBtnTap) {
      var _this4 = this;

      return dishesData.map(function (dishData) {
        return _this4.setDishTypeData('default', onDishBtnTap, dishData, dishesData, dishData.id);
      });
    }
  }, {
    key: 'getDishesDataDuplicateNew',
    value: function getDishesDataDuplicateNew() {
      var _props2 = this.props,
          recommendDishList = _props2.recommendDishList,
          dishesDataDuplicate = _props2.dishesDataDuplicate,
          fromWay = _props2.fromWay,
          linkType = _props2.linkType;

      var dishesDataDuplicateNew = [];

      if (linkType) {
        dishesDataDuplicateNew = recommendDishList;
        return dishesDataDuplicateNew;
      }

      switch (fromWay) {
        case 'DishMenuCart':
          dishesDataDuplicateNew = dishesDataDuplicate;
          break;
        default:
          recommendDishList.forEach(function (item) {
            var findObj = dishesDataDuplicate.find(function (itemt) {
              return itemt.id === item.id;
            });
            if (findObj) {
              dishesDataDuplicateNew.push(findObj);
            }
          });
          break;
      }

      return dishesDataDuplicateNew;
    }
  }, {
    key: 'formatRecommendDishList',
    value: function formatRecommendDishList() {
      return this.dishElementsLength;
    }
  }, {
    key: 'render',
    value: function render() {
      var partNumber = this.state.partNumber;
      var _props3 = this.props,
          recommendDishListOuterStyle = _props3.recommendDishListOuterStyle,
          _props3$initDishNumbe = _props3.initDishNumber,
          initDishNumber = _props3$initDishNumbe === undefined ? 3 : _props3$initDishNumbe;

      var dishesDataDuplicateNew = this.getDishesDataDuplicateNew();
      var dishElements = this.buildDishElements(dishesDataDuplicateNew, this.onDishBtnTap);
      var dishElementsLength = dishElements.length;
      this.dishElementsLength = dishElementsLength;
      var dishElementsLimit = dishElements.slice(partNumber - initDishNumber, partNumber);

      if (dishElementsLength === 0) {
        return _react2.default.createElement('div', null);
      }

      return _react2.default.createElement(
        'div',
        { className: 'recommendDishList__holder', style: recommendDishListOuterStyle },
        _react2.default.createElement(
          'div',
          { className: 'recommendDishList__inner', ref: 'recommendDishListInner' },
          _react2.default.createElement(
            'div',
            { className: 'o-flex o-fz--16 o-ta--c o-fw--b recommendDishList__title' },
            _react2.default.createElement('img', { src: _guessyoulove2.default, alt: '\u731C\u4F60\u559C\u6B22', className: 'recommendDishList__title__img' }),
            _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.guessYouLove),
            dishElementsLength > initDishNumber && _react2.default.createElement(
              'i',
              { className: 'o-flex o-fz--13 recommendDishList__switch' },
              _react2.default.createElement('img', { src: _guessyouloveChange2.default, alt: '\u6362\u4E00\u6279', className: 'recommendDishList__switch__img' }),
              _react2.default.createElement(
                'i',
                { className: 'recommendDishList__switch__i' },
                (0, _helper.formatMessage)(_dishMenu2.default.changeView)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'recommendDishList default' },
            _react2.default.createElement(
              'ul',
              { className: 'recommendDishList__ul' },
              dishElementsLimit
            )
          )
        )
      );
    }
  }]);
  return GuessYouLove;
}(_react2.default.Component), Object.defineProperty(_class, 'dishPlayName', {
  enumerable: true,
  writable: true,
  value: 'GuessYouLove'
}), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    recommendDishList: _react2.default.PropTypes.array.isRequired,
    dishesDataDuplicate: _react2.default.PropTypes.array,

    onOrderBtnTap: _react2.default.PropTypes.func,
    onPropsBtnTap: _react2.default.PropTypes.func,
    redirectToGoodsDetail: _react2.default.PropTypes.func, // 跳转连接的方法
    recommendDishListOuterStyle: _react2.default.PropTypes.object,
    // 来源判断
    fromWay: _react2.default.PropTypes.string, // 引用来源
    linkType: _react2.default.PropTypes.bool, // 点击之后是跳转链接
    isSync: _react2.default.PropTypes.bool, // 是否是协同购物车
    outerClassName: _react2.default.PropTypes.string // 最外层class 用于唯一性
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    recommendDishList: [],
    outerClassName: ''
  }
}), _temp);
exports.default = GuessYouLove;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guessyoulove.svg";

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guessyoulove-change.svg";

/***/ }),
/* 523 */,
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array ? array.length : 0;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = findIndex;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(268)(module)))

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = __webpack_require__(14);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

var _jsencrypt = __webpack_require__(550);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ebuHelper = {
  /**
   * 判断是否通过饿了么进入点餐
   */
  isEbuEvn: function isEbuEvn() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var _path = path;
    if (!_path) {
      _path = location.search || '';
    }
    var res = _path.match(/accessFrom=(.*?)(&|$)/);

    var accessFrom = window.sessionStorage ? window.sessionStorage.getItem('ACCESS_FROM') : ''; // 饿企登录标志
    if (res && Array.isArray(res) && res[1] === _const.ACCESS_FROM.EBU || accessFrom === _const.ACCESS_FROM.EBU) {
      window.sessionStorage.setItem('ACCESS_FROM', _const.ACCESS_FROM.EBU);
      return true;
    }
    return false;
  },
  login: function login(info) {
    var shopId = info.shopId,
        euId = info.euId;

    var brandId = sessionStorage.getItem('brandId');
    var encrypt = new _jsencrypt.JSEncrypt();
    encrypt.setPublicKey(_const.PUBLIC_KEY);
    var code = encrypt.encrypt(brandId + '-' + shopId);

    return _fetchHelper2.default.get(_config2.default.getMobilesByEuid, { shopId: shopId, euId: euId }).then(function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var mobile = data.result.mobile;

      if (mobile) {
        return _fetchHelper2.default.get(_config2.default.elmLogin + '?shopId=' + shopId + '&mobile=' + mobile + '&code=' + code).then(function (res) {
          if (res === null || res === '') {
            throw { code: '5001', msg: '登录后返回参数为空' };
          }
          return true;
        }).catch(function (err) {
          throw err;
        });
      }
      throw { code: '5001', msg: '登录后返回参数为空' };
    }).catch(function (ex) {
      throw ex;
    });
  },

  /**
   * 判断用户是否登录
   */
  isLogin: function isLogin(info) {
    // const euIdData = window.localStorage && window.localStorage.getItem(EBU_INFO.EBU_EUID);
    // if (euIdData) return Promise.resolve();
    var shopId = info.shopId,
        euId = info.euId;

    return ebuHelper.login({ shopId: shopId, euId: euId }).then(function (res) {
      if (window.localStorage) {
        localStorage.setItem(_const.EBU_INFO.EBU_EUID, euId);
      }
      return true;
    }).catch(function (ex) {
      throw ex;
    });
  }
};
exports.default = ebuHelper;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/person-default.svg";

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _helper = __webpack_require__(16);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _shoppingCart = __webpack_require__(425);

var _shoppingCart2 = _interopRequireDefault(_shoppingCart);

var _common = __webpack_require__(449);

var _common2 = _interopRequireDefault(_common);

var _naviClose = __webpack_require__(533);

var _naviClose2 = _interopRequireDefault(_naviClose);

var _orderDinnerCartHelper = __webpack_require__(453);

var _commonHelper = __webpack_require__(3);

var _iParkHelper = __webpack_require__(462);

var _iParkHelper2 = _interopRequireDefault(_iParkHelper);

var _CcbAppHelper = __webpack_require__(410);

var _CcbAppHelper2 = _interopRequireDefault(_CcbAppHelper);

var _naviCenter = __webpack_require__(534);

var _naviCenter2 = _interopRequireDefault(_naviCenter);

var _naviCoupon = __webpack_require__(535);

var _naviCoupon2 = _interopRequireDefault(_naviCoupon);

var _naviDishmenu = __webpack_require__(536);

var _naviDishmenu2 = _interopRequireDefault(_naviDishmenu);

var _naviOrdercart = __webpack_require__(537);

var _naviOrdercart2 = _interopRequireDefault(_naviOrdercart);

var _naviOrdered = __webpack_require__(538);

var _naviOrdered2 = _interopRequireDefault(_naviOrdered);

var _naviPay = __webpack_require__(539);

var _naviPay2 = _interopRequireDefault(_naviPay);

var _naviServerbell = __webpack_require__(540);

var _naviServerbell2 = _interopRequireDefault(_naviServerbell);

var _prepaidCode = __webpack_require__(541);

var _prepaidCode2 = _interopRequireDefault(_prepaidCode);

var _classnames = __webpack_require__(50);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
// import FormattedMessage from '@/intl/formatted-message';

var BtnShortcutDefault = __webpack_require__(507);

var config = __webpack_require__(13);


var shopId = (0, _commonHelper.getUrlParam)('shopId');
var isIParkEnv = _iParkHelper2.default.isIParkEvn();

var BtnShortcutMulti = React.createClass({
  displayName: 'BtnShortcutMulti',
  propTypes: {
    btnAttributesMulti: React.PropTypes.object,
    orderId: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    tableId: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
    isNavi: React.PropTypes.bool
  },

  getInitialState: function getInitialState() {
    return {
      isChildrenShow: false,
      mainBtnAttributes: this.props.btnAttributesMulti.btnAttributesMain || {}
    };
  },
  componentDidMount: function componentDidMount() {
    document.body.addEventListener('touchstart', this.handleOtherTouch);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _this = this;

    var _nextProps$btnAttribu = nextProps.btnAttributesMulti,
        btnAttributesMulti = _nextProps$btnAttribu === undefined ? {} : _nextProps$btnAttribu,
        isChildrenShowProp = nextProps.isChildrenShowProp;

    this.setState({
      mainBtnAttributes: btnAttributesMulti.btnAttributesMain || {},
      isChildrenShow: isChildrenShowProp
    }, function () {
      setTimeout(function () {
        _this.setState({ isAddTransition: isChildrenShowProp });
      }, 0);
    });
    if (isChildrenShowProp) {
      this.setState({
        mainBtnAttributes: {
          icon: _naviClose2.default,
          text: '',
          iconWidth: '13px',
          onClick: this.clickMethod
        }
      });
    }
  },
  clickMethod: function clickMethod() {
    var _props = this.props,
        isChildrenShowProp = _props.isChildrenShowProp,
        _props$btnAttributesM = _props.btnAttributesMulti.btnAttributesMain,
        btnAttributesMain = _props$btnAttributesM === undefined ? {} : _props$btnAttributesM;
    var clickMethod = btnAttributesMain.onClick;

    this.setState({ isAddTransition: !isChildrenShowProp }, function () {
      if (clickMethod) {
        setTimeout(function () {
          clickMethod();
        }, 200);
      }
    });
  },
  componentWillUnmount: function componentWillUnmount() {
    document.body.removeEventListener('touchstart', this.handleOtherTouch);
  },
  getBtnChildren: function getBtnChildren() {
    var btnAttributesMulti = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _this2 = this;

    var orderId = arguments[1];
    var tableId = arguments[2];
    var _props2 = this.props,
        isNavi = _props2.isNavi,
        refreshServiceStatus = _props2.refreshServiceStatus,
        shopMinConsume = _props2.shopMinConsume,
        fromOrderDinnerStatement = _props2.fromOrderDinnerStatement;

    var isPayFirst = sessionStorage.getItem('diningForm') === '2';
    var tableParam = tableId ? '&tableId=' + tableId : '';
    var orderParam = orderId ? '&orderId=' + orderId : '';
    var hasShopMinConsume = isPayFirst && shopMinConsume && shopMinConsume.state === 1;
    var isCcbEnv = _CcbAppHelper2.default.isCcbEvn();

    var overwriteTableInfo = function overwriteTableInfo() {
      (0, _orderDinnerCartHelper.overWriteSessionStorage)(shopId, {
        tableId: tableId,
        orderId: orderId
      });
    };

    var btnChildrenArray = [];
    var btnChildrenTemp = [];
    var defaultChildren = [{
      text: (0, _helper.formatMessage)(_shoppingCart2.default.mineCoupons),
      childIcon: _naviCoupon2.default,
      onClick: function onClick() {
        overwriteTableInfo();
        location.href = config.getCouponListURL + '?shopId=' + shopId + '&isShowShortcut=true';
      }
    }, {
      text: (0, _helper.formatMessage)(_shoppingCart2.default.checkoutMoney),
      childIcon: _naviPay2.default,
      onClick: function onClick() {
        if (refreshServiceStatus) {
          refreshServiceStatus({ tableId: tableId, orderId: orderId }).then(function () {
            var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (res.addDishUnhandle) {
              _this2.props.setErrorMsg((0, _helper.formatMessage)(_common2.default.commoncannotPay));
              return;
            }

            location.href = config.settlement4DinnerURL + '?shopId=' + shopId + '&tradeId=' + orderId + '&type=TS';
          });
          return;
        }

        location.href = config.settlement4DinnerURL + '?shopId=' + shopId + '&tradeId=' + orderId + '&type=TS';
      }
    }, {
      text: (0, _helper.formatMessage)(_shoppingCart2.default.placedOrder),
      childIcon: _naviOrdered2.default,
      onClick: function onClick() {
        location.href = config.tradeDetailUncheckURL + '?shopId=' + shopId + '&orderId=' + orderId + '&type=TS';
      }
    }, {
      text: (0, _helper.formatMessage)(_shoppingCart2.default.title),
      childIcon: _naviOrdercart2.default,
      onClick: function onClick() {
        overwriteTableInfo();
        location.href = (isPayFirst ? config.dishCart4DinnerPayFirst : config.dishCart4DinnerURL) + '?shopId=' + shopId + '&type=TS';
      }
    }, {
      text: (0, _helper.formatMessage)(_dishMenu2.default.navigatorDishList),
      childIcon: _naviDishmenu2.default,
      onClick: function onClick() {
        location.href = config.dishMenu4DinnerURL + '?shopId=' + shopId + '&type=TS&addDishes=true' + tableParam + orderParam;
      }
    }];

    if (!isIParkEnv) {
      defaultChildren.unshift({
        text: (0, _helper.formatMessage)(_dishMenu2.default.navigatorMeCenter),
        childIcon: _naviCenter2.default,
        onClick: function onClick() {
          overwriteTableInfo();
          location.href = config.mineIndexURL + '?shopId=' + shopId + '&isShowShortcut=true';
          sessionStorage.setItem('isShowShortcut', true);
        }
      });
    }

    // 有最低消费，将菜单换成验证预付单
    if (hasShopMinConsume) {
      defaultChildren.pop();
      defaultChildren.push({
        text: '验证预付单',
        childIcon: _prepaidCode2.default,
        onClick: function onClick() {
          var returnUrl = encodeURIComponent(window.location.href);
          var href = config.prepaidCodeUrl + '?shopId=' + shopId + '&returnUrl=' + returnUrl;
          if (fromOrderDinnerStatement) {
            href = href + '&orderId=' + orderId;
          }
          location.href = href;
        }
      });
    }
    // 添加服务铃
    if (this.props.bell) {
      defaultChildren.push({
        text: (0, _helper.formatMessage)(_dishMenu2.default.serviceBell),
        childIcon: _naviServerbell2.default,
        onClick: function onClick() {
          //
        }
      });
    }

    if (btnAttributesMulti) {
      if (btnAttributesMulti.btnChildren && btnAttributesMulti.btnChildren.length > 0) {
        btnChildrenTemp = btnAttributesMulti.btnChildren;
      } else {
        btnChildrenTemp = defaultChildren;
      }

      if (btnAttributesMulti.btnDisable && btnAttributesMulti.btnDisable.length > 0) {
        for (var i = 0; i < btnAttributesMulti.btnDisable.length; i++) {
          if (typeof btnAttributesMulti.btnDisable[i] === 'number') {
            btnChildrenTemp[btnAttributesMulti.btnDisable[i] - 1].onClick = function () {};
            btnChildrenTemp[btnAttributesMulti.btnDisable[i] - 1].classnames = 'btn-shortcut-disable';
          }
        }
      }
      for (var _i = 0; _i < btnChildrenTemp.length; _i++) {
        var _btnAttributesMulti$b = btnAttributesMulti.btnAttributesDefault,
            btnAttributesDefault = _btnAttributesMulti$b === undefined ? {} : _btnAttributesMulti$b;
        var expandClassNames = btnAttributesDefault.expandClassNames;
        var _btnChildrenTemp$_i$t = btnChildrenTemp[_i].text,
            text = _btnChildrenTemp$_i$t === undefined ? '' : _btnChildrenTemp$_i$t;
        // 建行环境屏蔽个人中心和优惠券入口

        var isNotShowBtn = text === (0, _helper.formatMessage)(_shoppingCart2.default.mineCoupons) || text === (0, _helper.formatMessage)(_dishMenu2.default.navigatorMeCenter);
        if (isNotShowBtn && isCcbEnv) continue;

        var btnChild = React.createElement(BtnShortcutDefault, {
          key: _i,
          btnAttributes: (0, _assign2.default)({}, btnAttributesDefault, btnChildrenTemp[_i], expandClassNames && !isNavi ? { classnames: expandClassNames } : {}),
          isNavi: isNavi
        });
        // 服务铃的处理
        if (text === (0, _helper.formatMessage)(_dishMenu2.default.serviceBell)) {
          btnChild = React.createElement(BtnShortcutDefault, {
            key: _i,
            btnAttributes: (0, _assign2.default)({}, btnAttributesDefault, btnChildrenTemp[_i], expandClassNames && !isNavi ? { classnames: expandClassNames } : {}),
            isNavi: isNavi,
            bell: this.props.bell
          });
        }
        btnChildrenArray.push(btnChild);
      }
    }

    return btnChildrenArray;
  },
  handleOtherTouch: function handleOtherTouch(evt) {
    var target = evt.target;
    var isChildrenShow = this.state.isChildrenShow;


    if (!isChildrenShow || this.refs.wrapper.contains(target)) {
      return;
    }

    var mainBtnAttributes = this.state.mainBtnAttributes;

    if (mainBtnAttributes.onClick) {
      mainBtnAttributes.onClick();
    }
  },
  render: function render() {
    var _props3 = this.props,
        btnAttributesMulti = _props3.btnAttributesMulti,
        orderId = _props3.orderId,
        tableId = _props3.tableId,
        isNavi = _props3.isNavi;
    var _state = this.state,
        isChildrenShow = _state.isChildrenShow,
        isAddTransition = _state.isAddTransition,
        mainBtnAttributes = _state.mainBtnAttributes;
    var btnAttributesDefault = btnAttributesMulti.btnAttributesDefault;

    return React.createElement(
      'div',
      { ref: 'wrapper', className: 'shortcut-multi btn-shortcut-' + (btnAttributesDefault && btnAttributesDefault.size) },
      isChildrenShow && React.createElement(
        'div',
        { className: (0, _classnames2.default)('shortcut-multi-children', { 'shortcut-multi-children--navi': isNavi }) },
        React.createElement('div', {
          className: (0, _classnames2.default)('shortcut-multi-children__hover', {
            'shortcut-multi-children__hover--enter': isAddTransition,
            'shortcut-multi-children__hover--disable': !isNavi
          }),
          onTouchTap: this.clickMethod
        }),
        React.createElement(
          'div',
          { className: (0, _classnames2.default)('o-flex shortcut-multi-children__body', { 'shortcut-multi-children__body--enter': isAddTransition }) },
          this.getBtnChildren(btnAttributesMulti, orderId || (0, _orderDinnerCartHelper.getTableInfoInSessionStorage)(shopId).orderId, tableId || (0, _orderDinnerCartHelper.getTableInfoInSessionStorage)(shopId).tableId)
        )
      ),
      React.createElement(BtnShortcutDefault, { mainButton: true, isChildrenShow: isChildrenShow, btnAttributes: (0, _assign2.default)({}, btnAttributesDefault, mainBtnAttributes) })
    );
  }
});

module.exports = BtnShortcutMulti;

/***/ }),
/* 528 */,
/* 529 */,
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);
var helper = __webpack_require__(43);
var classnames = __webpack_require__(50);

__webpack_require__(620);

module.exports = React.createClass({
  displayName: 'DishDetailHead',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    onCountChange: React.PropTypes.func.isRequired,
    minimum: React.PropTypes.number,
    shouldInitCount: React.PropTypes.bool,
    showMemberPriceInfo: React.PropTypes.bool
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        dish = _props.dish,
        shouldInitCount = _props.shouldInitCount;

    if (shouldInitCount) {
      this.props.onCountChange(dish.dishIncreaseUnit);
    }
  },
  onCountChange: function onCountChange(newCount, increament) {
    this.props.onCountChange(increament);
  },
  splitPropsSpecifications: function splitPropsSpecifications(dish) {
    /*
    if (dish.sameDishIndexs) {
      return false;
    }
     if (!helper.isSingleDishWithoutProps(dish) && dish.dishPropertyTypeInfos) {
      const specification = [];
      dish.dishPropertyTypeInfos.map(
        dishProperty => {
          if (dishProperty.type === 4) {
            specification.push(dishProperty.properties[0].name);
          }
          return false;
        }
      );
      return specification.length !== 0 ? '(' + specification.join(',') + ')' : false;
    }
    */
    /*
    return dish.spec;
    */
    return false;
  },
  render: function render() {
    var _props2 = this.props,
        dish = _props2.dish,
        showMemberPriceInfo = _props2.showMemberPriceInfo;
    var order = dish.order,
        isMember = dish.isMember;

    var price = dish.marketPrice;
    var totalMemberPrice = 0;
    // 仅仅显示一份菜品的价格
    if (Array.isArray(order) && order.length) {
      var newDish = dish.setIn(['order', '0', 'count'], 1);
      price = helper.getDishPrice(newDish);
      totalMemberPrice += helper.getTotalMemberPrice(newDish);
    } else if (typeof order === 'number') {
      totalMemberPrice += helper.getTotalMemberPrice(dish);
    }

    var isShowMemberPrice = isMember && showMemberPriceInfo && totalMemberPrice >= 0;

    /* /{dish.unitName} */
    var unitName = dish.unitName === '份' ? '' : '/' + dish.unitName;
    return React.createElement(
      'div',
      { className: 'dish-detail-head o-flex__fixed' },
      React.createElement(
        'div',
        { className: 'head-main' },
        React.createElement(
          'p',
          { className: 'dish-name' },
          dish.name,
          this.splitPropsSpecifications(dish),
          unitName,
          React.createElement(
            'span',
            null,
            '\xA0'
          ),
          !dish.isVirtualDish && isShowMemberPrice > 0 && React.createElement(
            'span',
            { className: 'price' },
            parseFloat(totalMemberPrice)
          ),
          !dish.isVirtualDish && React.createElement(
            'span',
            { className: classnames('price', { 'line-price': isShowMemberPrice > 0 }) },
            parseFloat(price)
          )
        )
      )
    );
  }
});

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
var rAF = window.requestAnimationFrame	||
	window.webkitRequestAnimationFrame	||
	window.mozRequestAnimationFrame		||
	window.oRequestAnimationFrame		||
	window.msRequestAnimationFrame		||
	function (callback) { window.setTimeout(callback, 1000 / 60); };

var utils = (function () {
	var me = {};

	var _elementStyle = document.createElement('div').style;
	var _vendor = (function () {
		var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			transform,
			i = 0,
			l = vendors.length;

		for ( ; i < l; i++ ) {
			transform = vendors[i] + 'ransform';
			if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
		}

		return false;
	})();

	function _prefixStyle (style) {
		if ( _vendor === false ) return false;
		if ( _vendor === '' ) return style;
		return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
	}

	me.getTime = Date.now || function getTime () { return new Date().getTime(); };

	me.extend = function (target, obj) {
		for ( var i in obj ) {
			target[i] = obj[i];
		}
	};

	me.addEvent = function (el, type, fn, capture) {
		el.addEventListener(type, fn, !!capture);
	};

	me.removeEvent = function (el, type, fn, capture) {
		el.removeEventListener(type, fn, !!capture);
	};

	me.prefixPointerEvent = function (pointerEvent) {
		return window.MSPointerEvent ?
			'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
			pointerEvent;
	};

	me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
		var distance = current - start,
			speed = Math.abs(distance) / time,
			destination,
			duration;

		deceleration = deceleration === undefined ? 0.0006 : deceleration;

		destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
		duration = speed / deceleration;

		if ( destination < lowerMargin ) {
			destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
			distance = Math.abs(destination - current);
			duration = distance / speed;
		} else if ( destination > 0 ) {
			destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
			distance = Math.abs(current) + destination;
			duration = distance / speed;
		}

		return {
			destination: Math.round(destination),
			duration: duration
		};
	};

	var _transform = _prefixStyle('transform');

	me.extend(me, {
		hasTransform: _transform !== false,
		hasPerspective: _prefixStyle('perspective') in _elementStyle,
		hasTouch: 'ontouchstart' in window,
		hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
		hasTransition: _prefixStyle('transition') in _elementStyle
	});

	/*
	This should find all Android browsers lower than build 535.19 (both stock browser and webview)
	- galaxy S2 is ok
    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S3 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S4 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S5 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   - galaxy S6 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
  */
	me.isBadAndroid = (function() {
		var appVersion = window.navigator.appVersion;
		// Android browser is not a chrome browser.
		if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
			var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
			if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
				return parseFloat(safariVersion[1]) < 535.19;
			} else {
				return true;
			}
		} else {
			return false;
		}
	})();

	me.extend(me.style = {}, {
		transform: _transform,
		transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
		transitionDuration: _prefixStyle('transitionDuration'),
		transitionDelay: _prefixStyle('transitionDelay'),
		transformOrigin: _prefixStyle('transformOrigin')
	});

	me.hasClass = function (e, c) {
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
		return re.test(e.className);
	};

	me.addClass = function (e, c) {
		if ( me.hasClass(e, c) ) {
			return;
		}

		var newclass = e.className.split(' ');
		newclass.push(c);
		e.className = newclass.join(' ');
	};

	me.removeClass = function (e, c) {
		if ( !me.hasClass(e, c) ) {
			return;
		}

		var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
		e.className = e.className.replace(re, ' ');
	};

	me.offset = function (el) {
		var left = -el.offsetLeft,
			top = -el.offsetTop;

		// jshint -W084
		while (el = el.offsetParent) {
			left -= el.offsetLeft;
			top -= el.offsetTop;
		}
		// jshint +W084

		return {
			left: left,
			top: top
		};
	};

	me.preventDefaultException = function (el, exceptions) {
		for ( var i in exceptions ) {
			if ( exceptions[i].test(el[i]) ) {
				return true;
			}
		}

		return false;
	};

	me.extend(me.eventType = {}, {
		touchstart: 1,
		touchmove: 1,
		touchend: 1,

		mousedown: 2,
		mousemove: 2,
		mouseup: 2,

		pointerdown: 3,
		pointermove: 3,
		pointerup: 3,

		MSPointerDown: 3,
		MSPointerMove: 3,
		MSPointerUp: 3
	});

	me.extend(me.ease = {}, {
		quadratic: {
			style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
			fn: function (k) {
				return k * ( 2 - k );
			}
		},
		circular: {
			style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
			fn: function (k) {
				return Math.sqrt( 1 - ( --k * k ) );
			}
		},
		back: {
			style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
			fn: function (k) {
				var b = 4;
				return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
			}
		},
		bounce: {
			style: '',
			fn: function (k) {
				if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
					return 7.5625 * k * k;
				} else if ( k < ( 2 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
				} else if ( k < ( 2.5 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
				} else {
					return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
				}
			}
		},
		elastic: {
			style: '',
			fn: function (k) {
				var f = 0.22,
					e = 0.4;

				if ( k === 0 ) { return 0; }
				if ( k == 1 ) { return 1; }

				return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
			}
		}
	});

	me.tap = function (e, eventName) {
		var ev = document.createEvent('Event');
		ev.initEvent(eventName, true, true);
		ev.pageX = e.pageX;
		ev.pageY = e.pageY;
		e.target.dispatchEvent(ev);
	};

	me.click = function (e) {
		var target = e.target,
			ev;

		if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
			// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
			// initMouseEvent is deprecated.
			ev = document.createEvent(window.MouseEvent ? 'MouseEvents' : 'Event');
			ev.initEvent('click', true, true);
			ev.view = e.view || window;
			ev.detail = 1;
			ev.screenX = target.screenX || 0;
			ev.screenY = target.screenY || 0;
			ev.clientX = target.clientX || 0;
			ev.clientY = target.clientY || 0;
			ev.ctrlKey = !!e.ctrlKey;
			ev.altKey = !!e.altKey;
			ev.shiftKey = !!e.shiftKey;
			ev.metaKey = !!e.metaKey;
			ev.button = 0;
			ev.relatedTarget = null;
			ev._constructed = true;
			target.dispatchEvent(ev);
		}
	};

	me.getRect = function(el) {
		if (el instanceof SVGElement) {
			var rect = el.getBoundingClientRect();
			return {
				top : rect.top,
				left : rect.left,
				width : rect.width,
				height : rect.height
			};
		} else {
			return {
				top : el.offsetTop,
				left : el.offsetLeft,
				width : el.offsetWidth,
				height : el.offsetHeight
			};
		}
	};

	return me;
})();
function IScroll (el, options) {
	this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
	this.scroller = this.wrapper.children[0];
	this.scrollerStyle = this.scroller.style;		// cache style for better performance

	this.options = {

		resizeScrollbars: true,

		mouseWheelSpeed: 20,

		snapThreshold: 0.335,
		snapOnFlick: false,

// INSERT POINT: OPTIONS
		disablePointer : !utils.hasPointer,
		disableTouch : utils.hasPointer || !utils.hasTouch,
		disableMouse : utils.hasPointer || utils.hasTouch,
		startX: 0,
		startY: 0,
		scrollY: true,
		directionLockThreshold: 5,
		momentum: true,

		bounce: true,
		bounceTime: 600,
		bounceEasing: '',

		preventDefault: true,
		preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },

		HWCompositing: true,
		useTransition: true,
		useTransform: true,
		bindToWrapper: typeof window.onmousedown === "undefined"
	};

	for ( var i in options ) {
		this.options[i] = options[i];
	}

	// Normalize options
	this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

	this.options.useTransition = utils.hasTransition && this.options.useTransition;
	this.options.useTransform = utils.hasTransform && this.options.useTransform;

	this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
	this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

	// If you want eventPassthrough I have to lock one of the axes
	this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
	this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

	// With eventPassthrough we also need lockDirection mechanism
	this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
	this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

	this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

	this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

	if ( this.options.tap === true ) {
		this.options.tap = 'tap';
	}

	// https://github.com/cubiq/iscroll/issues/1029
	if (!this.options.useTransition && !this.options.useTransform) {
		if(!(/relative|absolute/i).test(this.scrollerStyle.position)) {
			this.scrollerStyle.position = "relative";
		}
	}

	if ( this.options.shrinkScrollbars == 'scale' ) {
		this.options.useTransition = false;
	}

	this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;

	if ( this.options.probeType == 3 ) {
		this.options.useTransition = false;	}

// INSERT POINT: NORMALIZATION

	// Some defaults
	this.x = 0;
	this.y = 0;
	this.directionX = 0;
	this.directionY = 0;
	this._events = {};

// INSERT POINT: DEFAULTS

	this._init();
	this.refresh();

	this.scrollTo(this.options.startX, this.options.startY);
	this.enable();
}

IScroll.prototype = {
	version: '5.2.0',

	_init: function () {
		this._initEvents();

		if ( this.options.scrollbars || this.options.indicators ) {
			this._initIndicators();
		}

		if ( this.options.mouseWheel ) {
			this._initWheel();
		}

		if ( this.options.snap ) {
			this._initSnap();
		}

		if ( this.options.keyBindings ) {
			this._initKeys();
		}

// INSERT POINT: _init

	},

	destroy: function () {
		this._initEvents(true);
		clearTimeout(this.resizeTimeout);
 		this.resizeTimeout = null;
		this._execEvent('destroy');
	},

	_transitionEnd: function (e) {
		if ( e.target != this.scroller || !this.isInTransition ) {
			return;
		}

		this._transitionTime();
		if ( !this.resetPosition(this.options.bounceTime) ) {
			this.isInTransition = false;
			this._execEvent('scrollEnd');
		}
	},

	_start: function (e) {
		// React to left mouse button only
		if ( utils.eventType[e.type] != 1 ) {
		  // for button property
		  // http://unixpapa.com/js/mouse.html
		  var button;
	    if (!e.which) {
	      /* IE case */
	      button = (e.button < 2) ? 0 :
	               ((e.button == 4) ? 1 : 2);
	    } else {
	      /* All others */
	      button = e.button;
	    }
			if ( button !== 0 ) {
				return;
			}
		}

		if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
			return;
		}

		if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}

		var point = e.touches ? e.touches[0] : e,
			pos;

		this.initiated	= utils.eventType[e.type];
		this.moved		= false;
		this.distX		= 0;
		this.distY		= 0;
		this.directionX = 0;
		this.directionY = 0;
		this.directionLocked = 0;

		this.startTime = utils.getTime();

		if ( this.options.useTransition && this.isInTransition ) {
			this._transitionTime();
			this.isInTransition = false;
			pos = this.getComputedPosition();
			this._translate(Math.round(pos.x), Math.round(pos.y));
			this._execEvent('scrollEnd');
		} else if ( !this.options.useTransition && this.isAnimating ) {
			this.isAnimating = false;
			this._execEvent('scrollEnd');
		}

		this.startX    = this.x;
		this.startY    = this.y;
		this.absStartX = this.x;
		this.absStartY = this.y;
		this.pointX    = point.pageX;
		this.pointY    = point.pageY;

		this._execEvent('beforeScrollStart');
	},

	_move: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}

		if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
			e.preventDefault();
		}

		var point		= e.touches ? e.touches[0] : e,
			deltaX		= point.pageX - this.pointX,
			deltaY		= point.pageY - this.pointY,
			timestamp	= utils.getTime(),
			newX, newY,
			absDistX, absDistY;

		this.pointX		= point.pageX;
		this.pointY		= point.pageY;

		this.distX		+= deltaX;
		this.distY		+= deltaY;
		absDistX		= Math.abs(this.distX);
		absDistY		= Math.abs(this.distY);

		// We need to move at least 10 pixels for the scrolling to initiate
		if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
			return;
		}

		// If you are scrolling in one direction lock the other
		if ( !this.directionLocked && !this.options.freeScroll ) {
			if ( absDistX > absDistY + this.options.directionLockThreshold ) {
				this.directionLocked = 'h';		// lock horizontally
			} else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
				this.directionLocked = 'v';		// lock vertically
			} else {
				this.directionLocked = 'n';		// no lock
			}
		}

		if ( this.directionLocked == 'h' ) {
			if ( this.options.eventPassthrough == 'vertical' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'horizontal' ) {
				this.initiated = false;
				return;
			}

			deltaY = 0;
		} else if ( this.directionLocked == 'v' ) {
			if ( this.options.eventPassthrough == 'horizontal' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'vertical' ) {
				this.initiated = false;
				return;
			}

			deltaX = 0;
		}

		deltaX = this.hasHorizontalScroll ? deltaX : 0;
		deltaY = this.hasVerticalScroll ? deltaY : 0;

		newX = this.x + deltaX;
		newY = this.y + deltaY;

		// Slow down if outside of the boundaries
		if ( newX > 0 || newX < this.maxScrollX ) {
			newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
		}
		if ( newY > 0 || newY < this.maxScrollY ) {
			newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
		}

		this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
		this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

		if ( !this.moved ) {
			this._execEvent('scrollStart');
		}

		this.moved = true;

		this._translate(newX, newY);

/* REPLACE START: _move */
		if ( timestamp - this.startTime > 300 ) {
			this.startTime = timestamp;
			this.startX = this.x;
			this.startY = this.y;

			if ( this.options.probeType == 1 ) {
				this._execEvent('scroll');
			}
		}

		if ( this.options.probeType > 1 ) {
			this._execEvent('scroll');
		}
/* REPLACE END: _move */

	},

	_end: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}

		if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}

		var point = e.changedTouches ? e.changedTouches[0] : e,
			momentumX,
			momentumY,
			duration = utils.getTime() - this.startTime,
			newX = Math.round(this.x),
			newY = Math.round(this.y),
			distanceX = Math.abs(newX - this.startX),
			distanceY = Math.abs(newY - this.startY),
			time = 0,
			easing = '';

		this.isInTransition = 0;
		this.initiated = 0;
		this.endTime = utils.getTime();

		// reset if we are outside of the boundaries
		if ( this.resetPosition(this.options.bounceTime) ) {
			return;
		}

		this.scrollTo(newX, newY);	// ensures that the last position is rounded

		// we scrolled less than 10 pixels
		if ( !this.moved ) {
			if ( this.options.tap ) {
				utils.tap(e, this.options.tap);
			}

			if ( this.options.click ) {
				utils.click(e);
			}

			this._execEvent('scrollCancel');
			return;
		}

		if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
			this._execEvent('flick');
			return;
		}

		// start momentum animation if needed
		if ( this.options.momentum && duration < 300 ) {
			momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
			momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
			newX = momentumX.destination;
			newY = momentumY.destination;
			time = Math.max(momentumX.duration, momentumY.duration);
			this.isInTransition = 1;
		}


		if ( this.options.snap ) {
			var snap = this._nearestSnap(newX, newY);
			this.currentPage = snap;
			time = this.options.snapSpeed || Math.max(
					Math.max(
						Math.min(Math.abs(newX - snap.x), 1000),
						Math.min(Math.abs(newY - snap.y), 1000)
					), 300);
			newX = snap.x;
			newY = snap.y;

			this.directionX = 0;
			this.directionY = 0;
			easing = this.options.bounceEasing;
		}

// INSERT POINT: _end

		if ( newX != this.x || newY != this.y ) {
			// change easing function when scroller goes out of the boundaries
			if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
				easing = utils.ease.quadratic;
			}

			this.scrollTo(newX, newY, time, easing);
			return;
		}

		this._execEvent('scrollEnd');
	},

	_resize: function () {
		var that = this;

		clearTimeout(this.resizeTimeout);

		this.resizeTimeout = setTimeout(function () {
			that.refresh();
		}, this.options.resizePolling);
	},

	resetPosition: function (time) {
		var x = this.x,
			y = this.y;

		time = time || 0;

		if ( !this.hasHorizontalScroll || this.x > 0 ) {
			x = 0;
		} else if ( this.x < this.maxScrollX ) {
			x = this.maxScrollX;
		}

		if ( !this.hasVerticalScroll || this.y > 0 ) {
			y = 0;
		} else if ( this.y < this.maxScrollY ) {
			y = this.maxScrollY;
		}

		if ( x == this.x && y == this.y ) {
			return false;
		}

		this.scrollTo(x, y, time, this.options.bounceEasing);
    if (this.options.snap) {
      this.currentPage = this._nearestSnap(x, y);
    }
		return true;
	},

	disable: function () {
		this.enabled = false;
	},

	enable: function () {
		this.enabled = true;
	},

	refresh: function () {
		utils.getRect(this.wrapper);		// Force reflow

		this.wrapperWidth	= this.wrapper.clientWidth;
		this.wrapperHeight	= this.wrapper.clientHeight;

		var rect = utils.getRect(this.scroller);
/* REPLACE START: refresh */

		this.scrollerWidth	= rect.width;
		this.scrollerHeight	= rect.height;

		this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
		this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;

/* REPLACE END: refresh */

		this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
		this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;

		if ( !this.hasHorizontalScroll ) {
			this.maxScrollX = 0;
			this.scrollerWidth = this.wrapperWidth;
		}

		if ( !this.hasVerticalScroll ) {
			this.maxScrollY = 0;
			this.scrollerHeight = this.wrapperHeight;
		}

		this.endTime = 0;
		this.directionX = 0;
		this.directionY = 0;

		this.wrapperOffset = utils.offset(this.wrapper);

		this._execEvent('refresh');

		this.resetPosition();

// INSERT POINT: _refresh

	},

	on: function (type, fn) {
		if ( !this._events[type] ) {
			this._events[type] = [];
		}

		this._events[type].push(fn);
	},

	off: function (type, fn) {
		if ( !this._events[type] ) {
			return;
		}

		var index = this._events[type].indexOf(fn);

		if ( index > -1 ) {
			this._events[type].splice(index, 1);
		}
	},

	_execEvent: function (type) {
		if ( !this._events[type] ) {
			return;
		}

		var i = 0,
			l = this._events[type].length;

		if ( !l ) {
			return;
		}

		for ( ; i < l; i++ ) {
			this._events[type][i].apply(this, [].slice.call(arguments, 1));
		}
	},

	scrollBy: function (x, y, time, easing) {
		x = this.x + x;
		y = this.y + y;
		time = time || 0;

		this.scrollTo(x, y, time, easing);
	},

	scrollTo: function (x, y, time, easing) {
		easing = easing || utils.ease.circular;

		this.isInTransition = this.options.useTransition && time > 0;
		var transitionType = this.options.useTransition && easing.style;
		if ( !time || transitionType ) {
				if(transitionType) {
					this._transitionTimingFunction(easing.style);
					this._transitionTime(time);
				}
			this._translate(x, y);
		} else {
			this._animate(x, y, time, easing.fn);
		}
	},

	scrollToElement: function (el, time, offsetX, offsetY, easing) {
		el = el.nodeType ? el : this.scroller.querySelector(el);

		if ( !el ) {
			return;
		}

		var pos = utils.offset(el);

		pos.left -= this.wrapperOffset.left;
		pos.top  -= this.wrapperOffset.top;

		// if offsetX/Y are true we center the element to the screen
		var elRect = utils.getRect(el);
		var wrapperRect = utils.getRect(this.wrapper);
		if ( offsetX === true ) {
			offsetX = Math.round(elRect.width / 2 - wrapperRect.width / 2);
		}
		if ( offsetY === true ) {
			offsetY = Math.round(elRect.height / 2 - wrapperRect.height / 2);
		}

		pos.left -= offsetX || 0;
		pos.top  -= offsetY || 0;

		pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
		pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;

		time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;

		this.scrollTo(pos.left, pos.top, time, easing);
	},

	_transitionTime: function (time) {
		if (!this.options.useTransition) {
			return;
		}
		time = time || 0;
		var durationProp = utils.style.transitionDuration;
		if(!durationProp) {
			return;
		}

		this.scrollerStyle[durationProp] = time + 'ms';

		if ( !time && utils.isBadAndroid ) {
			this.scrollerStyle[durationProp] = '0.0001ms';
			// remove 0.0001ms
			var self = this;
			rAF(function() {
				if(self.scrollerStyle[durationProp] === '0.0001ms') {
					self.scrollerStyle[durationProp] = '0s';
				}
			});
		}


		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].transitionTime(time);
			}
		}


// INSERT POINT: _transitionTime

	},

	_transitionTimingFunction: function (easing) {
		this.scrollerStyle[utils.style.transitionTimingFunction] = easing;


		if ( this.indicators ) {
			for ( var i = this.indicators.length; i--; ) {
				this.indicators[i].transitionTimingFunction(easing);
			}
		}


// INSERT POINT: _transitionTimingFunction

	},

	_translate: function (x, y) {
		if ( this.options.useTransform ) {

/* REPLACE START: _translate */

			this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

/* REPLACE END: _translate */

		} else {
			x = Math.round(x);
			y = Math.round(y);
			this.scrollerStyle.left = x + 'px';
			this.scrollerStyle.top = y + 'px';
		}

		this.x = x;
		this.y = y;


	if ( this.indicators ) {
		for ( var i = this.indicators.length; i--; ) {
			this.indicators[i].updatePosition();
		}
	}


// INSERT POINT: _translate

	},

	_initEvents: function (remove) {
		var eventType = remove ? utils.removeEvent : utils.addEvent,
			target = this.options.bindToWrapper ? this.wrapper : window;

		eventType(window, 'orientationchange', this);
		eventType(window, 'resize', this);

		if ( this.options.click ) {
			eventType(this.wrapper, 'click', this, true);
		}

		if ( !this.options.disableMouse ) {
			eventType(this.wrapper, 'mousedown', this);
			eventType(target, 'mousemove', this);
			eventType(target, 'mousecancel', this);
			eventType(target, 'mouseup', this);
		}

		if ( utils.hasPointer && !this.options.disablePointer ) {
			eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
			eventType(target, utils.prefixPointerEvent('pointermove'), this);
			eventType(target, utils.prefixPointerEvent('pointercancel'), this);
			eventType(target, utils.prefixPointerEvent('pointerup'), this);
		}

		if ( utils.hasTouch && !this.options.disableTouch ) {
			eventType(this.wrapper, 'touchstart', this);
			eventType(target, 'touchmove', this);
			eventType(target, 'touchcancel', this);
			eventType(target, 'touchend', this);
		}

		eventType(this.scroller, 'transitionend', this);
		eventType(this.scroller, 'webkitTransitionEnd', this);
		eventType(this.scroller, 'oTransitionEnd', this);
		eventType(this.scroller, 'MSTransitionEnd', this);
	},

	getComputedPosition: function () {
		var matrix = window.getComputedStyle(this.scroller, null),
			x, y;

		if ( this.options.useTransform ) {
			matrix = matrix[utils.style.transform].split(')')[0].split(', ');
			x = +(matrix[12] || matrix[4]);
			y = +(matrix[13] || matrix[5]);
		} else {
			x = +matrix.left.replace(/[^-\d.]/g, '');
			y = +matrix.top.replace(/[^-\d.]/g, '');
		}

		return { x: x, y: y };
	},

	_initIndicators: function () {
		var interactive = this.options.interactiveScrollbars,
			customStyle = typeof this.options.scrollbars != 'string',
			indicators = [],
			indicator;

		var that = this;

		this.indicators = [];

		if ( this.options.scrollbars ) {
			// Vertical scrollbar
			if ( this.options.scrollY ) {
				indicator = {
					el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
					interactive: interactive,
					defaultScrollbars: true,
					customStyle: customStyle,
					resize: this.options.resizeScrollbars,
					shrink: this.options.shrinkScrollbars,
					fade: this.options.fadeScrollbars,
					listenX: false
				};

				this.wrapper.appendChild(indicator.el);
				indicators.push(indicator);
			}

			// Horizontal scrollbar
			if ( this.options.scrollX ) {
				indicator = {
					el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
					interactive: interactive,
					defaultScrollbars: true,
					customStyle: customStyle,
					resize: this.options.resizeScrollbars,
					shrink: this.options.shrinkScrollbars,
					fade: this.options.fadeScrollbars,
					listenY: false
				};

				this.wrapper.appendChild(indicator.el);
				indicators.push(indicator);
			}
		}

		if ( this.options.indicators ) {
			// TODO: check concat compatibility
			indicators = indicators.concat(this.options.indicators);
		}

		for ( var i = indicators.length; i--; ) {
			this.indicators.push( new Indicator(this, indicators[i]) );
		}

		// TODO: check if we can use array.map (wide compatibility and performance issues)
		function _indicatorsMap (fn) {
			if (that.indicators) {
				for ( var i = that.indicators.length; i--; ) {
					fn.call(that.indicators[i]);
				}
			}
		}

		if ( this.options.fadeScrollbars ) {
			this.on('scrollEnd', function () {
				_indicatorsMap(function () {
					this.fade();
				});
			});

			this.on('scrollCancel', function () {
				_indicatorsMap(function () {
					this.fade();
				});
			});

			this.on('scrollStart', function () {
				_indicatorsMap(function () {
					this.fade(1);
				});
			});

			this.on('beforeScrollStart', function () {
				_indicatorsMap(function () {
					this.fade(1, true);
				});
			});
		}


		this.on('refresh', function () {
			_indicatorsMap(function () {
				this.refresh();
			});
		});

		this.on('destroy', function () {
			_indicatorsMap(function () {
				this.destroy();
			});

			delete this.indicators;
		});
	},

	_initWheel: function () {
		utils.addEvent(this.wrapper, 'wheel', this);
		utils.addEvent(this.wrapper, 'mousewheel', this);
		utils.addEvent(this.wrapper, 'DOMMouseScroll', this);

		this.on('destroy', function () {
			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = null;
			utils.removeEvent(this.wrapper, 'wheel', this);
			utils.removeEvent(this.wrapper, 'mousewheel', this);
			utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
		});
	},

	_wheel: function (e) {
		if ( !this.enabled ) {
			return;
		}

		e.preventDefault();

		var wheelDeltaX, wheelDeltaY,
			newX, newY,
			that = this;

		if ( this.wheelTimeout === undefined ) {
			that._execEvent('scrollStart');
		}

		// Execute the scrollEnd event after 400ms the wheel stopped scrolling
		clearTimeout(this.wheelTimeout);
		this.wheelTimeout = setTimeout(function () {
			if(!that.options.snap) {
				that._execEvent('scrollEnd');
			}
			that.wheelTimeout = undefined;
		}, 400);

		if ( 'deltaX' in e ) {
			if (e.deltaMode === 1) {
				wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
				wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
			} else {
				wheelDeltaX = -e.deltaX;
				wheelDeltaY = -e.deltaY;
			}
		} else if ( 'wheelDeltaX' in e ) {
			wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
			wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
		} else if ( 'wheelDelta' in e ) {
			wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
		} else if ( 'detail' in e ) {
			wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
		} else {
			return;
		}

		wheelDeltaX *= this.options.invertWheelDirection;
		wheelDeltaY *= this.options.invertWheelDirection;

		if ( !this.hasVerticalScroll ) {
			wheelDeltaX = wheelDeltaY;
			wheelDeltaY = 0;
		}

		if ( this.options.snap ) {
			newX = this.currentPage.pageX;
			newY = this.currentPage.pageY;

			if ( wheelDeltaX > 0 ) {
				newX--;
			} else if ( wheelDeltaX < 0 ) {
				newX++;
			}

			if ( wheelDeltaY > 0 ) {
				newY--;
			} else if ( wheelDeltaY < 0 ) {
				newY++;
			}

			this.goToPage(newX, newY);

			return;
		}

		newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
		newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);

		this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
		this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;

		if ( newX > 0 ) {
			newX = 0;
		} else if ( newX < this.maxScrollX ) {
			newX = this.maxScrollX;
		}

		if ( newY > 0 ) {
			newY = 0;
		} else if ( newY < this.maxScrollY ) {
			newY = this.maxScrollY;
		}

		this.scrollTo(newX, newY, 0);

		if ( this.options.probeType > 1 ) {
			this._execEvent('scroll');
		}

// INSERT POINT: _wheel
	},

	_initSnap: function () {
		this.currentPage = {};

	  this.options.originSnap = this.options.snap;

		this.on('refresh', function () {
			var i = 0, l,
				m = 0, n,
				cx, cy,
				x = 0, y,
				stepX = this.options.snapStepX || this.wrapperWidth,
				stepY = this.options.snapStepY || this.wrapperHeight,
				el,
				rect;

      if ( typeof this.options.originSnap == 'string' ) {
        this.options.snap = this.scroller.querySelectorAll(this.options.originSnap);
      }

			this.pages = [];

			if ( !this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight ) {
				return;
			}

			if ( this.options.snap === true ) {
				cx = Math.round( stepX / 2 );
				cy = Math.round( stepY / 2 );

				while ( x > -this.scrollerWidth ) {
					this.pages[i] = [];
					l = 0;
					y = 0;

					while ( y > -this.scrollerHeight ) {
						this.pages[i][l] = {
							x: Math.max(x, this.maxScrollX),
							y: Math.max(y, this.maxScrollY),
							width: stepX,
							height: stepY,
							cx: x - cx,
							cy: y - cy
						};

						y -= stepY;
						l++;
					}

					x -= stepX;
					i++;
				}
			} else {
				el = this.options.snap;
				l = el.length;
				n = -1;

				for ( ; i < l; i++ ) {
					rect = utils.getRect(el[i]);
					if ( i === 0 || rect.left <= utils.getRect(el[i-1]).left ) {
						m = 0;
						n++;
					}

					if ( !this.pages[m] ) {
						this.pages[m] = [];
					}

					x = Math.max(-rect.left, this.maxScrollX);
					y = Math.max(-rect.top, this.maxScrollY);
					cx = x - Math.round(rect.width / 2);
					cy = y - Math.round(rect.height / 2);

					this.pages[m][n] = {
						x: x,
						y: y,
						width: rect.width,
						height: rect.height,
						cx: cx,
						cy: cy
					};

					if ( x > this.maxScrollX ) {
						m++;
					}
				}
			}

			this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);

			// Update snap threshold if needed
			if ( this.options.snapThreshold % 1 === 0 ) {
				this.snapThresholdX = this.options.snapThreshold;
				this.snapThresholdY = this.options.snapThreshold;
			} else {
				this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
				this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
			}
		});
    if (this.options.snapOnFlick) {
    	this.on('flick', function () {
    		var time = this.options.snapSpeed || Math.max(
    				Math.max(
    					Math.min(Math.abs(this.x - this.startX), 1000),
    					Math.min(Math.abs(this.y - this.startY), 1000)
    				), 300);

    		this.goToPage(
    			this.currentPage.pageX + this.directionX,
    			this.currentPage.pageY + this.directionY,
    			time
    		);
    	});
    }
	},

	_nearestSnap: function (x, y) {
		if ( !this.pages.length ) {
			return { x: 0, y: 0, pageX: 0, pageY: 0 };
		}

		var i = 0,
			l = this.pages.length,
			m = 0;

		// Check if we exceeded the snap threshold
		if ( Math.abs(x - this.absStartX) < this.snapThresholdX &&
			Math.abs(y - this.absStartY) < this.snapThresholdY ) {
			return this.currentPage;
		}

		if ( x > 0 ) {
			x = 0;
		} else if ( x < this.maxScrollX ) {
			x = this.maxScrollX;
		}

		if ( y > 0 ) {
			y = 0;
		} else if ( y < this.maxScrollY ) {
			y = this.maxScrollY;
		}

		for ( ; i < l; i++ ) {
			if ( x >= this.pages[i][0].cx ) {
				x = this.pages[i][0].x;
				break;
			}
		}

		l = this.pages[i].length;

		for ( ; m < l; m++ ) {
			if ( y >= this.pages[0][m].cy ) {
				y = this.pages[0][m].y;
				break;
			}
		}

		if ( i == this.currentPage.pageX ) {
			i += this.directionX;

			if ( i < 0 ) {
				i = 0;
			} else if ( i >= this.pages.length ) {
				i = this.pages.length - 1;
			}

			x = this.pages[i][0].x;
		}

		if ( m == this.currentPage.pageY ) {
			m += this.directionY;

			if ( m < 0 ) {
				m = 0;
			} else if ( m >= this.pages[0].length ) {
				m = this.pages[0].length - 1;
			}

			y = this.pages[0][m].y;
		}

		return {
			x: x,
			y: y,
			pageX: i,
			pageY: m
		};
	},

	goToPage: function (x, y, time, easing) {
		easing = easing || this.options.bounceEasing;

		if ( x >= this.pages.length ) {
			x = this.pages.length - 1;
		} else if ( x < 0 ) {
			x = 0;
		}

		if ( y >= this.pages[x].length ) {
			y = this.pages[x].length - 1;
		} else if ( y < 0 ) {
			y = 0;
		}

		var posX = this.pages[x][y].x,
			posY = this.pages[x][y].y;

		time = time === undefined ? this.options.snapSpeed || Math.max(
			Math.max(
				Math.min(Math.abs(posX - this.x), 1000),
				Math.min(Math.abs(posY - this.y), 1000)
			), 300) : time;

		this.currentPage = {
			x: posX,
			y: posY,
			pageX: x,
			pageY: y
		};

		this.scrollTo(posX, posY, time, easing);
	},

	next: function (time, easing) {
		var x = this.currentPage.pageX,
			y = this.currentPage.pageY;

		x++;

		if ( x >= this.pages.length && this.hasVerticalScroll ) {
			x = 0;
			y++;
		}

		this.goToPage(x, y, time, easing);
	},

	prev: function (time, easing) {
		var x = this.currentPage.pageX,
			y = this.currentPage.pageY;

		x--;

		if ( x < 0 && this.hasVerticalScroll ) {
			x = 0;
			y--;
		}

		this.goToPage(x, y, time, easing);
	},

	_initKeys: function (e) {
		// default key bindings
		var keys = {
			pageUp: 33,
			pageDown: 34,
			end: 35,
			home: 36,
			left: 37,
			up: 38,
			right: 39,
			down: 40
		};
		var i;

		// if you give me characters I give you keycode
		if ( typeof this.options.keyBindings == 'object' ) {
			for ( i in this.options.keyBindings ) {
				if ( typeof this.options.keyBindings[i] == 'string' ) {
					this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
				}
			}
		} else {
			this.options.keyBindings = {};
		}

		for ( i in keys ) {
			this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
		}

		utils.addEvent(window, 'keydown', this);

		this.on('destroy', function () {
			utils.removeEvent(window, 'keydown', this);
		});
	},

	_key: function (e) {
		if ( !this.enabled ) {
			return;
		}

		var snap = this.options.snap,	// we are using this alot, better to cache it
			newX = snap ? this.currentPage.pageX : this.x,
			newY = snap ? this.currentPage.pageY : this.y,
			now = utils.getTime(),
			prevTime = this.keyTime || 0,
			acceleration = 0.250,
			pos;

		if ( this.options.useTransition && this.isInTransition ) {
			pos = this.getComputedPosition();

			this._translate(Math.round(pos.x), Math.round(pos.y));
			this.isInTransition = false;
		}

		this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;

		switch ( e.keyCode ) {
			case this.options.keyBindings.pageUp:
				if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
					newX += snap ? 1 : this.wrapperWidth;
				} else {
					newY += snap ? 1 : this.wrapperHeight;
				}
				break;
			case this.options.keyBindings.pageDown:
				if ( this.hasHorizontalScroll && !this.hasVerticalScroll ) {
					newX -= snap ? 1 : this.wrapperWidth;
				} else {
					newY -= snap ? 1 : this.wrapperHeight;
				}
				break;
			case this.options.keyBindings.end:
				newX = snap ? this.pages.length-1 : this.maxScrollX;
				newY = snap ? this.pages[0].length-1 : this.maxScrollY;
				break;
			case this.options.keyBindings.home:
				newX = 0;
				newY = 0;
				break;
			case this.options.keyBindings.left:
				newX += snap ? -1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.up:
				newY += snap ? 1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.right:
				newX -= snap ? -1 : 5 + this.keyAcceleration>>0;
				break;
			case this.options.keyBindings.down:
				newY -= snap ? 1 : 5 + this.keyAcceleration>>0;
				break;
			default:
				return;
		}

		if ( snap ) {
			this.goToPage(newX, newY);
			return;
		}

		if ( newX > 0 ) {
			newX = 0;
			this.keyAcceleration = 0;
		} else if ( newX < this.maxScrollX ) {
			newX = this.maxScrollX;
			this.keyAcceleration = 0;
		}

		if ( newY > 0 ) {
			newY = 0;
			this.keyAcceleration = 0;
		} else if ( newY < this.maxScrollY ) {
			newY = this.maxScrollY;
			this.keyAcceleration = 0;
		}

		this.scrollTo(newX, newY, 0);

		this.keyTime = now;
	},

	_animate: function (destX, destY, duration, easingFn) {
		var that = this,
			startX = this.x,
			startY = this.y,
			startTime = utils.getTime(),
			destTime = startTime + duration;

		function step () {
			var now = utils.getTime(),
				newX, newY,
				easing;

			if ( now >= destTime ) {
				that.isAnimating = false;
				that._translate(destX, destY);
				
				if ( !that.resetPosition(that.options.bounceTime) ) {
					that._execEvent('scrollEnd');
				}

				return;
			}

			now = ( now - startTime ) / duration;
			easing = easingFn(now);
			newX = ( destX - startX ) * easing + startX;
			newY = ( destY - startY ) * easing + startY;
			that._translate(newX, newY);

			if ( that.isAnimating ) {
				rAF(step);
			}

			if ( that.options.probeType == 3 ) {
				that._execEvent('scroll');
			}
		}

		this.isAnimating = true;
		step();
	},

	handleEvent: function (e) {
		switch ( e.type ) {
			case 'touchstart':
			case 'pointerdown':
			case 'MSPointerDown':
			case 'mousedown':
				this._start(e);
				break;
			case 'touchmove':
			case 'pointermove':
			case 'MSPointerMove':
			case 'mousemove':
				this._move(e);
				break;
			case 'touchend':
			case 'pointerup':
			case 'MSPointerUp':
			case 'mouseup':
			case 'touchcancel':
			case 'pointercancel':
			case 'MSPointerCancel':
			case 'mousecancel':
				this._end(e);
				break;
			case 'orientationchange':
			case 'resize':
				this._resize();
				break;
			case 'transitionend':
			case 'webkitTransitionEnd':
			case 'oTransitionEnd':
			case 'MSTransitionEnd':
				this._transitionEnd(e);
				break;
			case 'wheel':
			case 'DOMMouseScroll':
			case 'mousewheel':
				this._wheel(e);
				break;
			case 'keydown':
				this._key(e);
				break;
			case 'click':
				if ( this.enabled && !e._constructed ) {
					e.preventDefault();
					e.stopPropagation();
				}
				break;
		}
	}
};
function createDefaultScrollbar (direction, interactive, type) {
	var scrollbar = document.createElement('div'),
		indicator = document.createElement('div');

	if ( type === true ) {
		scrollbar.style.cssText = 'position:absolute;z-index:9999';
		indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
	}

	indicator.className = 'iScrollIndicator';

	if ( direction == 'h' ) {
		if ( type === true ) {
			scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
			indicator.style.height = '100%';
		}
		scrollbar.className = 'iScrollHorizontalScrollbar';
	} else {
		if ( type === true ) {
			scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
			indicator.style.width = '100%';
		}
		scrollbar.className = 'iScrollVerticalScrollbar';
	}

	scrollbar.style.cssText += ';overflow:hidden';

	if ( !interactive ) {
		scrollbar.style.pointerEvents = 'none';
	}

	scrollbar.appendChild(indicator);

	return scrollbar;
}

function Indicator (scroller, options) {
	this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
	this.wrapperStyle = this.wrapper.style;
	this.indicator = this.wrapper.children[0];
	this.indicatorStyle = this.indicator.style;
	this.scroller = scroller;

	this.options = {
		listenX: true,
		listenY: true,
		interactive: false,
		resize: true,
		defaultScrollbars: false,
		shrink: false,
		fade: false,
		speedRatioX: 0,
		speedRatioY: 0
	};

	for ( var i in options ) {
		this.options[i] = options[i];
	}

	this.sizeRatioX = 1;
	this.sizeRatioY = 1;
	this.maxPosX = 0;
	this.maxPosY = 0;

	if ( this.options.interactive ) {
		if ( !this.options.disableTouch ) {
			utils.addEvent(this.indicator, 'touchstart', this);
			utils.addEvent(window, 'touchend', this);
		}
		if ( !this.options.disablePointer ) {
			utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
			utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
		}
		if ( !this.options.disableMouse ) {
			utils.addEvent(this.indicator, 'mousedown', this);
			utils.addEvent(window, 'mouseup', this);
		}
	}

	if ( this.options.fade ) {
		this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
		var durationProp = utils.style.transitionDuration;
		if(!durationProp) {
			return;
		}
		this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
		// remove 0.0001ms
		var self = this;
		if(utils.isBadAndroid) {
			rAF(function() {
				if(self.wrapperStyle[durationProp] === '0.0001ms') {
					self.wrapperStyle[durationProp] = '0s';
				}
			});
		}
		this.wrapperStyle.opacity = '0';
	}
}

Indicator.prototype = {
	handleEvent: function (e) {
		switch ( e.type ) {
			case 'touchstart':
			case 'pointerdown':
			case 'MSPointerDown':
			case 'mousedown':
				this._start(e);
				break;
			case 'touchmove':
			case 'pointermove':
			case 'MSPointerMove':
			case 'mousemove':
				this._move(e);
				break;
			case 'touchend':
			case 'pointerup':
			case 'MSPointerUp':
			case 'mouseup':
			case 'touchcancel':
			case 'pointercancel':
			case 'MSPointerCancel':
			case 'mousecancel':
				this._end(e);
				break;
		}
	},

	destroy: function () {
		if ( this.options.fadeScrollbars ) {
			clearTimeout(this.fadeTimeout);
			this.fadeTimeout = null;
		}
		if ( this.options.interactive ) {
			utils.removeEvent(this.indicator, 'touchstart', this);
			utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
			utils.removeEvent(this.indicator, 'mousedown', this);

			utils.removeEvent(window, 'touchmove', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
			utils.removeEvent(window, 'mousemove', this);

			utils.removeEvent(window, 'touchend', this);
			utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
			utils.removeEvent(window, 'mouseup', this);
		}

		if ( this.options.defaultScrollbars ) {
			this.wrapper.parentNode.removeChild(this.wrapper);
		}
	},

	_start: function (e) {
		var point = e.touches ? e.touches[0] : e;

		e.preventDefault();
		e.stopPropagation();

		this.transitionTime();

		this.initiated = true;
		this.moved = false;
		this.lastPointX	= point.pageX;
		this.lastPointY	= point.pageY;

		this.startTime	= utils.getTime();

		if ( !this.options.disableTouch ) {
			utils.addEvent(window, 'touchmove', this);
		}
		if ( !this.options.disablePointer ) {
			utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
		}
		if ( !this.options.disableMouse ) {
			utils.addEvent(window, 'mousemove', this);
		}

		this.scroller._execEvent('beforeScrollStart');
	},

	_move: function (e) {
		var point = e.touches ? e.touches[0] : e,
			deltaX, deltaY,
			newX, newY,
			timestamp = utils.getTime();

		if ( !this.moved ) {
			this.scroller._execEvent('scrollStart');
		}

		this.moved = true;

		deltaX = point.pageX - this.lastPointX;
		this.lastPointX = point.pageX;

		deltaY = point.pageY - this.lastPointY;
		this.lastPointY = point.pageY;

		newX = this.x + deltaX;
		newY = this.y + deltaY;

		this._pos(newX, newY);


		if ( this.scroller.options.probeType == 1 && timestamp - this.startTime > 300 ) {
			this.startTime = timestamp;
			this.scroller._execEvent('scroll');
		} else if ( this.scroller.options.probeType > 1 ) {
			this.scroller._execEvent('scroll');
		}


// INSERT POINT: indicator._move

		e.preventDefault();
		e.stopPropagation();
	},

	_end: function (e) {
		if ( !this.initiated ) {
			return;
		}

		this.initiated = false;

		e.preventDefault();
		e.stopPropagation();

		utils.removeEvent(window, 'touchmove', this);
		utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
		utils.removeEvent(window, 'mousemove', this);

		if ( this.scroller.options.snap ) {
			var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);

			var time = this.options.snapSpeed || Math.max(
					Math.max(
						Math.min(Math.abs(this.scroller.x - snap.x), 1000),
						Math.min(Math.abs(this.scroller.y - snap.y), 1000)
					), 300);

			if ( this.scroller.x != snap.x || this.scroller.y != snap.y ) {
				this.scroller.directionX = 0;
				this.scroller.directionY = 0;
				this.scroller.currentPage = snap;
				this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
			}
		}

		if ( this.moved ) {
			this.scroller._execEvent('scrollEnd');
		}
	},

	transitionTime: function (time) {
		time = time || 0;
		var durationProp = utils.style.transitionDuration;
		if(!durationProp) {
			return;
		}

		this.indicatorStyle[durationProp] = time + 'ms';

		if ( !time && utils.isBadAndroid ) {
			this.indicatorStyle[durationProp] = '0.0001ms';
			// remove 0.0001ms
			var self = this;
			rAF(function() {
				if(self.indicatorStyle[durationProp] === '0.0001ms') {
					self.indicatorStyle[durationProp] = '0s';
				}
			});
		}
	},

	transitionTimingFunction: function (easing) {
		this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
	},

	refresh: function () {
		this.transitionTime();

		if ( this.options.listenX && !this.options.listenY ) {
			this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
		} else if ( this.options.listenY && !this.options.listenX ) {
			this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
		} else {
			this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
		}

		if ( this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll ) {
			utils.addClass(this.wrapper, 'iScrollBothScrollbars');
			utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');

			if ( this.options.defaultScrollbars && this.options.customStyle ) {
				if ( this.options.listenX ) {
					this.wrapper.style.right = '8px';
				} else {
					this.wrapper.style.bottom = '8px';
				}
			}
		} else {
			utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
			utils.addClass(this.wrapper, 'iScrollLoneScrollbar');

			if ( this.options.defaultScrollbars && this.options.customStyle ) {
				if ( this.options.listenX ) {
					this.wrapper.style.right = '2px';
				} else {
					this.wrapper.style.bottom = '2px';
				}
			}
		}

		utils.getRect(this.wrapper);	// force refresh

		if ( this.options.listenX ) {
			this.wrapperWidth = this.wrapper.clientWidth;
			if ( this.options.resize ) {
				this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
				this.indicatorStyle.width = this.indicatorWidth + 'px';
			} else {
				this.indicatorWidth = this.indicator.clientWidth;
			}

			this.maxPosX = this.wrapperWidth - this.indicatorWidth;

			if ( this.options.shrink == 'clip' ) {
				this.minBoundaryX = -this.indicatorWidth + 8;
				this.maxBoundaryX = this.wrapperWidth - 8;
			} else {
				this.minBoundaryX = 0;
				this.maxBoundaryX = this.maxPosX;
			}

			this.sizeRatioX = this.options.speedRatioX || (this.scroller.maxScrollX && (this.maxPosX / this.scroller.maxScrollX));
		}

		if ( this.options.listenY ) {
			this.wrapperHeight = this.wrapper.clientHeight;
			if ( this.options.resize ) {
				this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
				this.indicatorStyle.height = this.indicatorHeight + 'px';
			} else {
				this.indicatorHeight = this.indicator.clientHeight;
			}

			this.maxPosY = this.wrapperHeight - this.indicatorHeight;

			if ( this.options.shrink == 'clip' ) {
				this.minBoundaryY = -this.indicatorHeight + 8;
				this.maxBoundaryY = this.wrapperHeight - 8;
			} else {
				this.minBoundaryY = 0;
				this.maxBoundaryY = this.maxPosY;
			}

			this.maxPosY = this.wrapperHeight - this.indicatorHeight;
			this.sizeRatioY = this.options.speedRatioY || (this.scroller.maxScrollY && (this.maxPosY / this.scroller.maxScrollY));
		}

		this.updatePosition();
	},

	updatePosition: function () {
		var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
			y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;

		if ( !this.options.ignoreBoundaries ) {
			if ( x < this.minBoundaryX ) {
				if ( this.options.shrink == 'scale' ) {
					this.width = Math.max(this.indicatorWidth + x, 8);
					this.indicatorStyle.width = this.width + 'px';
				}
				x = this.minBoundaryX;
			} else if ( x > this.maxBoundaryX ) {
				if ( this.options.shrink == 'scale' ) {
					this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
					this.indicatorStyle.width = this.width + 'px';
					x = this.maxPosX + this.indicatorWidth - this.width;
				} else {
					x = this.maxBoundaryX;
				}
			} else if ( this.options.shrink == 'scale' && this.width != this.indicatorWidth ) {
				this.width = this.indicatorWidth;
				this.indicatorStyle.width = this.width + 'px';
			}

			if ( y < this.minBoundaryY ) {
				if ( this.options.shrink == 'scale' ) {
					this.height = Math.max(this.indicatorHeight + y * 3, 8);
					this.indicatorStyle.height = this.height + 'px';
				}
				y = this.minBoundaryY;
			} else if ( y > this.maxBoundaryY ) {
				if ( this.options.shrink == 'scale' ) {
					this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
					this.indicatorStyle.height = this.height + 'px';
					y = this.maxPosY + this.indicatorHeight - this.height;
				} else {
					y = this.maxBoundaryY;
				}
			} else if ( this.options.shrink == 'scale' && this.height != this.indicatorHeight ) {
				this.height = this.indicatorHeight;
				this.indicatorStyle.height = this.height + 'px';
			}
		}

		this.x = x;
		this.y = y;

		if ( this.scroller.options.useTransform ) {
			this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
		} else {
			this.indicatorStyle.left = x + 'px';
			this.indicatorStyle.top = y + 'px';
		}
	},

	_pos: function (x, y) {
		if ( x < 0 ) {
			x = 0;
		} else if ( x > this.maxPosX ) {
			x = this.maxPosX;
		}

		if ( y < 0 ) {
			y = 0;
		} else if ( y > this.maxPosY ) {
			y = this.maxPosY;
		}

		x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
		y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;

		this.scroller.scrollTo(x, y);
	},

	fade: function (val, hold) {
		if ( hold && !this.visible ) {
			return;
		}

		clearTimeout(this.fadeTimeout);
		this.fadeTimeout = null;

		var time = val ? 250 : 500,
			delay = val ? 0 : 300;

		val = val ? '1' : '0';

		this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';

		this.fadeTimeout = setTimeout((function (val) {
			this.wrapperStyle.opacity = val;
			this.visible = +val;
		}).bind(this, val), delay);
	}
};

IScroll.utils = utils;

if ( typeof module != 'undefined' && module.exports ) {
	module.exports = IScroll;
} else if ( true ) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return IScroll; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
	window.IScroll = IScroll;
}

})(window, document, Math);


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/navi-close.svg";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/navi-center.svg";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/navi-coupon.svg";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/navi-dishmenu.svg";

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/navi-ordercart.svg";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/navi-ordered.svg";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/navi-pay.svg";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/navi-serverbell.svg";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/prepaid-code.svg";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(645)('socket.io-parser');
var json = __webpack_require__(648);
var Emitter = __webpack_require__(650);
var binary = __webpack_require__(651);
var isBuf = __webpack_require__(563);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    encodeAsBinary(obj, callback);
  }
  else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {
  var str = '';
  var nsp = false;

  // first is type
  str += obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT == obj.type || exports.BINARY_ACK == obj.type) {
    str += obj.attachments;
    str += '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' != obj.nsp) {
    nsp = true;
    str += obj.nsp;
  }

  // immediately followed by the id
  if (null != obj.id) {
    if (nsp) {
      str += ',';
      nsp = false;
    }
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    if (nsp) str += ',';
    str += json.stringify(obj.data);
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an ecoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if ('string' == typeof obj) {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT == packet.type || exports.BINARY_ACK == packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  }
  else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  }
  else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var p = {};
  var i = 0;

  // look up type
  p.type = Number(str.charAt(0));
  if (null == exports.types[p.type]) return error();

  // look up attachments if type binary
  if (exports.BINARY_EVENT == p.type || exports.BINARY_ACK == p.type) {
    var buf = '';
    while (str.charAt(++i) != '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) != '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' == str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' == c) break;
      p.nsp += c;
      if (i == str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i == str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    p = tryParse(p, str.substr(i));
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(p, str) {
  try {
    p.data = json.parse(str);
  } catch(e){
    return error();
  }
  return p; 
};

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length == this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(data){
  return {
    type: exports.ERROR,
    data: 'parser error'
  };
}


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(656);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new global[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(482);
var Emitter = __webpack_require__(490);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),
/* 546 */,
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _const = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _find = __webpack_require__(411);
var _findIndex = __webpack_require__(524);
var getNewCountOfDish = __webpack_require__(43).getNewCountOfDish;


var isGroupDish = exports.isGroupDish = function (dish) {
  return dish.type === 1;
};
var isSingleDishWithoutProps = exports.isSingleDishWithoutProps = function (dish) {
  if (isGroupDish(dish)) {
    return false;
  }

  var propTypeInfo = dish.propertyTypeList || dish.dishPropertyTypeInfos || [];
  var ingredientInfos = dish.dishIngredientInfos || [];
  return !ingredientInfos.length && (!propTypeInfo.length || propTypeInfo.every(function (prop) {
    return prop.type === 4 || prop.type === 2;
  }));
};

exports.initializeDishes = function (dishesList) {
  var dishes = JSON.parse((0, _stringify2.default)(dishesList));

  dishes.map(function (dish) {
    if (isSingleDishWithoutProps(dish)) {
      dish.order = dish.num;
      dish.dishIngredientInfos.forEach(function (ingredient) {
        return ingredient.isChecked = true;
      });
      dish.propertyTypeList.map(function (property) {
        return property.properties.forEach(function (option) {
          return option.isChecked = true;
        });
      });
      dish.dishPropertyTypeInfos = dish.propertyTypeList;
    } else if (isGroupDish(dish)) {
      dish.order = [{ count: dish.num, groups: [] }];
      dish.groups = [];
      var subDishItems = dish.subDishItems || [];
      subDishItems.map(function (item) {
        item.id = item.groupId;
        item.childInfos = [];
        if (item.propertyTypeList.length) {
          item.propertyTypeList.map(function (property) {
            return property.properties.forEach(function (option) {
              return option.isChecked = true;
            });
          });
        }
        if (item.dishIngredientInfos.length) {
          item.dishIngredientInfos.map(function (ingredient) {
            return ingredient.isChecked = true;
          });
        }
        var childInfo = {
          id: item.itemId,
          name: item.name,
          unitName: item.unitName,
          marketPrice: item.marketPrice,
          saleType: item.saleType,
          isChildDish: true,
          dishIngredientInfos: item.dishIngredientInfos,
          dishPropertyTypeInfos: item.propertyTypeList,
          order: isSingleDishWithoutProps(item) ? item.num : [{
            count: item.num, // / dish.num,
            dishIngredientInfos: item.dishIngredientInfos,
            dishPropertyTypeInfos: item.propertyTypeList
          }]
        };
        item.childInfos.push(childInfo);
        return dish.order[0].groups.push(item);
      });
    } else {
      dish.dishIngredientInfos.forEach(function (ingredient) {
        return ingredient.isChecked = true;
      });
      dish.propertyTypeList.map(function (property) {
        return property.properties.forEach(function (option) {
          return option.isChecked = true;
        });
      });
      dish.order = [{
        count: dish.num,
        dishIngredientInfos: dish.dishIngredientInfos,
        dishPropertyTypeInfos: dish.propertyTypeList
      }];
      dish.dishPropertyTypeInfos = dish.propertyTypeList;
    }
    return dish;
  });

  return dishes;
};

exports.convertDetailStructureToOrderedStructure = function (dishes) {
  var initDishPropertyAndIngredient = function initDishPropertyAndIngredient(dish) {
    var propertyTypeList = dish.propertyTypeList,
        dishIngredientInfos = dish.dishIngredientInfos;

    (propertyTypeList || []).forEach(function (property) {
      return (property.properties || []).forEach(function (option) {
        return option.isChecked = true;
      });
    });
    (dishIngredientInfos || []).forEach(function (ingredient) {
      return ingredient.isChecked = true;
    });
    return { dishPropertyTypeInfos: propertyTypeList || [], dishIngredientInfos: dishIngredientInfos || [] };
  };

  dishes.forEach(function (dish) {
    if (isSingleDishWithoutProps(dish)) {
      (0, _assign2.default)(dish, { order: dish.num, dishPropertyTypeInfos: dish.propertyTypeList });
    } else if (isGroupDish(dish)) {
      var order = [{ count: dish.num, groups: [] }];
      var subDishItems = dish.subDishItems || [];

      subDishItems.forEach(function (group) {
        var _group = { id: group.groupId, childInfos: [] };
        (group.subDishVO || []).forEach(function (item) {
          var _initDishPropertyAndI = initDishPropertyAndIngredient(item),
              dishIngredientInfos = _initDishPropertyAndI.dishIngredientInfos,
              dishPropertyTypeInfos = _initDishPropertyAndI.dishPropertyTypeInfos;

          var childInfo = {
            id: item.itemId,
            name: item.name,
            saleType: item.saleType,
            unitName: item.unitName,
            marketPrice: item.marketPrice,
            isChildDish: true,
            dishIngredientInfos: dishIngredientInfos,
            dishPropertyTypeInfos: dishPropertyTypeInfos,
            order: isSingleDishWithoutProps(item) ? item.num : [{
              count: item.num,
              dishPropertyTypeInfos: dishPropertyTypeInfos,
              dishIngredientInfos: dishIngredientInfos
            }]
          };
          _group.childInfos.push(childInfo);
        });
        order[0].groups.push(_group);
      });
      (0, _assign2.default)(dish, { order: order, groups: [] });
    } else {
      var _initDishPropertyAndI2 = initDishPropertyAndIngredient(dish),
          dishIngredientInfos = _initDishPropertyAndI2.dishIngredientInfos,
          dishPropertyTypeInfos = _initDishPropertyAndI2.dishPropertyTypeInfos;

      (0, _assign2.default)(dish, { dishPropertyTypeInfos: dishPropertyTypeInfos, order: [{
          count: dish.num,
          dishIngredientInfos: dishIngredientInfos,
          dishPropertyTypeInfos: dishPropertyTypeInfos
        }] });
    }
  });
  return dishes;
};

/**
 * 按手录菜品备注合并单菜到order, 并动态创建dishPropertyTypeInfos property type=3(备注) array
 * @param {Array} dishes
 */
function combineSingleDishWithoutPropsToOrderByMemo(dishes) {
  var combinedRet = dishes.reduce(function (acc, dish) {
    var id = dish.id,
        marketPrice = dish.marketPrice,
        _dish$dishPropertyTyp = dish.dishPropertyTypeInfos,
        dishPropertyTypeInfos = _dish$dishPropertyTyp === undefined ? [] : _dish$dishPropertyTyp,
        _dish$dishIngredientI = dish.dishIngredientInfos,
        dishIngredientInfos = _dish$dishIngredientI === undefined ? [] : _dish$dishIngredientI,
        itemId = dish.itemId,
        tag = dish.tag;

    var key = id + '-' + marketPrice + '-' + (itemId || tag);
    var propertyLength = dishPropertyTypeInfos.length;


    if (dishIngredientInfos.length === propertyLength && propertyLength === 0) {
      var singleKey = key + '-single';
      acc[singleKey] = (acc[singleKey] || []).concat(dish);
    } else {
      acc[key] = [dish];
    }

    return acc;
  }, {});

  return (0, _keys2.default)(combinedRet).reduce(function (acc, key) {
    var list = combinedRet[key];
    if (list.length === 1 || list.every(function (item) {
      return !item.memo;
    })) {
      return acc.concat(list);
    }

    var _list = (0, _slicedToArray3.default)(list, 1),
        first = _list[0];

    return acc.concat((0, _extends3.default)({}, first, {
      dishIngredientInfos: [{}],
      order: list.map(function (item) {
        var order = item.order,
            memo = item.memo;

        var dishPropertyTypeInfos = [];

        if (memo) {
          dishPropertyTypeInfos.push({
            type: _const.DishPropertyTypes.REMARK,
            name: '备注',
            properties: [{ id: 0, name: memo, isChecked: true }]
          });
        }

        return {
          count: order,
          dishPropertyTypeInfos: dishPropertyTypeInfos,
          dishIngredientInfos: []
        };
      })
    }));
  }, []);
}

exports.reconstructDishes = function (realDishes, isDepart) {
  var copyedDishes = JSON.parse((0, _stringify2.default)(realDishes));
  var dishes = combineSingleDishWithoutPropsToOrderByMemo(copyedDishes);

  var _loop = function _loop(i) {
    var withSameIdDishes = void 0;

    if (isDepart) {
      dishes[i].isDepartRepeted = true;
      withSameIdDishes = dishes.filter(function (dish) {
        return !dish.isDepartRepeted;
      }).filter(function (dish) {
        if (dish.id === dishes[i].id && dish.itemId === dishes[i].itemId) {
          return dish;
        }
        dish.isDelete = false;
        return false;
      });
    } else {
      dishes[i].isRepeted = true;
      withSameIdDishes = dishes.filter(function (dish) {
        return !dish.isRepeted;
      }).filter(function (dish) {
        return dish.id === dishes[i].id && dish.marketPrice === dishes[i].marketPrice;
      });
    }

    if (withSameIdDishes && withSameIdDishes.length) {
      for (var j = 0; j < withSameIdDishes.length; j++) {
        withSameIdDishes.forEach(function (dish) {
          dish.isRepeted = true;dish.isDelete = true;
        });
        if (dishes[i].order instanceof Array && withSameIdDishes[j].order instanceof Array) {
          dishes[i].order.push(withSameIdDishes[j].order[0]);
        } else {
          var order = withSameIdDishes[j].order;
          if (Array.isArray(dishes[i].order) && dishes[i].order.length) {
            // dish[i].order  是数组  那么withSameIdDishes[j].order 就肯定不是数组了
            var count = withSameIdDishes[j].order;
            withSameIdDishes[j].order = [{
              count: count,
              dishIngredientInfos: [],
              dishPropertyTypeInfos: []
            }];
            dishes[i].order.push(withSameIdDishes[j].order[0]);
          } else if (Array.isArray(order) && order.length) {
            // 应该被删除的菜品是复杂菜品  将同id菜品也变为复杂菜品
            var _count = dishes[i].order;
            dishes[i].dishIngredientInfos = withSameIdDishes[j].dishIngredientInfos;
            dishes[i].dishPropertyTypeInfos = withSameIdDishes[j].dishPropertyTypeInfos;
            dishes[i].order = [{
              count: _count,
              dishIngredientInfos: [],
              dishPropertyTypeInfos: []
            }];
            dishes[i].order.push(withSameIdDishes[j].order[0]);
          } else {
            // 两者皆不是复杂菜品
            dishes[i].order += order;
          }
        }
      }
    }
  };

  for (var i in dishes) {
    _loop(i);
  }

  return dishes.filter(function (dish) {
    return !dish.isDelete;
  });
};

exports.recombineDishData = function (dishes) {
  var dishTypeList = JSON.parse(sessionStorage.getItem('dishTypeList'));
  var finalDishesList = [];
  dishes.map(function (dish) {
    var dishesList = dish.dishesList;
    dishesList.map(function (dishData) {
      var result = _find(dishTypeList, function (dishType) {
        return dishType.id === dishData.dishTypeId;
      });
      var newDishObject = {
        dishTypeInfo: result,
        dishes: [dishData],
        userInfo: dish.userInfo
      };
      var isRepeat = _find(finalDishesList, function (dishProp) {
        return dishProp.dishTypeInfo && dishProp.dishTypeInfo.id === result.id;
      });
      if (isRepeat) {
        // 表示有重复的中类
        isRepeat.dishes.push(dishData);
      } else {
        finalDishesList.push(newDishObject);
      }
      return true;
    });
    return true;
  });
  return finalDishesList;
};

exports.updateSyncShoppingCart = function (state, payload) {
  var userInfo = payload.userInfo,
      increment = payload.increment,
      orderDishes = payload.orderDishes;

  var _orderDishes = (0, _slicedToArray3.default)(orderDishes, 1),
      orderDish = _orderDishes[0];

  var userOrderedDishList = state.userOrderedDishList;

  var userOrderIndex = _findIndex(userOrderedDishList, function (item) {
    return item.userInfo.userId === userInfo.userId;
  });

  // 新用户加入
  if (userOrderIndex === -1 && increment !== -1) {
    return state.update('userOrderedDishList', function (items) {
      var orderDishList = [orderDish];
      return (items || []).concat([{ userInfo: userInfo, dishList: orderDishList }]);
    });
  }

  var dishList = userOrderedDishList[userOrderIndex].dishList || [];
  var dishIndex = _findIndex(dishList, function (item) {
    return item.id === orderDish.id;
  });
  var oldDish = dishList[dishIndex];
  var dishListChain = ['userOrderedDishList', userOrderIndex, 'dishList'];

  // 单菜
  if (isSingleDishWithoutProps(orderDish)) {
    if (dishIndex === -1) {
      return increment <= 0 ? state : state.updateIn(dishListChain, function (list) {
        (0, _assign2.default)(orderDish, { order: getNewCountOfDish(orderDish, 0) });
        return list.concat([orderDish]);
      });
    }

    var _newState = state.updateIn(dishListChain.concat([dishIndex]), function (dish) {
      return dish.update('order', function (order) {
        return (order || 0) + increment;
      });
    });
    return _newState.updateIn(dishListChain, function (list) {
      return list.flatMap(function (item) {
        var order = item.order || 0;
        return order < (item.dishIncreaseUnit || 1) ? [] : item;
      });
    });
  }

  if (!oldDish) {
    return increment <= 0 ? state : state.updateIn(dishListChain, function (list) {
      (0, _assign2.default)(orderDish.order, { count: increment });
      return list.concat([orderDish]);
    });
  }

  var orderIndex = -1;
  if (isGroupDish(orderDish)) {
    orderIndex = _findIndex(oldDish.order || [], { groups: orderDish.order[0].groups });
  } else {
    orderIndex = _findIndex(oldDish.order || [], {
      dishIngredientInfos: orderDish.order[0].dishIngredientInfos,
      dishPropertyTypeInfos: orderDish.order[0].dishPropertyTypeInfos
    });
  }

  if (orderIndex === -1 && increment > 0) {
    return state.updateIn(dishListChain.concat([dishIndex, 'order']), function (order) {
      if (order) {
        return order.concat(orderDish.order);
      }
      return orderDish.order;
    });
  }

  var newCount = 0;
  var newState = state.updateIn(dishListChain.concat([dishIndex, 'order', orderIndex, 'count']), function (count) {
    newCount = count + orderDish.order[0].count;
    if (newCount < (orderDish.dishIncreaseUnit || 1)) {
      newCount = 0;
    }
    return newCount;
  });

  if (newCount === 0) {
    newState = newState.updateIn(dishListChain.concat([dishIndex, 'order']), function (list) {
      return list.flatMap(function (item, index) {
        if (index === orderIndex) {
          return [];
        }
        return item;
      });
    });

    newState = newState.updateIn(dishListChain, function (list) {
      return list.flatMap(function (item, index) {
        if (item.order && item.order.length === 0) {
          return [];
        }
        return item;
      });
    });
  }
  return newState;
};

/***/ }),
/* 548 */,
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _coupon = __webpack_require__(473);

var _coupon2 = _interopRequireDefault(_coupon);

var _order = __webpack_require__(249);

var _order2 = _interopRequireDefault(_order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonHelper = __webpack_require__(3);
var config = __webpack_require__(13);

var _require = __webpack_require__(14),
    CouponTypes = _require.CouponTypes,
    DeliveryWay = _require.DeliveryWay;

var Immutable = __webpack_require__(77);

exports.filterCouponListByStatus = function (couponList, status) {
  return couponList.filter(function (item) {
    return item.coupInstanceBean.couponStatus === status;
  });
};

exports.formatDate = function (date) {
  var replaceStr = '-';
  if (date) {
    return date.toString().replace(new RegExp(replaceStr, 'gm'), '/').substring(0, 10);
  }
  return false;
};

exports.formatOriginDate = function (date) {
  function appendZero(obj) {
    if (obj < 10) return '0' + obj;
    return obj;
  }

  if (date) {
    var time = new Date(date);
    var getFullYear = time.getFullYear();
    var getMonth = time.getMonth() + 1;
    var getDate = time.getDate();
    return getFullYear + '/' + appendZero(getMonth) + '/' + appendZero(getDate);
  }
  return false;
};

var formatInstruction = exports.formatInstruction = function (information) {
  if (information) {
    return information.replace(/<\/(h[1-6]|p|li)>/g, '</$1>\n').replace(/<\/?.+?>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, '').trim().split('\n');
  }
  return '';
};

var formatWeixinTime = exports.formatWeixinTime = function (advancedInfo) {
  function appendZero(obj) {
    if (obj < 10) return '0' + obj;
    return obj;
  }
  if (advancedInfo.timeLimit && advancedInfo.timeLimit.length !== 0) {
    return advancedInfo.timeLimit.map(function (item, index) {
      var day = '';
      switch (item.type) {
        case 'SUNDAY':
          day = (0, _helper.formatMessage)(_global2.default.sunday);
          break;
        case 'MONDAY':
          day = (0, _helper.formatMessage)(_global2.default.monday);
          break;
        case 'TUESDAY':
          day = (0, _helper.formatMessage)(_global2.default.tuesday);
          break;
        case 'WEDNESDAY':
          day = (0, _helper.formatMessage)(_global2.default.wednesday);
          break;
        case 'THURSDAY':
          day = (0, _helper.formatMessage)(_global2.default.thursday);
          break;
        case 'FRIDAY':
          day = (0, _helper.formatMessage)(_global2.default.friday);
          break;
        case 'SATURDAY':
          day = (0, _helper.formatMessage)(_global2.default.saturday);
          break;
        default:
          day = item.type;
          break;
      }

      return day + ' ' + appendZero(item.beginHour) + ':' + appendZero(item.beginMinute) + ' ~ ' + appendZero(item.endHour) + ':' + appendZero(item.endMinute) + ' \n';
    });
  }
  return false;
};

var getCouponRuleVale = exports.getCouponRuleVale = function (couponType, itemInner) {
  if (itemInner.ruleName === 'offerValue' || itemInner.ruleName === 'zkValue' || itemInner.ruleName === 'giftName' || itemInner.ruleName === 'faceValue') {
    return itemInner.ruleValue || '--';
  }
  return false;
};

// weixin优惠券参数设置
exports.weixinCouponParam = function (item) {
  var ruleVale = '';
  var typeClass = '';
  var typeUnit = '';
  var statusWord = '';
  var couponName = item.couponName;
  var couponTypeName = '';
  var fullValue = '';
  var instructions = '';
  var codeNumber = item.code;
  var periodStart = item.beginDate ? item.beginDate.substring(0, 5) || '00:00' : '00:00';
  var periodEnd = item.endDate ? item.endDate.substring(0, 5) || '00:00' : '00:00';
  var giftFontStyle = {};
  var extraPeriodStart = item.extraPeriodStart,
      extraPeriodEnd = item.extraPeriodEnd;


  switch (item.card.cardType) {
    case 'DISCOUNT':
      typeClass = 'zhekou';
      typeUnit = (0, _helper.formatMessage)(_global2.default.discount);
      couponTypeName = (0, _helper.formatMessage)(_coupon2.default.zhekouCoupon);
      instructions = [formatInstruction(item.card.discount.baseInfo.description), formatWeixinTime(item.card.discount.advancedInfo)];
      fullValue = item.card.discount.leastCost || 0;
      ruleVale = ((100 - item.card.discount.discount) / 10).toFixed(1);
      break;
    case 'CASH':
      typeClass = 'xianjin';
      typeUnit = sessionStorage.getItem('currency');
      couponTypeName = (0, _helper.formatMessage)(_coupon2.default.daijinCoupon);
      instructions = [formatInstruction(item.card.cash.baseInfo.description), formatWeixinTime(item.card.cash.advancedInfo)];
      fullValue = item.card.cash.leastCost || 0;
      ruleVale = item.card.cash.reduceCost.toString() || '';
      break;
    default:
      break;
  }

  statusWord = (0, _helper.formatMessage)(_global2.default.validityPeriod);

  return {
    typeClass: typeClass,
    giftFontStyle: giftFontStyle,
    typeUnit: typeUnit,
    ruleVale: ruleVale,
    fullValue: fullValue,
    statusWord: statusWord,
    codeNumber: codeNumber,
    instructions: instructions,
    couponName: couponName,
    couponTypeName: couponTypeName,
    periodStart: periodStart,
    periodEnd: periodEnd,
    extraPeriodStart: extraPeriodStart,
    extraPeriodEnd: extraPeriodEnd
  };
};

// loyalty优惠券参数设置

exports.loyaltyCouponParam = function (item) {
  var ruleVale = '';
  var typeClass = '';
  var typeUnit = '';
  var giftUnitBefore = '';
  var giftFontSize = '';
  var giftVerticalAlign = '';
  var giftLineHeight = '';
  var statusWord = '';
  var deliveryWay = '';
  var couponName = item.couponName;
  var couponTypeName = '';
  var giftFontStyle = {};
  var fullValue = item.fullValue;
  var delivery = item.delivery;
  var codeNumber = item.codeNumber;
  var renderWeek = commonHelper.renderDay(item.week);
  var periodStart = item.periodStart ? item.periodStart.substring(0, 5) || '00:00' : '00:00';
  var periodEnd = item.periodEnd ? item.periodEnd.substring(0, 5) || '00:00' : '00:00';
  var couponType = item.couponType;
  var extraPeriodStart = item.extraPeriodStart,
      extraPeriodEnd = item.extraPeriodEnd;

  var instructions = [].concat(formatInstruction(item.instructions));

  if (renderWeek) {
    instructions.push((0, _helper.formatMessage)(_global2.default.conditionEnable, { condition: renderWeek.substring(0, renderWeek.length - 1) }));
  } else {}
  /* instructions.push('整周可用');*/


  // 配送方式
  switch (delivery) {
    case DeliveryWay.ALL:
      deliveryWay = '' + (0, _helper.formatMessage)(_coupon2.default.distributionMode) + (0, _helper.formatMessage)(_coupon2.default.send) + ',' + (0, _helper.formatMessage)(_coupon2.default.self);
      break;
    case DeliveryWay.SEND:
      deliveryWay = '' + (0, _helper.formatMessage)(_coupon2.default.distributionMode) + (0, _helper.formatMessage)(_coupon2.default.send);
      break;
    case DeliveryWay.SELF:
      deliveryWay = '' + (0, _helper.formatMessage)(_coupon2.default.distributionMode) + (0, _helper.formatMessage)(_coupon2.default.self);
      break;
    default:
      break;
  }

  // 本券部分门店可用
  var desc = '' + (0, _helper.formatMessage)(_coupon2.default.thisCoupon) + (0, _helper.formatMessage)(_coupon2.default.couponAvailableInSomeStores);

  if (item.allCommercial) {
    // true=全部门店可用 false=部分门店可用
    // 本券全部门店可用
    desc = '' + (0, _helper.formatMessage)(_coupon2.default.thisCoupon) + (0, _helper.formatMessage)(_coupon2.default.couponAvailableInAllStores);
  }

  instructions.push({
    desc: desc,
    usableShop: item.usableCommercialDesc,
    showUsableBtn: !item.allCommercial
  });

  item.coupRuleBeanList.forEach(function (itemInner, indexInner) {
    var vale = getCouponRuleVale(item.couponType, itemInner);
    if (vale) {
      ruleVale = vale;
    }
  });
  switch (item.couponType) {
    case CouponTypes.OFFERVALUE:
      typeClass = 'manjian';
      typeUnit = sessionStorage.getItem('currency');
      couponTypeName = (0, _helper.formatMessage)(_coupon2.default.manjianCoupon);
      break;
    case CouponTypes.ZKVALUE:
      typeClass = 'zhekou';
      typeUnit = (0, _helper.formatMessage)(_global2.default.discount);
      couponTypeName = (0, _helper.formatMessage)(_coupon2.default.zhekouCoupon);
      break;
    case CouponTypes.GIFTVALUE:
      typeClass = 'lipin';
      giftUnitBefore = (0, _helper.formatMessage)(_order2.default.orderGift);
      couponTypeName = item.coupDishBeanList.length ? (0, _helper.formatMessage)(_coupon2.default.cplipinCoupon) : (0, _helper.formatMessage)(_coupon2.default.ptlipinCoupon);
      giftFontSize = '1.2em';
      giftVerticalAlign = '0px';
      giftLineHeight = '1.2em';
      giftFontStyle = { fontSize: giftFontSize, verticalAlign: giftVerticalAlign, lineHeight: giftLineHeight };
      break;
    case CouponTypes.FACEVALUE:
      typeClass = 'xianjin';
      typeUnit = sessionStorage.getItem('currency');
      couponTypeName = (0, _helper.formatMessage)(_coupon2.default.daijinCoupon);
      break;
    default:
      break;
  }

  if (item.couponStatus !== 1) {
    if (item.couponStatus === 3) {
      typeClass = 'shixiao yiguoqi';
    } else {
      typeClass = 'shixiao yishiyong';
    }
  }

  statusWord = (0, _helper.formatMessage)(_global2.default.validityPeriod);

  return {
    typeClass: typeClass,
    giftFontStyle: giftFontStyle,
    giftUnitBefore: giftUnitBefore,
    typeUnit: typeUnit,
    ruleVale: ruleVale,
    fullValue: fullValue,
    periodStart: periodStart,
    periodEnd: periodEnd,
    extraPeriodStart: extraPeriodStart,
    extraPeriodEnd: extraPeriodEnd,
    statusWord: statusWord,
    codeNumber: codeNumber,
    instructions: instructions,
    couponName: couponName,
    couponTypeName: couponTypeName,
    couponType: couponType,
    deliveryWay: deliveryWay
  };
};

exports.getShareCouponPageUrl = function (args) {
  var url = config.apiBase + '/coupon/getShareCouponPage?' + commonHelper.formatObjToParamStr(args);
  return url;
};

exports.getShareCouponImageUrl = function (args) {
  var url = config.apiBase + '/images/common/share_icon.png';
  return url;
};

exports.getUseCouponsId = function (coupons) {
  var couponItem = Immutable.from(coupons).asMutable({ deep: true }) || [];
  var useCoupons = [];

  couponItem.forEach(function (prop) {
    useCoupons.push(prop.id);
  });

  return useCoupons;
};

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.JSEncrypt = {})));
}(this, (function (exports) { 'use strict';

var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
function int2char(n) {
    return BI_RM.charAt(n);
}
//#region BIT_OPERATIONS
// (public) this & a
function op_and(x, y) {
    return x & y;
}
// (public) this | a
function op_or(x, y) {
    return x | y;
}
// (public) this ^ a
function op_xor(x, y) {
    return x ^ y;
}
// (public) this & ~a
function op_andnot(x, y) {
    return x & ~y;
}
// return index of lowest 1-bit in x, x < 2^31
function lbit(x) {
    if (x == 0) {
        return -1;
    }
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) {
        ++r;
    }
    return r;
}
// return number of 1 bits in x
function cbit(x) {
    var r = 0;
    while (x != 0) {
        x &= x - 1;
        ++r;
    }
    return r;
}
//#endregion BIT_OPERATIONS

var b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var b64pad = "=";
function hex2b64(h) {
    var i;
    var c;
    var ret = "";
    for (i = 0; i + 3 <= h.length; i += 3) {
        c = parseInt(h.substring(i, i + 3), 16);
        ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
    }
    if (i + 1 == h.length) {
        c = parseInt(h.substring(i, i + 1), 16);
        ret += b64map.charAt(c << 2);
    }
    else if (i + 2 == h.length) {
        c = parseInt(h.substring(i, i + 2), 16);
        ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
    }
    while ((ret.length & 3) > 0) {
        ret += b64pad;
    }
    return ret;
}
// convert a base64 string to hex
function b64tohex(s) {
    var ret = "";
    var i;
    var k = 0; // b64 state, 0-3
    var slop = 0;
    for (i = 0; i < s.length; ++i) {
        if (s.charAt(i) == b64pad) {
            break;
        }
        var v = b64map.indexOf(s.charAt(i));
        if (v < 0) {
            continue;
        }
        if (k == 0) {
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 1;
        }
        else if (k == 1) {
            ret += int2char((slop << 2) | (v >> 4));
            slop = v & 0xf;
            k = 2;
        }
        else if (k == 2) {
            ret += int2char(slop);
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 3;
        }
        else {
            ret += int2char((slop << 2) | (v >> 4));
            ret += int2char(v & 0xf);
            k = 0;
        }
    }
    if (k == 1) {
        ret += int2char(slop << 2);
    }
    return ret;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

// Hex JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var decoder;
var Hex = {
    decode: function (a) {
        var i;
        if (decoder === undefined) {
            var hex = "0123456789ABCDEF";
            var ignore = " \f\n\r\t\u00A0\u2028\u2029";
            decoder = {};
            for (i = 0; i < 16; ++i) {
                decoder[hex.charAt(i)] = i;
            }
            hex = hex.toLowerCase();
            for (i = 10; i < 16; ++i) {
                decoder[hex.charAt(i)] = i;
            }
            for (i = 0; i < ignore.length; ++i) {
                decoder[ignore.charAt(i)] = -1;
            }
        }
        var out = [];
        var bits = 0;
        var char_count = 0;
        for (i = 0; i < a.length; ++i) {
            var c = a.charAt(i);
            if (c == "=") {
                break;
            }
            c = decoder[c];
            if (c == -1) {
                continue;
            }
            if (c === undefined) {
                throw new Error("Illegal character at offset " + i);
            }
            bits |= c;
            if (++char_count >= 2) {
                out[out.length] = bits;
                bits = 0;
                char_count = 0;
            }
            else {
                bits <<= 4;
            }
        }
        if (char_count) {
            throw new Error("Hex encoding incomplete: 4 bits missing");
        }
        return out;
    }
};

// Base64 JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var decoder$1;
var Base64 = {
    decode: function (a) {
        var i;
        if (decoder$1 === undefined) {
            var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var ignore = "= \f\n\r\t\u00A0\u2028\u2029";
            decoder$1 = Object.create(null);
            for (i = 0; i < 64; ++i) {
                decoder$1[b64.charAt(i)] = i;
            }
            for (i = 0; i < ignore.length; ++i) {
                decoder$1[ignore.charAt(i)] = -1;
            }
        }
        var out = [];
        var bits = 0;
        var char_count = 0;
        for (i = 0; i < a.length; ++i) {
            var c = a.charAt(i);
            if (c == "=") {
                break;
            }
            c = decoder$1[c];
            if (c == -1) {
                continue;
            }
            if (c === undefined) {
                throw new Error("Illegal character at offset " + i);
            }
            bits |= c;
            if (++char_count >= 4) {
                out[out.length] = (bits >> 16);
                out[out.length] = (bits >> 8) & 0xFF;
                out[out.length] = bits & 0xFF;
                bits = 0;
                char_count = 0;
            }
            else {
                bits <<= 6;
            }
        }
        switch (char_count) {
            case 1:
                throw new Error("Base64 encoding incomplete: at least 2 bits missing");
            case 2:
                out[out.length] = (bits >> 10);
                break;
            case 3:
                out[out.length] = (bits >> 16);
                out[out.length] = (bits >> 8) & 0xFF;
                break;
        }
        return out;
    },
    re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
    unarmor: function (a) {
        var m = Base64.re.exec(a);
        if (m) {
            if (m[1]) {
                a = m[1];
            }
            else if (m[2]) {
                a = m[2];
            }
            else {
                throw new Error("RegExp out of sync");
            }
        }
        return Base64.decode(a);
    }
};

// Big integer base-10 printing library
// Copyright (c) 2014 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */
var max = 10000000000000; // biggest integer that can still fit 2^53 when multiplied by 256
var Int10 = /** @class */ (function () {
    function Int10(value) {
        this.buf = [+value || 0];
    }
    Int10.prototype.mulAdd = function (m, c) {
        // assert(m <= 256)
        var b = this.buf;
        var l = b.length;
        var i;
        var t;
        for (i = 0; i < l; ++i) {
            t = b[i] * m + c;
            if (t < max) {
                c = 0;
            }
            else {
                c = 0 | (t / max);
                t -= c * max;
            }
            b[i] = t;
        }
        if (c > 0) {
            b[i] = c;
        }
    };
    Int10.prototype.sub = function (c) {
        // assert(m <= 256)
        var b = this.buf;
        var l = b.length;
        var i;
        var t;
        for (i = 0; i < l; ++i) {
            t = b[i] - c;
            if (t < 0) {
                t += max;
                c = 1;
            }
            else {
                c = 0;
            }
            b[i] = t;
        }
        while (b[b.length - 1] === 0) {
            b.pop();
        }
    };
    Int10.prototype.toString = function (base) {
        if ((base || 10) != 10) {
            throw new Error("only base 10 is supported");
        }
        var b = this.buf;
        var s = b[b.length - 1].toString();
        for (var i = b.length - 2; i >= 0; --i) {
            s += (max + b[i]).toString().substring(1);
        }
        return s;
    };
    Int10.prototype.valueOf = function () {
        var b = this.buf;
        var v = 0;
        for (var i = b.length - 1; i >= 0; --i) {
            v = v * max + b[i];
        }
        return v;
    };
    Int10.prototype.simplify = function () {
        var b = this.buf;
        return (b.length == 1) ? b[0] : this;
    };
    return Int10;
}());

// ASN.1 JavaScript decoder
var ellipsis = "\u2026";
var reTimeS = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
var reTimeL = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
function stringCut(str, len) {
    if (str.length > len) {
        str = str.substring(0, len) + ellipsis;
    }
    return str;
}
var Stream = /** @class */ (function () {
    function Stream(enc, pos) {
        this.hexDigits = "0123456789ABCDEF";
        if (enc instanceof Stream) {
            this.enc = enc.enc;
            this.pos = enc.pos;
        }
        else {
            // enc should be an array or a binary string
            this.enc = enc;
            this.pos = pos;
        }
    }
    Stream.prototype.get = function (pos) {
        if (pos === undefined) {
            pos = this.pos++;
        }
        if (pos >= this.enc.length) {
            throw new Error("Requesting byte offset " + pos + " on a stream of length " + this.enc.length);
        }
        return ("string" === typeof this.enc) ? this.enc.charCodeAt(pos) : this.enc[pos];
    };
    Stream.prototype.hexByte = function (b) {
        return this.hexDigits.charAt((b >> 4) & 0xF) + this.hexDigits.charAt(b & 0xF);
    };
    Stream.prototype.hexDump = function (start, end, raw) {
        var s = "";
        for (var i = start; i < end; ++i) {
            s += this.hexByte(this.get(i));
            if (raw !== true) {
                switch (i & 0xF) {
                    case 0x7:
                        s += "  ";
                        break;
                    case 0xF:
                        s += "\n";
                        break;
                    default:
                        s += " ";
                }
            }
        }
        return s;
    };
    Stream.prototype.isASCII = function (start, end) {
        for (var i = start; i < end; ++i) {
            var c = this.get(i);
            if (c < 32 || c > 176) {
                return false;
            }
        }
        return true;
    };
    Stream.prototype.parseStringISO = function (start, end) {
        var s = "";
        for (var i = start; i < end; ++i) {
            s += String.fromCharCode(this.get(i));
        }
        return s;
    };
    Stream.prototype.parseStringUTF = function (start, end) {
        var s = "";
        for (var i = start; i < end;) {
            var c = this.get(i++);
            if (c < 128) {
                s += String.fromCharCode(c);
            }
            else if ((c > 191) && (c < 224)) {
                s += String.fromCharCode(((c & 0x1F) << 6) | (this.get(i++) & 0x3F));
            }
            else {
                s += String.fromCharCode(((c & 0x0F) << 12) | ((this.get(i++) & 0x3F) << 6) | (this.get(i++) & 0x3F));
            }
        }
        return s;
    };
    Stream.prototype.parseStringBMP = function (start, end) {
        var str = "";
        var hi;
        var lo;
        for (var i = start; i < end;) {
            hi = this.get(i++);
            lo = this.get(i++);
            str += String.fromCharCode((hi << 8) | lo);
        }
        return str;
    };
    Stream.prototype.parseTime = function (start, end, shortYear) {
        var s = this.parseStringISO(start, end);
        var m = (shortYear ? reTimeS : reTimeL).exec(s);
        if (!m) {
            return "Unrecognized time: " + s;
        }
        if (shortYear) {
            // to avoid querying the timer, use the fixed range [1970, 2069]
            // it will conform with ITU X.400 [-10, +40] sliding window until 2030
            m[1] = +m[1];
            m[1] += (+m[1] < 70) ? 2000 : 1900;
        }
        s = m[1] + "-" + m[2] + "-" + m[3] + " " + m[4];
        if (m[5]) {
            s += ":" + m[5];
            if (m[6]) {
                s += ":" + m[6];
                if (m[7]) {
                    s += "." + m[7];
                }
            }
        }
        if (m[8]) {
            s += " UTC";
            if (m[8] != "Z") {
                s += m[8];
                if (m[9]) {
                    s += ":" + m[9];
                }
            }
        }
        return s;
    };
    Stream.prototype.parseInteger = function (start, end) {
        var v = this.get(start);
        var neg = (v > 127);
        var pad = neg ? 255 : 0;
        var len;
        var s = "";
        // skip unuseful bits (not allowed in DER)
        while (v == pad && ++start < end) {
            v = this.get(start);
        }
        len = end - start;
        if (len === 0) {
            return neg ? -1 : 0;
        }
        // show bit length of huge integers
        if (len > 4) {
            s = v;
            len <<= 3;
            while (((+s ^ pad) & 0x80) == 0) {
                s = +s << 1;
                --len;
            }
            s = "(" + len + " bit)\n";
        }
        // decode the integer
        if (neg) {
            v = v - 256;
        }
        var n = new Int10(v);
        for (var i = start + 1; i < end; ++i) {
            n.mulAdd(256, this.get(i));
        }
        return s + n.toString();
    };
    Stream.prototype.parseBitString = function (start, end, maxLength) {
        var unusedBit = this.get(start);
        var lenBit = ((end - start - 1) << 3) - unusedBit;
        var intro = "(" + lenBit + " bit)\n";
        var s = "";
        for (var i = start + 1; i < end; ++i) {
            var b = this.get(i);
            var skip = (i == end - 1) ? unusedBit : 0;
            for (var j = 7; j >= skip; --j) {
                s += (b >> j) & 1 ? "1" : "0";
            }
            if (s.length > maxLength) {
                return intro + stringCut(s, maxLength);
            }
        }
        return intro + s;
    };
    Stream.prototype.parseOctetString = function (start, end, maxLength) {
        if (this.isASCII(start, end)) {
            return stringCut(this.parseStringISO(start, end), maxLength);
        }
        var len = end - start;
        var s = "(" + len + " byte)\n";
        maxLength /= 2; // we work in bytes
        if (len > maxLength) {
            end = start + maxLength;
        }
        for (var i = start; i < end; ++i) {
            s += this.hexByte(this.get(i));
        }
        if (len > maxLength) {
            s += ellipsis;
        }
        return s;
    };
    Stream.prototype.parseOID = function (start, end, maxLength) {
        var s = "";
        var n = new Int10();
        var bits = 0;
        for (var i = start; i < end; ++i) {
            var v = this.get(i);
            n.mulAdd(128, v & 0x7F);
            bits += 7;
            if (!(v & 0x80)) { // finished
                if (s === "") {
                    n = n.simplify();
                    if (n instanceof Int10) {
                        n.sub(80);
                        s = "2." + n.toString();
                    }
                    else {
                        var m = n < 80 ? n < 40 ? 0 : 1 : 2;
                        s = m + "." + (n - m * 40);
                    }
                }
                else {
                    s += "." + n.toString();
                }
                if (s.length > maxLength) {
                    return stringCut(s, maxLength);
                }
                n = new Int10();
                bits = 0;
            }
        }
        if (bits > 0) {
            s += ".incomplete";
        }
        return s;
    };
    return Stream;
}());
var ASN1 = /** @class */ (function () {
    function ASN1(stream, header, length, tag, sub) {
        if (!(tag instanceof ASN1Tag)) {
            throw new Error("Invalid tag value.");
        }
        this.stream = stream;
        this.header = header;
        this.length = length;
        this.tag = tag;
        this.sub = sub;
    }
    ASN1.prototype.typeName = function () {
        switch (this.tag.tagClass) {
            case 0: // universal
                switch (this.tag.tagNumber) {
                    case 0x00:
                        return "EOC";
                    case 0x01:
                        return "BOOLEAN";
                    case 0x02:
                        return "INTEGER";
                    case 0x03:
                        return "BIT_STRING";
                    case 0x04:
                        return "OCTET_STRING";
                    case 0x05:
                        return "NULL";
                    case 0x06:
                        return "OBJECT_IDENTIFIER";
                    case 0x07:
                        return "ObjectDescriptor";
                    case 0x08:
                        return "EXTERNAL";
                    case 0x09:
                        return "REAL";
                    case 0x0A:
                        return "ENUMERATED";
                    case 0x0B:
                        return "EMBEDDED_PDV";
                    case 0x0C:
                        return "UTF8String";
                    case 0x10:
                        return "SEQUENCE";
                    case 0x11:
                        return "SET";
                    case 0x12:
                        return "NumericString";
                    case 0x13:
                        return "PrintableString"; // ASCII subset
                    case 0x14:
                        return "TeletexString"; // aka T61String
                    case 0x15:
                        return "VideotexString";
                    case 0x16:
                        return "IA5String"; // ASCII
                    case 0x17:
                        return "UTCTime";
                    case 0x18:
                        return "GeneralizedTime";
                    case 0x19:
                        return "GraphicString";
                    case 0x1A:
                        return "VisibleString"; // ASCII subset
                    case 0x1B:
                        return "GeneralString";
                    case 0x1C:
                        return "UniversalString";
                    case 0x1E:
                        return "BMPString";
                }
                return "Universal_" + this.tag.tagNumber.toString();
            case 1:
                return "Application_" + this.tag.tagNumber.toString();
            case 2:
                return "[" + this.tag.tagNumber.toString() + "]"; // Context
            case 3:
                return "Private_" + this.tag.tagNumber.toString();
        }
    };
    ASN1.prototype.content = function (maxLength) {
        if (this.tag === undefined) {
            return null;
        }
        if (maxLength === undefined) {
            maxLength = Infinity;
        }
        var content = this.posContent();
        var len = Math.abs(this.length);
        if (!this.tag.isUniversal()) {
            if (this.sub !== null) {
                return "(" + this.sub.length + " elem)";
            }
            return this.stream.parseOctetString(content, content + len, maxLength);
        }
        switch (this.tag.tagNumber) {
            case 0x01: // BOOLEAN
                return (this.stream.get(content) === 0) ? "false" : "true";
            case 0x02: // INTEGER
                return this.stream.parseInteger(content, content + len);
            case 0x03: // BIT_STRING
                return this.sub ? "(" + this.sub.length + " elem)" :
                    this.stream.parseBitString(content, content + len, maxLength);
            case 0x04: // OCTET_STRING
                return this.sub ? "(" + this.sub.length + " elem)" :
                    this.stream.parseOctetString(content, content + len, maxLength);
            // case 0x05: // NULL
            case 0x06: // OBJECT_IDENTIFIER
                return this.stream.parseOID(content, content + len, maxLength);
            // case 0x07: // ObjectDescriptor
            // case 0x08: // EXTERNAL
            // case 0x09: // REAL
            // case 0x0A: // ENUMERATED
            // case 0x0B: // EMBEDDED_PDV
            case 0x10: // SEQUENCE
            case 0x11: // SET
                if (this.sub !== null) {
                    return "(" + this.sub.length + " elem)";
                }
                else {
                    return "(no elem)";
                }
            case 0x0C: // UTF8String
                return stringCut(this.stream.parseStringUTF(content, content + len), maxLength);
            case 0x12: // NumericString
            case 0x13: // PrintableString
            case 0x14: // TeletexString
            case 0x15: // VideotexString
            case 0x16: // IA5String
            // case 0x19: // GraphicString
            case 0x1A: // VisibleString
                // case 0x1B: // GeneralString
                // case 0x1C: // UniversalString
                return stringCut(this.stream.parseStringISO(content, content + len), maxLength);
            case 0x1E: // BMPString
                return stringCut(this.stream.parseStringBMP(content, content + len), maxLength);
            case 0x17: // UTCTime
            case 0x18: // GeneralizedTime
                return this.stream.parseTime(content, content + len, (this.tag.tagNumber == 0x17));
        }
        return null;
    };
    ASN1.prototype.toString = function () {
        return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + ((this.sub === null) ? "null" : this.sub.length) + "]";
    };
    ASN1.prototype.toPrettyString = function (indent) {
        if (indent === undefined) {
            indent = "";
        }
        var s = indent + this.typeName() + " @" + this.stream.pos;
        if (this.length >= 0) {
            s += "+";
        }
        s += this.length;
        if (this.tag.tagConstructed) {
            s += " (constructed)";
        }
        else if ((this.tag.isUniversal() && ((this.tag.tagNumber == 0x03) || (this.tag.tagNumber == 0x04))) && (this.sub !== null)) {
            s += " (encapsulates)";
        }
        s += "\n";
        if (this.sub !== null) {
            indent += "  ";
            for (var i = 0, max = this.sub.length; i < max; ++i) {
                s += this.sub[i].toPrettyString(indent);
            }
        }
        return s;
    };
    ASN1.prototype.posStart = function () {
        return this.stream.pos;
    };
    ASN1.prototype.posContent = function () {
        return this.stream.pos + this.header;
    };
    ASN1.prototype.posEnd = function () {
        return this.stream.pos + this.header + Math.abs(this.length);
    };
    ASN1.prototype.toHexString = function () {
        return this.stream.hexDump(this.posStart(), this.posEnd(), true);
    };
    ASN1.decodeLength = function (stream) {
        var buf = stream.get();
        var len = buf & 0x7F;
        if (len == buf) {
            return len;
        }
        // no reason to use Int10, as it would be a huge buffer anyways
        if (len > 6) {
            throw new Error("Length over 48 bits not supported at position " + (stream.pos - 1));
        }
        if (len === 0) {
            return null;
        } // undefined
        buf = 0;
        for (var i = 0; i < len; ++i) {
            buf = (buf * 256) + stream.get();
        }
        return buf;
    };
    /**
     * Retrieve the hexadecimal value (as a string) of the current ASN.1 element
     * @returns {string}
     * @public
     */
    ASN1.prototype.getHexStringValue = function () {
        var hexString = this.toHexString();
        var offset = this.header * 2;
        var length = this.length * 2;
        return hexString.substr(offset, length);
    };
    ASN1.decode = function (str) {
        var stream;
        if (!(str instanceof Stream)) {
            stream = new Stream(str, 0);
        }
        else {
            stream = str;
        }
        var streamStart = new Stream(stream);
        var tag = new ASN1Tag(stream);
        var len = ASN1.decodeLength(stream);
        var start = stream.pos;
        var header = start - streamStart.pos;
        var sub = null;
        var getSub = function () {
            var ret = [];
            if (len !== null) {
                // definite length
                var end = start + len;
                while (stream.pos < end) {
                    ret[ret.length] = ASN1.decode(stream);
                }
                if (stream.pos != end) {
                    throw new Error("Content size is not correct for container starting at offset " + start);
                }
            }
            else {
                // undefined length
                try {
                    for (;;) {
                        var s = ASN1.decode(stream);
                        if (s.tag.isEOC()) {
                            break;
                        }
                        ret[ret.length] = s;
                    }
                    len = start - stream.pos; // undefined lengths are represented as negative values
                }
                catch (e) {
                    throw new Error("Exception while decoding undefined length content: " + e);
                }
            }
            return ret;
        };
        if (tag.tagConstructed) {
            // must have valid content
            sub = getSub();
        }
        else if (tag.isUniversal() && ((tag.tagNumber == 0x03) || (tag.tagNumber == 0x04))) {
            // sometimes BitString and OctetString are used to encapsulate ASN.1
            try {
                if (tag.tagNumber == 0x03) {
                    if (stream.get() != 0) {
                        throw new Error("BIT STRINGs with unused bits cannot encapsulate.");
                    }
                }
                sub = getSub();
                for (var i = 0; i < sub.length; ++i) {
                    if (sub[i].tag.isEOC()) {
                        throw new Error("EOC is not supposed to be actual content.");
                    }
                }
            }
            catch (e) {
                // but silently ignore when they don't
                sub = null;
            }
        }
        if (sub === null) {
            if (len === null) {
                throw new Error("We can't skip over an invalid tag with undefined length at offset " + start);
            }
            stream.pos = start + Math.abs(len);
        }
        return new ASN1(streamStart, header, len, tag, sub);
    };
    return ASN1;
}());
var ASN1Tag = /** @class */ (function () {
    function ASN1Tag(stream) {
        var buf = stream.get();
        this.tagClass = buf >> 6;
        this.tagConstructed = ((buf & 0x20) !== 0);
        this.tagNumber = buf & 0x1F;
        if (this.tagNumber == 0x1F) { // long tag
            var n = new Int10();
            do {
                buf = stream.get();
                n.mulAdd(128, buf & 0x7F);
            } while (buf & 0x80);
            this.tagNumber = n.simplify();
        }
    }
    ASN1Tag.prototype.isUniversal = function () {
        return this.tagClass === 0x00;
    };
    ASN1Tag.prototype.isEOC = function () {
        return this.tagClass === 0x00 && this.tagNumber === 0x00;
    };
    return ASN1Tag;
}());

// Copyright (c) 2005  Tom Wu
// Bits per digit
var dbits;
// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = ((canary & 0xffffff) == 0xefcafe);
//#region
var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997];
var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];
//#endregion
// (public) Constructor
var BigInteger = /** @class */ (function () {
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) {
                this.fromNumber(a, b, c);
            }
            else if (b == null && "string" != typeof a) {
                this.fromString(a, 256);
            }
            else {
                this.fromString(a, b);
            }
        }
    }
    //#region PUBLIC
    // BigInteger.prototype.toString = bnToString;
    // (public) return string representation in given radix
    BigInteger.prototype.toString = function (b) {
        if (this.s < 0) {
            return "-" + this.negate().toString(b);
        }
        var k;
        if (b == 16) {
            k = 4;
        }
        else if (b == 8) {
            k = 3;
        }
        else if (b == 2) {
            k = 1;
        }
        else if (b == 32) {
            k = 5;
        }
        else if (b == 4) {
            k = 2;
        }
        else {
            return this.toRadix(b);
        }
        var km = (1 << k) - 1;
        var d;
        var m = false;
        var r = "";
        var i = this.t;
        var p = this.DB - (i * this.DB) % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while (i >= 0) {
                if (p < k) {
                    d = (this[i] & ((1 << p) - 1)) << (k - p);
                    d |= this[--i] >> (p += this.DB - k);
                }
                else {
                    d = (this[i] >> (p -= k)) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) {
                    m = true;
                }
                if (m) {
                    r += int2char(d);
                }
            }
        }
        return m ? r : "0";
    };
    // BigInteger.prototype.negate = bnNegate;
    // (public) -this
    BigInteger.prototype.negate = function () {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    };
    // BigInteger.prototype.abs = bnAbs;
    // (public) |this|
    BigInteger.prototype.abs = function () {
        return (this.s < 0) ? this.negate() : this;
    };
    // BigInteger.prototype.compareTo = bnCompareTo;
    // (public) return + if this > a, - if this < a, 0 if equal
    BigInteger.prototype.compareTo = function (a) {
        var r = this.s - a.s;
        if (r != 0) {
            return r;
        }
        var i = this.t;
        r = i - a.t;
        if (r != 0) {
            return (this.s < 0) ? -r : r;
        }
        while (--i >= 0) {
            if ((r = this[i] - a[i]) != 0) {
                return r;
            }
        }
        return 0;
    };
    // BigInteger.prototype.bitLength = bnBitLength;
    // (public) return the number of bits in "this"
    BigInteger.prototype.bitLength = function () {
        if (this.t <= 0) {
            return 0;
        }
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM));
    };
    // BigInteger.prototype.mod = bnMod;
    // (public) this mod a
    BigInteger.prototype.mod = function (a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
            a.subTo(r, r);
        }
        return r;
    };
    // BigInteger.prototype.modPowInt = bnModPowInt;
    // (public) this^e % m, 0 <= e < 2^32
    BigInteger.prototype.modPowInt = function (e, m) {
        var z;
        if (e < 256 || m.isEven()) {
            z = new Classic(m);
        }
        else {
            z = new Montgomery(m);
        }
        return this.exp(e, z);
    };
    // BigInteger.prototype.clone = bnClone;
    // (public)
    BigInteger.prototype.clone = function () {
        var r = nbi();
        this.copyTo(r);
        return r;
    };
    // BigInteger.prototype.intValue = bnIntValue;
    // (public) return value as integer
    BigInteger.prototype.intValue = function () {
        if (this.s < 0) {
            if (this.t == 1) {
                return this[0] - this.DV;
            }
            else if (this.t == 0) {
                return -1;
            }
        }
        else if (this.t == 1) {
            return this[0];
        }
        else if (this.t == 0) {
            return 0;
        }
        // assumes 16 < DB < 32
        return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0];
    };
    // BigInteger.prototype.byteValue = bnByteValue;
    // (public) return value as byte
    BigInteger.prototype.byteValue = function () {
        return (this.t == 0) ? this.s : (this[0] << 24) >> 24;
    };
    // BigInteger.prototype.shortValue = bnShortValue;
    // (public) return value as short (assumes DB>=16)
    BigInteger.prototype.shortValue = function () {
        return (this.t == 0) ? this.s : (this[0] << 16) >> 16;
    };
    // BigInteger.prototype.signum = bnSigNum;
    // (public) 0 if this == 0, 1 if this > 0
    BigInteger.prototype.signum = function () {
        if (this.s < 0) {
            return -1;
        }
        else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) {
            return 0;
        }
        else {
            return 1;
        }
    };
    // BigInteger.prototype.toByteArray = bnToByteArray;
    // (public) convert to bigendian byte array
    BigInteger.prototype.toByteArray = function () {
        var i = this.t;
        var r = [];
        r[0] = this.s;
        var p = this.DB - (i * this.DB) % 8;
        var d;
        var k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) {
                r[k++] = d | (this.s << (this.DB - p));
            }
            while (i >= 0) {
                if (p < 8) {
                    d = (this[i] & ((1 << p) - 1)) << (8 - p);
                    d |= this[--i] >> (p += this.DB - 8);
                }
                else {
                    d = (this[i] >> (p -= 8)) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) {
                    d |= -256;
                }
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) {
                    ++k;
                }
                if (k > 0 || d != this.s) {
                    r[k++] = d;
                }
            }
        }
        return r;
    };
    // BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.equals = function (a) {
        return (this.compareTo(a) == 0);
    };
    // BigInteger.prototype.min = bnMin;
    BigInteger.prototype.min = function (a) {
        return (this.compareTo(a) < 0) ? this : a;
    };
    // BigInteger.prototype.max = bnMax;
    BigInteger.prototype.max = function (a) {
        return (this.compareTo(a) > 0) ? this : a;
    };
    // BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.and = function (a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    };
    // BigInteger.prototype.or = bnOr;
    BigInteger.prototype.or = function (a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    };
    // BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.xor = function (a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    };
    // BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.andNot = function (a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    };
    // BigInteger.prototype.not = bnNot;
    // (public) ~this
    BigInteger.prototype.not = function () {
        var r = nbi();
        for (var i = 0; i < this.t; ++i) {
            r[i] = this.DM & ~this[i];
        }
        r.t = this.t;
        r.s = ~this.s;
        return r;
    };
    // BigInteger.prototype.shiftLeft = bnShiftLeft;
    // (public) this << n
    BigInteger.prototype.shiftLeft = function (n) {
        var r = nbi();
        if (n < 0) {
            this.rShiftTo(-n, r);
        }
        else {
            this.lShiftTo(n, r);
        }
        return r;
    };
    // BigInteger.prototype.shiftRight = bnShiftRight;
    // (public) this >> n
    BigInteger.prototype.shiftRight = function (n) {
        var r = nbi();
        if (n < 0) {
            this.lShiftTo(-n, r);
        }
        else {
            this.rShiftTo(n, r);
        }
        return r;
    };
    // BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    // (public) returns index of lowest 1-bit (or -1 if none)
    BigInteger.prototype.getLowestSetBit = function () {
        for (var i = 0; i < this.t; ++i) {
            if (this[i] != 0) {
                return i * this.DB + lbit(this[i]);
            }
        }
        if (this.s < 0) {
            return this.t * this.DB;
        }
        return -1;
    };
    // BigInteger.prototype.bitCount = bnBitCount;
    // (public) return number of set bits
    BigInteger.prototype.bitCount = function () {
        var r = 0;
        var x = this.s & this.DM;
        for (var i = 0; i < this.t; ++i) {
            r += cbit(this[i] ^ x);
        }
        return r;
    };
    // BigInteger.prototype.testBit = bnTestBit;
    // (public) true iff nth bit is set
    BigInteger.prototype.testBit = function (n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) {
            return (this.s != 0);
        }
        return ((this[j] & (1 << (n % this.DB))) != 0);
    };
    // BigInteger.prototype.setBit = bnSetBit;
    // (public) this | (1<<n)
    BigInteger.prototype.setBit = function (n) {
        return this.changeBit(n, op_or);
    };
    // BigInteger.prototype.clearBit = bnClearBit;
    // (public) this & ~(1<<n)
    BigInteger.prototype.clearBit = function (n) {
        return this.changeBit(n, op_andnot);
    };
    // BigInteger.prototype.flipBit = bnFlipBit;
    // (public) this ^ (1<<n)
    BigInteger.prototype.flipBit = function (n) {
        return this.changeBit(n, op_xor);
    };
    // BigInteger.prototype.add = bnAdd;
    // (public) this + a
    BigInteger.prototype.add = function (a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    };
    // BigInteger.prototype.subtract = bnSubtract;
    // (public) this - a
    BigInteger.prototype.subtract = function (a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    };
    // BigInteger.prototype.multiply = bnMultiply;
    // (public) this * a
    BigInteger.prototype.multiply = function (a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    };
    // BigInteger.prototype.divide = bnDivide;
    // (public) this / a
    BigInteger.prototype.divide = function (a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    };
    // BigInteger.prototype.remainder = bnRemainder;
    // (public) this % a
    BigInteger.prototype.remainder = function (a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    };
    // BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    // (public) [this/a,this%a]
    BigInteger.prototype.divideAndRemainder = function (a) {
        var q = nbi();
        var r = nbi();
        this.divRemTo(a, q, r);
        return [q, r];
    };
    // BigInteger.prototype.modPow = bnModPow;
    // (public) this^e % m (HAC 14.85)
    BigInteger.prototype.modPow = function (e, m) {
        var i = e.bitLength();
        var k;
        var r = nbv(1);
        var z;
        if (i <= 0) {
            return r;
        }
        else if (i < 18) {
            k = 1;
        }
        else if (i < 48) {
            k = 3;
        }
        else if (i < 144) {
            k = 4;
        }
        else if (i < 768) {
            k = 5;
        }
        else {
            k = 6;
        }
        if (i < 8) {
            z = new Classic(m);
        }
        else if (m.isEven()) {
            z = new Barrett(m);
        }
        else {
            z = new Montgomery(m);
        }
        // precomputation
        var g = [];
        var n = 3;
        var k1 = k - 1;
        var km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while (n <= km) {
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1;
        var w;
        var is1 = true;
        var r2 = nbi();
        var t;
        i = nbits(e[j]) - 1;
        while (j >= 0) {
            if (i >= k1) {
                w = (e[j] >> (i - k1)) & km;
            }
            else {
                w = (e[j] & ((1 << (i + 1)) - 1)) << (k1 - i);
                if (j > 0) {
                    w |= e[j - 1] >> (this.DB + i - k1);
                }
            }
            n = k;
            while ((w & 1) == 0) {
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) { // ret == 1, don't bother squaring or multiplying it
                g[w].copyTo(r);
                is1 = false;
            }
            else {
                while (n > 1) {
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) {
                    z.sqrTo(r, r2);
                }
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while (j >= 0 && (e[j] & (1 << i)) == 0) {
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    };
    // BigInteger.prototype.modInverse = bnModInverse;
    // (public) 1/this % m (HAC 14.61)
    BigInteger.prototype.modInverse = function (m) {
        var ac = m.isEven();
        if ((this.isEven() && ac) || m.signum() == 0) {
            return BigInteger.ZERO;
        }
        var u = m.clone();
        var v = this.clone();
        var a = nbv(1);
        var b = nbv(0);
        var c = nbv(0);
        var d = nbv(1);
        while (u.signum() != 0) {
            while (u.isEven()) {
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                }
                else if (!b.isEven()) {
                    b.subTo(m, b);
                }
                b.rShiftTo(1, b);
            }
            while (v.isEven()) {
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                }
                else if (!d.isEven()) {
                    d.subTo(m, d);
                }
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) {
                    a.subTo(c, a);
                }
                b.subTo(d, b);
            }
            else {
                v.subTo(u, v);
                if (ac) {
                    c.subTo(a, c);
                }
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) {
            return BigInteger.ZERO;
        }
        if (d.compareTo(m) >= 0) {
            return d.subtract(m);
        }
        if (d.signum() < 0) {
            d.addTo(m, d);
        }
        else {
            return d;
        }
        if (d.signum() < 0) {
            return d.add(m);
        }
        else {
            return d;
        }
    };
    // BigInteger.prototype.pow = bnPow;
    // (public) this^e
    BigInteger.prototype.pow = function (e) {
        return this.exp(e, new NullExp());
    };
    // BigInteger.prototype.gcd = bnGCD;
    // (public) gcd(this,a) (HAC 14.54)
    BigInteger.prototype.gcd = function (a) {
        var x = (this.s < 0) ? this.negate() : this.clone();
        var y = (a.s < 0) ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit();
        var g = y.getLowestSetBit();
        if (g < 0) {
            return x;
        }
        if (i < g) {
            g = i;
        }
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while (x.signum() > 0) {
            if ((i = x.getLowestSetBit()) > 0) {
                x.rShiftTo(i, x);
            }
            if ((i = y.getLowestSetBit()) > 0) {
                y.rShiftTo(i, y);
            }
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            }
            else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) {
            y.lShiftTo(g, y);
        }
        return y;
    };
    // BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // (public) test primality with certainty >= 1-.5^t
    BigInteger.prototype.isProbablePrime = function (t) {
        var i;
        var x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for (i = 0; i < lowprimes.length; ++i) {
                if (x[0] == lowprimes[i]) {
                    return true;
                }
            }
            return false;
        }
        if (x.isEven()) {
            return false;
        }
        i = 1;
        while (i < lowprimes.length) {
            var m = lowprimes[i];
            var j = i + 1;
            while (j < lowprimes.length && m < lplim) {
                m *= lowprimes[j++];
            }
            m = x.modInt(m);
            while (i < j) {
                if (m % lowprimes[i++] == 0) {
                    return false;
                }
            }
        }
        return x.millerRabin(t);
    };
    //#endregion PUBLIC
    //#region PROTECTED
    // BigInteger.prototype.copyTo = bnpCopyTo;
    // (protected) copy this to r
    BigInteger.prototype.copyTo = function (r) {
        for (var i = this.t - 1; i >= 0; --i) {
            r[i] = this[i];
        }
        r.t = this.t;
        r.s = this.s;
    };
    // BigInteger.prototype.fromInt = bnpFromInt;
    // (protected) set from integer value x, -DV <= x < DV
    BigInteger.prototype.fromInt = function (x) {
        this.t = 1;
        this.s = (x < 0) ? -1 : 0;
        if (x > 0) {
            this[0] = x;
        }
        else if (x < -1) {
            this[0] = x + this.DV;
        }
        else {
            this.t = 0;
        }
    };
    // BigInteger.prototype.fromString = bnpFromString;
    // (protected) set from string and radix
    BigInteger.prototype.fromString = function (s, b) {
        var k;
        if (b == 16) {
            k = 4;
        }
        else if (b == 8) {
            k = 3;
        }
        else if (b == 256) {
            k = 8;
            /* byte array */
        }
        else if (b == 2) {
            k = 1;
        }
        else if (b == 32) {
            k = 5;
        }
        else if (b == 4) {
            k = 2;
        }
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length;
        var mi = false;
        var sh = 0;
        while (--i >= 0) {
            var x = (k == 8) ? (+s[i]) & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") {
                    mi = true;
                }
                continue;
            }
            mi = false;
            if (sh == 0) {
                this[this.t++] = x;
            }
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh;
                this[this.t++] = (x >> (this.DB - sh));
            }
            else {
                this[this.t - 1] |= x << sh;
            }
            sh += k;
            if (sh >= this.DB) {
                sh -= this.DB;
            }
        }
        if (k == 8 && ((+s[0]) & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) {
                this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh;
            }
        }
        this.clamp();
        if (mi) {
            BigInteger.ZERO.subTo(this, this);
        }
    };
    // BigInteger.prototype.clamp = bnpClamp;
    // (protected) clamp off excess high words
    BigInteger.prototype.clamp = function () {
        var c = this.s & this.DM;
        while (this.t > 0 && this[this.t - 1] == c) {
            --this.t;
        }
    };
    // BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    // (protected) r = this << n*DB
    BigInteger.prototype.dlShiftTo = function (n, r) {
        var i;
        for (i = this.t - 1; i >= 0; --i) {
            r[i + n] = this[i];
        }
        for (i = n - 1; i >= 0; --i) {
            r[i] = 0;
        }
        r.t = this.t + n;
        r.s = this.s;
    };
    // BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    // (protected) r = this >> n*DB
    BigInteger.prototype.drShiftTo = function (n, r) {
        for (var i = n; i < this.t; ++i) {
            r[i - n] = this[i];
        }
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    };
    // BigInteger.prototype.lShiftTo = bnpLShiftTo;
    // (protected) r = this << n
    BigInteger.prototype.lShiftTo = function (n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB);
        var c = (this.s << bs) & this.DM;
        for (var i = this.t - 1; i >= 0; --i) {
            r[i + ds + 1] = (this[i] >> cbs) | c;
            c = (this[i] & bm) << bs;
        }
        for (var i = ds - 1; i >= 0; --i) {
            r[i] = 0;
        }
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    };
    // BigInteger.prototype.rShiftTo = bnpRShiftTo;
    // (protected) r = this >> n
    BigInteger.prototype.rShiftTo = function (n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for (var i = ds + 1; i < this.t; ++i) {
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) {
            r[this.t - ds - 1] |= (this.s & bm) << cbs;
        }
        r.t = this.t - ds;
        r.clamp();
    };
    // BigInteger.prototype.subTo = bnpSubTo;
    // (protected) r = this - a
    BigInteger.prototype.subTo = function (a, r) {
        var i = 0;
        var c = 0;
        var m = Math.min(a.t, this.t);
        while (i < m) {
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while (i < this.t) {
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        }
        else {
            c += this.s;
            while (i < a.t) {
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = (c < 0) ? -1 : 0;
        if (c < -1) {
            r[i++] = this.DV + c;
        }
        else if (c > 0) {
            r[i++] = c;
        }
        r.t = i;
        r.clamp();
    };
    // BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyTo = function (a, r) {
        var x = this.abs();
        var y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = 0; i < y.t; ++i) {
            r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        }
        r.s = 0;
        r.clamp();
        if (this.s != a.s) {
            BigInteger.ZERO.subTo(r, r);
        }
    };
    // BigInteger.prototype.squareTo = bnpSquareTo;
    // (protected) r = this^2, r != this (HAC 14.16)
    BigInteger.prototype.squareTo = function (r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = 0; i < x.t - 1; ++i) {
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) {
            r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        }
        r.s = 0;
        r.clamp();
    };
    // BigInteger.prototype.divRemTo = bnpDivRemTo;
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    BigInteger.prototype.divRemTo = function (m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) {
            return;
        }
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) {
                q.fromInt(0);
            }
            if (r != null) {
                this.copyTo(r);
            }
            return;
        }
        if (r == null) {
            r = nbi();
        }
        var y = nbi();
        var ts = this.s;
        var ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        }
        else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) {
            return;
        }
        var yt = y0 * (1 << this.F1) + ((ys > 1) ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt;
        var d2 = (1 << this.F1) / yt;
        var e = 1 << this.F2;
        var i = r.t;
        var j = i - ys;
        var t = (q == null) ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while (y.t < ys) {
            y[y.t++] = 0;
        }
        while (--j >= 0) {
            // Estimate quotient digit
            var qd = (r[--i] == y0) ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) { // Try it out
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while (r[i] < --qd) {
                    r.subTo(t, r);
                }
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) {
                BigInteger.ZERO.subTo(q, q);
            }
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) {
            r.rShiftTo(nsh, r);
        } // Denormalize remainder
        if (ts < 0) {
            BigInteger.ZERO.subTo(r, r);
        }
    };
    // BigInteger.prototype.invDigit = bnpInvDigit;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    BigInteger.prototype.invDigit = function () {
        if (this.t < 1) {
            return 0;
        }
        var x = this[0];
        if ((x & 1) == 0) {
            return 0;
        }
        var y = x & 3; // y == 1/x mod 2^2
        y = (y * (2 - (x & 0xf) * y)) & 0xf; // y == 1/x mod 2^4
        y = (y * (2 - (x & 0xff) * y)) & 0xff; // y == 1/x mod 2^8
        y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = (y * (2 - x * y % this.DV)) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return (y > 0) ? this.DV - y : -y;
    };
    // BigInteger.prototype.isEven = bnpIsEven;
    // (protected) true iff this is even
    BigInteger.prototype.isEven = function () {
        return ((this.t > 0) ? (this[0] & 1) : this.s) == 0;
    };
    // BigInteger.prototype.exp = bnpExp;
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    BigInteger.prototype.exp = function (e, z) {
        if (e > 0xffffffff || e < 1) {
            return BigInteger.ONE;
        }
        var r = nbi();
        var r2 = nbi();
        var g = z.convert(this);
        var i = nbits(e) - 1;
        g.copyTo(r);
        while (--i >= 0) {
            z.sqrTo(r, r2);
            if ((e & (1 << i)) > 0) {
                z.mulTo(r2, g, r);
            }
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    };
    // BigInteger.prototype.chunkSize = bnpChunkSize;
    // (protected) return x s.t. r^x < DV
    BigInteger.prototype.chunkSize = function (r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    };
    // BigInteger.prototype.toRadix = bnpToRadix;
    // (protected) convert to radix string
    BigInteger.prototype.toRadix = function (b) {
        if (b == null) {
            b = 10;
        }
        if (this.signum() == 0 || b < 2 || b > 36) {
            return "0";
        }
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a);
        var y = nbi();
        var z = nbi();
        var r = "";
        this.divRemTo(d, y, z);
        while (y.signum() > 0) {
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    };
    // BigInteger.prototype.fromRadix = bnpFromRadix;
    // (protected) convert from radix string
    BigInteger.prototype.fromRadix = function (s, b) {
        this.fromInt(0);
        if (b == null) {
            b = 10;
        }
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs);
        var mi = false;
        var j = 0;
        var w = 0;
        for (var i = 0; i < s.length; ++i) {
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) {
                    mi = true;
                }
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) {
            BigInteger.ZERO.subTo(this, this);
        }
    };
    // BigInteger.prototype.fromNumber = bnpFromNumber;
    // (protected) alternate constructor
    BigInteger.prototype.fromNumber = function (a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) {
                this.fromInt(1);
            }
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) {
                    // force MSB set
                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                }
                if (this.isEven()) {
                    this.dAddOffset(1, 0);
                } // force odd
                while (!this.isProbablePrime(b)) {
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) {
                        this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                    }
                }
            }
        }
        else {
            // new BigInteger(int,RNG)
            var x = [];
            var t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) {
                x[0] &= ((1 << t) - 1);
            }
            else {
                x[0] = 0;
            }
            this.fromString(x, 256);
        }
    };
    // BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    // (protected) r = this op a (bitwise)
    BigInteger.prototype.bitwiseTo = function (a, op, r) {
        var i;
        var f;
        var m = Math.min(a.t, this.t);
        for (i = 0; i < m; ++i) {
            r[i] = op(this[i], a[i]);
        }
        if (a.t < this.t) {
            f = a.s & this.DM;
            for (i = m; i < this.t; ++i) {
                r[i] = op(this[i], f);
            }
            r.t = this.t;
        }
        else {
            f = this.s & this.DM;
            for (i = m; i < a.t; ++i) {
                r[i] = op(f, a[i]);
            }
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    };
    // BigInteger.prototype.changeBit = bnpChangeBit;
    // (protected) this op (1<<n)
    BigInteger.prototype.changeBit = function (n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    };
    // BigInteger.prototype.addTo = bnpAddTo;
    // (protected) r = this + a
    BigInteger.prototype.addTo = function (a, r) {
        var i = 0;
        var c = 0;
        var m = Math.min(a.t, this.t);
        while (i < m) {
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while (i < this.t) {
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        }
        else {
            c += this.s;
            while (i < a.t) {
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = (c < 0) ? -1 : 0;
        if (c > 0) {
            r[i++] = c;
        }
        else if (c < -1) {
            r[i++] = this.DV + c;
        }
        r.t = i;
        r.clamp();
    };
    // BigInteger.prototype.dMultiply = bnpDMultiply;
    // (protected) this *= n, this >= 0, 1 < n < DV
    BigInteger.prototype.dMultiply = function (n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    };
    // BigInteger.prototype.dAddOffset = bnpDAddOffset;
    // (protected) this += n << w words, this >= 0
    BigInteger.prototype.dAddOffset = function (n, w) {
        if (n == 0) {
            return;
        }
        while (this.t <= w) {
            this[this.t++] = 0;
        }
        this[w] += n;
        while (this[w] >= this.DV) {
            this[w] -= this.DV;
            if (++w >= this.t) {
                this[this.t++] = 0;
            }
            ++this[w];
        }
    };
    // BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyLowerTo = function (a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while (i > 0) {
            r[--i] = 0;
        }
        for (var j = r.t - this.t; i < j; ++i) {
            r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        }
        for (var j = Math.min(a.t, n); i < j; ++i) {
            this.am(0, a[i], r, i, 0, n - i);
        }
        r.clamp();
    };
    // BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyUpperTo = function (a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while (--i >= 0) {
            r[i] = 0;
        }
        for (i = Math.max(n - this.t, 0); i < a.t; ++i) {
            r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        }
        r.clamp();
        r.drShiftTo(1, r);
    };
    // BigInteger.prototype.modInt = bnpModInt;
    // (protected) this % n, n < 2^26
    BigInteger.prototype.modInt = function (n) {
        if (n <= 0) {
            return 0;
        }
        var d = this.DV % n;
        var r = (this.s < 0) ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) {
                r = this[0] % n;
            }
            else {
                for (var i = this.t - 1; i >= 0; --i) {
                    r = (d * r + this[i]) % n;
                }
            }
        }
        return r;
    };
    // BigInteger.prototype.millerRabin = bnpMillerRabin;
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    BigInteger.prototype.millerRabin = function (t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) {
            return false;
        }
        var r = n1.shiftRight(k);
        t = (t + 1) >> 1;
        if (t > lowprimes.length) {
            t = lowprimes.length;
        }
        var a = nbi();
        for (var i = 0; i < t; ++i) {
            // Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while (j++ < k && y.compareTo(n1) != 0) {
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) {
                        return false;
                    }
                }
                if (y.compareTo(n1) != 0) {
                    return false;
                }
            }
        }
        return true;
    };
    // BigInteger.prototype.square = bnSquare;
    // (public) this^2
    BigInteger.prototype.square = function () {
        var r = nbi();
        this.squareTo(r);
        return r;
    };
    //#region ASYNC
    // Public API method
    BigInteger.prototype.gcda = function (a, callback) {
        var x = (this.s < 0) ? this.negate() : this.clone();
        var y = (a.s < 0) ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit();
        var g = y.getLowestSetBit();
        if (g < 0) {
            callback(x);
            return;
        }
        if (i < g) {
            g = i;
        }
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        // Workhorse of the algorithm, gets called 200 - 800 times per 512 bit keygen.
        var gcda1 = function () {
            if ((i = x.getLowestSetBit()) > 0) {
                x.rShiftTo(i, x);
            }
            if ((i = y.getLowestSetBit()) > 0) {
                y.rShiftTo(i, y);
            }
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            }
            else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
            if (!(x.signum() > 0)) {
                if (g > 0) {
                    y.lShiftTo(g, y);
                }
                setTimeout(function () { callback(y); }, 0); // escape
            }
            else {
                setTimeout(gcda1, 0);
            }
        };
        setTimeout(gcda1, 10);
    };
    // (protected) alternate constructor
    BigInteger.prototype.fromNumberAsync = function (a, b, c, callback) {
        if ("number" == typeof b) {
            if (a < 2) {
                this.fromInt(1);
            }
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) {
                    this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                }
                if (this.isEven()) {
                    this.dAddOffset(1, 0);
                }
                var bnp_1 = this;
                var bnpfn1_1 = function () {
                    bnp_1.dAddOffset(2, 0);
                    if (bnp_1.bitLength() > a) {
                        bnp_1.subTo(BigInteger.ONE.shiftLeft(a - 1), bnp_1);
                    }
                    if (bnp_1.isProbablePrime(b)) {
                        setTimeout(function () { callback(); }, 0); // escape
                    }
                    else {
                        setTimeout(bnpfn1_1, 0);
                    }
                };
                setTimeout(bnpfn1_1, 0);
            }
        }
        else {
            var x = [];
            var t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) {
                x[0] &= ((1 << t) - 1);
            }
            else {
                x[0] = 0;
            }
            this.fromString(x, 256);
        }
    };
    return BigInteger;
}());
//#region REDUCERS
//#region NullExp
var NullExp = /** @class */ (function () {
    function NullExp() {
    }
    // NullExp.prototype.convert = nNop;
    NullExp.prototype.convert = function (x) {
        return x;
    };
    // NullExp.prototype.revert = nNop;
    NullExp.prototype.revert = function (x) {
        return x;
    };
    // NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
    };
    // NullExp.prototype.sqrTo = nSqrTo;
    NullExp.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
    };
    return NullExp;
}());
// Modular reduction using "classic" algorithm
var Classic = /** @class */ (function () {
    function Classic(m) {
        this.m = m;
    }
    // Classic.prototype.convert = cConvert;
    Classic.prototype.convert = function (x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) {
            return x.mod(this.m);
        }
        else {
            return x;
        }
    };
    // Classic.prototype.revert = cRevert;
    Classic.prototype.revert = function (x) {
        return x;
    };
    // Classic.prototype.reduce = cReduce;
    Classic.prototype.reduce = function (x) {
        x.divRemTo(this.m, null, x);
    };
    // Classic.prototype.mulTo = cMulTo;
    Classic.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Classic.prototype.sqrTo = cSqrTo;
    Classic.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Classic;
}());
//#endregion
//#region Montgomery
// Montgomery reduction
var Montgomery = /** @class */ (function () {
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << (m.DB - 15)) - 1;
        this.mt2 = 2 * m.t;
    }
    // Montgomery.prototype.convert = montConvert;
    // xR mod m
    Montgomery.prototype.convert = function (x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
            this.m.subTo(r, r);
        }
        return r;
    };
    // Montgomery.prototype.revert = montRevert;
    // x/R mod m
    Montgomery.prototype.revert = function (x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    };
    // Montgomery.prototype.reduce = montReduce;
    // x = x/R mod m (HAC 14.32)
    Montgomery.prototype.reduce = function (x) {
        while (x.t <= this.mt2) {
            // pad x so am has enough room later
            x[x.t++] = 0;
        }
        for (var i = 0; i < this.m.t; ++i) {
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while (x[j] >= x.DV) {
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) {
            x.subTo(this.m, x);
        }
    };
    // Montgomery.prototype.mulTo = montMulTo;
    // r = "xy/R mod m"; x,y != r
    Montgomery.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Montgomery.prototype.sqrTo = montSqrTo;
    // r = "x^2/R mod m"; x != r
    Montgomery.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Montgomery;
}());
//#endregion Montgomery
//#region Barrett
// Barrett modular reduction
var Barrett = /** @class */ (function () {
    function Barrett(m) {
        this.m = m;
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
    }
    // Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.convert = function (x) {
        if (x.s < 0 || x.t > 2 * this.m.t) {
            return x.mod(this.m);
        }
        else if (x.compareTo(this.m) < 0) {
            return x;
        }
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    };
    // Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.revert = function (x) {
        return x;
    };
    // Barrett.prototype.reduce = barrettReduce;
    // x = x mod m (HAC 14.42)
    Barrett.prototype.reduce = function (x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while (x.compareTo(this.r2) < 0) {
            x.dAddOffset(1, this.m.t + 1);
        }
        x.subTo(this.r2, x);
        while (x.compareTo(this.m) >= 0) {
            x.subTo(this.m, x);
        }
    };
    // Barrett.prototype.mulTo = barrettMulTo;
    // r = x*y mod m; x,y != r
    Barrett.prototype.mulTo = function (x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Barrett.prototype.sqrTo = barrettSqrTo;
    // r = x^2 mod m; x != r
    Barrett.prototype.sqrTo = function (x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Barrett;
}());
//#endregion
//#endregion REDUCERS
// return new, unset BigInteger
function nbi() { return new BigInteger(null); }
function parseBigInt(str, r) {
    return new BigInteger(str, r);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i, x, w, j, c, n) {
    while (--n >= 0) {
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff;
    var xh = x >> 15;
    while (--n >= 0) {
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff;
    var xh = x >> 14;
    while (--n >= 0) {
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
if (j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
    BigInteger.prototype.am = am2;
    dbits = 30;
}
else if (j_lm && (navigator.appName != "Netscape")) {
    BigInteger.prototype.am = am1;
    dbits = 26;
}
else { // Mozilla/Netscape seems to prefer am3
    BigInteger.prototype.am = am3;
    dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = ((1 << dbits) - 1);
BigInteger.prototype.DV = (1 << dbits);
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
// Digit conversions
var BI_RC = [];
var rr;
var vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) {
    BI_RC[rr++] = vv;
}
rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
}
rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
    BI_RC[rr++] = vv;
}
function intAt(s, i) {
    var c = BI_RC[s.charCodeAt(i)];
    return (c == null) ? -1 : c;
}
// return bigint initialized to value
function nbv(i) {
    var r = nbi();
    r.fromInt(i);
    return r;
}
// returns bit length of the integer x
function nbits(x) {
    var r = 1;
    var t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

// prng4.js - uses Arcfour as a PRNG
var Arcfour = /** @class */ (function () {
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = [];
    }
    // Arcfour.prototype.init = ARC4init;
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    Arcfour.prototype.init = function (key) {
        var i;
        var j;
        var t;
        for (i = 0; i < 256; ++i) {
            this.S[i] = i;
        }
        j = 0;
        for (i = 0; i < 256; ++i) {
            j = (j + this.S[i] + key[i % key.length]) & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    };
    // Arcfour.prototype.next = ARC4next;
    Arcfour.prototype.next = function () {
        var t;
        this.i = (this.i + 1) & 255;
        this.j = (this.j + this.S[this.i]) & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[(t + this.S[this.i]) & 255];
    };
    return Arcfour;
}());
// Plug in your RNG constructor here
function prng_newstate() {
    return new Arcfour();
}
// Pool size must be a multiple of 4 and greater than 32.
// An array of bytes the size of the pool will be passed to init()
var rng_psize = 256;

// Random number generator - requires a PRNG backend, e.g. prng4.js
var rng_state;
var rng_pool = null;
var rng_pptr;
// Initialize the pool with junk if needed.
if (rng_pool == null) {
    rng_pool = [];
    rng_pptr = 0;
    var t = void 0;
    if (window.crypto && window.crypto.getRandomValues) {
        // Extract entropy (2048 bits) from RNG if available
        var z = new Uint32Array(256);
        window.crypto.getRandomValues(z);
        for (t = 0; t < z.length; ++t) {
            rng_pool[rng_pptr++] = z[t] & 255;
        }
    }
    // Use mouse events for entropy, if we do not have enough entropy by the time
    // we need it, entropy will be generated by Math.random.
    var onMouseMoveListener_1 = function (ev) {
        this.count = this.count || 0;
        if (this.count >= 256 || rng_pptr >= rng_psize) {
            if (window.removeEventListener) {
                window.removeEventListener("mousemove", onMouseMoveListener_1, false);
            }
            else if (window.detachEvent) {
                window.detachEvent("onmousemove", onMouseMoveListener_1);
            }
            return;
        }
        try {
            var mouseCoordinates = ev.x + ev.y;
            rng_pool[rng_pptr++] = mouseCoordinates & 255;
            this.count += 1;
        }
        catch (e) {
            // Sometimes Firefox will deny permission to access event properties for some reason. Ignore.
        }
    };
    if (window.addEventListener) {
        window.addEventListener("mousemove", onMouseMoveListener_1, false);
    }
    else if (window.attachEvent) {
        window.attachEvent("onmousemove", onMouseMoveListener_1);
    }
}
function rng_get_byte() {
    if (rng_state == null) {
        rng_state = prng_newstate();
        // At this point, we may not have collected enough entropy.  If not, fall back to Math.random
        while (rng_pptr < rng_psize) {
            var random = Math.floor(65536 * Math.random());
            rng_pool[rng_pptr++] = random & 255;
        }
        rng_state.init(rng_pool);
        for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) {
            rng_pool[rng_pptr] = 0;
        }
        rng_pptr = 0;
    }
    // TODO: allow reseeding after first request
    return rng_state.next();
}
var SecureRandom = /** @class */ (function () {
    function SecureRandom() {
    }
    SecureRandom.prototype.nextBytes = function (ba) {
        for (var i = 0; i < ba.length; ++i) {
            ba[i] = rng_get_byte();
        }
    };
    return SecureRandom;
}());

// Depends on jsbn.js and rng.js
// function linebrk(s,n) {
//   var ret = "";
//   var i = 0;
//   while(i + n < s.length) {
//     ret += s.substring(i,i+n) + "\n";
//     i += n;
//   }
//   return ret + s.substring(i,s.length);
// }
// function byte2Hex(b) {
//   if(b < 0x10)
//     return "0" + b.toString(16);
//   else
//     return b.toString(16);
// }
function pkcs1pad1(s, n) {
    if (n < s.length + 22) {
        console.error("Message too long for RSA");
        return null;
    }
    var len = n - s.length - 6;
    var filler = "";
    for (var f = 0; f < len; f += 2) {
        filler += "ff";
    }
    var m = "0001" + filler + "00" + s;
    return parseBigInt(m, 16);
}
// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
function pkcs1pad2(s, n) {
    if (n < s.length + 11) { // TODO: fix for utf-8
        console.error("Message too long for RSA");
        return null;
    }
    var ba = [];
    var i = s.length - 1;
    while (i >= 0 && n > 0) {
        var c = s.charCodeAt(i--);
        if (c < 128) { // encode using utf-8
            ba[--n] = c;
        }
        else if ((c > 127) && (c < 2048)) {
            ba[--n] = (c & 63) | 128;
            ba[--n] = (c >> 6) | 192;
        }
        else {
            ba[--n] = (c & 63) | 128;
            ba[--n] = ((c >> 6) & 63) | 128;
            ba[--n] = (c >> 12) | 224;
        }
    }
    ba[--n] = 0;
    var rng = new SecureRandom();
    var x = [];
    while (n > 2) { // random non-zero pad
        x[0] = 0;
        while (x[0] == 0) {
            rng.nextBytes(x);
        }
        ba[--n] = x[0];
    }
    ba[--n] = 2;
    ba[--n] = 0;
    return new BigInteger(ba);
}
// "empty" RSA key constructor
var RSAKey = /** @class */ (function () {
    function RSAKey() {
        this.n = null;
        this.e = 0;
        this.d = null;
        this.p = null;
        this.q = null;
        this.dmp1 = null;
        this.dmq1 = null;
        this.coeff = null;
    }
    //#region PROTECTED
    // protected
    // RSAKey.prototype.doPublic = RSADoPublic;
    // Perform raw public operation on "x": return x^e (mod n)
    RSAKey.prototype.doPublic = function (x) {
        return x.modPowInt(this.e, this.n);
    };
    // RSAKey.prototype.doPrivate = RSADoPrivate;
    // Perform raw private operation on "x": return x^d (mod n)
    RSAKey.prototype.doPrivate = function (x) {
        if (this.p == null || this.q == null) {
            return x.modPow(this.d, this.n);
        }
        // TODO: re-calculate any missing CRT params
        var xp = x.mod(this.p).modPow(this.dmp1, this.p);
        var xq = x.mod(this.q).modPow(this.dmq1, this.q);
        while (xp.compareTo(xq) < 0) {
            xp = xp.add(this.p);
        }
        return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);
    };
    //#endregion PROTECTED
    //#region PUBLIC
    // RSAKey.prototype.setPublic = RSASetPublic;
    // Set the public key fields N and e from hex strings
    RSAKey.prototype.setPublic = function (N, E) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = parseBigInt(N, 16);
            this.e = parseInt(E, 16);
        }
        else {
            console.error("Invalid RSA public key");
        }
    };
    // RSAKey.prototype.encrypt = RSAEncrypt;
    // Return the PKCS#1 RSA encryption of "text" as an even-length hex string
    RSAKey.prototype.encrypt = function (text) {
        var m = pkcs1pad2(text, (this.n.bitLength() + 7) >> 3);
        if (m == null) {
            return null;
        }
        var c = this.doPublic(m);
        if (c == null) {
            return null;
        }
        var h = c.toString(16);
        if ((h.length & 1) == 0) {
            return h;
        }
        else {
            return "0" + h;
        }
    };
    // RSAKey.prototype.setPrivate = RSASetPrivate;
    // Set the private key fields N, e, and d from hex strings
    RSAKey.prototype.setPrivate = function (N, E, D) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = parseBigInt(N, 16);
            this.e = parseInt(E, 16);
            this.d = parseBigInt(D, 16);
        }
        else {
            console.error("Invalid RSA private key");
        }
    };
    // RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
    // Set the private key fields N, e, d and CRT params from hex strings
    RSAKey.prototype.setPrivateEx = function (N, E, D, P, Q, DP, DQ, C) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = parseBigInt(N, 16);
            this.e = parseInt(E, 16);
            this.d = parseBigInt(D, 16);
            this.p = parseBigInt(P, 16);
            this.q = parseBigInt(Q, 16);
            this.dmp1 = parseBigInt(DP, 16);
            this.dmq1 = parseBigInt(DQ, 16);
            this.coeff = parseBigInt(C, 16);
        }
        else {
            console.error("Invalid RSA private key");
        }
    };
    // RSAKey.prototype.generate = RSAGenerate;
    // Generate a new random private key B bits long, using public expt E
    RSAKey.prototype.generate = function (B, E) {
        var rng = new SecureRandom();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new BigInteger(E, 16);
        for (;;) {
            for (;;) {
                this.p = new BigInteger(B - qs, 1, rng);
                if (this.p.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.p.isProbablePrime(10)) {
                    break;
                }
            }
            for (;;) {
                this.q = new BigInteger(qs, 1, rng);
                if (this.q.subtract(BigInteger.ONE).gcd(ee).compareTo(BigInteger.ONE) == 0 && this.q.isProbablePrime(10)) {
                    break;
                }
            }
            if (this.p.compareTo(this.q) <= 0) {
                var t = this.p;
                this.p = this.q;
                this.q = t;
            }
            var p1 = this.p.subtract(BigInteger.ONE);
            var q1 = this.q.subtract(BigInteger.ONE);
            var phi = p1.multiply(q1);
            if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
                this.n = this.p.multiply(this.q);
                this.d = ee.modInverse(phi);
                this.dmp1 = this.d.mod(p1);
                this.dmq1 = this.d.mod(q1);
                this.coeff = this.q.modInverse(this.p);
                break;
            }
        }
    };
    // RSAKey.prototype.decrypt = RSADecrypt;
    // Return the PKCS#1 RSA decryption of "ctext".
    // "ctext" is an even-length hex string and the output is a plain string.
    RSAKey.prototype.decrypt = function (ctext) {
        var c = parseBigInt(ctext, 16);
        var m = this.doPrivate(c);
        if (m == null) {
            return null;
        }
        return pkcs1unpad2(m, (this.n.bitLength() + 7) >> 3);
    };
    // Generate a new random private key B bits long, using public expt E
    RSAKey.prototype.generateAsync = function (B, E, callback) {
        var rng = new SecureRandom();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new BigInteger(E, 16);
        var rsa = this;
        // These functions have non-descript names because they were originally for(;;) loops.
        // I don't know about cryptography to give them better names than loop1-4.
        var loop1 = function () {
            var loop4 = function () {
                if (rsa.p.compareTo(rsa.q) <= 0) {
                    var t = rsa.p;
                    rsa.p = rsa.q;
                    rsa.q = t;
                }
                var p1 = rsa.p.subtract(BigInteger.ONE);
                var q1 = rsa.q.subtract(BigInteger.ONE);
                var phi = p1.multiply(q1);
                if (phi.gcd(ee).compareTo(BigInteger.ONE) == 0) {
                    rsa.n = rsa.p.multiply(rsa.q);
                    rsa.d = ee.modInverse(phi);
                    rsa.dmp1 = rsa.d.mod(p1);
                    rsa.dmq1 = rsa.d.mod(q1);
                    rsa.coeff = rsa.q.modInverse(rsa.p);
                    setTimeout(function () { callback(); }, 0); // escape
                }
                else {
                    setTimeout(loop1, 0);
                }
            };
            var loop3 = function () {
                rsa.q = nbi();
                rsa.q.fromNumberAsync(qs, 1, rng, function () {
                    rsa.q.subtract(BigInteger.ONE).gcda(ee, function (r) {
                        if (r.compareTo(BigInteger.ONE) == 0 && rsa.q.isProbablePrime(10)) {
                            setTimeout(loop4, 0);
                        }
                        else {
                            setTimeout(loop3, 0);
                        }
                    });
                });
            };
            var loop2 = function () {
                rsa.p = nbi();
                rsa.p.fromNumberAsync(B - qs, 1, rng, function () {
                    rsa.p.subtract(BigInteger.ONE).gcda(ee, function (r) {
                        if (r.compareTo(BigInteger.ONE) == 0 && rsa.p.isProbablePrime(10)) {
                            setTimeout(loop3, 0);
                        }
                        else {
                            setTimeout(loop2, 0);
                        }
                    });
                });
            };
            setTimeout(loop2, 0);
        };
        setTimeout(loop1, 0);
    };
    RSAKey.prototype.sign = function (text, digestMethod, digestName) {
        var header = getDigestHeader(digestName);
        var digest = header + digestMethod(text).toString();
        var m = pkcs1pad1(digest, this.n.bitLength() / 4);
        if (m == null) {
            return null;
        }
        var c = this.doPrivate(m);
        if (c == null) {
            return null;
        }
        var h = c.toString(16);
        if ((h.length & 1) == 0) {
            return h;
        }
        else {
            return "0" + h;
        }
    };
    RSAKey.prototype.verify = function (text, signature, digestMethod) {
        var c = parseBigInt(signature, 16);
        var m = this.doPublic(c);
        if (m == null) {
            return null;
        }
        var unpadded = m.toString(16).replace(/^1f+00/, "");
        var digest = removeDigestHeader(unpadded);
        return digest == digestMethod(text).toString();
    };
    return RSAKey;
}());
// Undo PKCS#1 (type 2, random) padding and, if valid, return the plaintext
function pkcs1unpad2(d, n) {
    var b = d.toByteArray();
    var i = 0;
    while (i < b.length && b[i] == 0) {
        ++i;
    }
    if (b.length - i != n - 1 || b[i] != 2) {
        return null;
    }
    ++i;
    while (b[i] != 0) {
        if (++i >= b.length) {
            return null;
        }
    }
    var ret = "";
    while (++i < b.length) {
        var c = b[i] & 255;
        if (c < 128) { // utf-8 decode
            ret += String.fromCharCode(c);
        }
        else if ((c > 191) && (c < 224)) {
            ret += String.fromCharCode(((c & 31) << 6) | (b[i + 1] & 63));
            ++i;
        }
        else {
            ret += String.fromCharCode(((c & 15) << 12) | ((b[i + 1] & 63) << 6) | (b[i + 2] & 63));
            i += 2;
        }
    }
    return ret;
}
// https://tools.ietf.org/html/rfc3447#page-43
var DIGEST_HEADERS = {
    md2: "3020300c06082a864886f70d020205000410",
    md5: "3020300c06082a864886f70d020505000410",
    sha1: "3021300906052b0e03021a05000414",
    sha224: "302d300d06096086480165030402040500041c",
    sha256: "3031300d060960864801650304020105000420",
    sha384: "3041300d060960864801650304020205000430",
    sha512: "3051300d060960864801650304020305000440",
    ripemd160: "3021300906052b2403020105000414",
};
function getDigestHeader(name) {
    return DIGEST_HEADERS[name] || "";
}
function removeDigestHeader(str) {
    for (var name_1 in DIGEST_HEADERS) {
        if (DIGEST_HEADERS.hasOwnProperty(name_1)) {
            var header = DIGEST_HEADERS[name_1];
            var len = header.length;
            if (str.substr(0, len) == header) {
                return str.substr(len);
            }
        }
    }
    return str;
}
// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
// function RSAEncryptB64(text) {
//  var h = this.encrypt(text);
//  if(h) return hex2b64(h); else return null;
// }
// public
// RSAKey.prototype.encrypt_b64 = RSAEncryptB64;

/*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/
var YAHOO = {};
YAHOO.lang = {
    /**
     * Utility to set up the prototype, constructor and superclass properties to
     * support an inheritance strategy that can chain constructors and methods.
     * Static members will not be inherited.
     *
     * @method extend
     * @static
     * @param {Function} subc   the object to modify
     * @param {Function} superc the object to inherit
     * @param {Object} overrides  additional properties/methods to add to the
     *                              subclass prototype.  These will override the
     *                              matching items obtained from the superclass
     *                              if present.
     */
    extend: function(subc, superc, overrides) {
        if (! superc || ! subc) {
            throw new Error("YAHOO.lang.extend failed, please check that " +
                "all dependencies are included.");
        }

        var F = function() {};
        F.prototype = superc.prototype;
        subc.prototype = new F();
        subc.prototype.constructor = subc;
        subc.superclass = superc.prototype;

        if (superc.prototype.constructor == Object.prototype.constructor) {
            superc.prototype.constructor = superc;
        }

        if (overrides) {
            var i;
            for (i in overrides) {
                subc.prototype[i] = overrides[i];
            }

            /*
             * IE will not enumerate native functions in a derived object even if the
             * function was overridden.  This is a workaround for specific functions
             * we care about on the Object prototype.
             * @property _IEEnumFix
             * @param {Function} r  the object to receive the augmentation
             * @param {Function} s  the object that supplies the properties to augment
             * @static
             * @private
             */
            var _IEEnumFix = function() {},
                ADD = ["toString", "valueOf"];
            try {
                if (/MSIE/.test(navigator.userAgent)) {
                    _IEEnumFix = function(r, s) {
                        for (i = 0; i < ADD.length; i = i + 1) {
                            var fname = ADD[i], f = s[fname];
                            if (typeof f === 'function' && f != Object.prototype[fname]) {
                                r[fname] = f;
                            }
                        }
                    };
                }
            } catch (ex) {}            _IEEnumFix(subc.prototype, overrides);
        }
    }
};

/* asn1-1.0.13.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
 */

/**
 * @fileOverview
 * @name asn1-1.0.js
 * @author Kenji Urushima kenji.urushima@gmail.com
 * @version asn1 1.0.13 (2017-Jun-02)
 * @since jsrsasign 2.1
 * @license <a href="https://kjur.github.io/jsrsasign/license/">MIT License</a>
 */

/**
 * kjur's class library name space
 * <p>
 * This name space provides following name spaces:
 * <ul>
 * <li>{@link KJUR.asn1} - ASN.1 primitive hexadecimal encoder</li>
 * <li>{@link KJUR.asn1.x509} - ASN.1 structure for X.509 certificate and CRL</li>
 * <li>{@link KJUR.crypto} - Java Cryptographic Extension(JCE) style MessageDigest/Signature
 * class and utilities</li>
 * </ul>
 * </p>
 * NOTE: Please ignore method summary and document of this namespace. This caused by a bug of jsdoc2.
 * @name KJUR
 * @namespace kjur's class library name space
 */
var KJUR = {};

/**
 * kjur's ASN.1 class library name space
 * <p>
 * This is ITU-T X.690 ASN.1 DER encoder class library and
 * class structure and methods is very similar to
 * org.bouncycastle.asn1 package of
 * well known BouncyCaslte Cryptography Library.
 * <h4>PROVIDING ASN.1 PRIMITIVES</h4>
 * Here are ASN.1 DER primitive classes.
 * <ul>
 * <li>0x01 {@link KJUR.asn1.DERBoolean}</li>
 * <li>0x02 {@link KJUR.asn1.DERInteger}</li>
 * <li>0x03 {@link KJUR.asn1.DERBitString}</li>
 * <li>0x04 {@link KJUR.asn1.DEROctetString}</li>
 * <li>0x05 {@link KJUR.asn1.DERNull}</li>
 * <li>0x06 {@link KJUR.asn1.DERObjectIdentifier}</li>
 * <li>0x0a {@link KJUR.asn1.DEREnumerated}</li>
 * <li>0x0c {@link KJUR.asn1.DERUTF8String}</li>
 * <li>0x12 {@link KJUR.asn1.DERNumericString}</li>
 * <li>0x13 {@link KJUR.asn1.DERPrintableString}</li>
 * <li>0x14 {@link KJUR.asn1.DERTeletexString}</li>
 * <li>0x16 {@link KJUR.asn1.DERIA5String}</li>
 * <li>0x17 {@link KJUR.asn1.DERUTCTime}</li>
 * <li>0x18 {@link KJUR.asn1.DERGeneralizedTime}</li>
 * <li>0x30 {@link KJUR.asn1.DERSequence}</li>
 * <li>0x31 {@link KJUR.asn1.DERSet}</li>
 * </ul>
 * <h4>OTHER ASN.1 CLASSES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.ASN1Object}</li>
 * <li>{@link KJUR.asn1.DERAbstractString}</li>
 * <li>{@link KJUR.asn1.DERAbstractTime}</li>
 * <li>{@link KJUR.asn1.DERAbstractStructured}</li>
 * <li>{@link KJUR.asn1.DERTaggedObject}</li>
 * </ul>
 * <h4>SUB NAME SPACES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.cades} - CAdES long term signature format</li>
 * <li>{@link KJUR.asn1.cms} - Cryptographic Message Syntax</li>
 * <li>{@link KJUR.asn1.csr} - Certificate Signing Request (CSR/PKCS#10)</li>
 * <li>{@link KJUR.asn1.tsp} - RFC 3161 Timestamping Protocol Format</li>
 * <li>{@link KJUR.asn1.x509} - RFC 5280 X.509 certificate and CRL</li>
 * </ul>
 * </p>
 * NOTE: Please ignore method summary and document of this namespace.
 * This caused by a bug of jsdoc2.
 * @name KJUR.asn1
 * @namespace
 */
if (typeof KJUR.asn1 == "undefined" || !KJUR.asn1) KJUR.asn1 = {};

/**
 * ASN1 utilities class
 * @name KJUR.asn1.ASN1Util
 * @class ASN1 utilities class
 * @since asn1 1.0.2
 */
KJUR.asn1.ASN1Util = new function() {
    this.integerToByteHex = function(i) {
        var h = i.toString(16);
        if ((h.length % 2) == 1) h = '0' + h;
        return h;
    };
    this.bigIntToMinTwosComplementsHex = function(bigIntegerValue) {
        var h = bigIntegerValue.toString(16);
        if (h.substr(0, 1) != '-') {
            if (h.length % 2 == 1) {
                h = '0' + h;
            } else {
                if (! h.match(/^[0-7]/)) {
                    h = '00' + h;
                }
            }
        } else {
            var hPos = h.substr(1);
            var xorLen = hPos.length;
            if (xorLen % 2 == 1) {
                xorLen += 1;
            } else {
                if (! h.match(/^[0-7]/)) {
                    xorLen += 2;
                }
            }
            var hMask = '';
            for (var i = 0; i < xorLen; i++) {
                hMask += 'f';
            }
            var biMask = new BigInteger(hMask, 16);
            var biNeg = biMask.xor(bigIntegerValue).add(BigInteger.ONE);
            h = biNeg.toString(16).replace(/^-/, '');
        }
        return h;
    };
    /**
     * get PEM string from hexadecimal data and header string
     * @name getPEMStringFromHex
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {String} dataHex hexadecimal string of PEM body
     * @param {String} pemHeader PEM header string (ex. 'RSA PRIVATE KEY')
     * @return {String} PEM formatted string of input data
     * @description
     * This method converts a hexadecimal string to a PEM string with
     * a specified header. Its line break will be CRLF("\r\n").
     * @example
     * var pem  = KJUR.asn1.ASN1Util.getPEMStringFromHex('616161', 'RSA PRIVATE KEY');
     * // value of pem will be:
     * -----BEGIN PRIVATE KEY-----
     * YWFh
     * -----END PRIVATE KEY-----
     */
    this.getPEMStringFromHex = function(dataHex, pemHeader) {
        return hextopem(dataHex, pemHeader);
    };

    /**
     * generate ASN1Object specifed by JSON parameters
     * @name newObject
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {Array} param JSON parameter to generate ASN1Object
     * @return {KJUR.asn1.ASN1Object} generated object
     * @since asn1 1.0.3
     * @description
     * generate any ASN1Object specified by JSON param
     * including ASN.1 primitive or structured.
     * Generally 'param' can be described as follows:
     * <blockquote>
     * {TYPE-OF-ASNOBJ: ASN1OBJ-PARAMETER}
     * </blockquote>
     * 'TYPE-OF-ASN1OBJ' can be one of following symbols:
     * <ul>
     * <li>'bool' - DERBoolean</li>
     * <li>'int' - DERInteger</li>
     * <li>'bitstr' - DERBitString</li>
     * <li>'octstr' - DEROctetString</li>
     * <li>'null' - DERNull</li>
     * <li>'oid' - DERObjectIdentifier</li>
     * <li>'enum' - DEREnumerated</li>
     * <li>'utf8str' - DERUTF8String</li>
     * <li>'numstr' - DERNumericString</li>
     * <li>'prnstr' - DERPrintableString</li>
     * <li>'telstr' - DERTeletexString</li>
     * <li>'ia5str' - DERIA5String</li>
     * <li>'utctime' - DERUTCTime</li>
     * <li>'gentime' - DERGeneralizedTime</li>
     * <li>'seq' - DERSequence</li>
     * <li>'set' - DERSet</li>
     * <li>'tag' - DERTaggedObject</li>
     * </ul>
     * @example
     * newObject({'prnstr': 'aaa'});
     * newObject({'seq': [{'int': 3}, {'prnstr': 'aaa'}]})
     * // ASN.1 Tagged Object
     * newObject({'tag': {'tag': 'a1',
     *                    'explicit': true,
     *                    'obj': {'seq': [{'int': 3}, {'prnstr': 'aaa'}]}}});
     * // more simple representation of ASN.1 Tagged Object
     * newObject({'tag': ['a1',
     *                    true,
     *                    {'seq': [
     *                      {'int': 3},
     *                      {'prnstr': 'aaa'}]}
     *                   ]});
     */
    this.newObject = function(param) {
        var _KJUR = KJUR,
            _KJUR_asn1 = _KJUR.asn1,
            _DERBoolean = _KJUR_asn1.DERBoolean,
            _DERInteger = _KJUR_asn1.DERInteger,
            _DERBitString = _KJUR_asn1.DERBitString,
            _DEROctetString = _KJUR_asn1.DEROctetString,
            _DERNull = _KJUR_asn1.DERNull,
            _DERObjectIdentifier = _KJUR_asn1.DERObjectIdentifier,
            _DEREnumerated = _KJUR_asn1.DEREnumerated,
            _DERUTF8String = _KJUR_asn1.DERUTF8String,
            _DERNumericString = _KJUR_asn1.DERNumericString,
            _DERPrintableString = _KJUR_asn1.DERPrintableString,
            _DERTeletexString = _KJUR_asn1.DERTeletexString,
            _DERIA5String = _KJUR_asn1.DERIA5String,
            _DERUTCTime = _KJUR_asn1.DERUTCTime,
            _DERGeneralizedTime = _KJUR_asn1.DERGeneralizedTime,
            _DERSequence = _KJUR_asn1.DERSequence,
            _DERSet = _KJUR_asn1.DERSet,
            _DERTaggedObject = _KJUR_asn1.DERTaggedObject,
            _newObject = _KJUR_asn1.ASN1Util.newObject;

        var keys = Object.keys(param);
        if (keys.length != 1)
            throw "key of param shall be only one.";
        var key = keys[0];

        if (":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + key + ":") == -1)
            throw "undefined key: " + key;

        if (key == "bool")    return new _DERBoolean(param[key]);
        if (key == "int")     return new _DERInteger(param[key]);
        if (key == "bitstr")  return new _DERBitString(param[key]);
        if (key == "octstr")  return new _DEROctetString(param[key]);
        if (key == "null")    return new _DERNull(param[key]);
        if (key == "oid")     return new _DERObjectIdentifier(param[key]);
        if (key == "enum")    return new _DEREnumerated(param[key]);
        if (key == "utf8str") return new _DERUTF8String(param[key]);
        if (key == "numstr")  return new _DERNumericString(param[key]);
        if (key == "prnstr")  return new _DERPrintableString(param[key]);
        if (key == "telstr")  return new _DERTeletexString(param[key]);
        if (key == "ia5str")  return new _DERIA5String(param[key]);
        if (key == "utctime") return new _DERUTCTime(param[key]);
        if (key == "gentime") return new _DERGeneralizedTime(param[key]);

        if (key == "seq") {
            var paramList = param[key];
            var a = [];
            for (var i = 0; i < paramList.length; i++) {
                var asn1Obj = _newObject(paramList[i]);
                a.push(asn1Obj);
            }
            return new _DERSequence({'array': a});
        }

        if (key == "set") {
            var paramList = param[key];
            var a = [];
            for (var i = 0; i < paramList.length; i++) {
                var asn1Obj = _newObject(paramList[i]);
                a.push(asn1Obj);
            }
            return new _DERSet({'array': a});
        }

        if (key == "tag") {
            var tagParam = param[key];
            if (Object.prototype.toString.call(tagParam) === '[object Array]' &&
                tagParam.length == 3) {
                var obj = _newObject(tagParam[2]);
                return new _DERTaggedObject({tag: tagParam[0],
                    explicit: tagParam[1],
                    obj: obj});
            } else {
                var newParam = {};
                if (tagParam.explicit !== undefined)
                    newParam.explicit = tagParam.explicit;
                if (tagParam.tag !== undefined)
                    newParam.tag = tagParam.tag;
                if (tagParam.obj === undefined)
                    throw "obj shall be specified for 'tag'.";
                newParam.obj = _newObject(tagParam.obj);
                return new _DERTaggedObject(newParam);
            }
        }
    };

    /**
     * get encoded hexadecimal string of ASN1Object specifed by JSON parameters
     * @name jsonToASN1HEX
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {Array} param JSON parameter to generate ASN1Object
     * @return hexadecimal string of ASN1Object
     * @since asn1 1.0.4
     * @description
     * As for ASN.1 object representation of JSON object,
     * please see {@link newObject}.
     * @example
     * jsonToASN1HEX({'prnstr': 'aaa'});
     */
    this.jsonToASN1HEX = function(param) {
        var asn1Obj = this.newObject(param);
        return asn1Obj.getEncodedHex();
    };
};

/**
 * get dot noted oid number string from hexadecimal value of OID
 * @name oidHexToInt
 * @memberOf KJUR.asn1.ASN1Util
 * @function
 * @param {String} hex hexadecimal value of object identifier
 * @return {String} dot noted string of object identifier
 * @since jsrsasign 4.8.3 asn1 1.0.7
 * @description
 * This static method converts from hexadecimal string representation of
 * ASN.1 value of object identifier to oid number string.
 * @example
 * KJUR.asn1.ASN1Util.oidHexToInt('550406') &rarr; "2.5.4.6"
 */
KJUR.asn1.ASN1Util.oidHexToInt = function(hex) {
    var s = "";
    var i01 = parseInt(hex.substr(0, 2), 16);
    var i0 = Math.floor(i01 / 40);
    var i1 = i01 % 40;
    var s = i0 + "." + i1;

    var binbuf = "";
    for (var i = 2; i < hex.length; i += 2) {
        var value = parseInt(hex.substr(i, 2), 16);
        var bin = ("00000000" + value.toString(2)).slice(- 8);
        binbuf = binbuf + bin.substr(1, 7);
        if (bin.substr(0, 1) == "0") {
            var bi = new BigInteger(binbuf, 2);
            s = s + "." + bi.toString(10);
            binbuf = "";
        }
    }
    return s;
};

/**
 * get hexadecimal value of object identifier from dot noted oid value
 * @name oidIntToHex
 * @memberOf KJUR.asn1.ASN1Util
 * @function
 * @param {String} oidString dot noted string of object identifier
 * @return {String} hexadecimal value of object identifier
 * @since jsrsasign 4.8.3 asn1 1.0.7
 * @description
 * This static method converts from object identifier value string.
 * to hexadecimal string representation of it.
 * @example
 * KJUR.asn1.ASN1Util.oidIntToHex("2.5.4.6") &rarr; "550406"
 */
KJUR.asn1.ASN1Util.oidIntToHex = function(oidString) {
    var itox = function(i) {
        var h = i.toString(16);
        if (h.length == 1) h = '0' + h;
        return h;
    };

    var roidtox = function(roid) {
        var h = '';
        var bi = new BigInteger(roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7) padLen = 0;
        var bPad = '';
        for (var i = 0; i < padLen; i++) bPad += '0';
        b = bPad + b;
        for (var i = 0; i < b.length - 1; i += 7) {
            var b8 = b.substr(i, 7);
            if (i != b.length - 7) b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };

    if (! oidString.match(/^[0-9.]+$/)) {
        throw "malformed oid string: " + oidString;
    }
    var h = '';
    var a = oidString.split('.');
    var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
    h += itox(i0);
    a.splice(0, 2);
    for (var i = 0; i < a.length; i++) {
        h += roidtox(a[i]);
    }
    return h;
};


// ********************************************************************
//  Abstract ASN.1 Classes
// ********************************************************************

// ********************************************************************

/**
 * base class for ASN.1 DER encoder object
 * @name KJUR.asn1.ASN1Object
 * @class base class for ASN.1 DER encoder object
 * @property {Boolean} isModified flag whether internal data was changed
 * @property {String} hTLV hexadecimal string of ASN.1 TLV
 * @property {String} hT hexadecimal string of ASN.1 TLV tag(T)
 * @property {String} hL hexadecimal string of ASN.1 TLV length(L)
 * @property {String} hV hexadecimal string of ASN.1 TLV value(V)
 * @description
 */
KJUR.asn1.ASN1Object = function() {
    var hV = '';

    /**
     * get hexadecimal ASN.1 TLV length(L) bytes from TLV value(V)
     * @name getLengthHexFromValue
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV length(L)
     */
    this.getLengthHexFromValue = function() {
        if (typeof this.hV == "undefined" || this.hV == null) {
            throw "this.hV is null or undefined.";
        }
        if (this.hV.length % 2 == 1) {
            throw "value hex must be even length: n=" + hV.length + ",v=" + this.hV;
        }
        var n = this.hV.length / 2;
        var hN = n.toString(16);
        if (hN.length % 2 == 1) {
            hN = "0" + hN;
        }
        if (n < 128) {
            return hN;
        } else {
            var hNlen = hN.length / 2;
            if (hNlen > 15) {
                throw "ASN.1 length too long to represent by 8x: n = " + n.toString(16);
            }
            var head = 128 + hNlen;
            return head.toString(16) + hN;
        }
    };

    /**
     * get hexadecimal string of ASN.1 TLV bytes
     * @name getEncodedHex
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV
     */
    this.getEncodedHex = function() {
        if (this.hTLV == null || this.isModified) {
            this.hV = this.getFreshValueHex();
            this.hL = this.getLengthHexFromValue();
            this.hTLV = this.hT + this.hL + this.hV;
            this.isModified = false;
            //alert("first time: " + this.hTLV);
        }
        return this.hTLV;
    };

    /**
     * get hexadecimal string of ASN.1 TLV value(V) bytes
     * @name getValueHex
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV value(V) bytes
     */
    this.getValueHex = function() {
        this.getEncodedHex();
        return this.hV;
    };

    this.getFreshValueHex = function() {
        return '';
    };
};

// == BEGIN DERAbstractString ================================================
/**
 * base class for ASN.1 DER string classes
 * @name KJUR.asn1.DERAbstractString
 * @class base class for ASN.1 DER string classes
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @property {String} s internal string of value
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERAbstractString = function(params) {
    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);

    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @return {String} string value of this string object
     */
    this.getString = function() {
        return this.s;
    };

    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @param {String} newS value by a string to set
     */
    this.setString = function(newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(this.s);
    };

    /**
     * set value by a hexadecimal string
     * @name setStringHex
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @param {String} newHexString value by a hexadecimal string to set
     */
    this.setStringHex = function(newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };

    this.getFreshValueHex = function() {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params == "string") {
            this.setString(params);
        } else if (typeof params['str'] != "undefined") {
            this.setString(params['str']);
        } else if (typeof params['hex'] != "undefined") {
            this.setStringHex(params['hex']);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERAbstractString, KJUR.asn1.ASN1Object);
// == END   DERAbstractString ================================================

// == BEGIN DERAbstractTime ==================================================
/**
 * base class for ASN.1 DER Generalized/UTCTime class
 * @name KJUR.asn1.DERAbstractTime
 * @class base class for ASN.1 DER Generalized/UTCTime class
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERAbstractTime = function(params) {
    KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);

    // --- PRIVATE METHODS --------------------
    this.localDateToUTC = function(d) {
        utc = d.getTime() + (d.getTimezoneOffset() * 60000);
        var utcDate = new Date(utc);
        return utcDate;
    };

    /*
     * format date string by Data object
     * @name formatDate
     * @memberOf KJUR.asn1.AbstractTime;
     * @param {Date} dateObject
     * @param {string} type 'utc' or 'gen'
     * @param {boolean} withMillis flag for with millisections or not
     * @description
     * 'withMillis' flag is supported from asn1 1.0.6.
     */
    this.formatDate = function(dateObject, type, withMillis) {
        var pad = this.zeroPadding;
        var d = this.localDateToUTC(dateObject);
        var year = String(d.getFullYear());
        if (type == 'utc') year = year.substr(2, 2);
        var month = pad(String(d.getMonth() + 1), 2);
        var day = pad(String(d.getDate()), 2);
        var hour = pad(String(d.getHours()), 2);
        var min = pad(String(d.getMinutes()), 2);
        var sec = pad(String(d.getSeconds()), 2);
        var s = year + month + day + hour + min + sec;
        if (withMillis === true) {
            var millis = d.getMilliseconds();
            if (millis != 0) {
                var sMillis = pad(String(millis), 3);
                sMillis = sMillis.replace(/[0]+$/, "");
                s = s + "." + sMillis;
            }
        }
        return s + "Z";
    };

    this.zeroPadding = function(s, len) {
        if (s.length >= len) return s;
        return new Array(len - s.length + 1).join('0') + s;
    };

    // --- PUBLIC METHODS --------------------
    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @return {String} string value of this time object
     */
    this.getString = function() {
        return this.s;
    };

    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @param {String} newS value by a string to set such like "130430235959Z"
     */
    this.setString = function(newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(newS);
    };

    /**
     * set value by a Date object
     * @name setByDateValue
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @param {Integer} year year of date (ex. 2013)
     * @param {Integer} month month of date between 1 and 12 (ex. 12)
     * @param {Integer} day day of month
     * @param {Integer} hour hours of date
     * @param {Integer} min minutes of date
     * @param {Integer} sec seconds of date
     */
    this.setByDateValue = function(year, month, day, hour, min, sec) {
        var dateObject = new Date(Date.UTC(year, month - 1, day, hour, min, sec, 0));
        this.setByDate(dateObject);
    };

    this.getFreshValueHex = function() {
        return this.hV;
    };
};
YAHOO.lang.extend(KJUR.asn1.DERAbstractTime, KJUR.asn1.ASN1Object);
// == END   DERAbstractTime ==================================================

// == BEGIN DERAbstractStructured ============================================
/**
 * base class for ASN.1 DER structured class
 * @name KJUR.asn1.DERAbstractStructured
 * @class base class for ASN.1 DER structured class
 * @property {Array} asn1Array internal array of ASN1Object
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERAbstractStructured = function(params) {
    KJUR.asn1.DERAbstractString.superclass.constructor.call(this);

    /**
     * set value by array of ASN1Object
     * @name setByASN1ObjectArray
     * @memberOf KJUR.asn1.DERAbstractStructured#
     * @function
     * @param {array} asn1ObjectArray array of ASN1Object to set
     */
    this.setByASN1ObjectArray = function(asn1ObjectArray) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array = asn1ObjectArray;
    };

    /**
     * append an ASN1Object to internal array
     * @name appendASN1Object
     * @memberOf KJUR.asn1.DERAbstractStructured#
     * @function
     * @param {ASN1Object} asn1Object to add
     */
    this.appendASN1Object = function(asn1Object) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array.push(asn1Object);
    };

    this.asn1Array = new Array();
    if (typeof params != "undefined") {
        if (typeof params['array'] != "undefined") {
            this.asn1Array = params['array'];
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERAbstractStructured, KJUR.asn1.ASN1Object);


// ********************************************************************
//  ASN.1 Object Classes
// ********************************************************************

// ********************************************************************
/**
 * class for ASN.1 DER Boolean
 * @name KJUR.asn1.DERBoolean
 * @class class for ASN.1 DER Boolean
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERBoolean = function() {
    KJUR.asn1.DERBoolean.superclass.constructor.call(this);
    this.hT = "01";
    this.hTLV = "0101ff";
};
YAHOO.lang.extend(KJUR.asn1.DERBoolean, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER Integer
 * @name KJUR.asn1.DERInteger
 * @class class for ASN.1 DER Integer
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>bigint - specify initial ASN.1 value(V) by BigInteger object</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERInteger = function(params) {
    KJUR.asn1.DERInteger.superclass.constructor.call(this);
    this.hT = "02";

    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DERInteger#
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */
    this.setByBigInteger = function(bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };

    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DERInteger
     * @function
     * @param {Integer} integer value to set
     */
    this.setByInteger = function(intValue) {
        var bi = new BigInteger(String(intValue), 10);
        this.setByBigInteger(bi);
    };

    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DERInteger#
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     * @example
     * new KJUR.asn1.DERInteger(123);
     * new KJUR.asn1.DERInteger({'int': 123});
     * new KJUR.asn1.DERInteger({'hex': '1fad'});
     */
    this.setValueHex = function(newHexString) {
        this.hV = newHexString;
    };

    this.getFreshValueHex = function() {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params['bigint'] != "undefined") {
            this.setByBigInteger(params['bigint']);
        } else if (typeof params['int'] != "undefined") {
            this.setByInteger(params['int']);
        } else if (typeof params == "number") {
            this.setByInteger(params);
        } else if (typeof params['hex'] != "undefined") {
            this.setValueHex(params['hex']);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERInteger, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER encoded BitString primitive
 * @name KJUR.asn1.DERBitString
 * @class class for ASN.1 DER encoded BitString primitive
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>bin - specify binary string (ex. '10111')</li>
 * <li>array - specify array of boolean (ex. [true,false,true,true])</li>
 * <li>hex - specify hexadecimal string of ASN.1 value(V) including unused bits</li>
 * <li>obj - specify {@link KJUR.asn1.ASN1Util.newObject}
 * argument for "BitString encapsulates" structure.</li>
 * </ul>
 * NOTE1: 'params' can be omitted.<br/>
 * NOTE2: 'obj' parameter have been supported since
 * asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).<br/>
 * @example
 * // default constructor
 * o = new KJUR.asn1.DERBitString();
 * // initialize with binary string
 * o = new KJUR.asn1.DERBitString({bin: "1011"});
 * // initialize with boolean array
 * o = new KJUR.asn1.DERBitString({array: [true,false,true,true]});
 * // initialize with hexadecimal string (04 is unused bits)
 * o = new KJUR.asn1.DEROctetString({hex: "04bac0"});
 * // initialize with ASN1Util.newObject argument for encapsulated
 * o = new KJUR.asn1.DERBitString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
 * // above generates a ASN.1 data like this:
 * // BIT STRING, encapsulates {
 * //   SEQUENCE {
 * //     INTEGER 3
 * //     PrintableString 'aaa'
 * //     }
 * //   }
 */
KJUR.asn1.DERBitString = function(params) {
    if (params !== undefined && typeof params.obj !== "undefined") {
        var o = KJUR.asn1.ASN1Util.newObject(params.obj);
        params.hex = "00" + o.getEncodedHex();
    }
    KJUR.asn1.DERBitString.superclass.constructor.call(this);
    this.hT = "03";

    /**
     * set ASN.1 value(V) by a hexadecimal string including unused bits
     * @name setHexValueIncludingUnusedBits
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {String} newHexStringIncludingUnusedBits
     */
    this.setHexValueIncludingUnusedBits = function(newHexStringIncludingUnusedBits) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = newHexStringIncludingUnusedBits;
    };

    /**
     * set ASN.1 value(V) by unused bit and hexadecimal string of value
     * @name setUnusedBitsAndHexValue
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {Integer} unusedBits
     * @param {String} hValue
     */
    this.setUnusedBitsAndHexValue = function(unusedBits, hValue) {
        if (unusedBits < 0 || 7 < unusedBits) {
            throw "unused bits shall be from 0 to 7: u = " + unusedBits;
        }
        var hUnusedBits = "0" + unusedBits;
        this.hTLV = null;
        this.isModified = true;
        this.hV = hUnusedBits + hValue;
    };

    /**
     * set ASN.1 DER BitString by binary string<br/>
     * @name setByBinaryString
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {String} binaryString binary value string (i.e. '10111')
     * @description
     * Its unused bits will be calculated automatically by length of
     * 'binaryValue'. <br/>
     * NOTE: Trailing zeros '0' will be ignored.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.setByBooleanArray("01011");
     */
    this.setByBinaryString = function(binaryString) {
        binaryString = binaryString.replace(/0+$/, '');
        var unusedBits = 8 - binaryString.length % 8;
        if (unusedBits == 8) unusedBits = 0;
        for (var i = 0; i <= unusedBits; i++) {
            binaryString += '0';
        }
        var h = '';
        for (var i = 0; i < binaryString.length - 1; i += 8) {
            var b = binaryString.substr(i, 8);
            var x = parseInt(b, 2).toString(16);
            if (x.length == 1) x = '0' + x;
            h += x;
        }
        this.hTLV = null;
        this.isModified = true;
        this.hV = '0' + unusedBits + h;
    };

    /**
     * set ASN.1 TLV value(V) by an array of boolean<br/>
     * @name setByBooleanArray
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {array} booleanArray array of boolean (ex. [true, false, true])
     * @description
     * NOTE: Trailing falses will be ignored in the ASN.1 DER Object.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.setByBooleanArray([false, true, false, true, true]);
     */
    this.setByBooleanArray = function(booleanArray) {
        var s = '';
        for (var i = 0; i < booleanArray.length; i++) {
            if (booleanArray[i] == true) {
                s += '1';
            } else {
                s += '0';
            }
        }
        this.setByBinaryString(s);
    };

    /**
     * generate an array of falses with specified length<br/>
     * @name newFalseArray
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {Integer} nLength length of array to generate
     * @return {array} array of boolean falses
     * @description
     * This static method may be useful to initialize boolean array.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.newFalseArray(3) &rarr; [false, false, false]
     */
    this.newFalseArray = function(nLength) {
        var a = new Array(nLength);
        for (var i = 0; i < nLength; i++) {
            a[i] = false;
        }
        return a;
    };

    this.getFreshValueHex = function() {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params == "string" && params.toLowerCase().match(/^[0-9a-f]+$/)) {
            this.setHexValueIncludingUnusedBits(params);
        } else if (typeof params['hex'] != "undefined") {
            this.setHexValueIncludingUnusedBits(params['hex']);
        } else if (typeof params['bin'] != "undefined") {
            this.setByBinaryString(params['bin']);
        } else if (typeof params['array'] != "undefined") {
            this.setByBooleanArray(params['array']);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERBitString, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER OctetString<br/>
 * @name KJUR.asn1.DEROctetString
 * @class class for ASN.1 DER OctetString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * This class provides ASN.1 OctetString simple type.<br/>
 * Supported "params" attributes are:
 * <ul>
 * <li>str - to set a string as a value</li>
 * <li>hex - to set a hexadecimal string as a value</li>
 * <li>obj - to set a encapsulated ASN.1 value by JSON object
 * which is defined in {@link KJUR.asn1.ASN1Util.newObject}</li>
 * </ul>
 * NOTE: A parameter 'obj' have been supported
 * for "OCTET STRING, encapsulates" structure.
 * since asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).
 * @see KJUR.asn1.DERAbstractString - superclass
 * @example
 * // default constructor
 * o = new KJUR.asn1.DEROctetString();
 * // initialize with string
 * o = new KJUR.asn1.DEROctetString({str: "aaa"});
 * // initialize with hexadecimal string
 * o = new KJUR.asn1.DEROctetString({hex: "616161"});
 * // initialize with ASN1Util.newObject argument
 * o = new KJUR.asn1.DEROctetString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
 * // above generates a ASN.1 data like this:
 * // OCTET STRING, encapsulates {
 * //   SEQUENCE {
 * //     INTEGER 3
 * //     PrintableString 'aaa'
 * //     }
 * //   }
 */
KJUR.asn1.DEROctetString = function(params) {
    if (params !== undefined && typeof params.obj !== "undefined") {
        var o = KJUR.asn1.ASN1Util.newObject(params.obj);
        params.hex = o.getEncodedHex();
    }
    KJUR.asn1.DEROctetString.superclass.constructor.call(this, params);
    this.hT = "04";
};
YAHOO.lang.extend(KJUR.asn1.DEROctetString, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER Null
 * @name KJUR.asn1.DERNull
 * @class class for ASN.1 DER Null
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */
KJUR.asn1.DERNull = function() {
    KJUR.asn1.DERNull.superclass.constructor.call(this);
    this.hT = "05";
    this.hTLV = "0500";
};
YAHOO.lang.extend(KJUR.asn1.DERNull, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER ObjectIdentifier
 * @name KJUR.asn1.DERObjectIdentifier
 * @class class for ASN.1 DER ObjectIdentifier
 * @param {Array} params associative array of parameters (ex. {'oid': '2.5.4.5'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>oid - specify initial ASN.1 value(V) by a oid string (ex. 2.5.4.13)</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERObjectIdentifier = function(params) {
    var itox = function(i) {
        var h = i.toString(16);
        if (h.length == 1) h = '0' + h;
        return h;
    };
    var roidtox = function(roid) {
        var h = '';
        var bi = new BigInteger(roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7) padLen = 0;
        var bPad = '';
        for (var i = 0; i < padLen; i++) bPad += '0';
        b = bPad + b;
        for (var i = 0; i < b.length - 1; i += 7) {
            var b8 = b.substr(i, 7);
            if (i != b.length - 7) b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };

    KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this);
    this.hT = "06";

    /**
     * set value by a hexadecimal string
     * @name setValueHex
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} newHexString hexadecimal value of OID bytes
     */
    this.setValueHex = function(newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };

    /**
     * set value by a OID string<br/>
     * @name setValueOidString
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} oidString OID string (ex. 2.5.4.13)
     * @example
     * o = new KJUR.asn1.DERObjectIdentifier();
     * o.setValueOidString("2.5.4.13");
     */
    this.setValueOidString = function(oidString) {
        if (! oidString.match(/^[0-9.]+$/)) {
            throw "malformed oid string: " + oidString;
        }
        var h = '';
        var a = oidString.split('.');
        var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
        h += itox(i0);
        a.splice(0, 2);
        for (var i = 0; i < a.length; i++) {
            h += roidtox(a[i]);
        }
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = h;
    };

    /**
     * set value by a OID name
     * @name setValueName
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} oidName OID name (ex. 'serverAuth')
     * @since 1.0.1
     * @description
     * OID name shall be defined in 'KJUR.asn1.x509.OID.name2oidList'.
     * Otherwise raise error.
     * @example
     * o = new KJUR.asn1.DERObjectIdentifier();
     * o.setValueName("serverAuth");
     */
    this.setValueName = function(oidName) {
        var oid = KJUR.asn1.x509.OID.name2oid(oidName);
        if (oid !== '') {
            this.setValueOidString(oid);
        } else {
            throw "DERObjectIdentifier oidName undefined: " + oidName;
        }
    };

    this.getFreshValueHex = function() {
        return this.hV;
    };

    if (params !== undefined) {
        if (typeof params === "string") {
            if (params.match(/^[0-2].[0-9.]+$/)) {
                this.setValueOidString(params);
            } else {
                this.setValueName(params);
            }
        } else if (params.oid !== undefined) {
            this.setValueOidString(params.oid);
        } else if (params.hex !== undefined) {
            this.setValueHex(params.hex);
        } else if (params.name !== undefined) {
            this.setValueName(params.name);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERObjectIdentifier, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER Enumerated
 * @name KJUR.asn1.DEREnumerated
 * @class class for ASN.1 DER Enumerated
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * @example
 * new KJUR.asn1.DEREnumerated(123);
 * new KJUR.asn1.DEREnumerated({int: 123});
 * new KJUR.asn1.DEREnumerated({hex: '1fad'});
 */
KJUR.asn1.DEREnumerated = function(params) {
    KJUR.asn1.DEREnumerated.superclass.constructor.call(this);
    this.hT = "0a";

    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */
    this.setByBigInteger = function(bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };

    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {Integer} integer value to set
     */
    this.setByInteger = function(intValue) {
        var bi = new BigInteger(String(intValue), 10);
        this.setByBigInteger(bi);
    };

    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     */
    this.setValueHex = function(newHexString) {
        this.hV = newHexString;
    };

    this.getFreshValueHex = function() {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params['int'] != "undefined") {
            this.setByInteger(params['int']);
        } else if (typeof params == "number") {
            this.setByInteger(params);
        } else if (typeof params['hex'] != "undefined") {
            this.setValueHex(params['hex']);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DEREnumerated, KJUR.asn1.ASN1Object);

// ********************************************************************
/**
 * class for ASN.1 DER UTF8String
 * @name KJUR.asn1.DERUTF8String
 * @class class for ASN.1 DER UTF8String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERUTF8String = function(params) {
    KJUR.asn1.DERUTF8String.superclass.constructor.call(this, params);
    this.hT = "0c";
};
YAHOO.lang.extend(KJUR.asn1.DERUTF8String, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER NumericString
 * @name KJUR.asn1.DERNumericString
 * @class class for ASN.1 DER NumericString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERNumericString = function(params) {
    KJUR.asn1.DERNumericString.superclass.constructor.call(this, params);
    this.hT = "12";
};
YAHOO.lang.extend(KJUR.asn1.DERNumericString, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER PrintableString
 * @name KJUR.asn1.DERPrintableString
 * @class class for ASN.1 DER PrintableString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERPrintableString = function(params) {
    KJUR.asn1.DERPrintableString.superclass.constructor.call(this, params);
    this.hT = "13";
};
YAHOO.lang.extend(KJUR.asn1.DERPrintableString, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER TeletexString
 * @name KJUR.asn1.DERTeletexString
 * @class class for ASN.1 DER TeletexString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERTeletexString = function(params) {
    KJUR.asn1.DERTeletexString.superclass.constructor.call(this, params);
    this.hT = "14";
};
YAHOO.lang.extend(KJUR.asn1.DERTeletexString, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER IA5String
 * @name KJUR.asn1.DERIA5String
 * @class class for ASN.1 DER IA5String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */
KJUR.asn1.DERIA5String = function(params) {
    KJUR.asn1.DERIA5String.superclass.constructor.call(this, params);
    this.hT = "16";
};
YAHOO.lang.extend(KJUR.asn1.DERIA5String, KJUR.asn1.DERAbstractString);

// ********************************************************************
/**
 * class for ASN.1 DER UTCTime
 * @name KJUR.asn1.DERUTCTime
 * @class class for ASN.1 DER UTCTime
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * <h4>EXAMPLES</h4>
 * @example
 * d1 = new KJUR.asn1.DERUTCTime();
 * d1.setString('130430125959Z');
 *
 * d2 = new KJUR.asn1.DERUTCTime({'str': '130430125959Z'});
 * d3 = new KJUR.asn1.DERUTCTime({'date': new Date(Date.UTC(2015, 0, 31, 0, 0, 0, 0))});
 * d4 = new KJUR.asn1.DERUTCTime('130430125959Z');
 */
KJUR.asn1.DERUTCTime = function(params) {
    KJUR.asn1.DERUTCTime.superclass.constructor.call(this, params);
    this.hT = "17";

    /**
     * set value by a Date object<br/>
     * @name setByDate
     * @memberOf KJUR.asn1.DERUTCTime#
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * o = new KJUR.asn1.DERUTCTime();
     * o.setByDate(new Date("2016/12/31"));
     */
    this.setByDate = function(dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'utc');
        this.hV = stohex(this.s);
    };

    this.getFreshValueHex = function() {
        if (typeof this.date == "undefined" && typeof this.s == "undefined") {
            this.date = new Date();
            this.s = this.formatDate(this.date, 'utc');
            this.hV = stohex(this.s);
        }
        return this.hV;
    };

    if (params !== undefined) {
        if (params.str !== undefined) {
            this.setString(params.str);
        } else if (typeof params == "string" && params.match(/^[0-9]{12}Z$/)) {
            this.setString(params);
        } else if (params.hex !== undefined) {
            this.setStringHex(params.hex);
        } else if (params.date !== undefined) {
            this.setByDate(params.date);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERUTCTime, KJUR.asn1.DERAbstractTime);

// ********************************************************************
/**
 * class for ASN.1 DER GeneralizedTime
 * @name KJUR.asn1.DERGeneralizedTime
 * @class class for ASN.1 DER GeneralizedTime
 * @param {Array} params associative array of parameters (ex. {'str': '20130430235959Z'})
 * @property {Boolean} withMillis flag to show milliseconds or not
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'20130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * <li>millis - specify flag to show milliseconds (from 1.0.6)</li>
 * </ul>
 * NOTE1: 'params' can be omitted.
 * NOTE2: 'withMillis' property is supported from asn1 1.0.6.
 */
KJUR.asn1.DERGeneralizedTime = function(params) {
    KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this, params);
    this.hT = "18";
    this.withMillis = false;

    /**
     * set value by a Date object
     * @name setByDate
     * @memberOf KJUR.asn1.DERGeneralizedTime#
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * When you specify UTC time, use 'Date.UTC' method like this:<br/>
     * o1 = new DERUTCTime();
     * o1.setByDate(date);
     *
     * date = new Date(Date.UTC(2015, 0, 31, 23, 59, 59, 0)); #2015JAN31 23:59:59
     */
    this.setByDate = function(dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'gen', this.withMillis);
        this.hV = stohex(this.s);
    };

    this.getFreshValueHex = function() {
        if (this.date === undefined && this.s === undefined) {
            this.date = new Date();
            this.s = this.formatDate(this.date, 'gen', this.withMillis);
            this.hV = stohex(this.s);
        }
        return this.hV;
    };

    if (params !== undefined) {
        if (params.str !== undefined) {
            this.setString(params.str);
        } else if (typeof params == "string" && params.match(/^[0-9]{14}Z$/)) {
            this.setString(params);
        } else if (params.hex !== undefined) {
            this.setStringHex(params.hex);
        } else if (params.date !== undefined) {
            this.setByDate(params.date);
        }
        if (params.millis === true) {
            this.withMillis = true;
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERGeneralizedTime, KJUR.asn1.DERAbstractTime);

// ********************************************************************
/**
 * class for ASN.1 DER Sequence
 * @name KJUR.asn1.DERSequence
 * @class class for ASN.1 DER Sequence
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */
KJUR.asn1.DERSequence = function(params) {
    KJUR.asn1.DERSequence.superclass.constructor.call(this, params);
    this.hT = "30";
    this.getFreshValueHex = function() {
        var h = '';
        for (var i = 0; i < this.asn1Array.length; i++) {
            var asn1Obj = this.asn1Array[i];
            h += asn1Obj.getEncodedHex();
        }
        this.hV = h;
        return this.hV;
    };
};
YAHOO.lang.extend(KJUR.asn1.DERSequence, KJUR.asn1.DERAbstractStructured);

// ********************************************************************
/**
 * class for ASN.1 DER Set
 * @name KJUR.asn1.DERSet
 * @class class for ASN.1 DER Set
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * <li>sortflag - flag for sort (default: true). ASN.1 BER is not sorted in 'SET OF'.</li>
 * </ul>
 * NOTE1: 'params' can be omitted.<br/>
 * NOTE2: sortflag is supported since 1.0.5.
 */
KJUR.asn1.DERSet = function(params) {
    KJUR.asn1.DERSet.superclass.constructor.call(this, params);
    this.hT = "31";
    this.sortFlag = true; // item shall be sorted only in ASN.1 DER
    this.getFreshValueHex = function() {
        var a = new Array();
        for (var i = 0; i < this.asn1Array.length; i++) {
            var asn1Obj = this.asn1Array[i];
            a.push(asn1Obj.getEncodedHex());
        }
        if (this.sortFlag == true) a.sort();
        this.hV = a.join('');
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params.sortflag != "undefined" &&
            params.sortflag == false)
            this.sortFlag = false;
    }
};
YAHOO.lang.extend(KJUR.asn1.DERSet, KJUR.asn1.DERAbstractStructured);

// ********************************************************************
/**
 * class for ASN.1 DER TaggedObject
 * @name KJUR.asn1.DERTaggedObject
 * @class class for ASN.1 DER TaggedObject
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * Parameter 'tagNoNex' is ASN.1 tag(T) value for this object.
 * For example, if you find '[1]' tag in a ASN.1 dump,
 * 'tagNoHex' will be 'a1'.
 * <br/>
 * As for optional argument 'params' for constructor, you can specify *ANY* of
 * following properties:
 * <ul>
 * <li>explicit - specify true if this is explicit tag otherwise false
 *     (default is 'true').</li>
 * <li>tag - specify tag (default is 'a0' which means [0])</li>
 * <li>obj - specify ASN1Object which is tagged</li>
 * </ul>
 * @example
 * d1 = new KJUR.asn1.DERUTF8String({'str':'a'});
 * d2 = new KJUR.asn1.DERTaggedObject({'obj': d1});
 * hex = d2.getEncodedHex();
 */
KJUR.asn1.DERTaggedObject = function(params) {
    KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);
    this.hT = "a0";
    this.hV = '';
    this.isExplicit = true;
    this.asn1Object = null;

    /**
     * set value by an ASN1Object
     * @name setString
     * @memberOf KJUR.asn1.DERTaggedObject#
     * @function
     * @param {Boolean} isExplicitFlag flag for explicit/implicit tag
     * @param {Integer} tagNoHex hexadecimal string of ASN.1 tag
     * @param {ASN1Object} asn1Object ASN.1 to encapsulate
     */
    this.setASN1Object = function(isExplicitFlag, tagNoHex, asn1Object) {
        this.hT = tagNoHex;
        this.isExplicit = isExplicitFlag;
        this.asn1Object = asn1Object;
        if (this.isExplicit) {
            this.hV = this.asn1Object.getEncodedHex();
            this.hTLV = null;
            this.isModified = true;
        } else {
            this.hV = null;
            this.hTLV = asn1Object.getEncodedHex();
            this.hTLV = this.hTLV.replace(/^../, tagNoHex);
            this.isModified = false;
        }
    };

    this.getFreshValueHex = function() {
        return this.hV;
    };

    if (typeof params != "undefined") {
        if (typeof params['tag'] != "undefined") {
            this.hT = params['tag'];
        }
        if (typeof params['explicit'] != "undefined") {
            this.isExplicit = params['explicit'];
        }
        if (typeof params['obj'] != "undefined") {
            this.asn1Object = params['obj'];
            this.setASN1Object(this.isExplicit, this.hT, this.asn1Object);
        }
    }
};
YAHOO.lang.extend(KJUR.asn1.DERTaggedObject, KJUR.asn1.ASN1Object);

/**
 * Create a new JSEncryptRSAKey that extends Tom Wu's RSA key object.
 * This object is just a decorator for parsing the key parameter
 * @param {string|Object} key - The key in string format, or an object containing
 * the parameters needed to build a RSAKey object.
 * @constructor
 */
var JSEncryptRSAKey = /** @class */ (function (_super) {
    __extends(JSEncryptRSAKey, _super);
    function JSEncryptRSAKey(key) {
        var _this = _super.call(this) || this;
        // Call the super constructor.
        //  RSAKey.call(this);
        // If a key key was provided.
        if (key) {
            // If this is a string...
            if (typeof key === "string") {
                _this.parseKey(key);
            }
            else if (JSEncryptRSAKey.hasPrivateKeyProperty(key) ||
                JSEncryptRSAKey.hasPublicKeyProperty(key)) {
                // Set the values for the key.
                _this.parsePropertiesFrom(key);
            }
        }
        return _this;
    }
    /**
     * Method to parse a pem encoded string containing both a public or private key.
     * The method will translate the pem encoded string in a der encoded string and
     * will parse private key and public key parameters. This method accepts public key
     * in the rsaencryption pkcs #1 format (oid: 1.2.840.113549.1.1.1).
     *
     * @todo Check how many rsa formats use the same format of pkcs #1.
     *
     * The format is defined as:
     * PublicKeyInfo ::= SEQUENCE {
     *   algorithm       AlgorithmIdentifier,
     *   PublicKey       BIT STRING
     * }
     * Where AlgorithmIdentifier is:
     * AlgorithmIdentifier ::= SEQUENCE {
     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
     * }
     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
     * RSAPublicKey ::= SEQUENCE {
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER   -- e
     * }
     * it's possible to examine the structure of the keys obtained from openssl using
     * an asn.1 dumper as the one used here to parse the components: http://lapo.it/asn1js/
     * @argument {string} pem the pem encoded string, can include the BEGIN/END header/footer
     * @private
     */
    JSEncryptRSAKey.prototype.parseKey = function (pem) {
        try {
            var modulus = 0;
            var public_exponent = 0;
            var reHex = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/;
            var der = reHex.test(pem) ? Hex.decode(pem) : Base64.unarmor(pem);
            var asn1 = ASN1.decode(der);
            // Fixes a bug with OpenSSL 1.0+ private keys
            if (asn1.sub.length === 3) {
                asn1 = asn1.sub[2].sub[0];
            }
            if (asn1.sub.length === 9) {
                // Parse the private key.
                modulus = asn1.sub[1].getHexStringValue(); // bigint
                this.n = parseBigInt(modulus, 16);
                public_exponent = asn1.sub[2].getHexStringValue(); // int
                this.e = parseInt(public_exponent, 16);
                var private_exponent = asn1.sub[3].getHexStringValue(); // bigint
                this.d = parseBigInt(private_exponent, 16);
                var prime1 = asn1.sub[4].getHexStringValue(); // bigint
                this.p = parseBigInt(prime1, 16);
                var prime2 = asn1.sub[5].getHexStringValue(); // bigint
                this.q = parseBigInt(prime2, 16);
                var exponent1 = asn1.sub[6].getHexStringValue(); // bigint
                this.dmp1 = parseBigInt(exponent1, 16);
                var exponent2 = asn1.sub[7].getHexStringValue(); // bigint
                this.dmq1 = parseBigInt(exponent2, 16);
                var coefficient = asn1.sub[8].getHexStringValue(); // bigint
                this.coeff = parseBigInt(coefficient, 16);
            }
            else if (asn1.sub.length === 2) {
                // Parse the public key.
                var bit_string = asn1.sub[1];
                var sequence = bit_string.sub[0];
                modulus = sequence.sub[0].getHexStringValue();
                this.n = parseBigInt(modulus, 16);
                public_exponent = sequence.sub[1].getHexStringValue();
                this.e = parseInt(public_exponent, 16);
            }
            else {
                return false;
            }
            return true;
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Translate rsa parameters in a hex encoded string representing the rsa key.
     *
     * The translation follow the ASN.1 notation :
     * RSAPrivateKey ::= SEQUENCE {
     *   version           Version,
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER,  -- e
     *   privateExponent   INTEGER,  -- d
     *   prime1            INTEGER,  -- p
     *   prime2            INTEGER,  -- q
     *   exponent1         INTEGER,  -- d mod (p1)
     *   exponent2         INTEGER,  -- d mod (q-1)
     *   coefficient       INTEGER,  -- (inverse of q) mod p
     * }
     * @returns {string}  DER Encoded String representing the rsa private key
     * @private
     */
    JSEncryptRSAKey.prototype.getPrivateBaseKey = function () {
        var options = {
            array: [
                new KJUR.asn1.DERInteger({ int: 0 }),
                new KJUR.asn1.DERInteger({ bigint: this.n }),
                new KJUR.asn1.DERInteger({ int: this.e }),
                new KJUR.asn1.DERInteger({ bigint: this.d }),
                new KJUR.asn1.DERInteger({ bigint: this.p }),
                new KJUR.asn1.DERInteger({ bigint: this.q }),
                new KJUR.asn1.DERInteger({ bigint: this.dmp1 }),
                new KJUR.asn1.DERInteger({ bigint: this.dmq1 }),
                new KJUR.asn1.DERInteger({ bigint: this.coeff })
            ]
        };
        var seq = new KJUR.asn1.DERSequence(options);
        return seq.getEncodedHex();
    };
    /**
     * base64 (pem) encoded version of the DER encoded representation
     * @returns {string} pem encoded representation without header and footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPrivateBaseKeyB64 = function () {
        return hex2b64(this.getPrivateBaseKey());
    };
    /**
     * Translate rsa parameters in a hex encoded string representing the rsa public key.
     * The representation follow the ASN.1 notation :
     * PublicKeyInfo ::= SEQUENCE {
     *   algorithm       AlgorithmIdentifier,
     *   PublicKey       BIT STRING
     * }
     * Where AlgorithmIdentifier is:
     * AlgorithmIdentifier ::= SEQUENCE {
     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
     * }
     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
     * RSAPublicKey ::= SEQUENCE {
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER   -- e
     * }
     * @returns {string} DER Encoded String representing the rsa public key
     * @private
     */
    JSEncryptRSAKey.prototype.getPublicBaseKey = function () {
        var first_sequence = new KJUR.asn1.DERSequence({
            array: [
                new KJUR.asn1.DERObjectIdentifier({ oid: "1.2.840.113549.1.1.1" }),
                new KJUR.asn1.DERNull()
            ]
        });
        var second_sequence = new KJUR.asn1.DERSequence({
            array: [
                new KJUR.asn1.DERInteger({ bigint: this.n }),
                new KJUR.asn1.DERInteger({ int: this.e })
            ]
        });
        var bit_string = new KJUR.asn1.DERBitString({
            hex: "00" + second_sequence.getEncodedHex()
        });
        var seq = new KJUR.asn1.DERSequence({
            array: [
                first_sequence,
                bit_string
            ]
        });
        return seq.getEncodedHex();
    };
    /**
     * base64 (pem) encoded version of the DER encoded representation
     * @returns {string} pem encoded representation without header and footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPublicBaseKeyB64 = function () {
        return hex2b64(this.getPublicBaseKey());
    };
    /**
     * wrap the string in block of width chars. The default value for rsa keys is 64
     * characters.
     * @param {string} str the pem encoded string without header and footer
     * @param {Number} [width=64] - the length the string has to be wrapped at
     * @returns {string}
     * @private
     */
    JSEncryptRSAKey.wordwrap = function (str, width) {
        width = width || 64;
        if (!str) {
            return str;
        }
        var regex = "(.{1," + width + "})( +|$\n?)|(.{1," + width + "})";
        return str.match(RegExp(regex, "g")).join("\n");
    };
    /**
     * Retrieve the pem encoded private key
     * @returns {string} the pem encoded private key with header/footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPrivateKey = function () {
        var key = "-----BEGIN RSA PRIVATE KEY-----\n";
        key += JSEncryptRSAKey.wordwrap(this.getPrivateBaseKeyB64()) + "\n";
        key += "-----END RSA PRIVATE KEY-----";
        return key;
    };
    /**
     * Retrieve the pem encoded public key
     * @returns {string} the pem encoded public key with header/footer
     * @public
     */
    JSEncryptRSAKey.prototype.getPublicKey = function () {
        var key = "-----BEGIN PUBLIC KEY-----\n";
        key += JSEncryptRSAKey.wordwrap(this.getPublicBaseKeyB64()) + "\n";
        key += "-----END PUBLIC KEY-----";
        return key;
    };
    /**
     * Check if the object contains the necessary parameters to populate the rsa modulus
     * and public exponent parameters.
     * @param {Object} [obj={}] - An object that may contain the two public key
     * parameters
     * @returns {boolean} true if the object contains both the modulus and the public exponent
     * properties (n and e)
     * @todo check for types of n and e. N should be a parseable bigInt object, E should
     * be a parseable integer number
     * @private
     */
    JSEncryptRSAKey.hasPublicKeyProperty = function (obj) {
        obj = obj || {};
        return (obj.hasOwnProperty("n") &&
            obj.hasOwnProperty("e"));
    };
    /**
     * Check if the object contains ALL the parameters of an RSA key.
     * @param {Object} [obj={}] - An object that may contain nine rsa key
     * parameters
     * @returns {boolean} true if the object contains all the parameters needed
     * @todo check for types of the parameters all the parameters but the public exponent
     * should be parseable bigint objects, the public exponent should be a parseable integer number
     * @private
     */
    JSEncryptRSAKey.hasPrivateKeyProperty = function (obj) {
        obj = obj || {};
        return (obj.hasOwnProperty("n") &&
            obj.hasOwnProperty("e") &&
            obj.hasOwnProperty("d") &&
            obj.hasOwnProperty("p") &&
            obj.hasOwnProperty("q") &&
            obj.hasOwnProperty("dmp1") &&
            obj.hasOwnProperty("dmq1") &&
            obj.hasOwnProperty("coeff"));
    };
    /**
     * Parse the properties of obj in the current rsa object. Obj should AT LEAST
     * include the modulus and public exponent (n, e) parameters.
     * @param {Object} obj - the object containing rsa parameters
     * @private
     */
    JSEncryptRSAKey.prototype.parsePropertiesFrom = function (obj) {
        this.n = obj.n;
        this.e = obj.e;
        if (obj.hasOwnProperty("d")) {
            this.d = obj.d;
            this.p = obj.p;
            this.q = obj.q;
            this.dmp1 = obj.dmp1;
            this.dmq1 = obj.dmq1;
            this.coeff = obj.coeff;
        }
    };
    return JSEncryptRSAKey;
}(RSAKey));

/**
 *
 * @param {Object} [options = {}] - An object to customize JSEncrypt behaviour
 * possible parameters are:
 * - default_key_size        {number}  default: 1024 the key size in bit
 * - default_public_exponent {string}  default: '010001' the hexadecimal representation of the public exponent
 * - log                     {boolean} default: false whether log warn/error or not
 * @constructor
 */
var JSEncrypt = /** @class */ (function () {
    function JSEncrypt(options) {
        options = options || {};
        this.default_key_size = parseInt(options.default_key_size, 10) || 1024;
        this.default_public_exponent = options.default_public_exponent || "010001"; // 65537 default openssl public exponent for rsa key type
        this.log = options.log || false;
        // The private and public key.
        this.key = null;
    }
    /**
     * Method to set the rsa key parameter (one method is enough to set both the public
     * and the private key, since the private key contains the public key paramenters)
     * Log a warning if logs are enabled
     * @param {Object|string} key the pem encoded string or an object (with or without header/footer)
     * @public
     */
    JSEncrypt.prototype.setKey = function (key) {
        if (this.log && this.key) {
            console.warn("A key was already set, overriding existing.");
        }
        this.key = new JSEncryptRSAKey(key);
    };
    /**
     * Proxy method for setKey, for api compatibility
     * @see setKey
     * @public
     */
    JSEncrypt.prototype.setPrivateKey = function (privkey) {
        // Create the key.
        this.setKey(privkey);
    };
    /**
     * Proxy method for setKey, for api compatibility
     * @see setKey
     * @public
     */
    JSEncrypt.prototype.setPublicKey = function (pubkey) {
        // Sets the public key.
        this.setKey(pubkey);
    };
    /**
     * Proxy method for RSAKey object's decrypt, decrypt the string using the private
     * components of the rsa key object. Note that if the object was not set will be created
     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
     * @param {string} str base64 encoded crypted string to decrypt
     * @return {string} the decrypted string
     * @public
     */
    JSEncrypt.prototype.decrypt = function (str) {
        // Return the decrypted string.
        try {
            return this.getKey().decrypt(b64tohex(str));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's encrypt, encrypt the string using the public
     * components of the rsa key object. Note that if the object was not set will be created
     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
     * @param {string} str the string to encrypt
     * @return {string} the encrypted string encoded in base64
     * @public
     */
    JSEncrypt.prototype.encrypt = function (str) {
        // Return the encrypted string.
        try {
            return hex2b64(this.getKey().encrypt(str));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's sign.
     * @param {string} str the string to sign
     * @param {function} digestMethod hash method
     * @param {string} digestName the name of the hash algorithm
     * @return {string} the signature encoded in base64
     * @public
     */
    JSEncrypt.prototype.sign = function (str, digestMethod, digestName) {
        // return the RSA signature of 'str' in 'hex' format.
        try {
            return hex2b64(this.getKey().sign(str, digestMethod, digestName));
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's verify.
     * @param {string} str the string to verify
     * @param {string} signature the signature encoded in base64 to compare the string to
     * @param {function} digestMethod hash method
     * @return {boolean} whether the data and signature match
     * @public
     */
    JSEncrypt.prototype.verify = function (str, signature, digestMethod) {
        // Return the decrypted 'digest' of the signature.
        try {
            return this.getKey().verify(str, b64tohex(signature), digestMethod);
        }
        catch (ex) {
            return false;
        }
    };
    /**
     * Getter for the current JSEncryptRSAKey object. If it doesn't exists a new object
     * will be created and returned
     * @param {callback} [cb] the callback to be called if we want the key to be generated
     * in an async fashion
     * @returns {JSEncryptRSAKey} the JSEncryptRSAKey object
     * @public
     */
    JSEncrypt.prototype.getKey = function (cb) {
        // Only create new if it does not exist.
        if (!this.key) {
            // Get a new private key.
            this.key = new JSEncryptRSAKey();
            if (cb && {}.toString.call(cb) === "[object Function]") {
                this.key.generateAsync(this.default_key_size, this.default_public_exponent, cb);
                return;
            }
            // Generate the key.
            this.key.generate(this.default_key_size, this.default_public_exponent);
        }
        return this.key;
    };
    /**
     * Returns the pem encoded representation of the private key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the private key WITH header and footer
     * @public
     */
    JSEncrypt.prototype.getPrivateKey = function () {
        // Return the private representation of this key.
        return this.getKey().getPrivateKey();
    };
    /**
     * Returns the pem encoded representation of the private key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the private key WITHOUT header and footer
     * @public
     */
    JSEncrypt.prototype.getPrivateKeyB64 = function () {
        // Return the private representation of this key.
        return this.getKey().getPrivateBaseKeyB64();
    };
    /**
     * Returns the pem encoded representation of the public key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the public key WITH header and footer
     * @public
     */
    JSEncrypt.prototype.getPublicKey = function () {
        // Return the private representation of this key.
        return this.getKey().getPublicKey();
    };
    /**
     * Returns the pem encoded representation of the public key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the public key WITHOUT header and footer
     * @public
     */
    JSEncrypt.prototype.getPublicKeyB64 = function () {
        // Return the private representation of this key.
        return this.getKey().getPublicBaseKeyB64();
    };
    JSEncrypt.version = "3.0.0-rc.1";
    return JSEncrypt;
}());

window.JSEncrypt = JSEncrypt;

exports.JSEncrypt = JSEncrypt;
exports.default = JSEncrypt;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearPrepaidCodes = exports.getPrepaidAvailableAmount = exports.getPrepaidTotalAmount = exports.getPrepaidCodes = exports.setPrepaidAvailableAmount = exports.setPrepaidBoundAmount = undefined;

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 预付码
 * 已验证 但是未绑定到订单的 存储在 sessionStorage，关闭浏览器后销毁
 * 已经绑定在订单的 存储在 localStorage，下次进入还需要展示
 */

var BOUND_PREFIX = 'PREPAID_BOUND_AMOUNT_';
var CODE_PREFIX = 'PREPAID_CODES_';
var AVAILABLE_PREFIX = 'PREPAID_AVAILABLE_AMOUNT_';

// 设置已和订单绑定的预付金金额
var setPrepaidBoundAmount = exports.setPrepaidBoundAmount = function setPrepaidBoundAmount(orderId, amount) {
  return localStorage.setItem('' + BOUND_PREFIX + orderId, amount);
};

// 设置已和订单绑定的可用的预付金金额
var setPrepaidAvailableAmount = exports.setPrepaidAvailableAmount = function setPrepaidAvailableAmount(orderId, amount) {
  return localStorage.setItem('' + AVAILABLE_PREFIX + orderId, amount);
};

var getPrepaidCodes = exports.getPrepaidCodes = function getPrepaidCodes(shopId) {
  return JSON.parse(sessionStorage.getItem('' + CODE_PREFIX + shopId) || '[]');
};

// 获取总的预付金的总额
var getPrepaidTotalAmount = exports.getPrepaidTotalAmount = function getPrepaidTotalAmount(shopId, orderId) {
  var freshAmount = getPrepaidCodes(shopId).reduce(function (total, item) {
    return total + Number(item.prepayAmount);
  }, 0);
  var boundAmount = Number(localStorage.getItem('' + BOUND_PREFIX + orderId));

  return freshAmount + boundAmount;
};

// 获取可用的总的预付金金额
var getPrepaidAvailableAmount = exports.getPrepaidAvailableAmount = function getPrepaidAvailableAmount(shopId, orderId) {
  var boundAmount = Number(localStorage.getItem('' + AVAILABLE_PREFIX + orderId));
  var freshAmount = getPrepaidCodes(shopId).reduce(function (total, item) {
    return total + Number(item.prepayAmount);
  }, 0);

  return freshAmount + boundAmount;
};

var clearPrepaidCodes = exports.clearPrepaidCodes = function clearPrepaidCodes(shopId) {
  var codes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (!codes.length) {
    sessionStorage.removeItem('' + CODE_PREFIX + shopId);
  } else {
    var oldCodes = getPrepaidCodes(shopId);
    var update = oldCodes.filter(function (item) {
      return codes.indexOf(item.prepayCode) === -1;
    });

    sessionStorage.setItem('' + CODE_PREFIX + shopId, (0, _stringify2.default)(update));
  }
};

/***/ }),
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/receive-coupons.png";

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helper = __webpack_require__(16);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _dish = __webpack_require__(506);

var _dish2 = _interopRequireDefault(_dish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var Immutable = __webpack_require__(77);
var classnames = __webpack_require__(50);
var ActiveSelect = __webpack_require__(455);
var DishPropsOption = __webpack_require__(621);

__webpack_require__(624);

module.exports = React.createClass({
  displayName: 'DishPropsSelect',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    dishData: React.PropTypes.object,
    sameRuleList: React.PropTypes.array,
    checkedRuleIds: React.PropTypes.object,
    disabledRuleIdMap: React.PropTypes.object,
    onSelectPropsOption: React.PropTypes.func,
    onDishRuleChecked: React.PropTypes.func,
    showMemberPriceInfo: React.PropTypes.bool
  },
  onSelectPropsOption: function onSelectPropsOption(recipeData, optionData) {
    this.props.onSelectPropsOption(recipeData, optionData);
  },
  onDishRuleChecked: function onDishRuleChecked(categoryId, id) {
    var onDishRuleChecked = this.props.onDishRuleChecked;

    onDishRuleChecked(categoryId, id);
  },
  getChangeShowDataItemsOrder: function getChangeShowDataItemsOrder(order) {
    if (Array.isArray(order) && order.length) {
      return order[0].count;
    } else if (Array.isArray(order) && !order.length) {
      return null;
    }

    return order;
  },
  buildRule: function buildRule(dish) {
    var _this = this;

    var _props = this.props,
        _props$sameRuleList = _props.sameRuleList,
        sameRuleList = _props$sameRuleList === undefined ? [] : _props$sameRuleList,
        _props$checkedRuleIds = _props.checkedRuleIds,
        checkedRuleIds = _props$checkedRuleIds === undefined ? {} : _props$checkedRuleIds,
        _props$disabledRuleId = _props.disabledRuleIdMap,
        disabledRuleIdMap = _props$disabledRuleId === undefined ? {} : _props$disabledRuleId;

    if (!sameRuleList.length) {
      return false;
    }

    var rules = sameRuleList;
    var buildRuleProperties = function buildRuleProperties(rule) {
      var properties = rule.list,
          categoryId = rule.id;

      var propertyMap = {};
      // 已经有排序了的
      return properties.sort(function (a, b) {
        return a.sort - b.sort;
      }).map(function (prop) {
        if (propertyMap.hasOwnProperty(prop.id)) {
          return false;
        }

        var id = prop.id;

        var checked = checkedRuleIds[categoryId] === id;
        var disabled = disabledRuleIdMap[id];
        propertyMap[prop.id] = true;
        return React.createElement(
          'button',
          {
            className: classnames('dish-porps-option', { 'is-checked': checked, 'is-disable': disabled }),
            onTouchTap: function onTouchTap(evt) {
              return _this.onDishRuleChecked(categoryId, id);
            },
            key: id
          },
          React.createElement(
            'span',
            { className: 'extra' },
            prop.reprice ? '+' + sessionStorage.getItem('currency') + prop.reprice : false
          ),
          React.createElement(
            'span',
            { className: 'name ellipsis' },
            prop.name
          )
        );
      });
    };
    return rules.map(function (ruleItem) {
      var id = ruleItem.id;

      return React.createElement(
        'div',
        { className: 'recipe-group clearfix', key: id },
        React.createElement(
          'span',
          { className: 'recipe-title' },
          ruleItem.name + '(' + (0, _helper.formatMessage)(_dish2.default.dishrequired) + ')'
        ),
        buildRuleProperties(ruleItem)
      );
    });
  },
  buildRecipe: function buildRecipe(props) {
    var _this2 = this;

    var showMemberPriceInfo = this.props.showMemberPriceInfo;

    var recipesData = props.filter(function (propData) {
      return propData.type === 1;
    });
    if (recipesData.length === 0) {
      return false;
    }

    return recipesData.map(function (recipeData) {
      return React.createElement(
        'div',
        { className: 'recipe-group', key: recipeData.id },
        React.createElement(
          'span',
          { className: 'recipe-title' },
          recipeData.name,
          recipeData.isMandatory === 1 && React.createElement(
            'span',
            null,
            '(',
            (0, _helper.formatMessage)(_dish2.default.dishrequired),
            ')'
          )
        ),
        React.createElement(ActiveSelect, {
          className: 'clearfix',
          optionsData: recipeData.properties,
          sendSubComponentParam: { showMemberPriceInfo: showMemberPriceInfo },
          optionComponent: DishPropsOption,
          onSelectOption: function onSelectOption(evt, optionData) {
            return _this2.onSelectPropsOption(recipeData, optionData);
          }
        })
      );
    });
  },
  buildNote: function buildNote(props) {
    var _this3 = this;

    var showMemberPriceInfo = this.props.showMemberPriceInfo;

    var notesData = props.filter(function (propData) {
      return propData.type === 3;
    });
    if (notesData.length === 0) {
      return false;
    }

    return notesData.map(function (noteData) {
      return React.createElement(
        'div',
        { className: 'note-group', key: noteData.id },
        React.createElement(
          'span',
          { className: 'note-title' },
          noteData.name
        ),
        React.createElement(ActiveSelect, {
          className: 'clearfix',
          optionsData: noteData.properties,
          optionComponent: DishPropsOption,
          sendSubComponentParam: { showMemberPriceInfo: showMemberPriceInfo },
          onSelectOption: function onSelectOption(evt, optionData) {
            return _this3.onSelectPropsOption(noteData, optionData);
          }
        })
      );
    });
  },
  buildIngredient: function buildIngredient(ingredients) {
    var _this4 = this;

    var showMemberPriceInfo = this.props.showMemberPriceInfo;

    var wrappedIngredientsData = Immutable.from([{ name: (0, _helper.formatMessage)(_dishMenu2.default.ingredients), type: -1, properties: ingredients }]);
    if (wrappedIngredientsData[0].properties.length === 0) {
      return false;
    }
    return wrappedIngredientsData.map(function (wrappedIngredientData) {
      return React.createElement(
        'div',
        { className: 'ingredient-group', key: 'ingredient' },
        React.createElement(
          'span',
          { className: 'ingredient-title' },
          wrappedIngredientData.name
        ),
        React.createElement(ActiveSelect, {
          className: 'clearfix',
          optionsData: wrappedIngredientData.properties,
          optionComponent: DishPropsOption,
          sendSubComponentParam: { showMemberPriceInfo: showMemberPriceInfo },
          onSelectOption: function onSelectOption(evt, optionData) {
            return _this4.onSelectPropsOption(wrappedIngredientData, optionData);
          }
        })
      );
    });
  },
  render: function render() {
    var dish = this.props.dish;

    var ruleElement = this.buildRule(dish);
    var propertyVisible = Array.isArray(dish.order);
    var recipeElement = propertyVisible ? this.buildRecipe(dish.order[0].dishPropertyTypeInfos || []) : false;
    var noteElement = propertyVisible ? this.buildNote(dish.order[0].dishPropertyTypeInfos || []) : false;
    var buildIngredientElement = propertyVisible ? this.buildIngredient(dish.order[0].dishIngredientInfos || []) : false;

    return React.createElement(
      'div',
      { className: 'dish-props-select o-flex__fluid' },
      ruleElement,
      React.createElement('div', { className: 'clearfix' }),
      recipeElement,
      buildIngredientElement,
      noteElement
    );
  }
});

/***/ }),
/* 561 */,
/* 562 */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
module.exports = isBuf;

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (global.Buffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(653);
var Socket = __webpack_require__(570);
var Emitter = __webpack_require__(490);
var parser = __webpack_require__(542);
var on = __webpack_require__(571);
var bind = __webpack_require__(572);
var debug = __webpack_require__(500)('socket.io-client:manager');
var indexOf = __webpack_require__(569);
var Backoff = __webpack_require__(672);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  this.encoder = new parser.Encoder();
  this.decoder = new parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.engine.id;
    }
  }
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.engine.id;
    });

    if (this.autoConnect) {
      // manually call here since connecting evnet is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(543);
var XHR = __webpack_require__(657);
var JSONP = __webpack_require__(667);
var websocket = __webpack_require__(668);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(544);
var parseqs = __webpack_require__(545);
var parser = __webpack_require__(482);
var inherit = __webpack_require__(501);
var yeast = __webpack_require__(568);
var debug = __webpack_require__(502)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(543);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/*
 * Module requirements.
 */

var isArray = __webpack_require__(659);

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Right now only Buffer and ArrayBuffer are supported..
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary(data) {

  function _hasBinary(obj) {
    if (!obj) return false;

    if ( (global.Buffer && global.Buffer.isBuffer && global.Buffer.isBuffer(obj)) ||
         (global.ArrayBuffer && obj instanceof ArrayBuffer) ||
         (global.Blob && obj instanceof Blob) ||
         (global.File && obj instanceof File)
        ) {
      return true;
    }

    if (isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
          if (_hasBinary(obj[i])) {
              return true;
          }
      }
    } else if (obj && 'object' == typeof obj) {
      // see: https://github.com/Automattic/has-binary/pull/4
      if (obj.toJSON && 'function' == typeof obj.toJSON) {
        obj = obj.toJSON();
      }

      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && _hasBinary(obj[key])) {
          return true;
        }
      }
    }

    return false;
  }

  return _hasBinary(data);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),
/* 569 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(542);
var Emitter = __webpack_require__(490);
var toArray = __webpack_require__(671);
var on = __webpack_require__(571);
var bind = __webpack_require__(572);
var debug = __webpack_require__(500)('socket.io-client:socket');
var hasBin = __webpack_require__(567);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var parserType = parser.EVENT; // default
  if (hasBin(args)) { parserType = parser.BINARY_EVENT; } // binary
  var packet = { type: parserType, data: args };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  delete this.flags;

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      this.packet({type: parser.CONNECT, query: this.query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  if (packet.nsp !== this.nsp) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    var type = hasBin(args) ? parser.BINARY_ACK : parser.ACK;
    self.packet({
      type: type,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags = this.flags || {};
  this.flags.compress = compress;
  return this;
};


/***/ }),
/* 571 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),
/* 572 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(74);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(9);

var _extends5 = _interopRequireDefault(_extends4);

var _receiveCoupons = __webpack_require__(558);

var _receiveCoupons2 = _interopRequireDefault(_receiveCoupons);

__webpack_require__(125);

__webpack_require__(559);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _const = __webpack_require__(14);

var _storagePairHelper = __webpack_require__(408);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);


var commonHelper = __webpack_require__(3);

var shopId = commonHelper.getUrlParam('shopId');
var type = commonHelper.getUrlParam('type');
var orderCoupon = commonHelper.getUrlParam('orderId');
var receivedCoupon = (0, _storagePairHelper.createReceivedCouponMgr)();
var receivedCouponValue = receivedCoupon.get();
var sharedCouponValue = (0, _storagePairHelper.createShareCouponMgr)().get();

module.exports = React.createClass({
  displayName: 'ReceiveCoupons',
  propTypes: {
    handleClose: React.PropTypes.func,
    couponList: React.PropTypes.array,
    couponType: React.PropTypes.number,
    getCoupons: React.PropTypes.func,
    shopInfo: React.PropTypes.object,
    isShowAlreadyGotCoupon: React.PropTypes.bool,
    linkUrl: React.PropTypes.string
  },

  defaultProps: {
    linkUrl: _config2.default.getCouponListURL,
    couponList: []
  },

  getInitialState: function getInitialState() {
    return {
      showCouponList: true
    };
  },
  handleClick: function handleClick(e, coupId) {
    var _this = this;

    if (e) {
      e.preventDefault();
    }

    var _props = this.props,
        getCoupons = _props.getCoupons,
        couponType = _props.couponType;
    var _props$shopInfo = this.props.shopInfo,
        isOldMarketing = _props$shopInfo.isOldMarketing,
        _props$shopInfo$coupo = _props$shopInfo.couponList,
        couponList = _props$shopInfo$coupo === undefined ? [] : _props$shopInfo$coupo;


    if (couponType === _const.CouponEntry.DISHDETAIL) {
      // 如果是从结算后页面过来
      location.href = '/coupon/getCouponList?shopId=' + shopId;
    } else if (couponType === _const.CouponEntry.DISH) {
      if (isOldMarketing) {
        // 老逻辑
        getCoupons(coupId, function () {
          return _this.handleClose(null, coupId);
        });
      } else {
        // 新逻辑
        getCoupons(couponList[0].coupId, function () {
          return _this.handleClose(null);
        });
      }
    }
  },
  handleClose: function handleClose(e, coupId) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    var _props2 = this.props,
        shopInfo = _props2.shopInfo,
        couponType = _props2.couponType,
        handleClose = _props2.handleClose;

    var _ref = shopInfo || {},
        ruleId = _ref.ruleId,
        planId = _ref.planId,
        isOldMarketing = _ref.isOldMarketing;

    if (couponType === _const.CouponEntry.DISHDETAIL || couponType === _const.CouponEntry.RECEIVED) {
      if (handleClose) {
        handleClose();
      }

      this.defaultCloseEvent();
      return;
    }

    if (isOldMarketing) {
      // 老逻辑
      var alreadySendCouponOld = localStorage.alreadySendCouponOld || '';
      var stuff = type + '_' + shopId + '_' + coupId;
      if (alreadySendCouponOld.indexOf(stuff) === -1) {
        localStorage.alreadySendCouponOld = (localStorage.alreadySendCouponOld || '') + stuff + ',';
      }
    } else {
      // 新逻辑
      var alreadySendCouponNew = localStorage.alreadySendCouponNew || '';
      var _stuff = type + '_' + shopId + '_' + ruleId + '_' + planId;
      if (alreadySendCouponNew.indexOf(_stuff) === -1) {
        localStorage.alreadySendCouponNew = (localStorage.alreadySendCouponNew || '') + _stuff + ',';
      }
    }

    this.props.handleClose();
    this.props.getCoupontoGuid(true);
  },


  // 计算优惠券规则
  setCouponValue: function setCouponValue() {
    var marketCoupon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref2 = this.props.shopInfo || {},
        ruleId = _ref2.ruleId,
        planId = _ref2.planId;

    var spanInfo = '';

    // 1 代金券 2 折扣券 3 礼品券 4 代金券
    // 领券新方案
    if (ruleId && planId) {
      if (marketCoupon.coupType === 1 || marketCoupon.coupType === 4) {
        spanInfo = React.createElement(
          'span',
          { className: 'o-fz--16 coupons-content__value-money money-after price o-fw--b' },
          marketCoupon.value
        );
      } else if (marketCoupon.coupType === 2) {
        spanInfo = React.createElement(
          'span',
          { className: 'o-fz--16 coupons-content__value-money o-fw--b' },
          marketCoupon.value,
          React.createElement(
            'small',
            null,
            React.createElement(_formattedMessage2.default, _global2.default.discount)
          )
        );
      }
    } else {
      // 老方案
      if (marketCoupon.coupType === 1 || marketCoupon.coupType === 4) {
        spanInfo = React.createElement(
          'span',
          { className: 'o-fz--16 coupons-content__value-money money-after price o-fw--b' },
          marketCoupon.value
        );
      } else if (marketCoupon.coupType === 2) {
        spanInfo = React.createElement(
          'span',
          { className: 'o-fz--16 coupons-content__value-money o-fw--b' },
          marketCoupon.value,
          React.createElement(
            'small',
            null,
            React.createElement(_formattedMessage2.default, _global2.default.discount)
          )
        );
      } else if (marketCoupon.coupType === 3) {
        spanInfo = React.createElement(
          'span',
          { className: 'o-fz--16 coupons-content__value-money o-fw--b' },
          '\u793C\u54C1\u5238'
        );
      }
    }
    return spanInfo;
  },
  getCouponItem: function getCouponItem() {
    var _this2 = this;

    var _props3 = this.props,
        _props3$couponList = _props3.couponList,
        couponList = _props3$couponList === undefined ? [] : _props3$couponList,
        _props3$shopInfo = _props3.shopInfo,
        shopInfo = _props3$shopInfo === undefined ? {} : _props3$shopInfo;

    var couponArr = [];
    var newCouponList = void 0;
    // 新老逻辑交替判断
    if (shopInfo.isOldMarketing) {
      // 老逻辑
      newCouponList = [shopInfo.marketCoupon];
    } else {
      // 新逻辑
      // 新老逻辑交替判断
      if (couponList.length === 0) {
        return false;
      }
      newCouponList = couponList;
    }

    newCouponList.forEach(function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments[1];

      var rule = _this2.setCouponValue(item);
      couponArr.push(React.createElement(
        'li',
        { className: '', key: index },
        React.createElement(
          'div',
          { className: 'coupons-content' },
          React.createElement(
            'div',
            { className: 'coupons-content__value' },
            rule,
            React.createElement(
              'span',
              { className: 'o-fz--10 coupons-content__value-text' },
              item.limit ? React.createElement(_formattedMessage2.default, (0, _extends5.default)({}, _global2.default.limitValueCanUse, { values: { limitValue: item.limit, currency: sessionStorage.getItem('currency') } })) : React.createElement(_formattedMessage2.default, _global2.default.useUnlimited)
            )
          ),
          React.createElement(
            'div',
            { className: 'coupons-content__description' },
            React.createElement(
              'span',
              { className: 'o-fz--15 coupons-content__description-title o-fw--b', 'data-coupons': item.count <= 1 ? '' : 'x' + item.count },
              item.name
            )
          )
        )
      ));
    });

    return couponArr;
  },
  defaultLinkEvent: function defaultLinkEvent() {
    var _props4 = this.props,
        clickEvent = _props4.clickEvent,
        linkUrl = _props4.linkUrl;


    if (clickEvent) {
      clickEvent();
    }

    if (this.props.couponType === _const.CouponEntry.RECEIVED && this.props.couponExit) {
      if (!(receivedCouponValue || {})[orderCoupon]) {
        receivedCoupon.set((0, _extends5.default)({}, receivedCouponValue, (0, _defineProperty3.default)({}, orderCoupon, true)));
      }
    }

    location.href = (linkUrl || _config2.default.getCouponListURL) + '?shopId=' + shopId + '&type=' + type;
  },
  defaultCloseEvent: function defaultCloseEvent() {
    this.setState({ showCouponList: false });

    if (!(receivedCouponValue || {})[orderCoupon] && orderCoupon) {
      receivedCoupon.set((0, _extends5.default)({}, receivedCouponValue, (0, _defineProperty3.default)({}, orderCoupon, true)));
    }
  },
  render: function render() {
    var _this3 = this;

    var _props5 = this.props,
        couponType = _props5.couponType,
        couponSuccess = _props5.couponSuccess,
        shopInfo = _props5.shopInfo,
        isShowAlreadyGotCoupon = _props5.isShowAlreadyGotCoupon,
        title = _props5.title,
        text = _props5.text,
        couponList = _props5.couponList;
    var showCouponList = this.state.showCouponList;

    var marketCoupon = shopInfo && shopInfo.marketCoupon || {};
    var hideElement = !showCouponList || !couponList.length || couponType === _const.CouponEntry.RECEIVED && ((receivedCouponValue || {})[orderCoupon] || !orderCoupon);

    if (this.props.shareTip && !sharedCouponValue) {
      hideElement = true;
    }

    if (hideElement) {
      return null;
    }

    return React.createElement(
      'div',
      {
        className: 'receive-coupons',
        onTouchTap: function onTouchTap(e) {
          _this3.handleClose(e, marketCoupon.coupId);
        }
      },
      React.createElement(
        'div',
        { className: 'receive-coupons__container', onTouchTap: function onTouchTap(e) {
            return e.stopPropagation();
          } },
        React.createElement(
          'div',
          { className: 'container-head' },
          React.createElement('img', { src: '' + _receiveCoupons2.default || '', alt: '', className: 'container-head__bg' }),
          React.createElement(
            'div',
            { className: 'container-head__text o-flex o-flex--column-modify o-flex--align-c o-flex--justify-c' },
            React.createElement(
              'p',
              { className: 'o-fz--20 o-fw--b' },
              title
            ),
            text && React.createElement(
              'p',
              { className: 'o-fz--12', style: { marginTop: 5 } },
              text
            )
          ),
          React.createElement(
            'span',
            {
              className: 'coupons-close',
              onTouchTap: function onTouchTap(e) {
                _this3.handleClose(e, marketCoupon.coupId);
              }
            },
            '\xA0'
          )
        ),
        React.createElement(
          'div',
          { className: 'container-content' },
          React.createElement(
            'div',
            { className: 'container-content__box', style: { height: isShowAlreadyGotCoupon ? '300px' : '' } },
            React.createElement(
              'ul',
              { className: 'box-coupons' },
              this.getCouponItem()
            )
          )
        ),
        couponType === _const.CouponEntry.DISH && React.createElement(
          'div',
          { className: 'container-btn', style: { height: isShowAlreadyGotCoupon ? '15px' : '' } },
          !isShowAlreadyGotCoupon && React.createElement(
            'span',
            {
              onTouchTap: function onTouchTap(e) {
                _this3.handleClick(e, marketCoupon.coupId);
              }
            },
            couponSuccess ? React.createElement(_formattedMessage2.default, _global2.default.viewCoupon) : React.createElement(_formattedMessage2.default, _global2.default.pickCoupon)
          )
        ),
        (couponType === _const.CouponEntry.DISHDETAIL || couponType === _const.CouponEntry.RECEIVED) && React.createElement(
          'div',
          { className: 'container-btn' },
          React.createElement(
            'span',
            {
              onTouchTap: function onTouchTap(e) {
                _this3.defaultLinkEvent();
              },
              className: 'o-fz--16 o-fw--b'
            },
            couponType === _const.CouponEntry.RECEIVED ? React.createElement(_formattedMessage2.default, _global2.default.viewReceivedCoupon) : React.createElement(_formattedMessage2.default, _global2.default.viewAndPickCoupon)
          )
        )
      )
    );
  }
});

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */,
/* 587 */,
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _const = __webpack_require__(14);

var _reducerHelper = __webpack_require__(458);

var _reducerHelper2 = _interopRequireDefault(_reducerHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const _findIndex = require('../../utils/findIndex.js');
var _findIndex = __webpack_require__(524);
var Immutable = __webpack_require__(77);
var helper = __webpack_require__(43);
var commonHelper = __webpack_require__(3);
var filterNoneString = commonHelper.filterNoneString;

// import { MemberPrivTypes } from '../../helper/const';
var reducerContainer = _reducerHelper2.default.create();

module.exports = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.from({
    industry: _const.INDUSTRY.NORMAL,
    activeDishTypeId: -1,
    activeDishTypeIdIndex: 0,
    dishTypesData: [],
    dishesData: [],
    dishPageTpl: 'default',
    dishesDataDuplicate: [],
    enableMemberRegistry: false,
    shopInfo: {
      isOldMarketing: true, // true 老逻辑 false 新逻辑
      commercialName: '',
      openTimeList: [],
      diningForm: undefined,
      formatDishesData: {},
      marketList: {},
      marketListUpdate: [],
      marketMatchDishes: false,
      multiMarketing: [],
      limitedMarketing: [],
      notice: null,
      marketCoupon: null,
      couponSuccessInfo: null,
      couponSuccess: false,
      getMarket: false,
      mobile: 0,
      serviceMobile: 0,
      address: '',
      isEnableShop: true,
      choosePeopleCountFlag: false,
      isYaZuo: false,
      couponList: [],
      ruleId: null,
      planId: null,
      flag: null,
      type: null,
      payBeforeDinner: false,
      enableOpenDish: false
    },
    dishDetailData: undefined,
    takeawayServiceProps: undefined,
    dishBoxChargeInfo: null,
    normalDiscountProps: null,
    discountProps: null,
    errorMessage: {},
    load: {
      status: false,
      word: ''
    },
    serviceStatus: {},
    callMsg: {
      info: '',
      callStatus: false
    },
    callAble: true,
    shopLogo: '',
    orderPageImage: '',
    orderPageTitle: '',
    wmCartImageUrl: '',
    tsCartImageUrl: '',
    sendTimeList: [],
    isAcceptOrder: null,
    pageIsLoaded: false,
    soldTopDishList: [],
    dishDetailRecommendDishList: [],
    guidStatus: false,
    isDataInitOver: false,
    saveOrderChangeItem: null,
    deliveryTime: '--',
    changed: false,
    selfChooseDishList: [],
    selfChooseDishTypeObj: {}
  });
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  var orderIdx = void 0;
  var newState = void 0;

  var getFirstValidDishTypeId = function getFirstValidDishTypeId(_payload) {
    var dishTypeList = _payload.dishTypeList || [];
    var dishList = _payload.dishList || [];
    var i = 0;
    while (i < dishTypeList.length) {
      var dishTypeDishes = dishList.filter(function (dish) {
        return dishTypeList[i].dishIds && dishTypeList[i].dishIds.indexOf(dish.id) > -1;
      });
      var isNotEmpty = dishTypeDishes.some(function (dish) {
        return dish.currRemainTotal !== 0;
      });
      if (isNotEmpty) return dishTypeList[i].id;
      i++;
    }
    return -1;
  };

  // 对标签中类进行排序
  var sortDishTypesWithTag = function sortDishTypesWithTag(prev, next) {
    return prev.sort - next.sort;
  };

  var getDishTypesWithTag = function getDishTypesWithTag(dishList) {
    var dishIdsWithTagTypes = {};
    var tagTypes = {};
    // 标签中类 list
    var tagTypeList = [];
    // 默认的六个标签中类
    var defaultTagTypeList = [];
    // 自定义的标签中类
    var customTagTypeList = [];
    var iconTagReg = /热门|推荐|折扣|赠品|特价|特色/;

    // 遍历 dishList
    // 找出所有的含有标签的菜品
    // 将这些菜品归类到相应的标签下
    dishList.forEach(function (dish) {
      if (Array.isArray(dish.dishPropertyTypeInfos) && dish.dishPropertyTypeInfos.length !== 0) {
        dish.dishPropertyTypeInfos.forEach(function (dishPropertyInfo) {
          if (dishPropertyInfo.type === 2) {
            dishPropertyInfo.properties.forEach(function (property) {
              if (!dishIdsWithTagTypes[property.name]) {
                dishIdsWithTagTypes[property.name] = [];
              }
              dishIdsWithTagTypes[property.name].push(dish.proxyDishId || dish.id);
              tagTypes[property.name] = {
                id: property.id,
                name: property.name,
                sort: property.sort,
                // 含有 type 属性并且值为 tag 的时候，表示标签中类
                type: 'tag',
                dishIds: dishIdsWithTagTypes[property.name].filter(function (item, index, array) {
                  return array.indexOf(item) === index;
                })
              };
            });
          }
        });
      }
    });

    for (var key in tagTypes) {
      if (iconTagReg.test(tagTypes[key].name)) {
        defaultTagTypeList.push(tagTypes[key]);
      } else {
        customTagTypeList.push(tagTypes[key]);
      }
    }

    // 合并各种标签并对标签中的菜品进行去重
    tagTypeList = defaultTagTypeList.sort(sortDishTypesWithTag).concat(customTagTypeList.sort(sortDishTypesWithTag));

    return tagTypeList.filter(function (tagType) {
      return typeof tagType !== 'undefined' || tagType && tagType.dishIds.length !== 0;
    });
  };

  if (reducerContainer.exist(type)) {
    return reducerContainer.getNextState(type, state, payload);
  }

  switch (type) {
    case 'SET_INDUSTRY_INFO':
      {
        return state.set('industry', payload);
      }
    case 'SET_MENU_DATA':
      {
        var _payload$dishList = payload.dishList,
            dishList = _payload$dishList === undefined ? [] : _payload$dishList,
            _payload$dishTypeList = payload.dishTypeList,
            dishTypeList = _payload$dishTypeList === undefined ? [] : _payload$dishTypeList;
        // dishList.sort((a, b) => a.marketPrice - b.marketPrice);

        var resultRuleData = helper.mergeSameRuleDish(dishList, dishTypeList);

        // 标签中类与原生中类合并
        var dishTypeListWithTag = getDishTypesWithTag(resultRuleData.dishList);
        var mergedDishTypeList = dishTypeListWithTag.concat(resultRuleData.dishTypeList);
        var updatingObj = {
          dishesDataDuplicate: resultRuleData.dishList,
          dishTypesData: mergedDishTypeList,
          menuDataStatus: true, // 数据请求完毕
          dishesData: [],
          activeDishTypeId: dishTypeListWithTag[0] ? dishTypeListWithTag[0].id : getFirstValidDishTypeId(payload),
          normalDiscountProps: payload.discountInfo
        };

        return state.setIn(['shopInfo', 'formatDishesData'], helper.formatDishesData(dishList)).merge(updatingObj);
      }
    case 'ACTIVE_DISH_TYPE':
      return state.setIn(['activeDishTypeId'], payload.dishTypeId).setIn(['activeDishTypeIdIndex'], payload.dishTypeIdIndex);
    case 'TOGGLE_DISH_DETAIL':
      return state.setIn(['dishDetailData'], payload);
    case 'SET_DATA_INIT_OVER':
      return state.setIn(['isDataInitOver'], payload);
    case 'TOGGLE_DISH_DESC':
      return state.setIn(['dishDescData'], payload);
    case 'SET_SOLD_DISH_LIST':
      {
        var formatRecommentList = function formatRecommentList(list) {
          return list.map(function (item) {
            return {
              dishId: item.id,
              soldNum: item.soldNum
            };
          });
        };

        if (payload.dishMenuRecommendList) {
          return state.set('soldTopDishList', formatRecommentList(payload.dishMenuRecommendList));
        } else if (payload.dishDetailRecommendList) {
          return state.set('dishDetailRecommendDishList', payload.dishDetailRecommendList);
        }
        return state;
      }
    case 'SET_GUID_STATUS':
      return state.set('guidStatus', payload);
    /*
    case 'SET_COUPON_STATUS':
      return state.set('couponStatus', payload);
    */
    case 'REMOVE_ALL_ORDERS':
      return state.update('dishesDataDuplicate', function (dishes) {
        return dishes.flatMap(function (dish) {
          return dish.set('order', undefined);
        });
      });
    case 'REINSTATE_UNDEFINED':
      return state.set('saveOrderChangeItem', null);
    case 'CLEAR_SAVE_ORDER':
      return state.set('saveOrderChangeItem', 'clearAll');
    case 'SET_TAKEAWAY_SERVICE_PROPS':
      return state.set('takeawayServiceProps', payload);
    case 'BATCH_ORDER_DISH':
      {
        // 再来一单批量设置order
        var _payload$dishList2 = payload.dishList,
            anthorDishList = _payload$dishList2 === undefined ? [] : _payload$dishList2,
            changed = payload.changed;

        var _newState = state; // 为了和外部newState区别
        _newState = _newState.set('changed', changed);
        anthorDishList.forEach(function () {
          var dish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var dishIdx = _findIndex(state.dishesDataDuplicate, { id: String(dish.id) });
          if (helper.isSingleDishWithoutProps(dish)) {
            // 简单菜
            var order = dish.order;

            var count = typeof order === 'number' ? order : order.reduce(function (all, cur) {
              return all + cur.count;
            }, 0);
            _newState = _newState.setIn(['dishesDataDuplicate', dishIdx, 'order'], count);
          } else {
            // 套餐、多规格
            var dishAllDishList = _newState.dishesDataDuplicate.filter(function (d) {
              return d.id === dish.id;
            });
            if (!dishAllDishList.length) return;

            var _dishAllDishList = (0, _slicedToArray3.default)(dishAllDishList, 1),
                dishAllDish = _dishAllDishList[0];

            if (dishAllDish.groups && dishAllDish.groups.length) {
              // 套餐
              var _order = dish.order;

              _newState = _newState.setIn(['dishesDataDuplicate', dishIdx, 'order'], _order);
            } else {
              // 多规格菜品
              var oriOrder = dishAllDish.order;

              var newOrder = helper.getAnthorOrder(dish);
              var allOrder = oriOrder ? oriOrder.concat(newOrder) : newOrder;
              _newState = _newState.setIn(['dishesDataDuplicate', dishIdx, 'order'], allOrder);
            }
          }
        });
        return _newState;
      }
    case 'ORDER_DISH':
      {
        var _payload2 = (0, _slicedToArray3.default)(payload, 1),
            dish = _payload2[0];

        var dishIdx = _findIndex(state.dishesDataDuplicate, { id: String(dish.id) });

        if (helper.isSingleDishWithoutProps(state.dishesDataDuplicate[dishIdx])) {
          // for single dish without props;
          newState = state.setIn(['dishesDataDuplicate', dishIdx, 'order'], helper.getNewCountOfDish(state.dishesDataDuplicate[dishIdx], payload[1], dish));
        } else {
          // for single dish with props
          var currentOrder = state.dishesDataDuplicate[dishIdx].order || [];

          var _dish$order = (0, _slicedToArray3.default)(dish.order, 1),
              firstNextOrder = _dish$order[0];

          if (helper.isGroupDish(state.dishesDataDuplicate[dishIdx])) {
            orderIdx = _findIndex(currentOrder, { groups: firstNextOrder.groups });
          } else {
            orderIdx = _findIndex(currentOrder, {
              dishIngredientInfos: firstNextOrder.dishIngredientInfos,
              dishPropertyTypeInfos: firstNextOrder.dishPropertyTypeInfos
            });
          }

          if (orderIdx !== -1) {
            // if find the order with same props, just add the count of the exsited order;
            newState = state.setIn(['dishesDataDuplicate', dishIdx, 'order', orderIdx, 'count'], Math.min(state.dishesDataDuplicate[dishIdx].order[orderIdx].count + firstNextOrder.count, _const.MaxOrderedDishCount));

            if (newState.dishesDataDuplicate[dishIdx].order[orderIdx].count < dish.dishIncreaseUnit) {
              // if order's count is 0, remove it.
              newState = newState.updateIn(['dishesDataDuplicate', dishIdx, 'order'], function (order) {
                return order.flatMap(function (eachOrder, idx) {
                  return orderIdx === idx ? [] : eachOrder;
                });
              });
            }
          } else {
            // if cannot find the order with same props,add it as new order;
            newState = state.updateIn(['dishesDataDuplicate', dishIdx, 'order'], function (order) {
              return order === undefined ? dish.order : order.concat(dish.order);
            });
          }
        }

        return newState.setIn(['dishesDataDuplicate', dishIdx, 'dishTypeName'], dish.dishTypeName || '默认分类');
      }
    case 'CHANGE_DISH':
      return state.set('saveOrderChangeItem', payload);
    case 'SET_DISCOUNT_TO_ORDER':
      {
        var discountData = payload.dishList && payload.dishList.length || payload.type === _const.MemberPrivTypes.UNIFIED_DISCOUNT ? payload : state.normalDiscountProps || {};

        var _discountData$isMembe = discountData.isMember,
            isMember = _discountData$isMembe === undefined ? false : _discountData$isMembe,
            _discountData$dishLis = discountData.dishList,
            _dishList = _discountData$dishLis === undefined ? [] : _discountData$dishLis,
            _discountData$type = discountData.type,
            discountType = _discountData$type === undefined ? 1 : _discountData$type,
            _discountData$levelNa = discountData.levelName,
            levelName = _discountData$levelNa === undefined ? '' : _discountData$levelNa,
            _discountData$loginTy = discountData.loginType,
            loginType = _discountData$loginTy === undefined ? 1 : _discountData$loginTy,
            isPeriod = discountData.isPeriod,
            _discountData$discoun = discountData.discount,
            discount = _discountData$discoun === undefined ? 1 : _discountData$discoun,
            _discountData$ableAdd = discountData.ableAddPriceDiscount,
            ableAddPriceDiscount = _discountData$ableAdd === undefined ? false : _discountData$ableAdd;

        var uniqDishList = helper.uniqueDiscountInfo(isPeriod ? _dishList : []);
        var isUserMember = payload.isMember === true;
        helper.storeDishesLocalStorage(state.dishesDataDuplicate, state.shopInfo);
        // const orderId = helper.getUrlParam('orderId');
        var orderId = sessionStorage.orderId;
        return state.set('discountProps', payload).update('dishesDataDuplicate', function (dishesData) {
          return dishesData.flatMap(function (dishData) {
            var memberPrice = null;
            if (discountType === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
              memberPrice = discount;
            } else {
              var discountInfo = uniqDishList.find(function (item) {
                return item.dishId === dishData.id;
              });
              memberPrice = discountInfo ? discountInfo.value : memberPrice;
            }

            var memberPriceStr = memberPrice !== null && memberPrice !== undefined ? memberPrice.toString() : null; // 消除memberPrice为0的影响

            // 是会员，并且有会员折扣，计算口味做法相关价格
            var dishPropertyTypeInfos = dishData.dishPropertyTypeInfos,
                dishIngredientInfos = dishData.dishIngredientInfos,
                groups = dishData.groups;

            if (isUserMember && memberPriceStr && ableAddPriceDiscount) {
              var res = helper.computePropsAndIngredientMemberRePrice(dishData, memberPrice, discountType);
              dishPropertyTypeInfos = res.dishPropertyTypeInfos;
              dishIngredientInfos = res.dishIngredientInfos;

              if (Array.isArray(groups)) {
                groups = helper.computeMemberRePriceByGroups(groups, memberPrice, discountType);
              }
            }
            // 处理再来一单order的会员价
            var order = dishData.order;
            if (order) {
              if (memberPriceStr) {
                if (Array.isArray(groups)) {
                  order = helper.computeGroupOrderMemberPrice(dishData, memberPrice, discountType, ableAddPriceDiscount);
                } else {
                  order = helper.computeOrderMemberPrice(dishData, memberPrice, discountType, ableAddPriceDiscount);
                }
              }
            }
            if (orderId) {
              return dishData
              // .set('isMember', !!memberPrice)
              // .set('memberPrice', memberPrice || false)
              .set('isMember', !!memberPriceStr).set('memberPrice', memberPriceStr ? memberPrice : false).set('discountType', discountType).set('discountLevel', levelName).set('loginType', loginType).set('isUserMember', isUserMember).set('dishPropertyTypeInfos', dishPropertyTypeInfos, { deep: true }).set('dishIngredientInfos', dishIngredientInfos, { deep: true }).set('groups', groups, { deep: true }).set('order', order);
            } else {
              return dishData
              // .set('isMember', !!memberPrice)
              // .set('memberPrice', memberPrice || false)
              .set('isMember', !!memberPriceStr).set('memberPrice', memberPriceStr ? memberPrice : false).set('discountType', discountType).set('discountLevel', levelName).set('loginType', loginType).set('isUserMember', isUserMember).set('dishPropertyTypeInfos', dishPropertyTypeInfos, { deep: true }).set('dishIngredientInfos', dishIngredientInfos, { deep: true }).set('groups', groups, { deep: true });
            }
          });
        });
      }
    case 'SET_NORMAL_DISCOUNT':
      {
        var urlType = commonHelper.getUrlParam('type');
        var commercialNotice = '';
        switch (urlType) {
          case 'TS':
            commercialNotice = payload.commercialNoticeTS || '';
            break;
          case 'WM':
            commercialNotice = payload.commercialNoticeWM || '';
            break;
          default:
            break;
        }

        return state.set('normalDiscountProps', payload.discountInfo).setIn(['shopInfo', 'marketList'], helper.formatMarket(payload.marketing || [], state.shopInfo.formatDishesData)).setIn(['shopInfo', 'marketListUpdate'], helper.formatMarketUpdate(payload.marketing || [], state.shopInfo.formatDishesData)).setIn(['shopInfo', 'marketMatchDishes'], helper.matchDishesData(helper.formatMarketUpdate(payload.marketing || [], state.shopInfo.formatDishesData), state.shopInfo.formatDishesData)).setIn(['shopInfo', 'multiMarketing'], payload.multiMarketing).setIn(['shopInfo', 'limitedMarketing'], payload.limitedMarketing).setIn(['shopInfo', 'notice'], filterNoneString('word', commercialNotice)).setIn(['shopInfo', 'getMarket'], true);
      }
    case 'SET_ERROR_MSG':
      {
        var newPayload = {};
        if (typeof payload === 'string') {
          newPayload.text = payload;
        } else {
          newPayload = payload;
        }
        return state.set('errorMessage', newPayload || {});
      }
    case 'SET_COUPON_SUCCESS_INFO':
      return state.setIn(['shopInfo', 'couponSuccessInfo'], payload || {});
    case 'SET_COUPON_SUCCESS':
      return state.setIn(['shopInfo', 'couponSuccess'], payload);
    case 'SET_LOAD_MSG':
      return state.set('load', payload);
    case 'SET_TABLE_AREA_INFO':
      return state.set('tableAreaInfo', payload);
    case 'SET_SHOP_ORDER_STATUS':
      return state.set('isAcceptOrder', payload);
    case 'SET_SHOP_INFO':
      {
        var isWM = helper.getUrlParam('type') === 'WM';
        var updateShopInfo = {
          dishPageTpl: isWM ? payload.dishPageTpl : payload.tsDishPageTpl,
          enableMemberRegistry: payload.enableMemberRegistry,
          dishBoxChargeInfo: isWM && payload.extraCharge ? payload.extraCharge : null,
          isAcceptTakeaway: payload.isAcceptTakeaway,
          isHDL: payload.isHDL,
          guide: payload.guide,
          operateImgUrl: filterNoneString('url', isWM ? payload.operateImgUrl : payload.tsOperateImgUrl),
          operateUrl: filterNoneString('url', isWM ? payload.operateUrl : payload.tsOperateUrl),
          swiperAdImgs: isWM ? payload.marketImgsWm : payload.marketImgsTs,
          shopLogo: payload.shopLogo,
          orderPageImage: filterNoneString('url', payload.orderPageImage),
          tsOperateUrl: filterNoneString('url', payload.tsOperateUrl),
          tsOperateImgUrl: filterNoneString('url', payload.tsOperateImgUrl),
          fullAdvertUrl: filterNoneString('url', payload.fullAdvertUrl),
          fullAdvertImgUrl: filterNoneString('url', payload.fullAdvertImgUrl),
          showFullscreenAd: payload.showFullscreenAd,
          orderPageTitle: filterNoneString('word', isWM ? payload.orderPageTitle : payload.tsOrderPageTitle),
          wmCartImageUrl: filterNoneString('url', payload.wmCartImageUrl),
          tsCartImageUrl: filterNoneString('url', payload.tsCartImageUrl),
          enableSyncShoppingCart: payload.enableSyncShoppingCart,
          sendTimeList: payload.sendTimeList,
          openTimeList: payload.openTimeList,
          loadShopStatus: true,
          shopInfo: {
            isOldMarketing: payload.isOldMarketing,
            commercialName: payload.commercialName,
            openTimeList: payload.openTimeList,
            diningForm: payload.diningForm, // 0 正餐 1 快餐
            isSingleShop: payload.isSingleShop,
            marketCoupon: payload.takeCouponVO || {},
            formatDishesData: {},
            marketList: {},
            marketListUpdate: [],
            marketMatchDishes: false,
            mobile: payload.mobile,
            serviceMobile: payload.serviceMobile,
            nationTelCode: payload.nationTelCode,
            address: payload.address,
            multiMarketing: [],
            limitedMarketing: [],
            notice: null,
            couponSuccessInfo: null,
            couponSuccess: false,
            isEnableShop: isWM ? payload.isEnableWm : payload.isEnableTs,
            choosePeopleCountFlag: payload.choosePeopleCountFlag,
            serviceSupply: payload.ringVOS,
            openStatus: payload.openStatus,
            isYaZuo: payload.isYaZuo || false,
            goodsNumEditable: payload.goodsNumEditable || false,
            couponList: payload.takeCouponVOS || [],
            ruleId: payload.ruleId,
            planId: payload.planId,
            flag: payload.flag,
            type: payload.type,
            payBeforeDinner: payload.payBeforeDinner,
            isToHomeFlag: payload.isToHomeFlag,
            isToShopFlag: payload.isToShopFlag,
            enableWeixinMini: payload.enableWeixinMini,
            enableOpenDish: payload.enableOpenDish === 1,
            isAcceptTakeaway: payload.isAcceptTakeaway,
            avaliableDays: payload.avaliableDays
          }
        };
        return state.merge(updateShopInfo);
      }

    case 'SET_PAGE_LOADED_STATUS':
      return state.set('pageIsLoaded', payload);

    case 'SET_SERVICE_STATUS':
      return state.set('serviceStatus', payload || {});

    case 'SET_CALL_MSG':
      {
        return state.set('callMsg', payload || {});
      }
    case 'SET_CANCEL_CALL_MSG':
      {
        return state.set('callMsg', payload || {});
      }
    case 'SET_CAN_CALL':
      {
        return state.set('callAble', payload);
      }
    case 'SET_DELIVERY_TIME':
      {
        return state.set('deliveryTime', payload);
      }
    case 'SET_MUST_ORDER_DISH_LIST':
      {
        var _ref = payload || {},
            selfChooseDishList = _ref.selfChooseDishList,
            selfChooseDishTypeObj = _ref.selfChooseDishTypeObj;

        return state.set('selfChooseDishList', selfChooseDishList).set('selfChooseDishTypeObj', selfChooseDishTypeObj);
      }

    default:
      return state;
  }
};

reducerContainer.add('UPDATE_DISH_ORDER', function (state, payload) {
  var dishList = payload;
  if (!dishList || !dishList.length) {
    return state;
  }

  return state.update('dishesDataDuplicate', function (dishes) {
    return dishes.flatMap(function (dish) {
      var orderedDish = dishList.filter(function (item) {
        return String(item.id) === dish.id;
      })[0];
      if (!orderedDish) {
        return dish;
      }

      return dish.set('order', orderedDish.order);
    });
  });
});

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(74);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _ReducerContainer$cre;

var _reducerHelper = __webpack_require__(458);

var _reducerHelper2 = _interopRequireDefault(_reducerHelper);

var _commonActionType = __webpack_require__(417);

var _commonActionType2 = _interopRequireDefault(_commonActionType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Immutable = __webpack_require__(77);


var initialState = Immutable.from({
  errorMessage: '',
  loading: {
    status: false,
    word: '加载中'
  },
  brandInfo: {}
});

exports.default = _reducerHelper2.default.createReducer(initialState, (_ReducerContainer$cre = {}, (0, _defineProperty3.default)(_ReducerContainer$cre, _commonActionType2.default.SET_ERROR_MSG, function (state, payload) {
  return state.set('errorMessage', payload || '');
}), (0, _defineProperty3.default)(_ReducerContainer$cre, _commonActionType2.default.SET_LOAD_MSG, function (state, payload) {
  return state.set('load', payload);
}), (0, _defineProperty3.default)(_ReducerContainer$cre, _commonActionType2.default.SET_BRAND_INFO, function (state, payload) {
  return state.set('brandInfo', payload);
}), _ReducerContainer$cre));

/***/ }),
/* 590 */,
/* 591 */,
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/shop-logo-default.svg";

/***/ }),
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _singleDishDetail = __webpack_require__(618);

var _singleDishDetail2 = _interopRequireDefault(_singleDishDetail);

var _BaseComponent2 = __webpack_require__(456);

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var helper = __webpack_require__(43);
var classnames = __webpack_require__(50);
var GroupDishDetail = __webpack_require__(625);

__webpack_require__(585);

var DishDetailContainer = (_temp = _class = function (_BaseComponent) {
  (0, _inherits3.default)(DishDetailContainer, _BaseComponent);

  function DishDetailContainer(props) {
    (0, _classCallCheck3.default)(this, DishDetailContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DishDetailContainer.__proto__ || (0, _getPrototypeOf2.default)(DishDetailContainer)).call(this, props));

    _this.bind('onCloseBtnTap');
    return _this;
  }

  (0, _createClass3.default)(DishDetailContainer, [{
    key: 'onCloseBtnTap',
    value: function onCloseBtnTap(evt) {
      evt.preventDefault();

      if (location.hash === '#hot-dish') {
        this.props.onCloseBtnTap();
      } else {
        location.hash = '';
        this.props.onCloseBtnTap();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dish = _props.dish,
          sameRuleDishList = _props.sameRuleDishList,
          onAddToCarBtnTap = _props.onAddToCarBtnTap,
          changeShowDataItems = _props.changeShowDataItems,
          singleMaximum = _props.singleMaximum,
          ifShowToolTip = _props.ifShowToolTip,
          confirmButtonText = _props.confirmButtonText,
          showMemberPriceInfo = _props.showMemberPriceInfo;

      var isGroupDish = helper.isGroupDish(dish);

      return React.createElement(
        'div',
        {
          className: classnames('dish-detail-container', {
            'single-dish-detail-all': !isGroupDish,
            'group-dish-detail-all': isGroupDish
          })
        },
        React.createElement('div', {
          className: classnames('dish-detail-container_mask', {
            'dish-detail-container_mask__modify': isGroupDish
          }),
          onTouchTap: this.onCloseBtnTap
        }),
        React.createElement(
          'div',
          { className: 'dish-detail-content' },
          isGroupDish ? React.createElement(GroupDishDetail, {
            dish: dish,
            showMemberPriceInfo: showMemberPriceInfo,
            changeShowDataItems: changeShowDataItems,
            onAddToCarBtnTap: onAddToCarBtnTap,
            onCloseBtnTap: this.onCloseBtnTap,
            confirmButtonText: confirmButtonText
          }) : React.createElement(_singleDishDetail2.default, {
            changeShowDataItems: changeShowDataItems,
            dish: dish,
            showMemberPriceInfo: showMemberPriceInfo,
            sameRuleDishList: sameRuleDishList,
            onAddToCarBtnTap: onAddToCarBtnTap,
            onCloseBtnTap: this.onCloseBtnTap,
            maximum: singleMaximum,
            ifShowToolTip: ifShowToolTip,
            confirmButtonText: confirmButtonText
          })
        )
      );
    }
  }]);
  return DishDetailContainer;
}(_BaseComponent3.default), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    dish: React.PropTypes.object.isRequired,
    sameRuleDishList: React.PropTypes.array,
    onCloseBtnTap: React.PropTypes.func.isRequired,
    onAddToCarBtnTap: React.PropTypes.func.isRequired,
    singleMaximum: React.PropTypes.number,
    ifShowToolTip: React.PropTypes.bool,
    confirmButtonText: React.PropTypes.string,
    showMemberPriceInfo: React.PropTypes.bool
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    showMemberPriceInfo: true
  }
}), _temp);
exports.default = DishDetailContainer;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _commonHelper = __webpack_require__(3);

var helper = _interopRequireWildcard(_commonHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isKoubei = helper.getUrlParam('isKoubei'); // 是否是口碑秒付
var kShopId = helper.getUrlParam('kShopId'); // 口碑秒付ShopId
var commodityId = helper.getUrlParam('commodityId'); // 口碑秒付commodityId
var appId = helper.getUrlParam('appId'); // 口碑秒付appId

exports.getSecondsToPayParams = function () {
  return {
    isKoubei: isKoubei === 'true',
    appId: appId,
    shopId: kShopId,
    commodityId: commodityId
  };
};

exports.secondsToPayBurryStart = function (obj) {
  // 此处进行埋点BEGIN
  document.addEventListener('AlipayJSBridgeReady', function () {
    var req = {
      appId: appId,
      shopId: kShopId,
      commodityId: commodityId
    };
    if (window.MCloudJSBridge) {
      window.MCloudJSBridge.processStartLog((0, _assign2.default)({}, req, obj));
    }
  });
};

exports.secondsToPayBurryEnd = function (obj) {
  // 此处进行埋点END
  var req = {
    appId: appId,
    shopId: kShopId,
    endStatus: 'Success',
    commodityId: commodityId
  };
  if (window.MCloudJSBridge) {
    window.MCloudJSBridge.processEndLog((0, _assign2.default)({}, req, obj));
  }
};

exports.secondsToPayIncludeScript = function (callback, obj) {
  var scriptEle = document.createElement('script');
  scriptEle.type = 'text/javascript';
  scriptEle.src = 'https://os.alipayobjects.com/rmsportal/oknmeDPmBzRhliY.js';
  var x = document.getElementsByTagName('head')[0];
  x.insertBefore(scriptEle, x.firstChild);

  scriptEle.onload = function () {
    // 此处进行埋点BEGIN
    callback(obj);
  };
};

/***/ }),
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/dish_img_default.svg";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _registerDivolte = __webpack_require__(124);

var _registerDivolte2 = _interopRequireDefault(_registerDivolte);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(619);

var React = __webpack_require__(2);
var _findIndex = __webpack_require__(452);
var helper = __webpack_require__(43);
var DishDetailHead = __webpack_require__(531);
var DishPropsSelect = __webpack_require__(560);
var Counter = __webpack_require__(461);
var classnames = __webpack_require__(50);
var toastIcon = __webpack_require__(267);

module.exports = React.createClass({
  displayName: 'SingleDishDetail',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    sameRuleDishList: React.PropTypes.array,
    onAddToCarBtnTap: React.PropTypes.func.isRequired,
    maximum: React.PropTypes.number,
    ifShowToolTip: React.PropTypes.bool,
    confirmButtonText: React.PropTypes.string,
    showMemberPriceInfo: React.PropTypes.bool
  },
  getInitialState: function getInitialState() {
    var _props = this.props,
        dish = _props.dish,
        sameRuleDishList = _props.sameRuleDishList;

    var checkedRuleIds = {};
    var disabledRuleIdMap = {};
    var validateDish = dish;

    this.sameRuleList = this.getSameRuleList();
    if (sameRuleDishList) {
      var id = null;
      validateDish = sameRuleDishList.filter(function (item) {
        return !item.clearStatus;
      })[0] || dish;
      validateDish.dishPropertyTypeInfos.filter(function (item) {
        return item.type === 4;
      }).forEach(function (item) {
        id = checkedRuleIds[item.id] = item.properties[0].id;
      });

      var rulePropertyInfo = this.getRulePropertyInfo({ checkedRuleIds: checkedRuleIds, id: id });
      disabledRuleIdMap = rulePropertyInfo.disabledRuleIdMap;
    }

    return {
      dish: validateDish.merge({ order: this.getNewDishOrder(validateDish) }),
      toast: 0,
      tipText: '',
      checkedRuleIds: checkedRuleIds,
      disabledRuleIdMap: disabledRuleIdMap
    };
  },
  componentWillMount: function componentWillMount() {
    this.historyDishMap = {};
  },
  componentDidUpdate: function componentDidUpdate() {
    var sameRuleDishList = this.props.sameRuleDishList;
    var dish = this.state.dish;

    if (sameRuleDishList && dish && dish.ruleFlag) {
      this.historyDishMap[dish.ruleFlag] = dish;
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    delete this.historyDishMap;
  },

  /**
   * 埋点购物车
   */
  buryingPointAddToCart: function buryingPointAddToCart() {
    var dish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    try {
      var pageType = (0, _registerDivolte.getPageTypeFromUrl)();
      _registerDivolte2.default.send('AddToShoppingCart', { commodityId: dish.id || '', pageType: pageType });
    } catch (ex) {
      console.error(ex);
    }
  },
  onAddToCarBtnTap: function onAddToCarBtnTap() {
    if (!this.valid()) return;
    var onAddToCarBtnTap = this.props.onAddToCarBtnTap;
    var dish = this.state.dish;

    var dishCount = helper.getDishesCount([dish]);
    if (dishCount > 0) {
      onAddToCarBtnTap(dish, dishCount);
      this.buryingPointAddToCart(dish);
      return true;
    }

    this.showToast(React.createElement(_formattedMessage2.default, _dishMenu2.default.pleaseChooseDish));
    return false;
  },
  onDishItemCountChange: function onDishItemCountChange(increment) {
    var dishForDetail = this.state.dish;
    var dishForCart = this.props.dish;
    var countForDetail = helper.getDishesCount([dishForDetail]);
    var countForCart = helper.getDishesCount([dishForCart]);
    var newCountForDetail = void 0;

    if (countForDetail === 0 && countForCart === 0) {
      // if never ordered this dish;
      newCountForDetail = dishForDetail.dishIncreaseUnit;
    } else if (countForCart === 0 && countForDetail + increment < dishForDetail.dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCountForDetail = 0;
    } else {
      newCountForDetail = countForDetail + increment;
    }

    if (helper.isSingleDishWithoutProps(dishForDetail)) {
      this.setState({ dish: dishForDetail.set('order', newCountForDetail) });
    } else {
      this.setState({
        dish: dishForDetail.setIn(['order', 0, 'count'], newCountForDetail)
      });
    }
  },

  /**
   * 校验
   * 增加必选校验
   * @return boolean
   */
  valid: function valid() {
    var res = true;
    var dish = this.state.dish;

    if (!dish || !dish.hasOwnProperty('order') || !Array.isArray(dish.order) || !dish.order[0]) return res; // 不满足条件都默认校验通过
    var dishPropertyTypeInfos = dish.order[0].dishPropertyTypeInfos;

    if (!dishPropertyTypeInfos || !Array.isArray(dishPropertyTypeInfos)) return res;
    for (var i = 0, l = dishPropertyTypeInfos.length; i < l; i++) {
      var _dishPropertyTypeInfo = dishPropertyTypeInfos[i],
          isMandatory = _dishPropertyTypeInfo.isMandatory,
          properties = _dishPropertyTypeInfo.properties,
          name = _dishPropertyTypeInfo.name;

      if (isMandatory === 1) {
        // 选项中没有一个被设置为选中
        if (!properties.some(function (pro) {
          return pro.isChecked;
        })) {
          this.showToast('\u8BF7\u9009\u62E9' + name, 1000);
          res = false;
          break;
        }
      }
    }
    return res;
  },
  onSelectPropsOption: function onSelectPropsOption(propData, optionData) {
    var dishForDetail = this.state.dish;
    var propIdx = -1;
    switch (propData.type) {
      case 1:
        propIdx = _findIndex(dishForDetail.order[0].dishPropertyTypeInfos, {
          id: propData.id
        });
        this.setState({
          dish: dishForDetail.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], function (options) {
            return options.flatMap(function (option) {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              } else if (option.id !== optionData.id && option.isChecked === true) {
                return option.set('isChecked', false);
              }
              return option;
            });
          })
        });
        break;
      case 3:
        propIdx = _findIndex(dishForDetail.order[0].dishPropertyTypeInfos, {
          id: propData.id
        });
        this.setState({
          dish: dishForDetail.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], function (options) {
            return options.flatMap(function (option) {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              }
              return option;
            });
          })
        });
        break;
      case -1:
        // this is a client workround for ingredientsData, we don't have this value of type on serverside
        this.setState({
          dish: dishForDetail.updateIn(['order', 0, 'dishIngredientInfos'], function (options) {
            return options.flatMap(function (option) {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              }
              return option;
            });
          })
        });
        break;
      default:
    }
  },
  getVirtualDish: function getVirtualDish() {
    var dish = this.props.dish;

    var virtualDish = (0, _assign2.default)({}, dish, {
      marketPrice: 0,
      dishPropertyTypeInfos: [],
      dishIngredientInfos: [],
      isVirtualDish: true,
      clearStatus: true,
      order: 0,
      ruleFlag: null
    });
    return virtualDish;
  },
  getDishPropertyTypeInfos: function getDishPropertyTypeInfos(infos) {
    var mutabledInfo = infos.asMutable({ deep: true });
    return mutabledInfo.map(function (info) {
      if (info.type === 4) {
        info.properties.forEach(function (property) {
          return (0, _assign2.default)(property, { isChecked: true });
        });
      }
      return info;
    });
  },
  getNewDishOrder: function getNewDishOrder(dish) {
    if (helper.isSingleDishWithoutProps(dish)) {
      return dish.dishIncreaseUnit || 1;
    }

    return [{
      count: dish.dishIncreaseUnit || 1,
      dishPropertyTypeInfos: dish.dishPropertyTypeInfos,
      dishIngredientInfos: dish.dishIngredientInfos
    }];
  },
  getSameRuleList: function getSameRuleList() {
    // 多规格菜品合并
    var sameRuleDishList = this.props.sameRuleDishList;

    var rules = [];

    if (!sameRuleDishList) {
      return rules;
    }

    sameRuleDishList.forEach(function (dish) {
      var dishRules = dish.dishPropertyTypeInfos.filter(function (property) {
        return property.type === 4;
      });
      dishRules.forEach(function (rule, index) {
        var ruleItem = rules[index] || {
          name: rule.name,
          list: [],
          id: rule.id
        };
        ruleItem.list = ruleItem.list.concat(rule.properties);
        rules[index] = ruleItem;
      });
    });
    return rules;
  },
  getRulePropertyInfo: function getRulePropertyInfo(args) {
    var checkedRuleIds = args.checkedRuleIds;
    var sameRuleDishList = this.props.sameRuleDishList;

    var ruleList = this.sameRuleList;
    var flags = sameRuleDishList.map(function (dish) {
      return dish.ruleFlag;
    });
    var disabledRuleIdMap = {};
    if (ruleList.length === 1) {
      return { checkedRuleIds: checkedRuleIds, disabledRuleIdMap: disabledRuleIdMap };
    }

    var rulePropertiesForEach = function rulePropertiesForEach(func) {
      ruleList.forEach(function (rule, index) {
        var list = rule.list;

        list.forEach(function (property) {
          func(rule, property);
        });
      });
    };

    var matchFlag = function matchFlag(str, searchValue) {
      return ('-' + str + '-').indexOf('-' + searchValue + '-') > -1;
    };
    // clear invalid checked property id
    var predictableDishFlags = flags.filter(function (flag) {
      return matchFlag(flag, args.id);
    });
    rulePropertiesForEach(function (rule, property) {
      var exist = predictableDishFlags.filter(function (flag) {
        return matchFlag(flag, property.id);
      }).length > 0;
      if (!exist) {
        var checkedId = checkedRuleIds[rule.id];
        if (checkedId === property.id) {
          checkedRuleIds[rule.id] = -1;
        }
      }
    });

    // predict next step valid dish
    var ruleIds = (0, _keys2.default)(checkedRuleIds);
    var predictableDishFlagMap = {};
    ruleIds.forEach(function (ruleId) {
      var subCheckedRuleIds = [];
      ruleIds.forEach(function (_ruleId) {
        if (ruleId !== _ruleId && checkedRuleIds[_ruleId] !== -1) {
          subCheckedRuleIds.push(checkedRuleIds[_ruleId]);
        }
      });

      predictableDishFlagMap[ruleId] = flags.filter(function (flag) {
        var matched = true;
        subCheckedRuleIds.forEach(function (item) {
          matched &= flag.indexOf(item) > -1;
        });
        return matched;
      });
    });

    rulePropertiesForEach(function (rule, property) {
      var exist = predictableDishFlagMap[rule.id].filter(function (flag) {
        return matchFlag(flag, property.id);
      }).length > 0;
      if (!exist) {
        disabledRuleIdMap[property.id] = true;
      }
    });
    return { checkedRuleIds: checkedRuleIds, disabledRuleIdMap: disabledRuleIdMap };
  },
  setDishRuleProps: function setDishRuleProps(categoryId, id) {
    var checkedRuleIds = this.state.checkedRuleIds;
    var sameRuleDishList = this.props.sameRuleDishList;

    var nextCheckedRuleIds = (0, _assign2.default)({}, checkedRuleIds);
    var ruleIds = [];

    nextCheckedRuleIds[categoryId] = id;
    for (var name in nextCheckedRuleIds) {
      if (nextCheckedRuleIds.hasOwnProperty(name)) {
        ruleIds.push(nextCheckedRuleIds[name]);
      }
    }

    var ruleFlag = ruleIds.sort().join('-');
    var nextDish = sameRuleDishList.filter(function (item) {
      return item.ruleFlag === ruleFlag;
    })[0];
    var historyDish = this.historyDishMap[ruleFlag];
    var nextState = this.getRulePropertyInfo({
      id: id,
      nextDish: nextDish,
      checkedRuleIds: nextCheckedRuleIds
    });

    if (historyDish) {
      nextState.dish = historyDish;
    } else if (nextDish) {
      nextState.dish = nextDish.set('order', this.getNewDishOrder(nextDish));
    } else {
      nextState.dish = this.getVirtualDish();
    }
    this.setState(nextState);
  },
  buildDishCounter: function buildDishCounter(dish) {
    var _this = this;

    if (dish.isVirtualDish) {
      return false;
    }

    if (dish.clearStatus) {
      return React.createElement(
        'span',
        { className: 'dish-detail-addtocarta-soldout' },
        React.createElement(_formattedMessage2.default, _dishMenu2.default.soldout)
      );
    }

    return React.createElement(Counter, {
      step: dish.stepNum || 1,
      maximum: this.props.maximum,
      minimum: dish.dishIncreaseUnit || 1,
      count: helper.getDishesCount([dish]),
      onCountChange: function onCountChange(count, increment) {
        return _this.onDishItemCountChange(increment);
      },
      dishItem: dish,
      ifShowToolTip: this.props.ifShowToolTip,
      flag: true
    });
  },
  showToast: function showToast(text, time) {
    var _this2 = this;

    var _time = time === undefined || time === null ? 3000 : time;
    this.setState({ toast: 1, tipText: text });
    setTimeout(function () {
      _this2.setState({ toast: 0, tipText: '' });
    }, _time);
  },
  render: function render() {
    var _this3 = this;

    var _state = this.state,
        dish = _state.dish,
        checkedRuleIds = _state.checkedRuleIds,
        disabledRuleIdMap = _state.disabledRuleIdMap;
    var _props2 = this.props,
        _props2$confirmButton = _props2.confirmButtonText,
        confirmButtonText = _props2$confirmButton === undefined ? React.createElement(_formattedMessage2.default, _dishMenu2.default.addToShoppingCart) : _props2$confirmButton,
        showMemberPriceInfo = _props2.showMemberPriceInfo;


    return React.createElement(
      'div',
      { className: 'single-dish-detail o-flex o-flex--column' },
      React.createElement(
        'div',
        { className: 'dish-detail-close--modify', onTouchTap: this.props.onCloseBtnTap },
        React.createElement('a', { className: 'btn-close' })
      ),
      React.createElement(DishDetailHead, { dish: dish, showMemberPriceInfo: showMemberPriceInfo, onCountChange: this.onDishItemCountChange }),
      React.createElement(DishPropsSelect, {
        showMemberPriceInfo: showMemberPriceInfo,
        onSelectPropsOption: this.onSelectPropsOption,
        dish: dish,
        checkedRuleIds: checkedRuleIds,
        disabledRuleIdMap: disabledRuleIdMap,
        sameRuleList: this.sameRuleList,
        onDishRuleChecked: this.setDishRuleProps
      }),
      React.createElement(
        'div',
        { className: 'dish-detail-addtocarta o-flex__fixed o-border--top' },
        this.buildDishCounter(dish),
        React.createElement(
          'div',
          { style: { flex: 1 } },
          React.createElement(
            'button',
            {
              className: classnames('o-btn o-btn--linear', {
                'o-btn--grey': dish.clearStatus
              }),
              onTouchTap: function onTouchTap(evt) {
                evt.preventDefault();
                if (dish.clearStatus) {
                  return false;
                }
                return _this3.onAddToCarBtnTap();
              }
            },
            confirmButtonText
          )
        )
      ),
      this.state.toast === 1 && React.createElement(
        'div',
        { className: 'c-toast' },
        React.createElement(
          'div',
          { className: 'c-toast__content' },
          React.createElement('img', { src: toastIcon, style: { width: 28 }, alt: '' }),
          this.state.tipText
        )
      )
    );
  }
});

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _commonHelper = __webpack_require__(3);

var React = __webpack_require__(2);
var DynamicClassButton = __webpack_require__(450)('button');
var shallowCompare = __webpack_require__(120);
__webpack_require__(622);
var dishIconMian = __webpack_require__(623);


module.exports = React.createClass({
  displayName: 'DishPropsOption',
  propTypes: {
    id: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    name: React.PropTypes.string.isRequired,
    reprice: React.PropTypes.number.isRequired,
    isChecked: React.PropTypes.bool.isRequired,
    onTouchTap: React.PropTypes.func.isRequired,
    showMemberPriceInfo: React.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      isChecked: false
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  getCharNumber: function getCharNumber(name) {
    if (name == null) return 0;
    if (typeof name !== 'string') {
      name += '';
    }
    return name.replace(/[^\x00-\xff]/g, '01').length;
  },

  // 显示限免加料标签
  renderTags: function renderTags(tag) {
    var type = sessionStorage.getItem('tagsType');
    // ​只是堂食下的快餐才展示
    if (!type || type === 'WM') {
      return;
    }
    return tag && React.createElement(
      'div',
      { className: 'free-time' },
      React.createElement('img', { src: dishIconMian })
    );
  },
  render: function render() {
    var _props = this.props,
        id = _props.id,
        name = _props.name,
        reprice = _props.reprice,
        memberReprice = _props.memberReprice,
        isChecked = _props.isChecked,
        onTouchTap = _props.onTouchTap,
        showMemberPriceInfo = _props.showMemberPriceInfo,
        tag = _props.tag;
    // const isShowMemberPrice = showMemberPriceInfo && memberReprice > 0;

    var isShowMemberPrice = showMemberPriceInfo && memberReprice >= 0; // 消除memberReprice为0的影响


    return React.createElement(
      DynamicClassButton,
      { className: 'dish-porps-option', 'data-id': id, 'data-reprice': reprice, isChecked: isChecked, onTouchTap: onTouchTap },
      this.renderTags(tag),
      React.createElement(
        'span',
        { className: 'o-flex dish-porps-layout' },
        React.createElement(
          'span',
          { className: 'name o-flex__fluid' },
          name
        ),
        reprice !== 0 ? React.createElement(
          'span',
          { className: 'extra o-flex__fixed' },
          isShowMemberPrice && React.createElement(
            'span',
            null,
            memberReprice >= 0 ? '' : '-',
            React.createElement(
              'span',
              { className: 'price' },
              Math.abs(memberReprice)
            )
          ),
          React.createElement(
            'span',
            { className: '' + (!!isShowMemberPrice && 'dish-porps-option-line-thought') },
            reprice > 0 ? '' : '-',
            React.createElement(
              'span',
              { className: 'price' },
              Math.abs(reprice)
            )
          )
        ) : false
      )
    );
  }
});

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/dish-icon-mian.svg";

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _registerDivolte = __webpack_require__(124);

var _registerDivolte2 = _interopRequireDefault(_registerDivolte);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(626);

var React = __webpack_require__(2);
var Immutable = __webpack_require__(77);
var helper = __webpack_require__(43);
var DishDetailHead = __webpack_require__(531);
var ChildDish = __webpack_require__(627);
var Counter = __webpack_require__(461);
var classnames = __webpack_require__(50);
var toastIcon = __webpack_require__(267);

module.exports = React.createClass({
  displayName: 'GroupDishDetail',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    onAddToCarBtnTap: React.PropTypes.func.isRequired,
    confirmButtonText: React.PropTypes.string,
    showMemberPriceInfo: React.PropTypes.bool
  },
  getInitialState: function getInitialState() {
    var dish = this.props.dish;

    var initRulePropertyChecked = function initRulePropertyChecked(dishPropertyTypeInfos) {
      return dishPropertyTypeInfos.flatMap(function (info) {
        if (info.type !== 4) {
          return info;
        }
        return info.update('properties', function (properties) {
          return properties.flatMap(function (item) {
            return item.set('isChecked', true);
          });
        });
      });
    };

    var dishForDetail = dish.setIn(['order'], Immutable.from([{
      count: 0,
      groups: dish.groups
    }])).updateIn(
    // process each childDish, if it is default dish, make its order count to its leastCellNum.
    ['order', 0, 'groups'], function (groups) {
      return groups.flatMap(function (group) {
        return group.update('childInfos', function (childDishes) {
          // 设置子菜排序
          var childDishes_ = Immutable.from([].concat(childDishes).sort(function (a, b) {
            return a.sort - b.sort;
          }));
          return childDishes_.flatMap(function (childDish) {
            var count = childDish.isDefault || childDish.isReplace ? childDish.leastCellNum : 0;
            if (helper.isSingleDishWithoutProps(childDish)) {
              return childDish.set('isChildDish', true).set('order', count);
            }
            return childDish.set('isChildDish', true).set('order', Immutable.from([{
              count: count,
              dishPropertyTypeInfos: initRulePropertyChecked(childDish.dishPropertyTypeInfos),
              dishIngredientInfos: childDish.dishIngredientInfos
            }]));
          });
        });
      });
    });
    return {
      activeGroupIdx: 0,
      dish: dishForDetail,
      toast: 0,
      toastText: '',
      groupsValid: true,
      closeModal: true,
      dishModalShow: false,
      childDishExpand: false
    };
  },
  handleChangeExpand: function handleChangeExpand(value) {
    this.setState({ childDishExpand: value });
  },
  componentDidUpdate: function componentDidUpdate() {},
  onChildDishChange: function onChildDishChange(targetDish) {
    var dish = this.state.dish;

    var activeGroupIdx = parseInt(this.refs.blockIdx.getAttribute('data-blockidx'), 10);

    this.setState({
      activeGroupIdx: activeGroupIdx,
      dish: dish.updateIn(['order', 0, 'groups', activeGroupIdx, 'childInfos'], function (childInfos) {
        return childInfos.flatMap(function (childDish) {
          return childDish.id === targetDish.id ? targetDish : childDish;
        });
      })
    });
  },
  onGroupDishCountChange: function onGroupDishCountChange(increment) {
    var dishForDetail = this.state.dish;
    var _dishForDetail$dishIn = dishForDetail.dishIncreaseUnit,
        dishIncreaseUnit = _dishForDetail$dishIn === undefined ? 1 : _dishForDetail$dishIn;

    var oldDishDataForCart = this.props.dish;
    var oldCountForDetail = helper.getDishesCount([dishForDetail]);
    var oldCountForCart = helper.getDishesCount([oldDishDataForCart]);
    var newCountForDetail = void 0;
    if (oldCountForDetail === 0 && oldCountForCart === 0) {
      // if never ordered this dish;
      newCountForDetail = dishIncreaseUnit;
    } else if (oldCountForCart === 0 && oldCountForDetail + increment < dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCountForDetail = 0;
    } else {
      newCountForDetail = oldCountForDetail + increment;
    }
    this.setState({
      dish: dishForDetail.setIn(['order', 0, 'count'], newCountForDetail)
    });
  },

  /**
   * 埋点购物车
   */
  buryingPointAddToCart: function buryingPointAddToCart() {
    var dish = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    try {
      var pageType = (0, _registerDivolte.getPageTypeFromUrl)();
      _registerDivolte2.default.send('AddToShoppingCart', { commodityId: dish.id || '', pageType: pageType });
    } catch (ex) {
      console.error(ex);
    }
  },
  onAddToCarBtnTap: function onAddToCarBtnTap() {
    var _this = this;

    var onAddToCarBtnTap = this.props.onAddToCarBtnTap;
    var dish = this.state.dish;

    var firstOrder = dish.order[0];
    var dishCount = helper.getDishesCount([dish]);
    if (!firstOrder) {
      return false;
    }

    if (dishCount <= 0) {
      this.showToast(React.createElement(_formattedMessage2.default, _dishMenu2.default.chooseGroupDishCount));
      return false;
    }

    var invalidRets = [];
    var invalidGroupsIndexes = [];
    firstOrder.groups.forEach(function (dishGroup, index) {
      var orderedCount = helper.getDishesCount(helper.getOrderedDishes(dishGroup.childInfos));
      var isValid = true;
      var message = '';

      // 新增判断必须菜是否选够
      dishGroup.childInfos.forEach(function (replaceDish) {
        if (replaceDish.isReplace) {
          var replaceDishCount = helper.getDishesCount([replaceDish]);
          if (replaceDishCount < replaceDish.leastCellNum) {
            isValid = false;
            message = React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.mushDishCount, {
              values: {
                dishGroupName: dishGroup.name,
                replaceDishName: replaceDish.name,
                leastCellNum: replaceDish.leastCellNum
              }
            }));
            invalidRets.push({ message: message, isValid: isValid });
          }
        }
      });

      if (orderedCount > dishGroup.orderMax) {
        // message = '子菜份数超出可选范围';
        message = React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.childDishOverMax, { values: { dishGroupName: dishGroup.name } }));
      } else if (orderedCount < dishGroup.orderMin) {
        // message = '请选择足够的子菜份数';
        message = React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.childDishLessMin, { values: { dishGroupName: dishGroup.name } }));
        isValid = false;
        invalidGroupsIndexes.push(index);
      }
      if (!isValid) {
        invalidRets.push({ message: message, isValid: isValid });
        _this.setState({ groupsValid: false });
        _this.setState({
          activeGroupIdx: Math.min.apply(null, invalidGroupsIndexes)
        });
      }
    });

    if (invalidRets.length) {
      this.showToast(invalidRets.shift().message);
      return false;
    }
    this.buryingPointAddToCart(dish);
    onAddToCarBtnTap(dish, dishCount);
    return true;
  },
  onDishCartModalTap: function onDishCartModalTap() {
    this.setState({ closeModal: !this.state.closeModal });
  },
  onDishModalShow: function onDishModalShow(state) {
    this.setState({ dishModalShow: state });
  },
  showToast: function showToast(text) {
    var _this2 = this;

    this.setState({ toast: 1, toastText: text });

    setTimeout(function () {
      _this2.setState({ toast: 0, toastText: '' });
    }, 3000);
  },
  buildDishCounter: function buildDishCounter(dish) {
    var _this3 = this;

    if (dish.isVirtualDish) {
      return false;
    }

    if (dish.clearStatus) {
      return React.createElement(
        'span',
        { className: 'dish-detail-addtocarta-soldout' },
        React.createElement(_formattedMessage2.default, _dishMenu2.default.soldout)
      );
    }

    return React.createElement(Counter, {
      step: dish.stepNum || 1,
      minimum: dish.dishIncreaseUnit || 1,
      count: helper.getDishesCount([dish]),
      onCountChange: function onCountChange(count, increment) {
        return _this3.onGroupDishCountChange(increment);
      },
      dishItem: dish,
      flag: true
    });
  },
  buildGroupBlock: function buildGroupBlock(forCartModal) {
    var _this4 = this;

    var dish = this.state.dish;

    var groups = dish.order[0].groups;
    var modalTitleArray = [];

    var groupBlock = groups.map(function (groupData, idx) {
      var id = groupData.id,
          name = groupData.name,
          orderMin = groupData.orderMin,
          orderMax = groupData.orderMax;


      var dishCount = helper.getDishesCount(groupData.childInfos);
      if (forCartModal && dishCount > 0) {
        modalTitleArray.push(dishCount + '\u4EFD' + name);
      }

      return !forCartModal || forCartModal && dishCount > 0 ? React.createElement(
        'div',
        { className: 'group-block', key: id, 'data-idx': idx },
        React.createElement(
          'div',
          { className: classnames('group-block__title') },
          React.createElement(
            'strong',
            null,
            name,
            ' '
          ),
          React.createElement(
            'small',
            { style: { float: 'right' } },
            React.createElement(_formattedMessage2.default, _dishMenu2.default.picked),
            React.createElement(
              'span',
              { className: 'dish-count' },
              dishCount
            ),
            React.createElement(_formattedMessage2.default, _dishMenu2.default.dishCount),
            '/',
            React.createElement(_formattedMessage2.default, _dishMenu2.default.mustChecked),
            orderMin !== orderMax ? orderMin + '~' : false,
            orderMax,
            React.createElement(_formattedMessage2.default, _dishMenu2.default.dishCount)
          )
        ),
        _this4.buildGroupDishes(groupData, forCartModal)
      ) : false;
    });

    if (forCartModal && modalTitleArray.length > 0) {
      var closeModal = this.state.closeModal;

      return React.createElement(
        'div',
        { className: 'dish-cart-modal__content' },
        React.createElement(
          'div',
          {
            className: classnames('dish-cart-modal__title', {
              'is-open': !closeModal
            }),
            onTouchTap: this.onDishCartModalTap
          },
          React.createElement(
            'label',
            null,
            React.createElement(_formattedMessage2.default, _dishMenu2.default.picked)
          ),
          modalTitleArray.map(function (subTitle, index) {
            return React.createElement(
              'span',
              { className: 'dish-cart-modal__title-sub', key: index },
              subTitle
            );
          })
        ),
        React.createElement(
          'div',
          {
            className: classnames('dish-cart-modal__block', {
              'dish-cart-modal--hide': closeModal
            })
          },
          groupBlock
        )
      );
    }

    return groupBlock;
  },
  buildCartModal: function buildCartModal() {
    var closeModal = this.state.closeModal;

    return React.createElement(
      'div',
      { className: 'dish-cart-modal' },
      React.createElement('div', {
        className: classnames('dish-cart-modal__close', {
          'dish-cart-modal--hide': closeModal
        }),
        onTouchTap: this.onDishCartModalTap
      }),
      this.buildGroupBlock(true)
    );
  },
  buildGroupDishes: function buildGroupDishes(groupData, forCartModal) {
    var _this5 = this;

    if (!groupData) {
      return null;
    }
    var childDishes = groupData.childInfos;
    function divideDishes(dishes) {
      return [].concat.apply([], dishes.map(function (dish) {
        if (helper.isSingleDishWithoutProps(dish)) {
          return [(0, _assign2.default)({}, dish, { key: '' + dish.id })];
        }
        return dish.order.map(function (dishOrder, idx) {
          return (0, _assign2.default)({}, dish, { key: dish.id + '-' + idx }, { order: [(0, _assign2.default)({}, dishOrder)] });
        });
      }));
    }
    if (forCartModal) {
      childDishes = divideDishes(groupData.childInfos);
    }

    var remainCount = groupData.orderMax - helper.getDishesCount(groupData.childInfos);
    var _props = this.props,
        showMemberPriceInfo = _props.showMemberPriceInfo,
        dish = _props.dish;
    var _dish$isMember = dish.isMember,
        isMember = _dish$isMember === undefined ? false : _dish$isMember;

    return childDishes.map(function (childDish, index) {
      var cDish = Immutable.isImmutable(childDish) ? childDish.set('isMember', isMember) : (0, _extends3.default)({}, childDish, { isMember: isMember });
      return React.createElement(
        'div',
        { key: index },
        React.createElement(ChildDish, {
          key: forCartModal ? childDish.key : childDish.id
          // dish={childDish}
          , dish: cDish,
          showMemberPriceInfo: showMemberPriceInfo,
          remainCount: remainCount,
          onDishChange: _this5.onChildDishChange,
          forCartModal: forCartModal,
          onDishModalShow: _this5.onDishModalShow,
          showHandleInput: _this5.props.showHandleInput,
          handleChangeExpand: _this5.handleChangeExpand
        }),
        index + 1 === childDishes.length && React.createElement('div', { className: 'o-border--bottom o-border--bottom__modify' })
      );
    });
  },
  render: function render() {
    var _this6 = this;

    var _state = this.state,
        dish = _state.dish,
        closeModal = _state.closeModal;
    var _props2 = this.props,
        _props2$confirmButton = _props2.confirmButtonText,
        confirmButtonText = _props2$confirmButton === undefined ? React.createElement(_formattedMessage2.default, _dishMenu2.default.addToShoppingCart) : _props2$confirmButton,
        showMemberPriceInfo = _props2.showMemberPriceInfo;


    return React.createElement(
      'div',
      { className: 'group-dish-detail' },
      React.createElement(
        'div',
        { className: 'dish-detail-close--modify', onTouchTap: function onTouchTap(event) {
            return _this6.props.onCloseBtnTap(event);
          } },
        React.createElement('a', { className: 'btn-close' })
      ),
      React.createElement(DishDetailHead, { minimum: 1, dish: dish, showMemberPriceInfo: showMemberPriceInfo, onCountChange: this.onGroupDishCountChange, shouldInitCount: true }),
      React.createElement(
        'div',
        { className: 'dish-detail-title-line' },
        React.createElement('i', { className: 'dish-detail-title-line__left' }),
        React.createElement(
          'span',
          null,
          React.createElement(_formattedMessage2.default, _dishMenu2.default.choseGroup)
        ),
        React.createElement('i', { className: 'dish-detail-title-line__right' })
      ),
      React.createElement(
        'div',
        {
          ref: 'blockIdx',
          className: 'dishes-container',
          style: {
            flex: 1,
            minHeight: '101%',
            maxHeight: 360,
            webkitOverflowScrolling: this.state.childDishExpand ? 'auto' : 'touch'
          }
        },
        this.buildGroupBlock()
      ),
      React.createElement(
        'div',
        { className: 'dish-detail-addtocarta o-flex__fixed o-border--top' },
        this.buildDishCounter(dish),
        React.createElement(
          'div',
          { style: { flex: 1 } },
          React.createElement(
            'button',
            {
              className: classnames('o-btn o-btn--linear', {
                'o-btn--grey': dish.clearStatus
              }),
              onTouchTap: function onTouchTap(evt) {
                if (dish.clearStatus) {
                  return false;
                }
                return _this6.onAddToCarBtnTap();
              }
            },
            confirmButtonText
          )
        )
      ),
      this.state.toast === 1 && React.createElement(
        'div',
        { className: 'c-toast' },
        React.createElement(
          'div',
          { className: 'c-toast__content' },
          React.createElement('img', { src: toastIcon, style: { width: 28 }, alt: '' }),
          this.state.toastText
        )
      ),
      React.createElement('div', {
        className: classnames('dish-cart-modal__close', {
          'dish-cart-modal--hide': closeModal
        }),
        onTouchTap: this.onDishCartModalTap
      }),
      this.buildCartModal()
    );
  }
});

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _counter = __webpack_require__(461);

var _counter2 = _interopRequireDefault(_counter);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var _findIndex = __webpack_require__(452);
var helper = __webpack_require__(43);

var DishDetailHead = __webpack_require__(531);
var DishPropsSelect = __webpack_require__(560);
var toastIcon = __webpack_require__(267);
window.I = __webpack_require__(77);
var classnames = __webpack_require__(50);
__webpack_require__(628);

var addToGroupFlag = false;

module.exports = React.createClass({
  displayName: 'GroupDishDetailChildDish',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    remainCount: React.PropTypes.number.isRequired,
    onDishChange: React.PropTypes.func.isRequired,
    forCartModal: React.PropTypes.bool,
    onDishModalShow: React.PropTypes.func,
    showMemberPriceInfo: React.PropTypes.bool
  },
  getInitialState: function getInitialState() {
    var dish = this.props.dish;

    return {
      tempDish: dish,
      deleteDish: dish,
      deleteDishCopy: dish,
      expand: false,
      deleteExpand: false,
      toast: 0,
      toastText: ''
    };
  },
  onCountChange: function onCountChange(newCount, increment) {
    var _props = this.props,
        dish = _props.dish,
        onDishChange = _props.onDishChange;

    var oldCount = helper.getDishesCount([dish]);

    if (oldCount === 0) {
      newCount = dish.leastCellNum;
    } else if (oldCount + increment < dish.leastCellNum) {
      newCount = 0;
    } else {
      newCount = oldCount + increment;
    }

    onDishChange(dish.update('order', function (order) {
      return helper.isSingleDishWithoutProps(dish) ? newCount : order.setIn([0, 'count'], parseInt(newCount, 10));
    }));
  },
  onCountChange2: function onCountChange2(newCount, increment) {
    var dishForTemp = this.state.tempDish;
    var oldCount = helper.getDishesCount([dishForTemp]);

    // if (oldCount === 0) {
    //   newCount = dishForTemp.leastCellNum;
    // } else if (oldCount + increment < dishForTemp.leastCellNum) {
    //   newCount = 0;
    // } else {
    //   newCount = oldCount + increment;
    // }
    newCount = oldCount + increment;
    if (helper.isSingleDishWithoutProps(dishForTemp)) {
      this.setState({ tempDish: dishForTemp.set('order', newCount) });
    } else {
      this.setState({
        tempDish: dishForTemp.setIn(['order', 0, 'count'], newCount)
      });
    }
  },
  onOrderDish: function onOrderDish(tempDish) {
    var _props2 = this.props,
        dish = _props2.dish,
        onDishChange = _props2.onDishChange;
    // for single dish with props

    var orderIdx = _findIndex(dish.order === undefined ? [] : dish.order,
    // { dishPropertyTypeInfos:payload[0].order[0].dishPropertyTypeInfos }
    { dishIngredientInfos: tempDish.order[0].dishIngredientInfos, dishPropertyTypeInfos: tempDish.order[0].dishPropertyTypeInfos });
    if (orderIdx !== -1) {
      if (tempDish.order[0].count === 0) {
        return;
      }
      var count = dish.order[orderIdx].count + tempDish.order[0].count;
      // if find the order with same props, just add the count of the exsited order;
      onDishChange(dish.setIn(['order', orderIdx, 'count'], count));
      if (count <= 0) {
        // if order's count is 0, remove it.
        onDishChange(dish.updateIn(['order'], function (order) {
          return order.flatMap(function (eachOrder, idx) {
            return orderIdx === idx ? [] : eachOrder;
          });
        }).updateIn(['order'], function (order) {
          return order.flatMap(function (eachorder) {
            return eachorder.count === 0 ? [] : eachorder;
          });
        }));
      }
    } else {
      // if cannot find the order with same props,add it as new order;
      // if order's count is 0, remove it.
      onDishChange(dish.updateIn(['order'], function (order) {
        return order === undefined ? tempDish.order : order.concat(tempDish.order);
      }).updateIn(['order'], function (order) {
        return order.flatMap(function (eachorder) {
          return eachorder.count === 0 ? [] : eachorder;
        });
      }));
    }
  },

  /**
   * 校验
   * 增加必选校验
   * @return boolean
   */
  valid: function valid() {
    var _this = this;

    var res = true;
    var tempDish = this.state.tempDish;

    if (!tempDish || !tempDish.hasOwnProperty('order') || !Array.isArray(tempDish.order) || !tempDish.order[0]) return res; // 不满足条件都默认校验通过
    var dishPropertyTypeInfos = tempDish.order[0].dishPropertyTypeInfos;

    if (!dishPropertyTypeInfos || !Array.isArray(dishPropertyTypeInfos)) return res;
    for (var i = 0, l = dishPropertyTypeInfos.length; i < l; i++) {
      var _dishPropertyTypeInfo = dishPropertyTypeInfos[i],
          isMandatory = _dishPropertyTypeInfo.isMandatory,
          properties = _dishPropertyTypeInfo.properties,
          name = _dishPropertyTypeInfo.name;

      if (isMandatory === 1) {
        // 选项中没有一个被设置为选中
        if (!properties.some(function (pro) {
          return pro.isChecked;
        })) {
          this.setState({ toast: 1, toastText: '\u8BF7\u9009\u62E9' + name });
          setTimeout(function () {
            _this.setState({ toast: 0 });
          }, 1000);
          res = false;
          break;
        }
      }
    }
    return res;
  },
  onAddToGroupTap: function onAddToGroupTap() {
    var _this2 = this;

    if (!this.valid()) return;
    var tempDish = this.state.tempDish;
    // 未选择菜品份数

    if (!addToGroupFlag) {
      this.setState({ toast: 1, toastText: React.createElement(_formattedMessage2.default, _dishMenu2.default.notChooseDish) });
      setTimeout(function () {
        _this2.setState({ toast: 0 });
      }, 3000);
      return;
    }
    this.onOrderDish(tempDish);
    this.onCloseModalTap();
  },
  onDeleteToGroupTap: function onDeleteToGroupTap() {
    var _this3 = this;

    var _props3 = this.props,
        dish = _props3.dish,
        onDishChange = _props3.onDishChange;
    var _state = this.state,
        deleteDishCopy = _state.deleteDishCopy,
        deleteDish = _state.deleteDish;

    var state = false;
    var cnt = 0;
    var leastCnt = 0;
    for (var i = 0; i < deleteDish.order.length; i++) {
      var dishOrder = deleteDish.order[i];
      if (dishOrder.countChange === undefined || dishOrder.count === dishOrder.countChange) {
        cnt += 1;
      }
      leastCnt += dishOrder.countChange === undefined ? dishOrder.count : dishOrder.countChange;
    }
    if (state || cnt === deleteDish.order.length) {
      this.setState({ toast: 1, toastText: React.createElement(_formattedMessage2.default, _dishMenu2.default.chooseDeleteDish) });
      setTimeout(function () {
        _this3.setState({ toast: 0 });
      }, 3000);
      return;
    }
    // 必选菜必须保留起卖份数
    if (deleteDish.isReplace && deleteDish.leastCellNum > leastCnt) {
      this.setState({
        toast: 1,
        toastText: React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.keepLeastCellNum, { values: { leastCellNum: deleteDish.leastCellNum } }))
      });
      setTimeout(function () {
        _this3.setState({ toast: 0 });
      }, 3000);
      return;
    }

    var dOrder = deleteDishCopy.updateIn(['order'], function (order) {
      return order.flatMap(function (eachOrder, idx) {
        return eachOrder.count === 0 && idx !== 0 ? [] : eachOrder;
      });
    });
    onDishChange(dish.setIn(['order'], dOrder.order));
    this.onCloseDeleteModalTap();
  },
  onDeleteToGroupTap2: function onDeleteToGroupTap2(evt) {
    var _props4 = this.props,
        dish = _props4.dish,
        onDishChange = _props4.onDishChange;

    this.onSetBlockIdx(evt);
    onDishChange(dish.updateIn(['order'], function (order) {
      return order.flatMap(function (eachOrder, idx) {
        return idx !== 0 ? [] : eachOrder;
      });
    }).setIn(['order', 0, 'count'], 0).updateIn(['order', 0, 'dishIngredientInfos'], function (infos) {
      return infos.flatMap(function (info) {
        return info.set('isChecked', false);
      });
    }).updateIn(['order', 0, 'dishPropertyTypeInfos'], function (infos) {
      return infos.flatMap(function (info) {
        return info.update('properties', function (props) {
          return props.flatMap(function (prop) {
            return prop.set('isChecked', false);
          });
        });
      });
    }));
  },
  onSelectPropsOption: function onSelectPropsOption(propData, optionData) {
    var _props5 = this.props,
        dish = _props5.dish,
        onDishChange = _props5.onDishChange;

    var propIdx = -1;
    switch (propData.type) {
      case 1:
        propIdx = _findIndex(dish.order[0].dishPropertyTypeInfos, { id: propData.id });
        onDishChange(dish.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], function (options) {
          return options.flatMap(function (option) {
            if (option.id === optionData.id) {
              return option.set('isChecked', !option.isChecked);
            } else if (option.id !== optionData.id && option.isChecked === true) {
              return option.set('isChecked', false);
            }
            return option;
          });
        }));
        break;
      case 3:
        propIdx = _findIndex(dish.order[0].dishPropertyTypeInfos, { id: propData.id });
        onDishChange(dish.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], function (options) {
          return options.flatMap(function (option) {
            if (option.id === optionData.id) {
              return option.set('isChecked', !option.isChecked);
            }
            return option;
          });
        }));
        break;
      case -1:
        // this is a client workround for ingredientsData, we don't have this value of type on serverside
        onDishChange(dish.updateIn(['order', 0, 'dishIngredientInfos'], function (options) {
          return options.flatMap(function (option) {
            if (option.id === optionData.id) {
              return option.set('isChecked', !option.isChecked);
            }
            return option;
          });
        }));
        break;
      default:
    }
  },
  onDishItemCountChange: function onDishItemCountChange(increment) {
    var dishForDetail = this.state.tempDish;
    var dishForCart = this.props.dish;
    var countForDetail = helper.getDishesCount([dishForDetail]);
    var countForCart = helper.getDishesCount([dishForCart]);
    var newCountForDetail = void 0;

    if (countForDetail === 0 && countForCart === 0) {
      // if never ordered this dish;
      newCountForDetail = dishForDetail.dishIncreaseUnit;
    } else if (countForCart === 0 && countForDetail + increment < dishForDetail.dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCountForDetail = 0;
    } else {
      newCountForDetail = countForDetail + increment;
    }

    if (helper.isSingleDishWithoutProps(dishForDetail)) {
      this.setState({ tempDish: dishForDetail.set('order', newCountForDetail) });
    } else {
      this.setState({
        tempDish: dishForDetail.setIn(['order', 0, 'count'], newCountForDetail)
      });
    }
  },
  onSelectPropsOption2: function onSelectPropsOption2(propData, optionData) {
    var dishForTemp = this.state.tempDish;
    var propIdx = -1;
    switch (propData.type) {
      case 1:
        propIdx = _findIndex(dishForTemp.order[0].dishPropertyTypeInfos, { id: propData.id });
        this.setState({
          tempDish: dishForTemp.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], function (options) {
            return options.flatMap(function (option) {
              // if (option.id === optionData.id) {
              //   return option.set('isChecked', !option.isChecked);
              // } else if (option.id !== optionData.id && option.isChecked === true) {
              //   return option.set('isChecked', false);
              // }
              // return option;
              var isChecked = option.isChecked ? option.isChecked : false;
              if (option.id === optionData.id) {
                isChecked = !option.isChecked;
              } else if (option.id !== optionData.id && option.isChecked === true) {
                isChecked = false;
              }
              return option.set('isChecked', isChecked);
            });
          })
        });
        break;
      case 3:
        propIdx = _findIndex(dishForTemp.order[0].dishPropertyTypeInfos, { id: propData.id });
        this.setState({
          tempDish: dishForTemp.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], function (options) {
            return options.flatMap(function (option) {
              // if (option.id === optionData.id) {
              //   return option.set('isChecked', !option.isChecked);
              // }
              // return option;
              var isChecked = option.isChecked ? option.isChecked : false;
              if (option.id === optionData.id) {
                isChecked = !option.isChecked;
              }
              return option.set('isChecked', isChecked);
            });
          })
        });
        break;
      case -1:
        // this is a client workround for ingredientsData, we don't have this value of type on serverside
        this.setState({
          tempDish: dishForTemp.updateIn(['order', 0, 'dishIngredientInfos'], function (options) {
            return options.flatMap(function (option) {
              // if (option.id === optionData.id) {
              //   return option.set('isChecked', !option.isChecked);
              // }
              // return option;
              var isChecked = option.isChecked ? option.isChecked : false;
              if (option.id === optionData.id) {
                isChecked = !option.isChecked;
              }
              return option.set('isChecked', isChecked);
            });
          })
        });
        break;
      default:
    }
  },
  onSetBlockIdx: function onSetBlockIdx(evt) {
    var target = evt.target;
    while (target.className.indexOf('group-block') === -1) {
      target = target.parentNode;
    }
    target.parentNode.setAttribute('data-blockidx', target.getAttribute('data-idx'));
  },
  onPropsBtnTap: function onPropsBtnTap(evt) {
    var _this4 = this;

    var dish = this.props.dish;
    var dishCount = dish.order.map(function (order) {
      return order.count;
    }).reduce(function (c, p) {
      return c + p;
    }, 0);
    var count = dish.leastCellNum;

    if (dishCount >= dish.leastCellNum) {
      count = 1;
    }

    this.onSetBlockIdx(evt);

    this.setState({
      expand: !this.state.expand,
      tempDish: this.state.tempDish.setIn(['order', 0, 'count'], count)
    }, function () {
      _this4.props.handleChangeExpand(_this4.state.expand);
    });

    addToGroupFlag = true;
    this.props.onDishModalShow(true);
  },
  onCloseModalTap: function onCloseModalTap(e) {
    var _this5 = this;

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    var dishForTemp = this.state.tempDish;

    if (helper.isSingleDishWithoutProps(dishForTemp)) {
      dishForTemp = dishForTemp.set('order', 0);
    } else {
      dishForTemp = dishForTemp.setIn(['order', 0], this.props.dish.order[0]).setIn(['order', 0, 'count'], 0);
    }

    this.setState({
      expand: !this.state.expand,
      tempDish: dishForTemp
    }, function () {
      _this5.props.handleChangeExpand(_this5.state.expand);
    });
    this.props.onDishModalShow(false);
  },
  onCloseDeleteModalTap: function onCloseDeleteModalTap() {
    this.setState({
      deleteExpand: !this.state.deleteExpand
    });
    this.props.onDishModalShow(false);
  },
  onDishDeleteTap: function onDishDeleteTap(evt) {
    var dish = this.props.dish;


    this.onSetBlockIdx(evt);
    this.setState({
      deleteExpand: !this.state.deleteExpand,
      deleteDish: dish,
      deleteDishCopy: dish
    });
    this.props.onDishModalShow(true);
  },
  onSelectDeleteDish: function onSelectDeleteDish(index, i, step, flag) {
    var dishForTemp = this.state.deleteDish;
    var deleteDishCopy = this.state.deleteDishCopy;
    var isSelected = false;
    if (dishForTemp.order[index].isSelected === undefined) {
      isSelected = false;
    } else if (dishForTemp.order[index].isSelected[i] === undefined) {
      isSelected = false;
    } else {
      isSelected = dishForTemp.order[index].isSelected[i];
    }
    var count = dishForTemp.order[index].countChange === undefined ? dishForTemp.order[index].count : dishForTemp.order[index].countChange;
    if (!isSelected) {
      count -= step;
    } else {
      count += step;
    }
    this.setState({
      deleteDishCopy: deleteDishCopy.setIn(['order', index, 'count'], count),
      deleteDish: dishForTemp.setIn(['order', index, 'isSelected', i], !isSelected).setIn(['order', index, 'countChange'], count)
    });
  },
  buildDishCounter: function buildDishCounter(args) {
    var dish = args.dish,
        count = args.count,
        remainCount = args.remainCount;

    var leastCellNum = Math.max(dish.leastCellNum, 1);
    var maximum = count + remainCount;
    var minimum = 0;
    var msg = { minimumMsg: '', maximumMsg: '' };
    // 必选
    if (dish.isReplace) {
      minimum = leastCellNum;
      msg.minimumMsg = React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.mustCheckedMinCount, { values: { minimum: minimum } }));
      if (!dish.isMulti) {
        maximum = minimum;
        msg.maximum = React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.notMoreMaxCount, { values: { maximum: maximum } }));
      }
    } else {
      minimum = 0;
      if (dish.isMulti) {
        if (maximum < leastCellNum) {
          maximum = 0;
        }
      } else {
        maximum = leastCellNum > maximum ? 0 : leastCellNum;
        msg.maximum = React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.notMoreMaxCount, { values: { maximum: maximum } }));
      }
    }

    if (maximum < minimum) {
      maximum = minimum = 0;
      msg.maximumMsg = React.createElement(_formattedMessage2.default, _global2.default.onLimitMax);
    }
    return React.createElement(_counter2.default, {
      count: count,
      maximum: maximum,
      minimum: minimum,
      onCountChange: this.onCountChange,
      onTouchTap: this.onSetBlockIdx,
      msg: msg,
      ifShowToolTip: true,
      showHandleInput: this.props.showHandleInput
    });
  },
  buildDishCounter2: function buildDishCounter2(args) {
    var dishCount = helper.getDishesCount([this.props.dish]);
    var tempDish = args.tempDish,
        count2 = args.count2,
        remainCount = args.remainCount;

    var leastCellNum = Math.max(tempDish.leastCellNum, 1);
    var maximum = remainCount;
    var minimum = dishCount >= leastCellNum ? 1 : leastCellNum;
    var msg = { minimumMsg: React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.leastCellNum, { values: { leastCellNum: leastCellNum } })), maximumMsg: '' };

    if (leastCellNum <= dishCount) {
      minimum = 1;
      msg.minimumMsg = React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.chooseMinCount, { values: { count: 1 } }));
    }
    if (!tempDish.isMulti) {
      maximum = leastCellNum;
      if (leastCellNum === dishCount) {
        maximum = 0;
      }
      msg.maximumMsg = React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.chooseMaxCount, { values: { count: leastCellNum } }));
    }

    if (remainCount < maximum || maximum < minimum) {
      maximum = minimum = 0;
      msg.maximumMsg = React.createElement(_formattedMessage2.default, _global2.default.onLimitMax);
    }

    if (minimum === 0 && maximum === 0) {
      addToGroupFlag = false;
    }

    return React.createElement(_counter2.default, {
      count: minimum === 0 && maximum === 0 ? 0 : count2,
      maximum: maximum,
      minimum: minimum,
      onCountChange: this.onCountChange2,
      msg: msg,
      ifShowToolTip: true,
      showHandleInput: this.props.showHandleInput
    });
  },
  buildOrderBtn: function buildOrderBtn(dish, hasProps, remainCount, count) {
    var _this6 = this;

    var expand = this.state.expand;

    if (dish.clearStatus) {
      return React.createElement(
        'span',
        { className: 'dish-item-soldout' },
        React.createElement(_formattedMessage2.default, _dishMenu2.default.soldout)
      );
    }
    if (hasProps) {
      var countStyle = {};
      if (count < 10) {
        countStyle = { width: '15px' };
      } else if (count >= 10 && count <= 99) {
        countStyle = { width: '21px' };
      } else {
        countStyle = { width: '27px' };
      }
      return React.createElement(
        'div',
        { className: 'right' },
        React.createElement('span', {
          // onTouchTap={evt => this.onDishDeleteTap(evt)}
          onTouchTap: function onTouchTap(evt) {
            return _this6.onDeleteToGroupTap2(evt);
          },
          className: classnames({ 'dish-delete': true, 'dish-hide': expand || count <= 0 })
        }),
        React.createElement(
          'button',
          {
            // className="dish-dropdown-trigger btn--ellips"
            className: classnames('dish-dropdown-trigger btn--ellips', { 'btn--grey': remainCount <= 0 }),
            onTouchTap: function onTouchTap(evt) {
              if (remainCount <= 0) return false;
              return _this6.onPropsBtnTap(evt);
            }
          },
          React.createElement(_formattedMessage2.default, _dishMenu2.default.choseSpecification),
          React.createElement(
            'span',
            { className: classnames('child-dish--counter counter-special', { 'dish-hide': count <= 0 }), style: countStyle },
            count > 99 ? '99+' : count
          )
        )
      );
    }
    return this.buildDishCounter({ dish: dish, remainCount: remainCount, count: count });
  },
  buildDetailInfo: function buildDetailInfo(dish) {
    if (!dish.order[0]) return false;
    var _dish$order$ = dish.order[0],
        dishPropertyTypeInfos = _dish$order$.dishPropertyTypeInfos,
        dishIngredientInfos = _dish$order$.dishIngredientInfos;

    var RecipeProps = dishPropertyTypeInfos.filter(function (propInfo) {
      return propInfo.type === 1;
    });
    var NoteProps = dishPropertyTypeInfos.filter(function (propInfo) {
      return propInfo.type === 3;
    });
    function buildPropsText(propsInfo) {
      var checkedProps = propsInfo.properties.filter(function (props) {
        return props.isChecked;
      });
      if (checkedProps.length > 0) {
        return propsInfo.name + ': ' + checkedProps.map(function (props) {
          return props.name;
        }).join('、');
      }
      return '';
    }
    return React.createElement(
      'div',
      { className: 'detail-props-info' },
      RecipeProps.map(function (propInfo) {
        return buildPropsText(propInfo);
      }).filter(function (propsText) {
        return propsText;
      }).concat([buildPropsText({ name: (0, _helper.formatMessage)(_dishMenu2.default.ingredients), properties: dishIngredientInfos })].filter(function (propsText) {
        return propsText;
      }), NoteProps.map(function (propInfo) {
        return buildPropsText(propInfo);
      }).filter(function (propsText) {
        return propsText;
      })).join(' | ')
    );
  },
  buildDeleteDishes: function buildDeleteDishes(allDish) {
    var _this7 = this;

    function divideDishes(dish) {
      return [].concat.apply([], dish.order.map(function (dishOrder, idx) {
        return [(0, _assign2.default)({}, dish, { key: dish.id + '-' + idx }, { order: [(0, _assign2.default)({}, dishOrder)] })];
      }));
    }
    var childDishes = divideDishes(allDish);
    var step = allDish.leastCellNum ? allDish.leastCellNum : 1;
    var list = function list(length, dish, idx) {
      var res = [];

      var _loop = function _loop(i) {
        res.push(React.createElement(
          'div',
          {
            key: idx + '-' + i,
            'data-attr': idx,
            className: 'child-dish child-dish--delete',
            onTouchTap: function onTouchTap(evt) {
              evt.preventDefault();
              return _this7.onSelectDeleteDish(idx, i, i === 0 ? step : 1, i === 0);
            }
          },
          React.createElement(
            'div',
            {
              className: classnames('dish-name-wrap', {
                'is-selected': dish.order[0].isSelected && dish.order[0].isSelected[i],
                'dish-name-after': dish.order[0].isSelected && dish.order[0].isSelected[i]
              })
            },
            React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'dish-name o-text-ellipsis' },
                helper.generateDishNameWithUnit(dish),
                React.createElement(
                  'div',
                  { className: 'dish-count' },
                  'x',
                  i === 0 ? step : 1
                )
              )
            ),
            _this7.buildDetailInfo(dish)
          )
        ));
      };

      for (var i = 0; i < length; i === 0 ? i += step : i += 1) {
        _loop(i);
      }
      return res;
    };

    return childDishes.map(function (dish, idx) {
      return !dish.order[0].count ? false : list(dish.order[0].count, dish, idx);
    });
  },
  render: function render() {
    var _this8 = this;

    var _props6 = this.props,
        dish = _props6.dish,
        remainCount = _props6.remainCount,
        forCartModal = _props6.forCartModal,
        showMemberPriceInfo = _props6.showMemberPriceInfo;
    var order = dish.order,
        memberMarketPrice = dish.memberMarketPrice;

    var chooseOrderNum = typeof order === 'number' ? order : order[0].count;
    var _state2 = this.state,
        deleteDish = _state2.deleteDish,
        tempDish = _state2.tempDish,
        expand = _state2.expand,
        deleteExpand = _state2.deleteExpand;

    var hasProps = !helper.isSingleDishWithoutProps(dish);
    var count = helper.getDishesCount([dish]);
    var count2 = helper.getDishesCount([tempDish]);
    var marketPrice = dish.marketPrice || 0;
    if (forCartModal && count <= 0) {
      return false;
    }

    return React.createElement(
      'div',
      { className: 'child-dish' },
      React.createElement(
        'div',
        { className: 'child-dish__img' },
        React.createElement(_httpsProtocolImage2.default, { src: dish.imageUrl, alt: '' })
      ),
      React.createElement(
        'div',
        { className: 'dish-name-wrap', style: { flex: 1 } },
        forCartModal && count > 0 ? React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: classnames('dish-name o-text-ellipsis') },
            helper.generateDishNameWithUnit(dish),
            marketPrice !== 0 ? React.createElement(
              'span',
              { className: 'badge-price' },
              marketPrice > 0 ? '+ ' : '',
              memberMarketPrice > 0 && React.createElement(
                'span',
                { className: 'price', style: { marginRight: '5px' } },
                memberMarketPrice
              ),
              React.createElement(
                'span',
                { className: classnames('price', { 'child-dish__line_thought': memberMarketPrice > 0 }) },
                marketPrice
              )
            ) : false,
            dish.isReplace ? React.createElement('span', { className: 'badge-bi', 'data-bi': (0, _helper.formatMessage)(_dishMenu2.default.must) }) : false
          ),
          React.createElement(
            'div',
            { className: 'dish-count' },
            'x',
            count
          )
        ) : false,
        forCartModal ? this.buildDetailInfo(dish) : React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: classnames('dish-name o-text-ellipsis', { 'dish-name-after': chooseOrderNum }) },
            helper.generateDishNameWithUnit(dish),
            marketPrice !== 0 ? React.createElement(
              'span',
              { className: 'badge-price' },
              marketPrice > 0 ? '+ ' : '',
              memberMarketPrice >= 0 && React.createElement(
                'span',
                { className: 'price', style: { marginRight: '5px' } },
                memberMarketPrice
              ),
              React.createElement(
                'span',
                { className: classnames('price', { 'child-dish__line_thought': memberMarketPrice >= 0 }) },
                marketPrice
              )
            ) : false,
            dish.isReplace ? React.createElement('span', { className: 'badge-bi', 'data-bi': (0, _helper.formatMessage)(_dishMenu2.default.must) }) : false
          ),
          this.buildOrderBtn(dish, hasProps, remainCount, count)
        )
      ),
      expand ? React.createElement(
        'div',
        null,
        React.createElement('div', { className: 'dish-detail-modal-mask', onTouchTap: this.onCloseModalTap }),
        React.createElement(
          'div',
          { className: 'dish-detail-modal' },
          React.createElement(
            'div',
            { className: 'dish-detail-close--modify', onTouchTap: this.onCloseModalTap },
            React.createElement('a', { className: 'btn-close' })
          ),
          React.createElement(DishDetailHead, { showMemberPriceInfo: showMemberPriceInfo, dish: tempDish, onCountChange: this.onDishItemCountChange }),
          React.createElement(DishPropsSelect, { showMemberPriceInfo: showMemberPriceInfo, dish: tempDish, onSelectPropsOption: this.onSelectPropsOption2 }),
          React.createElement(
            'div',
            { className: 'dish-detail-addtocarta o-flex__fixed o-border--top' },
            this.buildDishCounter2({ tempDish: tempDish, remainCount: remainCount, count2: count2 }),
            React.createElement(
              'div',
              { style: { flex: 1 } },
              React.createElement(
                'button',
                {
                  className: classnames('btn--yellow', { 'btn--grey': dish.clearStatus }),
                  onTouchTap: function onTouchTap(evt) {
                    evt.preventDefault();
                    if (dish.clearStatus) {
                      return false;
                    }
                    return _this8.onAddToGroupTap();
                  }
                },
                React.createElement(_formattedMessage2.default, _dishMenu2.default.addToGroup)
              )
            )
          )
        )
      ) : false,
      deleteExpand ? React.createElement(
        'div',
        null,
        React.createElement('div', { className: 'dish-detail-modal-mask', onTouchTap: this.onCloseDeleteModalTap }),
        React.createElement(
          'div',
          { className: 'dish-detail-modal dish-detail-modal--delete o-flex o-flex--column' },
          React.createElement('a', { className: 'btn-close', onTouchTap: this.onCloseDeleteModalTap }),
          React.createElement(
            'div',
            { className: 'dish-detail-head o-flex__fixed' },
            React.createElement(_formattedMessage2.default, _dishMenu2.default.chooseDeleteDish)
          ),
          React.createElement(
            'div',
            { className: 'o-flex__fluid' },
            this.buildDeleteDishes(deleteDish)
          ),
          React.createElement(
            'div',
            { className: 'dish-detail-addtocarta o-flex__fixed o-border--top' },
            React.createElement(
              'button',
              {
                className: 'btn-delete',
                onTouchTap: function onTouchTap(evt) {
                  evt.preventDefault();
                  return _this8.onDeleteToGroupTap();
                }
              },
              React.createElement(_formattedMessage2.default, _dishMenu2.default.confirmDelete)
            )
          )
        )
      ) : false,
      this.state.toast === 1 && React.createElement(
        'div',
        { className: 'c-toast' },
        React.createElement(
          'div',
          { className: 'c-toast__content' },
          React.createElement('img', { src: toastIcon, style: { width: 28 }, alt: '' }),
          this.state.toastText
        )
      )
    );
  }
});

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(633);

__webpack_require__(530);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactIdSwiper = __webpack_require__(498);

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _adSwiper = __webpack_require__(634);

var _adSwiper2 = _interopRequireDefault(_adSwiper);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopSwiper = function (_React$Component) {
  (0, _inherits3.default)(ShopSwiper, _React$Component);

  function ShopSwiper(props) {
    (0, _classCallCheck3.default)(this, ShopSwiper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShopSwiper.__proto__ || (0, _getPrototypeOf2.default)(ShopSwiper)).call(this, props));

    _this.onTouchStart = _this.onTouchStart.bind(_this);
    _this.onTouchEnd = _this.onTouchEnd.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ShopSwiper, [{
    key: 'onTouchStart',
    value: function onTouchStart() {
      this.mySwiper.stopAutoplay();
    }
  }, {
    key: 'onTouchEnd',
    value: function onTouchEnd() {
      var _this2 = this;

      setTimeout(function () {
        _this2.mySwiper.startAutoplay();
      }, 500);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      // 处理图片高度
      var imgSize = this.props.imgSize;

      var imgHeight = imgSize === 0 ? '37.4vw' : '130px';
      var shopImgs = this.props.shopIntroImgs.map(function (item, index) {
        if (imgSize === undefined) {
          return _react2.default.createElement(
            'div',
            { key: index, className: 'o-pl o-pr o-pt o-pb' },
            _react2.default.createElement(_httpsProtocolImage2.default, { src: item.link, alt: '', style: { height: imgHeight } })
          );
        }
        if (imgSize === 0) {
          return _react2.default.createElement(
            'div',
            { key: index, className: 'o-pl o-pr o-pt o-pb' },
            _react2.default.createElement(
              'a',
              { href: item.url, style: { background: '#fff' } },
              _react2.default.createElement(_httpsProtocolImage2.default, { src: item.imgUrl, alt: '', style: { height: imgHeight } })
            )
          );
        }
        return true;
      });

      // 获取图片数量 根据图片数量判断是否显示.swiper-pageination
      var showNav = this.props.shopIntroImgs.length === 1 ? '.swiper-pagination .dis-none' : '.swiper-pagination';
      // 通过 resize 事件避免 swiper 不能正确加载的 bug
      // 有待改进
      var event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, true);
      document.dispatchEvent(event);

      // imgSize === 1  堂食 外卖轮播广告
      return imgSize === 1 ? _react2.default.createElement(_adSwiper2.default, {
        imgList: this.props.shopIntroImgs,
        autoplay: 3500
      }) : _react2.default.createElement(
        'div',
        { className: 'shop-swiper' },
        _react2.default.createElement(
          _reactIdSwiper2.default,
          {
            pagination: showNav,
            paginationClickable: true,
            autoplay: 2500,
            onTouchStart: this.onTouchStart,
            onTouchEnd: this.onTouchEnd,
            onInit: function onInit(swiper) {
              return _this3.mySwiper = swiper;
            },
            loop: this.props.shopIntroImgs.length > 1
          },
          shopImgs
        )
      );
    }
  }]);
  return ShopSwiper;
}(_react2.default.Component);

ShopSwiper.propTypes = {
  shopIntroImgs: _react2.default.PropTypes.array,
  imgSize: _react2.default.PropTypes.number
};

exports.default = ShopSwiper;

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(75);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

__webpack_require__(635);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRANSITION = 0.6;
var AdSwiper = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(AdSwiper, _React$Component);

  function AdSwiper() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AdSwiper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdSwiper.__proto__ || (0, _getPrototypeOf2.default)(AdSwiper)).call.apply(_ref, [this].concat(args))), _this), Object.defineProperty(_this, 'clientWith', {
      enumerable: true,
      writable: true,
      value: document.body.clientWidth
    }), Object.defineProperty(_this, 'bannerWidth', {
      enumerable: true,
      writable: true,
      value: _this.clientWith - 21
    }), Object.defineProperty(_this, 'startX', {
      enumerable: true,
      writable: true,
      value: 0
    }), Object.defineProperty(_this, 'endX', {
      enumerable: true,
      writable: true,
      value: 0
    }), Object.defineProperty(_this, 'touchIndex', {
      enumerable: true,
      writable: true,
      value: 1
    }), Object.defineProperty(_this, 'timer', {
      enumerable: true,
      writable: true,
      value: null
    }), Object.defineProperty(_this, 'state', {
      enumerable: true,
      writable: true,
      value: {
        translateX: -_this.bannerWidth,
        transition: TRANSITION,
        isShowMask: true
      }
    }), Object.defineProperty(_this, 'setAutoPlay', {
      enumerable: true,
      writable: true,
      value: function value() {
        var autoplay = _this.props.autoplay;

        if (autoplay) {
          _this.timer = setInterval(_this.nextView, autoplay);
        }
      }
    }), Object.defineProperty(_this, 'clearAutoPlay', {
      enumerable: true,
      writable: true,
      value: function value() {
        clearInterval(_this.timer);
        _this.timer = null;
      }
    }), Object.defineProperty(_this, 'setMaskHidden', {
      enumerable: true,
      writable: true,
      value: function value() {
        var isShowMask = _this.state.isShowMask;

        if (isShowMask) {
          _this.setState({
            isShowMask: false
          });
        }
      }
    }), Object.defineProperty(_this, 'touchStart', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.clearAutoPlay();
        _this.startX = e.changedTouches[0].clientX;
      }
    }), Object.defineProperty(_this, 'touchMove', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        var touchVal = e.touches[0].clientX;
        var move = touchVal - _this.startX;
        _this.setState({
          transition: 0,
          translateX: -_this.touchIndex * _this.bannerWidth + move
        });
      }
    }), Object.defineProperty(_this, 'touchEnd', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        _this.endX = e.changedTouches[0].clientX;
        if (_this.startX - _this.endX > 5) {
          _this.nextView();
        }
        if (_this.endX - _this.startX > 5) {
          _this.preView();
        }
      }
    }), Object.defineProperty(_this, 'nextView', {
      enumerable: true,
      writable: true,
      value: function value() {
        var len = _this.props.imgList.length + 2;
        if (_this.touchIndex >= len - 1) return;
        _this.clearAutoPlay();
        var returnFirst = _this.touchIndex === len - 2;
        // console.log('---returnFirst---', returnFirst);
        _this.touchIndex++;
        var left = -_this.touchIndex * _this.bannerWidth;
        _this.setState({
          transition: TRANSITION,
          translateX: left
        });
        if (returnFirst) {
          setTimeout(function () {
            _this.touchIndex = 1;
            _this.setState({
              transition: 0,
              translateX: -_this.bannerWidth
            });
            _this.setAutoPlay();
          }, 620);
        } else {
          _this.setAutoPlay();
        }
        _this.setMaskHidden();
      }
    }), Object.defineProperty(_this, 'preView', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (_this.touchIndex < 0) return;
        _this.clearAutoPlay();
        var len = _this.props.imgList.length + 2;
        var returnLast = _this.touchIndex === 1;
        // console.log('---returnLast---', returnLast);
        _this.touchIndex--;
        var left = -_this.touchIndex * _this.bannerWidth;
        _this.setState({
          transition: TRANSITION,
          translateX: left
        });
        if (returnLast) {
          setTimeout(function () {
            _this.touchIndex = len - 2;
            _this.setState({
              transition: 0,
              translateX: -_this.touchIndex * _this.bannerWidth
            });
            _this.setAutoPlay();
          }, 620);
        } else {
          _this.setAutoPlay();
        }
        _this.setMaskHidden();
      }
    }), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AdSwiper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setAutoPlay();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearAutoPlay();
    }

    // 根据UI图在图片初始化的时候第一张右边没有最后一张的图片

  }, {
    key: 'render',
    value: function render() {
      var imgList = this.props.imgList;
      var _state = this.state,
          transition = _state.transition,
          translateX = _state.translateX,
          isShowMask = _state.isShowMask;

      var style = {
        width: this.clientWith - 28 + 'px',
        height: '29vw', // UI图 682 * 212
        borderRadius: '6px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      };
      if (imgList.length === 0) return null;
      if (imgList.length === 1) {
        var imgItem = imgList[0];
        return _react2.default.createElement(
          'div',
          { className: 'ad-swiper-container' },
          _react2.default.createElement(
            'div',
            { className: 'ad-swiper-item' },
            _react2.default.createElement(
              'a',
              { href: imgItem.url },
              _react2.default.createElement(_httpsProtocolImage2.default, {
                src: imgItem.imgUrl,
                bgImg: true,
                alt: '',
                style: (0, _extends3.default)({}, style, {
                  backgroundImage: 'url(' + imgItem.imgUrl + ')'
                })
              })
            )
          )
        );
      }
      var length = imgList.length;
      var swiperList = [imgList[length - 1]].concat((0, _toConsumableArray3.default)(imgList), [imgList[0]]);
      return _react2.default.createElement(
        'div',
        {
          className: 'ad-swiper-container',
          onTouchStart: this.touchStart,
          onTouchMove: this.touchMove,
          onTouchEnd: this.touchEnd
        },
        isShowMask ? _react2.default.createElement('div', { className: 'ad-swiper-mask' }) : null,
        _react2.default.createElement(
          'div',
          {
            className: 'ad-swiper',
            style: {
              width: this.bannerWidth * swiperList.length + 'px',
              transition: 'all ' + transition + 's ease',
              transform: 'translate3d(' + translateX + 'px, 0, 0)'
            }
          },
          swiperList.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { className: 'ad-swiper-item', key: index },
              _react2.default.createElement(
                'a',
                { href: item.url },
                _react2.default.createElement(_httpsProtocolImage2.default, {
                  src: item.imgUrl,
                  bgImg: true,
                  alt: '',
                  style: (0, _extends3.default)({}, style, {
                    backgroundImage: 'url(' + item.imgUrl + ')'
                  })
                })
              )
            );
          })
        )
      );
    }
  }]);
  return AdSwiper;
}(_react2.default.Component), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    imgList: [],
    autoplay: 3500
  }
}), _temp2);


AdSwiper.propTypes = {
  imgList: _react2.default.PropTypes.array,
  autoplay: _react2.default.PropTypes.number
};

exports.default = AdSwiper;

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(637);

var React = __webpack_require__(2);
var classnames = __webpack_require__(50);

var loginUrl = __webpack_require__(638);
var orderSuccessUrl = __webpack_require__(639);
var personDefaultImageUrl = __webpack_require__(526);

module.exports = React.createClass({
  displayName: 'SyncOrderToast',
  propTypes: {
    toastProps: React.PropTypes.object,
    onCloseWindow: React.PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      imgStyle: {},
      buttonPropStyle: {},
      contentStyle: null
    };
  },
  componentDidMount: function componentDidMount() {},
  componentWillReceiveProps: function componentWillReceiveProps(newProps) {},
  buildImgProp: function buildImgProp(data) {
    var imgUrl = null;
    if (!data) {
      return personDefaultImageUrl;
    }

    if (data === 'login') {
      imgUrl = loginUrl;
    } else if (data === 'order_success') {
      imgUrl = orderSuccessUrl;
    } else {
      // 默认用户头像地址
      imgUrl = data;
    }
    return imgUrl;
  },
  handleModalTouchTap: function handleModalTouchTap(evt) {
    if (evt) {
      evt.preventDefault();
    }

    this.props.onCloseWindow();
  },
  handleBtnTouchTap: function handleBtnTouchTap(evt) {
    if (evt) {
      evt.preventDefault();
    }

    var toastProps = this.props.toastProps;

    if (toastProps.onBtnTap) {
      toastProps.onBtnTap();
    }
  },
  render: function render() {
    var toastProps = this.props.toastProps;

    var _ref = toastProps || {},
        buttonProp = _ref.buttonProp;

    var _state = this.state,
        imgStyle = _state.imgStyle,
        buttonPropStyle = _state.buttonPropStyle;

    var classNames = ('sync-order-toast ' + (toastProps.className || '')).trim();

    return React.createElement(
      'div',
      { className: classNames, style: this.state.contentStyle },
      React.createElement('div', { className: 'sync-order-toast-back', onTouchTap: this.handleModalTouchTap }),
      React.createElement(
        'div',
        { className: 'sync-order-toast-content' },
        React.createElement(
          'div',
          { className: 'sync-order-toast-body' },
          React.createElement(_httpsProtocolImage2.default, { src: this.buildImgProp(toastProps.imgProp), className: 'userPic', alt: '\u5934\u50CF', style: toastProps.imgStyle || imgStyle }),
          React.createElement(
            'p',
            { className: 'main-message' },
            React.createElement(
              'span',
              { className: 'user-name' },
              toastProps.userName
            ),
            React.createElement(
              'span',
              null,
              toastProps.mainMessage
            )
          ),
          React.createElement(
            'p',
            { className: 'vice-message' },
            toastProps.viceMessage
          )
        ),
        buttonProp && buttonProp.text && React.createElement(
          'div',
          {
            className: classnames('sync-order-toast-btn', buttonProp.className || '', { 'right-button': toastProps.viceButtonProps }),
            onTouchTap: this.handleBtnTouchTap,
            style: buttonProp.style || buttonPropStyle
          },
          buttonProp.text
        )
      )
    );
  }
});

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/login.svg";

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/order_success.svg";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var io = __webpack_require__(641);
var dishHelper = __webpack_require__(43);
var orderDinnerHelper = __webpack_require__(547);
var config = __webpack_require__(13);

var _require = __webpack_require__(16),
    formatMessage = _require.formatMessage;

// soket 连接地址;
var SOCKET_URL = config.syncOrderDinnerSocketUrl;

// 事件常量定义
var CONNECT = 'connect';
var CONNECT_ERROR = 'connect_error';
var CONNECT_TIMEOUT = 'connect_timeout';

var JOIN_ROOM = 'join_room';
var CLOSE_ROOM = 'close_room';
var JOIN_ROOM_RESULT = 'join_room_result';
var CLOSE_ROOM_RESULT = 'close_room_result';

var CLEAN_ROOMS_ORDER = 'clean_rooms_order';
var CLEAN_ROOMS_ORDER_RESULT = 'clean_rooms_order_result';

var GET_SHOPPING_CART = 'get_shopping_cart';
var GET_SHOPPING_CART_RESULT = 'get_shopping_cart_result';
var CLOSE_ROOM_NOTICE = 'close_room_notice'; // 销房通知
var GET_ROOMS_INFO = 'get_rooms_info'; // 获取房间列表
var GET_ROOMS_INFO_RESULT = 'get_rooms_info_result'; // 获取房间列表结果
var GET_ORDER_CART = 'get_order_cart';
var GET_ORDER_CART_RESULT = 'get_order_cart_result';
var ORDER_DISH_NOTICE = 'order_dish_notice';
var ADD_ORDER_DISH = 'add_order_dish';
var ADD_ORDER_DISH_RESULT = 'add_order_dish_result';
var MINUS_ORDER_DISH = 'minus_order_dish';
var MINUS_ORDER_DISH_RESULT = 'minus_order_dish_result';
var ERROR = 'error';
var CLEAR_SHOPPINGCART = 'clear_shoppingcart';
var CLEAR_SHOPPINGCART_RESULT = 'clear_shoppingcart_result';
var CLEAR_SHOPPINGCART_NOTICE = 'clear_shoppingcart_notice';
var PLACE_ORDER = 'place_order';
var PLACE_ORDER_RESULT = 'place_order_result';
var PLACE_ORDER_NOTICE = 'place_order_notice';
var DISCONNECT = 'disconnect';
var HEART_BEATS = 'heartbeats_test';
var LOCK_PLACE_ORDER = 'lock_place_order';
var LOCK_PLACE_ORDER_RESULT = 'lock_place_order_result';

var MAX_NETWORK_DELAY_MILLISECOND = 500; // 网络延迟阈值(ms)，连续超出5次，客户端将提示 '当前网络环境差，请刷新后重试';
var RECONNECTION_DELAY = 5000; // 连接失败后延迟5S重连
var RECONNECTION_ATTEMPTS = 3; // 重连次数
var TIME_OUT = 60000;

var NetworkDelayMgr = function () {
  function NetworkDelayMgr(options) {
    (0, _classCallCheck3.default)(this, NetworkDelayMgr);
    Object.defineProperty(this, 'maxSliceLength', {
      enumerable: true,
      writable: true,
      value: 5
    });

    (0, _assign2.default)(this, options);

    this.timeSlices = [];
  }

  (0, _createClass3.default)(NetworkDelayMgr, [{
    key: '_appendSlice',
    value: function _appendSlice(slice) {
      if (this.timeSlices.length >= this.maxSliceLength) {
        this.timeSlices = [];
      }

      this.timeSlices.push(slice);
    }
  }, {
    key: 'checkIsDelay',
    value: function checkIsDelay(slice) {
      this._appendSlice(slice);

      if (this.timeSlices.length < this.maxSliceLength) {
        return false;
      }

      return this.timeSlices.every(function (timeSlice) {
        return timeSlice.end - timeSlice.start > MAX_NETWORK_DELAY_MILLISECOND;
      });
    }
  }]);
  return NetworkDelayMgr;
}();
/**
 *  正餐Socket帮助类
 */


var DinnerSocketHelper = function () {
  // 连接错误次数

  function DinnerSocketHelper() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, DinnerSocketHelper);
    Object.defineProperty(this, 'loopIndex', {
      enumerable: true,
      writable: true,
      value: 3
    });
    Object.defineProperty(this, 'isConnected', {
      enumerable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, 'onBeforeInitDishes', {
      enumerable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, 'onBeforeAddOrMinusDish', {
      enumerable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, 'onBeforeJoinRoom', {
      enumerable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, 'onAfterJoinRoom', {
      enumerable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, 'onNetworkDelay', {
      enumerable: true,
      writable: true,
      value: function value() {}
    });
    Object.defineProperty(this, 'isJoinRoom', {
      enumerable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, 'showDisconnectInfo', {
      enumerable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, 'shoppingCartResultOwnerId', {
      enumerable: true,
      writable: true,
      value: ''
    });
    Object.defineProperty(this, 'tableWay', {
      enumerable: true,
      writable: true,
      value: ''
    });
    Object.defineProperty(this, 'connectionErrCount', {
      enumerable: true,
      writable: true,
      value: 0
    });

    (0, _assign2.default)(this, options);
    var reconnectionAttempts = options.reconnectionAttempts || RECONNECTION_ATTEMPTS;
    // this.socket = io(SOCKET_URL, { reconnectionDelay: 5000, timeout: 60000 });
    this.socket = io(SOCKET_URL, { reconnectionDelay: RECONNECTION_DELAY, timeout: TIME_OUT, reconnectionAttempts: reconnectionAttempts });
    if (options.onConnectError) {
      this.socket.on(CONNECT_ERROR, function () {
        _this.connectionErrCount++;
        // console.log('---this.socket CONNECT_ERROR--', this.socket);
        // console.log('---this.socket this.connectionErrCount--', this.connectionErrCount);
        options.onConnectError(_this.connectionErrCount);
      });
    }
    this.networkDelayMgr = new NetworkDelayMgr();
  }

  /**
   * 初始化socket
   *
   * @param userInfo
   */


  (0, _createClass3.default)(DinnerSocketHelper, [{
    key: 'initSocket',
    value: function initSocket(userInfo, callback) {
      var _this2 = this;

      if (this.isConnected) {
        callback();
        return;
      }

      if (this.onBeforeJoinRoom) {
        this.onBeforeJoinRoom();
      }

      // this.socket.io.reconnect(); 此处需要修改

      this.socket.removeListener(CONNECT);
      this.socket.on(CONNECT, function () {
        _this2.joinRoom(userInfo, callback);
      });

      this.socket.removeListener(CONNECT_ERROR);
      this.socket.on(CONNECT_ERROR, function (error) {
        _this2.isConnected = false;
        if (_this2.onConnectError) {
          _this2.onConnectError();
        }
      });

      this.socket.removeListener(CONNECT_TIMEOUT);
      this.socket.on(CONNECT_TIMEOUT, function (info) {
        _this2.isConnected = false;
      });

      if (this.socket.connected) {
        this.joinRoom(userInfo, callback);
      } else {
        this.socket.connect();
      }

      this.socketIoHeartbeats(); // 建立心跳连接
    }
  }, {
    key: 'socketIoHeartbeats',
    value: function socketIoHeartbeats() {
      var _this3 = this;

      var heartBeatTimeout = null;
      var hearBeatLock = null;
      var getMassageStatus = true; // 是否获取到信息
      var startTimestamp = null;

      var heartBeatBegin = function heartBeatBegin() {
        heartBeatTimeout = setTimeout(function () {
          // 心跳时间设置
          if (getMassageStatus && _this3.socket) {
            getMassageStatus = false;
            startTimestamp = Date.now();
            _this3.socket.emit(HEART_BEATS, (0, _stringify2.default)({ status: true })); // 3秒发送一次信息
          }

          hearBeatLock = setTimeout(function () {
            if (!getMassageStatus) {
              _this3.heartBeatReconnect();
            }
          }, 2000);
        }, 5000);
      };

      var heartBeatEnd = function heartBeatEnd() {
        if (_this3.networkDelayMgr.checkIsDelay({ start: startTimestamp, end: Date.now() })) {
          _this3.onNetworkDelay(formatMessage(_errorMessage2.default.networkFailTryRefresh));
        }

        getMassageStatus = true;
        clearTimeout(heartBeatTimeout);
        clearTimeout(hearBeatLock);
        heartBeatBegin();
      };

      this.heartBeatReconnect = function () {
        _this3.socket.connect();
        heartBeatEnd();
      };

      heartBeatBegin();
      this.socket.on(HEART_BEATS, function (msg) {
        heartBeatEnd();
      });
    }
  }, {
    key: 'joinRoom',
    value: function joinRoom(userInfo, callback) {
      var _this4 = this;

      this.socket.emit(JOIN_ROOM, userInfo);
      this.socket.removeListener(JOIN_ROOM_RESULT);
      if (this.isJoinRoomInterval) {
        clearInterval(this.isJoinRoomInterval);
      }
      // 加入房间监听事件
      this.socket.on(JOIN_ROOM_RESULT, function (joinRoomResult) {
        clearInterval(_this4.isJoinRoomInterval);
        if (joinRoomResult.success) {
          _this4.isConnected = true;
          // callback();

          if (_this4.onAfterJoinRoom) {
            _this4.onAfterJoinRoom();
          }

          callback();
          return;
        }
      });

      this.isJoinRoomInterval = setInterval(function () {
        _this4.showDisconnectInfo = false;
        _this4.socket.disconnect();
        _this4.socket.connect();
        _this4.initSocket(userInfo, callback);
        // 连接失败,重试
        /*
        if (this.loopIndex > 0) {
          this.loopIndex--;
          this.initSocket(userInfo, callback);
        } else {
          if (this.onAfterJoinRoom) {
            this.onAfterJoinRoom();
          }
        }
        */
      }, 3000);
    }
  }, {
    key: 'cleanRoomOrder',
    value: function cleanRoomOrder(orderList, callback) {
      this.socket.emit(CLEAN_ROOMS_ORDER, orderList);
      this.socket.removeListener(CLEAN_ROOMS_ORDER_RESULT);

      // 加入房间监听事件
      this.socket.on(CLEAN_ROOMS_ORDER_RESULT, function (cleanRoomResult) {
        if (cleanRoomResult.success) {
          // 成功退出房间
          callback();
        }
      });
    }
  }, {
    key: 'closeRoom',
    value: function closeRoom(userInfo, callback) {
      this.socket.compress(true).emit(CLOSE_ROOM, userInfo);
      this.socket.removeListener(CLOSE_ROOM_RESULT);

      // 加入房间监听事件
      this.socket.on(CLOSE_ROOM_RESULT, function (quitRoomResult) {
        if (quitRoomResult.success) {
          // 成功退出房间
          console.log('成功退出房间...');
        }
      });
    }
  }, {
    key: 'noticeRoomInfo',
    value: function noticeRoomInfo(_userInfo, callBack) {
      var _this5 = this;

      var doAction = function doAction() {
        _this5.socket.emit(GET_ROOMS_INFO, _userInfo);
        _this5.socket.on(GET_ROOMS_INFO_RESULT, function (noticeResult) {
          callBack(noticeResult);
        });
      };
      if (this.socket.connected) {
        doAction();
      } else {
        this.socket.connect();
        this.socket.removeListener(CONNECT);
        this.socket.on(CONNECT, function () {
          doAction();
        });
      }
    }

    /**
     * place_order_notice事件
     *
     * @param callback
     */

  }, {
    key: 'noticePlaceOrder',
    value: function noticePlaceOrder(_userInfo, callBack) {
      var _this6 = this;

      var doAction = function doAction() {
        _this6.socket.on(PLACE_ORDER_NOTICE, function (resultUserInfo) {
          callBack(resultUserInfo);
        });
      };
      if (this.socket.connected) {
        doAction();
      } else {
        this.socket.connect();
        this.socket.removeListener(CONNECT);
        this.socket.on(CONNECT, function () {
          doAction();
        });
      }
    }

    /**
     * 获取购物车数据
     *
     * @param callback
     */

  }, {
    key: 'getShoppingCartEventInCart',
    value: function getShoppingCartEventInCart(callback, beforeCallback) {
      var _this7 = this;

      var doAction = function doAction() {
        _this7.socket.emit(GET_SHOPPING_CART, _this7.userInfo);
        _this7.socket.removeListener(GET_SHOPPING_CART_RESULT);

        if (beforeCallback) {
          beforeCallback();
        }

        _this7.socket.on(GET_SHOPPING_CART_RESULT, function (shoppingCartResult) {
          var result = shoppingCartResult.chooseDishesResults.map(function (shoppingCartItem) {
            var userInfo = shoppingCartItem.userInfo;

            var dishItems = shoppingCartItem.dishItems || [];

            if (_this7.onBeforeInitDishes) {
              _this7.onBeforeInitDishes(dishItems);
            }
            return {
              uuidTag: shoppingCartItem.uuidTag,
              userInfo: userInfo,
              dishList: orderDinnerHelper.reconstructDishes(orderDinnerHelper.initializeDishes(dishItems))
            };
          });
          _this7.shoppingCartResultOwnerId = shoppingCartResult.ownerId;
          callback(result || [], shoppingCartResult);
        });
      };

      this.initSocket(this.userInfo, doAction);
    }
    /**
     * 加减菜操作
     *
     * @param dishData 购车菜品信息
     * @param action   加减菜数量,如果是加菜传入正数,如果是减菜传入负数
     * @param callback  回调
     * @param userInfo 用户
     */

  }, {
    key: 'addOrMinusDishEvent',
    value: function addOrMinusDishEvent(dishData, action, callback, userInfo) {
      var _this8 = this;

      var orderUserInfo = userInfo || this.userInfo;
      var isOneTableOneBill = this.tableWay === 'oneTableOneBill'; // 一桌一单
      var doAction = function doAction() {
        var orderDish = dishHelper.organizeDishData(dishData);
        if (_this8.onBeforeAddOrMinusDish) {
          _this8.onBeforeAddOrMinusDish(orderDish);
        }
        var actionArgs = {
          fromUser: (0, _assign2.default)({}, orderUserInfo, { ownerId: isOneTableOneBill ? orderUserInfo.tableId : _this8.shoppingCartResultOwnerId }),
          toUser: orderUserInfo,
          orderDish: orderDish
        };
        orderDish.num = action;

        // 加减菜时判断是否保持连接 如果已经断开则重连
        if (!_this8.socket.connected) {
          _this8.socket.connect();
        }

        // 加菜
        if (action > 0) {
          _this8.socket.emit(ADD_ORDER_DISH, actionArgs);
          _this8.socket.removeListener(ADD_ORDER_DISH_RESULT);
          _this8.socket.on(ADD_ORDER_DISH_RESULT, function (addDishResult) {
            if (callback) {
              callback(addDishResult.success);
            }
          });
          return;
        }

        // 减菜
        if (action < 0) {
          _this8.socket.emit(MINUS_ORDER_DISH, actionArgs);
          _this8.socket.removeListener(MINUS_ORDER_DISH_RESULT);
          _this8.socket.on(MINUS_ORDER_DISH_RESULT, function (minusDishResult) {
            if (callback) {
              callback(minusDishResult.success);
            }
          });
        }
      };

      this.initSocket(this.userInfo, doAction);
    }

    /**
     * 菜品通知事件监听
     *
     * @param callback
     */

  }, {
    key: 'dishNoticeListener',
    value: function dishNoticeListener(callback) {
      var _this9 = this;

      this.socket.on(ORDER_DISH_NOTICE, function (noticeResult) {
        var fromUser = noticeResult.fromUser,
            orderDish = noticeResult.orderDish;

        var userInfo = (0, _assign2.default)({ addOperation: noticeResult.addOperation }, fromUser);
        var orderedDishes = [orderDish];
        if (_this9.onBeforeInitDishes) {
          _this9.onBeforeInitDishes(orderedDishes);
        }

        var orderData = orderDinnerHelper.reconstructDishes(orderDinnerHelper.initializeDishes(orderedDishes));
        var result = { userInfo: userInfo, orderData: orderData };
        callback(result, orderDish.dishIncreaseUnit, orderDish.num, orderDish.stepNum);
      });
    }

    /**
     * 清空购物车监听
     *
     * @param callback
     */

  }, {
    key: 'clearShoppingcartListener',
    value: function clearShoppingcartListener(callback) {
      var _this10 = this;

      this.socket.on(CLEAR_SHOPPINGCART_NOTICE, function (clearNoticeResult) {
        _this10.isConnected = false;
        // 清空购物车时判断是否保持连接 如果已经断开则重连
        if (!_this10.socket.connected) {
          _this10.socket.connect();
        }
        callback(clearNoticeResult);
      });
    }

    /**
     * 清空购物车事件
     *
     * @param callback
     */

  }, {
    key: 'clearShoppingcartEvent',
    value: function clearShoppingcartEvent(callback) {
      var _this11 = this;

      var doAction = function doAction() {
        var userInfo = (0, _assign2.default)({ clearType: 'DEFAULT' }, _this11.userInfo);

        _this11.socket.emit(CLEAR_SHOPPINGCART, userInfo);
        _this11.socket.removeListener(CLEAR_SHOPPINGCART_RESULT);
        _this11.socket.on(CLEAR_SHOPPINGCART_RESULT, function (clearShoppingcartResult) {
          if (callback) {
            callback(clearShoppingcartResult.success);
          }
        });
      };

      this.initSocket(this.userInfo, doAction);
    }

    /**
     * 获取购物车订单事件
     *
     * @param callback
     */

  }, {
    key: 'getOrderCartEvent',
    value: function getOrderCartEvent(callback) {
      var _this12 = this;

      var doAction = function doAction() {
        // console.log('getOrderCartEvent calling');
        _this12.socket.emit(GET_ORDER_CART, _this12.userInfo);
        _this12.socket.removeListener(GET_ORDER_CART_RESULT);
        _this12.socket.on(GET_ORDER_CART_RESULT, function (result) {
          // console.log('getOrderCartEvent called');
          if (callback) {
            callback(result);
          }
        });
      };

      this.initSocket(this.userInfo, doAction);
    }

    /**
     * 提交订单事件
     *
     * @param callback
     */

  }, {
    key: 'submitOrderEvent',
    value: function submitOrderEvent(orderedId, callback) {
      var _this13 = this;

      var isOneTableOneBill = this.tableWay === 'oneTableOneBill'; // 一桌一单
      var doAction = function doAction() {
        var userInfo = (0, _assign2.default)({}, _this13.userInfo, {
          clearType: 'ORDER_SUCCESS',
          orderId: orderedId,
          ownerId: isOneTableOneBill ? _this13.userInfo.tableId : _this13.shoppingCartResultOwnerId || _this13.userInfo.userId
        });

        _this13.socket.emit(PLACE_ORDER, userInfo);
        _this13.socket.removeListener(PLACE_ORDER_RESULT);
        _this13.socket.on(PLACE_ORDER_RESULT, function () {
          _this13.socket.emit(CLEAR_SHOPPINGCART, userInfo);
          _this13.socket.removeListener(CLEAR_SHOPPINGCART_RESULT);
          _this13.socket.on(CLEAR_SHOPPINGCART_RESULT, function (clearShoppingcartResult) {
            if (callback) {
              callback(clearShoppingcartResult.success);
            }
          });
        });
      };

      this.initSocket(this.userInfo, doAction);
    }

    /**
     * 派发 LOCK_PLACE_ORDER 事件
     * @param {String} shoppingcartTag
     * @param {function} callback
     */

  }, {
    key: 'emitLockPlaceOrderEvent',
    value: function emitLockPlaceOrderEvent(shoppingcartTag) {
      var _this14 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      var doAction = function doAction() {
        var userInfo = _this14.userInfo;


        _this14.socket.emit(LOCK_PLACE_ORDER, {
          userInfo: userInfo,
          shoppingcartTag: shoppingcartTag
        });

        _this14.socket.removeListener(LOCK_PLACE_ORDER_RESULT);
        _this14.socket.on(LOCK_PLACE_ORDER_RESULT, callback);
      };

      this.initSocket(this.userInfo, doAction);
    }

    /**
     * 异常事件
     *
     * @param callback
     */

  }, {
    key: 'errorListener',
    value: function errorListener(callback, callbackCloseRoomNotice) {
      var _this15 = this;

      this.socket.on(ERROR, function (error) {
        callback(error);
      });
      this.socket.on(DISCONNECT, function (info) {
        if (_this15.showDisconnectInfo) {
          // 不提示用户断开连接
          // callback(formatMessage(errorMessages.disconnected));
        } else {
          _this15.showDisconnectInfo = true;
        }
      });
      setTimeout(function () {
        if (_this15.socket && _this15.socket.io.readyState === 'closed') {
          // 不提示用户断开连接
          // callback(formatMessage(errorMessages.errorAndReconnect));
        }
      }, RECONNECTION_DELAY);

      // 销房通知
      this.socket.on(CLOSE_ROOM_NOTICE, function (msg) {
        callbackCloseRoomNotice(msg);
      });
    }
  }, {
    key: 'reconnect',
    value: function reconnect() {
      this.socket.io.reconnect();
    }
  }, {
    key: 'close',
    value: function close() {
      if (this.socket) {
        this.socket.destroy();
      }
    }
  }]);
  return DinnerSocketHelper;
}();

module.exports = DinnerSocketHelper;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(642);
var parser = __webpack_require__(542);
var Manager = __webpack_require__(564);
var debug = __webpack_require__(500)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  } else if (opts && 'object' === typeof opts.query) {
    opts.query = encodeQueryString(opts.query);
  }
  return io.socket(parsed.path, opts);
}
/**
 *  Helper method to parse query objects to string.
 * @param {object} query
 * @returns {string}
 */
function encodeQueryString (obj) {
  var str = [];
  for (var p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  }
  return str.join('&');
}
/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(564);
exports.Socket = __webpack_require__(570);


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(562);
var debug = __webpack_require__(500)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || global.location;
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(644);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 644 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(646);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // is webkit? http://stackoverflow.com/a/16459606/376773
  return ('WebkitAppearance' in document.documentElement.style) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (window.console && (console.firebug || (console.exception && console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  return JSON.stringify(v);
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs() {
  var args = arguments;
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return args;

  var c = 'color: ' + this.color;
  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
  return args;
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}
  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage(){
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(647);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = Array.prototype.slice.call(arguments);

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    if ('function' === typeof exports.formatArgs) {
      args = exports.formatArgs.apply(self, args);
    }
    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 647 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options){
  options = options || {};
  if ('string' == typeof val) return parse(val);
  return options.long
    ? long(val)
    : short(val);
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = '' + str;
  if (str.length > 10000) return;
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
  if (!match) return;
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function short(ms) {
  if (ms >= d) return Math.round(ms / d) + 'd';
  if (ms >= h) return Math.round(ms / h) + 'h';
  if (ms >= m) return Math.round(ms / m) + 'm';
  if (ms >= s) return Math.round(ms / s) + 's';
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function long(ms) {
  return plural(ms, d, 'day')
    || plural(ms, h, 'hour')
    || plural(ms, m, 'minute')
    || plural(ms, s, 'second')
    || ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) return;
  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! JSON v3.3.2 | http://bestiejs.github.io/json3 | Copyright 2012-2014, Kit Cambridge | http://kit.mit-license.org */
;(function () {
  // Detect the `define` function exposed by asynchronous module loaders. The
  // strict `define` check is necessary for compatibility with `r.js`.
  var isLoader = "function" === "function" && __webpack_require__(649);

  // A set of types used to distinguish objects from primitives.
  var objectTypes = {
    "function": true,
    "object": true
  };

  // Detect the `exports` object exposed by CommonJS implementations.
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  // Use the `global` object exposed by Node (including Browserify via
  // `insert-module-globals`), Narwhal, and Ringo as the default context,
  // and the `window` object in browsers. Rhino exports a `global` function
  // instead.
  var root = objectTypes[typeof window] && window || this,
      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;

  if (freeGlobal && (freeGlobal["global"] === freeGlobal || freeGlobal["window"] === freeGlobal || freeGlobal["self"] === freeGlobal)) {
    root = freeGlobal;
  }

  // Public: Initializes JSON 3 using the given `context` object, attaching the
  // `stringify` and `parse` functions to the specified `exports` object.
  function runInContext(context, exports) {
    context || (context = root["Object"]());
    exports || (exports = root["Object"]());

    // Native constructor aliases.
    var Number = context["Number"] || root["Number"],
        String = context["String"] || root["String"],
        Object = context["Object"] || root["Object"],
        Date = context["Date"] || root["Date"],
        SyntaxError = context["SyntaxError"] || root["SyntaxError"],
        TypeError = context["TypeError"] || root["TypeError"],
        Math = context["Math"] || root["Math"],
        nativeJSON = context["JSON"] || root["JSON"];

    // Delegate to the native `stringify` and `parse` implementations.
    if (typeof nativeJSON == "object" && nativeJSON) {
      exports.stringify = nativeJSON.stringify;
      exports.parse = nativeJSON.parse;
    }

    // Convenience aliases.
    var objectProto = Object.prototype,
        getClass = objectProto.toString,
        isProperty, forEach, undef;

    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
    var isExtended = new Date(-3509827334573292);
    try {
      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
      // results for certain dates in Opera >= 10.53.
      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
        // Safari < 2.0.2 stores the internal millisecond time value correctly,
        // but clips the values returned by the date methods to the range of
        // signed 32-bit integers ([-2 ** 31, 2 ** 31 - 1]).
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
    } catch (exception) {}

    // Internal: Determines whether the native `JSON.stringify` and `parse`
    // implementations are spec-compliant. Based on work by Ken Snyder.
    function has(name) {
      if (has[name] !== undef) {
        // Return cached feature test result.
        return has[name];
      }
      var isSupported;
      if (name == "bug-string-char-index") {
        // IE <= 7 doesn't support accessing string characters using square
        // bracket notation. IE 8 only supports this for primitives.
        isSupported = "a"[0] != "a";
      } else if (name == "json") {
        // Indicates whether both `JSON.stringify` and `JSON.parse` are
        // supported.
        isSupported = has("json-stringify") && has("json-parse");
      } else {
        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
        // Test `JSON.stringify`.
        if (name == "json-stringify") {
          var stringify = exports.stringify, stringifySupported = typeof stringify == "function" && isExtended;
          if (stringifySupported) {
            // A test function object with a custom `toJSON` method.
            (value = function () {
              return 1;
            }).toJSON = value;
            try {
              stringifySupported =
                // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" &&
                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" &&
                stringify(new String()) == '""' &&
                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undef &&
                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undef) === undef &&
                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undef &&
                // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" &&
                stringify([value]) == "[1]" &&
                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undef]) == "[null]" &&
                // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" &&
                // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undef, getClass, null]) == "[null,null,null]" &&
                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" &&
                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]" &&
                // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
                // serialize extended years.
                stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
                // The milliseconds are optional in ES 5, but required in 5.1.
                stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
                // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
                // four-digit years instead of six-digit years. Credits: @Yaffle.
                stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
                // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
                // values less than 1000. Credits: @Yaffle.
                stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
            } catch (exception) {
              stringifySupported = false;
            }
          }
          isSupported = stringifySupported;
        }
        // Test `JSON.parse`.
        if (name == "json-parse") {
          var parse = exports.parse;
          if (typeof parse == "function") {
            try {
              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
              // Conforming implementations should also coerce the initial argument to
              // a string prior to parsing.
              if (parse("0") === 0 && !parse(false)) {
                // Simple parsing test.
                value = parse(serialized);
                var parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                if (parseSupported) {
                  try {
                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                    parseSupported = !parse('"\t"');
                  } catch (exception) {}
                  if (parseSupported) {
                    try {
                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                      // certain octal literals.
                      parseSupported = parse("01") !== 1;
                    } catch (exception) {}
                  }
                  if (parseSupported) {
                    try {
                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                      // points. These environments, along with FF 3.1b1 and 2,
                      // also allow trailing commas in JSON objects and arrays.
                      parseSupported = parse("1.") !== 1;
                    } catch (exception) {}
                  }
                }
              }
            } catch (exception) {
              parseSupported = false;
            }
          }
          isSupported = parseSupported;
        }
      }
      return has[name] = !!isSupported;
    }

    if (!has("json")) {
      // Common `[[Class]]` name aliases.
      var functionClass = "[object Function]",
          dateClass = "[object Date]",
          numberClass = "[object Number]",
          stringClass = "[object String]",
          arrayClass = "[object Array]",
          booleanClass = "[object Boolean]";

      // Detect incomplete support for accessing string characters by index.
      var charIndexBuggy = has("bug-string-char-index");

      // Define additional utility methods if the `Date` methods are buggy.
      if (!isExtended) {
        var floor = Math.floor;
        // A mapping between the months of the year and the number of days between
        // January 1st and the first of the respective month.
        var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        // Internal: Calculates the number of days between the Unix epoch and the
        // first day of the given month.
        var getDay = function (year, month) {
          return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
        };
      }

      // Internal: Determines if a property is a direct property of the given
      // object. Delegates to the native `Object#hasOwnProperty` method.
      if (!(isProperty = objectProto.hasOwnProperty)) {
        isProperty = function (property) {
          var members = {}, constructor;
          if ((members.__proto__ = null, members.__proto__ = {
            // The *proto* property cannot be set multiple times in recent
            // versions of Firefox and SeaMonkey.
            "toString": 1
          }, members).toString != getClass) {
            // Safari <= 2.0.3 doesn't implement `Object#hasOwnProperty`, but
            // supports the mutable *proto* property.
            isProperty = function (property) {
              // Capture and break the object's prototype chain (see section 8.6.2
              // of the ES 5.1 spec). The parenthesized expression prevents an
              // unsafe transformation by the Closure Compiler.
              var original = this.__proto__, result = property in (this.__proto__ = null, this);
              // Restore the original prototype chain.
              this.__proto__ = original;
              return result;
            };
          } else {
            // Capture a reference to the top-level `Object` constructor.
            constructor = members.constructor;
            // Use the `constructor` property to simulate `Object#hasOwnProperty` in
            // other environments.
            isProperty = function (property) {
              var parent = (this.constructor || constructor).prototype;
              return property in this && !(property in parent && this[property] === parent[property]);
            };
          }
          members = null;
          return isProperty.call(this, property);
        };
      }

      // Internal: Normalizes the `for...in` iteration algorithm across
      // environments. Each enumerated key is yielded to a `callback` function.
      forEach = function (object, callback) {
        var size = 0, Properties, members, property;

        // Tests for bugs in the current environment's `for...in` algorithm. The
        // `valueOf` property inherits the non-enumerable flag from
        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
        (Properties = function () {
          this.valueOf = 0;
        }).prototype.valueOf = 0;

        // Iterate over a new instance of the `Properties` class.
        members = new Properties();
        for (property in members) {
          // Ignore all properties inherited from `Object.prototype`.
          if (isProperty.call(members, property)) {
            size++;
          }
        }
        Properties = members = null;

        // Normalize the iteration algorithm.
        if (!size) {
          // A list of non-enumerable properties inherited from `Object.prototype`.
          members = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
          // properties.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, length;
            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
            for (property in object) {
              // Gecko <= 1.0 enumerates the `prototype` property of functions under
              // certain conditions; IE does not.
              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                callback(property);
              }
            }
            // Manually invoke the callback for each non-enumerable property.
            for (length = members.length; property = members[--length]; hasProperty.call(object, property) && callback(property));
          };
        } else if (size == 2) {
          // Safari <= 2.0.4 enumerates shadowed properties twice.
          forEach = function (object, callback) {
            // Create a set of iterated properties.
            var members = {}, isFunction = getClass.call(object) == functionClass, property;
            for (property in object) {
              // Store each property name to prevent double enumeration. The
              // `prototype` property of functions is not enumerated due to cross-
              // environment inconsistencies.
              if (!(isFunction && property == "prototype") && !isProperty.call(members, property) && (members[property] = 1) && isProperty.call(object, property)) {
                callback(property);
              }
            }
          };
        } else {
          // No bugs detected; use the standard `for...in` algorithm.
          forEach = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
            for (property in object) {
              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                callback(property);
              }
            }
            // Manually invoke the callback for the `constructor` property due to
            // cross-environment inconsistencies.
            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
              callback(property);
            }
          };
        }
        return forEach(object, callback);
      };

      // Public: Serializes a JavaScript `value` as a JSON string. The optional
      // `filter` argument may specify either a function that alters how object and
      // array members are serialized, or an array of strings and numbers that
      // indicates which properties should be serialized. The optional `width`
      // argument may be either a string or number that specifies the indentation
      // level of the output.
      if (!has("json-stringify")) {
        // Internal: A map of control characters and their escaped equivalents.
        var Escapes = {
          92: "\\\\",
          34: '\\"',
          8: "\\b",
          12: "\\f",
          10: "\\n",
          13: "\\r",
          9: "\\t"
        };

        // Internal: Converts `value` into a zero-padded string such that its
        // length is at least equal to `width`. The `width` must be <= 6.
        var leadingZeroes = "000000";
        var toPaddedString = function (width, value) {
          // The `|| 0` expression is necessary to work around a bug in
          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
          return (leadingZeroes + (value || 0)).slice(-width);
        };

        // Internal: Double-quotes a string `value`, replacing all ASCII control
        // characters (characters with code unit values between 0 and 31) with
        // their escaped equivalents. This is an implementation of the
        // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
        var unicodePrefix = "\\u00";
        var quote = function (value) {
          var result = '"', index = 0, length = value.length, useCharIndex = !charIndexBuggy || length > 10;
          var symbols = useCharIndex && (charIndexBuggy ? value.split("") : value);
          for (; index < length; index++) {
            var charCode = value.charCodeAt(index);
            // If the character is a control character, append its Unicode or
            // shorthand escape sequence; otherwise, append the character as-is.
            switch (charCode) {
              case 8: case 9: case 10: case 12: case 13: case 34: case 92:
                result += Escapes[charCode];
                break;
              default:
                if (charCode < 32) {
                  result += unicodePrefix + toPaddedString(2, charCode.toString(16));
                  break;
                }
                result += useCharIndex ? symbols[index] : value.charAt(index);
            }
          }
          return result + '"';
        };

        // Internal: Recursively serializes an object. Implements the
        // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
        var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
          var value, className, year, month, date, time, hours, minutes, seconds, milliseconds, results, element, index, length, prefix, result;
          try {
            // Necessary for host object support.
            value = object[property];
          } catch (exception) {}
          if (typeof value == "object" && value) {
            className = getClass.call(value);
            if (className == dateClass && !isProperty.call(value, "toJSON")) {
              if (value > -1 / 0 && value < 1 / 0) {
                // Dates are serialized according to the `Date#toJSON` method
                // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
                // for the ISO 8601 date time string format.
                if (getDay) {
                  // Manually compute the year, month, date, hours, minutes,
                  // seconds, and milliseconds if the `getUTC*` methods are
                  // buggy. Adapted from @Yaffle's `date-shim` project.
                  date = floor(value / 864e5);
                  for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
                  for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
                  date = 1 + date - getDay(year, month);
                  // The `time` value specifies the time within the day (see ES
                  // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
                  // to compute `A modulo B`, as the `%` operator does not
                  // correspond to the `modulo` operation for negative numbers.
                  time = (value % 864e5 + 864e5) % 864e5;
                  // The hours, minutes, seconds, and milliseconds are obtained by
                  // decomposing the time within the day. See section 15.9.1.10.
                  hours = floor(time / 36e5) % 24;
                  minutes = floor(time / 6e4) % 60;
                  seconds = floor(time / 1e3) % 60;
                  milliseconds = time % 1e3;
                } else {
                  year = value.getUTCFullYear();
                  month = value.getUTCMonth();
                  date = value.getUTCDate();
                  hours = value.getUTCHours();
                  minutes = value.getUTCMinutes();
                  seconds = value.getUTCSeconds();
                  milliseconds = value.getUTCMilliseconds();
                }
                // Serialize extended years correctly.
                value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
                  "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
                  // Months, dates, hours, minutes, and seconds should have two
                  // digits; milliseconds should have three.
                  "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
                  // Milliseconds are optional in ES 5.0, but required in 5.1.
                  "." + toPaddedString(3, milliseconds) + "Z";
              } else {
                value = null;
              }
            } else if (typeof value.toJSON == "function" && ((className != numberClass && className != stringClass && className != arrayClass) || isProperty.call(value, "toJSON"))) {
              // Prototype <= 1.6.1 adds non-standard `toJSON` methods to the
              // `Number`, `String`, `Date`, and `Array` prototypes. JSON 3
              // ignores all `toJSON` methods on these objects unless they are
              // defined directly on an instance.
              value = value.toJSON(property);
            }
          }
          if (callback) {
            // If a replacement function was provided, call it to obtain the value
            // for serialization.
            value = callback.call(object, property, value);
          }
          if (value === null) {
            return "null";
          }
          className = getClass.call(value);
          if (className == booleanClass) {
            // Booleans are represented literally.
            return "" + value;
          } else if (className == numberClass) {
            // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
            // `"null"`.
            return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
          } else if (className == stringClass) {
            // Strings are double-quoted and escaped.
            return quote("" + value);
          }
          // Recursively serialize objects and arrays.
          if (typeof value == "object") {
            // Check for cyclic structures. This is a linear search; performance
            // is inversely proportional to the number of unique nested objects.
            for (length = stack.length; length--;) {
              if (stack[length] === value) {
                // Cyclic structures cannot be serialized by `JSON.stringify`.
                throw TypeError();
              }
            }
            // Add the object to the stack of traversed objects.
            stack.push(value);
            results = [];
            // Save the current indentation level and indent one additional level.
            prefix = indentation;
            indentation += whitespace;
            if (className == arrayClass) {
              // Recursively serialize array elements.
              for (index = 0, length = value.length; index < length; index++) {
                element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                results.push(element === undef ? "null" : element);
              }
              result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
            } else {
              // Recursively serialize object members. Members are selected from
              // either a user-specified list of property names, or the object
              // itself.
              forEach(properties || value, function (property) {
                var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
                if (element !== undef) {
                  // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                  // is not the empty string, let `member` {quote(property) + ":"}
                  // be the concatenation of `member` and the `space` character."
                  // The "`space` character" refers to the literal space
                  // character, not the `space` {width} argument provided to
                  // `JSON.stringify`.
                  results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                }
              });
              result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
            }
            // Remove the object from the traversed object stack.
            stack.pop();
            return result;
          }
        };

        // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
        exports.stringify = function (source, filter, width) {
          var whitespace, callback, properties, className;
          if (objectTypes[typeof filter] && filter) {
            if ((className = getClass.call(filter)) == functionClass) {
              callback = filter;
            } else if (className == arrayClass) {
              // Convert the property names array into a makeshift set.
              properties = {};
              for (var index = 0, length = filter.length, value; index < length; value = filter[index++], ((className = getClass.call(value)), className == stringClass || className == numberClass) && (properties[value] = 1));
            }
          }
          if (width) {
            if ((className = getClass.call(width)) == numberClass) {
              // Convert the `width` to an integer and create a string containing
              // `width` number of space characters.
              if ((width -= width % 1) > 0) {
                for (whitespace = "", width > 10 && (width = 10); whitespace.length < width; whitespace += " ");
              }
            } else if (className == stringClass) {
              whitespace = width.length <= 10 ? width : width.slice(0, 10);
            }
          }
          // Opera <= 7.54u2 discards the values associated with empty string keys
          // (`""`) only if they are used directly within an object member list
          // (e.g., `!("" in { "": 1})`).
          return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
        };
      }

      // Public: Parses a JSON source string.
      if (!has("json-parse")) {
        var fromCharCode = String.fromCharCode;

        // Internal: A map of escaped control characters and their unescaped
        // equivalents.
        var Unescapes = {
          92: "\\",
          34: '"',
          47: "/",
          98: "\b",
          116: "\t",
          110: "\n",
          102: "\f",
          114: "\r"
        };

        // Internal: Stores the parser state.
        var Index, Source;

        // Internal: Resets the parser state and throws a `SyntaxError`.
        var abort = function () {
          Index = Source = null;
          throw SyntaxError();
        };

        // Internal: Returns the next token, or `"$"` if the parser has reached
        // the end of the source string. A token may be a string, number, `null`
        // literal, or Boolean literal.
        var lex = function () {
          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
          while (Index < length) {
            charCode = source.charCodeAt(Index);
            switch (charCode) {
              case 9: case 10: case 13: case 32:
                // Skip whitespace tokens, including tabs, carriage returns, line
                // feeds, and space characters.
                Index++;
                break;
              case 123: case 125: case 91: case 93: case 58: case 44:
                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                // the current position.
                value = charIndexBuggy ? source.charAt(Index) : source[Index];
                Index++;
                return value;
              case 34:
                // `"` delimits a JSON string; advance to the next character and
                // begin parsing the string. String tokens are prefixed with the
                // sentinel `@` character to distinguish them from punctuators and
                // end-of-string tokens.
                for (value = "@", Index++; Index < length;) {
                  charCode = source.charCodeAt(Index);
                  if (charCode < 32) {
                    // Unescaped ASCII control characters (those with a code unit
                    // less than the space character) are not permitted.
                    abort();
                  } else if (charCode == 92) {
                    // A reverse solidus (`\`) marks the beginning of an escaped
                    // control character (including `"`, `\`, and `/`) or Unicode
                    // escape sequence.
                    charCode = source.charCodeAt(++Index);
                    switch (charCode) {
                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
                        // Revive escaped control characters.
                        value += Unescapes[charCode];
                        Index++;
                        break;
                      case 117:
                        // `\u` marks the beginning of a Unicode escape sequence.
                        // Advance to the first character and validate the
                        // four-digit code point.
                        begin = ++Index;
                        for (position = Index + 4; Index < position; Index++) {
                          charCode = source.charCodeAt(Index);
                          // A valid sequence comprises four hexdigits (case-
                          // insensitive) that form a single hexadecimal value.
                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                            // Invalid Unicode escape sequence.
                            abort();
                          }
                        }
                        // Revive the escaped character.
                        value += fromCharCode("0x" + source.slice(begin, Index));
                        break;
                      default:
                        // Invalid escape sequence.
                        abort();
                    }
                  } else {
                    if (charCode == 34) {
                      // An unescaped double-quote character marks the end of the
                      // string.
                      break;
                    }
                    charCode = source.charCodeAt(Index);
                    begin = Index;
                    // Optimize for the common case where a string is valid.
                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
                      charCode = source.charCodeAt(++Index);
                    }
                    // Append the string as-is.
                    value += source.slice(begin, Index);
                  }
                }
                if (source.charCodeAt(Index) == 34) {
                  // Advance to the next character and return the revived string.
                  Index++;
                  return value;
                }
                // Unterminated string.
                abort();
              default:
                // Parse numbers and literals.
                begin = Index;
                // Advance past the negative sign, if one is specified.
                if (charCode == 45) {
                  isSigned = true;
                  charCode = source.charCodeAt(++Index);
                }
                // Parse an integer or floating-point value.
                if (charCode >= 48 && charCode <= 57) {
                  // Leading zeroes are interpreted as octal literals.
                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
                    // Illegal octal literal.
                    abort();
                  }
                  isSigned = false;
                  // Parse the integer component.
                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
                  // Floats cannot contain a leading decimal point; however, this
                  // case is already accounted for by the parser.
                  if (source.charCodeAt(Index) == 46) {
                    position = ++Index;
                    // Parse the decimal component.
                    for (; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal trailing decimal.
                      abort();
                    }
                    Index = position;
                  }
                  // Parse exponents. The `e` denoting the exponent is
                  // case-insensitive.
                  charCode = source.charCodeAt(Index);
                  if (charCode == 101 || charCode == 69) {
                    charCode = source.charCodeAt(++Index);
                    // Skip past the sign following the exponent, if one is
                    // specified.
                    if (charCode == 43 || charCode == 45) {
                      Index++;
                    }
                    // Parse the exponential component.
                    for (position = Index; position < length && ((charCode = source.charCodeAt(position)), charCode >= 48 && charCode <= 57); position++);
                    if (position == Index) {
                      // Illegal empty exponent.
                      abort();
                    }
                    Index = position;
                  }
                  // Coerce the parsed value to a JavaScript number.
                  return +source.slice(begin, Index);
                }
                // A negative sign may only precede numbers.
                if (isSigned) {
                  abort();
                }
                // `true`, `false`, and `null` literals.
                if (source.slice(Index, Index + 4) == "true") {
                  Index += 4;
                  return true;
                } else if (source.slice(Index, Index + 5) == "false") {
                  Index += 5;
                  return false;
                } else if (source.slice(Index, Index + 4) == "null") {
                  Index += 4;
                  return null;
                }
                // Unrecognized token.
                abort();
            }
          }
          // Return the sentinel `$` character if the parser has reached the end
          // of the source string.
          return "$";
        };

        // Internal: Parses a JSON `value` token.
        var get = function (value) {
          var results, hasMembers;
          if (value == "$") {
            // Unexpected end of input.
            abort();
          }
          if (typeof value == "string") {
            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
              // Remove the sentinel `@` character.
              return value.slice(1);
            }
            // Parse object and array literals.
            if (value == "[") {
              // Parses a JSON array, returning a new JavaScript array.
              results = [];
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing square bracket marks the end of the array literal.
                if (value == "]") {
                  break;
                }
                // If the array literal contains elements, the current token
                // should be a comma separating the previous element from the
                // next.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "]") {
                      // Unexpected trailing `,` in array literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each array element.
                    abort();
                  }
                }
                // Elisions and leading commas are not permitted.
                if (value == ",") {
                  abort();
                }
                results.push(get(value));
              }
              return results;
            } else if (value == "{") {
              // Parses a JSON object, returning a new JavaScript object.
              results = {};
              for (;; hasMembers || (hasMembers = true)) {
                value = lex();
                // A closing curly brace marks the end of the object literal.
                if (value == "}") {
                  break;
                }
                // If the object literal contains members, the current token
                // should be a comma separator.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "}") {
                      // Unexpected trailing `,` in object literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each object member.
                    abort();
                  }
                }
                // Leading commas are not permitted, object property names must be
                // double-quoted strings, and a `:` must separate each property
                // name and value.
                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                  abort();
                }
                results[value.slice(1)] = get(lex());
              }
              return results;
            }
            // Unexpected token encountered.
            abort();
          }
          return value;
        };

        // Internal: Updates a traversed object member.
        var update = function (source, property, callback) {
          var element = walk(source, property, callback);
          if (element === undef) {
            delete source[property];
          } else {
            source[property] = element;
          }
        };

        // Internal: Recursively traverses a parsed JSON object, invoking the
        // `callback` function for each value. This is an implementation of the
        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
        var walk = function (source, property, callback) {
          var value = source[property], length;
          if (typeof value == "object" && value) {
            // `forEach` can't be used to traverse an array in Opera <= 8.54
            // because its `Object#hasOwnProperty` implementation returns `false`
            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
            if (getClass.call(value) == arrayClass) {
              for (length = value.length; length--;) {
                update(value, length, callback);
              }
            } else {
              forEach(value, function (property) {
                update(value, property, callback);
              });
            }
          }
          return callback.call(source, property, value);
        };

        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
        exports.parse = function (source, callback) {
          var result, value;
          Index = 0;
          Source = "" + source;
          result = get(lex());
          // If a JSON string contains multiple tokens, it is invalid.
          if (lex() != "$") {
            abort();
          }
          // Reset the parser state.
          Index = Source = null;
          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
        };
      }
    }

    exports["runInContext"] = runInContext;
    return exports;
  }

  if (freeExports && !isLoader) {
    // Export for CommonJS environments.
    runInContext(root, freeExports);
  } else {
    // Export for web browsers and JavaScript engines.
    var nativeJSON = root.JSON,
        previousJSON = root["JSON3"],
        isRestored = false;

    var JSON3 = runInContext(root, (root["JSON3"] = {
      // Public: Restores the original value of the global `JSON` object and
      // returns a reference to the `JSON3` object.
      "noConflict": function () {
        if (!isRestored) {
          isRestored = true;
          root.JSON = nativeJSON;
          root["JSON3"] = previousJSON;
          nativeJSON = previousJSON = null;
        }
        return JSON3;
      }
    }));

    root.JSON = {
      "parse": JSON3.parse,
      "stringify": JSON3.stringify
    };
  }

  // Export for asynchronous module loaders.
  if (isLoader) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return JSON3;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(268)(module), __webpack_require__(49)))

/***/ }),
/* 649 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 650 */
/***/ (function(module, exports) {


/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks[event] = this._callbacks[event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  var self = this;
  this._callbacks = this._callbacks || {};

  function on() {
    self.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks[event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks[event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks[event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks[event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(652);
var isBuf = __webpack_require__(563);

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet){
  var buffers = [];
  var packetData = packet.data;

  function _deconstructPacket(data) {
    if (!data) return data;

    if (isBuf(data)) {
      var placeholder = { _placeholder: true, num: buffers.length };
      buffers.push(data);
      return placeholder;
    } else if (isArray(data)) {
      var newData = new Array(data.length);
      for (var i = 0; i < data.length; i++) {
        newData[i] = _deconstructPacket(data[i]);
      }
      return newData;
    } else if ('object' == typeof data && !(data instanceof Date)) {
      var newData = {};
      for (var key in data) {
        newData[key] = _deconstructPacket(data[key]);
      }
      return newData;
    }
    return data;
  }

  var pack = packet;
  pack.data = _deconstructPacket(packetData);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  var curPlaceHolder = 0;

  function _reconstructPacket(data) {
    if (data && data._placeholder) {
      var buf = buffers[data.num]; // appropriate buffer (should be natural order anyway)
      return buf;
    } else if (isArray(data)) {
      for (var i = 0; i < data.length; i++) {
        data[i] = _reconstructPacket(data[i]);
      }
      return data;
    } else if (data && 'object' == typeof data) {
      for (var key in data) {
        data[key] = _reconstructPacket(data[key]);
      }
      return data;
    }
    return data;
  }

  packet.data = _reconstructPacket(packet.data);
  packet.attachments = undefined; // no longer useful
  return packet;
};

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((global.Blob && obj instanceof Blob) ||
        (global.File && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (obj && 'object' == typeof obj && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(654);


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(655);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(482);


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var transports = __webpack_require__(565);
var Emitter = __webpack_require__(490);
var debug = __webpack_require__(502)('engine.io-client:socket');
var index = __webpack_require__(569);
var parser = __webpack_require__(482);
var parseuri = __webpack_require__(562);
var parsejson = __webpack_require__(670);
var parseqs = __webpack_require__(545);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (global.location && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (global.location ? location.hostname : 'localhost');
  this.port = opts.port || (global.location && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? null : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // other options for Node.js client
  var freeGlobal = typeof global === 'object' && global;
  if (freeGlobal.global === freeGlobal) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(544);
Socket.transports = __webpack_require__(565);
Socket.parser = __webpack_require__(482);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    agent: this.agent,
    hostname: this.hostname,
    port: this.port,
    secure: this.secure,
    path: this.path,
    query: query,
    forceJSONP: this.forceJSONP,
    jsonp: this.jsonp,
    forceBase64: this.forceBase64,
    enablesXDR: this.enablesXDR,
    timestampRequests: this.timestampRequests,
    timestampParam: this.timestampParam,
    policyPort: this.policyPort,
    socket: this,
    pfx: this.pfx,
    key: this.key,
    passphrase: this.passphrase,
    cert: this.cert,
    ca: this.ca,
    ciphers: this.ciphers,
    rejectUnauthorized: this.rejectUnauthorized,
    perMessageDeflate: this.perMessageDeflate,
    extraHeaders: this.extraHeaders,
    forceNode: this.forceNode,
    localAddress: this.localAddress
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(parsejson(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 656 */
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(543);
var Polling = __webpack_require__(566);
var Emitter = __webpack_require__(490);
var inherit = __webpack_require__(501);
var debug = __webpack_require__(502)('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;

  if (global.location) {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = opts.hostname !== global.location.hostname ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  } else {
    this.extraHeaders = opts.extraHeaders;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}
    if (this.supportsBinary) {
      // This has to be done after open because Firefox is stupid
      // http://stackoverflow.com/questions/13216903/get-binary-data-with-xmlhttprequest-in-a-firefox-extension
      xhr.responseType = 'arraybuffer';
    }

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (global.document) {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (global.document) {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type').split(';')[0];
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      if (!this.supportsBinary) {
        data = this.xhr.responseText;
      } else {
        try {
          data = String.fromCharCode.apply(null, new Uint8Array(this.xhr.response));
        } catch (e) {
          var ui8Arr = new Uint8Array(this.xhr.response);
          var dataArray = [];
          for (var idx = 0, length = ui8Arr.length; idx < length; idx++) {
            dataArray.push(ui8Arr[idx]);
          }

          data = String.fromCharCode.apply(null, dataArray);
        }
      }
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return 'undefined' !== typeof global.XDomainRequest && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (global.document) {
  if (global.attachEvent) {
    global.attachEvent('onunload', unloadHandler);
  } else if (global.addEventListener) {
    global.addEventListener('beforeunload', unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 658 */
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 660 */
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/wtf8 v1.0.0 by @mathias */
;(function(root) {

	// Detect free variables `exports`
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function wtf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte.
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read the first byte.
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			var byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid WTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function wtf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	var wtf8 = {
		'version': '1.0.0',
		'encode': wtf8encode,
		'decode': wtf8decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return wtf8;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = wtf8;
		} else { // in Narwhal or RingoJS v0.7.0-
			var object = {};
			var hasOwnProperty = object.hasOwnProperty;
			for (var key in wtf8) {
				hasOwnProperty.call(wtf8, key) && (freeExports[key] = wtf8[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.wtf8 = wtf8;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(268)(module), __webpack_require__(49)))

/***/ }),
/* 663 */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = global.BlobBuilder
  || global.WebKitBlobBuilder
  || global.MSBlobBuilder
  || global.MozBlobBuilder;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  for (var i = 0; i < ary.length; i++) {
    var chunk = ary[i];
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      ary[i] = buf;
    }
  }
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary);

  for (var i = 0; i < ary.length; i++) {
    bb.append(ary[i]);
  }

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  mapArrayBufferViews(ary);
  return new Blob(ary, options || {});
};

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = debug.debug = debug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(666);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lowercased letter, i.e. "n".
 */

exports.formatters = {};

/**
 * Previously assigned color.
 */

var prevColor = 0;

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 *
 * @return {Number}
 * @api private
 */

function selectColor() {
  return exports.colors[prevColor++ % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function debug(namespace) {

  // define the `disabled` version
  function disabled() {
  }
  disabled.enabled = false;

  // define the `enabled` version
  function enabled() {

    var self = enabled;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // add the `color` if not set
    if (null == self.useColors) self.useColors = exports.useColors();
    if (null == self.color && self.useColors) self.color = selectColor();

    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %o
      args = ['%o'].concat(args);
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting
    args = exports.formatArgs.apply(self, args);

    var logFn = enabled.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }
  enabled.enabled = true;

  var fn = exports.enabled(namespace) ? enabled : disabled;

  fn.namespace = namespace;

  return fn;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  var split = (namespaces || '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/[\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 666 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000
var m = s * 60
var h = m * 60
var d = h * 24
var y = d * 365.25

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} options
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {}
  var type = typeof val
  if (type === 'string' && val.length > 0) {
    return parse(val)
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ?
			fmtLong(val) :
			fmtShort(val)
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
}

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str)
  if (str.length > 10000) {
    return
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
  if (!match) {
    return
  }
  var n = parseFloat(match[1])
  var type = (match[2] || 'ms').toLowerCase()
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y
    case 'days':
    case 'day':
    case 'd':
      return n * d
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n
    default:
      return undefined
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd'
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h'
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm'
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's'
  }
  return ms + 'ms'
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms'
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name
  }
  return Math.ceil(ms / n) + ' ' + name + 's'
}


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module requirements.
 */

var Polling = __webpack_require__(566);
var inherit = __webpack_require__(501);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    if (!global.___eio) global.___eio = [];
    callbacks = global.___eio;
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (global.document && global.addEventListener) {
    global.addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(544);
var parser = __webpack_require__(482);
var parseqs = __webpack_require__(545);
var inherit = __webpack_require__(501);
var yeast = __webpack_require__(568);
var debug = __webpack_require__(502)('engine.io-client:websocket');
var BrowserWebSocket = global.WebSocket || global.MozWebSocket;
var NodeWebSocket;
if (typeof window === 'undefined') {
  try {
    NodeWebSocket = __webpack_require__(669);
  } catch (e) { }
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket;
if (!WebSocket && typeof window === 'undefined') {
  WebSocket = NodeWebSocket;
}

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  if (!this.usingBrowserWebSocket) {
    WebSocket = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = void (0);
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws = this.usingBrowserWebSocket ? new WebSocket(uri) : new WebSocket(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? global.Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 669 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * JSON parse.
 *
 * @see Based on jQuery#parseJSON (MIT) and JSON2
 * @api private
 */

var rvalidchars = /^[\],:{}\s]*$/;
var rvalidescape = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
var rvalidtokens = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g;
var rtrimLeft = /^\s+/;
var rtrimRight = /\s+$/;

module.exports = function parsejson(data) {
  if ('string' != typeof data || !data) {
    return null;
  }

  data = data.replace(rtrimLeft, '').replace(rtrimRight, '');

  // Attempt to parse using the native JSON parser first
  if (global.JSON && JSON.parse) {
    return JSON.parse(data);
  }

  if (rvalidchars.test(data.replace(rvalidescape, '@')
      .replace(rvalidtokens, ']')
      .replace(rvalidbraces, ''))) {
    return (new Function('return ' + data))();
  }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),
/* 672 */
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsShallowCompare = __webpack_require__(120);

var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);

__webpack_require__(729);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoardGoback = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(BoardGoback, _React$Component);

  function BoardGoback() {
    (0, _classCallCheck3.default)(this, BoardGoback);
    return (0, _possibleConstructorReturn3.default)(this, (BoardGoback.__proto__ || (0, _getPrototypeOf2.default)(BoardGoback)).apply(this, arguments));
  }

  (0, _createClass3.default)(BoardGoback, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _reactAddonsShallowCompare2.default)(this, nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          gobackAction = _props.gobackAction,
          title = _props.title;

      return _react2.default.createElement(
        'div',
        { className: 'o-fz--13 goback goback--modify', onTouchTap: gobackAction },
        title
      );
    }
  }]);
  return BoardGoback;
}(_react2.default.Component), Object.defineProperty(_class, 'displayName', {
  enumerable: true,
  writable: true,
  value: 'BoardGoback'
}), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    gobackAction: _react2.default.PropTypes.func.isRequired,
    title: _react2.default.PropTypes.string.isRequired
  }
}), _temp);
exports.default = BoardGoback;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(530);

var _reactIdSwiper = __webpack_require__(498);

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _dishHelper = __webpack_require__(43);

var _dishHelper2 = _interopRequireDefault(_dishHelper);

var _counter = __webpack_require__(461);

var _counter2 = _interopRequireDefault(_counter);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _classnames = __webpack_require__(50);

var _classnames2 = _interopRequireDefault(_classnames);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _brand = __webpack_require__(497);

var _brand2 = _interopRequireDefault(_brand);

__webpack_require__(585);

__webpack_require__(732);

var _guessYouLove = __webpack_require__(519);

var _guessYouLove2 = _interopRequireDefault(_guessYouLove);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DishDescPopupModes = {
  DEFAULT: 1, // popup模式
  PAGE: 2 // 单独页面模式
};

module.exports = _react2.default.createClass({
  displayName: 'DishDescPopup',
  contextTypes: {
    brandType: _react2.default.PropTypes.string
  },
  propTypes: {
    dishesDataDuplicate: _react2.default.PropTypes.array.isRequired,
    dish: _react2.default.PropTypes.object.isRequired,
    onOrderBtnTap: _react2.default.PropTypes.func.isRequired,
    onPropsBtnTap: _react2.default.PropTypes.func.isRequired,
    menuDataStatus: _react2.default.PropTypes.bool,
    backWhenPropsBtnTap: _react2.default.PropTypes.bool,
    toggleDishDescPopup: _react2.default.PropTypes.func,
    onCloseBtnTap: _react2.default.PropTypes.func,
    showHandleInput: _react2.default.PropTypes.func,
    mode: _react2.default.PropTypes.number,
    recommendDishList: _react2.default.PropTypes.array,
    dishTypesData: _react2.default.PropTypes.array,
    urlType: _react2.default.PropTypes.string,
    theme: _react2.default.PropTypes.string
  },
  componentDidMount: function componentDidMount() {
    window.swiper = _reactIdSwiper2.default;
  },
  onCloseBtnTap: function onCloseBtnTap(event) {
    if (event) {
      event.preventDefault();
    }

    var onCloseBtnTap = this.props.onCloseBtnTap;

    if (onCloseBtnTap) {
      onCloseBtnTap();
      return;
    }

    window.history.back(-1);
    this.props.toggleDishDescPopup();
  },
  onBtnTap: function onBtnTap(newCount, increment) {
    var _props = this.props,
        dish = _props.dish,
        onOrderBtnTap = _props.onOrderBtnTap,
        onPropsBtnTap = _props.onPropsBtnTap,
        backWhenPropsBtnTap = _props.backWhenPropsBtnTap;

    if (increment) {
      onOrderBtnTap(dish, increment);
    } else {
      if (backWhenPropsBtnTap !== false) {
        this.onCloseBtnTap();
      }

      onPropsBtnTap(dish, 'fromPopUp');
    }
  },
  getDishTitle: function getDishTitle(dish) {
    if (dish.sameDishIndexs) {
      /* /${dish.unitName} */
      return '' + dish.name + (dish.unitName !== '份' ? '/' + dish.unitName : '');
    }
    return _dishHelper2.default.generateDishNameWithUnit(dish, 'dishMenu');
  },
  getSameRuleDishList: function getSameRuleDishList(dish, dishesDataDuplicate) {
    var sameDishIndexs = dish.sameDishIndexs;

    return sameDishIndexs ? sameDishIndexs.map(function (dishIndex) {
      return dishesDataDuplicate[dishIndex];
    }) : null;
  },
  getDishMemberPrice: function getDishMemberPrice(dish, dishesDataDuplicate) {
    var sameRuleDishList = this.getSameRuleDishList(dish, dishesDataDuplicate);
    return _dishHelper2.default.getDishMemberPriceWithSameRuleDishes(dish, sameRuleDishList);
  },
  buildOrderBtn: function buildOrderBtn(dish, dishesDataDuplicate) {
    var dishOrder = (dishesDataDuplicate || []).filter(function (item) {
      return item.id === dish.id;
    })[0];
    var sameRuleDishList = this.getSameRuleDishList(dish, dishesDataDuplicate);
    var brandType = this.context.brandType;


    if (_dishHelper2.default.isSingleDishWithoutProps(dish) && !sameRuleDishList) {
      if (dish.clearStatus) {
        // 单菜品直接展示已售罄
        return _react2.default.createElement(
          'i',
          { className: 'dish-item-soldout-text' },
          _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.soldout)
        );
      }

      return _react2.default.createElement(_counter2.default, { count: dishOrder.order, onCountChange: this.onBtnTap, step: dish.stepNum, dishItem: dishOrder, soldoutClassName: 'dish-item-soldout' });
    }

    var dishes = sameRuleDishList || (dishOrder ? [dishOrder] : []);
    var count = _dishHelper2.default.getDishesCount(dishes);
    var title = Array.isArray(dish.groups) ? (0, _brand2.default)(brandType, 'dish-menu.select-child-dish', (0, _helper.formatMessage)(_dishMenu2.default.choseChildDish)) : (0, _helper.formatMessage)(_dishMenu2.default.choseSpecification);
    var countStyle = void 0;
    if (count < 10) {
      countStyle = { width: '16px' };
    } else if (count >= 10 && count <= 99) {
      countStyle = { width: '21px' };
    } else {
      countStyle = { width: '27px' };
    }
    return _react2.default.createElement(
      'div',
      { className: 'counter' },
      _react2.default.createElement(
        'button',
        { className: 'btn--ellips btn-choose-property', onTouchTap: this.onBtnTap },
        title,
        count > 0 ? _react2.default.createElement(
          'span',
          { className: (0, _classnames2.default)('dish-desc--counter counter-special', { 'counter-special--modify': count > 99 }), style: countStyle },
          count > 99 ? '99+' : count
        ) : false
      )
    );
  },
  buildDishSoldNum: function buildDishSoldNum(dishData) {
    var soldNum = parseInt(dishData.soldNum, 10);

    if (!soldNum || soldNum === 0) {
      return false;
    }
    return _react2.default.createElement(
      'span',
      { className: 'dish-sales-volume' },
      _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.monthlySales),
      soldNum
    );
  },
  buildDishResidueNum: function buildDishResidueNum(dishData) {
    var urlType = this.props.urlType;

    var enableSaleNum = (urlType === 'WM' ? dishData.residueTotalWechat : dishData.residueTotal) || 0;
    var showSaleNum = sessionStorage.getItem('showSaleNum') === 'true' || false; // 是否开启了商品余量展示开关
    var isShowRemainderTip = enableSaleNum <= 10 && enableSaleNum > 0 && showSaleNum;
    if (isShowRemainderTip) {
      return _react2.default.createElement(
        'span',
        { className: 'dish-sales-residue' },
        _react2.default.createElement(_formattedMessage2.default, _global2.default.onlyLeft),
        ' ',
        enableSaleNum + ' ' + dishData.unitName
      );
    }
    return null;
  },
  buildMemberPriceElement: function buildMemberPriceElement(dish, dishesDataDuplicate, useMergedMinPrice) {
    var memberPrice = this.getDishMemberPrice(dish, dishesDataDuplicate);
    var marketPrice = dish.marketPrice;

    if (dish.isUserMember) {
      return _react2.default.createElement(
        'p',
        { className: 'clearfix' },
        _react2.default.createElement(
          'span',
          { className: 'dish-desc-price--bold price' },
          memberPrice,
          useMergedMinPrice && _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.priceFrom)
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'price-badge-wrap' },
          _react2.default.createElement(
            'span',
            { className: 'dish-desc-price--del price' },
            marketPrice,
            useMergedMinPrice && _react2.default.createElement(
              'small',
              null,
              _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.priceFrom)
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'dish-desc-price-badge' },
            dish.discountLevel,
            _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.justForVIP),
            dish.discountType === 1 || dish.discountType === 3 ? _react2.default.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _dishMenu2.default.discountLevel, { values: { discountLevel: dish.memberPrice } })) : _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.price)
          )
        )
      );
    }

    return _react2.default.createElement(
      'p',
      { className: 'clearfix' },
      _react2.default.createElement(
        'span',
        { className: 'dish-desc-price--bold price' },
        marketPrice,
        useMergedMinPrice && _react2.default.createElement(
          'small',
          null,
          _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.priceFrom)
        )
      ),
      _react2.default.createElement(
        'span',
        { className: 'price-badge-wrap' },
        _react2.default.createElement(
          'span',
          { className: 'dish-desc-price--border' },
          _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.memberPrice),
          _react2.default.createElement(
            'i',
            { className: 'price' },
            memberPrice
          ),
          useMergedMinPrice && _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.priceFrom)
          )
        )
      )
    );
  },
  renderDishDesc: function renderDishDesc(dish) {
    var richDesc = dish.richDesc || '';
    if (!richDesc) {
      return _react2.default.createElement(
        'p',
        { className: 'dish-desc-desc' },
        dish.dishDesc || _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.noDesc)
      );
    }

    var escapeScript = function escapeScript(html) {
      return html.replace(/<([^>]*)script([^>]*)>/g, function ($0, $1, $2) {
        return '&lt;' + $1 + 'script' + $2 + '&gt;';
      });
    };

    return _react2.default.createElement('div', { className: 'dish-desc__rich-desc', dangerouslySetInnerHTML: { __html: escapeScript(richDesc) } });
  },
  onTouchStart: function onTouchStart() {
    this.mySwiper.stopAutoplay();
  },
  onTouchEnd: function onTouchEnd() {
    var _this = this;

    setTimeout(function () {
      _this.mySwiper.startAutoplay();
    }, 10);
  },
  renderTopNavBtn: function renderTopNavBtn() {
    var _this2 = this;

    var mode = this.props.mode;


    if (mode === DishDescPopupModes.PAGE) {
      return _react2.default.createElement(
        'div',
        { className: 'dish-detail-back', onTouchTap: function onTouchTap(event) {
            return _this2.onCloseBtnTap(event);
          } },
        _react2.default.createElement(
          'a',
          { className: 'btn-back' },
          _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.goOnPick)
        )
      );
    }

    return _react2.default.createElement(
      'div',
      { className: 'dish-detail-close', onTouchTap: function onTouchTap(event) {
          return _this2.onCloseBtnTap(event);
        } },
      _react2.default.createElement('a', { className: 'btn-close' })
    );
  },
  render: function render() {
    var _this3 = this;

    var _props2 = this.props,
        dish = _props2.dish,
        dishesDataDuplicate = _props2.dishesDataDuplicate,
        _props2$recommendDish = _props2.recommendDishList,
        recommendDishList = _props2$recommendDish === undefined ? [] : _props2$recommendDish,
        dishTypesData = _props2.dishTypesData,
        menuDataStatus = _props2.menuDataStatus;
    var _props3 = this.props,
        onOrderBtnTap = _props3.onOrderBtnTap,
        onPropsBtnTap = _props3.onPropsBtnTap;
    var mergedMinPrice = dish.mergedMinPrice,
        marketPrice = dish.marketPrice,
        largeImgList = dish.largeImgList;

    var orderBtn = this.buildOrderBtn(dish, dishesDataDuplicate);
    var useMergedMinPrice = mergedMinPrice !== undefined;
    var dishSoldNumElement = this.buildDishSoldNum(dish);
    var residueNum = this.buildDishResidueNum(dish);

    return _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)('dish-detail-container', 'dish-desc-container') },
      this.renderTopNavBtn(),
      _react2.default.createElement(
        'div',
        { className: 'dish-detail-content dish-detail-content--white' },
        _react2.default.createElement(
          'div',
          { className: 'dish-desc-content' },
          _react2.default.createElement(
            'div',
            { className: 'dish-desc-image', style: { background: largeImgList.length !== 0 && '#fff' } },
            largeImgList.length !== 0 ? _react2.default.createElement(
              _reactIdSwiper2.default,
              {
                pagination: largeImgList.length > 1 && '.swiper-pagination',
                paginationClickable: true,
                autoplay: 2500,
                onTouchStart: this.onTouchStart,
                onTouchEnd: this.onTouchEnd,
                onInit: function onInit(swiper) {
                  return _this3.mySwiper = swiper;
                },
                loop: largeImgList.length > 1
              },
              largeImgList.map(function (item, key) {
                return _react2.default.createElement(_httpsProtocolImage2.default, { src: item, alt: dish.name, key: key });
              })
            ) : false
          ),
          _react2.default.createElement(
            'div',
            { className: 'dish-desc-info' },
            _react2.default.createElement(
              'h2',
              { className: 'dish-desc-title' },
              this.getDishTitle(dish)
            ),
            dishSoldNumElement,
            residueNum,
            _react2.default.createElement(
              'div',
              { className: 'dish-desc-price-container' },
              dish.isMember ? this.buildMemberPriceElement(dish, dishesDataDuplicate, useMergedMinPrice) : _react2.default.createElement(
                'span',
                { className: 'dish-desc-price--bold price' },
                parseFloat(useMergedMinPrice ? mergedMinPrice : marketPrice, 10),
                useMergedMinPrice && _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.priceFrom)
                )
              ),
              orderBtn
            ),
            _react2.default.createElement(
              'h3',
              { className: 'dish-desc-subtitle' },
              _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.descSubtitle)
            ),
            this.renderDishDesc(dish)
          ),
          recommendDishList && recommendDishList.length && menuDataStatus ? _react2.default.createElement(_guessYouLove2.default, {
            recommendDishList: recommendDishList,
            dishesDataDuplicate: dishesDataDuplicate,
            dishTypesData: dishTypesData,
            onOrderBtnTap: onOrderBtnTap,
            onPropsBtnTap: onPropsBtnTap,
            recommendDishListOuterStyle: { paddingTop: 10 }
          }) : false
        )
      )
    );
  }
});

module.exports.Modes = DishDescPopupModes;

/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */,
/* 734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = __webpack_require__(51);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _commonHelper = __webpack_require__(3);

var _aliMiniprogramHelper = __webpack_require__(126);

var _aliMiniprogramHelper2 = _interopRequireDefault(_aliMiniprogramHelper);

__webpack_require__(736);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shopId = (0, _commonHelper.getUrlParam)('shopId');
var isAlipayMP = (0, _commonHelper.isAlipayMiniProgramBrowser)();
var ICON_SIZE_HALF = 75 / 2;

var HealthIcon = function (_React$Component) {
  (0, _inherits3.default)(HealthIcon, _React$Component);

  function HealthIcon(props) {
    (0, _classCallCheck3.default)(this, HealthIcon);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HealthIcon.__proto__ || (0, _getPrototypeOf2.default)(HealthIcon)).call(this, props));

    Object.defineProperty(_this, 'el', {
      enumerable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(_this, 'boundPreventDefault', {
      enumerable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_this, 'moving', {
      enumerable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_this, 'setPreventDefault', {
      enumerable: true,
      writable: true,
      value: function value() {
        if (!_this.el || _this.boundPreventDefault) {
          return;
        }

        _this.el.addEventListener('touchmove', function (e) {
          if (e.cancelable) {
            e.preventDefault();
          }
        }, { passive: false });
        _this.boundPreventDefault = true;
      }
    });
    Object.defineProperty(_this, 'handleIconClick', {
      enumerable: true,
      writable: true,
      value: function value() {
        // 跳转到插件页
        _aliMiniprogramHelper2.default.navigateTo('/pages/merchant-card/merchant-card', _this.state.callPluginParams);
      }
    });
    Object.defineProperty(_this, 'handleTouchStart', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.moving = true;
      }
    });
    Object.defineProperty(_this, 'handleTouchEnd', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.moving = false;
      }
    });
    Object.defineProperty(_this, 'handleTouchMove', {
      enumerable: true,
      writable: true,
      value: function value(e) {
        var point = e.changedTouches[0];

        if (point && _this.moving) {
          var clientX = point.clientX,
              clientY = point.clientY;

          _this.setState({
            positions: {
              top: clientY - ICON_SIZE_HALF,
              left: clientX - ICON_SIZE_HALF
            }
          });
        }
      }
    });

    _this.state = {
      visible: false,
      callPluginParams: null,
      positions: null
    };
    return _this;
  }

  (0, _createClass3.default)(HealthIcon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var now = new Date();

      if (!isAlipayMP) {
        return;
      }

      _fetchHelper2.default.get(_config2.default.shopHealthCodeInfoAPI, {
        shopId: shopId,
        dateStr: _commonHelper.dateUtility.format(now, 'yyyyMMdd')
      }).then(function (res) {
        var _ref = res || {},
            _ref$canShow = _ref.canShow,
            canShow = _ref$canShow === undefined ? false : _ref$canShow,
            rest = (0, _objectWithoutProperties3.default)(_ref, ['canShow']);

        _this2.setState({
          visible: canShow,
          callPluginParams: rest
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          visible = _state.visible,
          positions = _state.positions;


      return isAlipayMP && visible ? _react2.default.createElement('div', {
        className: 'health-icon',
        ref: function ref(el) {
          _this3.el = el;
          _this3.setPreventDefault();
        },
        style: positions,
        onClick: this.handleIconClick,
        onTouchStart: this.handleTouchStart,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd
      }) : null;
    }
  }]);
  return HealthIcon;
}(_react2.default.Component);

exports.default = HealthIcon;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = ShopDeliveryInfo;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _shop = __webpack_require__(477);

var _shop2 = _interopRequireDefault(_shop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ShopDeliveryInfo(_ref) {
  var takeawayServiceProps = _ref.takeawayServiceProps,
      _ref$prefixed = _ref.prefixed,
      prefixed = _ref$prefixed === undefined ? false : _ref$prefixed;

  if (!takeawayServiceProps) {
    return null;
  }

  var divider = ' | ';
  var sendTime = takeawayServiceProps.sendTime,
      shipmentFee = takeawayServiceProps.shipmentFee;

  var sendTextShipmentFee = takeawayServiceProps && typeof shipmentFee === 'number' ? [divider, _react2.default.createElement(_formattedMessage2.default, (0, _extends3.default)({ key: 'shipmentFee' }, _shop2.default.deliveryFee, { values: { shipmentFee: shipmentFee, currency: sessionStorage.getItem('currency') } }))] : '';
  var sendTextSendTime = takeawayServiceProps && typeof sendTime === 'number' ? [divider, _react2.default.createElement(_formattedMessage2.default, (0, _extends3.default)({ key: 'sendTime' }, _shop2.default.deliveryTime, { values: { sendTime: sendTime } }))] : '';

  return _react2.default.createElement(
    'span',
    null,
    prefixed ? divider : '',
    _react2.default.createElement(_formattedMessage2.default, (0, _extends3.default)({ key: 'deliveryFlag' }, _shop2.default.deliveryFlag)),
    sendTextShipmentFee,
    sendTextSendTime
  );
}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(114);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jsCookie = __webpack_require__(79);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _commonHelper = __webpack_require__(3);

var _helper = __webpack_require__(16);

var _floatingScrollSelector = __webpack_require__(492);

var _floatingScrollSelector2 = _interopRequireDefault(_floatingScrollSelector);

var _reactAddonsCssTransitionGroup = __webpack_require__(459);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _payMethodOption = __webpack_require__(493);

var _payMethodOption2 = _interopRequireDefault(_payMethodOption);

var _languages = __webpack_require__(739);

__webpack_require__(744);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shopId = (0, _commonHelper.getUrlParam)('shopId');

var LanguageRecharge = function (_React$Component) {
  (0, _inherits3.default)(LanguageRecharge, _React$Component);

  function LanguageRecharge(props) {
    (0, _classCallCheck3.default)(this, LanguageRecharge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LanguageRecharge.__proto__ || (0, _getPrototypeOf2.default)(LanguageRecharge)).call(this, props));

    _this.state = {
      tip: null,
      icon: null,
      showModal: false,
      defaultIndex: 1,
      isSubmit: false,
      customerRange: [],
      container: null
    };

    _this.showChangeList = _this.showChangeList.bind(_this);
    _this.clearChildView = _this.clearChildView.bind(_this);
    _this.getInitLanguageRange = _this.getInitLanguageRange.bind(_this);

    _this.confirmPeopleCountAndSubmit = _this.confirmPeopleCountAndSubmit.bind(_this);

    _this.toggleSelectorCheckedStatus = _this.toggleSelectorCheckedStatus.bind(_this);

    _this.renderSelector = _this.renderSelector.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(LanguageRecharge, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // 获取brandId
      this.brandId = sessionStorage.getItem('brandId');

      var userLanguage = _jsCookie2.default.get('language_switch_' + this.brandId);
      var localBrandLanguages = sessionStorage.getItem('brandLanguages');
      var brandLanguages = localBrandLanguages ? localBrandLanguages.split(',') : [];
      if (brandLanguages.length === 0) {
        return; // 如果品牌列表为空，则不展示语言切换
      }
      var supportLanguages = _languages.BrandLanguages.filter(function (item) {
        return brandLanguages.includes(item.type);
      });

      this.getInitLanguageRange(supportLanguages, userLanguage);
      var nowLocal = supportLanguages.filter(function (item) {
        return item.type === userLanguage;
      });

      var _ref = nowLocal.length !== 0 ? nowLocal[0] : supportLanguages[0],
          tip = _ref.tip,
          icon = _ref.icon,
          id = _ref.id;

      this.setState({
        tip: tip,
        icon: icon,
        defaultIndex: id
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var div = document.createElement('div');
      div.id = 'language__mask';
      document.body.appendChild(div);
      this.renderSelector();
    }
  }, {
    key: 'getInitLanguageRange',
    value: function getInitLanguageRange(range, userLanguage) {
      range.forEach(function (item, index) {
        item.id = index;
        item.isChecked = false;
      });
      this.setState({
        customerRange: range
      });
    }
  }, {
    key: 'showChangeList',
    value: function showChangeList() {
      var _this2 = this;

      var newHH = this.state.customerRange.map(function (item, index) {
        return (0, _extends3.default)({}, item, {
          isChecked: index === _this2.state.defaultIndex
        });
      });
      this.setState({ customerRange: newHH, showModal: true }, function () {
        _this2.renderSelector();
      });
      this.props.onChange(true);
    }
  }, {
    key: 'clearChildView',
    value: function clearChildView(e) {
      var _this3 = this;

      e.stopPropagation();

      this.setState({
        isSubmit: false,
        showModal: false
      }, function () {
        _this3.renderSelector();
      });
      this.props.onChange(false);
    }
  }, {
    key: 'confirmPeopleCountAndSubmit',
    value: function confirmPeopleCountAndSubmit(newCount) {
      var localLanguage = _jsCookie2.default.get('language_switch_' + this.brandId);
      var type = newCount.type,
          id = newCount.id,
          icon = newCount.icon,
          tip = newCount.tip;

      if (type === localLanguage) return;
      _jsCookie2.default.set('language_switch_' + this.brandId, type, { expires: 90 }); // 90天有效期
      this.setState({
        defaultIndex: id,
        tip: tip,
        icon: icon
      });
      // 因为很多页面在初始化时翻译了文案，所以此处统一重载页面
      // reload(type);

      location.reload();
    }
  }, {
    key: 'toggleSelectorCheckedStatus',
    value: function toggleSelectorCheckedStatus(value) {
      var _this4 = this;

      var newHH = this.state.customerRange.map(function (item, index) {
        return (0, _extends3.default)({}, item, {
          isChecked: index === value
        });
      });

      this.setState({ customerRange: newHH, defaultIndex: value }, function () {
        _this4.renderSelector();
      });
    }
  }, {
    key: 'renderSelector',
    value: function renderSelector() {
      _reactDom2.default.render(_react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        { transitionName: 'slideup', transitionEnterTimeout: 600, transitionLeaveTimeout: 600 },
        this.state.showModal && _react2.default.createElement(_floatingScrollSelector2.default, {
          selectorTitle: (0, _helper.formatMessage)(_global2.default.languageSwitch),
          closeSelector: this.clearChildView,
          setSelectedOption: this.confirmPeopleCountAndSubmit,
          toggleSelectorCheckedStatus: this.toggleSelectorCheckedStatus,
          optionComponent: _payMethodOption2.default,
          dataList: this.state.customerRange,
          defaultCheckedIndex: this.state.defaultIndex
        })
      ), document.getElementById('language__mask'));
    }
  }, {
    key: 'render',
    value: function render() {
      var tip = this.state.tip;

      return _react2.default.createElement(
        'div',
        null,
        tip && _react2.default.createElement(
          'div',
          { className: 'language-recharge', onTouchTap: this.showChangeList },
          _react2.default.createElement(
            'span',
            { className: 'language-recharge__tip' },
            this.state.tip
          ),
          _react2.default.createElement('div', { className: 'language-recharge__icon', style: { backgroundImage: 'url(' + this.state.icon + ')' } })
        )
      );
    }
  }]);
  return LanguageRecharge;
}(_react2.default.Component);

LanguageRecharge.propTypes = {
  onChange: _react2.default.PropTypes.func
};
LanguageRecharge.defaultProps = {
  onChange: function onChange() {}
};

exports.default = LanguageRecharge;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandLanguages = undefined;

var _zh_cn_icon = __webpack_require__(740);

var _zh_cn_icon2 = _interopRequireDefault(_zh_cn_icon);

var _zh_tw_icon = __webpack_require__(741);

var _zh_tw_icon2 = _interopRequireDefault(_zh_tw_icon);

var _en_gb_icon = __webpack_require__(742);

var _en_gb_icon2 = _interopRequireDefault(_en_gb_icon);

var _th_th_icon = __webpack_require__(743);

var _th_th_icon2 = _interopRequireDefault(_th_th_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 重要提示
 * 此处新增了语言类型，需要在 /src/helper/const/supportLanguage.js 中新增对应的语言类型
 * 同时在 src/root-application.js 中引入对应的react-intl资源，以及addLocaleData操作
 */
var BrandLanguages = exports.BrandLanguages = [{
  type: 'zh_CN', // 简体中文
  tip: '切换语言', // 切换语言的提示信息
  icon: _zh_cn_icon2.default,
  name: '简体中文'
}, {
  type: 'zh_TW', // 繁体中文
  tip: '切換語言',
  icon: _zh_tw_icon2.default,
  name: '繁體中文'
}, {
  type: 'en_GB', // 英文
  tip: 'Language',
  icon: _en_gb_icon2.default,
  name: 'English'
}, {
  type: 'th_TH', // 泰语
  tip: 'เปลี่ยนภาษา',
  icon: _th_th_icon2.default,
  name: 'ไทย'
}];

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/zh_cn_icon.svg";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/zh_tw_icon.svg";

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/en_gb_icon.svg";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/th_th_icon.svg";

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/yidayang.svg";

/***/ }),
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _pageHelper = __webpack_require__(123);

var _pageHelper2 = _interopRequireDefault(_pageHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
__webpack_require__(826);
var helper = __webpack_require__(43);
var cartHelper = __webpack_require__(453);
var shopId = helper.getUrlParam('shopId');
var type = helper.getUrlParam('type') || 'TS';
var config = __webpack_require__(13);
var ServiceBell = __webpack_require__(827);
var tradeDetailUncheckUrl = config.tradeDetailUncheckURL + '?type=' + type + '&shopId=' + shopId;
var dishCart4DinnerUrl = config.dishCart4DinnerURL + '?type=' + type + '&shopId=' + shopId;
var isShopOpen = __webpack_require__(43).isShopOpen;

var tableKey = cartHelper.getTableInfoInSessionStorage(shopId).tableKey || '';
var tableId = cartHelper.getTableInfoInSessionStorage(shopId).tableId || '';

var QuickMenu = React.createClass({
  displayName: 'QuickMenu',
  propTypes: {
    callBell: React.PropTypes.func.isRequired,
    clearBell: React.PropTypes.func.isRequired,
    callMsg: React.PropTypes.object.isRequired,
    callAble: React.PropTypes.bool.isRequired,
    dishes: React.PropTypes.array.isRequired,
    serviceStatus: React.PropTypes.object,
    openTimeList: React.PropTypes.array,
    showErrMsgFunc: React.PropTypes.func,
    clearErrorMsg: React.PropTypes.func,
    cancelCallMsg: React.PropTypes.func,
    updateCanCall: React.PropTypes.func,
    tableInfo: React.PropTypes.object.isRequired,
    shopInfo: React.PropTypes.object
  },

  getInitialState: function getInitialState() {
    return {
      expandMenu: true,
      animate: ''
    };
  },
  setCallClass: function setCallClass(enableCallService) {
    if (!enableCallService) {
      return 'call-menu-gray';
    }
    return '';
  },
  goToDetail: function goToDetail(enableOrder, isLogin) {
    // 进入订单详情页
    var orderId = sessionStorage.orderId || '';
    // 不带桌台的时候
    if (!tableKey && !tableId) {
      if (enableOrder && isLogin) {
        location.href = tradeDetailUncheckUrl + '&orderId=' + orderId;
      }
    } else {
      // 带桌台的时候
      if (enableOrder) {
        location.href = tradeDetailUncheckUrl + '&orderId=' + orderId;
      }
    }
  },
  goToPay: function goToPay(enablePay) {
    // 进入结算页面
    var orderId = sessionStorage.orderId || '';
    if (enablePay) {
      location.href = config.settlement4DinnerURL + '?type=TS&shopId=' + shopId + '&tradeId=' + orderId;
    }
  },
  jumpDetail: function jumpDetail(evt, num) {
    var _props = this.props,
        openTimeList = _props.openTimeList,
        showErrMsgFunc = _props.showErrMsgFunc;

    if (!isShopOpen(openTimeList)) {
      showErrMsgFunc('非常抱歉，门店已打烊');
      return false;
    }

    evt.preventDefault();
    var serviceStatus = this.props.serviceStatus;

    if (num) {
      if (serviceStatus.isLogin) {
        location.href = '' + dishCart4DinnerUrl; // 跳转到购物车详情页面
      } else {
        _pageHelper2.default.navigateToLoginPage({
          shopId: shopId,
          returnUrl: encodeURIComponent(dishCart4DinnerUrl)
        }); // 跳转到登录页面
      }
    }
    return true;
  },
  bellMenu: function bellMenu() {
    var _this = this;

    var status = this.state.expandMenu;
    if (status) {
      this.setState({ animate: '' }, function () {
        setTimeout(function () {
          _this.setState({ expandMenu: false });
        }, 400);
      });
    } else {
      this.setState({ expandMenu: true }, function () {
        _this.setState({ animate: 'animation' });
      });
    }
  },
  render: function render() {
    var _state = this.state,
        expandMenu = _state.expandMenu,
        animate = _state.animate;
    var _props2 = this.props,
        callBell = _props2.callBell,
        clearBell = _props2.clearBell,
        callMsg = _props2.callMsg,
        callAble = _props2.callAble,
        dishes = _props2.dishes,
        serviceStatus = _props2.serviceStatus,
        openTimeList = _props2.openTimeList,
        cancelCallMsg = _props2.cancelCallMsg,
        updateCanCall = _props2.updateCanCall,
        tableInfo = _props2.tableInfo,
        shopInfo = _props2.shopInfo,
        showErrMsgFunc = _props2.showErrMsgFunc,
        isFucBell = _props2.isFucBell;
    // 逻辑判断

    var enableCallService = serviceStatus.enableCallService;

    var orderedDishes = helper.getOrderedDishes(dishes);
    var dishesCount = helper.getDishesCount(orderedDishes);
    var cartIconClass = 'cart-icon cart-icon--tiny cart-icon--fixed';
    if (!dishesCount || !isShopOpen(openTimeList)) {
      cartIconClass += ' cart-icon--transparent';
    }
    return React.createElement(ServiceBell, {
      enableCallService: enableCallService,
      callBell: callBell,
      clearBell: clearBell,
      callMsg: callMsg,
      animate: animate,
      expandMenu: expandMenu,
      callAble: callAble,
      cancelCallMsg: cancelCallMsg,
      updateCanCall: updateCanCall,
      tableInfo: tableInfo,
      serviceSupply: shopInfo.serviceSupply,
      showErrMsgFunc: showErrMsgFunc,
      isFucBell: isFucBell
    });
  }
});
module.exports = QuickMenu;

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
__webpack_require__(828);

var classnames = __webpack_require__(50);
var Dialog = __webpack_require__(271);
var Toast = __webpack_require__(266);
var helper = __webpack_require__(3);


var ServiceBell = React.createClass({
  displayName: 'ServiceBell',
  propTypes: {
    enableCallService: React.PropTypes.bool,
    animate: React.PropTypes.string,
    callBell: React.PropTypes.func.isRequired,
    clearBell: React.PropTypes.func.isRequired,
    callMsg: React.PropTypes.object.isRequired,
    expandMenu: React.PropTypes.bool.isRequired,
    callAble: React.PropTypes.bool.isRequired,
    cancelCallMsg: React.PropTypes.func,
    updateCanCall: React.PropTypes.func,
    tableInfo: React.PropTypes.object.isRequired,
    serviceSupply: React.PropTypes.array,
    showErrMsgFunc: React.PropTypes.func
  },

  getInitialState: function getInitialState() {
    return {
      showBellList: false,
      contentCode: '',
      contentMsg: ''
    };
  },
  componentDidMount: function componentDidMount() {
    var updateCanCall = this.props.updateCanCall;
    // 设置服务铃

    var time = sessionStorage.getItem('callBellTime');

    if (time && time > 0) {
      updateCanCall(false);
      helper.interValSetting(time, function () {
        updateCanCall(true);
      });
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _this = this;

    if (nextProps.callAble && nextProps.callAble !== this.props.callAble) {
      this.setState({ endStatus: true });
      this._timer = setTimeout(function () {
        _this.setState({ endStatus: false });
      }, 1000);
    }
  },
  handleShowBellList: function handleShowBellList() {
    var _props = this.props,
        clearBell = _props.clearBell,
        callAble = _props.callAble,
        tableInfo = _props.tableInfo,
        serviceSupply = _props.serviceSupply,
        enableCallService = _props.enableCallService;

    var tableId = helper.getUrlParam('tableId') || helper.getUrlParam('tableKey') || tableInfo && (tableInfo.tableName || tableInfo.tableId);

    if (serviceSupply && serviceSupply.length === 0) {
      clearBell((0, _helper.formatMessage)(_errorMessage2.default.noConfigServiceBellError));
      return;
    }

    if (!tableId || !enableCallService) {
      clearBell((0, _helper.formatMessage)(_errorMessage2.default.noBindTableError));
      return;
    }

    if (!callAble) {
      clearBell((0, _helper.formatMessage)(_errorMessage2.default.waiterIsComingError));
      return;
    }

    this.setState({ showBellList: true });
  },
  handleHideBellList: function handleHideBellList() {
    this.setState({ showBellList: false, contentCode: '', contentMsg: '' });
  },
  handleCallBell: function handleCallBell(e) {
    var _state = this.state,
        contentCode = _state.contentCode,
        contentMsg = _state.contentMsg;
    var _props2 = this.props,
        callBell = _props2.callBell,
        showErrMsgFunc = _props2.showErrMsgFunc;

    e.stopPropagation();
    e.preventDefault();

    if (!contentCode || !contentMsg) {
      showErrMsgFunc((0, _helper.formatMessage)(_errorMessage2.default.chooseServiceError));
      return;
    }

    this.handleHideBellList();
    var time = sessionStorage.getItem('callBellTime') || 60;
    callBell(time, contentCode, contentMsg);
  },
  buildBellList: function buildBellList() {
    var _this2 = this;

    var _state2 = this.state,
        contentCode = _state2.contentCode,
        contentMsg = _state2.contentMsg;
    var serviceSupply = this.props.serviceSupply;

    var bellList = [].slice.call(serviceSupply || []).sort(function (a, b) {
      return a.sort - b.sort;
    });

    return bellList.map(function (item, index) {
      return React.createElement(
        'div',
        {
          key: index,
          className: classnames('shortcut-bell-item o-fz--14', { 'shortcut-bell-item-active': contentCode === item.code && contentMsg === item.desc }),
          onTouchTap: function onTouchTap() {
            return _this2.setState({ contentCode: item.code, contentMsg: item.desc });
          }
        },
        item.desc
      );
    });
  },
  render: function render() {
    var showBellList = this.state.showBellList;
    var _props3 = this.props,
        callMsg = _props3.callMsg,
        cancelCallMsg = _props3.cancelCallMsg,
        serviceSupply = _props3.serviceSupply,
        isFucBell = _props3.isFucBell;

    return React.createElement(
      'div',
      { className: 'shortcut-bell' },
      showBellList && React.createElement(
        Dialog,
        {
          hasTopBtnClose: false,
          title: (0, _helper.formatMessage)(_errorMessage2.default.chooseServiceError),
          onClose: this.handleHideBellList,
          theme: 'sliver'
        },
        React.createElement(
          'div',
          { className: 'shortcut-bell-box', ref: 'bellBox' },
          React.createElement(
            'div',
            { className: 'o-ta--l shortcut-bell-list' },
            this.buildBellList()
          ),
          React.createElement(
            'div',
            { className: 'shortcut-bell-sendouter' },
            React.createElement(
              'div',
              { className: 'shortcut-bell-send', onTouchTap: this.handleCallBell },
              React.createElement(_formattedMessage2.default, _dishMenu2.default.send)
            )
          )
        )
      ),
      !isFucBell && serviceSupply && serviceSupply.length ? React.createElement(
        'div',
        { className: 'shortcut-bell-button bg-grey', onTouchTap: this.handleShowBellList },
        React.createElement(
          'span',
          null,
          React.createElement(_formattedMessage2.default, _dishMenu2.default.serviceBell)
        )
      ) : false,
      isFucBell && serviceSupply && serviceSupply.length ? React.createElement('div', { className: 'shortcut-bell-button-reset', onTouchTap: this.handleShowBellList }) : false,
      callMsg.info && React.createElement(Toast, { errorMessage: callMsg.info, clearErrorMsg: cancelCallMsg })
    );
  }
});

module.exports = ServiceBell;

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactIdSwiper = __webpack_require__(498);

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _showGoback = __webpack_require__(728);

var _showGoback2 = _interopRequireDefault(_showGoback);

var _dish_img_default = __webpack_require__(617);

var _dish_img_default2 = _interopRequireDefault(_dish_img_default);

__webpack_require__(530);

var _seamlessImmutable = __webpack_require__(77);

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);

var DishListItem = __webpack_require__(488);

__webpack_require__(499);
var classnames = __webpack_require__(50);

__webpack_require__(830);


var DishHotSlide = React.createClass({
  displayName: 'DishHotSlide',

  propTypes: {
    goBack: React.PropTypes.func,
    theme: React.PropTypes.string,
    dishesData: React.PropTypes.array.isRequired,
    sameRuleDishList: React.PropTypes.array,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    onImageBtnTap: React.PropTypes.func.isRequired,
    diningForm: React.PropTypes.number,
    marketList: React.PropTypes.object,
    soldTopDishList: React.PropTypes.array
  },
  getInitialState: function getInitialState() {
    return {
      hotActiveIndex: 0
    };
  },

  onOrderDishUpdateInfo: {},

  onDishBtnTap: function onDishBtnTap(dishData, action) {
    var _props = this.props,
        onOrderBtnTap = _props.onOrderBtnTap,
        onPropsBtnTap = _props.onPropsBtnTap;

    if (action) {
      this.onOrderDishUpdateInfo = {
        dishData: dishData,
        action: action
      };
      onOrderBtnTap((0, _seamlessImmutable2.default)(dishData), action);
    } else {
      onPropsBtnTap((0, _seamlessImmutable2.default)(dishData));
    }
  },
  setActiveIndex: function setActiveIndex(num) {
    // 设置图片索引
    this.setState({ hotActiveIndex: num });
  },
  setDishTypeDataHot: function setDishTypeDataHot() {
    var _this = this;

    var dishHotItem = this.props.soldTopDishList.map(function (temp, i) {
      var sameDishIndexs = temp.sameDishIndexs;

      var sameRuleDishList = sameDishIndexs ? sameDishIndexs.map(function (dishIndex) {
        return _this.props.dishesData[dishIndex];
      }) : null;
      return React.createElement(
        'li',
        { key: i, className: classnames('dish-item-dish', { 'last-item': i === length - 1 }) },
        React.createElement(
          'div',
          { style: { position: 'relative' } },
          _this.state.hotActiveIndex !== i && React.createElement('div', { className: 'hot-hid' }),
          React.createElement(DishListItem, {
            theme: 'huge',
            dishData: temp,
            sameRuleDishList: sameRuleDishList,
            onOrderBtnTap: _this.onDishBtnTap,
            onPropsBtnTap: _this.onDishBtnTap,
            onImageBtnTap: _this.props.onImageBtnTap,
            marketList: _this.props.marketList,
            diningForm: _this.props.diningForm,
            hotTag: true,
            showHandleInput: _this.props.showHandleInput
          })
        )
      );
    });

    return dishHotItem;
  },
  gobackAction: function gobackAction() {
    location.hash = '';
  },
  render: function render() {
    var _this2 = this;

    var listSmallElement = this.props.soldTopDishList.map(function (item, index) {
      var hotNum = '';
      switch (index) {
        case 0:
          hotNum = 'hotNum hotNum_0';
          break;
        case 1:
          hotNum = 'hotNum hotNum_1';
          break;
        case 2:
          hotNum = 'hotNum hotNum_2';
          break;
        default:
          break;
      }
      var imgStyle = item.smallImgUrl || item.largeImgList[0] ? 'mediuImg' : 'smallImg';
      return React.createElement(
        'div',
        {
          key: index,
          className: classnames('o-mt hot-item', { 'o-ml': index === 0 }),
          onTouchTap: function onTouchTap() {
            _this2.swiperBig.slideTo(index, 1000, false);_this2.setActiveIndex(index);_this2.swiperSmall.slideTo(index - 1, 1000, false);
          },
          style: { right: '7px' }
        },
        React.createElement(
          'div',
          { className: classnames('small-item', { 'small-item-active': _this2.state.hotActiveIndex === index }) },
          React.createElement('i', { className: hotNum }),
          React.createElement(_httpsProtocolImage2.default, { src: item.smallImgUrl || item.largeImgList[0] || _dish_img_default2.default, alt: '', className: imgStyle })
        )
      );
    });

    var listBigElement = this.setDishTypeDataHot();

    return React.createElement(
      'div',
      { className: 'o-bg-grey dish-hot' },
      React.createElement('div', { className: 'dish-hot-blur' }),
      React.createElement(_showGoback2.default, { gobackAction: this.props.goBack, title: (0, _helper.formatMessage)(_global2.default.goToOrder) }),
      React.createElement(
        'div',
        { className: 'hot-list-small' },
        React.createElement(
          _reactIdSwiper2.default,
          {
            slidesPerView: 4.3,
            onInit: function onInit(swiper) {
              _this2.swiperSmall = swiper;
            },
            initialSlide: 0,
            slideToClickedSlide: true

          },
          listSmallElement
        )
      ),
      React.createElement(
        'div',
        { className: 'hot-list-big' },
        React.createElement(
          _reactIdSwiper2.default,
          {
            spaceBetween: -70,
            slidesPerView: 1,
            initialSlide: 0,
            nextButton: listBigElement.length > 1 ? '.swiper-button-next' : '',
            prevButton: listBigElement.length > 1 ? '.swiper-button-prev' : '',
            onInit: function onInit(swiper) {
              _this2.swiperBig = swiper;
            },
            onSlideChangeStart: function onSlideChangeStart(swiper) {
              _this2.swiperSmall.slideTo(swiper.activeIndex, 1000, false);_this2.setActiveIndex(swiper.activeIndex);
            }
          },
          listBigElement
        )
      ),
      React.createElement('div', { style: { height: '56px' } })
    );
  }
});

module.exports = DishHotSlide;

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(832);

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreloadSkeleton = function (_Component) {
  (0, _inherits3.default)(PreloadSkeleton, _Component);

  function PreloadSkeleton() {
    (0, _classCallCheck3.default)(this, PreloadSkeleton);
    return (0, _possibleConstructorReturn3.default)(this, (PreloadSkeleton.__proto__ || (0, _getPrototypeOf2.default)(PreloadSkeleton)).apply(this, arguments));
  }

  (0, _createClass3.default)(PreloadSkeleton, [{
    key: 'createSideBarItems',
    value: function createSideBarItems() {
      var items = [];

      // 写定 20 条数据
      for (var i = 0; i < 20; i++) {
        items.push(_react2.default.createElement(
          'div',
          { className: 'o-bg-grey skeleton__sidebar--item', key: i },
          _react2.default.createElement('div', { className: 'skeleton__sidebar--item-inner' })
        ));
      }

      return items;
    }
  }, {
    key: 'createListItems',
    value: function createListItems() {
      var items = [];

      for (var i = 0; i < 20; i++) {
        items.push(_react2.default.createElement(
          'div',
          { className: 'skeleton__list--item', key: i },
          _react2.default.createElement('div', { className: 'skeleton__list--img' }),
          _react2.default.createElement(
            'div',
            { className: 'o-flex skeleton__list--desc' },
            _react2.default.createElement('div', { className: 'skeleton__list--desc-title' }),
            _react2.default.createElement('div', { className: 'skeleton__list--desc-detail' }),
            _react2.default.createElement(
              'div',
              { className: 'o-flex skeleton__list--desc-operation' },
              _react2.default.createElement('div', { className: 'operation__desc' }),
              _react2.default.createElement('div', { className: 'operation__btn' })
            )
          )
        ));
      }

      return items;
    }
  }, {
    key: 'render',
    value: function render() {
      var sidebarItems = this.createSideBarItems();
      var listItems = this.createListItems();

      return _react2.default.createElement(
        'div',
        { className: 'o-bg-white skeleton__container' },
        _react2.default.createElement(
          'div',
          { className: 'skeleton__header' },
          _react2.default.createElement(
            'div',
            { className: 'o-flex skeleton__shop' },
            _react2.default.createElement('div', { className: 'skeleton__header--avatar' }),
            _react2.default.createElement(
              'div',
              { className: 'skeleton__header--title' },
              _react2.default.createElement('div', { className: 'skeleton__header--title-top' }),
              _react2.default.createElement('div', { className: 'skeleton__header--title-bottom' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'skeleton__ads' },
            _react2.default.createElement('div', { className: 'skeleton__ads--item' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'o-flex skeleton__body' },
          _react2.default.createElement(
            'div',
            { className: 'skeleton__sidebar' },
            sidebarItems
          ),
          _react2.default.createElement(
            'div',
            { className: 'skeleton__list' },
            _react2.default.createElement('div', { className: 'skeleton__list--title' }),
            listItems
          )
        )
      );
    }
  }]);
  return PreloadSkeleton;
}(_react.Component);

exports.default = PreloadSkeleton;

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var shallowCompare = __webpack_require__(120);
var couponHelper = __webpack_require__(549);
var Toast = __webpack_require__(266);

__webpack_require__(730);

module.exports = React.createClass({
  displayName: 'DishCoupon',
  propTypes: {
    // reducer
    shopInfo: React.PropTypes.object,
    showFixedCoupon: React.PropTypes.bool,
    closeDishCouponSuccess: React.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      shopInfo: {}
    };
  },
  getInitialState: function getInitialState() {
    return {
      showDishCouponSuccess: true,
      showToastMessage: true
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  setCouponValue: function setCouponValue(marketCoupon, bigCoupon) {
    // 展示领券成功
    if (bigCoupon) {
      if (marketCoupon.couponType === 1 || marketCoupon.couponType === 4) {
        return React.createElement(
          'div',
          { className: 'price' },
          marketCoupon.ruleValue
        );
      } else if (marketCoupon.couponType === 2) {
        return React.createElement(
          'div',
          null,
          marketCoupon.ruleValue,
          React.createElement(
            'small',
            null,
            React.createElement(_formattedMessage2.default, _global2.default.discount)
          )
        );
      }
    } else {
      // 领券成功
      if (marketCoupon.coupType === 1 || marketCoupon.coupType === 4) {
        return React.createElement(
          'div',
          { className: 'price' },
          marketCoupon.value
        );
      } else if (marketCoupon.coupType === 2) {
        return React.createElement(
          'div',
          null,
          marketCoupon.value,
          React.createElement(
            'small',
            null,
            React.createElement(_formattedMessage2.default, _global2.default.discount)
          )
        );
      }
    }
    return false;
  },
  getValidTime: function getValidTime(couponStatus, startDate, endDate, checkTime) {
    var validTime = '';
    validTime = React.createElement(
      'div',
      null,
      startDate !== endDate ? React.createElement(
        'div',
        null,
        React.createElement(
          'span',
          { className: 'validity-date' },
          couponHelper.formatDate(startDate)
        ),
        React.createElement(
          'span',
          { className: 'validity-date' },
          couponHelper.formatDate(endDate)
        )
      ) : React.createElement(
        'div',
        null,
        React.createElement(
          'span',
          { className: 'validity-date' },
          couponHelper.formatDate(startDate)
        ),
        React.createElement(
          'span',
          { className: 'validity-date' },
          React.createElement(_formattedMessage2.default, _global2.default.validOnTheDay)
        )
      )
    );
    return validTime;
  },
  closeCouponSuccess: function closeCouponSuccess() {
    var closeDishCouponSuccess = this.props.closeDishCouponSuccess;

    this.setState({ showDishCouponSuccess: false });
    closeDishCouponSuccess();
  },
  formatCouponSuccessInfo: function formatCouponSuccessInfo(couponSuccessInfo) {
    var validTime = this.getValidTime(couponSuccessInfo.couponStatus, couponSuccessInfo.validStartDate, couponSuccessInfo.validEndDate, couponSuccessInfo.checkTime);
    var couponObj = couponHelper.loyaltyCouponParam(couponSuccessInfo);
    return React.createElement(
      'div',
      { className: 'dish-coupon-success-content' },
      React.createElement('i', { className: 'dish-coupon-success-star star1' }),
      React.createElement('i', { className: 'dish-coupon-success-star star2' }),
      React.createElement('i', { className: 'dish-coupon-success-star star3' }),
      React.createElement(
        'div',
        { className: 'dish-coupon-success-content-head' },
        React.createElement(_formattedMessage2.default, _global2.default.receiveSuccess),
        React.createElement('i', { className: 'dish-coupon-success-close', onTouchTap: this.closeCouponSuccess })
      ),
      React.createElement(
        'div',
        { className: 'dish-coupon-success-content-detail of' },
        React.createElement(
          'div',
          { className: 'dish-coupon-inner' },
          React.createElement(
            'div',
            { className: 'dish-coupon-content' },
            React.createElement(
              'div',
              { className: 'clearfix', style: { width: '100%' } },
              React.createElement(
                'div',
                { className: 'dish-coupon-content__value' },
                this.setCouponValue(couponSuccessInfo, true)
              ),
              React.createElement(
                'div',
                { className: 'dish-coupon-content__title' },
                couponSuccessInfo.couponName
              ),
              React.createElement(
                'div',
                { className: 'dish-coupon-content__description' },
                couponObj.fullValue ? React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _global2.default.fullValueCanUse, { values: { fullValue: couponObj.fullValue, currency: sessionStorage.getItem('currency') } })) : React.createElement(_formattedMessage2.default, _global2.default.useUnlimited),
                couponObj.periodStart !== couponObj.periodEnd && React.createElement(
                  'span',
                  null,
                  '(',
                  couponObj.periodStart,
                  '~',
                  couponObj.periodEnd,
                  ')'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'dish-coupon-status' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'dish-coupon-content__title' },
                React.createElement(_formattedMessage2.default, _global2.default.validityPeriod)
              ),
              React.createElement(
                'div',
                { className: 'dish-coupon-content__description' },
                validTime
              )
            )
          )
        )
      )
    );
  },

  // 强制领券点击弹出浮层
  clearErrorMsg: function clearErrorMsg() {
    this.setState({ showToastMessage: false });
  },
  render: function render() {
    var _this = this;

    var _state = this.state,
        showDishCouponSuccess = _state.showDishCouponSuccess,
        showToastMessage = _state.showToastMessage;
    var _props = this.props,
        showFixedCoupon = _props.showFixedCoupon,
        shopInfo = _props.shopInfo;

    var errorMessage = (0, _helper.formatMessage)(_errorMessage2.default.successGetCoupon);

    return React.createElement(
      'div',
      { className: 'dish-coupon-success-outer' },
      (showFixedCoupon && showDishCouponSuccess && showToastMessage || shopInfo.couponSuccess && showToastMessage) && React.createElement(
        'div',
        { className: 'dish-menu-coupon__toast' },
        React.createElement(Toast, { errorMessage: errorMessage, clearErrorMsg: function clearErrorMsg() {
            _this.clearErrorMsg();
          }, timeout: 3000 })
      )
    );
  }
});

/***/ }),
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(848);

var FullscreenAd = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FullscreenAd, _Component);

  function FullscreenAd(props) {
    (0, _classCallCheck3.default)(this, FullscreenAd);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenAd.__proto__ || (0, _getPrototypeOf2.default)(FullscreenAd)).call(this, props));

    Object.defineProperty(_this, 'handleClose', {
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          visible: false
        });
      }
    });

    _this.state = {
      visible: true
    };
    return _this;
  }

  (0, _createClass3.default)(FullscreenAd, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          imageUrl = _props.imageUrl,
          _props$link = _props.link,
          link = _props$link === undefined ? '' : _props$link;
      var visible = this.state.visible;


      return imageUrl && visible ? _react2.default.createElement(
        'div',
        { className: 'fullscreen-ad' },
        _react2.default.createElement(
          'a',
          {
            className: 'fullscreen-ad-link',
            href: link
          },
          _react2.default.createElement('img', {
            className: 'fullscreen-ad-image',
            src: imageUrl,
            alt: '\u5168\u5C4F\u5E7F\u544A'
          })
        ),
        _react2.default.createElement('div', {
          onClick: this.handleClose,
          className: 'fullscreen-ad-close'
        })
      ) : null;
    }
  }]);
  return FullscreenAd;
}(_react.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    imageUrl: _react2.default.PropTypes.string,
    link: _react2.default.PropTypes.string
  }
}), _temp);
exports.default = FullscreenAd;

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);

var _require = __webpack_require__(114),
    findDOMNode = _require.findDOMNode;

var shallowCompare = __webpack_require__(120);
var IScroll = __webpack_require__(852);
var _find = __webpack_require__(411);
var DynamicClassLI = __webpack_require__(450)('li');
var helper = __webpack_require__(43);

var _require2 = __webpack_require__(3),
    isFormalMeal = _require2.isFormalMeal;

var isShowNav = helper.getUrlParam('showNav');
var diningType = helper.getUrlParam('type');
var classnames = __webpack_require__(50);
__webpack_require__(853);

var getPrevIndexNotFalse = function getPrevIndexNotFalse(ary, initIndex) {
  var prev = initIndex - 1;
  if (prev >= 0) {
    if (ary[prev] !== false) {
      return prev;
    } else {
      return getPrevIndexNotFalse(ary, prev);
    }
  }
  return -1;
};

var getActiveAndPrevIndex = function getActiveAndPrevIndex(dishTypes, dishesData, activeDishTypeId, activeDishTypeIdIndex) {
  var activeIndex = -1;
  var prevIndex = -1;
  var idxCount = 0;

  var newAry = dishTypes.map(function (dt, index) {
    var dishIds = dt.dishIds,
        id = dt.id;

    if (!dishIds || dishIds.length === 0) {
      return false;
    }
    if (dishIds.length === 1 && _find(dishesData, { id: dishIds[0] }).currRemainTotal === 0) {
      // 中类下面子菜的数量只有一个且售罄的情况下，中类不显示
      return false;
    }
    if (activeDishTypeId + '_' + activeDishTypeIdIndex === id + '_' + idxCount) {
      activeIndex = index;
    }
    idxCount++;
    return true;
  });

  if (activeIndex >= 0) {
    prevIndex = getPrevIndexNotFalse(newAry, activeIndex);
  }

  return { activeIndex: activeIndex, prevIndex: prevIndex };
};

module.exports = React.createClass({
  displayName: 'DishTypeScroller',
  propTypes: {
    activeDishTypeId: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    activeDishTypeIdIndex: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    dishTypesData: React.PropTypes.array.isRequired,
    dishesData: React.PropTypes.array.isRequired,
    onDishTypeElementTap: React.PropTypes.func.isRequired,
    theme: React.PropTypes.string,
    diningForm: React.PropTypes.number
  },
  componentWillMount: function componentWillMount() {
    this.shouldCalcIscroll = true;
  },
  componentDidMount: function componentDidMount() {
    var iScrollOptions = this.getIScrollOptionsInDiffTheme();

    this._cache = {};
    this._cache.iScroll = new IScroll('.scroll-wrapper', iScrollOptions);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (nextProps.theme === this.props.theme) {
      return;
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  componentDidUpdate: function componentDidUpdate() {
    var iScroll = this._cache.iScroll;
    var theme = this.props.theme;

    var activeDishType = findDOMNode(this).querySelector('.is-active');
    if (activeDishType) {
      if (/big|huge/.test(theme)) {
        iScroll.scrollToElement(activeDishType, 400, true);
      } else {
        iScroll.scrollToElement(activeDishType, 600, 0, -100);
      }
    }
    // this.initWrapSize();
    setTimeout(function () {
      iScroll.refresh();
    }, 500);
  },
  componentWillUnmount: function componentWillUnmount() {
    this._cache.iScroll.destroy();
    this._cache = null;
  },
  onDishTypeElementTap: function onDishTypeElementTap(evt) {
    var onDishTypeElementTap = this.props.onDishTypeElementTap;

    var dishTypeId = evt.currentTarget.dataset.id;
    this.setState({
      dishTypeIdFollow: dishTypeId.split('_')[1]
    });
    onDishTypeElementTap(evt, dishTypeId.split('_')[0], dishTypeId.split('_')[1]);
  },
  getIScrollOptionsInDiffTheme: function getIScrollOptionsInDiffTheme() {
    var defaultOptions = {
      click: true,
      tap: true,
      scrollX: true
    };

    var getOptions = {
      big: function big() {
        return { scrollX: true, scrollY: false };
      },
      huge: function huge() {
        return { scrollX: true, scrollY: false };
      }
    }[this.props.theme];

    var options = getOptions && getOptions.call(this);
    return (0, _assign2.default)({}, defaultOptions, options);
  },
  initWrapSize: function initWrapSize() {
    var _props = this.props,
        dishTypesData = _props.dishTypesData,
        theme = _props.theme;

    if (!dishTypesData.length || this._initWrapSized) {
      return;
    }

    var wrapEl = findDOMNode(this).querySelector('.scroll-wrapper');
    var listEl = wrapEl.querySelector('.dish-type-list');
    var rect = listEl.getBoundingClientRect();

    var _init = function _init() {
      if (!/big|huge/.test(theme)) {
        return;
      }
      wrapEl.style.width = rect.width + 10 + 'px';
    };

    _init();
    this._initWrapSized = true;
  },
  buildDishTypeIcon: function buildDishTypeIcon(dishTypeData) {
    if (dishTypeData.type !== 'tag') {
      return false;
    }
    var iconElement = '';
    switch (dishTypeData.name) {
      case '热门':
        iconElement = React.createElement('i', { className: 'icon icon-fire' });
        break;
      case '推荐':
        iconElement = React.createElement('i', { className: 'icon icon-thumb' });
        break;
      case '折扣':
        iconElement = React.createElement('i', { className: 'icon icon-percent' });
        break;
      case '赠品':
        iconElement = React.createElement('i', { className: 'icon icon-present' });
        break;
      case '特价':
        iconElement = React.createElement('i', { className: 'icon icon-tag' });
        break;
      case '特色':
        iconElement = React.createElement('i', { className: 'icon icon-star' });
        break;
      default:
        break;
    }
    return iconElement;
  },
  buildDishTypeElements: function buildDishTypeElements(activeDishTypeId, activeDishTypeIdIndex, dishTypesData, dishesData) {
    var _this = this;

    var getOrderedCountByType = function getOrderedCountByType(dishes, dishTypeData) {
      var orderedDishesByType = helper.getOrderedDishes(dishes).filter(function (dish) {
        return dish.dishTypeId === dishTypeData.id;
      });

      var count = helper.getDishesCount(orderedDishesByType);

      return count || null;
    };
    var _props2 = this.props,
        diningForm = _props2.diningForm,
        theme = _props2.theme;

    var hasFloatingNav = isFormalMeal(diningForm) && diningType === 'TS' || isShowNav;
    var dishTypeListStyle = theme === 'default' || theme === 'tea' ? { paddingBottom: hasFloatingNav ? 250 : 230 } : {};

    var _getActiveAndPrevInde = getActiveAndPrevIndex(dishTypesData, dishesData, activeDishTypeId, activeDishTypeIdIndex),
        activeIndex = _getActiveAndPrevInde.activeIndex,
        prevIndex = _getActiveAndPrevInde.prevIndex;

    var idxCount = 0;
    var dishTypeEl = dishTypesData.map(function (dishTypeData, idx) {
      if (!dishTypeData.dishIds || dishTypeData.dishIds.length === 0) {
        return false;
      }
      if (dishTypeData.dishIds.length === 1 && _find(dishesData, { id: dishTypeData.dishIds[0] }).currRemainTotal === 0) {
        // 中类下面子菜的数量只有一个且售罄的情况下，中类不显示
        return false;
      }

      // 设置标签图标
      var dishTypeIcon = _this.buildDishTypeIcon(dishTypeData);
      var count = getOrderedCountByType(dishesData, dishTypeData);
      var countStyle = void 0;
      if (count < 10) {
        countStyle = { width: '16px' };
      } else if (count >= 10 && count <= 99) {
        countStyle = { width: '21px' };
      } else {
        countStyle = { width: '27px' };
      }
      // const isActive = `${activeDishTypeId}_${activeDishTypeIdIndex}` === `${dishTypeData.id}_${idxCount}`;
      // if (isActive) {
      //   activeIndex = idx;
      // }
      var dynamicClassLI = React.createElement(
        DynamicClassLI,
        {
          key: idx,
          'data-id': dishTypeData.id + '_' + idxCount,
          'data-count': count,
          isActive: activeIndex === idx,
          className: classnames('dish-type-item', { 'dish-type-item--omitAfter': !count }, { 'dish-type-item-prev': prevIndex === idx }),
          onTouchTap: _this.onDishTypeElementTap
        },
        count > 0 && React.createElement(
          'i',
          { className: 'dish-type-item--count counter-special', style: countStyle },
          count > 99 ? '99+' : count
        ),
        dishTypeIcon,
        React.createElement(
          'span',
          null,
          dishTypeData.name
        )
      );
      idxCount++;
      return dynamicClassLI;
    });

    return React.createElement(
      'ul',
      { className: 'dish-type-list', style: dishTypeListStyle },
      dishTypeEl
    );
  },
  render: function render() {
    var _props3 = this.props,
        activeDishTypeId = _props3.activeDishTypeId,
        activeDishTypeIdIndex = _props3.activeDishTypeIdIndex,
        dishTypesData = _props3.dishTypesData,
        dishesData = _props3.dishesData,
        theme = _props3.theme;

    var dishTypeElements = this.buildDishTypeElements(activeDishTypeId, activeDishTypeIdIndex, dishTypesData, dishesData);
    var scrollWrapperStyle = theme === 'default' || theme === 'tea' ? { height: '100%' } : {};

    return React.createElement(
      'div',
      {
        className: 'dish-type-scroller',
        style: { borderBottom: 'solid 1px #f1f1f1' }
      },
      React.createElement(
        'div',
        { className: 'scroll-wrapper', style: scrollWrapperStyle },
        dishTypeElements
      )
    );
  }
});

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! iScroll v5.2.0 ~ (c) 2008-2016 Matteo Spinelli ~ http://cubiq.org/license */
(function (window, document, Math) {
var rAF = window.requestAnimationFrame	||
	window.webkitRequestAnimationFrame	||
	window.mozRequestAnimationFrame		||
	window.oRequestAnimationFrame		||
	window.msRequestAnimationFrame		||
	function (callback) { window.setTimeout(callback, 1000 / 60); };

var utils = (function () {
	var me = {};

	var _elementStyle = document.createElement('div').style;
	var _vendor = (function () {
		var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
			transform,
			i = 0,
			l = vendors.length;

		for ( ; i < l; i++ ) {
			transform = vendors[i] + 'ransform';
			if ( transform in _elementStyle ) return vendors[i].substr(0, vendors[i].length-1);
		}

		return false;
	})();

	function _prefixStyle (style) {
		if ( _vendor === false ) return false;
		if ( _vendor === '' ) return style;
		return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
	}

	me.getTime = Date.now || function getTime () { return new Date().getTime(); };

	me.extend = function (target, obj) {
		for ( var i in obj ) {
			target[i] = obj[i];
		}
	};

	me.addEvent = function (el, type, fn, capture) {
		el.addEventListener(type, fn, !!capture);
	};

	me.removeEvent = function (el, type, fn, capture) {
		el.removeEventListener(type, fn, !!capture);
	};

	me.prefixPointerEvent = function (pointerEvent) {
		return window.MSPointerEvent ?
			'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8):
			pointerEvent;
	};

	me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
		var distance = current - start,
			speed = Math.abs(distance) / time,
			destination,
			duration;

		deceleration = deceleration === undefined ? 0.0006 : deceleration;

		destination = current + ( speed * speed ) / ( 2 * deceleration ) * ( distance < 0 ? -1 : 1 );
		duration = speed / deceleration;

		if ( destination < lowerMargin ) {
			destination = wrapperSize ? lowerMargin - ( wrapperSize / 2.5 * ( speed / 8 ) ) : lowerMargin;
			distance = Math.abs(destination - current);
			duration = distance / speed;
		} else if ( destination > 0 ) {
			destination = wrapperSize ? wrapperSize / 2.5 * ( speed / 8 ) : 0;
			distance = Math.abs(current) + destination;
			duration = distance / speed;
		}

		return {
			destination: Math.round(destination),
			duration: duration
		};
	};

	var _transform = _prefixStyle('transform');

	me.extend(me, {
		hasTransform: _transform !== false,
		hasPerspective: _prefixStyle('perspective') in _elementStyle,
		hasTouch: 'ontouchstart' in window,
		hasPointer: !!(window.PointerEvent || window.MSPointerEvent), // IE10 is prefixed
		hasTransition: _prefixStyle('transition') in _elementStyle
	});

	/*
	This should find all Android browsers lower than build 535.19 (both stock browser and webview)
	- galaxy S2 is ok
    - 2.3.6 : `AppleWebKit/533.1 (KHTML, like Gecko) Version/4.0 Mobile Safari/533.1`
    - 4.0.4 : `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S3 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S4 is badAndroid (stock brower, webview)
     `AppleWebKit/534.30 (KHTML, like Gecko) Version/4.0 Mobile Safari/534.30`
   - galaxy S5 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
   - galaxy S6 is OK
     `AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Mobile Safari/537.36 (Chrome/)`
  */
	me.isBadAndroid = (function() {
		var appVersion = window.navigator.appVersion;
		// Android browser is not a chrome browser.
		if (/Android/.test(appVersion) && !(/Chrome\/\d/.test(appVersion))) {
			var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
			if(safariVersion && typeof safariVersion === "object" && safariVersion.length >= 2) {
				return parseFloat(safariVersion[1]) < 535.19;
			} else {
				return true;
			}
		} else {
			return false;
		}
	})();

	me.extend(me.style = {}, {
		transform: _transform,
		transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
		transitionDuration: _prefixStyle('transitionDuration'),
		transitionDelay: _prefixStyle('transitionDelay'),
		transformOrigin: _prefixStyle('transformOrigin')
	});

	me.hasClass = function (e, c) {
		var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
		return re.test(e.className);
	};

	me.addClass = function (e, c) {
		if ( me.hasClass(e, c) ) {
			return;
		}

		var newclass = e.className.split(' ');
		newclass.push(c);
		e.className = newclass.join(' ');
	};

	me.removeClass = function (e, c) {
		if ( !me.hasClass(e, c) ) {
			return;
		}

		var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
		e.className = e.className.replace(re, ' ');
	};

	me.offset = function (el) {
		var left = -el.offsetLeft,
			top = -el.offsetTop;

		// jshint -W084
		while (el = el.offsetParent) {
			left -= el.offsetLeft;
			top -= el.offsetTop;
		}
		// jshint +W084

		return {
			left: left,
			top: top
		};
	};

	me.preventDefaultException = function (el, exceptions) {
		for ( var i in exceptions ) {
			if ( exceptions[i].test(el[i]) ) {
				return true;
			}
		}

		return false;
	};

	me.extend(me.eventType = {}, {
		touchstart: 1,
		touchmove: 1,
		touchend: 1,

		mousedown: 2,
		mousemove: 2,
		mouseup: 2,

		pointerdown: 3,
		pointermove: 3,
		pointerup: 3,

		MSPointerDown: 3,
		MSPointerMove: 3,
		MSPointerUp: 3
	});

	me.extend(me.ease = {}, {
		quadratic: {
			style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
			fn: function (k) {
				return k * ( 2 - k );
			}
		},
		circular: {
			style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',	// Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
			fn: function (k) {
				return Math.sqrt( 1 - ( --k * k ) );
			}
		},
		back: {
			style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
			fn: function (k) {
				var b = 4;
				return ( k = k - 1 ) * k * ( ( b + 1 ) * k + b ) + 1;
			}
		},
		bounce: {
			style: '',
			fn: function (k) {
				if ( ( k /= 1 ) < ( 1 / 2.75 ) ) {
					return 7.5625 * k * k;
				} else if ( k < ( 2 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 1.5 / 2.75 ) ) * k + 0.75;
				} else if ( k < ( 2.5 / 2.75 ) ) {
					return 7.5625 * ( k -= ( 2.25 / 2.75 ) ) * k + 0.9375;
				} else {
					return 7.5625 * ( k -= ( 2.625 / 2.75 ) ) * k + 0.984375;
				}
			}
		},
		elastic: {
			style: '',
			fn: function (k) {
				var f = 0.22,
					e = 0.4;

				if ( k === 0 ) { return 0; }
				if ( k == 1 ) { return 1; }

				return ( e * Math.pow( 2, - 10 * k ) * Math.sin( ( k - f / 4 ) * ( 2 * Math.PI ) / f ) + 1 );
			}
		}
	});

	me.tap = function (e, eventName) {
		var ev = document.createEvent('Event');
		ev.initEvent(eventName, true, true);
		ev.pageX = e.pageX;
		ev.pageY = e.pageY;
		e.target.dispatchEvent(ev);
	};

	me.click = function (e) {
		var target = e.target,
			ev;

		if ( !(/(SELECT|INPUT|TEXTAREA)/i).test(target.tagName) ) {
			// https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
			// initMouseEvent is deprecated.
			ev = document.createEvent(window.MouseEvent ? 'MouseEvents' : 'Event');
			ev.initEvent('click', true, true);
			ev.view = e.view || window;
			ev.detail = 1;
			ev.screenX = target.screenX || 0;
			ev.screenY = target.screenY || 0;
			ev.clientX = target.clientX || 0;
			ev.clientY = target.clientY || 0;
			ev.ctrlKey = !!e.ctrlKey;
			ev.altKey = !!e.altKey;
			ev.shiftKey = !!e.shiftKey;
			ev.metaKey = !!e.metaKey;
			ev.button = 0;
			ev.relatedTarget = null;
			ev._constructed = true;
			target.dispatchEvent(ev);
		}
	};

	me.getRect = function(el) {
		if (el instanceof SVGElement) {
			var rect = el.getBoundingClientRect();
			return {
				top : rect.top,
				left : rect.left,
				width : rect.width,
				height : rect.height
			};
		} else {
			return {
				top : el.offsetTop,
				left : el.offsetLeft,
				width : el.offsetWidth,
				height : el.offsetHeight
			};
		}
	};

	return me;
})();
function IScroll (el, options) {
	this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
	this.scroller = this.wrapper.children[0];
	this.scrollerStyle = this.scroller.style;		// cache style for better performance

	this.options = {

// INSERT POINT: OPTIONS
		disablePointer : !utils.hasPointer,
		disableTouch : utils.hasPointer || !utils.hasTouch,
		disableMouse : utils.hasPointer || utils.hasTouch,
		startX: 0,
		startY: 0,
		scrollY: true,
		directionLockThreshold: 5,
		momentum: true,

		bounce: true,
		bounceTime: 600,
		bounceEasing: '',

		preventDefault: true,
		preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },

		HWCompositing: true,
		useTransition: true,
		useTransform: true,
		bindToWrapper: typeof window.onmousedown === "undefined"
	};

	for ( var i in options ) {
		this.options[i] = options[i];
	}

	// Normalize options
	this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';

	this.options.useTransition = utils.hasTransition && this.options.useTransition;
	this.options.useTransform = utils.hasTransform && this.options.useTransform;

	this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
	this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;

	// If you want eventPassthrough I have to lock one of the axes
	this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
	this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;

	// With eventPassthrough we also need lockDirection mechanism
	this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
	this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;

	this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;

	this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;

	if ( this.options.tap === true ) {
		this.options.tap = 'tap';
	}

	// https://github.com/cubiq/iscroll/issues/1029
	if (!this.options.useTransition && !this.options.useTransform) {
		if(!(/relative|absolute/i).test(this.scrollerStyle.position)) {
			this.scrollerStyle.position = "relative";
		}
	}

// INSERT POINT: NORMALIZATION

	// Some defaults
	this.x = 0;
	this.y = 0;
	this.directionX = 0;
	this.directionY = 0;
	this._events = {};

// INSERT POINT: DEFAULTS

	this._init();
	this.refresh();

	this.scrollTo(this.options.startX, this.options.startY);
	this.enable();
}

IScroll.prototype = {
	version: '5.2.0',

	_init: function () {
		this._initEvents();

// INSERT POINT: _init

	},

	destroy: function () {
		this._initEvents(true);
		clearTimeout(this.resizeTimeout);
 		this.resizeTimeout = null;
		this._execEvent('destroy');
	},

	_transitionEnd: function (e) {
		if ( e.target != this.scroller || !this.isInTransition ) {
			return;
		}

		this._transitionTime();
		if ( !this.resetPosition(this.options.bounceTime) ) {
			this.isInTransition = false;
			this._execEvent('scrollEnd');
		}
	},

	_start: function (e) {
		// React to left mouse button only
		if ( utils.eventType[e.type] != 1 ) {
		  // for button property
		  // http://unixpapa.com/js/mouse.html
		  var button;
	    if (!e.which) {
	      /* IE case */
	      button = (e.button < 2) ? 0 :
	               ((e.button == 4) ? 1 : 2);
	    } else {
	      /* All others */
	      button = e.button;
	    }
			if ( button !== 0 ) {
				return;
			}
		}

		if ( !this.enabled || (this.initiated && utils.eventType[e.type] !== this.initiated) ) {
			return;
		}

		if ( this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}

		var point = e.touches ? e.touches[0] : e,
			pos;

		this.initiated	= utils.eventType[e.type];
		this.moved		= false;
		this.distX		= 0;
		this.distY		= 0;
		this.directionX = 0;
		this.directionY = 0;
		this.directionLocked = 0;

		this.startTime = utils.getTime();

		if ( this.options.useTransition && this.isInTransition ) {
			this._transitionTime();
			this.isInTransition = false;
			pos = this.getComputedPosition();
			this._translate(Math.round(pos.x), Math.round(pos.y));
			this._execEvent('scrollEnd');
		} else if ( !this.options.useTransition && this.isAnimating ) {
			this.isAnimating = false;
			this._execEvent('scrollEnd');
		}

		this.startX    = this.x;
		this.startY    = this.y;
		this.absStartX = this.x;
		this.absStartY = this.y;
		this.pointX    = point.pageX;
		this.pointY    = point.pageY;

		this._execEvent('beforeScrollStart');
	},

	_move: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}

		if ( this.options.preventDefault ) {	// increases performance on Android? TODO: check!
			e.preventDefault();
		}

		var point		= e.touches ? e.touches[0] : e,
			deltaX		= point.pageX - this.pointX,
			deltaY		= point.pageY - this.pointY,
			timestamp	= utils.getTime(),
			newX, newY,
			absDistX, absDistY;

		this.pointX		= point.pageX;
		this.pointY		= point.pageY;

		this.distX		+= deltaX;
		this.distY		+= deltaY;
		absDistX		= Math.abs(this.distX);
		absDistY		= Math.abs(this.distY);

		// We need to move at least 10 pixels for the scrolling to initiate
		if ( timestamp - this.endTime > 300 && (absDistX < 10 && absDistY < 10) ) {
			return;
		}

		// If you are scrolling in one direction lock the other
		if ( !this.directionLocked && !this.options.freeScroll ) {
			if ( absDistX > absDistY + this.options.directionLockThreshold ) {
				this.directionLocked = 'h';		// lock horizontally
			} else if ( absDistY >= absDistX + this.options.directionLockThreshold ) {
				this.directionLocked = 'v';		// lock vertically
			} else {
				this.directionLocked = 'n';		// no lock
			}
		}

		if ( this.directionLocked == 'h' ) {
			if ( this.options.eventPassthrough == 'vertical' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'horizontal' ) {
				this.initiated = false;
				return;
			}

			deltaY = 0;
		} else if ( this.directionLocked == 'v' ) {
			if ( this.options.eventPassthrough == 'horizontal' ) {
				e.preventDefault();
			} else if ( this.options.eventPassthrough == 'vertical' ) {
				this.initiated = false;
				return;
			}

			deltaX = 0;
		}

		deltaX = this.hasHorizontalScroll ? deltaX : 0;
		deltaY = this.hasVerticalScroll ? deltaY : 0;

		newX = this.x + deltaX;
		newY = this.y + deltaY;

		// Slow down if outside of the boundaries
		if ( newX > 0 || newX < this.maxScrollX ) {
			newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
		}
		if ( newY > 0 || newY < this.maxScrollY ) {
			newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
		}

		this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
		this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;

		if ( !this.moved ) {
			this._execEvent('scrollStart');
		}

		this.moved = true;

		this._translate(newX, newY);

/* REPLACE START: _move */

		if ( timestamp - this.startTime > 300 ) {
			this.startTime = timestamp;
			this.startX = this.x;
			this.startY = this.y;
		}

/* REPLACE END: _move */

	},

	_end: function (e) {
		if ( !this.enabled || utils.eventType[e.type] !== this.initiated ) {
			return;
		}

		if ( this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException) ) {
			e.preventDefault();
		}

		var point = e.changedTouches ? e.changedTouches[0] : e,
			momentumX,
			momentumY,
			duration = utils.getTime() - this.startTime,
			newX = Math.round(this.x),
			newY = Math.round(this.y),
			distanceX = Math.abs(newX - this.startX),
			distanceY = Math.abs(newY - this.startY),
			time = 0,
			easing = '';

		this.isInTransition = 0;
		this.initiated = 0;
		this.endTime = utils.getTime();

		// reset if we are outside of the boundaries
		if ( this.resetPosition(this.options.bounceTime) ) {
			return;
		}

		this.scrollTo(newX, newY);	// ensures that the last position is rounded

		// we scrolled less than 10 pixels
		if ( !this.moved ) {
			if ( this.options.tap ) {
				utils.tap(e, this.options.tap);
			}

			if ( this.options.click ) {
				utils.click(e);
			}

			this._execEvent('scrollCancel');
			return;
		}

		if ( this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100 ) {
			this._execEvent('flick');
			return;
		}

		// start momentum animation if needed
		if ( this.options.momentum && duration < 300 ) {
			momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
			momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
			newX = momentumX.destination;
			newY = momentumY.destination;
			time = Math.max(momentumX.duration, momentumY.duration);
			this.isInTransition = 1;
		}

// INSERT POINT: _end

		if ( newX != this.x || newY != this.y ) {
			// change easing function when scroller goes out of the boundaries
			if ( newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY ) {
				easing = utils.ease.quadratic;
			}

			this.scrollTo(newX, newY, time, easing);
			return;
		}

		this._execEvent('scrollEnd');
	},

	_resize: function () {
		var that = this;

		clearTimeout(this.resizeTimeout);

		this.resizeTimeout = setTimeout(function () {
			that.refresh();
		}, this.options.resizePolling);
	},

	resetPosition: function (time) {
		var x = this.x,
			y = this.y;

		time = time || 0;

		if ( !this.hasHorizontalScroll || this.x > 0 ) {
			x = 0;
		} else if ( this.x < this.maxScrollX ) {
			x = this.maxScrollX;
		}

		if ( !this.hasVerticalScroll || this.y > 0 ) {
			y = 0;
		} else if ( this.y < this.maxScrollY ) {
			y = this.maxScrollY;
		}

		if ( x == this.x && y == this.y ) {
			return false;
		}

		this.scrollTo(x, y, time, this.options.bounceEasing);
    if (this.options.snap) {
      this.currentPage = this._nearestSnap(x, y);
    }
		return true;
	},

	disable: function () {
		this.enabled = false;
	},

	enable: function () {
		this.enabled = true;
	},

	refresh: function () {
		utils.getRect(this.wrapper);		// Force reflow

		this.wrapperWidth	= this.wrapper.clientWidth;
		this.wrapperHeight	= this.wrapper.clientHeight;

		var rect = utils.getRect(this.scroller);
/* REPLACE START: refresh */

		this.scrollerWidth	= rect.width;
		this.scrollerHeight	= rect.height;

		this.maxScrollX		= this.wrapperWidth - this.scrollerWidth;
		this.maxScrollY		= this.wrapperHeight - this.scrollerHeight;

/* REPLACE END: refresh */

		this.hasHorizontalScroll	= this.options.scrollX && this.maxScrollX < 0;
		this.hasVerticalScroll		= this.options.scrollY && this.maxScrollY < 0;

		if ( !this.hasHorizontalScroll ) {
			this.maxScrollX = 0;
			this.scrollerWidth = this.wrapperWidth;
		}

		if ( !this.hasVerticalScroll ) {
			this.maxScrollY = 0;
			this.scrollerHeight = this.wrapperHeight;
		}

		this.endTime = 0;
		this.directionX = 0;
		this.directionY = 0;

		this.wrapperOffset = utils.offset(this.wrapper);

		this._execEvent('refresh');

		this.resetPosition();

// INSERT POINT: _refresh

	},

	on: function (type, fn) {
		if ( !this._events[type] ) {
			this._events[type] = [];
		}

		this._events[type].push(fn);
	},

	off: function (type, fn) {
		if ( !this._events[type] ) {
			return;
		}

		var index = this._events[type].indexOf(fn);

		if ( index > -1 ) {
			this._events[type].splice(index, 1);
		}
	},

	_execEvent: function (type) {
		if ( !this._events[type] ) {
			return;
		}

		var i = 0,
			l = this._events[type].length;

		if ( !l ) {
			return;
		}

		for ( ; i < l; i++ ) {
			this._events[type][i].apply(this, [].slice.call(arguments, 1));
		}
	},

	scrollBy: function (x, y, time, easing) {
		x = this.x + x;
		y = this.y + y;
		time = time || 0;

		this.scrollTo(x, y, time, easing);
	},

	scrollTo: function (x, y, time, easing) {
		easing = easing || utils.ease.circular;

		this.isInTransition = this.options.useTransition && time > 0;
		var transitionType = this.options.useTransition && easing.style;
		if ( !time || transitionType ) {
				if(transitionType) {
					this._transitionTimingFunction(easing.style);
					this._transitionTime(time);
				}
			this._translate(x, y);
		} else {
			this._animate(x, y, time, easing.fn);
		}
	},

	scrollToElement: function (el, time, offsetX, offsetY, easing) {
		el = el.nodeType ? el : this.scroller.querySelector(el);

		if ( !el ) {
			return;
		}

		var pos = utils.offset(el);

		pos.left -= this.wrapperOffset.left;
		pos.top  -= this.wrapperOffset.top;

		// if offsetX/Y are true we center the element to the screen
		var elRect = utils.getRect(el);
		var wrapperRect = utils.getRect(this.wrapper);
		if ( offsetX === true ) {
			offsetX = Math.round(elRect.width / 2 - wrapperRect.width / 2);
		}
		if ( offsetY === true ) {
			offsetY = Math.round(elRect.height / 2 - wrapperRect.height / 2);
		}

		pos.left -= offsetX || 0;
		pos.top  -= offsetY || 0;

		pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
		pos.top  = pos.top  > 0 ? 0 : pos.top  < this.maxScrollY ? this.maxScrollY : pos.top;

		time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x-pos.left), Math.abs(this.y-pos.top)) : time;

		this.scrollTo(pos.left, pos.top, time, easing);
	},

	_transitionTime: function (time) {
		if (!this.options.useTransition) {
			return;
		}
		time = time || 0;
		var durationProp = utils.style.transitionDuration;
		if(!durationProp) {
			return;
		}

		this.scrollerStyle[durationProp] = time + 'ms';

		if ( !time && utils.isBadAndroid ) {
			this.scrollerStyle[durationProp] = '0.0001ms';
			// remove 0.0001ms
			var self = this;
			rAF(function() {
				if(self.scrollerStyle[durationProp] === '0.0001ms') {
					self.scrollerStyle[durationProp] = '0s';
				}
			});
		}

// INSERT POINT: _transitionTime

	},

	_transitionTimingFunction: function (easing) {
		this.scrollerStyle[utils.style.transitionTimingFunction] = easing;

// INSERT POINT: _transitionTimingFunction

	},

	_translate: function (x, y) {
		if ( this.options.useTransform ) {

/* REPLACE START: _translate */

			this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;

/* REPLACE END: _translate */

		} else {
			x = Math.round(x);
			y = Math.round(y);
			this.scrollerStyle.left = x + 'px';
			this.scrollerStyle.top = y + 'px';
		}

		this.x = x;
		this.y = y;

// INSERT POINT: _translate

	},

	_initEvents: function (remove) {
		var eventType = remove ? utils.removeEvent : utils.addEvent,
			target = this.options.bindToWrapper ? this.wrapper : window;

		eventType(window, 'orientationchange', this);
		eventType(window, 'resize', this);

		if ( this.options.click ) {
			eventType(this.wrapper, 'click', this, true);
		}

		if ( !this.options.disableMouse ) {
			eventType(this.wrapper, 'mousedown', this);
			eventType(target, 'mousemove', this);
			eventType(target, 'mousecancel', this);
			eventType(target, 'mouseup', this);
		}

		if ( utils.hasPointer && !this.options.disablePointer ) {
			eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
			eventType(target, utils.prefixPointerEvent('pointermove'), this);
			eventType(target, utils.prefixPointerEvent('pointercancel'), this);
			eventType(target, utils.prefixPointerEvent('pointerup'), this);
		}

		if ( utils.hasTouch && !this.options.disableTouch ) {
			eventType(this.wrapper, 'touchstart', this);
			eventType(target, 'touchmove', this);
			eventType(target, 'touchcancel', this);
			eventType(target, 'touchend', this);
		}

		eventType(this.scroller, 'transitionend', this);
		eventType(this.scroller, 'webkitTransitionEnd', this);
		eventType(this.scroller, 'oTransitionEnd', this);
		eventType(this.scroller, 'MSTransitionEnd', this);
	},

	getComputedPosition: function () {
		var matrix = window.getComputedStyle(this.scroller, null),
			x, y;

		if ( this.options.useTransform ) {
			matrix = matrix[utils.style.transform].split(')')[0].split(', ');
			x = +(matrix[12] || matrix[4]);
			y = +(matrix[13] || matrix[5]);
		} else {
			x = +matrix.left.replace(/[^-\d.]/g, '');
			y = +matrix.top.replace(/[^-\d.]/g, '');
		}

		return { x: x, y: y };
	},

	_animate: function (destX, destY, duration, easingFn) {
		var that = this,
			startX = this.x,
			startY = this.y,
			startTime = utils.getTime(),
			destTime = startTime + duration;

		function step () {
			var now = utils.getTime(),
				newX, newY,
				easing;

			if ( now >= destTime ) {
				that.isAnimating = false;
				that._translate(destX, destY);

				if ( !that.resetPosition(that.options.bounceTime) ) {
					that._execEvent('scrollEnd');
				}

				return;
			}

			now = ( now - startTime ) / duration;
			easing = easingFn(now);
			newX = ( destX - startX ) * easing + startX;
			newY = ( destY - startY ) * easing + startY;
			that._translate(newX, newY);

			if ( that.isAnimating ) {
				rAF(step);
			}
		}

		this.isAnimating = true;
		step();
	},
	handleEvent: function (e) {
		switch ( e.type ) {
			case 'touchstart':
			case 'pointerdown':
			case 'MSPointerDown':
			case 'mousedown':
				this._start(e);
				break;
			case 'touchmove':
			case 'pointermove':
			case 'MSPointerMove':
			case 'mousemove':
				this._move(e);
				break;
			case 'touchend':
			case 'pointerup':
			case 'MSPointerUp':
			case 'mouseup':
			case 'touchcancel':
			case 'pointercancel':
			case 'MSPointerCancel':
			case 'mousecancel':
				this._end(e);
				break;
			case 'orientationchange':
			case 'resize':
				this._resize();
				break;
			case 'transitionend':
			case 'webkitTransitionEnd':
			case 'oTransitionEnd':
			case 'MSTransitionEnd':
				this._transitionEnd(e);
				break;
			case 'wheel':
			case 'DOMMouseScroll':
			case 'mousewheel':
				this._wheel(e);
				break;
			case 'keydown':
				this._key(e);
				break;
			case 'click':
				if ( this.enabled && !e._constructed ) {
					e.preventDefault();
					e.stopPropagation();
				}
				break;
		}
	}
};
IScroll.utils = utils;

if ( typeof module != 'undefined' && module.exports ) {
	module.exports = IScroll;
} else if ( true ) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () { return IScroll; }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
	window.IScroll = IScroll;
}

})(window, document, Math);


/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _dish = __webpack_require__(506);

var _dish2 = _interopRequireDefault(_dish);

var _dish_img_default = __webpack_require__(617);

var _dish_img_default2 = _interopRequireDefault(_dish_img_default);

var _scrollerMenu = __webpack_require__(855);

var _scrollerMenu2 = _interopRequireDefault(_scrollerMenu);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var shallowCompare = __webpack_require__(120);

var classnames = __webpack_require__(50);
var DishListItem = __webpack_require__(488);
var DishCoupon = __webpack_require__(866);
var backArray = __webpack_require__(867);

__webpack_require__(868);

module.exports = React.createClass({
  displayName: 'DishScroller',
  propTypes: {
    activeDishTypeId: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    activeDishTypeIdIndex: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]).isRequired,
    dishTypesData: React.PropTypes.array.isRequired,
    dishesData: React.PropTypes.array.isRequired,
    onScrolling: React.PropTypes.func,
    onScroll: React.PropTypes.func.isRequired,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    reinstateUndefined: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    onImageBtnTap: React.PropTypes.func.isRequired,
    getMarketCoupon: React.PropTypes.func.isRequired,
    marketList: React.PropTypes.object,
    diningForm: React.PropTypes.number,
    theme: React.PropTypes.string,
    shopInfo: React.PropTypes.object,
    load: React.PropTypes.object,
    showHotSpan: React.PropTypes.func,
    soldTopDishList: React.PropTypes.array,
    showHandleInput: React.PropTypes.func,
    showAlreadyGotCoupon: React.PropTypes.func,
    isHDL: React.PropTypes.bool,
    isZc: React.PropTypes.bool,
    hasAds: React.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {};
  },
  getInitialState: function getInitialState() {
    return {
      distance: window.innerHeight - 84,
      dishClass: '',
      dishScrollerHeight: null
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  onDishBtnTap: function onDishBtnTap(dishData, action) {
    var _props = this.props,
        onOrderBtnTap = _props.onOrderBtnTap,
        onPropsBtnTap = _props.onPropsBtnTap;

    if (action) {
      this.onOrderDishUpdateInfo = {
        dishData: dishData,
        action: action
      };
      onOrderBtnTap(dishData, action, false);
    } else {
      onPropsBtnTap(dishData);
    }
  },
  onImageBtnTap: function onImageBtnTap(dish) {
    if (this._cache && this._cache.isScrolling) {
      return;
    }

    this.props.onImageBtnTap(dish);
  },
  buildDishElements: function buildDishElements(activeDishTypeId, activeDishTypeIdIndex, dishTypesData, dishesData, onDishBtnTap) {
    var _this = this;

    var _props2 = this.props,
        theme = _props2.theme,
        shopInfo = _props2.shopInfo,
        onScroll = _props2.onScroll,
        onScrolling = _props2.onScrolling,
        marketList = _props2.marketList,
        changeShowData = _props2.changeShowData,
        saveOrderChangeItem = _props2.saveOrderChangeItem,
        reinstateUndefined = _props2.reinstateUndefined,
        isDataInitOver = _props2.isDataInitOver,
        isZc = _props2.isZc,
        hasAds = _props2.hasAds;

    var hotDishElement = this.buildHotDishElements(theme);
    var isOldMarketing = shopInfo.isOldMarketing;

    function getDishTypeTitle(dishTypeData) {
      if (dishTypeData.desc) {
        return React.createElement(
          'span',
          null,
          dishTypeData.name,
          ' ',
          React.createElement(
            'span',
            { className: 'dish-type-desc' },
            '(' + dishTypeData.desc + ')'
          )
        );
      }

      return React.createElement(
        'span',
        null,
        dishTypeData.name
      );
    }

    if (isDataInitOver) {
      var newDishTypesData = [];
      var dishesReactObj = {};
      dishTypesData.forEach(function (dishTypeData) {
        var obj = (0, _extends3.default)({}, dishTypeData);

        var _obj = (0, _extends3.default)({}, obj),
            id = _obj.id,
            dishIds = _obj.dishIds;

        if (!dishIds || dishIds.length === 0) return;
        var itemLi = React.createElement(
          'li',
          { key: '' + id, 'data-id': id, className: 'dish-item-type' },
          getDishTypeTitle(dishTypeData)
        );
        obj.reactObj = itemLi;
        obj.dishAry = [];
        var newDishIds = [];
        if (!!dishIds && dishIds.length > 0) {
          dishIds.forEach(function (dishId) {
            var dishData = dishesData.filter(function (dish) {
              return dish.id === dishId;
            })[0];
            var dishDataCopy = (0, _extends3.default)({}, dishData);
            var sameDishIndexs = dishDataCopy.sameDishIndexs,
                proxyDishId = dishDataCopy.proxyDishId;

            if (!proxyDishId) {
              newDishIds.push(dishId);
              var sameRuleDishList = sameDishIndexs ? sameDishIndexs.map(function (dishIndex) {
                return dishesData[dishIndex];
              }) : null;

              var reactLi = React.createElement(
                'li',
                {
                  className: classnames('dish-item-dish'),
                  key: id + '-' + dishId,
                  'data-id': id + '-' + dishId
                },
                React.createElement(DishListItem, {
                  changeShowDataItems: _this.props.changeShowDataItems,
                  theme: theme,
                  sameRuleDishList: sameRuleDishList,
                  dishData: dishData,
                  onOrderBtnTap: onDishBtnTap,
                  onPropsBtnTap: onDishBtnTap,
                  onImageBtnTap: _this.props.onImageBtnTap,
                  marketList: _this.props.marketList,
                  diningForm: _this.props.diningForm,
                  hotTag: false,
                  num: 0,
                  showHandleInput: _this.props.showHandleInput,
                  setNoMore: _this.props.setNoMore,
                  isHDL: _this.props.isHDL
                })
              );
              dishesReactObj[id + '-' + dishId] = reactLi;
              dishDataCopy.reactObj = reactLi;

              obj.dishAry.push(dishDataCopy);
            }
          });
        }
        obj.dishIds = newDishIds;
        newDishTypesData.push(obj);
      });

      return React.createElement(
        _scrollerMenu2.default,
        {
          reinstateUndefined: reinstateUndefined,
          saveOrderChangeItem: saveOrderChangeItem,
          dishId: activeDishTypeId,
          dishIdIndex: activeDishTypeIdIndex,
          onOrderDishUpdateInfo: this.onOrderDishUpdateInfo,
          onScroll: onScroll,
          onScrollingTitleAction: onScrolling,
          theme: theme,
          changeShowData: changeShowData,
          marketList: marketList,
          isHDL: this.props.isHDL,
          dishesData: dishesData // snail 新增，将数据传递过去方便计算
          , dishTypesData: newDishTypesData // snail 新增，将数据传递过去，方便计算
          , dishesReactObj: dishesReactObj // snail 新增，将数据传递过去，方便计算
          , isZc: isZc // 是否正餐
          , hasAds: hasAds
        },
        (isOldMarketing && shopInfo.marketCoupon && shopInfo.marketCoupon.coupId || !isOldMarketing && shopInfo.couponList && shopInfo.couponList.length > 0) && React.createElement(DishCoupon, {
          shopInfo: shopInfo,
          getMarketCoupon: this.props.getMarketCoupon,
          firstStatus: 0,
          hiddenCouponsList: this.props.hiddenCouponsList,
          showCouponsList: this.props.showCouponsList,
          couponType: this.props.couponType,
          showAlreadyGotCoupon: this.props.showAlreadyGotCoupon
        }),
        hotDishElement
      );
    }

    return null;
  },
  buildHotDishElements: function buildHotDishElements(theme) {
    var _this2 = this;

    // 热销菜品
    if (this.props.soldTopDishList.length === 0) {
      return false;
    }

    return React.createElement(
      'ul',
      {
        className: 'dish-list dish-list-hot clearfix',
        style: { marginBottom: 0 }
      },
      React.createElement(
        'li',
        { className: 'dish-item-type', style: { marginBottom: 0 } },
        React.createElement(
          'span',
          { className: 'hot-icon' },
          React.createElement(_formattedMessage2.default, _dish2.default.dishguessYouLike)
        )
      ),
      React.createElement(
        'li',
        {
          className: 'hot-dish',
          style: {
            padding: theme === 'default' ? '10px 10px 0' : '10px 15px 0'
          }
        },
        this.props.soldTopDishList.length !== 0 && this.props.soldTopDishList.map(function (item, index) {
          var imgStyle = item.smallImgUrl || item.largeImgList[0] ? 'mediuImg_' : 'smallImg_';

          return React.createElement(
            'div',
            {
              className: 'dish-on-selling--modify is-hotdish',
              key: index
            },
            React.createElement(
              'div',
              { className: 'dish-item-img o-mr' },
              React.createElement(_httpsProtocolImage2.default, {
                src: item.smallImgUrl || item.largeImgList[0] || _dish_img_default2.default,
                alt: '',
                className: imgStyle
              })
            )
          );
        }),
        React.createElement(
          'div',
          {
            className: 'hot-arrow-box',
            onTouchTap: function onTouchTap(event) {
              _this2.props.showHotSpan(event);
            }
          },
          React.createElement(
            'div',
            { className: 'hot-arrow' },
            React.createElement('img', { src: backArray, alt: '' })
          )
        )
      )
    );
  },
  render: function render() {
    var _props3 = this.props,
        activeDishTypeId = _props3.activeDishTypeId,
        activeDishTypeIdIndex = _props3.activeDishTypeIdIndex,
        dishTypesData = _props3.dishTypesData,
        dishesData = _props3.dishesData;

    var dishElements = this.buildDishElements(activeDishTypeId, activeDishTypeIdIndex, dishTypesData, dishesData, this.onDishBtnTap);
    return React.createElement(
      'div',
      { className: 'dish-scroller' },
      React.createElement(
        'div',
        { className: 'copyright copyright--dish-scroller' },
        dishElements
      )
    );
  }
});

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertyDescriptor = __webpack_require__(856);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2; /*
                                                  * @Author: 未知
                                                  * @Date: 2019-07-09 16:23:49
                                                  * @Last Modified by: huping
                                                  * @Last Modified time: 2020-08-10 17:45:51
                                                  */


var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _initProps = __webpack_require__(859);

var _initProps2 = _interopRequireDefault(_initProps);

var _robotListBody = __webpack_require__(860);

var _robotListBody2 = _interopRequireDefault(_robotListBody);

var _checkRequestAnimationFrame = __webpack_require__(862);

var _checkRequestAnimationFrame2 = _interopRequireDefault(_checkRequestAnimationFrame);

var _timeout = __webpack_require__(863);

var _timeout2 = _interopRequireDefault(_timeout);

var _bindThis = __webpack_require__(864);

var _bindThis2 = _interopRequireDefault(_bindThis);

var _dishHelper = __webpack_require__(43);

var _dishHelper2 = _interopRequireDefault(_dishHelper);

__webpack_require__(865);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var ScrollerMenu = (_dec = (0, _checkRequestAnimationFrame2.default)('turbo'), _dec2 = (0, _timeout2.default)(400), (0, _bindThis2.default)(_class = (0, _initProps2.default)(_class = _dec(_class = (_class2 = function (_React$Component) {
  (0, _inherits3.default)(ScrollerMenu, _React$Component);

  function ScrollerMenu(props) {
    (0, _classCallCheck3.default)(this, ScrollerMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollerMenu.__proto__ || (0, _getPrototypeOf2.default)(ScrollerMenu)).call(this, props));

    _this.bind('scrollAction', 'turboAction', 'scrollEndAction', 'renderServingMeals', 'renderPackage', 'mealsListRender', 'changeZIndex',
    // 'getRobotInfo',
    'getMealsReduceCallback', 'selectRobot');
    _this.getRobotInfo = _this.getRobotInfo.bind(_this);

    _this.scrollerMenuBody = null;

    _this.saveThreshold = null;
    // 屏幕获取菜单系列区域阈值
    _this.windowThresholdNum = 90;

    _this.scrollTop = 0;

    _this.turboExecution = false;

    _this.scrollerMenuMainIndex = _this.getScrollerMenuMainIndex();

    // const isEnable = this.getIsEnable();

    _this.state = {
      isEnable: true,
      orderChangeList: {},
      titleMarkInfo: {},
      collectInfoAll: {
        // 总高度
        accumulationHeight: 0,
        // 屏幕总数
        screenNum: 1,
        // 队列信息
        locationGroup: {},
        // dish索引
        dishIndexList: []
      },
      screenInfo: {
        // 之前进入的屏幕
        saveScreen: null,
        // 显示的屏幕队列
        screenRenderList: [1, 2, 3, 4, 5]
      },
      // 可视区域高度
      scrollerMenuBodyHeight: 0,
      scrollerZIndex: 'auto',
      initOver: false
    };
    return _this;
  }

  /**
   * 获取菜品列表在props.children中的索引
   */


  (0, _createClass3.default)(ScrollerMenu, [{
    key: 'getScrollerMenuMainIndex',
    value: function getScrollerMenuMainIndex() {
      return this.props.children.findIndex(function (item) {
        return item && item.props && item.props.scrollerMenuMain;
      });
    }

    /**
     * 是否开启分屏加载
     */

  }, {
    key: 'getIsEnable',
    value: function getIsEnable() {
      var dishesData = this.props.dishesData;

      var quantity = dishesData.length; // this.props.children[this.scrollerMenuMainIndex].props.children.length;
      var isIphone = /iphone/i.test(navigator.userAgent);
      var isIpad = /iPad/i.test(navigator.userAgent);
      return (isIphone || isIpad) && quantity > 150;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setScrollerMenuBodyHeight();
      this.actionOnce = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.scrollActionIng) return;

      if (nextProps.saveOrderChangeItem) {
        this.orderChangeRobotInfo(nextProps);
        nextProps.reinstateUndefined();
      }

      if (nextProps.changeShowData && !nextProps.saveOrderChangeItem && this.actionOnce) {
        this.actionOnce = false;
        this.orderChangeRobotInfo(nextProps, true);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.saveThreshold && this.saveThreshold.dishId === this.props.dishId) return;
      if (this.props.dishId !== prevProps.dishId) this.clickMenuChangeScroll();
    }

    // componentWillUnmount() {
    //   this.animateId && window.cancelAnimationFrame(this.animateId);
    // }

    /**
     * changShowData和saveOrderChangeItem引发的RobotInfo的变更。
     * 属实觉的下面的逻辑很是诡异。。。
     * @param {*} nextProps
     * @param {*} firstLoad
     */

  }, {
    key: 'orderChangeRobotInfo',
    value: function orderChangeRobotInfo(nextProps, firstLoad) {
      var _this2 = this;

      var saveOrderChangeItem = nextProps.saveOrderChangeItem,
          changeShowData = nextProps.changeShowData;

      if (firstLoad) {
        changeShowData.forEach(function (item) {
          _this2.changeRobotOrder(nextProps, item); // 第一次加载
        });
      } else if (saveOrderChangeItem === 'clearAll') {
        this.clearAllOrder(nextProps);
      } else {
        this.changeRobotOrder(nextProps);
      }
    }
  }, {
    key: 'clearAllOrder',
    value: function clearAllOrder(nextProps) {
      var _this3 = this;

      var _state = this.state,
          collectInfoAll = _state.collectInfoAll,
          oldOrderChangeList = _state.orderChangeList;

      var changeListArray = (0, _keys2.default)(oldOrderChangeList);

      (changeListArray.length ? changeListArray : (0, _keys2.default)(collectInfoAll.dishIndexList)).forEach(function (item) {
        if (collectInfoAll.dishIndexList[item]) {
          collectInfoAll.dishIndexList[item].reduce(_this3.selectRobot, { collectInfoAll: collectInfoAll, nextProps: nextProps });
        }
      });

      this.setState({
        collectInfoAll: collectInfoAll,
        orderChangeList: {}
      });
    }

    /**
     * 改变Robot信息
     * @param {*} nextProps
     * @param {*} firstLoadData
     */

  }, {
    key: 'changeRobotOrder',
    value: function changeRobotOrder(nextProps, firstLoadData) {
      var _state2 = this.state,
          collectInfoAll = _state2.collectInfoAll,
          oldOrderChangeList = _state2.orderChangeList;

      var _ref = firstLoadData || nextProps.saveOrderChangeItem[0],
          proxyDishId = _ref.proxyDishId,
          id = _ref.id;

      var saveId = proxyDishId || id;
      var saveValue = firstLoadData ? _dishHelper2.default.getDishesCount([firstLoadData]) : oldOrderChangeList[saveId];

      oldOrderChangeList[saveId] = (saveValue === undefined ? 0 : saveValue) + (firstLoadData ? 0 : nextProps.saveOrderChangeItem[1]);

      Array.isArray(collectInfoAll.dishIndexList[saveId]) && collectInfoAll.dishIndexList[saveId].reduce(this.selectRobot, { collectInfoAll: collectInfoAll, nextProps: nextProps });

      this.setState({
        collectInfoAll: collectInfoAll,
        orderChangeList: oldOrderChangeList
      });
    }
  }, {
    key: 'selectRobot',
    value: function selectRobot(opt, indexItem) {
      var collectInfoAll = opt.collectInfoAll,
          nextProps = opt.nextProps;
      var screenNum = indexItem.screenNum,
          index = indexItem.index;


      var robot = collectInfoAll.locationGroup[screenNum][index];

      collectInfoAll.locationGroup[screenNum][index] = this.changeRobot(robot, nextProps);

      return opt;
    }
  }, {
    key: 'changeRobot',
    value: function changeRobot(robot, nextProps) {
      // robot.robotObj = nextProps.children[this.scrollerMenuMainIndex].props.children[robot.index];
      var dishesReactObj = nextProps.dishesReactObj;

      if (dishesReactObj[robot.robotId]) {
        robot.robotObj = dishesReactObj[robot.robotId];
        // robot.keys = `_${Math.random()
        //   .toString(36)
        //   .substr(2, 9)}-${performance.now()}`;
      }
      return robot;
    }
  }, {
    key: 'setScrollerMenuBodyHeight',
    value: function setScrollerMenuBodyHeight() {
      this.setState({
        scrollerMenuBodyHeight: this.scrollerMenuBody && this.scrollerMenuBody.clientHeight || 0
      });
    }

    /**
     * 获取TobotInfo的信息
     * @param {*} feedback
     */

  }, {
    key: 'getRobotInfo',
    value: function getRobotInfo(feedback) {
      var collectInfoAll = feedback.collectInfoAll,
          titleMarkInfo = feedback.titleMarkInfo;

      this.setState({
        collectInfoAll: collectInfoAll,
        titleMarkInfo: titleMarkInfo,
        initOver: true
      });
    }
  }, {
    key: 'calcPositionInfo',
    value: function calcPositionInfo() {}
  }, {
    key: 'checkSaveThreshold',
    value: function checkSaveThreshold() {
      if (!this.saveThreshold) {
        var _state$titleMarkInfo = this.state.titleMarkInfo,
            titleMarkInfo = _state$titleMarkInfo === undefined ? {} : _state$titleMarkInfo;
        var _titleMarkInfo$infoLi = titleMarkInfo.infoList,
            infoList = _titleMarkInfo$infoLi === undefined ? [] : _titleMarkInfo$infoLi;

        this.saveThreshold = infoList && infoList.length !== 0 ? infoList[0] : {};
      }
    }
  }, {
    key: 'checkIndex',
    value: function checkIndex(threshold) {
      var _saveThreshold = this.saveThreshold,
          top = _saveThreshold.top,
          index = _saveThreshold.index;
      var _state$titleMarkInfo2 = this.state.titleMarkInfo,
          titleMarkInfo = _state$titleMarkInfo2 === undefined ? {} : _state$titleMarkInfo2;
      var _titleMarkInfo$infoLi2 = titleMarkInfo.infoList,
          infoList = _titleMarkInfo$infoLi2 === undefined ? [] : _titleMarkInfo$infoLi2;


      if (threshold > top) return this.downActionSelectMenuId(threshold, index, infoList);

      if (threshold < top) return this.upActionSelectMenuId(threshold, index, infoList);

      return index;
    }
  }, {
    key: 'downActionSelectMenuId',
    value: function downActionSelectMenuId(threshold, index, infoList) {
      var interception = infoList.slice(index);
      var falstLength = infoList.length - interception.length;
      var findIndex = interception.findIndex(function (item) {
        return threshold < item.top;
      });

      return findIndex === -1 ? infoList.length - 1 : findIndex + falstLength - 1;
    }
  }, {
    key: 'upActionSelectMenuId',
    value: function upActionSelectMenuId(threshold, index, infoList) {
      var interception = infoList.slice(0, index);

      var findIndex = interception.reverse().findIndex(function (item) {
        return threshold > item.top;
      });

      return findIndex === -1 ? 0 : interception.length - 1 - findIndex;
    }
  }, {
    key: 'changeZIndex',
    value: function changeZIndex(indexNum) {
      this.setState({
        scrollerZIndex: indexNum
      });
    }

    /**
     * 根据滚动高度获取第几屏
     * @param {*} scrollTop
     */

  }, {
    key: 'scrollActionGetScreen',
    value: function scrollActionGetScreen(scrollTop) {
      var scrollerMenuBodyHeight = this.state.scrollerMenuBodyHeight;


      var scrollerHeightAddscrollTop = scrollTop + scrollerMenuBodyHeight;

      return Math.floor(scrollerHeightAddscrollTop / scrollerMenuBodyHeight);
    }

    /**
     * 滚动条 滚动的时候触发
     */

  }, {
    key: 'scrollAction',
    value: function scrollAction() {
      if (this.turboExecution) return;

      // if (this.state.scrollerZIndex === 'auto') this.changeZIndex(2);

      this.turboExecution = true;

      this.scrollActionIng = true;

      this.animateId = this.turbo(this.turboAction);
    }

    /**
     * 涡轮增压行为
     * 哈哈，直译。找打的行为哦。
     */

  }, {
    key: 'turboAction',
    value: function turboAction() {
      if (this.scrollTop === this.scrollerMenuBody.scrollTop) {
        this.changeZIndex('auto');

        this.scrollEndAction();

        this.turboExecution = false;

        return;
      }

      this.scrollTop = this.scrollerMenuBody.scrollTop;

      var onScrollingTitleAction = this.props.onScrollingTitleAction;


      onScrollingTitleAction(-this.scrollTop);

      if (!this.state.isEnable) {
        this.turbo(this.turboAction);

        return;
      }

      var screenNumNow = this.scrollActionGetScreen(this.scrollTop);

      var saveScreen = this.state.screenInfo.saveScreen;


      if (screenNumNow !== saveScreen && screenNumNow > -1) this.screenChange(screenNumNow);

      this.turbo(this.turboAction);
    }
  }, {
    key: 'scrollEndAction',
    value: function scrollEndAction() {
      var onScroll = this.props.onScroll;
      var scrollTop = this.scrollerMenuBody.scrollTop;


      var threshold = scrollTop + this.windowThresholdNum;

      this.checkSaveThreshold();

      var checkIndex = this.checkIndex(threshold);
      this.scrollActionIng = false;

      if (checkIndex === this.saveThreshold.index) return;

      var titleMarkInfo = this.state.titleMarkInfo;
      var _titleMarkInfo$infoLi3 = titleMarkInfo.infoList,
          infoList = _titleMarkInfo$infoLi3 === undefined ? [] : _titleMarkInfo$infoLi3;


      this.saveThreshold = infoList && infoList.length !== 0 ? infoList[checkIndex] : {};

      onScroll(null, this.saveThreshold.dishId, this.saveThreshold.index);
    }

    /**
     * 改变screenInfo的信息
     * 只会渲染指定屏数的上一屏和下一屏
     * 任何时候渲染三屏的数据。
     * @param {*} screenNewNumNow
     */

  }, {
    key: 'screenChange',
    value: function screenChange(screenNewNumNow) {
      var screenInfo = this.state.screenInfo;


      screenInfo.screenRenderList = [screenNewNumNow - 1, screenNewNumNow, screenNewNumNow + 1];

      screenInfo.saveScreen = screenNewNumNow;

      this.changeScreenInfo(screenInfo);
    }
  }, {
    key: 'clickMenuChangeScroll',
    value: function clickMenuChangeScroll() {
      var dishIdIndex = this.props.dishIdIndex;
      var titleMarkInfo = this.state.titleMarkInfo;
      var _titleMarkInfo$infoLi4 = titleMarkInfo.infoList,
          infoList = _titleMarkInfo$infoLi4 === undefined ? [] : _titleMarkInfo$infoLi4;


      var info = infoList.filter(function (item) {
        return item.index === Number(dishIdIndex);
      });

      if (info.length) {
        this.scrollerMenuBody.scrollTop = info[0].top;
      }
    }
  }, {
    key: 'changeScreenInfo',
    value: function changeScreenInfo(screenInfo) {
      this.setState({
        screenInfo: screenInfo
      });
    }
    /**
     * 获取菜品列表信息
     * 如果initOver===false 那么就直接将子元素中的子菜单直接返回出去
     */

  }, {
    key: 'mealsGet',
    value: function mealsGet() {
      var _state3 = this.state,
          scrollerMenuBodyHeight = _state3.scrollerMenuBodyHeight,
          initOver = _state3.initOver;


      if (!scrollerMenuBodyHeight) return null;

      if (!initOver) return null; // this.props.children[this.scrollerMenuMainIndex].props.children;

      var mealsShow = this.renderServingMeals();

      return mealsShow.map(function (item) {
        var top = item.top,
            className = item.className,
            dishId = item.dishId,
            robotObj = item.robotObj,
            keys = item.keys,
            left = item.left,
            width = item.width,
            height = item.height;


        return _react2.default.createElement(
          'li',
          {
            key: keys,
            className: className,
            'data-id': dishId,
            style: {
              position: 'absolute',
              width: width,
              top: top,
              left: left,
              height: height
            }
          },
          robotObj.props.children
        );
      });
    }

    /**
     * list渲染
     */

  }, {
    key: 'mealsListRender',
    value: function mealsListRender() {
      var _this4 = this;

      var _props = this.props,
          children = _props.children,
          theme = _props.theme;
      var _state4 = this.state,
          scrollerZIndex = _state4.scrollerZIndex,
          collectInfoAll = _state4.collectInfoAll;

      var meals = this.mealsGet();
      var mature = this.renderPackage(meals);

      var isDefault = '' + (theme !== 'default' && theme !== 'tea' ? 'dish-scroller-main-big' : '');
      return _react2.default.createElement(
        'div',
        {
          className: 'dish-scroller dish-scroller-main ' + isDefault,
          onScroll: this.scrollAction,
          ref: function ref(element) {
            return _this4.scrollerMenuBody = element;
          },
          style: { zIndex: scrollerZIndex },
          id: 'snailScroll'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'copyright copyright--dish-scroller dish-scroller-action',
            style: {
              position: 'relative',
              height: collectInfoAll.accumulationHeight
            }
          },
          _react2.default.createElement(
            'div',
            null,
            children[0],
            children[1],
            mature
          )
        )
      );
    }
  }, {
    key: 'selectMeals',
    value: function selectMeals() {
      var _state5 = this.state,
          screenInfo = _state5.screenInfo,
          collectInfoAll = _state5.collectInfoAll,
          isEnable = _state5.isEnable;

      return isEnable ? screenInfo.screenRenderList : (0, _keys2.default)(collectInfoAll.locationGroup);
    }

    /**
     * 渲染菜品
     */

  }, {
    key: 'renderPackage',
    value: function renderPackage(mealsRobot) {
      var scrollerMenuBodyHeight = this.state.scrollerMenuBodyHeight;
      var _props2 = this.props,
          children = _props2.children,
          dishTypesData = _props2.dishTypesData,
          dishesData = _props2.dishesData,
          theme = _props2.theme,
          isHDL = _props2.isHDL,
          isZc = _props2.isZc,
          hasAds = _props2.hasAds;

      if (!scrollerMenuBodyHeight) return null;
      // if (!mealsRobot) return children[this.scrollerMenuMainIndex].props.children;

      return _react2.default.createElement(
        _robotListBody2.default,
        {
          className: 'dish-list clearfix',
          dishesData: dishesData,
          dishTypesData: dishTypesData,
          parentBodyHeight: scrollerMenuBodyHeight,
          getRobotInfo: this.getRobotInfo,
          theme: theme,
          isHDL: isHDL,
          isZc: isZc,
          hasAds: hasAds
        },
        mealsRobot
      );
    }
  }, {
    key: 'getMealsReduceCallback',
    value: function getMealsReduceCallback(renderAccumulationList, screenNum) {
      if (screenNum <= 0) return renderAccumulationList;

      var mealsList = this.state.collectInfoAll.locationGroup[screenNum];

      if (mealsList) return renderAccumulationList.concat(mealsList);

      return renderAccumulationList;
    }
  }, {
    key: 'renderServingMeals',
    value: function renderServingMeals() {
      return this.selectMeals().reduce(this.getMealsReduceCallback, []);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.mealsListRender();
    }
  }]);
  return ScrollerMenu;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class2.prototype, 'scrollEndAction', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'scrollEndAction'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = ScrollerMenu;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(857), __esModule: true };

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(858);
var $Object = __webpack_require__(1).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(26);
var $getOwnPropertyDescriptor = __webpack_require__(98).f;

__webpack_require__(81)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _propTypes = __webpack_require__(119);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (scrollerMenu) {
  scrollerMenu.propTypes = {
    children: _propTypes2.default.any,
    dishId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    onScroll: _propTypes2.default.func,
    onScrollingTitleAction: _propTypes2.default.func,
    theme: _propTypes2.default.any,
    dishesData: _propTypes2.default.any
  };

  scrollerMenu.defaultProps = {
    children: null,
    dishId: 0,
    onScroll: function onScroll() {
      return null;
    },
    theme: 'default'
  };
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(119);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _calcPosHelper = __webpack_require__(861);

var _const = __webpack_require__(14);

var _industryHelper = __webpack_require__(489);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RobotListBody = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(RobotListBody, _React$Component);

  function RobotListBody() {
    (0, _classCallCheck3.default)(this, RobotListBody);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RobotListBody.__proto__ || (0, _getPrototypeOf2.default)(RobotListBody)).call(this));

    _this.robotBody = null;
    _this.state = {
      ulHeight: null
    };
    return _this;
  }

  (0, _createClass3.default)(RobotListBody, [{
    key: 'getNewScreenNum',
    value: function getNewScreenNum(robotNewTop) {
      var parentBodyHeight = this.props.parentBodyHeight;

      return Math.floor(robotNewTop / parentBodyHeight) + 1;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.assembleInfo();
    }

    /**
     * 根据数据计算组装相关信息。
     * 为了尽可能的减少改动原代码。此处返回的数据与原返回数据一致。
     * 只不过，这些数据是通过计算而来。
     * 原来是通过渲染出来 再获取而已。
     */

  }, {
    key: 'assembleInfo',
    value: function assembleInfo() {
      var _this2 = this;

      if (!this.robotBody) throw new Error('未查找到菜品容器DOM对象');
      var _robotBody = this.robotBody,
          pTop = _robotBody.offsetTop,
          pLeft = _robotBody.offsetLeft,
          pWidth = _robotBody.offsetWidth,
          pHeight = _robotBody.offsetHeight;
      var _props = this.props,
          dishTypesData = _props.dishTypesData,
          getRobotInfo = _props.getRobotInfo,
          dishesData = _props.dishesData,
          parentBodyHeight = _props.parentBodyHeight,
          theme = _props.theme;
      // 所有菜品和分类条目的坐标信息

      var locationGroup = {};
      // 用于保存条目的索引和屏数。之前这是个数组。但是对象应该更合理  看结构 id:[{}]
      var dishIndexList = {};

      // 分类条目信息
      var titleMarkInfo = {
        infoList: [],
        infoIndex: {}
      };
      var currentTop = pTop;
      dishTypesData.forEach(function (dishType, index) {
        var dishTypeId = dishType.id,
            dishIds = dishType.dishIds,
            reactObj = dishType.reactObj,
            dishAry = dishType.dishAry;


        var lastDishTypeTop = null;
        if (index === dishTypesData.length - 1) {
          lastDishTypeTop = currentTop;
        }

        var infoListLength = titleMarkInfo.infoList.length;

        titleMarkInfo.infoList[infoListLength] = {
          dishId: dishTypeId,
          top: currentTop,
          index: index
        };

        var sNum = _this2.getNewScreenNum(currentTop);
        _this2.assembleLocationGroupInfo(locationGroup, currentTop, sNum, { width: '100%', left: 0, className: '*', dishId: dishTypeId, reactObj: reactObj });
        currentTop += _this2.getDishTypeHeightByCalc(theme); // 累加分类高度

        var tempStorePrevHeight = 0; // 只有theme为big时使用。因为big一行有两个菜。
        // 遍历该分类下的所有菜品
        dishIds.forEach(function (dishId, dIndx) {
          var dishReactObj = dishAry[dIndx].reactObj;

          var screenNum = _this2.getNewScreenNum(currentTop);
          _this2.assembleLocationGroupInfo(locationGroup, currentTop, screenNum, {
            width: theme === _const.DishTheme.BIG ? '50%' : '100%',
            left: theme === _const.DishTheme.BIG && dIndx % 2 !== 0 ? '50%' : 0,
            className: '*',
            dishId: dishTypeId + '-' + dishId,
            reactObj: dishReactObj
          });
          if (!dishIndexList[dishId]) {
            dishIndexList[dishId] = [];
          }
          dishIndexList[dishId].push({
            index: locationGroup[screenNum].length - 1,
            screenNum: screenNum
          });
          var currentDishHeight = _this2.getDishHeightByCalc(theme, dishAry[dIndx]);
          if (theme === _const.DishTheme.BIG) {
            if (dIndx % 2 === 0 && dishIds.length - 1 !== dIndx) {
              tempStorePrevHeight = currentDishHeight;
            } else {
              currentDishHeight = Math.max(tempStorePrevHeight, currentDishHeight);
              tempStorePrevHeight = 0;
              currentTop += currentDishHeight; // 累加商品高度(商品的折扣信息)
            }
          } else {
            currentTop += currentDishHeight; // 累加商品高度(商品的折扣信息)
          }
        });

        // 最后一个中类，发现其菜品不足排列满一个可视区域，则自动加上一定高度来撑开一个可视区域。
        if (lastDishTypeTop !== null && currentTop - lastDishTypeTop < parentBodyHeight) {
          currentTop = parentBodyHeight + lastDishTypeTop + 15;
        }
      });
      var accumulationHeight = currentTop - pTop;
      var screenTotalNum = (0, _keys2.default)(locationGroup).length;
      this.setUlHeight(accumulationHeight);

      getRobotInfo({
        titleMarkInfo: titleMarkInfo,
        collectInfoAll: {
          locationGroup: locationGroup,
          accumulationHeight: accumulationHeight,
          screenTotalNum: screenTotalNum,
          dishIndexList: dishIndexList
        }
      });
    }
  }, {
    key: 'assembleLocationGroupInfo',
    value: function assembleLocationGroupInfo(locationGroup, currentTop, screenNum) {
      var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
          className = _ref.className,
          dishId = _ref.dishId,
          _ref$reactObj = _ref.reactObj,
          reactObj = _ref$reactObj === undefined ? null : _ref$reactObj,
          _ref$width = _ref.width,
          width = _ref$width === undefined ? '100%' : _ref$width,
          _ref$left = _ref.left,
          left = _ref$left === undefined ? 0 : _ref$left;

      if (!locationGroup[screenNum]) {
        locationGroup[screenNum] = [];
      }
      var lgItem = locationGroup[screenNum];
      lgItem.push({
        className: reactObj.props.className,
        top: currentTop,
        left: left,
        width: width,
        dishId: dishId,
        robotId: dishId,
        screenNum: screenNum,
        keys: dishId,
        robotObj: reactObj,
        index: lgItem.length - 1
      });
    }
    /**
     * 通过不同的主题，计算获取分类的高度
     * @param {*} theme
     */

  }, {
    key: 'getDishTypeHeightByCalc',
    value: function getDishTypeHeightByCalc(theme) {
      if (theme === _const.DishTheme.BIG) {
        return _calcPosHelper.BIG_ITEM_DISH_TYPE_HEIGHT;
      } else if (theme === _const.DishTheme.HUGE) {
        return _calcPosHelper.HUGE_ITEM_DISH_TYPE_HEIGHT;
      }
      return _calcPosHelper.ITEM_DISH_TYPE_HEIGHT;
    }

    /**
     * 通过不同的主题，计算商品的高度
     * @param {*} theme
     * @param {*} dish
     */

  }, {
    key: 'getDishHeightByCalc',
    value: function getDishHeightByCalc(theme) {
      var dish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var res = 0;
      switch (theme) {
        case _const.DishTheme.BIG:
          res = this.getHeightFromBig(dish);
          break;
        case _const.DishTheme.HUGE:
          res = this.getHeightFromHuge(dish);
          break;
        case _const.DishTheme.DEFAULT:
        default:
          res = this.getHeightFromDefault(dish);
      }

      return res;
    }

    /**
     * 默认模板 的 商品行高
     * @param {*} dish
     */

  }, {
    key: 'getHeightFromDefault',
    value: function getHeightFromDefault(dish) {
      var res = 0;
      var isMember = dish.isMember,
          isUserMember = dish.isUserMember,
          marketingInfos = dish.marketingInfos,
          singleMarketingInfos = dish.singleMarketingInfos;
      var isHDL = this.props.isHDL;


      var industry = (0, _industryHelper.getIndustryFromBody)() || _const.INDUSTRY.NORMAL;

      var activityNum = isHDL ? Array.isArray(singleMarketingInfos) && !isMember ? Math.min(singleMarketingInfos.length, 1) : 0 : Array.isArray(marketingInfos) ? Math.min(marketingInfos.length, 2) : 0;

      var getHeightByTea = function getHeightByTea() {
        var result = 0;
        if (isMember && !isUserMember) {
          result = _calcPosHelper.TEA_ITEM_DISH_HEIGHT_MEMBER;
        } else if (isMember && isUserMember) {
          result = _calcPosHelper.TEA_ITEM_DISH_HEIGHT_MEMBER_ACTIVITY;
        } else {
          result = _calcPosHelper.TEA_ITEM_DISH_HEIGHT_BASIC;
        }
        result += activityNum * _calcPosHelper.TEA_ITEM_DISH_DISCOUNT_HEIGHT;
        return result;
      };

      var getHeightByNormal = function getHeightByNormal() {
        return _calcPosHelper.ITEM_DISH_HEIGHT + _calcPosHelper.ITEM_DISH_DISCOUNT_WRAPPER_MARGIN_TOP + activityNum * _calcPosHelper.ITEM_DISH_DISCOUNT;
      };

      switch (industry) {
        case _const.INDUSTRY.TEA:
          res = getHeightByTea();
          break;
        case _const.INDUSTRY.NORMAL:
        default:
          res = getHeightByNormal();
      }

      return res;
    }

    /**
     * 大图模板 的 商品行高
     * @param {*} dish
     */

  }, {
    key: 'getHeightFromBig',
    value: function getHeightFromBig(dish) {
      return _calcPosHelper.BIG_ITEM_DISH_HEIGHT;
    }

    /**
     * 巨图模板 的 商品行高
     * @param {*} dish
     */

  }, {
    key: 'getHeightFromHuge',
    value: function getHeightFromHuge(dish) {
      return _calcPosHelper.HUGE_ITEM_DISH_HEIGHT;
    }
  }, {
    key: 'setUlHeight',
    value: function setUlHeight(accumulationHeight) {
      this.setState({
        ulHeight: accumulationHeight
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          children = _props2.children,
          isZc = _props2.isZc,
          hasAds = _props2.hasAds;
      var ulHeight = this.state.ulHeight;

      var height = document.body.clientHeight;
      var style = {
        width: '100%',
        whiteSpace: 'normal',
        height: ulHeight || 'auto'
      };
      if (hasAds && children && children.length < 5) {
        style.minHeight = height - (isZc ? 80 : 125) + 'px';
      }
      return _react2.default.createElement(
        'ul',
        {
          className: 'dish-list clearfix',
          style: style,
          ref: function ref(element) {
            return _this3.robotBody = element;
          }
        },
        children
      );
    }
  }]);
  return RobotListBody;
}(_react2.default.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    children: _propTypes2.default.any,
    parentBodyHeight: _propTypes2.default.number,
    getRobotInfo: _propTypes2.default.func,
    isZc: _propTypes2.default.bool,
    hasAds: _propTypes2.default.bool
  }
}), Object.defineProperty(_class, 'defaultProps', {
  enumerable: true,
  writable: true,
  value: {
    children: null,
    parentBodyHeight: 0,
    getRobotInfo: function getRobotInfo() {},
    isZc: false,
    hasAds: false
  }
}), _temp);
exports.default = RobotListBody;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 在菜品列表中，菜品类别条目的高度
 * （border+padding+margin+content）
 *  theme default
 */
var ITEM_DISH_TYPE_HEIGHT = 27;

/**
 * 在菜品列表中，菜品条目高度
 * （border+padding+margin+content）
 * theme default
 */
var ITEM_DISH_HEIGHT = 95;

/**
 * 在菜品列表中，优惠信息高度
 * （border+padding+margin+content）
 * line-height:15 padding:2px 0;
 * theme default
 */
var ITEM_DISH_DISCOUNT = 19;

/**
 * 优惠信息容器上外间距
 * theme default
 */
var ITEM_DISH_DISCOUNT_WRAPPER_MARGIN_TOP = 10;

/**
 *在菜品列表中，菜品类别条目的高度
 * （border+padding+margin+content）
 *  theme BIG
 */
var BIG_ITEM_DISH_TYPE_HEIGHT = 37;

/**
 * 在菜品列表中，菜品的高度
 * 图片的高度+价格信息的高度
 */
var BIG_ITEM_DISH_HEIGHT = document.documentElement.clientWidth * 0.34 + 100;

/**
 * 在菜品列表中，菜品类别条目的高度
 * （border+padding+margin+content）
 *  theme HUGE
 */
var HUGE_ITEM_DISH_TYPE_HEIGHT = 27;

/**
 * 在菜品列表中，菜品的高度
 * 图片的高度+价格信息的高度
 */
var HUGE_ITEM_DISH_HEIGHT = 15 + document.documentElement.clientWidth * 0.7 + 90;

/**
 * 没有会员价标签的高度
 */
var TEA_ITEM_DISH_HEIGHT_BASIC = 113;

/**
 * 会员价标签
 */
var TEA_ITEM_DISH_HEIGHT_MEMBER = 131;

/**
 * 会员活动
 */
var TEA_ITEM_DISH_HEIGHT_MEMBER_ACTIVITY = 129;

var TEA_ITEM_DISH_DISCOUNT_HEIGHT = 19;

exports.ITEM_DISH_TYPE_HEIGHT = ITEM_DISH_TYPE_HEIGHT;
exports.ITEM_DISH_HEIGHT = ITEM_DISH_HEIGHT;
exports.ITEM_DISH_DISCOUNT = ITEM_DISH_DISCOUNT;
exports.ITEM_DISH_DISCOUNT_WRAPPER_MARGIN_TOP = ITEM_DISH_DISCOUNT_WRAPPER_MARGIN_TOP;
exports.BIG_ITEM_DISH_TYPE_HEIGHT = BIG_ITEM_DISH_TYPE_HEIGHT;
exports.BIG_ITEM_DISH_HEIGHT = BIG_ITEM_DISH_HEIGHT;
exports.HUGE_ITEM_DISH_TYPE_HEIGHT = HUGE_ITEM_DISH_TYPE_HEIGHT;
exports.HUGE_ITEM_DISH_HEIGHT = HUGE_ITEM_DISH_HEIGHT;
exports.TEA_ITEM_DISH_HEIGHT_BASIC = TEA_ITEM_DISH_HEIGHT_BASIC;
exports.TEA_ITEM_DISH_HEIGHT_MEMBER = TEA_ITEM_DISH_HEIGHT_MEMBER;
exports.TEA_ITEM_DISH_HEIGHT_MEMBER_ACTIVITY = TEA_ITEM_DISH_HEIGHT_MEMBER_ACTIVITY;
exports.TEA_ITEM_DISH_DISCOUNT_HEIGHT = TEA_ITEM_DISH_DISCOUNT_HEIGHT;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (turboName) {
  return function (target, key, descriptor) {
    if (window.requestAnimationFrame) {
      target.prototype[turboName] = requestAnimationFrame.bind(window);
      return;
    }

    target.prototype[turboName] = function (fn) {
      setTimeout(fn, 17);
    };
  };
};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (timeMs) {
  return function (target, key, descriptor) {
    var oldValue = descriptor.value;

    descriptor.value = function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(target.timeoutClearTarget);

      target.timeoutClearTarget = setTimeout(function () {
        return oldValue.apply(_this, args);
      }, timeMs);
    };

    return descriptor;
  };
};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (scrollerMenu) {
  scrollerMenu.prototype.bind = function () {
    var _this = this;

    for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
      methods[_key] = arguments[_key];
    }

    methods.forEach(function (method) {
      return scrollerMenu.prototype[method] = scrollerMenu.prototype[method].bind(_this);
    });
  };
};

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var shallowCompare = __webpack_require__(120);

var helper = __webpack_require__(43);
var getCoupon = helper.getUrlParam('getCoupon');
// const couponBtn = require('../../asset/images/coupon-btn.svg');
// const shopId = helper.getUrlParam('shopId');
// const type = helper.getUrlParam('type');
__webpack_require__(730);

module.exports = React.createClass({
  displayName: 'DishCoupon',
  propTypes: {
    // reducer
    shopInfo: React.PropTypes.object,
    firstStatus: React.PropTypes.number,

    // action
    getMarketCoupon: React.PropTypes.func,
    closeFixedCoupon: React.PropTypes.func,
    showCouponAnimation: React.PropTypes.func,
    showAlreadyGotCoupon: React.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      shopInfo: {}
    };
  },
  getInitialState: function getInitialState() {
    return {
      getCouponStatus: false // 是否已领券
    };
  },
  componentDidMount: function componentDidMount() {
    this.shouldGetCoupon = true;
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var nextCoupon = nextProps.shopInfo.couponSuccessInfo;
    var thisCoupon = this.props.shopInfo.couponSuccessInfo;
    var isOldMarketing = nextProps.shopInfo.isOldMarketing;

    if (isOldMarketing && nextCoupon && nextCoupon !== thisCoupon) {
      // 老逻辑取券成功
      this.setState({ getCouponStatus: true });
    }

    // 触发领券
    var marketCoupon = nextProps.shopInfo.marketCoupon; // 老逻辑
    var couponList = nextProps.shopInfo.couponList; // 新逻辑
    var couponSuccess = nextProps.shopInfo.couponSuccess; // 新逻辑
    var getMarketCoupon = this.props.getMarketCoupon;

    // 老逻辑自动领券

    if (getCoupon === 'true' && isOldMarketing && marketCoupon.coupId && !nextCoupon && marketCoupon.flag && this.shouldGetCoupon) {
      this.shouldGetCoupon = false;
      getMarketCoupon(marketCoupon.coupId);
    }

    // 新逻辑自动领券
    if (getCoupon === 'true' && !isOldMarketing && couponList && couponList.length > 0 && !couponSuccess && nextProps.shopInfo.flag && this.shouldGetCoupon) {
      this.shouldGetCoupon = false;
      getMarketCoupon(couponList[0].coupId);
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  getCouponSuccess: function getCouponSuccess() {
    var _props = this.props,
        shopInfo = _props.shopInfo,
        getMarketCoupon = _props.getMarketCoupon,
        closeFixedCoupon = _props.closeFixedCoupon;

    if (!shopInfo.couponSuccessInfo) {
      if (!shopInfo.marketCoupon.flag) {
        return false;
      }
      setTimeout(function () {
        if (shopInfo.isOldMarketing) {
          // 老逻辑
          getMarketCoupon(shopInfo.marketCoupon.coupId, closeFixedCoupon);
        } else {
          // 新逻辑
          getMarketCoupon(shopInfo.ruleId, closeFixedCoupon);
        }
      }, 600);
    }

    return true;
  },
  setCouponValue: function setCouponValue(marketCoupon) {
    // 领券成功
    if (marketCoupon.coupType === 1 || marketCoupon.coupType === 4) {
      return React.createElement(
        'div',
        { className: 'price' },
        marketCoupon.value
      );
    } else if (marketCoupon.coupType === 2) {
      return React.createElement(
        'div',
        null,
        marketCoupon.value,
        React.createElement(
          'small',
          null,
          React.createElement(_formattedMessage2.default, _global2.default.discount)
        )
      );
    }
    return false;
  },
  handleGetCoupons: function handleGetCoupons(e, coupId, couldFetch, checkGetCoupon) {
    e.stopPropagation();
    e.preventDefault();
    var _props2 = this.props,
        couponType = _props2.couponType,
        getMarketCoupon = _props2.getMarketCoupon,
        showAlreadyGotCoupon = _props2.showAlreadyGotCoupon;
    var _props$shopInfo = this.props.shopInfo,
        isOldMarketing = _props$shopInfo.isOldMarketing,
        couponList = _props$shopInfo.couponList;

    if (!couldFetch) {
      if (checkGetCoupon && showAlreadyGotCoupon) {
        // 在不能领券 + 查看的情况下
        showAlreadyGotCoupon(checkGetCoupon);
      }
      return;
    }

    if (couponType === 'dishMenu') {
      if (isOldMarketing) {
        getMarketCoupon(coupId);
      } else {
        getMarketCoupon(couponList[0].coupId);
      }
    }
  },
  render: function render() {
    var _this = this;

    var getCouponStatus = this.state.getCouponStatus;
    var _props3 = this.props,
        shopInfo = _props3.shopInfo,
        firstStatus = _props3.firstStatus;

    var marketCoupon = shopInfo.marketCoupon || {};
    // const couponValue = this.setCouponValue(marketCoupon);

    var isOldMarketing = shopInfo.isOldMarketing,
        flag = shopInfo.flag,
        newType = shopInfo.type;

    var couldFetch = true;
    var couponWord = (0, _helper.formatMessage)(_global2.default.getCoupon);
    var checkGetCoupon = false;
    if (isOldMarketing) {
      // 老逻辑
      if (!shopInfo.marketCoupon.flag && shopInfo.marketCoupon.type === 1) {
        couponWord = (0, _helper.formatMessage)(_global2.default.haveFinished);
        couldFetch = false;
      } else if (getCouponStatus || !shopInfo.marketCoupon.flag && shopInfo.marketCoupon.type === 2) {
        couponWord = (0, _helper.formatMessage)(_global2.default.viewPackage);
        couldFetch = false;
        checkGetCoupon = true;
      }
    } else {
      // 新逻辑
      // const alreadySendCouponNew = localStorage.alreadySendCouponNew || '';
      if (!flag && newType === 1) {
        couponWord = (0, _helper.formatMessage)(_global2.default.haveFinished);
        couldFetch = false;
      } else if (shopInfo.couponSuccess || !flag && newType === 2) {
        couponWord = (0, _helper.formatMessage)(_global2.default.viewPackage);
        couldFetch = false;
        checkGetCoupon = true;
      }
    }

    return React.createElement(
      'div',
      { className: 'dish-coupon clearfix' },
      React.createElement(
        'div',
        { className: 'dish-coupon-inner' },
        firstStatus === 1 ? React.createElement('i', { className: 'coupon-icon coupon-icon--top' }) : '',
        firstStatus === 1 ? React.createElement('i', { className: 'coupon-icon coupon-icon--bottom' }) : '',
        React.createElement(
          'div',
          { className: 'dish-coupon-content' },
          React.createElement(
            'div',
            { className: 'clearfix', style: { width: '100%', textAlign: 'left' } },
            React.createElement(_formattedMessage2.default, _global2.default.storePackage)
          )
        ),
        React.createElement(
          'div',
          { className: 'dish-coupon-status' },
          React.createElement(
            'span',
            {
              className: 'dish-coupon-status__btn',
              onTouchTap: function onTouchTap(e) {
                return _this.handleGetCoupons(e, marketCoupon.coupId, couldFetch, checkGetCoupon);
              }
            },
            couponWord
          )
        )
      )
    );
  }
});

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/hot-arrow.svg";

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _shoppingCart = __webpack_require__(425);

var _shoppingCart2 = _interopRequireDefault(_shoppingCart);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
__webpack_require__(870);
var guidFunction = __webpack_require__(871);
var guidAdd = __webpack_require__(872);
var guidBeil = __webpack_require__(873);
var guidCar = __webpack_require__(874);
var guidArrow = __webpack_require__(875);
var guidNext = __webpack_require__(876);
var guidDish = __webpack_require__(617);
var guidTxt1_ = __webpack_require__(877);
var guidTxt8_ = __webpack_require__(878);
var guidTxt7_ = __webpack_require__(879);
var guidTxt6_ = __webpack_require__(880);
var guidTxt4_ = __webpack_require__(881);
var guidFunction_ = __webpack_require__(882);
var guidBeil_ = __webpack_require__(883);
var guidTSCart = __webpack_require__(884);
var guidTSDish = __webpack_require__(885);

var getUrlParam = __webpack_require__(43).getUrlParam;

var DishGuid = React.createClass({
  displayName: 'DishGuid',
  propTypes: {
    gotoNextTips: React.PropTypes.func,
    setClose: React.PropTypes.func,
    dishType: React.PropTypes.object,
    getGuidDetail: React.PropTypes.func,
    omitDishGuidStepNumber: React.PropTypes.number
  },
  getGuidDetail: function getGuidDetail() {
    var type = this.props.dishType.type;
    var showScan = this.props.dishType.showScan;
    // 扫码点餐出现时
    var scanFunc = this.props.dishType.showScan === true ? '76px' : '10px';
    var scanDesc = this.props.dishType.showScan === true ? '140px' : '85px';
    if (type === 'TS') {
      return React.createElement(
        'div',
        { id: 'tangshi', style: { display: 'block' } },
        React.createElement(
          'div',
          { className: 'tips_1', key: 'tips_1', style: { display: 'block' } },
          React.createElement(
            'div',
            { className: 'pos-a guid-add' },
            React.createElement(
              'div',
              { className: 'guid-dish' },
              React.createElement(
                'div',
                { className: 'guid-dish-img ' },
                React.createElement('img', { src: guidDish, alt: '' })
              ),
              React.createElement(
                'div',
                { className: 'guid-dish-content' },
                React.createElement(
                  'div',
                  { className: 'guid-dish-menu' },
                  '\xA0'
                ),
                React.createElement('span', { className: 'guid-dish-menu' }),
                React.createElement(
                  'div',
                  { className: 'guid-dish-bottom' },
                  React.createElement(
                    'span',
                    { className: 'guid-dish-price' },
                    '\xA0'
                  ),
                  React.createElement('img', { src: guidAdd, alt: '', title: '', className: 'add-img' })
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'pos-a guid-desc' },
            React.createElement('img', { src: guidTSDish, alt: '', style: { width: '160px' } }),
            React.createElement('img', { src: guidArrow, className: 'pos-a guid-line', alt: '' })
          )
        ),
        React.createElement(
          'div',
          { className: 'tips_2', key: 'tips_2', style: { display: 'none' } },
          React.createElement(
            'div',
            { className: 'pos-a o-ta--c guid-func', style: { bottom: scanFunc } },
            React.createElement('img', { src: guidFunction, alt: '', title: '', className: '', style: { width: '11px' } }),
            React.createElement(
              'span',
              { className: '' },
              React.createElement(_formattedMessage2.default, _shoppingCart2.default.func)
            )
          ),
          React.createElement(
            'div',
            { className: 'pos-a guid-desc', style: { bottom: scanDesc } },
            React.createElement('img', { src: guidArrow, className: 'pos-a guid-line', alt: '' }),
            React.createElement('img', { src: guidFunction_, alt: '', style: { width: '160px' } })
          )
        ),
        React.createElement(
          'div',
          { className: 'tips_3', key: 'tips_3', style: { display: 'none' } },
          React.createElement(
            'div',
            { className: 'pos-a o-ta--c guid-func', style: { bottom: scanFunc } },
            React.createElement('img', { src: guidBeil, alt: '', title: '', className: '', style: { width: '11px' } }),
            React.createElement(
              'span',
              { className: '' },
              React.createElement(_formattedMessage2.default, _dishMenu2.default.serviceBell)
            )
          ),
          React.createElement(
            'div',
            { className: 'pos-a guid-desc', style: { bottom: scanDesc } },
            React.createElement('img', { src: guidBeil_, alt: '', style: { width: '180px' } }),
            React.createElement('img', { src: guidArrow, className: 'pos-a guid-line', alt: '' })
          )
        ),
        React.createElement(
          'div',
          { className: 'tips_4', key: 'tips_4', style: { display: 'none' } },
          React.createElement(
            'div',
            { className: 'pos-a o-ta--c guid-func', style: { bottom: scanFunc } },
            React.createElement('img', { src: guidCar, alt: '', title: '', className: 'guid-func-img' }),
            React.createElement(
              'span',
              { className: 'price' },
              '239'
            ),
            React.createElement(
              'span',
              { className: 'guid-func-num' },
              '9'
            )
          ),
          React.createElement(
            'div',
            { className: 'pos-a guid-desc', style: { bottom: scanDesc } },
            React.createElement('img', { src: guidTSCart, alt: '', style: { width: '180px' } }),
            React.createElement('img', { src: guidArrow, className: 'pos-a guid-line', alt: '' })
          )
        )
      );
    }
    if (type === 'WM' && showScan === false) {
      return React.createElement(
        'div',
        { id: 'kuaican', style: { display: 'block' } },
        React.createElement(
          'div',
          { className: 'tips_1', key: 'tips_1', style: { display: 'block' } },
          React.createElement(
            'div',
            { className: 'pos-a guid-add' },
            React.createElement(
              'div',
              { className: 'guid-dish' },
              React.createElement(
                'div',
                { className: 'guid-dish-img ' },
                React.createElement('img', { src: guidDish, alt: '' })
              ),
              React.createElement(
                'div',
                { className: 'guid-dish-content' },
                React.createElement(
                  'div',
                  { className: 'guid-dish-menu' },
                  '\xA0'
                ),
                React.createElement('span', { className: 'guid-dish-menu' }),
                React.createElement(
                  'div',
                  { className: 'guid-dish-bottom' },
                  React.createElement(
                    'span',
                    { className: 'guid-dish-price' },
                    '\xA0'
                  ),
                  React.createElement('img', { src: guidAdd, alt: '', title: '', className: 'add-img' })
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'pos-a guid-desc' },
            React.createElement('img', { src: guidTxt1_, alt: '', style: { width: '160px' } }),
            React.createElement('img', { src: guidArrow, className: 'pos-a guid-line', alt: '' })
          )
        ),
        React.createElement(
          'div',
          { className: 'tips_2', key: 'tips_2', style: { display: 'none' } },
          React.createElement(
            'div',
            { className: 'pos-a o-ta--c guid-func' },
            React.createElement('img', { src: guidCar, alt: '', title: '' })
          ),
          React.createElement(
            'div',
            { className: 'pos-a guid-desc' },
            React.createElement('img', { src: guidArrow, className: 'pos-a guid-line', alt: '', style: { width: '20px' } }),
            React.createElement('img', { src: guidTxt4_, alt: '', style: { width: '160px' } })
          )
        ),
        React.createElement(
          'div',
          { className: 'tips_3', key: 'tips_3', style: { display: 'none' } },
          React.createElement(
            'div',
            { className: 'pos-a o-ta--c guid-func' },
            React.createElement(_formattedMessage2.default, _shoppingCart2.default.closeOk)
          ),
          React.createElement(
            'div',
            { className: 'pos-a guid-desc' },
            React.createElement('img', { src: guidTxt8_, alt: '', style: { width: '230px' } }),
            React.createElement('img', { src: guidArrow, className: 'pos-a guid-line', alt: '' })
          )
        )
      );
    }
    return true;
  },
  setClose: function setClose() {
    document.getElementById('guidBox').style.display = 'none';
    if (!localStorage.setItem('shop_' + getUrlParam('shopId') + getUrlParam('type'), getUrlParam('shopId'))) {
      localStorage.setItem('shop_' + getUrlParam('shopId') + getUrlParam('type'), getUrlParam('shopId'));
    }
  },
  gotoNextTips: function gotoNextTips() {
    var omitDishGuidStepNumber = this.props.omitDishGuidStepNumber; // 需要忽略的步骤

    var nextBtn = document.getElementById('guid-next');
    var guidBox = document.getElementById('guidBox');
    var changeImg = document.getElementById('changeImg');
    var type = this.props.dishType.type;
    var oriNextTips = type === 'TS' ? document.getElementById('tangshi').childNodes : document.getElementById('kuaican').childNodes;

    var nextTips = [].slice.call(oriNextTips);
    if (omitDishGuidStepNumber) {
      nextTips.splice(omitDishGuidStepNumber - 1, 1); // 去掉某一项
    }

    for (var i = 0; i < nextTips.length; i++) {
      if (nextTips[i].style.display === 'block') {
        if (i === nextTips.length - 2) {
          changeImg.src = type === 'WM' ? guidTxt7_ : guidTxt6_;
          changeImg.style.width = type === 'WM' ? '100px' : '150px';
        }
        if (i === nextTips.length - 1) {
          guidBox.style.display = 'none';
          nextBtn.disable = true;
          if (!localStorage.setItem('shop_' + getUrlParam('shopId') + getUrlParam('type'), getUrlParam('shopId'))) {
            localStorage.setItem('shop_' + getUrlParam('shopId') + getUrlParam('type'), getUrlParam('shopId'));
          }
          break;
        }
        nextTips[i].style.display = 'none';
        nextTips[i + 1].style.display = 'block';
        break;
      }
    }
  },
  render: function render() {
    var guidDetail = this.getGuidDetail();

    return React.createElement(
      'div',
      { className: 't-c guid', id: 'guidBox' },
      React.createElement(
        'button',
        { className: 'pos-a o-fz--15 guid-close', onTouchTap: this.setClose },
        React.createElement(_formattedMessage2.default, _dishMenu2.default.ignoreStep)
      ),
      React.createElement(
        'button',
        { className: 'pos-a t-c o-ta--c guid-next', onTouchTap: this.gotoNextTips, id: 'guid-next' },
        React.createElement('img', { src: guidNext, alt: '', style: { width: '60px', marginTop: '8px' }, id: 'changeImg' })
      ),
      guidDetail
    );
  }
});

module.exports = DishGuid;

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-function.svg";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-add.svg";

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-beil.svg";

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-car.svg";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-arrow.svg";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-next.svg";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-txt1.svg";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-txt8.svg";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-txt7.svg";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-txt6.svg";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-txt4.svg";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-txtFun.svg";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-TSCall.svg";

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-TSCart.svg";

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/guid-TSDish.svg";

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(25);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _EbuAppHelper = __webpack_require__(525);

var _EbuAppHelper2 = _interopRequireDefault(_EbuAppHelper);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _shopDelivertyInfo = __webpack_require__(737);

var _shopDelivertyInfo2 = _interopRequireDefault(_shopDelivertyInfo);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _shop = __webpack_require__(477);

var _shop2 = _interopRequireDefault(_shop);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _shopSwiper = __webpack_require__(632);

var _shopSwiper2 = _interopRequireDefault(_shopSwiper);

var _languageRecharge = __webpack_require__(738);

var _languageRecharge2 = _interopRequireDefault(_languageRecharge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var classnames = __webpack_require__(50);
var shallowCompare = __webpack_require__(120);
var helper = __webpack_require__(43);

var defaultShopLogo = __webpack_require__(592);
var searchLogo = __webpack_require__(887);
var shopSelect = __webpack_require__(888);
var AdsColumn = __webpack_require__(889);


var config = __webpack_require__(13);
var type = helper.getUrlParam('type');
var basicListInfo = localStorage.basicListInfo;
var wayFlag = JSON.parse(basicListInfo || '{}').way; // 自提外送

__webpack_require__(892);

module.exports = React.createClass({
  displayName: 'DishMesthead',
  propTypes: {
    shopInfo: React.PropTypes.object,
    shopLogo: React.PropTypes.string,
    tableInfo: React.PropTypes.object,
    setSearchPage: React.PropTypes.func,
    isHDL: React.PropTypes.bool,
    operateImgUrl: React.PropTypes.string,
    operateUrl: React.PropTypes.string,
    tsOperateImgUrl: React.PropTypes.string,
    tsOperateUrl: React.PropTypes.string,
    setAllDiscount: React.PropTypes.func.isRequired,
    orderPageImage: React.PropTypes.string,
    isAcceptOrder: React.PropTypes.bool,
    takeawayServiceProps: React.PropTypes.object,
    discountProps: React.PropTypes.object,
    openShopTimeStr: React.PropTypes.string,
    openShopTime: React.PropTypes.object,
    flodUpAppendCss: React.PropTypes.string,
    isShowHalf: React.PropTypes.bool // 是否显示第二杯半价的信息
  },
  getInitialState: function getInitialState() {
    return {
      showOperateImage: true,
      languageSwitch: false
    };
  },
  componentWillMount: function componentWillMount() {
    var languageSwitch = sessionStorage.getItem('language_switch');
    this.setState({
      languageSwitch: languageSwitch
    });
  },
  getDefaultProps: function getDefaultProps() {
    return {
      shopInfo: {},
      registered: false
    };
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  getSendText: function getSendText() {
    var _props = this.props,
        isToHomeFlag = _props.shopInfo.isToHomeFlag,
        _props$takeawayServic = _props.takeawayServiceProps,
        takeawayServiceProps = _props$takeawayServic === undefined ? {} : _props$takeawayServic;

    var sendText = '';

    if (type === 'WM' && (wayFlag && wayFlag === 'ws' || !wayFlag && isToHomeFlag)) {
      sendText = React.createElement(_shopDelivertyInfo2.default, { takeawayServiceProps: takeawayServiceProps, prefixed: true });
    }

    return sendText;
  },
  getShopTimeElement: function getShopTimeElement(isShopOpen, isHDL, isAcceptOrder, isEnableShop) {
    var text = isEnableShop && isAcceptOrder && isShopOpen ? React.createElement(_formattedMessage2.default, _shop2.default.openFlag) : React.createElement(_formattedMessage2.default, _shop2.default.closedFlag);

    var tableInfo = this.props.tableInfo;

    var hasTableInfo = this.detectHasTableInfo(tableInfo);

    return React.createElement(
      'span',
      { className: 'o-fz--12 shop-time-box' },
      React.createElement(
        'time',
        {
          className: classnames('shop-status o-text-ellipsis', {
            'shop-time-close': !isShopOpen,
            // 海底捞的时候，字体减小
            'font-size-hdl': isHDL && hasTableInfo
          })
        },
        text,
        this.getSendText()
      ),
      hasTableInfo && !isHDL && this.buildTableInfoText(tableInfo, isHDL)
    );
  },
  getJumpToListUrl: function getJumpToListUrl() {
    var url = '';
    var shopId = helper.getUrlParam('shopId');

    switch (type) {
      case 'TS':
        {
          // 堂食
          url = config.shopTSListURL + '?shopId=' + shopId + '&uniqueId=' + type;
          break;
        }
      case 'WM':
        {
          // 外卖
          url = config.shopWMListURL + '?shopId=' + shopId + '&uniqueId=' + type;
          break;
        }
      case 'YD':
        {
          // 预订
          url = config.shopTSListURL + '?shopId=' + shopId + '&uniqueId=' + type;
          break;
        }
      case 'PD':
        {
          // 排队
          url = config.shopTSListURL + '?shopId=' + shopId + '&uniqueId=' + type;
          break;
        }
      default:
        break;
    }

    return url;
  },
  setSearchPage: function setSearchPage(evt, bool) {
    evt.preventDefault();
    var setSearchPage = this.props.setSearchPage;

    setSearchPage(bool);
  },
  detectHasTableInfo: function detectHasTableInfo(tableInfo) {
    if (!tableInfo || (typeof tableInfo === 'undefined' ? 'undefined' : (0, _typeof3.default)(tableInfo)) !== 'object') {
      return false;
    }
    return (0, _keys2.default)(tableInfo).length !== 0;
  },
  buildTableInfoText: function buildTableInfoText(tableInfo, isHDL) {
    var hasTableInfo = this.detectHasTableInfo(tableInfo);

    return React.createElement(
      'span',
      {
        className: classnames('table-info o-text-ellipsis', {
          // 海底捞的时候，字体减小
          'font-size-hdl': isHDL && hasTableInfo,
          // 非海底捞的时候，营业状态和桌台信息展示在一行，加上分割线
          'table-info-divider': !isHDL && hasTableInfo
        })
      },
      tableInfo.areaName || '',
      ' ',
      tableInfo.tableName || ''
    );
  },
  jumpToListUrl: function jumpToListUrl(shopInfo) {
    if (_EbuAppHelper2.default.isEbuEvn()) {
      return;
    }
    if (!shopInfo.isSingleShop) {
      location.href = this.getJumpToListUrl();
    }
  },
  closeOperateImage: function closeOperateImage() {
    this.setState({
      showOperateImage: false
    });
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props,
        shopInfo = _props2.shopInfo,
        shopLogo = _props2.shopLogo,
        tableInfo = _props2.tableInfo,
        isHDL = _props2.isHDL,
        swiperAdImgs = _props2.swiperAdImgs,
        setAllDiscount = _props2.setAllDiscount,
        orderPageImage = _props2.orderPageImage,
        isAcceptOrder = _props2.isAcceptOrder,
        takeawayServiceProps = _props2.takeawayServiceProps,
        discountProps = _props2.discountProps,
        openShopTimeStr = _props2.openShopTimeStr,
        openShopTime = _props2.openShopTime,
        flodUpAppendCss = _props2.flodUpAppendCss,
        isShowHalf = _props2.isShowHalf;
    var showOperateImage = this.state.showOperateImage;

    var _ref = shopInfo || {},
        marketList = _ref.marketList,
        marketListUpdate = _ref.marketListUpdate,
        multiMarketing = _ref.multiMarketing,
        notice = _ref.notice,
        limitedMarketing = _ref.limitedMarketing;

    var hasTableInfo = this.detectHasTableInfo(tableInfo);
    var isEnableShop = shopInfo.isEnableShop;
    var adsExisted = !!shopInfo.getMarket;
    var orderPageImageObj = orderPageImage ? { backgroundImage: 'url("' + _httpsProtocolImage2.default.getFinalImageUrl(orderPageImage) + '")' } : {};

    return React.createElement(
      'div',
      {
        className: classnames('dish-mesthead o-flex__fixed', {
          'ads-existed': adsExisted,
          'operate-existed': swiperAdImgs && swiperAdImgs.length
        })
      },
      React.createElement(
        'div',
        { className: 'dish-mesthead', style: orderPageImageObj },
        React.createElement(
          'div',
          { className: 'shop shop-container shop-container__' + flodUpAppendCss },
          React.createElement(
            'div',
            { className: 'o-flex shop-header' },
            React.createElement(_httpsProtocolImage2.default, { alt: (0, _helper.formatMessage)(_global2.default.shopLogo), src: shopLogo || defaultShopLogo, className: 'shop-logo' }),
            React.createElement(
              'div',
              { className: 'shop-business-info-container' },
              React.createElement(
                'div',
                { className: 'shop-title o-text-ellipsis' },
                React.createElement(
                  'span',
                  { className: 'of o-text-ellipsis', onTouchTap: function onTouchTap() {
                      return _this.jumpToListUrl(shopInfo);
                    } },
                  shopInfo.commercialName || ''
                ),
                !shopInfo.isSingleShop && !_EbuAppHelper2.default.isEbuEvn() && React.createElement('img', { alt: (0, _helper.formatMessage)(_global2.default.shopSwitch), src: shopSelect, onTouchTap: function onTouchTap() {
                    return _this.jumpToListUrl(shopInfo);
                  } }),
                React.createElement(
                  'span',
                  { className: 'shop-language' },
                  this.state.languageSwitch === 'true' && React.createElement(_languageRecharge2.default, null)
                )
              ),
              this.getShopTimeElement(shopInfo.openStatus, isHDL, isAcceptOrder, isEnableShop),
              hasTableInfo && isHDL && this.buildTableInfoText(tableInfo, isHDL)
            ),
            React.createElement('img', { src: searchLogo, className: 'searchlogo', onTouchTap: function onTouchTap(evt) {
                return _this.setSearchPage(evt, true);
              }, alt: 'search' })
          )
        ),
        adsExisted && React.createElement(AdsColumn, {
          isHDL: isHDL,
          shopInfo: shopInfo,
          shopLogo: shopLogo,
          marketList: marketList,
          marketListUpdate: marketListUpdate,
          multiMarketing: multiMarketing,
          limitedMarketing: limitedMarketing,
          notice: notice,
          setAllDiscount: setAllDiscount,
          takeawayServiceProps: takeawayServiceProps,
          openShopTime: openShopTime,
          openShopTimeStr: openShopTimeStr,
          discountProps: discountProps || {},
          searchTouch: function searchTouch(evt, bool) {
            return _this.setSearchPage(evt, bool);
          },
          flodUpAppendCss: flodUpAppendCss,
          setSearchPage: function setSearchPage(evt) {
            _this.setSearchPage(evt, true);
          },
          isShowHalf: isShowHalf
        })
      ),
      swiperAdImgs && swiperAdImgs.length && showOperateImage ? React.createElement(
        'div',
        { className: 'operate-image-ad shop-container__' + flodUpAppendCss },
        React.createElement(_shopSwiper2.default, { shopIntroImgs: swiperAdImgs, imgSize: 1 })
      ) : null
    );
  }
});

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/search-white.png";

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/shop-switch.svg";

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _shopDelivertyInfo = __webpack_require__(737);

var _shopDelivertyInfo2 = _interopRequireDefault(_shopDelivertyInfo);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _shop = __webpack_require__(477);

var _shop2 = _interopRequireDefault(_shop);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
var classnames = __webpack_require__(50);

var helper = __webpack_require__(43);
var commonHelper = __webpack_require__(3);
var defaultShopLogo = __webpack_require__(592);
var searchLogo = __webpack_require__(890);


__webpack_require__(891);

var type = helper.getUrlParam('type');
var basicListInfo = localStorage.basicListInfo;
var way = JSON.parse(basicListInfo || '{}').way; // 自提外送

var AdsColumn = React.createClass({
  displayName: 'AdsColumn',
  propTypes: {
    dishesData: React.PropTypes.array,
    shopInfo: React.PropTypes.object,
    shopLogo: React.PropTypes.string,
    marketList: React.PropTypes.object,
    marketListUpdate: React.PropTypes.array,
    multiMarketing: React.PropTypes.array,
    notice: React.PropTypes.string,
    openShopTime: React.PropTypes.any,
    openShopTimeStr: React.PropTypes.string,
    setAllDiscount: React.PropTypes.func.isRequired,
    takeawayServiceProps: React.PropTypes.object,
    discountProps: React.PropTypes.object,
    searchTouch: React.PropTypes.func,
    flodUpAppendCss: React.PropTypes.string,
    isShowHalf: React.PropTypes.bool // 是否显示第二杯半价的信息
  },
  getInitialState: function getInitialState() {
    return { animation: {}, allDiscount: false, totalShowScroll: [] };
  },
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        marketListUpdate = _props.marketListUpdate,
        multiMarketing = _props.multiMarketing,
        notice = _props.notice,
        openShopTimeStr = _props.openShopTimeStr;

    var totalShowScroll = [{ type: -2, openShopTimeStr: openShopTimeStr }].concat(marketListUpdate || []).concat(multiMarketing || []).concat(notice && notice.replace(/(\r|\n)/g, '').trim().length > 0 ? [{ type: -1, notice: notice }] : []);

    this.setState({ totalShowScroll: totalShowScroll });
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this._setInterval = setInterval(function () {
      var totalShowScroll = _this.state.totalShowScroll;

      if (totalShowScroll.length === 1) {
        return;
      }
      var distanceClass = { top: '-26px', transition: 'all .5s' };
      _this.setState({ animation: distanceClass }, function () {
        setTimeout(function () {
          _this.setState({ animation: { top: 0, transition: 'none' }, totalShowScroll: _this.changeMarketList(totalShowScroll) });
        }, 500);
      });
    }, 5000);
  },
  componentWillUnmount: function componentWillUnmount() {
    clearInterval(this._setInterval);
  },
  changeMarketList: function changeMarketList() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var copyList = Array.prototype.slice.call(list);
    [].push.call(copyList, copyList.shift());
    return copyList;
  },
  showAllDiscount: function showAllDiscount() {
    var _props2 = this.props,
        shopInfo = _props2.shopInfo,
        shopLogo = _props2.shopLogo,
        notice = _props2.notice,
        openShopTime = _props2.openShopTime,
        takeawayServiceProps = _props2.takeawayServiceProps,
        discountProps = _props2.discountProps;

    var scrollPart = this.scrollPartFunc();
    var chargeDiscountPart = this.chargeDiscountPartFunc();
    var sendText = '';
    var phoneNumber = (commonHelper.validateForeignAreaCode(shopInfo.nationTelCode) || '') + ' ' + shopInfo.mobile;
    var phone = '' + (commonHelper.validateForeignAreaCode(shopInfo.nationTelCode) || '') + shopInfo.serviceMobile;

    if (type === 'WM' && way !== 'zt') {
      sendText = React.createElement(_shopDelivertyInfo2.default, { takeawayServiceProps: takeawayServiceProps });
    }

    var discountElement = React.createElement(
      'div',
      { className: 'ads-detail' },
      React.createElement(_httpsProtocolImage2.default, { className: 'ads-icon', src: shopLogo || defaultShopLogo, alt: (0, _helper.formatMessage)(_global2.default.shopIcon) }),
      React.createElement(
        'p',
        { className: 'shopname o-text-ellipsis' },
        shopInfo.commercialName || React.createElement(_formattedMessage2.default, _shop2.default.unknownShop)
      ),
      React.createElement(
        'p',
        { className: 'shopinfo' },
        sendText
      ),
      React.createElement(
        'div',
        { className: 'fieldset-outer' },
        React.createElement(
          'fieldset',
          { className: 'shopdiscount' },
          React.createElement(
            'legend',
            { className: 'shopdiscount-brief' },
            React.createElement(_formattedMessage2.default, _shop2.default.info)
          ),
          React.createElement(
            'div',
            { className: 'scrollpart' },
            React.createElement(
              'div',
              { className: 'o-flex' },
              React.createElement(_formattedMessage2.default, _shop2.default.openhour),
              '\uFF1A',
              openShopTime || React.createElement(_formattedMessage2.default, _global2.default.allDay)
            ),
            shopInfo.mobile && React.createElement(
              'div',
              { className: 'o-flex' },
              React.createElement(_formattedMessage2.default, _shop2.default.tel),
              '\uFF1A',
              React.createElement(
                'div',
                { className: 'o-flex__fluid' },
                React.createElement(
                  'a',
                  { href: 'tel:' + phoneNumber, className: 'clickphonecolor' },
                  phoneNumber
                ),
                shopInfo.serviceMobile && React.createElement(
                  'a',
                  { href: 'tel:' + phone, className: 'clickphonecolor' },
                  phone
                )
              )
            ),
            shopInfo.address && React.createElement(
              'div',
              { className: 'o-flex' },
              React.createElement(_formattedMessage2.default, _shop2.default.address),
              '\uFF1A',
              React.createElement(
                'div',
                { className: 'o-flex__fluid' },
                shopInfo.address
              )
            ),
            discountProps.validTime && React.createElement(
              'div',
              { className: 'o-flex' },
              React.createElement(_formattedMessage2.default, _shop2.default.vipPriceAvaliableTime),
              '\uFF1A',
              React.createElement(
                'div',
                { className: 'o-flex__fluid' },
                discountProps.levelName + ' ' + discountProps.validTime
              )
            )
          )
        ),
        (scrollPart && scrollPart.length !== 0 || chargeDiscountPart && chargeDiscountPart.length !== 0) && React.createElement(
          'fieldset',
          { className: 'shopdiscount' },
          React.createElement(
            'legend',
            { className: 'shopdiscount-brief' },
            React.createElement(_formattedMessage2.default, _shop2.default.privilegeInfo)
          ),
          React.createElement(
            'div',
            { className: 'scrollpart' },
            scrollPart,
            chargeDiscountPart,
            ' '
          )
        ),
        notice && notice.replace(/(\r|\n)/g, '').trim().length > 0 && React.createElement(
          'fieldset',
          { className: 'shopdiscount' },
          React.createElement(
            'legend',
            { className: 'shopdiscount-brief' },
            React.createElement(_formattedMessage2.default, _shop2.default.announcement)
          ),
          React.createElement(
            'div',
            { className: 'scrollpart noticepart' },
            notice
          )
        )
      ),
      React.createElement('div', { className: 'closedetail', onTouchTap: this.hideAllDiscount })
    );

    var setAllDiscount = this.props.setAllDiscount;

    setAllDiscount(discountElement);
  },
  hideAllDiscount: function hideAllDiscount(e) {
    e.stopPropagation();
    e.preventDefault();
    var setAllDiscount = this.props.setAllDiscount;

    setAllDiscount(null);
  },
  construntRuleName: function construntRuleName(item) {
    var consumeLimit = item.consumeLimit,
        ruleName = item.ruleName,
        dishNum = item.dishNum,
        _item$isHalfPrice = item.isHalfPrice,
        isHalfPrice = _item$isHalfPrice === undefined ? false : _item$isHalfPrice,
        _item$stackRule = item.stackRule,
        stackRule = _item$stackRule === undefined ? false : _item$stackRule;

    var currency = sessionStorage.getItem('currency');
    var isShowHalf = this.props.isShowHalf; // 只有快餐、外卖显示

    if (isHalfPrice && isShowHalf) {
      // 第二份半价活动只显示 满x份享x活动
      // globalMessages.fullDishNumRuleEvery
      // return (
      //   <span>
      //     {stackRule && <FormattedMessage {...globalMessages.fullDishNumRuleEvery} values={{ symbol: '' }} />}
      //     <FormattedMessage {...globalMessages.fullDishNumRule} values={{ symbol: '', dishNum, ruleName: ` ${ruleName}` }} />
      //   </span>
      // );
      return React.createElement(
        'span',
        null,
        ruleName
      );
    }

    // 满{currency}{consumeLimit}{ruleName}
    if (!item.dishId) {
      return React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _global2.default.fullMoneyRule, { values: { symbol: ' ', dishNum: consumeLimit, ruleName: ruleName } }));
    }
    if (item.dishNum > 1) {
      // 满{dishNum}份{ruleName}
      return React.createElement(_formattedMessage2.default, (0, _extends3.default)({}, _global2.default.fullDishNumRule, { values: { symbol: ' ', dishNum: dishNum, ruleName: ruleName } }));
    }
    return item.ruleName;
  },
  construntDishNum: function construntDishNum(item, condition) {
    var dishNum = item.dishNum;

    if (!item.dishId) {
      return '';
    }
    var str = !item.shared ? '，不与满减、单品折扣、代金券等优惠同享' : '';
    if (condition) {
      return (0, _helper.formatMessage)(_global2.default.perOrderLimitNum, { dishNum: dishNum, symbol: ',', str: str });
    }
    return (0, _helper.formatMessage)(_global2.default.perOrderLimitNum, { dishNum: dishNum, symbol: '', str: str });
  },
  scrollPartFunc: function scrollPartFunc() {
    var _this2 = this;

    var _props3 = this.props,
        marketListUpdate = _props3.marketListUpdate,
        shopInfo = _props3.shopInfo,
        multiMarketing = _props3.multiMarketing;

    var formatDishesData = shopInfo.formatDishesData;
    var infoList = marketListUpdate ? marketListUpdate.concat(multiMarketing || []) : multiMarketing || [];
    // console.log('---infoList--', infoList);
    var scrollAll = infoList.map(function (item, index) {
      if (item.dishId && !formatDishesData[item.dishId]) {
        return false;
      }
      if (item.isHalfPrice && !_this2.props.isShowHalf) {
        return null;
      } // 第二杯半价只有快餐 外卖显示
      var vip = '';
      if (item.customerType && item.customerType === 1) {
        vip = (0, _helper.formatMessage)(_global2.default.limitedVIP, { symbol: ',' });
      } else if (item.customerType && item.customerType === 2) {
        vip = (0, _helper.formatMessage)(_global2.default.limitedNotVIP, { symbol: ',' });
      } else {
        vip = '';
      }
      var openDay = commonHelper.renderDay(item.weekdays);
      var period = commonHelper.renderTime(item.periodStart, item.periodEnd);
      var condition = '';
      if (vip || openDay || period) {
        condition = '' + (vip + openDay + period);
        var length = condition.length;
        condition = (0, _helper.formatMessage)(_global2.default.conditionEnable, { condition: condition.substring(0, length - 1) });
      }
      var productName = item.applyProductType === 1 ? React.createElement(_formattedMessage2.default, _global2.default.allGoods) : React.createElement(_formattedMessage2.default, _global2.default.someGoods);
      return React.createElement(
        'p',
        {
          className: classnames('shopdiscount-item', {
            jian: item.type && item.type === 1,
            zhe: item.type && item.type === 2
          }),
          key: index
        },
        React.createElement(
          'span',
          { className: 'spanitem' },
          item.isHalfPrice ? '' : item.dishId ? formatDishesData[item.dishId].name : productName,
          item.dishId ? formatDishesData[item.dishId].spec && '(' + formatDishesData[item.dishId].spec + ')' : false,
          _this2.construntRuleName(item),
          condition || _this2.construntDishNum(item, condition) ? '\uFF08' + condition + '\n              ' + _this2.construntDishNum(item, condition) + '\uFF09' : false
        )
      );
    });
    return scrollAll;
  },

  // 更多优惠展示文案：部分商品每满1份限免x份加料
  chargeDiscountPartFunc: function chargeDiscountPartFunc() {
    var limitedMarketing = this.props.limitedMarketing;

    var type = sessionStorage.getItem('tagsType');
    // 只是堂食下的快餐才展示
    if (!type || type === 'WM') {
      return;
    }
    if (!limitedMarketing || limitedMarketing.length === 0) {
      return;
    }
    // 后端返回数组但只有一项，所有取第0个
    var limitedMarketingItem = limitedMarketing[0];
    var targetArray = limitedMarketingItem.marketRuleDtos ? limitedMarketingItem.marketRuleDtos : [];
    return targetArray && targetArray.length !== 0 && targetArray.map(function (item, index) {
      var desc = ' \u6BCF\u6EE11\u4EFD\u9650\u514D' + item.policyValue1 + '\u4EFD\u52A0\u6599 ';
      return React.createElement(
        'p',
        { key: index, className: 'shopdiscount-item mian' },
        React.createElement(
          'span',
          { className: 'spanitem' },
          React.createElement(
            'span',
            null,
            React.createElement(_formattedMessage2.default, _global2.default.someGoods)
          ),
          React.createElement(
            'span',
            null,
            desc
          )
        )
      );
    });
  },
  animatePartFunc: function animatePartFunc() {
    var _this3 = this;

    var shopInfo = this.props.shopInfo;
    var totalShowScroll = this.state.totalShowScroll;

    var formatDishesData = shopInfo.formatDishesData;
    var infoList = totalShowScroll || [];
    var animateAll = infoList.map(function (item, index) {
      if (item.dishId && !formatDishesData[item.dishId]) {
        return [];
      }
      var productName = item.applyProductType === 1 ? React.createElement(_formattedMessage2.default, _global2.default.allGoods) : React.createElement(_formattedMessage2.default, _global2.default.someGoods);
      if (item.type === -1) {
        return React.createElement(
          'div',
          { className: 'ads-column__content of', key: index },
          React.createElement('i', { className: 'icon icon-notice' }),
          React.createElement(
            'span',
            { className: 'detail o-text-ellipsis o-flex__fluid' },
            React.createElement(
              'span',
              { className: 'detail-inner o-text-ellipsis' },
              React.createElement(_formattedMessage2.default, _shop2.default.announcement),
              '\uFF1A',
              item.notice
            )
          )
        );
      } else if (item.type === -2) {
        return React.createElement(
          'div',
          { className: 'ads-column__content of', key: index },
          React.createElement('i', { className: 'icon icon-notice' }),
          React.createElement(
            'span',
            { className: 'detail o-text-ellipsis o-flex__fluid' },
            React.createElement(
              'span',
              { className: 'detail-inner o-text-ellipsis' },
              React.createElement(_formattedMessage2.default, _shop2.default.openhour),
              '\uFF1A',
              item.openShopTimeStr || React.createElement(_formattedMessage2.default, _global2.default.allDay)
            )
          )
        );
      }
      return React.createElement(
        'div',
        { className: 'ads-column__content of', key: index },
        React.createElement('i', {
          className: classnames('icon', {
            'icon-jian': item.type && item.type === 1,
            'icon-zhe': item.type && item.type === 2
          })
        }),
        React.createElement(
          'span',
          { className: 'detail o-text-ellipsis o-flex__fluid' },
          React.createElement(
            'span',
            { className: 'detail-inner o-text-ellipsis' },
            item.isHalfPrice ? '' : item.dishId ? formatDishesData[item.dishId].name : productName,
            item.dishId ? formatDishesData[item.dishId].spec && '(' + formatDishesData[item.dishId].spec + ')' : false,
            _this3.construntRuleName(item)
          )
        )
      );
    });
    return animateAll;
  },
  setSearchPage: function setSearchPage(evt) {
    var setSearchPage = this.props.setSearchPage;


    evt.preventDefault();
    evt.stopPropagation();
    setSearchPage(evt);
  },
  renderAdsMethod: function renderAdsMethod() {
    var _props4 = this.props,
        shopInfo = _props4.shopInfo,
        multiMarketing = _props4.multiMarketing,
        flodUpAppendCss = _props4.flodUpAppendCss,
        isHDL = _props4.isHDL;
    // 海底捞定制需求-将此处文案修改为 联系商家

    if (isHDL) {
      return React.createElement(
        'span',
        null,
        '\u8054\u7CFB\u5546\u5BB6',
        React.createElement('i', { className: 'btn-arrow-right' })
      );
    }

    if (flodUpAppendCss) {
      return React.createElement(
        'div',
        { className: 'ads-search', onTouchTap: this.setSearchPage },
        React.createElement('img', { src: searchLogo, className: 'ads-search__img', alt: 'search' })
      );
    }

    if (shopInfo.marketMatchDishes || multiMarketing && multiMarketing.length || shopInfo.notice) {
      return React.createElement(
        'span',
        null,
        React.createElement(_formattedMessage2.default, _shop2.default.morePrivilege),
        React.createElement('i', { className: 'btn-arrow-right' })
      );
    }

    return React.createElement(
      'span',
      null,
      React.createElement(_formattedMessage2.default, _shop2.default.info),
      React.createElement('i', { className: 'btn-arrow-right' })
    );
  },
  render: function render() {
    var animation = this.state.animation;
    var flodUpAppendCss = this.props.flodUpAppendCss;

    var animatePart = this.animatePartFunc();
    var adsMethod = this.renderAdsMethod();

    return React.createElement(
      'div',
      { className: 'ads-column-container ads-column-container__' + flodUpAppendCss },
      React.createElement(
        'div',
        { className: 'ads-column o-flex', onTouchTap: this.showAllDiscount },
        React.createElement(
          'div',
          { className: 'o-flex__fluid of ads-scroll' },
          React.createElement(
            'div',
            { className: 'ads-column__content-outer', style: animation },
            animatePart
          )
        ),
        React.createElement(
          'div',
          { className: 'o-flex__fixed o-flex ads-more' },
          adsMethod
        )
      )
    );
  }
});
module.exports = AdsColumn;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/search-black.svg";

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _button = __webpack_require__(409);

var _button2 = _interopRequireDefault(_button);

var _registerDivolte = __webpack_require__(124);

var _registerDivolte2 = _interopRequireDefault(_registerDivolte);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(2);
__webpack_require__(894);
var SearchHead = __webpack_require__(895);
var DishListItem = __webpack_require__(488);
var noSearchImg = __webpack_require__(897);
var IScroll = __webpack_require__(532);
var helper = __webpack_require__(43);

var _require = __webpack_require__(3),
    isFormalMeal = _require.isFormalMeal;

var shopId = helper.getUrlParam('shopId');
var isEqualWith = __webpack_require__(898);

var SearchDish = React.createClass({
  displayName: 'SearchDish',
  propTypes: {
    dishesData: React.PropTypes.array.isRequired,
    dishTypesData: React.PropTypes.array.isRequired,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    onImageBtnTap: React.PropTypes.func.isRequired,
    marketList: React.PropTypes.object,
    diningForm: React.PropTypes.number,
    setSearchPage: React.PropTypes.func,
    scanShow: React.PropTypes.bool,
    isHDL: React.PropTypes.bool
  },
  getInitialState: function getInitialState() {
    return {
      keyWord: '',
      searchedDataFromLocalHistory: JSON.parse(localStorage.searchedDataFromLocalHistory || '{}')
    };
  },
  componentWillMount: function componentWillMount() {
    this._cache = {};
    this.timer = null;
  },
  componentDidMount: function componentDidMount() {
    // this.setIscroll();
  },
  componentWillReceiveProps: function componentWillReceiveProps() {
    var searchedDataFromLocalHistory = this.state.searchedDataFromLocalHistory;

    var searchResult = JSON.parse(localStorage.searchedDataFromLocalHistory || '{}');
    if (!isEqualWith(searchedDataFromLocalHistory, searchResult)) {
      this.setState({ searchedDataFromLocalHistory: searchResult });
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    /*
    this.forceLazyLoadCheck();
    if (prevState.keyWord !== this.state.keyWord) { // keyWord 改变的时候重新启动Iscroll
      this.iScroll.destroy();
      // this._cache = null;
      setTimeout(() => {
        this.setIscroll();
      }, 300);
    }
    */
    if (prevState.keyWord !== this.state.keyWord) {
      // keyWord 改变的时候重新启动Iscroll
      document.querySelector('.search-content').scrollTop = 0;
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    // this.iScroll.destroy();
    // this._cache = null;
    if (!!this.timer) clearTimeout(this.timer);
  },

  /**
   * 查询内容 埋点
   */
  buryingPointSearch: function buryingPointSearch(searchContent) {
    try {
      if (!!this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        if (searchContent !== '' || searchContent !== null || searchContent !== undefined) {
          var pageType = (0, _registerDivolte.getPageTypeFromUrl)();
          _registerDivolte2.default.send('SearchContent', { pageType: pageType, searchContent: searchContent });
        }
      }, 800);
    } catch (ex) {
      console.error(ex);
    }
  },
  onDishBtnTap: function onDishBtnTap(dishData, action) {
    var _props = this.props,
        onOrderBtnTap = _props.onOrderBtnTap,
        onPropsBtnTap = _props.onPropsBtnTap;

    this.blurInput();
    if (action) {
      onOrderBtnTap(dishData, action);
    } else {
      onPropsBtnTap(dishData);
    }
  },
  onImageBtnTap: function onImageBtnTap(dish) {
    this.blurInput();
    this.props.onImageBtnTap(dish);
  },
  setIscroll: function setIscroll() {
    var _this = this;

    this._cache = {};
    var iScroll = this.iScroll = new IScroll('.search-content', {
      click: true,
      tap: true,
      probeType: 3
    });

    iScroll.on('scrollStart', function () {
      _this.blurInput();
    });

    iScroll.on('scroll', function () {
      _this.forceLazyLoadCheck();
    });

    iScroll.on('scrollEnd', function () {
      _this.forceLazyLoadCheck();
    });
  },
  getKeyWord: function getKeyWord() {
    var _this2 = this;

    var keyWord = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    setTimeout(function () {
      _this2.setState({ keyWord: keyWord });
      _this2.buryingPointSearch(keyWord);
    }, 300);
  },
  blurInput: function blurInput() {
    document.getElementsByClassName('search-input')[0].blur();
  },
  headButtonClickCallBack: function headButtonClickCallBack(evt) {
    evt.preventDefault();
    // 点击取消之后的操作
    var setSearchPage = this.props.setSearchPage;

    setSearchPage(false);
  },
  readyToSearch: function readyToSearch(evt, name) {
    evt.preventDefault();
    this.setState({ keyWord: name });
    this.refs.searchhead.refs.keyword.value = name;
    this.refs.searchhead.changeKeyWord();
    this.buryingPointSearch(name);
  },
  clearSearchedFromLocalHistory: function clearSearchedFromLocalHistory() {
    var searchedDataFromLocalHistory = JSON.parse(localStorage.searchedDataFromLocalHistory);
    delete searchedDataFromLocalHistory[shopId];
    localStorage.searchedDataFromLocalHistory = (0, _stringify2.default)(searchedDataFromLocalHistory);
    this.setState({ searchedDataFromLocalHistory: searchedDataFromLocalHistory });
  },
  deleteToSearch: function deleteToSearch(evt, name) {
    evt.preventDefault();
    evt.stopPropagation();
    var searchedDataFromLocalHistory = JSON.parse(localStorage.searchedDataFromLocalHistory);
    var sdArray = searchedDataFromLocalHistory[shopId].split(','); // 数组
    var position = sdArray.indexOf(name);
    var obj = {};

    delete sdArray[position];
    obj[shopId] = sdArray.filter(function (item) {
      return !!item;
    }).join(',');
    if (!obj[shopId]) {
      delete searchedDataFromLocalHistory[shopId];
    }

    var newObj = (0, _assign2.default)({}, searchedDataFromLocalHistory, obj[shopId] ? obj : {});
    localStorage.searchedDataFromLocalHistory = (0, _stringify2.default)(newObj);
    this.setState({ searchedDataFromLocalHistory: newObj });
  },
  getSearchedFromLocalHistory: function getSearchedFromLocalHistory() {
    var _this3 = this;

    var diningForm = this.props.diningForm;

    var historyList = (JSON.parse(localStorage.searchedDataFromLocalHistory || '{}')[shopId] || '').split(',');
    if (historyList.filter(function (item) {
      return !!item;
    }).length === 0) {
      return;
    }

    return React.createElement(
      'div',
      { className: 'hot-search-outer o-flex o-flex--column ' + (isFormalMeal(diningForm) ? 'hot-search-outer-zc' : '') },
      React.createElement(
        'div',
        { className: 'hot-search__delete o-flex__fluid' },
        React.createElement(
          'div',
          { className: 'hot-search__title o-fz--13' },
          React.createElement(_formattedMessage2.default, _global2.default.historySearch)
        ),
        (historyList || []).map(function (item, index) {
          return React.createElement(
            'p',
            { className: 'hot-search__delete__item o-flex o-fz--14', key: index, onTouchTap: function onTouchTap(e) {
                return _this3.readyToSearch(e, item);
              } },
            item,
            React.createElement('span', { className: 'hot-search__delete__icon', onTouchTap: function onTouchTap(e) {
                return _this3.deleteToSearch(e, item);
              } })
          );
        })
      ),
      React.createElement(
        'div',
        { className: 'hot-search__deleteall o-flex__fixed o-fz--14', onTouchTap: this.clearSearchedFromLocalHistory },
        React.createElement(_formattedMessage2.default, _global2.default.clearSearch)
      )
    );
  },
  formatSearchDishItem: function formatSearchDishItem() {
    var _this4 = this;

    var keyWord = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var _props2 = this.props,
        dishesData = _props2.dishesData,
        dishTypesData = _props2.dishTypesData,
        isHDL = _props2.isHDL;

    var filterDishes = [];
    var keyValue = keyWord.replace(/\s/g, '').toLocaleLowerCase();

    if (!keyValue) {
      return this.getSearchedFromLocalHistory();
    }

    // 完全匹配
    filterDishes = Array.prototype.slice.call(dishesData).filter(function (item) {
      return item.name.toLocaleLowerCase() === keyValue;
    }) || [];
    // 全匹配
    filterDishes = filterDishes.concat(dishesData.filter(function (item) {
      var nameLowerCase = item.name.toLocaleLowerCase();
      return nameLowerCase !== keyValue && nameLowerCase.indexOf(keyValue) !== -1;
    }));
    // 合并空格匹配
    filterDishes = filterDishes.concat(dishesData.filter(function (item) {
      var nameLowerCase = item.name.toLocaleLowerCase();
      return nameLowerCase !== keyValue && nameLowerCase.indexOf(keyValue) === -1 && nameLowerCase.replace(/\s/g, '').indexOf(keyValue) !== -1;
    }));
    // 模糊匹配
    filterDishes = filterDishes.concat(dishesData.filter(function (item) {
      var nameLowerCase = item.name.toLocaleLowerCase();
      var bool = nameLowerCase !== keyValue && nameLowerCase.indexOf(keyValue) === -1 && nameLowerCase.replace(/\s/g, '').indexOf(keyValue) === -1;
      var newBool = true;
      var newArray = keyValue.split('');
      newArray.forEach(function (itemt, indext) {
        if (nameLowerCase.indexOf(itemt) === -1) {
          newBool = false;
        }
      });
      return bool && newBool;
    }));

    // 对filterDishes建立索引
    var newfilterDishes = filterDishes.map(function (item, index) {
      return item.set('sort', index);
    });

    var totalDishArray = [];
    var arrayKeep = [];
    dishTypesData.forEach(function (dishTypeData, idx) {
      (dishTypeData.dishIds || []).forEach(function (dishId, i) {
        var dishData = newfilterDishes.filter(function (dish) {
          return dish.id === dishId;
        })[0] || null;
        if (!dishData || dishData.proxyDishId) {
          return false;
        }
        if (arrayKeep.indexOf(dishId) !== -1) {
          return false;
        }
        arrayKeep.push(dishId);
        var sameDishIndexs = dishData.sameDishIndexs;

        var sameRuleDishList = sameDishIndexs ? sameDishIndexs.map(function (dishIndex) {
          return dishesData[dishIndex];
        }) : null;
        totalDishArray.push({
          sort: dishData.sort,
          obj: React.createElement(
            'li',
            { className: 'dish-item-dish', key: dishData.sort },
            React.createElement(DishListItem, {
              theme: 'default',
              dishData: dishData,
              sameRuleDishList: sameRuleDishList,
              onOrderBtnTap: _this4.onDishBtnTap,
              onPropsBtnTap: _this4.onDishBtnTap,
              onImageBtnTap: _this4.onImageBtnTap,
              marketList: _this4.props.marketList,
              diningForm: _this4.props.diningForm,
              highLightName: keyWord.replace(/\s/g, ''),
              isHDL: isHDL,
              isFromSearch: true
            })
          )
        });
        return true;
      });
      return true;
    });
    return totalDishArray.sort(function (a, b) {
      return a.sort - b.sort;
    }).map(function (item, index) {
      return item.obj;
    });
  },
  forceLazyLoadCheck: function forceLazyLoadCheck() {
    var _this5 = this;

    var lazyloadCheckTimer = this._cache.lazyloadCheckTimer;

    if (lazyloadCheckTimer) {
      window.clearTimeout(lazyloadCheckTimer);
      this._cache.lazyloadCheckTimer = null;
    }
    this._cache.lazyloadCheckTimer = setTimeout(function () {
      _this5.iScroll.refresh();
    }, 200);
  },
  handleBlur: function handleBlur() {
    // this.forceLazyLoadCheck();
  },
  render: function render() {
    var _this6 = this;

    var keyWord = this.state.keyWord;

    var searchDishItem = this.formatSearchDishItem(keyWord);
    return React.createElement(
      'div',
      { className: 'search-part' },
      React.createElement(SearchHead, {
        placeholder: (0, _helper.formatMessage)(_global2.default.searchPlacehodler),
        buttonKind: {
          text: (0, _helper.formatMessage)(_button2.default.cancel),
          clickCallBack: function clickCallBack(evt) {
            return _this6.headButtonClickCallBack(evt);
          }
        },
        getKeyWord: this.getKeyWord,
        handleBlur: this.handleBlur,
        ref: 'searchhead'
      }),
      React.createElement(
        'div',
        { className: 'search-content of default' },
        searchDishItem && searchDishItem.length === 0 ? React.createElement(
          'div',
          { className: 'nosearchdata' },
          React.createElement('img', { src: noSearchImg, alt: (0, _helper.formatMessage)(_global2.default.noSearchResult), className: 'nosearchdata-img' }),
          React.createElement(_formattedMessage2.default, _global2.default.noSearchData)
        ) : React.createElement(
          'ul',
          { className: 'dish-list clearfix' },
          searchDishItem
        )
      )
    );
  }
});
module.exports = SearchDish;

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);
__webpack_require__(896);
var shallowCompare = __webpack_require__(120);

var SearchHead = React.createClass({
  displayName: 'SearchHead',
  propTypes: {
    placeholder: React.PropTypes.string,
    buttonKind: React.PropTypes.object.isRequired,
    getKeyWord: React.PropTypes.func.isRequired,
    handleBlur: React.PropTypes.func
  },
  getDefaultProps: function getDefaultProps() {
    return { placeholder: '' };
  },
  getInitialState: function getInitialState() {
    return {
      keyWord: '',
      showClearIcon: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.refs.keyword.focus();
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  },
  changeKeyWord: function changeKeyWord() {
    var _this = this;

    var getKeyWord = this.props.getKeyWord;

    var showClearIcon = !!this.refs.keyword.value;

    setTimeout(function () {
      _this.setState({ showClearIcon: showClearIcon });
    }, 300);
    getKeyWord(this.refs.keyword.value);
  },
  handleBlur: function handleBlur() {
    var handleBlur = this.props.handleBlur;

    if (handleBlur) {
      handleBlur();
    }
  },
  clearInput: function clearInput(e) {
    var _this2 = this;

    e.preventDefault();
    var getKeyWord = this.props.getKeyWord;

    this.setState({ showClearIcon: false }, function () {
      _this2.refs.keyword.value = '';
      getKeyWord('');
    });
  },
  render: function render() {
    var _props = this.props,
        placeholder = _props.placeholder,
        buttonKind = _props.buttonKind;
    var showClearIcon = this.state.showClearIcon;

    return React.createElement(
      'div',
      { className: 'search-head of' },
      React.createElement(
        'span',
        { className: 'search-button fr', onTouchTap: function onTouchTap(e) {
            return buttonKind.clickCallBack(e);
          } },
        buttonKind.text
      ),
      React.createElement(
        'div',
        { className: 'search-input-outer of' },
        React.createElement('input', {
          type: 'text',
          placeholder: placeholder,
          className: 'search-input',
          maxLength: '20',
          ref: 'keyword',
          onChange: this.changeKeyWord,
          onBlur: this.handleBlur
        }),
        showClearIcon && React.createElement('i', { className: 'clearIcon', onTouchTap: this.clearInput })
      )
    );
  }
});

module.exports = SearchHead;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/search-big.svg";

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getOwnPropertyNames = __webpack_require__(899);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isEqualWith(o1, o2) {
  var props1 = (0, _getOwnPropertyNames2.default)(o1);
  var props2 = (0, _getOwnPropertyNames2.default)(o2);
  if (props1.length != props2.length) {
    return false;
  }
  for (var i = 0, max = props1.length; i < max; i++) {
    var propName = props1[i];
    if (o1[propName] !== o2[propName]) {
      return false;
    }
  }
  return true;
}

module.exports = isEqualWith;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(900), __esModule: true };

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(901);
var $Object = __webpack_require__(1).Object;
module.exports = function getOwnPropertyNames(it) {
  return $Object.getOwnPropertyNames(it);
};


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(81)('getOwnPropertyNames', function () {
  return __webpack_require__(143).f;
});


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/head-default-new.svg";

/***/ }),
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1145);


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(1146);

var _index2 = _interopRequireDefault(_index);

var _application = __webpack_require__(1147);

var _application2 = _interopRequireDefault(_application);

var _rootApplication = __webpack_require__(250);

var _rootApplication2 = _interopRequireDefault(_rootApplication);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _rootApplication2.default)(_react2.default.createElement(_application2.default, null), _index2.default);

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _reducerHelper = __webpack_require__(458);

var _reducerHelper2 = _interopRequireDefault(_reducerHelper);

var _index = __webpack_require__(589);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Immutable = __webpack_require__(77);
var dishMenuReducer = __webpack_require__(588);
var dishHelper = __webpack_require__(43);
var updateSyncShoppingCart = __webpack_require__(547).updateSyncShoppingCart;
var combineReducers = __webpack_require__(122).combineReducers;


var reducerContainer = _reducerHelper2.default.create();

var dishMenuZcReducer = function dishMenuZcReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Immutable.from({
    callMsg: {
      info: '',
      callStatus: false
    },
    userOrderedDishList: [],
    callAble: true,
    serviceStatus: {},
    userInfo: null,
    authInfo: null,
    toastProps: null,
    notices: [],
    tableAreaInfo: {},
    guidStatus: false,
    isDataInitOver: false,
    saveOrderChangeItem: null,
    mustOrderDishList: [],
    selfChooseDishList: [],
    shopMinConsume: null
  });
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  if (reducerContainer.exist(type)) {
    return reducerContainer.getNextState(type, state, payload);
  }

  switch (type) {
    case 'SET_CALL_MSG':
      {
        return state.set('callMsg', payload || {});
      }
    case 'SET_CANCEL_CALL_MSG':
      {
        return state.set('callMsg', payload || {});
      }
    case 'SET_CAN_CALL':
      {
        return state.set('callAble', payload);
      }
    case 'SET_SERVICE_STATUS':
      {
        var serviceStatus = payload || {};
        if (!serviceStatus.peopleCount && sessionStorage.orderDinnerCartPersonCount) {
          // 之前在购物车页选择过人数，使用选择的人数
          serviceStatus.peopleCount = sessionStorage.orderDinnerCartPersonCount;
        }
        return state.set('serviceStatus', serviceStatus);
      }
    case 'SET_GUID_STATUS':
      return state.set('guidStatus', payload);

    case 'SET_USER_INFO':
      {
        return state.set('userInfo', payload);
      }
    case 'SET_AUTH_INFO':
      return state.set('authInfo', payload);
    case 'SET_TOAST_PROPS':
      return state.set('toastProps', payload);
    case 'SET_ORDER_NOTICE':
      return state.set('notice', payload);
    case 'SET_TABLE_AREA_INFO':
      return state.set('tableAreaInfo', payload);
    case 'SET_DATA_INIT_OVER':
      return state.set('isDataInitOver', payload);
    case 'CHANGE_DISH':
      return state.set('saveOrderChangeItem', payload);
    case 'REINSTATE_UNDEFINED':
      return state.set('saveOrderChangeItem', null);
    case 'CLEAR_SAVE_ORDER':
      return state.set('saveOrderChangeItem', 'clearAll');
    case 'SET_MUST_ORDER_DISH_LIST':
      {
        var must = payload.filter(function (item) {
          return item.strategyType !== 3;
        });
        var self = payload.filter(function (item) {
          return item.strategyType === 3;
        });

        return state.set('mustOrderDishList', must).set('selfChooseDishList', self);
      }
    case 'SET_SHOP_MIN_CONSUME':
      {
        return state.set('shopMinConsume', payload);
      }
    default:
      return state;
  }
};

reducerContainer.add('SYNC_SHOPPING_CART', function (state, payload) {
  return state.set('userOrderedDishList', payload);
});

reducerContainer.add('ADD_ORDER_NOTICE', function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // 设置必点菜属性
  payload.orderDishes = dishHelper.setDishListMustOrderProps(payload.orderDishes, state.mustOrderDishList.concat(state.selfChooseDishList));
  var userInfo = payload.userInfo,
      isOther = payload.isOther,
      orderDishes = payload.orderDishes,
      _payload$increment = payload.increment,
      increment = _payload$increment === undefined ? 1 : _payload$increment;

  var _orderDishes = (0, _slicedToArray3.default)(orderDishes, 1),
      dish = _orderDishes[0];

  var flag = '' + (userInfo.addOperation ? '+' : '') + increment;
  var nextState = updateSyncShoppingCart(state, payload);

  if (isOther) {
    var notice = (0, _assign2.default)({
      dishCount: dishHelper.getDishesCount([dish]),
      readed: false,
      dishName: dish.name,
      orderAction: flag
    }, payload.userInfo);
    return nextState.update('notices', function (notices) {
      return notices.concat([notice]);
    }).set('updateSyncShoppingCart', payload);
  }

  return nextState.set('updateSyncShoppingCart', payload);
});

reducerContainer.add('READ_ORDER_NOTICE', function (state, payload) {
  var updated = false;
  return state.update('notices', function () {
    var notices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return notices.flatMap(function () {
      var notice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments[1];

      var readed = notice.readed === true;
      if (!readed && !updated) {
        updated = true;
        return notice.set('readed', true);
      }
      return notice;
    });
  });
});

module.exports = combineReducers({
  dishMenuReducer: dishMenuReducer,
  dishMenuZcReducer: dishMenuZcReducer,
  common: _index2.default
});

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(62);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__(27);

var _typeof3 = _interopRequireDefault(_typeof2);

var _seamlessImmutable = __webpack_require__(77);

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

var _reactAddonsCssTransitionGroup = __webpack_require__(459);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _commonAction = __webpack_require__(434);

var _commonAction2 = _interopRequireDefault(_commonAction);

var _redux = __webpack_require__(122);

var _orderDinnerCartHelper = __webpack_require__(453);

var _preloadSkeleton = __webpack_require__(831);

var _preloadSkeleton2 = _interopRequireDefault(_preloadSkeleton);

var _dishCouponSuccess = __webpack_require__(833);

var _dishCouponSuccess2 = _interopRequireDefault(_dishCouponSuccess);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _dishDetailContainer = __webpack_require__(604);

var _dishDetailContainer2 = _interopRequireDefault(_dishDetailContainer);

var _headDefaultNew = __webpack_require__(902);

var _headDefaultNew2 = _interopRequireDefault(_headDefaultNew);

var _yidayang = __webpack_require__(745);

var _yidayang2 = _interopRequireDefault(_yidayang);

var _ordertogether = __webpack_require__(1148);

var _ordertogether2 = _interopRequireDefault(_ordertogether);

var _joinword = __webpack_require__(1149);

var _joinword2 = _interopRequireDefault(_joinword);

var _combinedword = __webpack_require__(1150);

var _combinedword2 = _interopRequireDefault(_combinedword);

var _dishHotSlide = __webpack_require__(829);

var _dishHotSlide2 = _interopRequireDefault(_dishHotSlide);

var _receiveCoupons = __webpack_require__(584);

var _receiveCoupons2 = _interopRequireDefault(_receiveCoupons);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _helper = __webpack_require__(16);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _button = __webpack_require__(409);

var _button2 = _interopRequireDefault(_button);

var _shop = __webpack_require__(477);

var _shop2 = _interopRequireDefault(_shop);

var _part = __webpack_require__(457);

var _part2 = _interopRequireDefault(_part);

var _fullscreenAd = __webpack_require__(847);

var _fullscreenAd2 = _interopRequireDefault(_fullscreenAd);

var _shoppingCart = __webpack_require__(425);

var _shoppingCart2 = _interopRequireDefault(_shoppingCart);

var _wxShareConfig = __webpack_require__(469);

var _const = __webpack_require__(14);

var _pageHelper = __webpack_require__(123);

var _pageHelper2 = _interopRequireDefault(_pageHelper);

var _aliMiniprogramHelper = __webpack_require__(126);

var _aliMiniprogramHelper2 = _interopRequireDefault(_aliMiniprogramHelper);

var _prepaidCode = __webpack_require__(554);

var _CcbAppHelper = __webpack_require__(410);

var _CcbAppHelper2 = _interopRequireDefault(_CcbAppHelper);

var _healthIcon = __webpack_require__(735);

var _healthIcon2 = _interopRequireDefault(_healthIcon);

var _selfChooseMustOrder = __webpack_require__(1151);

var _selfChooseMustOrder2 = _interopRequireDefault(_selfChooseMustOrder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(125);
__webpack_require__(850);
__webpack_require__(1152);
__webpack_require__(734);

var React = __webpack_require__(2);
var connect = __webpack_require__(115).connect;
var actions = __webpack_require__(1153);
var findDOMNode = __webpack_require__(114).findDOMNode;
var config = __webpack_require__(13);

var Loading = __webpack_require__(413);
var DishTypeScroller = __webpack_require__(851);
var DishScroller = __webpack_require__(854);
var DishGuid = __webpack_require__(869);

var DishDescPopup = __webpack_require__(731);
var QuickMenu = __webpack_require__(825);
var SearchDish = __webpack_require__(893);
var MessageDialog = __webpack_require__(479);
var DishMesthead = __webpack_require__(886);
var Toast = __webpack_require__(266);
var SyncOrderToast = __webpack_require__(636);
var BtnShortcutMulti = __webpack_require__(527);
var helper = __webpack_require__(43);
var secondsToPayhelper = __webpack_require__(605);
var isKoubei = secondsToPayhelper.getSecondsToPayParams().isKoubei; // 是否是口碑
var shopId = helper.getUrlParam('shopId');
var type = helper.getUrlParam('type');
var dishIdFromUrl = helper.getUrlParam('dishId');
var isFromTsButton = helper.getUrlParam('fromTsButton') === 'true';
var addDishStatus = helper.getUrlParam('addDishes');
var classnames = __webpack_require__(50);
var dishCart4DinnerUrl = config.dishCart4DinnerURL + '?type=' + type + '&shopId=' + shopId;
var dishCart4DinnerUrlPayFirst = config.dishCart4DinnerPayFirst + '?type=' + type + '&shopId=' + shopId;
var includeAlipayJSApi = __webpack_require__(3).includeAlipayJSApi;
var isAlipayMiniProgramBrowser = __webpack_require__(3).isAlipayMiniProgramBrowser;
var doClearSocketShoppingCart = __webpack_require__(453).doClearSocketShoppingCart;
var DinnerSocketHelper = __webpack_require__(640);
var callWxClientMethod = __webpack_require__(444).callWxClientMethod;
var commonHelper = __webpack_require__(3);

var isWeiXinBrowser = commonHelper.getWeixinVersionInfo().weixin; // 判断是否微信浏览器
var isAlipayBrowser = commonHelper.isAlipayBrowser(); // 判断是否支付宝浏览器
var isWeiXinMiniBrowser = commonHelper.isWechatMiniProgramBrowser();


var DishMenuZcApplication = React.createClass({
  displayName: 'DishMenuZcApplication',
  propTypes: {
    // MapedActionsToProps
    fetchMenuData: React.PropTypes.func.isRequired,
    fetchSoldDishList: React.PropTypes.func.isRequired,
    fetchTableInfo: React.PropTypes.func.isRequired,
    activeDishType: React.PropTypes.func.isRequired,
    orderDish: React.PropTypes.func.isRequired,
    toggleDishDetailPopup: React.PropTypes.func.isRequired,
    toggleDishDescPopup: React.PropTypes.func.isRequired,
    fetchOrderDiscountInfo: React.PropTypes.func.isRequired,
    fetchDishMarketInfos: React.PropTypes.func.isRequired,
    clearErrorMsg: React.PropTypes.func.isRequired,
    showErrMsgFunc: React.PropTypes.func.isRequired,
    getMarketCoupons: React.PropTypes.func.isRequired,
    fetchUserInfo: React.PropTypes.func.isRequired,
    fetchWXAuthInfo: React.PropTypes.func.isRequired,
    closeInfoWindow: React.PropTypes.func.isRequired,
    fetchTableIdFromNewVersionQRCode: React.PropTypes.func,
    syncShoppingCart: React.PropTypes.func.isRequired,
    addOrderNotice: React.PropTypes.func.isRequired,
    readOrderNotice: React.PropTypes.func.isRequired,
    removeAllOrders: React.PropTypes.func.isRequired,
    reinstateUndefined: React.PropTypes.func.isRequired,
    setToastProps: React.PropTypes.func.isRequired,
    saveTableInfoFromUrl: React.PropTypes.func,
    errorMessage: React.PropTypes.string,
    fetchServiceStatusNoTable: React.PropTypes.func.isRequired,
    cancelCallMsg: React.PropTypes.func.isRequired,
    updateCanCall: React.PropTypes.func,
    fetchShopInfo: React.PropTypes.func,
    setPageLoadedStatus: React.PropTypes.func,
    dataInitIsOver: React.PropTypes.func,
    setErrorMsg: React.PropTypes.func,
    // MapedStatesToProps
    dishDescData: React.PropTypes.object,
    dishMenuZcReducer: React.PropTypes.object.isRequired,
    dishMenuReducer: React.PropTypes.object.isRequired,
    callBell: React.PropTypes.func.isRequired,
    clearBell: React.PropTypes.func.isRequired,
    // fetchTableId: React.PropTypes.func.isRequired,
    dishesDataDuplicate: React.PropTypes.array,
    dishDetailData: React.PropTypes.object,
    openTimeList: React.PropTypes.array,
    normalDiscountProps: React.PropTypes.object,
    dishPageTpl: React.PropTypes.string,
    getCoupontoGuid: React.PropTypes.func,
    guidStatus: React.PropTypes.bool,
    // saveTableParam
    saveTableParam: React.PropTypes.func.isRequired,
    userOrderedDishList: React.PropTypes.object,
    common: React.PropTypes.object,
    shopMinConsume: React.PropTypes.object,
    getMinConsumeConf: React.PropTypes.func
  },
  childContextTypes: {
    brandType: React.PropTypes.string
  },
  getChildContext: function getChildContext() {
    var _props$common = this.props.common,
        common = _props$common === undefined ? {} : _props$common;
    var _common$brandInfo = common.brandInfo,
        brandInfo = _common$brandInfo === undefined ? {} : _common$brandInfo;

    return { brandType: brandInfo.brandType };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      dishMenuReducer: {
        dishPageTpl: 'default',
        allDiscount: null // 设置弹出层
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      isMinMesthead: false,
      isChildrenShow: false,
      animationBottom: 0,
      animationItem: [],
      loadingInfo: null,
      isShowSearch: false,
      showDishCouponSuccess: true,
      showFixedCoupon: true, // 默认领券弹出层
      showHotSpan: false,
      showCouponList: false,
      isSync: false, // 是否是协同点餐
      isShowAlreadyGotCoupon: false,
      dishIdForStatistics: dishIdFromUrl, // 埋点统计是否为推荐菜进入商品详情页
      isShowOpenStatus: true, // 是否展示已打烊对话框
      autoAddedMustOrderDishes: null,
      showSelfChoose: false,
      isShowLoginExceptionDialog: false, // 建行登录异常模态框显示与否
      showLoginExceptionDesc: '登录异常，不可点餐' // 建行登录异常模态框显示与否
    };
  },

  flyQueue: [],
  flyFree: true,
  syncCartUnavailable: false, // 协同购物车不可用
  componentWillMount: function componentWillMount() {
    var _this = this;

    // 每次进入页面清除协同购物车不可用标识
    window.sessionStorage && window.sessionStorage.removeItem(_const.SYNC_CART_UNAVAILABLE);
    this.canSlip = true;
    this.canFoldup = false;
    this.scrollTimeout = null;
    this.getShoppingCartInterval = null;
    var _props = this.props,
        toggleDishDescPopup = _props.toggleDishDescPopup,
        setErrorMsg = _props.setErrorMsg;

    commonHelper.getCommericalInfo(setErrorMsg, function () {
      var commericalInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!commericalInfo.enablePortalStore) {
        setErrorMsg({
          text: (0, _helper.formatMessage)(_errorMessage2.default.notMobileStore),
          timeout: -1
        });
      }
    });

    if (isKoubei) {
      // 口碑保存在 sessionStorage 里面, 不是口碑就不保存
      sessionStorage.isKoubei = true;
    }

    if (isAlipayBrowser) {
      includeAlipayJSApi(function () {});
    }

    window.addEventListener('hashchange', function () {
      var hash = location.hash;
      if (hash === '') {
        _this.setHotViewAccordingToHash();
        toggleDishDescPopup();
      }

      if (hash && hash !== '#hot-dish' && hash !== '#dish-desc') {
        _this.setHotViewAccordingToHash();
      }

      if (hash && hash !== '#dish-desc' && hash === '#hot-dish') {
        toggleDishDescPopup();
      }
    });

    this._cache = {};
  },
  componentDidMount: function componentDidMount() {
    var _this2 = this;

    sessionStorage.removeItem('tagsType');
    var _props2 = this.props,
        fetchMenuData = _props2.fetchMenuData,
        fetchSoldDishList = _props2.fetchSoldDishList,
        fetchOrderDiscountInfo = _props2.fetchOrderDiscountInfo,
        fetchDishMarketInfos = _props2.fetchDishMarketInfos,
        saveTableInfoFromUrl = _props2.saveTableInfoFromUrl,
        fetchUserInfo = _props2.fetchUserInfo,
        fetchTableInfo = _props2.fetchTableInfo,
        fetchShopInfo = _props2.fetchShopInfo,
        setPageLoadedStatus = _props2.setPageLoadedStatus,
        dataInitIsOver = _props2.dataInitIsOver,
        fetchMustOrderMenu = _props2.fetchMustOrderMenu,
        getMinConsumeConf = _props2.getMinConsumeConf;

    // 获取未支付订单信息

    var tableInfo = (0, _orderDinnerCartHelper.getTableInfoInSessionStorage)(shopId);
    var tableId = helper.getUrlParam('tableId') || tableInfo.tableId;
    var tableKey = helper.getUrlParam('tableKey') || tableInfo.tableKey;
    var orderId = helper.getUrlParam('orderId');
    var ownerId = helper.getUrlParam('ownerId') || tableInfo.ownerId;
    var addDishes = helper.getUrlParam('addDishes');
    var isPayFirst = sessionStorage.getItem('diningForm') === '2';
    var isScanCodeFromPage = sessionStorage.getItem('isScanCodeFromConf') === 'true'; // 如果是客户配置了url参数为&scan=true
    // 判断是否是扫码点餐 如果是扫码点餐需要在本地写入localStorage
    if ((tableId || tableKey || isScanCodeFromPage) && !addDishes) {
      sessionStorage.isScanCode = true;
    }

    var saveTableInfo = function saveTableInfo() {
      return saveTableInfoFromUrl({ tableId: tableId, tableKey: tableKey, orderId: orderId, ownerId: ownerId }).then(function (res) {
        if (!res || (typeof res === 'undefined' ? 'undefined' : (0, _typeof3.default)(res)) !== 'object') {
          return;
        }
        var _res$serviceStatus = res.serviceStatus,
            serviceStatus = _res$serviceStatus === undefined ? {} : _res$serviceStatus,
            ifJumpToDishMenu = res.ifJumpToDishMenu;

        if (ifJumpToDishMenu) {
          throw new Error('跳转阻塞');
        }
        var isOneTableOneBill = serviceStatus.tableWay === 'oneTableOneBill';

        if (serviceStatus.tableId || serviceStatus.orderId) {
          _this2.setLoadingInfo({
            ing: true,
            text: (0, _helper.formatMessage)(_errorMessage2.default.connectingCollCart)
          });
        }
        if (isOneTableOneBill) {
          (0, _orderDinnerCartHelper.overWriteSessionStorage)(shopId, {
            tableId: serviceStatus.tableId,
            tableKey: serviceStatus.tableKey,
            orderId: serviceStatus.orderId
          });
        } else {
          (0, _orderDinnerCartHelper.overWriteSessionStorage)(shopId, {
            tableId: serviceStatus.tableId,
            tableKey: serviceStatus.tableKey
          });
        }

        // 订单未确认状态下进行操作（一桌一单有orderId的情况下）
        // 正餐先付不跳转
        if (sessionStorage.getItem('jupmOrder') !== 'uncheckOrder' && !isPayFirst) {
          if (serviceStatus.orderId && serviceStatus.orderId > 0 && !addDishes && isOneTableOneBill) {
            // 标识跳转到订单未结算页面
            sessionStorage.setItem('jupmOrder', 'dishMenu');
            location.href = config.tradeDetailUncheckURL + '?orderId=' + serviceStatus.orderId + '&type=' + type + '&shopId=' + shopId;
            throw new Error('跳转阻塞');
          }
        }
        var tableInfoFromSession = (0, _orderDinnerCartHelper.getTableInfoInSessionStorage)(shopId);
        var tableIdFromSession = tableInfoFromSession.tableId;
        var tableKeyFromSession = tableInfoFromSession.tableKey;

        fetchUserInfo(serviceStatus.memberVO);

        if (addDishStatus) {
          // 在加菜模式下不会刷新 scanTableType
          return;
        }
        /* 因为操作中会刷新页面 所以不能清除 scanTableType && oriScanTableType */
        if (!sessionStorage.oriScanTableType) {
          sessionStorage.removeItem('scanTableType');
        }

        if (tableIdFromSession || tableKeyFromSession) {
          fetchTableInfo(tableInfoFromSession);
          /* 新的 scanTableType = 1 老的 scanTableType = 2 */
          if (tableIdFromSession) {
            sessionStorage.scanTableType = sessionStorage.oriScanTableType || 2;
          } else if (tableKeyFromSession) {
            sessionStorage.scanTableType = 1;
          }
        }
      });
    };

    // 建行App环境下，无感登录逻辑
    this.outComeInAndLoginLogic();

    _promise2.default.all([fetchShopInfo(tableId, tableKey), getMinConsumeConf()]).then(fetchMenuData).then(fetchMustOrderMenu).then(fetchSoldDishList).then(saveTableInfo).then(function () {
      setPageLoadedStatus(true);
    }).then(fetchDishMarketInfos).then(function (discountRule) {
      return fetchOrderDiscountInfo(discountRule);
    }).then(function () {
      var _props$dishMenuZcRedu = _this2.props.dishMenuZcReducer,
          _props$dishMenuZcRedu2 = _props$dishMenuZcRedu.serviceStatus,
          serviceStatus = _props$dishMenuZcRedu2 === undefined ? {} : _props$dishMenuZcRedu2,
          userInfo = _props$dishMenuZcRedu.userInfo;
      var _props$dishMenuReduce = _this2.props.dishMenuReducer,
          enableSyncShoppingCart = _props$dishMenuReduce.enableSyncShoppingCart,
          _props$dishMenuReduce2 = _props$dishMenuReduce.shopInfo,
          shopInfo = _props$dishMenuReduce2 === undefined ? {} : _props$dishMenuReduce2; // 是否开启了协同购物车

      var curTableId = serviceStatus.tableId,
          curOrderId = serviceStatus.orderId;


      _this2.setState({ isSync: !!(curTableId || curOrderId) });
      if ((curTableId || curOrderId) && userInfo && enableSyncShoppingCart !== 0) {
        _this2.getShoppingCartInterval = setInterval(function () {
          if (_this2.syncCartUnavailable) {
            clearInterval(_this2.getShoppingCartInterval);
            _this2.initDishList();
          } else if (_this2._dinnerSocket && _this2._dinnerSocket.socket.connected) {
            _this2.props.removeAllOrders(); // 连上协同购物车再清除本地点过的菜记录
            _this2._dinnerSocket.getShoppingCartEventInCart(function (userOrderedDishList, shoppingCartResult) {
              _this2.setLoadingInfo(null);
              setTimeout(function () {
                _this2.syncShoppingCart({ userOrderedDishList: userOrderedDishList, userInfo: _this2._userInfo }, function () {
                  dataInitIsOver(true);
                  _this2.mustOrderDishInit();
                  _this2.syncLocalStorageDishes();
                });
              }, 200);
            }, function () {
              _this2.setLoadingInfo({
                ing: true,
                text: (0, _helper.formatMessage)(_errorMessage2.default.connecting)
              });
            });
            clearInterval(_this2.getShoppingCartInterval);
          }
        }, 1500);
      } else {
        _this2.initDishList();
      }

      // this.scrollTimeout = setTimeout(() => {
      //   this.scrollToTop();
      // }, 1000);

      if (!shopInfo.isOldMarketing && shopInfo.couponList && shopInfo.couponList.length > 0 || // 新逻辑
      shopInfo.isOldMarketing && shopInfo.marketCoupon && shopInfo.marketCoupon.coupId // 旧逻辑
      ) {
          _this2.setState({ showCouponList: true });
        }
    }).catch(function (err) {
      console.log(err.message);
    });

    if (this.props.fetchBrandInfo) {
      this.props.fetchBrandInfo();
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _props$dishMenuZcRedu3 = this.props.dishMenuZcReducer,
        _props$dishMenuZcRedu4 = _props$dishMenuZcRedu3.serviceStatus,
        serviceStatus = _props$dishMenuZcRedu4 === undefined ? {} : _props$dishMenuZcRedu4,
        userInfo = _props$dishMenuZcRedu3.userInfo;
    var newUserInfo = nextProps.dishMenuZcReducer.userInfo;
    var _props$dishMenuReduce3 = this.props.dishMenuReducer,
        load = _props$dishMenuReduce3.load,
        loadShopStatus = _props$dishMenuReduce3.loadShopStatus,
        enableSyncShoppingCart = _props$dishMenuReduce3.enableSyncShoppingCart;
    var _nextProps$dishMenuRe = nextProps.dishMenuReducer,
        loadNew = _nextProps$dishMenuRe.load,
        loadShopStatusNew = _nextProps$dishMenuRe.loadShopStatus,
        dishesDataDuplicate = _nextProps$dishMenuRe.dishesDataDuplicate;
    var removeAllOrders = this.props.removeAllOrders;


    if (load !== loadNew) {
      this.setLoadingInfo({ ing: loadNew.status, text: loadNew.text });
    }

    if (dishIdFromUrl && dishesDataDuplicate && dishesDataDuplicate.length) {
      var dishData = dishesDataDuplicate.find(function (item) {
        return item.id === dishIdFromUrl;
      });
      if (dishData) {
        location.hash = '#dish-desc';
        this.props.toggleDishDescPopup(dishData);
        dishIdFromUrl = -1;
      }
    }

    if (userInfo !== newUserInfo && (serviceStatus.tableId || serviceStatus.orderId)) {
      var tableInfo = (0, _orderDinnerCartHelper.getTableInfoInSessionStorage)(shopId);
      var curTableId = serviceStatus.tableId;
      var curOrderId = serviceStatus.orderId;
      var curOwnerId = tableInfo.ownerId;
      if ((curTableId || curOrderId) && enableSyncShoppingCart !== 0) {
        this.dishesLocalStorage = helper.getDishesLocalStorage({
          shopId: shopId,
          type: helper.getUrlParam('type')
        }) || {};
        // 清除本地点过的菜记录
        // removeAllOrders();
        this.initDinnerSocketHelper(newUserInfo, curTableId, curOrderId, curOwnerId);
        return;
      }
    }

    if (loadShopStatus !== loadShopStatusNew && loadShopStatusNew) {
      // 表示已经请求了orderPageInfo接口
      var orderPageTitle = nextProps.dishMenuReducer.orderPageTitle;

      document.title = orderPageTitle || (0, _helper.formatMessage)(_global2.default.mealOrder);
      this.title = document.title;
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    var el = findDOMNode(this);

    (0, _wxShareConfig.initWXShareEventWithConfig)({ entry: _const.WxSharEventEntry.SHOP, _this: this });

    if (this._cache.mesthead) {
      return;
    }

    this._cache = {
      mesthead: el.querySelector('.dish-mesthead'),
      scrollerWrap: el.querySelector('.scroller-wrap'),
      shortcutOperator: el.querySelector('.shortcut-operate'),
      lastSourceTapRect: null
    };
  },
  initDishList: function initDishList() {
    var dataInitIsOver = this.props.dataInitIsOver;


    this.setLoadingInfo(null);
    dataInitIsOver(true);
    this.mustOrderDishInit();
  },

  // 同步之前存在localStorage中的菜列表
  syncLocalStorageDishes: function syncLocalStorageDishes() {
    var _this3 = this;

    var _ref = this.dishesLocalStorage || {},
        _ref$dishes = _ref.dishes,
        dishes = _ref$dishes === undefined ? [] : _ref$dishes;

    if (!dishes.length) {
      return;
    }

    var orderedDishes = helper.divideOrderedDishes(dishes);
    orderedDishes.forEach(function (dishData) {
      var increment = helper.getDishesCount([dishData]);
      _this3._dinnerSocket.addOrMinusDishEvent(dishData, increment);
    });

    this.dishesLocalStorage = {};
    helper.clearDishesLocalStorage();
  },
  outComeInAndLoginLogic: function outComeInAndLoginLogic() {
    var _this4 = this;

    var isCcbEvn = _CcbAppHelper2.default.isCcbEvn();
    if (!isCcbEvn) return _promise2.default.resolve();

    var ccbParamSJ = helper.getUrlParam('ccbParamSJ'); // 建行传入参数
    var errMsg = (0, _helper.formatMessage)(_global2.default.urlLostInfo);
    _CcbAppHelper2.default.getUserIndividual({ shopId: shopId, ccbParamSJ: ccbParamSJ, errMsg: errMsg }).then().catch(function (ex) {
      if (typeof ex === 'string') {
        _this4.setState({ showLoginExceptionDesc: ex });
      }
      _this4.setState({ isShowLoginExceptionDialog: true });
    });

    // return fetch(`${config.individualAPI}?shopId=${shopId}`, config.requestOptions)
    //   .then((res = {}) => {
    //     console.log('---res', res);
    //     if (!res.ok) {
    //       if (!ccbParamSJ) {
    //         throw formatMessage(globalMessages.urlLostInfo);
    //       }
    //       return ccbAppHelper
    //         .getUserInfo(ccbParamSJ)
    //         .then(userInfo => {
    //           return ccbAppHelper.login({ shopId, mobile: userInfo.mobile || '' });
    //         })
    //         .catch(ex => {
    //           throw ex;
    //         });
    //     }
    //   })
    //   .catch(ex => {
    //     console.error(ex);
    //     if (typeof ex === 'string') {
    //       this.setState({ showLoginExceptionDesc: ex });
    //     }
    //     this.setState({ isShowLoginExceptionDialog: true });
    //   });
  },
  getNeedAutoAddDishes: function getNeedAutoAddDishes() {
    var _props$dishMenuZcRedu5 = this.props.dishMenuZcReducer,
        serviceStatus = _props$dishMenuZcRedu5.serviceStatus,
        userOrderedDishList = _props$dishMenuZcRedu5.userOrderedDishList,
        mustOrderDishList = _props$dishMenuZcRedu5.mustOrderDishList;
    var _props$dishMenuReduce4 = this.props.dishMenuReducer,
        _props$dishMenuReduce5 = _props$dishMenuReduce4.shopInfo,
        shopInfo = _props$dishMenuReduce5 === undefined ? {} : _props$dishMenuReduce5,
        dishesDataDuplicate = _props$dishMenuReduce4.dishesDataDuplicate;
    var curTableId = serviceStatus.tableId,
        curOrderId = serviceStatus.orderId;
    // 未连上协同购物前点的菜列表

    var _ref2 = this.dishesLocalStorage || {},
        _ref2$dishes = _ref2.dishes,
        localDishes = _ref2$dishes === undefined ? [] : _ref2$dishes;

    // 开启必点菜 & 有桌台ID & 么有订单号 才返回需自动加入的必点菜列表


    if (shopInfo.enableOpenDish && curTableId && !curOrderId) {
      var orderedDishes = this.getCurrentOrderedDishes(userOrderedDishList, dishesDataDuplicate).concat(localDishes);
      var orderedDishesIdMap = orderedDishes.reduce(function (t, c) {
        t[c.brandDishId] = 1;
        return t;
      }, {});
      var needAutoAddDishes = mustOrderDishList.filter(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return !orderedDishesIdMap[item.brandDishId];
      });

      return needAutoAddDishes;
    }

    return [];
  },
  mustOrderDishInit: function mustOrderDishInit() {
    var _props$dishMenuZcRedu6 = this.props.dishMenuZcReducer,
        selfChooseDishList = _props$dishMenuZcRedu6.selfChooseDishList,
        serviceStatus = _props$dishMenuZcRedu6.serviceStatus;
    var _props$dishMenuReduce6 = this.props.dishMenuReducer.shopInfo,
        shopInfo = _props$dishMenuReduce6 === undefined ? {} : _props$dishMenuReduce6;
    var curTableId = serviceStatus.tableId,
        curOrderId = serviceStatus.orderId,
        peopleCount = serviceStatus.peopleCount;

    var needAutoAddDishes = this.getNeedAutoAddDishes();

    // 必点菜需要人数
    if (needAutoAddDishes.length && !peopleCount) {
      location.href = config.dishMenu4DinnerChoosePeopleURL + '?shopId=' + shopId + '&tableId=' + curTableId + '&returnUrl=' + encodeURIComponent(location.href);
      return;
    }

    // 开启开台必点&有桌台号&没有订单号&有开台自选菜
    if (shopInfo.enableOpenDish && curTableId && !curOrderId && selfChooseDishList.length) {
      this.setState({ showSelfChoose: true });
    } else if (needAutoAddDishes.length) {
      this.autoAddMustOrderDishes(needAutoAddDishes);
    }
  },
  handleConfirmSelfChoose: function handleConfirmSelfChoose() {
    var needAutoAddDishes = this.getNeedAutoAddDishes();

    this.setState({ showSelfChoose: false });
    if (needAutoAddDishes.length) {
      this.autoAddMustOrderDishes(needAutoAddDishes);
    }
  },
  autoAddMustOrderDishes: function autoAddMustOrderDishes(needAutoAddDishes) {
    var _this5 = this;

    var _props$dishMenuZcRedu7 = this.props.dishMenuZcReducer.serviceStatus,
        serviceStatus = _props$dishMenuZcRedu7 === undefined ? {} : _props$dishMenuZcRedu7;
    var peopleCount = serviceStatus.peopleCount;

    var addRecords = [];

    needAutoAddDishes.forEach(function (item) {
      var strategyType = item.strategyType,
          strategyValue = item.strategyValue,
          dishIncreaseUnit = item.dishIncreaseUnit,
          stepNum = item.stepNum,
          clearStatus = item.clearStatus;

      var isNormalDish = stepNum === 1;
      // 1 为按桌台，2为按人数
      var count = strategyType === 1 ? Math.max(strategyValue, dishIncreaseUnit) : strategyType === 2 ? isNormalDish ? Math.max(strategyValue * peopleCount, dishIncreaseUnit) : dishIncreaseUnit : 0;
      // 必点且未估清
      if (!count || clearStatus) {
        return;
      }
      var dish = item.asMutable({ deep: true });
      // 必点菜没有套餐
      // 初始化选中的数量以及属性
      // 属性默认选第一个
      if (helper.isSingleDishWithoutProps(dish)) {
        dish.order = count;
      } else {
        dish.order = [{
          count: count,
          dishPropertyTypeInfos: dish.dishPropertyTypeInfos,
          dishIngredientInfos: dish.dishIngredientInfos
        }];

        if (dish.dishIngredientInfos.length) {
          dish.order[0].dishIngredientInfos[0].isChecked = true;
        }

        if (dish.dishPropertyTypeInfos.length) {
          dish.order[0].dishPropertyTypeInfos.forEach(function (typeInfo) {
            // 是否有默认做法
            var hasDefaultChecked = typeInfo.properties.find(function (prop) {
              return prop.isChecked;
            });
            if (typeInfo.type === _const.DishPropertyTypes.REMARK || typeInfo.type === _const.DishPropertyTypes.CUSTOMLABEL || hasDefaultChecked) {
              return;
            }

            typeInfo.properties[0].isChecked = true;
          });
        }
      }

      addRecords.push({
        name: dish.name,
        count: count,
        unitName: dish.unitName,
        brandDishId: dish.brandDishId
      });

      _this5.handleOrderDishChange(_seamlessImmutable2.default.from(dish), count);
    });

    // 添加后显示提示，直到下次加菜
    if (addRecords.length > 0) {
      this.setState({
        autoAddedMustOrderDishes: addRecords
      });
    }
  },
  onDishDetailAddBtnTap: function onDishDetailAddBtnTap(dishData, dishCount) {
    var _this6 = this;

    var toggleDishDetailPopup = this.props.toggleDishDetailPopup;
    var lastSourceTapRect = this._cache.lastSourceTapRect;

    toggleDishDetailPopup();
    if (lastSourceTapRect) {
      this.setState({ dropInShoping: false }, function () {
        _this6.startBallFlyQueue(lastSourceTapRect);
      });
    }
    this.handleOrderDishChange(dishData, dishCount);
  },
  onShoppingCartRelativeBtnClick: function onShoppingCartRelativeBtnClick() {
    var _props$dishMenuReduce7 = this.props.dishMenuReducer.shopInfo,
        shopInfo = _props$dishMenuReduce7 === undefined ? {} : _props$dishMenuReduce7;

    var noBuyWeixinMini = !shopInfo.enableWeixinMini && !!isWeiXinMiniBrowser;
    if (noBuyWeixinMini) return false;
    var status = this.getLoginStatus();
    if (!status.isLogin && status.isSync) {
      this.showLoginPopup();
      return false;
    }

    return true;
  },
  onDishTouchTap: function onDishTouchTap(event) {
    var _this7 = this;

    var status = this.getLoginStatus();
    if (!status.isLogin && status.isSync) {
      return;
    }

    var target = event.target;

    if (target.parentNode.className === 'counter') {
      this._cache.lastSourceTapRect = target.getBoundingClientRect();
      return;
    }

    if (target.className.indexOf('counter-click-mask') === -1 || target.parentNode.className.indexOf('counter-add') === -1) {
      return;
    }

    var rect = target.getBoundingClientRect();
    this.setState({ dropInShoping: false }, function () {
      setTimeout(function () {
        _this7.startBallFlyQueue(rect);
      }, 0);
    });
  },
  getCurrentOrderedDishes: function getCurrentOrderedDishes(userOrderedDishList, dishesDataDuplicate) {
    if (!userOrderedDishList || !userOrderedDishList.length) {
      return helper.getOrderedDishes(dishesDataDuplicate);
    }

    var orderedDishes = [];
    userOrderedDishList.forEach(function (item) {
      [].push.apply(orderedDishes, item.dishList);
    });
    return orderedDishes;
  },
  setScrollTop: function setScrollTop(scrollTop) {
    var dishScrollerMain = document.querySelector('.dish-scroller-main');
    if (!dishScrollerMain) {
      return;
    }

    if (scrollTop < 0 && this.canSlip) {
      this.canSlip = false;
      this.canFoldup = true;

      this.methodAfterSlip();
      if (dishScrollerMain.scrollTop <= 0) {
        dishScrollerMain.scrollTop = 1;
      }
    } else if (scrollTop >= 0 && this.canFoldup) {
      this.canFoldup = false;
      this.canSlip = true;

      this.methodAfterFoldUp();
    }
  },


  // scrollToTop() {
  //   this.setScrollTop(-1);
  // },
  getBtnDisable: function getBtnDisable(serviceStatus) {
    var btnDisableArray = [];
    if (!serviceStatus.enablePay) {
      btnDisableArray.push(3);
    }

    if (!serviceStatus.enableOrder) {
      btnDisableArray.push(4);
    }
    return btnDisableArray;
  },
  getLoginStatus: function getLoginStatus() {
    var userInfo = this.props.dishMenuZcReducer.userInfo;
    var isSync = this.state.isSync;


    return {
      isLogin: !!userInfo,
      isSync: isSync
    };
  },
  setTrunToDetailPage: function setTrunToDetailPage() {
    var serviceStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!serviceStatus.enableTableMultiUse && serviceStatus.enableAddDish && !sessionStorage.getItem('isFirstDish') && serviceStatus.enableOrder) {
      location.href = config.tradeDetailUncheckURL + '?shopId=' + shopId + '&orderId=' + serviceStatus.orderId;
      sessionStorage.setItem('isFirstDish', true);
    }
  },
  getDishTypeInfo: function getDishTypeInfo(dishTypeId) {
    var _props$dishMenuReduce8 = this.props.dishMenuReducer.dishTypesData,
        dishTypesData = _props$dishMenuReduce8 === undefined ? [] : _props$dishMenuReduce8;


    for (var i = 0, len = dishTypesData.length; i < len; i++) {
      var cur = dishTypesData[i];
      if (cur.id === dishTypeId) {
        return (0, _assign2.default)({ order: i }, cur);
      }
    }

    return null;
  },
  setLoadingInfo: function setLoadingInfo(info) {
    this.setState({ loadingInfo: info });
  },
  getSameRuleDishList: function getSameRuleDishList(dish, dishList) {
    var _dish$sameDishIndexs = dish.sameDishIndexs,
        sameDishIndexs = _dish$sameDishIndexs === undefined ? [] : _dish$sameDishIndexs;

    return sameDishIndexs.map(function (dishIndex) {
      return dishList[dishIndex];
    });
  },
  setSearchPage: function setSearchPage(isShowSearch) {
    if (isShowSearch) {
      document.title = (0, _helper.formatMessage)(_global2.default.search);
    } else {
      document.title = this.title;
    }
    this.setState({ isShowSearch: isShowSearch });
  },
  setAllDiscount: function setAllDiscount(allDiscount) {
    this.setState({ allDiscount: allDiscount });
  },
  startBallFlyQueue: function startBallFlyQueue(start) {
    var common = this.props.common;

    if (common && common.brandInfo && common.brandInfo.brandId === '77299') {
      this.setState({ dropInShoping: true });
      return;
    }
    if (start) {
      var length = this.flyQueue.length;
      if (length < 1) {
        this.flyQueue.push(start);
      }
      // else if (length === 2) {
      //   this.flyQueue[1] = start;
      // }
    }
    // this.ballFlyOutQueue();
  },
  ballFlyOutQueue: function ballFlyOutQueue() {
    if (this.flyFree && this.flyQueue.length > 0) {
      this.flyFree = false;
      this.startBallFly(this.flyQueue.shift());
    }
  },
  startBallFly: function startBallFly(start) {
    var _this8 = this;

    this.setState({ dropInShoping: false });
    var bottom = this._cache.shortcutOperator.offsetTop + 30;
    helper.ballFlyWhenOrderDish({
      speed: 2.8,
      start: {
        left: start.left - 10,
        top: start.top - 10
      },
      end: {
        left: window.innerWidth / 2,
        top: bottom
      },
      className: 'ball',
      onEnd: function onEnd() {
        _this8.flyFree = true;
        _this8.setState({ dropInShoping: true });
        _this8.ballFlyOutQueue();
      }
    });
  },
  getRealIncrementAndFromUser: function getRealIncrementAndFromUser(dish, increment) {
    // 非单菜的话，点餐页只能加不能减，不需要修正
    if (!helper.isSingleDishWithoutProps(dish)) {
      return {
        increment: increment,
        userInfo: null
      };
    }

    // 拿到菜品数据，返回正确的变动数量，以及菜品所在的用户信息
    var _props$dishMenuZcRedu8 = this.props.dishMenuZcReducer,
        userOrderedDishList = _props$dishMenuZcRedu8.userOrderedDishList,
        userInfo = _props$dishMenuZcRedu8.userInfo;
    var _props$dishMenuReduce9 = this.props.dishMenuReducer.dishesDataDuplicate,
        dishesDataDuplicate = _props$dishMenuReduce9 === undefined ? [] : _props$dishMenuReduce9;


    var orderedDish = null;
    var user = null;
    // 协同点餐
    if (userOrderedDishList && userOrderedDishList.length) {
      // 先找自己有没有点这个菜
      var currentUser = userOrderedDishList.find(function (item) {
        return item.userInfo.userId === userInfo.customerId;
      });
      var currentUserOrderedDish = currentUser && currentUser.dishList ? currentUser.dishList.find(function (item) {
        return item.id === dish.id;
      }) : null;

      if (currentUserOrderedDish) {
        orderedDish = currentUserOrderedDish;
      } else {
        var userX = userOrderedDishList.find(function (item) {
          return (item.dishList || []).find(function (itemDish) {
            if (itemDish.id === dish.id) {
              orderedDish = itemDish;
              return true;
            }

            return false;
          });
        });

        user = userX ? userX.userInfo : null;
      }
    }

    // 没有人点过
    if (!orderedDish) {
      orderedDish = dishesDataDuplicate.filter(function (item) {
        return item.id === dish.id;
      })[0];
    }

    // 仍然没有
    if (!orderedDish) {
      return {
        increment: increment,
        userInfo: null
      };
    }

    return {
      increment: helper.adjustOrderedDishIncrement(orderedDish, increment),
      userInfo: user
    };
  },

  // 清除自动添加的必点菜的通知
  clearAutoAddedMustOrderDishes: function clearAutoAddedMustOrderDishes() {
    if (this.state.autoAddedMustOrderDishes) {
      this.setState({
        autoAddedMustOrderDishes: null
      });
    }
  },
  handleOrderDishChange: function handleOrderDishChange(dishData, action) {
    var _this9 = this;

    var needRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (!this.onShoppingCartRelativeBtnClick()) {
      return;
    }
    var orderDish = this.props.orderDish;

    var afterFlyingBall = function afterFlyingBall() {
      if (_this9._dinnerSocket && !_this9.syncCartUnavailable) {
        var incrementAndFromUser = _this9.getRealIncrementAndFromUser(dishData, action);
        _this9._dinnerSocket.addOrMinusDishEvent(dishData, incrementAndFromUser.increment, null, incrementAndFromUser.userInfo);
        return;
      }

      var dishTypeInfo = _this9.getDishTypeInfo(dishData.dishTypeId);
      var newDishData = dishData;
      if (dishTypeInfo) {
        newDishData = dishData.set('dishTypeName', dishTypeInfo.name);
      }
      orderDish(newDishData, action);

      setTimeout(function () {
        _this9.ballFlyOutQueue();
      }, 0);
    };

    afterFlyingBall();

    this.clearAutoAddedMustOrderDishes();

    // if (action > 0) {
    //   setTimeout(afterFlyingBall, 300);
    // } else {
    //   afterFlyingBall();
    // }
  },
  hanleMainClick: function hanleMainClick() {
    var isChildrenShow = this.state.isChildrenShow;

    this.setState({ isChildrenShow: !isChildrenShow });
  },
  jumpDetail: function jumpDetail(evt, num) {
    evt.preventDefault();
    var _props$dishMenuReduce10 = this.props.dishMenuReducer.shopInfo,
        shopInfo = _props$dishMenuReduce10 === undefined ? {} : _props$dishMenuReduce10;

    var fromTsButton = '';
    if (isFromTsButton) {
      fromTsButton = '&fromTsButton=true';
    }

    // 正餐先付跳转先付的购物车页面
    location.href = '' + (shopInfo.diningForm === 2 ? dishCart4DinnerUrlPayFirst : dishCart4DinnerUrl) + fromTsButton;
  },
  closeWindow: function closeWindow() {
    var closeInfoWindow = this.props.closeInfoWindow;

    closeInfoWindow();
  },
  scanCode: function scanCode() {
    if (!isWeiXinBrowser && !isAlipayBrowser) {
      this.props.showErrMsgFunc((0, _helper.formatMessage)(_errorMessage2.default.weixinBrowserError));
    } else if (isWeiXinBrowser) {
      this.scanCodeWeixin(); // 唤起微信扫码
    } else {
      this.scanCodeAlipay(); // 唤起支付宝扫码
    }
  },
  scanCodeAlipay: function scanCodeAlipay() {
    var _this10 = this;

    var handleScanErr = function handleScanErr(errorCode) {
      if (errorCode === 10) {
        // this.props.showErrMsgFunc('用户取消');
      } else {
        _this10.props.showErrMsgFunc((0, _helper.formatMessage)(_errorMessage2.default.operateFailError));
      }
    };
    if (isAlipayMiniProgramBrowser()) {
      _aliMiniprogramHelper2.default.postMessage();
      _aliMiniprogramHelper2.default.onMessage(function (res) {
        if (!res) {
          handleScanErr();
          return;
        }
        _this10.handleScanResult(res.code);
      });
    } else {
      var ap = window.ap;
      if (!ap) {
        this.props.showErrMsgFunc((0, _helper.formatMessage)(_errorMessage2.default.alipayConfigFailError));
        return;
      }
      ap.scan({
        type: 'qr'
      }, function (res) {
        if (res.error) {
          handleScanErr(res.error);
        } else if (!res.code) {
          _this10.props.showErrMsgFunc((0, _helper.formatMessage)(_errorMessage2.default.getQRCodeFailError));
        } else {
          _this10.handleScanResult(res.code);
        }
      });
    }
  },
  scanCodeWeixin: function scanCodeWeixin() {
    var _this11 = this;

    var handleScanErr = function handleScanErr() {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this11.props.showErrMsgFunc((0, _helper.formatMessage)(_errorMessage2.default.cantScanPlaceOrderError) + ': ' + err.errMsg);
    };

    callWxClientMethod('scanQRCode', {
      needResult: 1,
      scanType: ['qrCode', 'barCode'],
      success: function success() {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return _this11.handleScanResult(res.resultStr);
      },
      error: handleScanErr
    });
  },
  handleScanResult: function handleScanResult(str) {
    var _this12 = this;

    if (!str) {
      this.props.showErrMsgFunc((0, _helper.formatMessage)(_errorMessage2.default.identifyQRCodeError));
      return;
    }

    var reg = /tableId=(\w+)/i;
    var match = reg.exec(str);
    // 老二维码可以直接取到tableId
    if (match) {
      sessionStorage.oriScanTableType = 2;
      location.href = config.dishMenu4DinnerURL + '?shopId=' + shopId + '&tableId=' + match[1] + '&type=TS';
      return;
    }

    // 新二维码需要调用后端接口获取tableId
    this.props.fetchTableIdFromNewVersionQRCode(str);
    sessionStorage.oriScanTableType = 1;
    //  扫码之后重刷页面或调用一下getshoppingcart
    this._dinnerSocket.getShoppingCartEventInCart(function (userOrderedDishList) {
      _this12.syncShoppingCart({
        userOrderedDishList: userOrderedDishList,
        userInfo: _this12._dinnerSockert.userInfo
      });
      _this12.setLoadingInfo(null);
    }, function () {
      _this12.setLoadingInfo({
        ing: true,
        text: (0, _helper.formatMessage)(_errorMessage2.default.connecting)
      });
    });
  },
  clearShoppingcart: function clearShoppingcart() {
    this.props.syncShoppingCart({});
    this.props.removeAllOrders();
  },
  showLoginPopup: function showLoginPopup() {
    this.props.setToastProps({
      className: 'order-dish-login-msgbox',
      mainMessage: (0, _helper.formatMessage)(_dishMenu2.default.loginBeforeOrder),
      buttonProp: {
        text: (0, _helper.formatMessage)(_global2.default.goToLogin),
        className: 'o-tc--primary'
      },
      imgProp: 'login',
      onBtnTap: function onBtnTap() {
        _pageHelper2.default.navigateToLoginPage({
          shopId: shopId
        });
      }
    });
  },
  initDinnerSocketHelper: function initDinnerSocketHelper(userInfo, curTableId, curOrderId, curOwnerId) {
    var _this13 = this;

    this.setLoadingInfo({
      ing: true
    });
    if (!userInfo) {
      return null;
    }
    if (this._dinnerSocket) {
      return this._dinnerSocket;
    }
    var serviceStatus = this.props.dishMenuZcReducer.serviceStatus;

    var customerId = serviceStatus.memberVO.customerId;
    var isOneTableOneBill = serviceStatus.tableWay === 'oneTableOneBill'; // 一桌一单
    var userNickname = commonHelper.getUserName(userInfo);
    var userPicPath = commonHelper.getUserAvatar(userInfo);
    var _userInfo = this._userInfo = {
      userId: customerId,
      mobile: userInfo.mobile,
      userPicPath: userPicPath,
      userNickname: userNickname,
      sex: String(userInfo.sex) === '0' || String(userInfo.sex) === '1' ? userInfo.sex : -1,
      shopId: shopId,
      tableId: curTableId,
      orderId: curOrderId,
      ownerId: isOneTableOneBill ? curTableId : curOwnerId || customerId
    };
    var dinnerSocket = new DinnerSocketHelper({
      reconnectionAttempts: _const.RECONNECTION_ATTEMPTS,
      userInfo: _userInfo,
      tableWay: serviceStatus.tableWay,
      onConnectError: function onConnectError(connectionErrCount) {
        // this.props.showErrMsgFunc(formatMessage(errorMessages.collCartError));  // 协同购物车错误不提示
        if (connectionErrCount >= _const.RECONNECTION_ATTEMPTS + 1) {
          // 错误次数超过最大重连次数，设置协同购物车不可用
          _this13.setLoadingInfo(null);
          window.sessionStorage && window.sessionStorage.setItem(_const.SYNC_CART_UNAVAILABLE, 'true');
          _this13.syncCartUnavailable = true; // 将协同购物车设置为不可用
        }
      },
      onBeforeAddOrMinusDish: function onBeforeAddOrMinusDish(orderDish) {
        var dishTypeInfo = _this13.getDishTypeInfo(orderDish.dishTypeId);
        if (dishTypeInfo) {
          (0, _assign2.default)(orderDish, {
            dishTypeName: dishTypeInfo.name,
            dishTypeOrder: dishTypeInfo.order
          });
        }
        if (!_this13.NetWorkErrorTimeOut) {
          _this13.NetWorkErrorTimeOut = setTimeout(function () {
            _this13.setLoadingInfo({
              text: (0, _helper.formatMessage)(_errorMessage2.default.netWorkError)
            });
          }, 1500);
        }
      },
      onBeforeJoinRoom: function onBeforeJoinRoom() {
        _this13.setLoadingInfo({
          ing: true,
          text: (0, _helper.formatMessage)(_errorMessage2.default.intoTableError)
        });
      },
      onBeforeInitDishes: function onBeforeInitDishes(orderedDishes) {
        var dishesDataDuplicate = _this13.props.dishMenuReducer.dishesDataDuplicate;

        var _orderedDishes = orderedDishes || [];
        var assignDishIngredientInfos = function assignDishIngredientInfos(dish) {
          if (!dish.dishIngredientInfos || dish.dishIngredientInfos.length) {
            return;
          }
          var originDish = dishesDataDuplicate.filter(function (item) {
            return item.id === dish.id;
          })[0];
          if (originDish && originDish.dishIngredientInfos && originDish.dishIngredientInfos.length) {
            (0, _assign2.default)(dish, {
              dishIngredientInfos: [{ id: -1, reprice: 0 }]
            });
          }
        };
        _orderedDishes.forEach(function (dish) {
          return assignDishIngredientInfos(dish);
        });
      },
      onAfterJoinRoom: function onAfterJoinRoom(success) {
        _this13.setLoadingInfo(null);
      },
      onNetworkDelay: function onNetworkDelay(delayMsg) {
        // this.props.setErrorMsg({ text: delayMsg, timeout: 2000 });
        _this13.setLoadingInfo(null);
        // 断开连接后不提示用户已经断开
        // this.props.setToastProps({
        //   mainMessage: delayMsg || <FormattedMessage {...errorMessages.socketLinkError} />,
        //   buttonProp: { text: <FormattedMessage {...buttonMessages.iknown} /> },
        //   onBtnTap: () => {
        //     window.location.reload();
        //   },
        //   imgProp: userInfo.userPicPath,
        //   userName: userInfo.userNickname,
        // });
      }
    });
    dinnerSocket.dishNoticeListener(function (result, dishIncreaseUnit, minNum, stepNum) {
      clearTimeout(_this13.NetWorkErrorTimeOut);
      _this13.NetWorkErrorTimeOut = null;
      _this13.setLoadingInfo(null);

      var _result$orderData = (0, _slicedToArray3.default)(result.orderData, 1),
          dish = _result$orderData[0];

      var _result$userInfo = result.userInfo,
          operatorInfo = _result$userInfo === undefined ? {} : _result$userInfo;
      var _props3 = _this13.props,
          addOrderNotice = _props3.addOrderNotice,
          readOrderNotice = _props3.readOrderNotice;

      var isOther = operatorInfo.userId !== _userInfo.userId;
      var notice = {
        isOther: isOther,
        userInfo: operatorInfo,
        orderDishes: result.orderData,
        increment: dish.num
      };
      var originUserOrderedDishList = _this13.props.dishMenuZcReducer.userOrderedDishList || [];
      var updateSyncShoppingCart = _this13.props.dishMenuZcReducer.updateSyncShoppingCart;
      var originMinNumber = 0;
      var minNumber = 0;
      var getMinNumber = function getMinNumber() {
        var dishList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var syncShoppingCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var number = 0;
        dishList.forEach(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var index = arguments[1];

          if (item.dishList && item.dishList.length === 0) {
            return;
          }
          item.dishList.forEach(function () {
            var itemt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var indext = arguments[1];

            if (itemt.brandDishId === result.orderData[0].brandDishId && itemt.id === result.orderData[0].id &&
            /* syncShoppingCart.userInfo.userId === result.userInfo.userId && */
            item.userInfo.userId === result.userInfo.userId) {
              if (typeof itemt.order === 'number') {
                number = itemt.order;
              } else {
                number = itemt.order[0].count;
              }
            }
          });
        });
        return number;
      };
      originMinNumber = getMinNumber(originUserOrderedDishList, updateSyncShoppingCart);
      if (originMinNumber === 0 && minNum < 0) {
        // 阻止请求发送
        return;
      }
      addOrderNotice(notice);
      var userOrderedDishList = _this13.props.dishMenuZcReducer.userOrderedDishList;
      minNumber = getMinNumber(userOrderedDishList, updateSyncShoppingCart);
      if (minNum < 0) {
        if (userOrderedDishList && userOrderedDishList.length && originUserOrderedDishList && originUserOrderedDishList.length) {
          if (minNumber === 0 && originMinNumber !== 0 && originMinNumber - stepNum < dishIncreaseUnit) {
            // 小于步长
            if (updateSyncShoppingCart) {
              _this13._dinnerSocket.addOrMinusDishEvent(updateSyncShoppingCart.orderDishes[0], Number('-' + dishIncreaseUnit), function () {}, result.userInfo);
            }
          }
        }
      }
      // 其他点菜通知
      if (isOther) {
        setTimeout(function () {
          readOrderNotice();
        }, 2000);
      } else {
        _this13.props.orderDish(dish, notice.increment, false);
      }
    });
    dinnerSocket.clearShoppingcartListener(function () {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var setToastProps = _this13.props.setToastProps;

      _this13.clearShoppingcart();
      _this13.clearAutoAddedMustOrderDishes();
      doClearSocketShoppingCart({
        setToastProps: setToastProps,
        userInfo: result,
        tradeDetailUncheckURL: config.tradeDetailUncheckURL + '?type=TS&shopId=' + shopId + '&orderId=' + result.orderId + '&tableId=' + result.tableId
      });
    });
    dinnerSocket.errorListener(function () {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this13.setLoadingInfo(null);
      // 不显示购物车连接断开
      // this.props.showErrMsgFunc(`${formatMessage(errorMessages.collCartError)}： ${error.msg || error}`);
    });
    dinnerSocket.noticePlaceOrder(function () {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _this13.props.showErrMsgFunc('' + result.userNickname + (0, _helper.formatMessage)(_dishMenu2.default.alreadyOrderedAndRedirecting));
      setTimeout(function () {
        location.href = config.tradeDetailUncheckURL + '?type=TS&shopId=' + shopId + '&orderId=' + result.orderId + '&tableId=' + result.tableId;
      }, 3000);
    });
    this._dinnerSocket = dinnerSocket;
    return this._dinnerSocket;
  },
  syncShoppingCart: function syncShoppingCart(args, callBack) {
    var syncShoppingCart = this.props.syncShoppingCart;


    syncShoppingCart(args);

    if (callBack) {
      callBack();
    }
  },
  closeDishCouponSuccess: function closeDishCouponSuccess() {
    this.setState({ showDishCouponSuccess: false });
  },
  methodAfterSlip: function methodAfterSlip() {
    this.setState({
      flodUpAppendCss: 'flodup'
    });
  },
  methodAfterFoldUp: function methodAfterFoldUp() {
    this.setState({
      flodUpAppendCss: ''
    });
  },
  closeFixedCoupon: function closeFixedCoupon(evt) {
    var _this14 = this;

    new _promise2.default(function (resolve, reject) {
      _this14.props.getCoupontoGuid(true, resolve);
    }).then(function () {
      _this14.setState({ showFixedCoupon: false });
    });

    if (evt) {
      evt.preventDefault();
    }
  },

  // 热销菜品推荐
  showHotSpans: function showHotSpans(e) {
    e.preventDefault();
    this.setState({ showHotSpan: true });

    e.preventDefault();
    e.stopPropagation();
    location.hash = '#hot-dish';
  },
  cancelHotSpan: function cancelHotSpan(e) {
    this.setState({ showHotSpan: false });

    e.preventDefault();
    e.stopPropagation();
    location.hash = '';
  },
  setHotViewAccordingToHash: function setHotViewAccordingToHash() {
    this.setState({ showHotSpan: false });
  },
  getDishHotElement: function getDishHotElement() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var dish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var hotElement = [];
    if (data && dish) {
      data.forEach(function (temp, index) {
        // 热销菜品
        dish.forEach(function (item, i) {
          // 所有菜品
          if (String(temp.dishId) === String(item.id)) {
            hotElement.push((0, _assign2.default)({}, item, {
              soldNum: temp.soldNum || item.soldNum,
              index: i
            }));
          }
        });
      });
    }
    return hotElement;
  },
  getReceiveCouponsStatus: function getReceiveCouponsStatus(name) {
    var _props$dishMenuReduce11 = this.props.dishMenuReducer.shopInfo,
        shopInfo = _props$dishMenuReduce11 === undefined ? {} : _props$dishMenuReduce11;

    var status = true;
    if (helper.getUrlParam('getCoupon')) {
      status = false;
    }

    if (shopInfo.isOldMarketing) {
      // 老逻辑标识已经领过券了
      var _shopInfo$marketCoupo = shopInfo.marketCoupon,
          marketCoupon = _shopInfo$marketCoupo === undefined ? {} : _shopInfo$marketCoupo;
      var coupId = marketCoupon.coupId;

      var alreadySendCouponOld = localStorage.alreadySendCouponOld || '';
      if (alreadySendCouponOld.indexOf(type + '_' + shopId + '_' + coupId) !== -1) {
        // WM_810005865_82847257400999936
        status = false;
      }
      if (shopInfo.marketCoupon && !shopInfo.marketCoupon.flag && (shopInfo.marketCoupon.type === 2 || shopInfo.marketCoupon.type === 1)) {
        status = false;
      }
    } else {
      // 新逻辑标识领券了
      var ruleId = shopInfo.ruleId,
          planId = shopInfo.planId;

      var alreadySendCouponNew = localStorage.alreadySendCouponNew || '';
      if (alreadySendCouponNew.indexOf(type + '_' + shopId + '_' + ruleId + '_' + planId) !== -1) {
        // dishWM_WM_810005865
        status = false;
      }
      if (!shopInfo.flag && (shopInfo.type === 1 || shopInfo.type === 2) || shopInfo.couponSuccess) {
        status = false;
      }
    }

    return status;
  },
  hiddenCouponsList: function hiddenCouponsList(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ showCouponList: false, isShowAlreadyGotCoupon: false });
  },
  showCouponsList: function showCouponsList(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({ showCouponList: true });
  },
  showAlreadyGotCoupon: function showAlreadyGotCoupon(showStatus) {
    this.setState({ isShowAlreadyGotCoupon: showStatus });
  },
  getOmitDishGuidStepNumber: function getOmitDishGuidStepNumber() {
    var _props$dishMenuReduce12 = this.props.dishMenuReducer.shopInfo,
        shopInfo = _props$dishMenuReduce12 === undefined ? {} : _props$dishMenuReduce12;
    var serviceSupply = shopInfo.serviceSupply;

    if (!serviceSupply || !serviceSupply.length) {
      return 3; // tips_3
    }
    return 0;
  },
  formatShowPrice: function formatShowPrice(orderedDishes) {
    var discountProps = this.props.discountProps;

    var isMember = discountProps && discountProps.isMember;
    var totalPrice = helper.getDishesPrice(orderedDishes);
    var totalMemberPrice = helper.getDishesPrice(orderedDishes, null, true);
    var allowShowMemberPrice = totalPrice > totalMemberPrice && totalMemberPrice >= 0 && isMember; // 是否满足展示条件
    var tpPartStyle = {};
    var tmpPartStyle = {};
    var tmpPart = '';

    if (allowShowMemberPrice) {
      tmpPartStyle = { marginRight: 4 };
      tpPartStyle = {
        textDecoration: 'line-through',
        color: '#999',
        fontSize: 11
      };
      tmpPart = React.createElement(
        'span',
        { className: 'price', style: tmpPartStyle },
        React.createElement(
          'strong',
          null,
          totalMemberPrice
        )
      );
    }
    var tpPart = React.createElement(
      'span',
      { className: 'price', style: tpPartStyle },
      React.createElement(
        'strong',
        null,
        totalPrice
      )
    );
    return React.createElement(
      'div',
      { className: 'o-flex shortcut-car-text__inner' },
      tmpPart,
      tpPart
    );
  },
  renderOpenDialog: function renderOpenDialog() {
    var shopInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _this15 = this;

    var isAcceptOrder = arguments[1];
    var openShopTime = arguments[2];
    var isShowOpenStatus = this.state.isShowOpenStatus;
    var isEnableShop = shopInfo.isEnableShop,
        openStatus = shopInfo.openStatus,
        enableWeixinMini = shopInfo.enableWeixinMini;

    var closeWord = '';
    var enableCloseDialog = true;
    if (!enableWeixinMini && !!isWeiXinMiniBrowser) {
      closeWord = React.createElement(
        'div',
        { className: 'shopopen-time' },
        (0, _helper.formatMessage)(_part2.default.DishMenuApplicationmircAppUnOpen)
      );
      enableCloseDialog = false;
    } else if (!isEnableShop) {
      closeWord = React.createElement(
        'div',
        { className: 'shopopen-time' },
        React.createElement(_formattedMessage2.default, _shop2.default.isDisable)
      );
    } else if (!isAcceptOrder) {
      closeWord = React.createElement(
        'div',
        { className: 'shopopen-time' },
        React.createElement(_formattedMessage2.default, _shop2.default.isNotAcceptOrder)
      );
    } else if (!openStatus) {
      closeWord = React.createElement(
        'div',
        { className: 'shopopen-time' },
        React.createElement(_formattedMessage2.default, _shop2.default.openhour),
        '\uFF1A',
        openShopTime || React.createElement(_formattedMessage2.default, _shop2.default.notConfig)
      );
    }

    return React.createElement(
      'div',
      { className: 'dish-mesthead-opendialog' },
      (!isEnableShop || !isAcceptOrder || !openStatus || !enableWeixinMini && !!isWeiXinMiniBrowser) && isShowOpenStatus && React.createElement(
        MessageDialog,
        {
          onConfirm: function onConfirm() {
            if (!enableCloseDialog) return;
            _this15.setState({ isShowOpenStatus: false });
          },
          btnText: React.createElement(
            'span',
            { className: !enableCloseDialog ? 'shopopen-btn_disabled' : '' },
            (0, _helper.formatMessage)(_button2.default.iknown)
          )
        },
        React.createElement('img', { className: 'shopopen-img', src: _yidayang2.default, alt: (0, _helper.formatMessage)(_shop2.default.closedFlag) }),
        React.createElement(
          'p',
          { className: 'shopopen-info' },
          React.createElement(_formattedMessage2.default, _shop2.default.isClose)
        ),
        closeWord
      )
    );
  },
  handleGoPrepaidCode: function handleGoPrepaidCode() {
    var returnUrl = encodeURIComponent(window.location.href);
    window.location.href = config.prepaidCodeUrl + '?shopId=' + shopId + '&returnUrl=' + returnUrl;
  },
  render: function render() {
    var _this16 = this;

    // states
    var _props$dishMenuZcRedu9 = this.props.dishMenuZcReducer,
        callAble = _props$dishMenuZcRedu9.callAble,
        callMsg = _props$dishMenuZcRedu9.callMsg,
        serviceStatus = _props$dishMenuZcRedu9.serviceStatus,
        notices = _props$dishMenuZcRedu9.notices,
        userInfo = _props$dishMenuZcRedu9.userInfo,
        toastProps = _props$dishMenuZcRedu9.toastProps,
        userOrderedDishList = _props$dishMenuZcRedu9.userOrderedDishList,
        tableAreaInfo = _props$dishMenuZcRedu9.tableAreaInfo,
        isDataInitOver = _props$dishMenuZcRedu9.isDataInitOver,
        saveOrderChangeItem = _props$dishMenuZcRedu9.saveOrderChangeItem,
        shopMinConsume = _props$dishMenuZcRedu9.shopMinConsume,
        selfChooseDishList = _props$dishMenuZcRedu9.selfChooseDishList;
    var _props$dishMenuReduce13 = this.props.dishMenuReducer,
        activeDishTypeId = _props$dishMenuReduce13.activeDishTypeId,
        activeDishTypeIdIndex = _props$dishMenuReduce13.activeDishTypeIdIndex,
        dishTypesData = _props$dishMenuReduce13.dishTypesData,
        dishDetailData = _props$dishMenuReduce13.dishDetailData,
        dishDescData = _props$dishMenuReduce13.dishDescData,
        errorMessage = _props$dishMenuReduce13.errorMessage,
        openTimeList = _props$dishMenuReduce13.openTimeList,
        _props$dishMenuReduce14 = _props$dishMenuReduce13.shopInfo,
        shopInfo = _props$dishMenuReduce14 === undefined ? {} : _props$dishMenuReduce14,
        shopLogo = _props$dishMenuReduce13.shopLogo,
        dishesDataDuplicate = _props$dishMenuReduce13.dishesDataDuplicate,
        load = _props$dishMenuReduce13.load,
        orderPageImage = _props$dishMenuReduce13.orderPageImage,
        tsOperateImgUrl = _props$dishMenuReduce13.tsOperateImgUrl,
        tsOperateUrl = _props$dishMenuReduce13.tsOperateUrl,
        _props$dishMenuReduce15 = _props$dishMenuReduce13.swiperAdImgs,
        swiperAdImgs = _props$dishMenuReduce15 === undefined ? [] : _props$dishMenuReduce15,
        fullAdvertImgUrl = _props$dishMenuReduce13.fullAdvertImgUrl,
        fullAdvertUrl = _props$dishMenuReduce13.fullAdvertUrl,
        showFullscreenAd = _props$dishMenuReduce13.showFullscreenAd,
        isAcceptOrder = _props$dishMenuReduce13.isAcceptOrder,
        dishDetailRecommendDishList = _props$dishMenuReduce13.dishDetailRecommendDishList,
        soldTopDishList = _props$dishMenuReduce13.soldTopDishList;
    // actions

    var _props4 = this.props,
        activeDishType = _props4.activeDishType,
        toggleDishDetailPopup = _props4.toggleDishDetailPopup,
        toggleDishDescPopup = _props4.toggleDishDescPopup,
        clearErrorMsg = _props4.clearErrorMsg,
        callBell = _props4.callBell,
        clearBell = _props4.clearBell,
        showErrMsgFunc = _props4.showErrMsgFunc,
        getMarketCoupons = _props4.getMarketCoupons,
        cancelCallMsg = _props4.cancelCallMsg,
        updateCanCall = _props4.updateCanCall,
        reinstateUndefined = _props4.reinstateUndefined;
    var _state = this.state,
        isChildrenShow = _state.isChildrenShow,
        loadingInfo = _state.loadingInfo,
        isShowSearch = _state.isShowSearch,
        allDiscount = _state.allDiscount,
        showDishCouponSuccess = _state.showDishCouponSuccess,
        showFixedCoupon = _state.showFixedCoupon,
        isSync = _state.isSync,
        showCouponList = _state.showCouponList,
        isShowAlreadyGotCoupon = _state.isShowAlreadyGotCoupon,
        dishIdForStatistics = _state.dishIdForStatistics,
        flodUpAppendCss = _state.flodUpAppendCss,
        autoAddedMustOrderDishes = _state.autoAddedMustOrderDishes,
        showSelfChoose = _state.showSelfChoose,
        isShowLoginExceptionDialog = _state.isShowLoginExceptionDialog,
        showLoginExceptionDesc = _state.showLoginExceptionDesc;

    var marketList = shopInfo.marketList;
    var marketListUpdate = shopInfo.marketListUpdate;
    var _props$dishMenuReduce16 = this.props.dishMenuReducer,
        enableMemberRegistry = _props$dishMenuReduce16.enableMemberRegistry,
        discountProps = _props$dishMenuReduce16.discountProps,
        pageIsLoaded = _props$dishMenuReduce16.pageIsLoaded,
        guide = _props$dishMenuReduce16.guide,
        menuDataStatus = _props$dishMenuReduce16.menuDataStatus;

    var isMember = discountProps && discountProps.isMember;
    var orderedDishes = this.getCurrentOrderedDishes(userOrderedDishList, dishesDataDuplicate);
    var dishesCount = helper.getDishesCount(orderedDishes);
    var tableInfo = (0, _orderDinnerCartHelper.getTableInfoInSessionStorage)(shopId);
    var dishPageTpl = this.props.dishMenuReducer.dishPageTpl || 'default';
    this.setTrunToDetailPage(serviceStatus);
    var scanShow = serviceStatus && !isSync && userInfo && !(tableInfo.tableId || tableInfo.tableKey || tableInfo.orderId) && (isWeiXinBrowser || isAlipayBrowser);
    /* const scanShow = true; */
    var changeShowData = helper.getOrderedDishes(dishesDataDuplicate);

    var changeShowDataItems = changeShowData.reduce(function (changeItems, item) {
      changeItems[item.id] = item;

      return changeItems;
    }, {});

    var openShopTimeStr = '' + helper.formatOpenTime(openTimeList);
    var openShopTime = openShopTimeStr ? React.createElement(
      'div',
      { className: 'o-flex__fluid' },
      React.createElement(
        'div',
        null,
        helper.formatOpenTime(openTimeList)
      )
    ) : '';

    var openDialog = this.renderOpenDialog(shopInfo, isAcceptOrder, openShopTime);
    var isRegistry = enableMemberRegistry && isMember === false || false;

    var showReceiveCoupons = false;
    if (!shopInfo.isOldMarketing && showCouponList && this.getReceiveCouponsStatus() && shopInfo.couponList.length !== 0 || shopInfo.isOldMarketing && showCouponList && this.getReceiveCouponsStatus() && shopInfo.marketCoupon && shopInfo.marketCoupon.coupId || isShowAlreadyGotCoupon) {
      showReceiveCoupons = true;
    }
    var formatShowPrice = this.formatShowPrice(orderedDishes);
    var isPayFirst = shopInfo.diningForm === 2;
    var prepaidCodes = (0, _prepaidCode.getPrepaidCodes)(shopId);
    var showPrepaidCodeTip = isPayFirst && shopMinConsume && shopMinConsume.state === 1 && !prepaidCodes.length && !tableInfo.orderId;

    return !pageIsLoaded ? React.createElement(_preloadSkeleton2.default, null) : React.createElement(
      'div',
      { className: 'o-flex o-flex--column dish-menu-zc' },
      openDialog,
      isRegistry && React.createElement(
        'div',
        { className: 'register notice' },
        React.createElement(
          'a',
          { href: '/member/register' + location.search + '&returnUrl=' + encodeURIComponent(location.href) },
          React.createElement(_formattedMessage2.default, _dishMenu2.default.registerGoToRegister)
        ),
        React.createElement(
          'p',
          null,
          React.createElement(_formattedMessage2.default, _dishMenu2.default.registerDescription),
          '\uFF5E'
        )
      ),
      React.createElement(
        'div',
        {
          className: classnames('o-flex o-flex--column dish-menu-zc-main', {
            scanShow: scanShow
          })
        },
        React.createElement(DishMesthead, {
          shopInfo: shopInfo,
          shopLogo: shopLogo,
          tableInfo: tableAreaInfo,
          setSearchPage: this.setSearchPage,
          setAllDiscount: this.setAllDiscount,
          tsOperateImgUrl: tsOperateImgUrl,
          tsOperateUrl: tsOperateUrl,
          swiperAdImgs: swiperAdImgs,
          orderPageImage: orderPageImage,
          isAcceptOrder: isAcceptOrder,
          discountProps: discountProps,
          openShopTimeStr: openShopTimeStr,
          openShopTime: openShopTime,
          flodUpAppendCss: flodUpAppendCss,
          isShowHalf: false // 正餐不显示第二杯半价的信息
        }),
        React.createElement(
          'div',
          { ref: 'scrollWrap', className: dishPageTpl + ' scroller-wrap o-flex__fluid dish-menu-zc', onTouchTap: this.onDishTouchTap },
          React.createElement(DishTypeScroller, {
            theme: dishPageTpl,
            dishTypesData: dishTypesData,
            dishesData: dishesDataDuplicate,
            activeDishTypeId: activeDishTypeId,
            activeDishTypeIdIndex: activeDishTypeIdIndex,
            onDishTypeElementTap: activeDishType,
            diningForm: shopInfo.diningForm
          }),
          React.createElement(DishScroller, {
            isDataInitOver: isDataInitOver,
            saveOrderChangeItem: saveOrderChangeItem,
            theme: dishPageTpl,
            changeShowData: changeShowData,
            dishTypesData: dishTypesData,
            dishesData: dishesDataDuplicate,
            diningForm: shopInfo.diningForm,
            activeDishTypeId: activeDishTypeId,
            activeDishTypeIdIndex: activeDishTypeIdIndex,
            setSearchPage: this.setSearchPage,
            onScroll: activeDishType,
            marketList: marketList,
            reinstateUndefined: reinstateUndefined,
            onOrderBtnTap: this.handleOrderDishChange,
            onPropsBtnTap: function onPropsBtnTap(dish) {
              if (!_this16.onShoppingCartRelativeBtnClick()) {
                return;
              }

              toggleDishDetailPopup(dish);
            },
            onImageBtnTap: function onImageBtnTap(dish) {
              _this16.setState({ dishIdForStatistics: -1 });
              toggleDishDescPopup(dish);
            },
            marketListUpdate: marketListUpdate,
            shopInfo: shopInfo,
            load: load,
            getMarketCoupon: getMarketCoupons,
            onScrolling: function onScrolling(direction) {
              _this16.setScrollTop(direction);
            },
            showHotSpan: this.showHotSpans,
            soldTopDishList: this.getDishHotElement(soldTopDishList, dishesDataDuplicate),
            couponType: 'dishMenu',
            showCouponsList: this.showCouponsList,
            showAlreadyGotCoupon: this.showAlreadyGotCoupon,
            isZc: true // 是否正餐
            , hasAds: !!swiperAdImgs.length
          })
        ),
        dishDetailData !== undefined ? React.createElement(_dishDetailContainer2.default, {
          changeShowDataItems: changeShowDataItems,
          dish: dishDetailData,
          sameRuleDishList: this.getSameRuleDishList(dishDetailData, dishesDataDuplicate),
          onCloseBtnTap: toggleDishDetailPopup,
          onAddToCarBtnTap: this.onDishDetailAddBtnTap
        }) : false,
        dishDescData !== undefined ? React.createElement(
          'div',
          { onTouchTap: this.onDishTouchTap },
          React.createElement(DishDescPopup, {
            dish: dishDescData,
            onOrderBtnTap: this.handleOrderDishChange,
            onPropsBtnTap: function onPropsBtnTap(dish) {
              if (!_this16.onShoppingCartRelativeBtnClick()) {
                return;
              }

              toggleDishDetailPopup(dish);
            },
            urlType: helper.getUrlParam('type'),
            dishesDataDuplicate: dishesDataDuplicate,
            menuDataStatus: menuDataStatus,
            toggleDishDescPopup: toggleDishDescPopup,
            recommendDishList: dishDetailRecommendDishList,
            dishIdForStatistics: dishIdForStatistics,
            theme: dishPageTpl
          })
        ) : false,
        errorMessage.text ? React.createElement(Toast, { errorMessage: errorMessage.text, clearErrorMsg: clearErrorMsg, timeout: errorMessage.timeout }) : false
      ),
      React.createElement(
        'div',
        {
          className: classnames('shortcut-operate', {
            'shortcut-operate-bottom': scanShow && !isShowSearch && !this.state.showHotSpan,
            'shortcut-operate--desc': !!dishDescData,
            'shortcut-operate-hidden': !isDataInitOver
          })
        },
        React.createElement(
          _reactAddonsCssTransitionGroup2.default,
          { transitionName: 'must-order-dish-fade', transitionEnterTimeout: 600, transitionLeaveTimeout: 600 },
          autoAddedMustOrderDishes && React.createElement(
            'div',
            { className: 'auto-added-must-order-dishes-tip' },
            React.createElement(
              'div',
              { className: 'content' },
              autoAddedMustOrderDishes.map(function (dish) {
                return '' + dish.count + dish.unitName + dish.name;
              }).join(', '),
              (0, _helper.formatMessage)(_dishMenu2.default.addedToCart)
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'btn-shortcut-outer ' + (this.state.dropInShoping ? 'dropin-shopcart-animation' : '') },
          React.createElement(
            'div',
            {
              onTouchTap: function onTouchTap(evt) {
                if (!_this16.onShoppingCartRelativeBtnClick()) {
                  return;
                }
                _this16.jumpDetail(evt, dishesCount);
              },
              className: classnames('btn-shortcut btn-shortcut-car btn-shortcut-larger bg-grey', {
                'shortcut-car-empty-padding': dishesCount === 0,
                'shortcut-car-left-margin': !dishDescData
              })
            },
            React.createElement(
              'span',
              {
                className: classnames('shortcut-car-text ellipsis', {
                  'shortcut-car-empty': dishesCount === 0
                })
              },
              dishesCount > 0 ? formatShowPrice : (0, _helper.formatMessage)(_dishMenu2.default.dishEmpty)
            ),
            dishesCount > 0 && React.createElement(
              'span',
              {
                className: classnames('o-fz--11 shortcut-car--counter', {
                  'shortcut-car-count--modify': dishesCount > 99
                })
              },
              dishesCount < 99 ? dishesCount : '99+'
            ),
            React.createElement(
              'span',
              {
                className: classnames('shortcut-car-chosenBtn o-btn--linear', {
                  'shortcut-car-chosenBtn-hidden': dishesCount === 0
                })
              },
              (0, _helper.formatMessage)(_shoppingCart2.default.closeOk)
            )
          )
        ),
        serviceStatus && React.createElement(BtnShortcutMulti, {
          isChildrenShowProp: isChildrenShow,
          orderId: serviceStatus.orderId,
          btnAttributesMulti: {
            btnAttributesDefault: {
              size: 'default',
              classnames: 'o-btn--default'
            },
            btnAttributesMain: {
              onClick: this.hanleMainClick,
              text: (0, _helper.formatMessage)(_shoppingCart2.default.func),
              iconWidth: '11px',
              verticalAlign: '-1px'
            },
            btnDisable: this.getBtnDisable(serviceStatus)
          },
          shopMinConsume: shopMinConsume,
          isNavi: true,
          bell: React.createElement(QuickMenu, {
            callBell: callBell,
            clearBell: clearBell,
            callMsg: callMsg,
            callAble: callAble,
            dishes: dishesDataDuplicate,
            serviceStatus: serviceStatus,
            openTimeList: openTimeList,
            showErrMsgFunc: showErrMsgFunc,
            cancelCallMsg: cancelCallMsg,
            updateCanCall: updateCanCall,
            tableInfo: tableInfo,
            shopInfo: shopInfo,
            isFucBell: true
          })
        }),
        React.createElement(
          'div',
          { className: 'shortcut-car-animation of' },
          React.createElement(
            'div',
            { className: 'real-animation', style: { bottom: this.state.animationBottom }, ref: 'noticeWrap' },
            notices.map(function () {
              var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var index = arguments[1];
              return React.createElement(
                'div',
                { className: 'shortcut-car-outer' },
                React.createElement(
                  'div',
                  { className: 'shortcut-car-item of', key: index, style: { display: item.readed ? 'none' : '' } },
                  React.createElement(_httpsProtocolImage2.default, { src: item.userPicPath || _headDefaultNew2.default, className: 'user-icon fl', alt: (0, _helper.formatMessage)(_shoppingCart2.default.customerImg) }),
                  React.createElement(
                    'span',
                    { className: 'fr' },
                    item.orderAction
                  ),
                  React.createElement(
                    'span',
                    { className: 'ellipsis user-dishname' },
                    item.dishName
                  )
                )
              );
            }).asMutable().reverse()
          )
        ),
        false && React.createElement(QuickMenu, {
          callBell: callBell,
          clearBell: clearBell,
          callMsg: callMsg,
          callAble: callAble,
          dishes: dishesDataDuplicate,
          serviceStatus: serviceStatus,
          openTimeList: openTimeList,
          showErrMsgFunc: showErrMsgFunc,
          cancelCallMsg: cancelCallMsg,
          updateCanCall: updateCanCall,
          tableInfo: tableInfo,
          shopInfo: shopInfo
        })
      ),
      scanShow && React.createElement(
        'div',
        { className: 'o-flex qrcode-tip', onTouchTap: this.scanCode },
        React.createElement(
          'div',
          { className: 'o-flex o-flex__fluid' },
          React.createElement('img', { src: _ordertogether2.default, className: 'qrcode-tip__together', alt: '\u4E00\u8D77\u70B9\u9910' }),
          React.createElement('img', { src: _combinedword2.default, className: 'qrcode-tip__combinedword', alt: '\u4E00\u8D77\u70B9\u9910' })
        ),
        React.createElement(
          'div',
          { className: 'o-flex o-flex__fixed qrcode-tip__word' },
          React.createElement('div', { className: 'depart-line' }),
          React.createElement('img', { src: _joinword2.default, className: 'qrcode-tip__wordimg', alt: '\u4E00\u8D77\u70B9\u9910' })
        )
      ),
      toastProps && React.createElement(SyncOrderToast, { toastProps: toastProps, onCloseWindow: this.closeWindow }),
      loadingInfo && loadingInfo.ing && React.createElement(Loading, { word: loadingInfo.text }),
      isShowSearch && React.createElement(SearchDish, {
        dishesData: dishesDataDuplicate,
        dishTypesData: dishTypesData,
        diningForm: shopInfo.diningForm,
        marketList: marketList,
        isMember: isMember,
        onOrderBtnTap: this.handleOrderDishChange,
        scanShow: scanShow,
        onPropsBtnTap: function onPropsBtnTap(dish) {
          if (!_this16.onShoppingCartRelativeBtnClick()) {
            return;
          }

          toggleDishDetailPopup(dish);
        },
        onImageBtnTap: toggleDishDescPopup,
        setSearchPage: this.setSearchPage
      }),
      allDiscount && React.createElement(
        'div',
        { className: 'ads-column add-content' },
        allDiscount
      ),
      localStorage.getItem('shop_' + shopId + helper.getUrlParam('type')) === null && helper.getUrlParam('type') === 'TS' && guide && this.props.dishMenuZcReducer.guidStatus ? React.createElement(DishGuid, { dishType: { type: 'TS', showScan: scanShow }, omitDishGuidStepNumber: this.getOmitDishGuidStepNumber() }) : '',
      (shopInfo.couponSuccessInfo && shopInfo.couponSuccessInfo.couponId && showDishCouponSuccess || shopInfo.couponSuccess) && React.createElement(_dishCouponSuccess2.default, { shopInfo: shopInfo, closeDishCouponSuccess: this.closeDishCouponSuccess, showFixedCoupon: showFixedCoupon }),
      showReceiveCoupons && React.createElement(_receiveCoupons2.default, {
        handleClose: this.hiddenCouponsList,
        ruleId: shopInfo.ruleId || 0,
        couponList: shopInfo.couponList,
        getCoupons: this.props.getMarketCoupons,
        getCoupontoGuid: this.props.getCoupontoGuid,
        isShowAlreadyGotCoupon: isShowAlreadyGotCoupon,
        shopInfo: shopInfo,
        couponType: 1,
        title: isShowAlreadyGotCoupon ? (0, _helper.formatMessage)(_part2.default.DishMenuApplicationgetSpecialGift) : (0, _helper.formatMessage)(_part2.default.DishMenuApplicationgetSpecialGiftSuccess)
      }),
      this.state.showHotSpan && React.createElement(
        'div',
        { onTouchTap: this.onDishTouchTap },
        React.createElement(_dishHotSlide2.default, {
          goBack: this.cancelHotSpan,
          theme: dishPageTpl,
          dishesData: dishesDataDuplicate,
          diningForm: shopInfo.diningForm,
          marketList: marketList,
          onOrderBtnTap: this.handleOrderDishChange,
          onPropsBtnTap: function onPropsBtnTap(dish) {
            if (!_this16.onShoppingCartRelativeBtnClick()) {
              return;
            }

            toggleDishDetailPopup(dish);
          },
          onImageBtnTap: toggleDishDescPopup,
          soldTopDishList: this.getDishHotElement(soldTopDishList, dishesDataDuplicate)
        })
      ),
      showFullscreenAd && React.createElement(_fullscreenAd2.default, { imageUrl: fullAdvertImgUrl, link: fullAdvertUrl }),
      isShowLoginExceptionDialog && React.createElement(
        'div',
        { className: 'login-exception-tip' },
        React.createElement(
          'div',
          { className: 'login-exception-container' },
          React.createElement(
            'div',
            { className: 'login-exception-text' },
            '\u7CFB\u7EDF\u5F02\u5E38'
          ),
          React.createElement(
            'div',
            { className: 'login-exception-desc' },
            showLoginExceptionDesc
          )
        )
      ),
      React.createElement('div', { id: 'handleInputDOM', 'data-editable': shopInfo.goodsNumEditable, style: { display: 'none' } }),
      showPrepaidCodeTip && React.createElement(
        'div',
        { className: 'check-prepaid-code-tip' },
        React.createElement(
          'div',
          { className: 'check-prepaid-code-container' },
          React.createElement('div', { className: 'check-prepaid-code-img' }),
          React.createElement(
            'div',
            { className: 'check-prepaid-code-tip-text' },
            '\u8BF7\u5148\u9A8C\u8BC1\u9884\u4ED8\u5355'
          ),
          React.createElement(
            'button',
            { className: 'o-btn o-btn--linear', onTouchTap: this.handleGoPrepaidCode },
            '\u7ACB\u5373\u9A8C\u8BC1'
          )
        )
      ),
      React.createElement(_healthIcon2.default, null),
      showSelfChoose && React.createElement(_selfChooseMustOrder2.default, {
        selfChooseDishList: selfChooseDishList,
        orderedDishes: orderedDishes,
        onOrderBtnTap: this.handleOrderDishChange,
        onConfirm: this.handleConfirmSelfChoose,
        onPropsBtnTap: function onPropsBtnTap(dish) {
          if (!_this16.onShoppingCartRelativeBtnClick()) {
            return;
          }

          toggleDishDetailPopup(dish);
        }
      })
    );
  }
});

var mapActionsToProps = function mapActionsToProps(dispatch) {
  var mergedActions = (0, _assign2.default)({}, actions, _commonAction2.default);
  return (0, _extends3.default)({}, (0, _redux.bindActionCreators)(mergedActions, dispatch), { dispatch: dispatch });
};

module.exports = connect(function (state) {
  return state;
}, mapActionsToProps)(DishMenuZcApplication);

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/ordertogether.png";

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/joinword.svg";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "asset/img/combinedword.svg";

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(28);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(21);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(29);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(30);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(119);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(50);

var _classnames2 = _interopRequireDefault(_classnames);

var _httpsProtocolImage = __webpack_require__(121);

var _httpsProtocolImage2 = _interopRequireDefault(_httpsProtocolImage);

var _buildOrderBtn = __webpack_require__(494);

var _buildOrderBtn2 = _interopRequireDefault(_buildOrderBtn);

var _dishHelper = __webpack_require__(43);

var _dishHelper2 = _interopRequireDefault(_dishHelper);

var _formattedMessage = __webpack_require__(48);

var _formattedMessage2 = _interopRequireDefault(_formattedMessage);

var _dishMenu = __webpack_require__(87);

var _dishMenu2 = _interopRequireDefault(_dishMenu);

__webpack_require__(849);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelfChooseMustOrder = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(SelfChooseMustOrder, _React$Component);

  function SelfChooseMustOrder(props) {
    (0, _classCallCheck3.default)(this, SelfChooseMustOrder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SelfChooseMustOrder.__proto__ || (0, _getPrototypeOf2.default)(SelfChooseMustOrder)).call(this, props));

    Object.defineProperty(_this, 'onBtnTap', {
      enumerable: true,
      writable: true,
      value: function value(dish, newCount, increment) {
        var _this$props = _this.props,
            onOrderBtnTap = _this$props.onOrderBtnTap,
            onPropsBtnTap = _this$props.onPropsBtnTap;


        if (increment) {
          onOrderBtnTap(dish, increment);
        } else {
          onPropsBtnTap(dish);
        }
      }
    });
    Object.defineProperty(_this, 'getDishList', {
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props2 = _this.props,
            orderedDishes = _this$props2.orderedDishes,
            selfChooseDishList = _this$props2.selfChooseDishList;
        // 收集已点的数据

        var orderedDishesMap = orderedDishes.reduce(function (t, _ref) {
          var brandDishId = _ref.brandDishId,
              order = _ref.order;

          if (t[brandDishId]) {
            t[brandDishId] = typeof order === 'number' ? t[brandDishId] + order : t[brandDishId].concat(order);
          } else {
            t[brandDishId] = order;
          }
          return t;
        }, {});

        return selfChooseDishList.map(function (dish) {
          return (0, _extends3.default)({}, dish, {
            order: orderedDishesMap[dish.brandDishId] || dish.order
          });
        });
      }
    });


    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(SelfChooseMustOrder, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var dishList = this.getDishList();
      var count = _dishHelper2.default.getDishesCount(dishList);

      return _react2.default.createElement(
        'div',
        { className: 'self-choose' },
        _react2.default.createElement('div', { className: 'self-choose-mask' }),
        _react2.default.createElement(
          'div',
          { className: 'self-choose-modal' },
          _react2.default.createElement(
            'div',
            { className: 'self-choose-modal-title' },
            _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.selfChooseModalTitle)
          ),
          _react2.default.createElement(
            'div',
            { className: 'self-choose-modal-body' },
            dishList.map(function (dish) {
              var img = dish.smallImgUrl || dish.largeImgList && dish.largeImgList[0];
              var bgStyle = img ? {
                background: 'center/100% url(' + _httpsProtocolImage2.default.getFinalImageUrl(img) + ') no-repeat'
              } : {};
              return _react2.default.createElement(
                'div',
                { className: 'self-choose-dish', key: dish.id },
                _react2.default.createElement('div', {
                  className: (0, _classnames2.default)('self-choose-dish-img', {
                    'self-choose-dish-img-default': !img
                  }),
                  style: bgStyle
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'self-choose-dish-name' },
                  dish.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'self-choose-dish-price price' },
                  dish.marketPrice
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'self-choose-dish-counter' },
                  _react2.default.createElement(_buildOrderBtn2.default, {
                    dishData: dish,
                    isClear: dish.clearStatus,
                    onBtnTap: function onBtnTap() {
                      for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
                        rest[_key] = arguments[_key];
                      }

                      _this2.onBtnTap.apply(_this2, [dish].concat(rest));
                    }
                  })
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            {
              className: (0, _classnames2.default)('self-choose-modal-footer', {
                'self-choose-modal-footer-disabled': !count
              }),
              onClick: function onClick() {
                if (count > 0) {
                  _this2.props.onConfirm();
                }
              }
            },
            _react2.default.createElement(_formattedMessage2.default, _dishMenu2.default.selfChooseModalFooter)
          )
        )
      );
    }
  }]);
  return SelfChooseMustOrder;
}(_react2.default.Component), Object.defineProperty(_class, 'propTypes', {
  enumerable: true,
  writable: true,
  value: {
    selfChooseDishList: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    orderedDishes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired, // 已点菜列表
    onConfirm: _propTypes2.default.func.isRequired,
    onPropsBtnTap: _propTypes2.default.func.isRequired,
    onOrderBtnTap: _propTypes2.default.func.isRequired
  }
}), _temp);
exports.default = SelfChooseMustOrder;

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(19);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(10);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(35);

var _stringify2 = _interopRequireDefault(_stringify);

var _config = __webpack_require__(13);

var _config2 = _interopRequireDefault(_config);

var _reduxActions = __webpack_require__(265);

var _dishHelper = __webpack_require__(43);

var _commonHelper = __webpack_require__(3);

var _orderDinnerCartHelper = __webpack_require__(453);

var _httpRequestHelper = __webpack_require__(84);

var _commonAction = __webpack_require__(434);

var _pageHelper = __webpack_require__(123);

var _pageHelper2 = _interopRequireDefault(_pageHelper);

var _helper = __webpack_require__(16);

var _errorMessage = __webpack_require__(117);

var _errorMessage2 = _interopRequireDefault(_errorMessage);

var _global = __webpack_require__(73);

var _global2 = _interopRequireDefault(_global);

var _const = __webpack_require__(14);

var _fetchHelper = __webpack_require__(41);

var _fetchHelper2 = _interopRequireDefault(_fetchHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setMenuData = (0, _reduxActions.createAction)('SET_MENU_DATA', function (menuData) {
  return menuData;
});
var setShopInfo = (0, _reduxActions.createAction)('SET_SHOP_INFO', function (shopInfo) {
  return shopInfo;
});
var _orderDish = (0, _reduxActions.createAction)('ORDER_DISH', function (dishData, action) {
  return [dishData, action];
});
var changeDish = (0, _reduxActions.createAction)('CHANGE_DISH', function (dishData, action) {
  return [dishData, action];
});
var _removeAllOrders = (0, _reduxActions.createAction)('REMOVE_ALL_ORDERS', function (orders) {
  return orders;
});
var _clearSaveOrder = (0, _reduxActions.createAction)('CLEAR_SAVE_ORDER', function (orders) {
  return orders;
});
var _reinstateUndefined = (0, _reduxActions.createAction)('REINSTATE_UNDEFINED', function (orders) {
  return orders;
});
var setDiscountToOrder = (0, _reduxActions.createAction)('SET_DISCOUNT_TO_ORDER', function (discount) {
  return discount;
});
var setNormalDiscount = (0, _reduxActions.createAction)('SET_NORMAL_DISCOUNT', function (discount) {
  return discount;
});
var setErrorMsg = exports.setErrorMsg = (0, _reduxActions.createAction)('SET_ERROR_MSG', function (error) {
  return error;
});
var setLoadMsg = (0, _reduxActions.createAction)('SET_LOAD_MSG', function (loadinfo) {
  return loadinfo;
});
var setCouponSuccessInfo = (0, _reduxActions.createAction)('SET_COUPON_SUCCESS_INFO', function (couponSuccessInfo) {
  return couponSuccessInfo;
});
var setCouponSuccess = (0, _reduxActions.createAction)('SET_COUPON_SUCCESS', function (couponSuccess) {
  return couponSuccess;
});
var setCallMsg = (0, _reduxActions.createAction)('SET_CALL_MSG', function (callInfo) {
  return callInfo;
});
var setCancelCanMsg = (0, _reduxActions.createAction)('SET_CANCEL_CALL_MSG', function (callInfo) {
  return callInfo;
});
var setCanCall = (0, _reduxActions.createAction)('SET_CAN_CALL', function (callAble) {
  return callAble;
});
var setTableAreaInfo = (0, _reduxActions.createAction)('SET_TABLE_AREA_INFO', function (tableAreaInfo) {
  return tableAreaInfo;
});
var setUserInfo = (0, _reduxActions.createAction)('SET_USER_INFO', function (info) {
  return info;
});
var setAuthInfo = (0, _reduxActions.createAction)('SET_AUTH_INFO', function (info) {
  return info;
});
var setToastProps = exports.setToastProps = (0, _reduxActions.createAction)('SET_TOAST_PROPS', function (props) {
  return props;
});
var setSoldDishList = (0, _reduxActions.createAction)('SET_SOLD_DISH_LIST', function (soldTopDishList) {
  return soldTopDishList;
});
var setDataInitOver = (0, _reduxActions.createAction)('SET_DATA_INIT_OVER', function (isOver) {
  return isOver;
});
var setGuidStatus = (0, _reduxActions.createAction)('SET_GUID_STATUS', function (status) {
  return status;
});
var setMustOrderDishList = (0, _reduxActions.createAction)('SET_MUST_ORDER_DISH_LIST', function (list) {
  return list;
});
// exports.setCouponStatus = createAction('SET_COUPON_STATUS', couponStatus => couponStatus);

// 设置店铺的营业状态 - 外卖和堂食点餐
var setShopOrderStatus = (0, _reduxActions.createAction)('SET_SHOP_ORDER_STATUS', function (shopOrderStatus) {
  return shopOrderStatus;
});
var setPageLoadedStatus = exports.setPageLoadedStatus = (0, _reduxActions.createAction)('SET_PAGE_LOADED_STATUS', function (pageLoadedStatus) {
  return pageLoadedStatus;
});

var YDtime = (0, _commonHelper.getUrlParam)('presetTime');

var shopId = (0, _commonHelper.getUrlParam)('shopId');
var orderType = (0, _commonHelper.getUrlParam)('type');
var dishListUrl = _config2.default.orderallDishListAPI + '?shopId=' + shopId;
if (YDtime) {
  dishListUrl = _config2.default.orderAllYDListAPI + '?shopId=' + shopId + '&presetTime=' + YDtime;
}
var runEnv = (0, _commonHelper.getRunEnv)();
var shopInfoUrl = _config2.default.orderallShopInfoAPI + '?shopId=' + shopId + '&runEnv=' + runEnv;

var errorLocation = function errorLocation(errorCode, errorMsg) {
  (0, _orderDinnerCartHelper.clearTableInfoInSessionStorage)();
  sessionStorage.errorMsg = errorMsg || (0, _helper.formatMessage)(_errorMessage2.default.unknown);
  location.href = _config2.default.exceptionLinkURL + '?shopId=' + shopId + '&linkType=1&diningForm=0';
};

var getCoupontoGuid = exports.getCoupontoGuid = function (info, resolve) {
  return function (dispatch, getState) {
    dispatch(setGuidStatus(info));

    if (resolve) {
      resolve();
    }
  };
};

var saveTableParam = exports.saveTableParam = function (tableInfo) {
  return function (dispatch, getState) {
    (0, _orderDinnerCartHelper.setTableInfoInSessionStorage)(shopId, tableInfo);
  };
};

exports.dataInitIsOver = function (is) {
  return function (dispatch) {
    dispatch(setDataInitOver(is));
  };
};

// 如果session中有tableId的话将table信息读取出来展示在页面上
exports.fetchTableInfo = function (tableInfo) {
  return function (dispatch) {
    var _ref = tableInfo || {},
        tableId = _ref.tableId,
        tableKey = _ref.tableKey;

    var urlString = '';

    if (tableId || tableKey) {
      var tableStr = tableId ? 'tableId' : 'tableKey';
      urlString = '&' + tableStr + '=' + (tableId || tableKey);
    }

    return _fetchHelper2.default.get(_config2.default.getTableInfoAPI + '?' + urlString, { shopId: shopId }).then(function () {
      var table = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setTableAreaInfo(table));
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      errorLocation(err.code, err.msg);
    });
  };
};

var jumpToDishMenu4DinnerChoosePeopleURL = function jumpToDishMenu4DinnerChoosePeopleURL() {
  var serviceStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    var choosePeopleCountFlag = getState().dishMenuReducer.shopInfo.choosePeopleCountFlag;
    var peopleCount = serviceStatus.peopleCount;
    var tableWay = serviceStatus.tableWay;
    var tableId = serviceStatus.tableId;
    var tableKey = serviceStatus.tableKey;
    var orderId = serviceStatus.orderId;
    var isSync = !!(tableId || tableKey || orderId); // 是否为协同点餐
    // 新增如果需要选择人数 则自动跳转到选择人数页面 (一桌一单)
    /* 暂时屏蔽 */
    if (tableWay === 'oneTableOneBill' && // 一桌一单
    isSync && // 协同点餐
    choosePeopleCountFlag && ( // 配置打开
    tableId || tableKey) && // 扫码进入
    !orderId && // 没有订单
    !peopleCount // 没有选择人数
    ) {
        var href = _config2.default.dishMenu4DinnerChoosePeopleURL + '?shopId=' + shopId + '&returnUrl=' + encodeURIComponent(location.href);
        if (tableId) {
          href = href + '&tableId=' + tableId;
        } else if (tableKey) {
          href = href + '&tableKey=' + tableKey;
        }
        location.href = href;
        return true;
      }
    return false;
  };
};

// 获取serviceStatus
var fetchServiceStatusNoTable = exports.fetchServiceStatusNoTable = function (tableInfo) {
  return function (dispatch, getState) {
    var _ref2 = tableInfo || {},
        tableId = _ref2.tableId,
        tableKey = _ref2.tableKey,
        orderId = _ref2.orderId;

    return (0, _commonAction.getServiceStatus)({ tableId: tableId, tableKey: tableKey, orderId: orderId })(dispatch).then(function (serviceStatus) {
      if (!serviceStatus) {
        return '';
      }

      if (serviceStatus.errCode) {
        var errCode = serviceStatus.errCode,
            errMsg = serviceStatus.errMsg;

        errorLocation(errCode, errMsg);
        return '';
      }

      if (serviceStatus.peopleCount) {
        // 保存已经选择的人数
        sessionStorage.orderDinnerCartPersonCount = serviceStatus.peopleCount.toString();
      }

      var ifJumpToDishMenu = jumpToDishMenu4DinnerChoosePeopleURL(serviceStatus)(dispatch, getState);
      return { serviceStatus: serviceStatus, ifJumpToDishMenu: ifJumpToDishMenu };
    });
  };
};

// 保存url的table信息，用于扫码点餐url自带tableId/tableKey，此接口进页面必调用
exports.saveTableInfoFromUrl = function () {
  var tableInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getStates) {
    if (tableInfo.tableId || tableInfo.tableKey || tableInfo.orderId || tableInfo.ownerId) {
      saveTableParam(tableInfo)(dispatch, getStates);
    }

    // 获取sessionStorage的tableInfo,所有tableInfo都从session里面取
    var tableInfoFromSession = (0, _orderDinnerCartHelper.getTableInfoInSessionStorage)(shopId);

    // 获取serviceStatus
    return fetchServiceStatusNoTable(tableInfoFromSession)(dispatch, getStates);
  };
};

exports.activeDishType = (0, _reduxActions.createAction)('ACTIVE_DISH_TYPE', function (evt, dishTypeId, dishTypeIdIndex) {
  window.__activeTypeByTap__ = evt && /dish-type-item/.test(evt.target.className);
  return { dishTypeId: dishTypeId, dishTypeIdIndex: dishTypeIdIndex };
});

exports.fetchShopInfo = function (tableId, tableKey) {
  return function (dispatch, getState) {
    dispatch(setPageLoadedStatus(false));
    return _fetchHelper2.default.get(shopInfoUrl).then(function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      data.showFullscreenAd = (0, _dishHelper.getFullscreenAdShow)(data);
      dispatch(setShopInfo(data));

      var _ref3 = data || {},
          bizStatus = _ref3.bizStatus;

      // 在没有优惠券的情况下 主动弹出新手引导


      if ((0, _commonHelper.getUrlParam)('getCoupon')) {
        dispatch(getCoupontoGuid(true));
      } else if (data.isOldMarketing && (!data.takeCouponVO || !data.takeCouponVO.coupId)) {
        // 老逻辑
        dispatch(getCoupontoGuid(true));
      } else if (!data.isOldMarketing && (!data.takeCouponVOS || data.takeCouponVOS.length === 0)) {
        // 新逻辑
        dispatch(getCoupontoGuid(true));
      }

      if (bizStatus) {
        var isAcceptOrder = bizStatus.slice(0, 1) === '1' && (0, _commonHelper.getUrlParam)('type') === 'TS';
        dispatch(setShopOrderStatus(isAcceptOrder));
      }
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    });
  };
};

exports.fetchMenuData = function () {
  return function (dispatch) {
    return _fetchHelper2.default.get(dishListUrl).then(function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      sessionStorage.setItem('dishTypeList', (0, _stringify2.default)(data.dishTypeList));
      var newData = (0, _dishHelper.restoreDishesLocalStorage)(data);
      dispatch(setMenuData(newData));
      // if (callBack) {
      //   callBack();
      // }
      // dispatch(setSoldDishList(menuData.data.soldTopInfos));
    });
  };
};

exports.fetchSoldDishList = function () {
  return function (dispatch) {
    // 点餐页推荐菜品 rqo = request recommendDishList ordering_page
    var rqo = (0, _commonHelper.getRecommendDish)((orderType || '').toLowerCase(), 'ordering_page').then(function (recommendDishList) {
      return dispatch(setSoldDishList({ dishMenuRecommendList: recommendDishList }));
    }).catch(function (errMsg) {
      return dispatch(setErrorMsg({ text: errMsg }));
    });

    // 商品详情页 rqd = request recommendDishList dish_detail_page
    var rqd = (0, _commonHelper.getRecommendDish)((orderType || '').toLowerCase(), 'dish_detail_page').then(function (recommendDishList) {
      return dispatch(setSoldDishList({ dishDetailRecommendList: recommendDishList }));
    }).catch(function (errMsg) {
      return dispatch(setErrorMsg({ text: errMsg }));
    });

    // 这样写是为了两个请求并行
    return rqo.then(function () {
      return rqd;
    });
  };
};

exports.orderDish = function (dishData, action, isStorageInLocal) {
  return function (dispatch, getStates) {
    dispatch(_orderDish(dishData, action));
    dispatch(changeDish(dishData, action));
    var dishTypeList = JSON.parse(sessionStorage.dishTypeList || '[]');
    var dishTypeObj = {};
    dishTypeList.forEach(function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dishTypeObj[item.id] = item.name;
    });
    var fadeDishes = Array.prototype.slice.call(getStates().dishMenuReducer.dishesDataDuplicate);
    var getFadeDishes = [];
    fadeDishes.forEach(function () {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      getFadeDishes.push((0, _assign2.default)({}, item, {
        dishTypeName: dishTypeObj[item.dishTypeId] || (0, _helper.formatMessage)(_global2.default.defaultSort)
      }));
    });
    if (isStorageInLocal !== false) {
      (0, _dishHelper.storeDishesLocalStorage)(getFadeDishes, getStates().dishMenuReducer.shopInfo);
    }
  };
};

exports.removeAllOrders = function (orders) {
  return function (dispatch) {
    dispatch(_removeAllOrders(orders));
    dispatch(_clearSaveOrder(orders));
    (0, _dishHelper.clearDishesLocalStorage)();
  };
};

exports.reinstateUndefined = function (orders) {
  return function (dispatch) {
    dispatch(_reinstateUndefined(orders));
  };
};

exports.fetchOrderDiscountInfo = function () {
  var discountRule = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    // 平头哥 屏蔽会员优惠
    var _getState = getState(),
        _getState$dishMenuZcR = _getState.dishMenuZcReducer.shopMinConsume,
        shopMinConsume = _getState$dishMenuZcR === undefined ? {} : _getState$dishMenuZcR;

    if (shopMinConsume && shopMinConsume.state === 1) {
      dispatch(setDiscountToOrder({ dishList: [] }));
      return _promise2.default.resolve();
    }

    return _fetchHelper2.default.get('' + _config2.default.orderDiscountInfoAPI, { shopId: shopId }, { enableDefaultResponseResolve: false }).then(function () {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var res = response.data || {};
      if (res.code !== '200') {
        if (res.code !== 'NOT_LOGIN') {
          dispatch(setErrorMsg({ text: res.msg }));
        }
      }

      var _ref4 = res.data || {},
          _ref4$dishList = _ref4.dishList,
          dishList = _ref4$dishList === undefined ? [] : _ref4$dishList,
          _ref4$isMember = _ref4.isMember,
          isMember = _ref4$isMember === undefined ? false : _ref4$isMember,
          _ref4$type = _ref4.type,
          type = _ref4$type === undefined ? 1 : _ref4$type;

      if (dishList && dishList.length || type === _const.MemberPrivTypes.UNIFIED_DISCOUNT) {
        dispatch(setDiscountToOrder((0, _extends3.default)({}, res.data, {
          ableAddPriceDiscount: discountRule.ableAddPriceDiscount // 是否开启会员加价折扣
        })));
      } else {
        dispatch(setDiscountToOrder((0, _extends3.default)({}, discountRule, { isMember: isMember })));
      }
    });
  };
};

exports.showErrMsgFunc = function (msg) {
  return function (dispatch, getState) {
    return dispatch(setErrorMsg({ text: msg }));
  };
};

exports.clearErrorMsg = function () {
  return function (dispatch, getState) {
    return dispatch(setErrorMsg({}));
  };
};

exports.cancelCallMsg = function () {
  return function (dispatch, getState) {
    return dispatch(setCancelCanMsg(null));
  };
};

exports.updateCanCall = function (isCan) {
  return function (dispatch, getState) {
    return dispatch(setCanCall(isCan));
  };
};

// 临时注释，以后有用勿删
// const removeBasicSession = (name) => {
//   sessionStorage.removeItem(name);
// };

// call 服务铃
exports.callBell = function (timer, contentCode, contentMsg) {
  return function (dispatch, getStates) {
    var orderId = getStates().dishMenuZcReducer.serviceStatus.orderId || '';
    var tableId = getStates().dishMenuZcReducer.serviceStatus.tableId;
    dispatch(setCanCall(true));
    var callServiceAPI = '' + _config2.default.callServiceAPI;
    var queries = {
      shopId: shopId,
      orderId: orderId,
      tableId: tableId,
      contentCode: contentCode,
      contentMsg: contentMsg
    };

    return _fetchHelper2.default.get('' + callServiceAPI, queries).then(function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setCanCall(false));
      (0, _commonHelper.interValSetting)(timer, function () {
        dispatch(setCanCall(true));
      });
      if (data.status.toString() === '1501') {
        // 已经呼叫过服务员了
        dispatch(setCallMsg({
          info: data.message,
          callStatus: true
        }));
        return;
      }
      dispatch(setCallMsg({
        info: (0, _helper.formatMessage)(_errorMessage2.default.waiterWillCome),
        callStatus: true
      }));
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setCallMsg({
        info: err.msg || (0, _helper.formatMessage)(_errorMessage2.default.sendFail),
        callStatus: false
      }));
    });
  };
};

exports.fetchDishMarketInfos = function () {
  return function (dispatch) {
    return _fetchHelper2.default.get('' + _config2.default.getDishMarketInfosAPI, { shopId: shopId }).then(function () {
      var marketInfoData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!marketInfoData) {
        return {};
      }

      if (!marketInfoData.discountInfo || !marketInfoData.discountInfo.dishList || !marketInfoData.discountInfo.dishList.length) {
        marketInfoData.discountInfo = {};
      }

      dispatch(setNormalDiscount(marketInfoData));

      return (0, _extends3.default)({}, marketInfoData.discountInfo, {
        ableAddPriceDiscount: marketInfoData.ableAddPriceDiscount
      });
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setErrorMsg({ text: err.msg }));
    });
  };
};

exports.clearBell = function (msg) {
  return function (dispatch) {
    dispatch(setCallMsg({
      info: msg,
      callStatus: false
    }));
  };
};

exports.getMarketCoupons = function (couponId, callBack) {
  return function (dispatch, getState) {
    dispatch(setLoadMsg({ status: true, word: (0, _helper.formatMessage)(_errorMessage2.default.beingInTheVoucher) }));
    // 根据需求判断新老接口

    var _ref5 = getState().dishMenuReducer.shopInfo || {},
        isOldMarketing = _ref5.isOldMarketing,
        ruleId = _ref5.ruleId,
        planId = _ref5.planId;

    var queries = {
      shopId: shopId
    };
    if (isOldMarketing) queries = (0, _extends3.default)({}, queries, { couponId: couponId });else queries = (0, _extends3.default)({}, queries, { ruleId: ruleId, planId: planId });

    return _fetchHelper2.default.get('' + (isOldMarketing ? _config2.default.fetchCouponAPI : _config2.default.sendCouponsAPI), queries, { enableDefaultResponseResolve: false }).then(function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setLoadMsg({ status: false, word: '' }));
      var result = res.data || {};

      if (result.code === '200') {
        if (isOldMarketing) {
          // 老逻辑
          dispatch(setCouponSuccessInfo(result.data.coup));
        } else {
          // 新逻辑
          dispatch(setCouponSuccess(result.data)); // true 成功  false 失败
        }

        // 领券成功关闭掉领券页面
        if (callBack) {
          callBack();
        }
      } else if (result.code === '60200') {
        dispatch(setErrorMsg({ text: (0, _helper.formatMessage)(_errorMessage2.default.tryAgainForGet) }));
      } else if (result.code === '110000') {
        dispatch(setErrorMsg({ text: result.msg }));
      } else {
        if (result.code === 'NOT_LOGIN') {
          // 用户未登录
          setTimeout(function () {
            _pageHelper2.default.navigateToLoginPage({
              shopId: shopId,
              getCoupon: true
            });
          }, 800);
        }
      }
    });
  };
};

// 判断用户是否登录 仅在一桌一单加菜模式下会用到
exports.fetchUserInfo = function (memberVO) {
  return function (dispatch) {
    dispatch(setUserInfo(memberVO));
    sessionStorage.setItem('userInfo', (0, _stringify2.default)(memberVO));
  };
};

exports.fetchWXAuthInfo = function () {
  return function (dispatch) {
    var authUrl = encodeURIComponent(location.href);

    return _fetchHelper2.default.get('' + _config2.default.getWXAuthInfoAPI, { shopId: shopId, reqUrl: authUrl }).then(function () {
      var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setAuthInfo(result));
      return result;
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setErrorMsg({ text: err.msg + ', ' + (0, _helper.formatMessage)(_errorMessage2.default.cantCallTableQRCode) }));
    });
  };
};

exports.closeInfoWindow = function () {
  return function (dispatch) {
    dispatch(setToastProps(null));
  };
};

// 获取扫桌台码信息
exports.fetchTableIdFromNewVersionQRCode = function (tableUrl) {
  return function (dispatch, getState) {
    return _fetchHelper2.default.get('' + _config2.default.getTableIdFromQRCodeAPI, { shopId: shopId, url: tableUrl }).then(function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var tableInfo = {
        tableId: res.synFlag || ''
      };
      // 扫桌台码，将tableInfo存进session
      saveTableParam(tableInfo)(dispatch, getState);
      location.href = _config2.default.dishMenu4DinnerURL + '?shopId=' + shopId + '&tableId=' + res.synFlag + '&type=TS';
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setErrorMsg({ text: err.msg }));
    });
  };
};

exports.syncShoppingCart = function (shoppingCartDishData) {
  return function (dispatch, getState) {
    var _shoppingCartDishData = shoppingCartDishData.userInfo,
        userInfo = _shoppingCartDishData === undefined ? {} : _shoppingCartDishData;
    var userOrderedDishList = shoppingCartDishData.userOrderedDishList;

    var _getState2 = getState(),
        _getState2$dishMenuZc = _getState2.dishMenuZcReducer,
        mustOrderDishList = _getState2$dishMenuZc.mustOrderDishList,
        selfChooseDishList = _getState2$dishMenuZc.selfChooseDishList;

    var action = (0, _reduxActions.createAction)('SYNC_SHOPPING_CART', function (data) {
      return data;
    });

    // 设置必点菜的属性
    if (mustOrderDishList.length || selfChooseDishList.length) {
      userOrderedDishList = (0, _dishHelper.setUserOrderedDishListMustOrderProps)(userOrderedDishList, mustOrderDishList.concat(selfChooseDishList));
    }

    dispatch(action(userOrderedDishList));

    var currentUserOrderedResult = (userOrderedDishList || []).filter(function (item) {
      return item.userInfo.userId === userInfo.userId;
    })[0];

    var _ref6 = currentUserOrderedResult || {},
        _ref6$dishList = _ref6.dishList,
        dishList = _ref6$dishList === undefined ? [] : _ref6$dishList;

    if (dishList.length) {
      var updateOrderedDishAction = (0, _reduxActions.createAction)('UPDATE_DISH_ORDER', function (data) {
        return data;
      });
      dispatch(updateOrderedDishAction(dishList));
    }
  };
};

exports.addOrderNotice = function (notice) {
  return function (dispatch) {
    var action = (0, _reduxActions.createAction)('ADD_ORDER_NOTICE', function (data) {
      return data;
    });
    dispatch(action(notice));
  };
};

exports.readOrderNotice = function (readedIndex) {
  return function (dispatch) {
    var action = (0, _reduxActions.createAction)('READ_ORDER_NOTICE', function (data) {
      return data;
    });
    dispatch(action(readedIndex));
  };
};

exports.syncDishesFromShoppingCart = function (shoppingCartDishes) {
  return function (dispatch) {
    dispatch((0, _reduxActions.createAction)('SYNC_DISHES_FROM_SHOPPINGCART', function (data) {
      return data;
    }));
  };
};

exports.fetchMustOrderMenu = function () {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        _getState3$dishMenuRe = _getState3.dishMenuReducer.shopInfo,
        shopInfo = _getState3$dishMenuRe === undefined ? {} : _getState3$dishMenuRe;

    if (!shopInfo.enableOpenDish) {
      return false;
    }

    return _fetchHelper2.default.get('' + _config2.default.mustOrderDishListAPI, { shopId: shopId, type: 'TS' }).then(function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setMustOrderDishList(res));
    }).catch(function () {
      var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      dispatch(setErrorMsg(err.msg));
    });
  };
};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dish-menu-zc-entry.js